{
  "testit": {
    "catalog": {
      "title": "TestIt",
      "subtitle": "Seus resultados de testes reutilizáveis — faça um teste uma vez e reutilize em qualquer CheckUp.",
      "notTaken": "Ainda não feito",
      "validDays": "Válido · {{days}}d restantes",
      "expired": "Expirado",
      "delete": "Excluir",
      "declareHint": "Autodeclare seu nível (não verificado). Você pode substituí-lo por um teste verificado depois.",
      "retake": "Refazer",
      "kindPitch": "Pitch em vídeo",
      "kindCefr": "Teste de idioma",
      "kindMotivational": "Questionário",
      "valid": "Válido",
      "takeTest": "Fazer teste",
      "heroTitle": "Seu banco de testes reutilizáveis",
      "heroSubtitle": "Resultados válidos são usados automaticamente na próxima vez que você fizer um CheckUp.",
      "statValid": "Válidos",
      "statExpired": "Expirados",
      "statUntaken": "Não feitos",
      "errorTitle": "Não foi possível carregar seus testes",
      "errorBody": "Algo deu errado ao buscar seu banco de testes. Tente novamente em instantes.",
      "band": {
        "ringValue": "{{valid}}/{{total}}",
        "ringCaption": "testes válidos",
        "ringLabel": "{{valid}} de {{total}} testes válidos",
        "allValid": "Todos os testes válidos",
        "toRenew_one": "{{count}} para renovar",
        "toRenew_other": "{{count}} para renovar",
        "toTake_one": "{{count}} para fazer",
        "toTake_other": "{{count}} para fazer",
        "nextEyebrow": "Seu próximo passo",
        "startNow": "Começar agora",
        "renewNow": "Renovar agora",
        "renewCaption": "O resultado expirou · cerca de {{minutes}} min",
        "upToDate": "Todos os resultados em dia",
        "soonestExpiry": "O primeiro a expirar é {{test}}, em {{date}}"
      },
      "measures": {
        "pitch": "Um vídeo curto em que você se apresenta — a clareza e a confiança com que diz quem é e por que está se mudando.",
        "cefr": "Seu nível no idioma, de A1 a C2 — geral e em leitura, compreensão auditiva, fala e escrita.",
        "motivational": "Um questionário curto sobre por que você está se mudando e o que busca na sua nova vida."
      },
      "kindWithMinutes": "{{kind}} · cerca de {{minutes}} min",
      "aboutMinutes": "Cerca de {{minutes}} min",
      "expiredOn": "expirou em {{date}}",
      "viewResult": "Ver resultado",
      "renew": "Renovar"
    },
    "modal": {
      "history": "Histórico",
      "historyError": "Não foi possível carregar suas tentativas.",
      "current": "Atual",
      "superseded": "Substituído",
      "daysLeft": "{{days}} dias restantes",
      "takenOn": "Feito em {{date}}",
      "expiresOn": "expira em {{date}}",
      "reuseNote": "Reutilizado automaticamente no seu próximo CheckUp",
      "takeNew": "Fazer um novo teste",
      "declareCta": "Declarar nível"
    },
    "test": {
      "pitch": "Pitch",
      "languageEn": "Inglês",
      "languagePt": "Português",
      "language": "Idioma",
      "motivational": "Motivacional"
    },
    "invite": {
      "bulkKindNote": "Aplica-se a todos os candidatos selecionados.",
      "kindFull": "CheckUp completo",
      "kindFullHint": "A avaliação CheckUp completa — um perfil iQulture completo.",
      "kindLabel": "O que devem completar?",
      "kindTestit": "Testes específicos",
      "kindTestitHint": "Apenas os testes que você escolher abaixo — mais rápido e os resultados são reutilizáveis.",
      "previewFull": "O e-mail de convite do CheckUp completo.",
      "previewLabel": "Eles receberão",
      "previewTestit": "Um convite TestIt indicando: {{tests}}.",
      "previewTestitEmpty": "Um convite TestIt — escolha os testes acima.",
      "selectAtLeastOne": "Selecione pelo menos um teste.",
      "selectTestsHint": "Escolha um ou mais. O candidato completa apenas estes.",
      "selectTestsLabel": "Quais testes eles devem fazer?",
      "testNeverExpires": "Sem expiração",
      "wizardBannerCta": "Começar agora",
      "wizardCompleteBody": "Seus resultados foram compartilhados com a empresa. Você pode fechar isto e explorar seu painel.",
      "wizardCompleteTitle": "Todos os testes concluídos!",
      "wizardDoLater": "Fazer isso depois",
      "wizardDone": "Concluído",
      "wizardGoToDashboard": "Ir para o painel",
      "wizardIntro": "Você foi convidado a completar estes testes. Faça-os na ordem que quiser — seus resultados são salvos e reutilizáveis.",
      "wizardPending": "Ainda não feito",
      "wizardProgress": "{{done}} de {{total}} concluídos",
      "wizardRetake": "Refazer",
      "wizardStart": "Começar",
      "wizardTitle": "Complete os testes para os quais você foi convidado",
      "testValidityDays_one": "Válido por {{count}} dia",
      "testValidityDays_other": "Válido por {{count}} dias",
      "wizardBannerTitle_one": "Você foi convidado a completar {{count}} teste",
      "wizardBannerTitle_other": "Você foi convidado a completar {{count}} testes",
      "completeBannerTitle": "Os testes que pediram a você estão concluídos",
      "completeBannerBody": "A empresa que os pediu pode ver seus resultados. Não falta nada para fazer."
    },
    "vetting": {
      "allComplete": "Todos os testes convidados concluídos",
      "askDescription": "Vamos pedir a {{name}} a avaliação selecionada. Se precisar de mais do que compartilha com você agora, é o talento quem decide se compartilha — nada mais é compartilhado até responder. Os resultados que já tem são reutilizados.",
      "askFailed": "Não foi possível enviar a solicitação",
      "askForCheckup": "Pedir CheckUp completo",
      "askSend": "Enviar solicitação",
      "askSending": "Enviando…",
      "askEmailFailed": "O pedido para {{name}} foi registrado, mas não foi possível enviar o e-mail",
      "askTitle": "Solicitar uma avaliação de {{name}}",
      "decline": "Recusar",
      "declined": "Recusado",
      "expired": "Expirado",
      "invitedProgress": "{{done}} de {{total}} testes concluídos",
      "latestResult": "Último resultado",
      "noPriorAttempts": "Sem tentativas anteriores",
      "noResults": "Ainda sem resultados de testes",
      "noVerdict": "Sem decisão ainda",
      "notTaken": "Não feito",
      "otherResults": "Outros resultados",
      "overviewTitle": "Avaliação TestIt",
      "pass": "Aprovar",
      "passed": "Aprovado",
      "pending": "Pendente",
      "pitchAria": "Gravação do pitch do candidato",
      "pitchUnavailable": "Gravação indisponível",
      "previousAttempts": "Tentativas anteriores",
      "remind": "Lembrar",
      "reminderFailed": "Não foi possível enviar o lembrete.",
      "reminderSent": "Lembrete enviado",
      "reminderTooSoon": "Você lembrou há pouco — tente novamente mais tarde.",
      "takenOn": "feito em {{date}}",
      "valid": "Válido · {{days}}d restantes",
      "validShort": "Válido",
      "verdictTitle": "Veredito",
      "failed": "Análise falhou",
      "failedReason": {
        "languageMismatch": "O certificado atesta um idioma diferente do deste teste.",
        "unsupportedDocument": "Não foi possível ler o arquivo enviado.",
        "archiveTooLarge": "O documento Word é grande demais para ser lido com segurança.",
        "docxEmpty": "O documento Word não tem texto nem imagem legíveis.",
        "tooManyPages": "O certificado tem mais de {{max}} páginas; só são lidos certificados com até {{max}} páginas.",
        "noLevelFound": "Nenhum nível QECR foi encontrado no certificado.",
        "serviceUnavailable": "Nosso serviço de análise não conseguiu processar o certificado."
      },
      "withheldBody": "Este cidadão não compartilhou os resultados dos testes com a sua empresa. Os testes para os quais você o convidou continuam listados; se ele os concluiu está retido — não é “pendente”.",
      "moreActions": "Mais ações",
      "repositoryTitle": "Resultados de testes salvos",
      "repositorySubtitle": "Todos os testes e o que o candidato já concluiu de cada um — somente leitura. Este convite de CheckUp não pediu testes específicos.",
      "loadFailed": "Não foi possível carregar os resultados dos testes.",
      "askRequested": "Pedido enviado para {{name}} — nada mais é compartilhado até responder",
      "askReminded": "Lembramos {{name}} do que ainda falta fazer",
      "askAlreadyShared": "{{name}} já compartilha isso com você — não há nada a pedir"
    },
    "doOnWeb": "Fazer meus testes na web",
    "doOnWebDesc": "Os testes que sua empresa pediu são feitos no Portal Web Citizen — abra-o em um navegador de desktop para começar.",
    "result": {
      "overallLevel": "Nível geral",
      "skillReading": "Leitura",
      "skillListening": "Compreensão auditiva",
      "skillSpeaking": "Fala",
      "skillWriting": "Escrita",
      "selfDeclared": "Autodeclarado",
      "analyserConfidence": "Confiança da análise: {{value}}",
      "recorded": "Gravado",
      "motivationalComplete": "Questionário concluído",
      "motivationalAnswered_one": "{{count}} resposta",
      "motivationalAnswered_other": "{{count}} respostas",
      "sourceCheckup": "Do CheckUp",
      "sourceTestit": "TestIt",
      "duration": "Duração",
      "cefrLevel": "QECR {{level}}",
      "recordedDuration": "Gravado · {{duration}}",
      "answersCaption_one": "resposta",
      "answersCaption_other": "respostas"
    },
    "tabs": {
      "tests": "Testes",
      "history": "Histórico"
    },
    "brief": {
      "title": "Antes de começar: {{test}}",
      "measuresHeading": "O que mede",
      "needsHeading": "Do que você vai precisar",
      "stepsHeading": "Como funciona",
      "start": "Começar o teste",
      "replaces": "Seu resultado atual ({{result}}) é substituído pelo novo e fica no seu histórico.",
      "needs": {
        "camera": "Uma câmera e um microfone",
        "quietPlace": "Um lugar silencioso — você responde em inglês",
        "computer": "Um computador com acesso à internet",
        "headphones": "Fones de ouvido para a parte de compreensão auditiva",
        "resultFile": "Uma captura de tela, um PDF ou um arquivo Word do resultado",
        "time": "Um momento tranquilo — as respostas ficam salvas enquanto você escreve"
      },
      "steps": {
        "pitch": {
          "read": "Leia as perguntas na tela",
          "record": "Grave as respostas em um único vídeo",
          "send": "Reveja, grave de novo se quiser e envie"
        },
        "language": {
          "take": "Faça o teste no site do parceiro",
          "upload": "Envie o resultado — uma captura de tela, um PDF ou um arquivo Word",
          "read": "Lemos seu nível automaticamente e mostramos para você"
        },
        "motivational": {
          "answer": "Responda às perguntas sobre sua mudança, no seu ritmo",
          "review": "Revise as respostas",
          "send": "Envie"
        }
      }
    },
    "done": {
      "title": "Resultado salvo",
      "saving": "Salvando seu resultado…",
      "validUntil": "Válido até {{date}}",
      "finish": "Concluir",
      "seeResult": "Ver resultado e histórico"
    },
    "history": {
      "deleteTitle": "Excluir esta tentativa?",
      "deleteWhat": "{{test}} · {{result}} · {{date}}",
      "deleteCurrent": "É seu resultado atual: a tentativa anterior, se houver, passa a ser o resultado deste teste.",
      "deleteAttempt": "Excluir a tentativa de {{test}}",
      "errorTitle": "Não foi possível carregar seu histórico",
      "errorBody": "Tente novamente em instantes.",
      "emptyTitle": "Ainda sem tentativas",
      "emptyBody": "Cada teste que você fizer aparece aqui, com o resultado e a data.",
      "browseTests": "Ver os testes",
      "filterLabel": "Mostrar tentativas de",
      "filterAll": "Todos"
    }
  },
  "introCarousel": {
    "back": "Voltar",
    "business": {
      "cta": "Adicionar talentos",
      "ctaSecondary": "Talvez depois",
      "slides": {
        "welcome": {
          "eyebrow": "Bem-vindo à Tonnie",
          "title": "Patrocine talento global, com proteção",
          "body": "Avalie, patrocine e apoie contratações internacionais num só lugar — a Tonnie protege cada patrocínio, com trilha de auditoria em cada etapa."
        },
        "acquire": {
          "eyebrow": "Pool de talentos · Avaliação",
          "title": "Avalie antes de patrocinar",
          "body": "Analise a prontidão de realocação de cada candidato no Pool de Talentos, para patrocinar só quem realmente vai chegar."
        },
        "sponsor": {
          "eyebrow": "Patrocínio · Protegido",
          "title": "Patrocine com proteção",
          "body": "Aposte num talento e a Tonnie protege o investimento de ponta a ponta — verificações de prontidão, marcos e evidências mantêm cada patrocínio no rumo certo."
        },
        "mobility": {
          "eyebrow": "Mobilidade · Adaptação",
          "title": "Acompanhe a mudança e a adaptação",
          "body": "Siga cada realocação entre trâmites legais, viagem e instalação — e veja como cada contratado patrocinado se adapta à função e ao país."
        },
        "care": {
          "eyebrow": "Care · Conformidade",
          "title": "Retenha talento, com evidências",
          "body": "Apoie o bem-estar sem vigilância e exporte registros verificados assim que auditoria, jurídico ou liderança precisarem."
        },
        "start": {
          "eyebrow": "Vamos começar",
          "title": "Patrocine seu primeiro talento",
          "body": "Adicione um talento ao seu programa — cada patrocínio fica protegido pela Tonnie, desde o primeiro dia."
        }
      }
    },
    "goToSlide": "Ir para o slide {{number}}",
    "next": "Próximo",
    "skip": "Pular",
    "title": "Introdução à Tonnie"
  },
  "activity": {
    "task": {
      "completed": "Concluído: {{label}}",
      "completedForMember": "Concluído: {{label}} — {{member}}"
    },
    "housing": {
      "secured": "Habitação garantida"
    },
    "checkup": {
      "scored": "Pontuação de CheckUp calculada"
    },
    "checkin": {
      "completed": "Check-in concluído"
    },
    "checkpoint": {
      "completed": "Ponto de verificação: {{label}}"
    },
    "mission": {
      "completed": "Missão concluída: {{label}}"
    },
    "world": {
      "completed": "Mundo concluído: {{label}}"
    },
    "streak": {
      "milestone_one": "{{count}} dia de sequência!",
      "milestone_other": "{{count}} dias de sequência!"
    },
    "stamp": {
      "earned": "Selo ganho: {{label}}"
    },
    "badge": {
      "earned": "Distintivo ganho: {{label}}"
    },
    "onboarding": {
      "completed": "Começando"
    },
    "journey": {
      "completed": "Jornada completa!"
    },
    "event": {
      "addedFromPool": "Adicionado do pool de talentos",
      "adoptedByInvitation": "Jornada vinculada a um convite de empresa",
      "arrived": "Chegado ao destino",
      "badgeEarned": "Distintivo ganho",
      "checkpointCompleted": "Checkpoint concluído",
      "checkupCompleted": "CheckUp concluído",
      "checkupStarted": "CheckUp iniciado",
      "companyTaskCompleted": "Tarefa da empresa concluída",
      "documentUploaded": "Documento enviado",
      "expiryRenewed": "Jornada estendida",
      "fundingChanged": "Financiamento alterado",
      "guideCompleted": "Guia concluído",
      "guideDiscarded": "Guia descartado",
      "guideRestarted": "Guia reiniciado",
      "guideRetaken": "Guia retomado",
      "guideStarted": "Guia iniciado",
      "interventionLogged": "Intervenção Care registrada",
      "interventionResolved": "Intervenção Care resolvida",
      "interventionScheduled": "Intervenção Care agendada",
      "interventionUpdated": "Intervenção Care atualizada",
      "interviewRequested": "Entrevista solicitada",
      "invitationAccepted": "Convite aceito",
      "journeyArchived": "Jornada arquivada",
      "journeyCreated": "Jornada criada",
      "journeyLifecycle": "Status da jornada alterado",
      "journeyRestored": "Jornada restaurada",
      "missionCompleted": "Missão concluída",
      "objectiveFeedbackSubmitted": "Feedback objetivo enviado",
      "pipelineStageChanged": "Etapa do pipeline alterada",
      "pitchAnalyzed": "Pitch analisado",
      "protectiveActionLogged": "Ação protetiva registrada",
      "setPrimary": "Definir como jornada principal",
      "sponsorshipAccepted": "Patrocínio aceito",
      "sponsorshipCancelled": "Patrocínio cancelado",
      "sponsorshipDeclined": "Patrocínio recusado",
      "sponsorshipRefunded": "Patrocínio reembolsado",
      "sponsorshipStarted": "Patrocínio iniciado",
      "stampEarned": "Selo ganho",
      "talentArchived": "Talento arquivado",
      "talentSponsored": "Patrocínio ativado",
      "talentUnarchived": "Talento desarquivado",
      "teleportalTaskCompleted": "Tarefa TelePortal concluída",
      "trackCompleted": "Rastreamento concluído",
      "vettingInviteEmailFailed": "Não foi possível enviar o e-mail do convite de avaliação",
      "visaApproved": "Visto aprovado",
      "worldCompleted": "Mundo concluído",
      "copilotInterviewCompleted": "Entrevista com o CoPilot concluída",
      "testResultsRecorded": "Resultados dos testes registrados",
      "testitPassed": "Veredito TestIt: aprovado",
      "testitDeclined": "Veredito TestIt: recusado",
      "profileCompleted": "Perfil concluído",
      "documentValidated": "Documento validado",
      "relocationPlanCreated": "Plano de mudança criado",
      "relocationPlanUpdated": "Plano de mudança atualizado",
      "milestoneReached": "Marco alcançado",
      "interventionDue": "Ação de cuidado agendada pendente",
      "taskReopened": "Tarefa de mudança reaberta",
      "relationshipMoved": "Passou para uma jornada própria",
      "programmeLeft": "Saiu do programa",
      "shareRequested": "Pediu para ver mais",
      "shareRequestAccepted": "Compartilhou o que foi pedido",
      "shareRequestDeclined": "Recusou o pedido para ver mais",
      "vettingReminded": "Lembrado do que ainda falta fazer",
      "testitCompleted": "Concluiu os testes que foram pedidos"
    },
    "externalLevel": {
      "reached": "{{world}}: nível {{band}} alcançado"
    },
    "pipeline": {
      "transition": "Pipeline: {{from}} → {{to}}"
    },
    "business": {
      "intervention": "Intervenção: {{label}}",
      "feedbackRoutineCreated": "Rotina de feedback \"{{name}}\" criada",
      "feedbackRoutineStarted": "Rotina de feedback iniciada",
      "feedbackRoutineCompleted": "Rotina de feedback concluída",
      "feedbackRoutinePaused": "Rotina de feedback pausada",
      "protectiveAction": "Ação protetiva — {{label}}",
      "interventionLogged": "Intervenção — {{label}}",
      "documentUploaded": "Documento enviado — {{label}}",
      "taskReminderSent": "Lembrete enviado — {{label}}",
      "interventionScheduled": "{{label}} agendado",
      "messageSent": "Enviado \"{{name}}\" via {{channel}}",
      "messageSentNoName": "Mensagem enviada via {{channel}}",
      "messageNotDelivered": "\"{{name}}\" via {{channel}} não foi entregue",
      "messageNotDeliveredNoName": "Mensagem via {{channel}} não foi entregue",
      "messageDispatched": "\"{{name}}\" via {{channel}} foi entregue para envio — resultado não registrado",
      "messageDispatchedNoName": "Mensagem via {{channel}} foi entregue para envio — resultado não registrado",
      "invitationCreated": "Convite criado",
      "invitationSent": "Convite enviado",
      "invitationReminded": "Lembrete do convite enviado",
      "invitationAccepted": "Convite aceito",
      "invitationRevoked": "Convite revogado",
      "invitationRevokedAccountDeleted": "Convite revogado — a pessoa excluiu a conta",
      "invitationExpired": "Convite expirado",
      "invitationDeclined": "Convite recusado"
    },
    "generic": "{{text}}",
    "objective": {
      "selfEvaluated": "Concluiu uma autoavaliação de objetivos"
    },
    "messageTemplate": {
      "account_email_changed": "E-mail de acesso alterado",
      "account_invitation_claim_code": "Código para assumir o convite",
      "adaptation_nudge_missions": "Sugestão de missão de adaptação",
      "adaptation_streak_broken": "Lembrete de sequência de adaptação",
      "care_checkin_request": "Solicitação de check-in Care",
      "care_checkpoint_overdue_reminder": "Lembrete de prazo excedido (talento)",
      "care_feedback_requested": "Solicitação de feedback Care (para talento)",
      "care_intervention_due": "Intervenção Care devida (interna)",
      "care_objective_feedback_cycle_open": "Feedback objetivo — rodada aberta (talento)",
      "care_objective_feedback_due": "Feedback objetivo — devido (fornecedor)",
      "care_objective_feedback_received": "Feedback objetivo — recebido (talento)",
      "coaching_message": "Mensagem de coaching",
      "cohort_welcome": "Boas-vindas ao grupo",
      "company_nudge_digest": "Ação necessária — resumo semanal da empresa",
      "evidence_celebrate_badge": "Celebração de badge",
      "evidence_request": "Solicitação de evidência / documento",
      "integration_mission_assigned": "Missão QultureUp atribuída",
      "interview_first_requested": "Solicitação de entrevista-primeiro",
      "mobility_task_assigned": "Tarefa de mobilidade atribuída",
      "mobility_task_pending": "Lembrete de tarefa de mobilidade",
      "program_enrollment": "Boas-vindas à inscrição no programa",
      "services_request_received": "Solicitação de serviços Tonnie recebida (interna)",
      "sponsorship_activate": "Ativação de patrocínio — aguardando aceitação do talento",
      "sponsorship_invite": "Convite de patrocínio (lançamento da jornada)",
      "sponsorship_offer_reminder": "Lembrete de oferta de patrocínio (sem resposta)",
      "sponsorship_talent_accepted": "Patrocínio — talento aceito (notificação administrativa)",
      "sponsorship_talent_declined": "Patrocínio — talento recusado (notificação administrativa + reembolso)",
      "sponsorship_welcome": "Boas-vindas ao patrocínio",
      "talent_invite": "Convite de integração de talento",
      "team_invite": "Convite para membro da equipe",
      "team_invite_reminder": "Lembrete de convite para a equipe",
      "vetting_complete_checkup": "Lembrete de progresso CheckUp",
      "vetting_invite": "Convide o candidato para CheckUp",
      "vetting_invite_reminder": "Lembrete de convite (sem resposta)",
      "vetting_invite_testit": "Convide o candidato para testes específicos (TestIt)",
      "vetting_reminder": "Lembrete CheckUp",
      "talent_checkup_link": "Link do CheckUp para o computador",
      "coaching_encourage": "Coaching — incentivo",
      "coaching_challenge": "Coaching — desafio semanal",
      "coaching_checkin": "Coaching — acompanhamento",
      "coaching_celebrate": "Coaching — celebração",
      "coaching_remind": "Coaching — lembrete",
      "talent_programme_left": "Talento saiu do programa (notificação administrativa)",
      "vetting_share_request": "Pedido para ver o CheckUp (relação existente)",
      "vetting_share_request_testit": "Pedido para ver resultados de testes (relação existente)",
      "vetting_testit_reminder": "Lembrete do TestIt",
      "talent_share_request_declined": "O talento recusou um pedido (notificação ao administrador)",
      "talent_testit_completed": "O talento concluiu os testes que você pediu (notificação ao administrador)",
      "fiscal_document_issued": "Fatura-recibo emitida",
      "fiscal_document_issued_company": "Fatura-recibo emitida para a empresa",
      "inout_notice_lead_time": "InOut: limite de residência se aproximando",
      "inout_notice_confirmation": "InOut: confirmação de presença",
      "inout_notice_renewal_window": "InOut: janela de renovação aberta",
      "inout_agency_contact_request": "InOut: pedido de contato à assessoria",
      "inout_agency_refund_request": "InOut: pedido de reembolso à assessoria",
      "inout_refund_request_tonnie": "InOut: pedido de reembolso à Tonnie",
      "inout_agency_dossier": "InOut: dossiê para a assessoria",
      "qultureup_academy_mission_completed": "Languages Academy: missão concluída",
      "qultureup_academy_level_reached": "Languages Academy: nível alcançado",
      "qultureup_academy_goal_reached": "Languages Academy: meta alcançada",
      "qultureup_academy_inactive": "Languages Academy: hora de uma aula"
    },
    "guide": {
      "started": "Guia {{flow}} iniciado",
      "completed": "Guia {{flow}} concluído",
      "discarded": "Guia {{flow}} descartado",
      "restarted": "Guia {{flow}} reiniciado",
      "retaken": "Guia {{flow}} refeito"
    },
    "milestone": {
      "reached": "Marco alcançado: {{label}}"
    },
    "inout": {
      "started": "InOut iniciado",
      "tripRecorded_one": "Viagem registrada — {{count}} dia fora",
      "tripRecorded_other": "Viagem registrada — {{count}} dias fora",
      "tripPlanned_one": "Viagem planejada — {{count}} dia",
      "tripPlanned_other": "Viagem planejada — {{count}} dias"
    }
  },
  "catalog": {
    "stamps": {
      "first_step": {
        "name": "Primeiro Passo",
        "description": "Complete seu onboarding e comece sua jornada"
      },
      "first_checkup": {
        "name": "Primeiro CheckUp",
        "description": "Complete sua primeira avaliação CheckUp"
      },
      "iqulture_pro": {
        "name": "iQulture PRO",
        "description": "Alcance o status iQulture PRO (pontuação 70+)"
      },
      "visa_approved": {
        "name": "Visto Aprovado",
        "description": "Seu visto ou permissão de residência foi aprovado"
      },
      "arrived": {
        "name": "Chegado ao Destino",
        "description": "Você chegou ao seu país de destino"
      },
      "housing_secured": {
        "name": "Lar, doce lar",
        "description": "Você garantiu habitação em seu destino"
      },
      "first_mission": {
        "name": "Primeira Missão",
        "description": "Complete sua primeira missão de aprendizado QultureUp"
      },
      "world_explorer": {
        "name": "Explorador do Mundo",
        "description": "Complete seu primeiro mundo QultureUp (todas as trilhas)"
      },
      "streak_7": {
        "name": "Sequência de 7 Dias",
        "description": "Complete QultureUp atividades por 7 dias seguidos"
      },
      "streak_30": {
        "name": "Sequência de 30 Dias",
        "description": "Complete QultureUp atividades por 30 dias seguidos"
      },
      "first_checkpoint": {
        "name": "Primeiro Ponto de Verificação",
        "description": "Complete seu primeiro ponto de verificação de bem-estar Care"
      },
      "care_champion": {
        "name": "Campeão Care",
        "description": "Complete todos os 4 pontos de verificação Care agendados"
      },
      "all_heroes": {
        "name": "Jornada Completa",
        "description": "Ativou todos os 5 heróis em sua jornada"
      },
      "adaptation_master": {
        "name": "Mestre da Adaptação",
        "description": "Dominou a adaptação cultural em múltiplos mundos"
      },
      "journey_complete": {
        "name": "Jornada Completa",
        "description": "Concluiu com sucesso toda a sua jornada de integração"
      },
      "inout_started": {
        "name": "InOut iniciado",
        "description": "Comece a manter seu registro de residência no InOut"
      },
      "inout_first_trip": {
        "name": "Primeira viagem registrada",
        "description": "Registre uma viagem fora do país de acolhimento"
      },
      "inout_trip_planned": {
        "name": "Planejado com antecedência",
        "description": "Planeje uma viagem no InOut antes de sair"
      }
    },
    "badges": {
      "legal_expert": {
        "name": "Especialista Legal",
        "description": "Dominou a trilha legal e os direitos cívicos"
      },
      "culture_citizen": {
        "name": "Cultura Citizen",
        "description": "Concluiu todos os mundos culturais no nível Avançado"
      },
      "workplace_master": {
        "name": "Mestre do Local de Trabalho",
        "description": "Adaptação ao local de trabalho e domínio da linguagem concluídos"
      },
      "fully_adapted": {
        "name": "Totalmente Adaptado Citizen",
        "description": "Integração completa — todas as jornadas finalizadas"
      },
      "cultural_ambassador": {
        "name": "Embaixador Cultural",
        "description": "Adaptação cultural excepcional — status de embaixador"
      }
    }
  },
  "about": {
    "aiModel": "Modelo de IA",
    "appName": "Tonnie Citizen",
    "appVersion": "Versão do app",
    "brainService": "Serviço do cérebro",
    "build": "Construir",
    "copyright": "© {{year}} Tonnie. Todos os direitos reservados.",
    "description": "Tonnie é uma plataforma global de mobilidade de talentos que reduz o fracasso na realocação e acelera a integração estável. Combinamos orientação impulsionada por IA com cuidado humano para apoiar cada passo da sua jornada.",
    "environment": "Ambiente",
    "expoSdk": "Expo SDK",
    "fetchingVersions": "Buscando informações da versão...",
    "platform": "Plataforma",
    "platformApi": "API da plataforma",
    "systemInfo": "Informações do sistema",
    "title": "Sobre a Tonnie",
    "version": "Versão {{version}}"
  },
  "accessControl": {
    "accessDenied": "Acesso negado",
    "accessFeatureInCitizenApp": "Acesse {{feature}} através do aplicativo móvel Citizen.",
    "buildJourney": "Construir jornada",
    "enableFamilyProgram": "Ative o Programa Familiar na cobrança para acessar este recurso.",
    "familyMasterOnly": "Este recurso está disponível apenas para Family Masters.",
    "familyProgramRequired": "Programa familiar necessário",
    "featureInCitizenApp": "Este recurso está disponível através do aplicativo móvel Citizen.",
    "featureLocked": "Recurso bloqueado",
    "goToBilling": "Ir para cobrança",
    "heroNotEnabled": "Herói não ativado",
    "heroNotEnabledDescription": "Este herói não está ativado no seu plano atual. Atualize ou troque de jornadas para desbloqueá-lo.",
    "journeyRequired": "Jornada necessária",
    "locked": "Bloqueado",
    "needJourneyToAccess": "Você precisa construir uma jornada para acessar este recurso.",
    "noPermission": "Você não tem permissão para acessar este recurso.",
    "openCitizen": "Abra Citizen",
    "switchJourney": "Trocar jornada",
    "talentOrFamilyMasterOnly": "Este recurso está disponível apenas para Talentos e Family Masters.",
    "upgrade": "Atualizar",
    "useCitizenMobileApp": "Use o aplicativo móvel Citizen"
  },
  "accessScenario": {
    "badges": {
      "companySponsored": "Patrocinado pela empresa",
      "familyMember": "Membro da família",
      "free": "Modo Gratuito",
      "governmentSponsored": "Patrocinado pelo governo"
    },
    "companySponsored": {
      "description": "Talento com jornada patrocinada pela empresa. Acesso completo ao nível Pro, sem pagamento necessário.",
      "label": "Patrocinado pela empresa"
    },
    "familyMember": {
      "description": "Membro da família com o mesmo acesso que o Modo Gratuito. A jornada é desbloqueada através do Programa Familiar.",
      "label": "Membro da família"
    },
    "free": {
      "description": "Assinatura gratuita com acesso limitado. Atualize via Cobrança para desbloquear Pro, Família ou mais Jornadas.",
      "label": "Modo Gratuito"
    },
    "governmentSponsored": {
      "description": "Talento com jornada patrocinada pelo governo. Acesso completo ao nível Pro, sem pagamento necessário.",
      "label": "Patrocinado pelo governo"
    },
    "info": {
      "description": "Cenários de acesso ajudam você a testar diferentes combinações de modos de assinatura, patrocínio de jornada e papéis de usuário. O cenário selecionado determina quais recursos você pode acessar no mockup. Na produção, seu acesso é determinado pela sua assinatura real e instâncias de jornada.",
      "title": "Sobre cenários de acesso"
    },
    "loading": "Carregando...",
    "matrix": {
      "allowed": "Acesso completo",
      "billingDescription": "Gerenciamento de plano e cobrança",
      "careDescription": "Pontos de verificação e suporte pós-chegada",
      "careNotAllowed": "Sem acesso ao Care no Modo Gratuito",
      "careerDescription": "Oportunidades de emprego e ferramentas de carreira",
      "checkupDescription": "Avaliação de prontidão pré-imigração",
      "citizenMobile": "Citizen mobile",
      "cvBuilder": "Construtor de CV",
      "cvBuilderDescription": "Gerador de CV estilo UE e modelos",
      "description": "Compare o acesso aos recursos em todos os cenários. Selecione um cenário para continuar.",
      "familyProgramDescription": "Gerenciamento e convites do programa familiar",
      "familyProgramViaBilling": "Disponível via cobrança. Compre o adicional familiar (€4,99/mês) para habilitar.",
      "features": "Recursos",
      "homeDescription": "Visão geral do painel e da jornada",
      "journeyBuilder": "Construtor de jornada",
      "journeyBuilderDescription": "Configure e construa sua jornada personalizada",
      "journeyBuilderViaBilling": "Disponível após a compra de uma jornada via Cobrança",
      "legend": {
        "allowed": "Acesso completo",
        "citizenMobile": "Disponível via aplicativo móvel Citizen",
        "limited": "Acesso limitado",
        "notAllowed": "Não disponível",
        "readOnly": "Somente leitura (membro da família)",
        "viaBilling": "Disponível via cobrança/Aprimoramento"
      },
      "limited": "Acesso limitado",
      "notAllowed": "Não disponível",
      "passportDescription": "Linha do tempo da jornada e conquistas",
      "passportLimited": "Visualizar eventos/log apenas, sem recursos avançados",
      "profileDescription": "Configurações e preferências do perfil",
      "qultureupDescription": "Integração cultural e aprendizado",
      "qultureupLimited": "Missões básicas apenas, conteúdo limitado",
      "readOnly": "Somente leitura",
      "selected": "Selecionado",
      "teleportalDescription": "Tarefas de realocação e mobilidade",
      "teleportalLimited": "Lista de verificação apenas, sem upload de documentos, sem revisão de IA",
      "title": "Matriz de acesso a recursos",
      "viaBilling": "Via cobrança"
    },
    "select": "Selecionar cenário",
    "subtitle": "Escolha um cenário para testar diferentes níveis de acesso. Você pode atualizar para Pro, adicionar Família ou comprar mais Jornadas via Cobrança.",
    "title": "Selecionar cenário de acesso"
  },
  "address": {
    "city": "Cidade",
    "country": "País",
    "detailsError": "Falha ao obter detalhes do endereço. Por favor, tente novamente.",
    "search": "Buscar endereço",
    "searchDescription": "Comece a digitar para pesquisar um endereço",
    "searchError": "Falha ao buscar endereços. Por favor, tente novamente.",
    "searchPlaceholder": "Comece a digitar um endereço...",
    "typeMinChars": "Digite pelo menos 3 caracteres para pesquisar",
    "citySearch": {
      "suggestions": "Sugestões de cidades",
      "noResults": "Nenhuma cidade encontrada — você pode manter o que digitou.",
      "unavailable": "As sugestões não estão disponíveis agora — você pode manter o que digitou."
    }
  },
  "admin": {
    "carePillars": {
      "saveSuccess": "Configuração dos pilares salva!"
    }
  },
  "alt": {
    "care": "Care",
    "career": "Career",
    "checkup": "CheckUp",
    "copilot": "CoPilot",
    "dialogGraphic": "Gráfico de diálogo",
    "logo": "Logo",
    "passport": "Passport",
    "profile": "Perfil",
    "qultureup": "QultureUp",
    "teleportal": "TelePortal",
    "tonnieLogo": "Logo da Tonnie"
  },
  "assessment": {
    "analyzing": "Analisando seu nível de conhecimento...",
    "answerPlaceholder": "Digite sua resposta aqui...",
    "duration": "Leva cerca de 5-10 minutos",
    "evaluating": "Avaliando suas respostas",
    "finish": "Finalizar",
    "saveFailed": "Não foi possível salvar suas respostas. Tente novamente.",
    "getRecommendations": "Obtenha seu nível e recomendações",
    "loadingAssessment": "Carregando avaliação...",
    "next": "Próximo",
    "personalizedResults": "Resultados personalizados",
    "previous": "Anterior",
    "questionOf": "Pergunta {{current}} de {{total}}",
    "quickAssessment": "Avaliação rápida",
    "skipAhead": "Pular à frente",
    "skipKnownContent": "Pule o conteúdo que você já conhece",
    "startAssessment": "Iniciar avaliação",
    "startFailed": "Não conseguimos carregar as perguntas. Verifique sua conexão e tente novamente.",
    "startFromBeginning": "Começar do início",
    "subtitle": "Deixe-nos avaliar seu nível atual de conhecimento cultural",
    "title": "Avaliação de conhecimento",
    "viewRecommendedPath": "Ver caminho recomendado",
    "placement": {
      "beginner": "Você está começando — seu percurso começa pelos fundamentos da cultura.",
      "intermediate": "Você já conhece o essencial — seu percurso parte do que você já sabe.",
      "advanced": "Você conhece bem a cultura — seu percurso leva você mais longe."
    }
  },
  "assessmentChat": {
    "clickToStartRecording": "Clique para começar a gravar",
    "clickToUpload": "Clique para enviar CV",
    "fileFormats": "PDF, DOC, DOCX",
    "notAtAll": "De forma alguma",
    "recordAgain": "Gravar novamente",
    "recordPitch": "Grave sua apresentação",
    "recordPitchDesc": "Grave um pitch de 60 segundos sobre você e seus objetivos",
    "recordVideoDesc": "Grave um vídeo curto se apresentando (máx. 30 segundos)",
    "recording": "Gravando...",
    "recordingPitch": "Gravando... (máx. 60 segundos)",
    "startRecording": "Começar a gravação",
    "stopRecording": "Parar gravação",
    "typeAnswer": "Digite sua resposta...",
    "typeMessage": "Digite sua mensagem...",
    "veryMuch": "Muito"
  },
  "auth": {
    "alreadySignedIn": {
      "continueToDashboard": "Continuar para o painel",
      "description": "Você está conectado como {{email}}. Continue sua jornada ou saia para usar uma conta diferente.",
      "descriptionBusiness": "Você está conectado como {{email}}. Continue para o painel de Negócios ou desconecte-se para usar uma conta diferente.",
      "signingOut": "Desconectando…",
      "switchAccount": "Sair e usar uma conta diferente",
      "title": "Você já está conectado"
    },
    "backToLogin": "Voltar ao login",
    "biometricSignIn": "Entrar com biometria",
    "checkEmail": "Verifique seu E-mail",
    "confirmPassword": "Confirmar senha",
    "createNewPassword": "Criar nova senha",
    "createStrongPassword": "Crie uma senha forte para sua conta",
    "email": "Email",
    "enterEmailToReset": "Insira seu email para redefinir sua senha",
    "enterNewPassword": "Insira sua nova senha abaixo",
    "errors": {
      "invalidCredentials": "Email ou senha inválidos. Por favor, tente novamente.",
      "invalidVerificationCode": "Código de verificação inválido. Por favor, tente novamente.",
      "resetFailed": "Falha ao redefinir a senha. Por favor, tente novamente ou solicite um novo link de redefinição.",
      "twoFactorRequiredOnReset": "A autenticação de dois fatores é necessária. Por favor, faça login normalmente e redefina sua senha nas Configurações.",
      "unableToCreate": "Não foi possível criar a conta. Por favor, tente novamente.",
      "unableToProcess": "Não foi possível processar sua solicitação. Por favor, tente novamente mais tarde.",
      "unableToResend": "Não foi possível reenviar o código. Por favor, tente novamente."
    },
    "forgotPassword": "Esqueceu a senha?",
    "forgotPasswordTitle": "Esqueceu a senha?",
    "goToLogin": "Ir para login",
    "hidePassword": "Ocultar senha",
    "newPassword": "Nova senha",
    "oauthError": "A autenticação OAuth não pôde ser concluída. Por favor, tente novamente.",
    "oauthFailed": "Falha ao fazer login",
    "oauthRedirecting": "Redirecionando você agora...",
    "oauthSuccess": "Login bem-sucedido!",
    "oauthVerifying": "Por favor, aguarde enquanto verificamos sua conta",
    "password": "Senha",
    "passwordResetSuccess": "Senha redefinida com sucesso!",
    "passwordResetSuccessDesc": "Sua senha foi redefinida com sucesso",
    "passwordResetSuccessTitle": "Redefinição de senha bem-sucedida",
    "resendEmail": "Reenviar email",
    "resetCode": "Redefinir código",
    "resetLinkInstructions": "Clique no link no email para redefinir sua senha. O link expirará em 1 hora.",
    "resetLinkSent": "Link de redefinição de senha enviado para seu email!",
    "resetLinkSentTo": "Enviamos um link de redefinição de senha para {{email}}",
    "resetPassword": "Redefinir senha",
    "returnToLogin": "Retornar ao login",
    "sendResetCode": "Enviar código de redefinição",
    "sendResetLink": "Enviar link de redefinição",
    "sessionExpiring": "Sessão expirando",
    "sessionExpiringDesc": "Você esteve inativo. Você será desconectado em {{seconds}} segundos.",
    "showPassword": "Mostrar senha",
    "signIn": "Entrar",
    "signOut": "Sair",
    "staySignedIn": "Permanecer conectado",
    "validation": {
      "passwordsMatch": "As senhas coincidem"
    },
    "providerErrors": {
      "emailTaken": "Já existe uma conta com este email. Entre com ela.",
      "accountNotFound": "Não encontramos nenhuma conta com este email.",
      "passwordIncorrect": "A senha está incorreta. Tente novamente ou redefina-a.",
      "credentialsIncorrect": "O email ou a senha estão incorretos.",
      "passwordBreached": "Esta senha apareceu em um vazamento de dados. Escolha outra, por favor.",
      "passwordTooShort": "A senha deve ter pelo menos {{passwordMinLength}} caracteres.",
      "passwordTooWeak": "Esta senha é fraca demais. Escolha uma mais forte, por favor.",
      "passwordUnchanged": "A nova senha precisa ser diferente da atual.",
      "codeIncorrect": "Esse código não está correto. Confira o email e tente novamente.",
      "codeExpired": "Esse código expirou. Peça um novo.",
      "codeAttemptsExhausted": "Muitos códigos errados. Peça um novo.",
      "emailInvalid": "Digite um endereço de email válido.",
      "emailNotAllowed": "Este endereço de email não pode ser usado aqui.",
      "tooManyAttempts": "Muitas tentativas. Aguarde alguns minutos e tente novamente.",
      "accountLocked": "Sua conta foi bloqueada temporariamente após muitas tentativas. Tente novamente mais tarde.",
      "alreadySignedIn": "Você já está conectado.",
      "botCheckFailed": "Não foi possível verificar esta solicitação. Atualize a página e tente novamente.",
      "passwordNotSet": "Esta conta não usa senha. Entre da mesma forma que você a criou.",
      "accountUnavailable": "Esta conta não pode ser usada. Entre em contato com o suporte, por favor.",
      "networkUnreachable": "Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.",
      "passwordTooLong": "Esta senha é longa demais. Escolha uma mais curta, por favor.",
      "reverificationRequired": "Por segurança, saia e entre novamente; depois tente de novo.",
      "socialCancelled": "O login foi cancelado. Você pode tentar novamente ou usar seu e-mail.",
      "socialAccountInUse": "Essa conta já está conectada a outra conta Tonnie. Entre nessa conta ou escolha outra opção."
    },
    "passwordRule": {
      "length": "Pelo menos {{passwordMinLength}} caracteres",
      "advice": "Algumas palavras juntas formam uma senha forte e fácil de lembrar.",
      "levels": {
        "weak": "Fraca",
        "fair": "Razoável",
        "good": "Boa",
        "strong": "Forte"
      }
    },
    "passwordCard": {
      "signOutOthers": "Sair dos outros dispositivos",
      "signOutOthersHint": "Quem estiver conectado à sua conta em outro lugar vai precisar da nova senha."
    },
    "social": {
      "continueWith": "Continuar com {{provider}}",
      "failed": "Não conseguimos fazer seu login com {{provider}}. Tente novamente ou use seu e-mail.",
      "failedGeneric": "Não conseguimos concluir seu login. Tente novamente ou use seu e-mail.",
      "signingIn": "Entrando…",
      "signingInDesc": "Só um momento enquanto concluímos seu login.",
      "returnFailed": "Não conseguimos concluir seu login",
      "returnFailedDesc": "A volta da página de login demorou demais. Tente novamente."
    },
    "signUpContinue": {
      "unsupported": "Não conseguimos concluir a criação da sua conta",
      "unsupportedDesc": "Esse login precisa de algo que não pedimos. Comece de novo ou cadastre-se com seu e-mail.",
      "startAgain": "Começar de novo"
    },
    "connected": {
      "connect": "Conectar {{provider}}",
      "disconnect": "Desconectar",
      "disconnectTitle": "Desconectar {{provider}}?",
      "disconnectDesc": "Você não poderá mais entrar com {{provider}}. Você ainda pode entrar com seu e-mail.",
      "connected": "{{provider}} está conectado. Agora você pode entrar com ele.",
      "disconnected": "{{provider}} foi desconectado.",
      "failed": "Não conseguimos conectar {{provider}}. Tente novamente.",
      "disconnectFailed": "Não conseguimos desconectar {{provider}}. Tente novamente."
    },
    "brand": {
      "name": "Tonnie",
      "copyright": "© {{year}} Tonnie",
      "citizen": {
        "signInHeadline": "Sua mudança para o exterior, guiada passo a passo.",
        "signInSubline": "Um só lugar para sua jornada de mudança — do primeiro CheckUp até se sentir em casa.",
        "signUpHeadline": "Comece sua mudança com um plano.",
        "signUpSubline": "Crie sua conta e a Tonnie guia cada passo — antes de partir, no dia e quando você chegar.",
        "checkup": "Saiba onde você está antes de se mudar",
        "teleportal": "Todas as tarefas da mudança, em ordem",
        "qultureup": "Conheça a cultura antes de chegar",
        "care": "Apoio depois que você chegar",
        "passport": "Cada marco da sua jornada, carimbado"
      },
      "business": {
        "signInHeadline": "Realoque seus talentos com confiança.",
        "signInSubline": "Convide, patrocine e acompanhe a mudança de cada contratação — em um só lugar.",
        "signUpHeadline": "Reúna em um só lugar as realocações do seu time.",
        "signUpSubline": "Crie a conta da sua empresa e convide as pessoas que você está realocando quando quiser.",
        "vetting": "Veja quem está pronto para se mudar",
        "mobility": "Todas as tarefas da realocação, em ordem",
        "adaptation": "Ajude quem chega a se instalar",
        "care": "Apoio depois da chegada"
      }
    },
    "flow": {
      "back": "Voltar",
      "continue": "Continuar",
      "orWithEmail": "ou com seu e-mail",
      "or": "ou",
      "emailLabel": "E-mail",
      "emailPlaceholder": "nome@exemplo.com",
      "change": "Alterar",
      "signIn": {
        "title": "Que bom ter você de volta",
        "descriptionCitizen": "Entre para continuar sua jornada.",
        "descriptionBusiness": "Entre no espaço de trabalho da sua empresa.",
        "newHere": "Novo na Tonnie?",
        "createAccount": "Criar uma conta",
        "noAccount": "Não existe nenhuma conta Tonnie com este e-mail."
      },
      "password": {
        "title": "Digite sua senha",
        "label": "Senha",
        "forgot": "Esqueceu a senha?",
        "submit": "Entrar",
        "codeInstead": "Entrar com um código por e-mail"
      },
      "code": {
        "title": "Confira seu e-mail",
        "description": "Enviamos um código de 6 dígitos para {{email}}.",
        "newDevice": "Este dispositivo é novo para nós. Enviamos um código de 6 dígitos para {{email}} para confirmar que é você.",
        "label": "Código de 6 dígitos",
        "submit": "Entrar",
        "resend": "Enviar um novo código",
        "resendIn": "Você pode enviar um novo código em {{seconds}} s."
      },
      "totp": {
        "title": "Digite o código do autenticador",
        "description": "Abra seu aplicativo autenticador e digite o código de 6 dígitos da Tonnie.",
        "label": "Código do autenticador"
      },
      "signUp": {
        "title": "Crie sua conta",
        "description": "Use uma conta que você já tem, ou seu e-mail.",
        "haveAccount": "Já tem uma conta?",
        "signIn": "Entrar",
        "emailTaken": "Já existe uma conta com este e-mail.",
        "signInInstead": "Entrar",
        "legal": "Ao continuar, você aceita os termos da Tonnie.",
        "terms": "Termos de serviço",
        "privacy": "Política de privacidade",
        "step": "Etapa {{current}} de {{total}}",
        "detailsTitle": "Conte um pouco sobre você",
        "firstName": "Nome",
        "lastName": "Sobrenome",
        "passwordLabel": "Crie uma senha",
        "submit": "Criar conta",
        "codeNext": "Em seguida, enviaremos um código por e-mail para confirmar o endereço.",
        "codeTitle": "Confirme seu e-mail",
        "codeSubmit": "Confirmar"
      },
      "invitation": {
        "signIn": "Este convite foi enviado para {{email}}. Entre com esse endereço para aceitá-lo.",
        "signUp": "Este convite foi enviado para {{email}}. Crie sua conta com esse endereço para aceitá-lo."
      }
    },
    "security": {
      "methods": {
        "title": "Formas de acesso",
        "description": "Todas as formas de entrar na sua conta Tonnie, em um só lugar."
      },
      "email": {
        "label": "E-mail",
        "badge": "Acesso e mensagens",
        "change": "Alterar"
      },
      "password": {
        "label": "Senha",
        "set": "Definida — use com seu e-mail para entrar.",
        "notSetWith": "Não definida — você entra com {{providers}} ou com um código enviado para seu e-mail.",
        "notSet": "Não definida — você entra com um código enviado para seu e-mail.",
        "add": "Adicionar senha",
        "change": "Alterar"
      },
      "connected": {
        "heading": "Contas conectadas",
        "connected": "Conectada",
        "notConnected": "Não conectada",
        "connect": "Conectar",
        "description": "Entre com uma conta que você já tem."
      },
      "sessions": {
        "title": "Onde você está conectado",
        "description": "Saia de qualquer lugar que você não reconheça.",
        "signOutOthers": "Sair dos outros dispositivos",
        "thisDevice": "Este dispositivo",
        "signOut": "Sair",
        "none": "Nenhum outro dispositivo está conectado."
      },
      "passwordDialog": {
        "changeTitle": "Alterar senha",
        "addTitle": "Adicionar uma senha",
        "description": "Você vai usá-la na próxima vez que entrar com seu e-mail.",
        "current": "Senha atual",
        "new": "Nova senha",
        "confirm": "Confirmar nova senha",
        "submitChange": "Atualizar senha",
        "submitAdd": "Adicionar senha"
      },
      "emailDialog": {
        "step": "Etapa {{current}} de {{total}}",
        "title": "Alterar seu e-mail",
        "description": "Vamos enviar um código para o novo endereço. Nada muda até você digitá-lo.",
        "current": "Atual",
        "new": "Novo e-mail",
        "linkedNote": "O {{provider}} continua fazendo seu login. O endereço dele continua vinculado e não é afetado por esta alteração.",
        "send": "Enviar código",
        "codeTitle": "Digite o código",
        "codeDescription": "Enviamos para {{email}}.",
        "codeLabel": "Código",
        "confirm": "Confirmar novo e-mail",
        "resend": "Enviar um novo código",
        "doneTitle": "Seu e-mail foi alterado",
        "close": "Concluído"
      }
    },
    "welcome": {
      "haveAccount": "Já tenho uma conta"
    },
    "stepUp": {
      "title": "Confirme que é você",
      "description": "Por segurança, confirme que é você antes desta alteração.",
      "password": "Sua senha",
      "continue": "Continuar",
      "useCode": "Receber um código por e-mail",
      "confirm": "Confirmar",
      "failed": "Não foi possível confirmar que é você. Tente novamente.",
      "unavailable": "Não foi possível confirmar que é você aqui. Feche e tente mais tarde."
    }
  },
  "billing": {
    "availableJourneys": "Jornadas disponíveis",
    "basicAccess": "Acesso básico",
    "cancel": "Cancelar",
    "cancelFailed": "Falha ao cancelar a assinatura. Por favor, tente novamente.",
    "cancelFamilyAddon": "Cancelar adicional família",
    "cancelFamilyAddonError": "Falha ao cancelar o adicional familiar",
    "cancelFamilyDesc": "Seus familiares perderão o acesso no fim do período de cobrança atual.",
    "cancelMessage": "Você tem certeza de que deseja cancelar sua assinatura Pro? Você manterá o acesso até o final do seu período de cobrança.",
    "cancelSubscriptionError": "Falha ao cancelar a assinatura",
    "cancelSuccess": "Assinatura cancelada. O acesso continua até o final do período.",
    "cancelTitle": "Cancelar assinatura",
    "checkoutError": "Falha ao iniciar o checkout. Por favor, tente novamente.",
    "checkoutFailed": "Falha ao iniciar o checkout. Por favor, tente novamente.",
    "commitmentNote": "Sem compromisso — cancele quando quiser.",
    "confirmCancellation": "Confirmar cancelamento",
    "contactSupport": "Falar com o suporte",
    "createFirstJourney": "Criar sua primeira jornada",
    "currentPlan": "Plano atual",
    "downgradeToFree": "Rebaixar para gratuito",
    "email": "Email",
    "emailPlaceholder": "membro@exemplo.com",
    "expired": "Expirado",
    "expires": "Expira",
    "expiringSoon": "Expirando em breve",
    "familyAddonError": "Falha ao comprar o complemento familiar. Por favor, tente novamente.",
    "familyCancelFailed": "Falha ao cancelar o complemento familiar. Por favor, tente novamente.",
    "familyCancelSuccess": "Seu adicional família foi cancelado.",
    "familyDesc": "Leve sua família junto — acesso compartilhado à sua jornada de mudança.",
    "familyMembersWithAccess": "Membros da família com acesso",
    "familyProgram": "Programa familiar",
    "familyProgramAccess": "Acesso ao Programa Familiar",
    "familyPurchaseFailed": "Falha ao comprar o complemento familiar. Por favor, tente novamente.",
    "freeDescription": "Acesso limitado a recursos Tonnie",
    "freePlan": "Plano gratuito",
    "fullAccess": "Acesso completo",
    "invalidEmail": "Por favor, insira um endereço de e-mail válido",
    "inviteDesc": "Envie um convite para que possam entrar na sua jornada.",
    "inviteFailed": "Falha ao enviar o convite. Por favor, tente novamente.",
    "inviteFamilyMember": "Convidar um familiar",
    "inviteMember": "Enviar convite",
    "inviteSent": "Convite enviado para {{email}}",
    "journeyInstances": "Instâncias de jornada",
    "journeyUnlockedPro": "Esta jornada está desbloqueada com o Pro.",
    "keepAddon": "Manter adicional",
    "keepPro": "Manter o Pro",
    "locked": "Bloqueado",
    "manageHousehold": "Gerenciar família",
    "members": "Membros",
    "monthly": "Mensal",
    "monthlyPrice": "Preço mensal",
    "needHelp": "Precisa de ajuda",
    "nextRenewal": "Próxima renovação",
    "noFamilyMembers": "Ainda sem familiares",
    "noJourneyInstances": "Você ainda não tem jornadas",
    "paymentAlreadyProcessed": "Pagamento já processado. Sua jornada está ativa!",
    "paymentCompleted": "Pagamento concluído! Sua jornada foi desbloqueada.",
    "paymentStillProcessing": "Pagamento ainda está sendo processado. Por favor, aguarde um momento e atualize.",
    "paymentSuccessUnlocked": "Pagamento bem-sucedido! Sua jornada foi desbloqueada.",
    "paymentVerificationIssue": "Problema de verificação de pagamento. Por favor, entre em contato com o suporte se sua jornada não estiver desbloqueada.",
    "pending": "Pendente",
    "perMonth": "/mês",
    "perYear": "/ano",
    "pro": "Pro",
    "proDescription": "Jornadas ilimitadas, todas as funcionalidades, suporte prioritário",
    "proFullAccessDesc": "Acesso total a todos os heróis, ferramentas e documentos da sua jornada.",
    "proPlan": "Plano Pro",
    "proUnlockDesc": "Desbloqueie a jornada completa com o Pro.",
    "proceedToPayment": "Continuar para o pagamento",
    "processing": "Processando",
    "purchaseFamilyAddon": "Adicionar o programa família",
    "purchased": "Comprado",
    "recentInvoices": "Faturas recentes",
    "recommended": "Recomendado",
    "renewFailed": "Falha ao renovar a jornada. Por favor, tente novamente.",
    "renewJourney": "Renovar jornada",
    "renewStripeDesc": "Você será levado ao Stripe para renovar sua assinatura com segurança.",
    "revokeAccess": "Revogar acesso",
    "revokeConfirm": "Você tem certeza de que deseja revogar o acesso deste membro?",
    "revokeFailed": "Falha ao revogar o acesso. Por favor, tente novamente.",
    "revokeSuccess": "Acesso revogado com sucesso",
    "sendInvite": "Enviar convite",
    "sending": "Enviando",
    "statusActive": "Ativa",
    "stripeRedirectDesc": "Descrição do StripeRedirect",
    "title": "Cobrança",
    "unlockFailed": "Falha ao desbloquear a jornada. Por favor, tente novamente.",
    "unlockJourney": "Desbloquear jornada",
    "unlockNow": "Desbloquear agora",
    "unlocked": "Desbloqueado",
    "unlockedJourneys": "Jornadas desbloqueadas",
    "upgradeToPro": "Atualizar para Pro",
    "verificationFailed": "Não foi possível verificar a sessão de checkout.",
    "verificationIssue": "Pagamento concluído, mas a verificação teve um problema. Seu acesso deve ser atualizado em breve.",
    "verifyPaymentError": "Não foi possível verificar o pagamento. Por favor, atualize a página ou entre em contato com o suporte.",
    "yearly": "Anual",
    "yearlyDiscount": "Economize com cobrança anual",
    "planChangesUnavailable": "Mudanças de plano não estão disponíveis neste aplicativo.",
    "invoiceKind": {
      "journey_unlock": "Desbloqueio da jornada",
      "journey_renewal": "Renovação da jornada",
      "talent_sponsorship": "Patrocínio de talento",
      "pro_subscription": "Assinatura Pro",
      "enterprise_subscription": "Assinatura Enterprise",
      "family_addon": "Adicional família",
      "subscription": "Assinatura",
      "inout_consultation": "Consulta InOut",
      "inout_requisition": "Requisição InOut"
    },
    "invoiceStatus": {
      "draft": "Rascunho",
      "open": "Aguardando pagamento",
      "paid": "Paga",
      "void": "Anulada",
      "uncollectible": "Pagamento falhou"
    },
    "planFeature": {
      "checkup_basic": "Acesso básico ao CheckUp",
      "career_basic": "Ferramentas de carreira básicas",
      "teleportal_limited": "Acesso limitado ao TelePortal",
      "qultureup_limited": "Acesso limitado ao QultureUp",
      "copilot_limited": "Uso limitado do CoPilot",
      "passport_basic": "Acesso básico ao Passport",
      "journeys_unlimited": "Jornadas ilimitadas",
      "checkup_full": "Acesso completo ao CheckUp",
      "teleportal_full": "Acesso completo ao TelePortal",
      "qultureup_full": "Acesso completo ao QultureUp",
      "copilot_unlimited": "Uso ilimitado do CoPilot",
      "care_advanced": "Recursos avançados do Care",
      "passport_full": "Acesso completo ao Passport",
      "career_tools": "Ferramentas do Career",
      "journey_access_shared": "Acesso compartilhado à jornada",
      "family_dashboard": "Painel da família",
      "seats_unlimited": "Assentos ilimitados",
      "candidates_unlimited": "Candidatos ilimitados",
      "programs_unlimited": "Programas ilimitados",
      "cohorts_unlimited": "Coortes ilimitadas",
      "copilot_queries_unlimited": "Perguntas ao CoPilot ilimitadas",
      "analytics_basic": "Análises básicas",
      "analytics_advanced_api": "Análises avançadas e API",
      "mobility_adaptation_full": "Trilhas completas de Mobilidade e Adaptação",
      "yearly_two_months_free": "2 meses grátis em relação ao mensal",
      "sponsorship_full_access": "Acesso completo à jornada e à área do cidadão para o talento",
      "sponsorship_heroes": "CheckUp, TelePortal, QultureUp e Care",
      "sponsorship_passport": "Passport e conquistas",
      "family_access_optional": "Adicional opcional de acesso para a família",
      "discount_vs_free": "{{count}}% de desconto em relação ao plano Gratuito",
      "support_email": "Suporte por e-mail",
      "support_priority": "Suporte prioritário",
      "family_members_up_to_one": "Até {{count}} membro da família",
      "family_members_up_to_other": "Até {{count}} membros da família",
      "seats_one": "{{count}} assento (um usuário)",
      "seats_other": "{{count}} assentos",
      "candidates_up_to_one": "Até {{count}} candidato",
      "candidates_up_to_other": "Até {{count}} candidatos",
      "programs_one": "{{count}} programa",
      "programs_other": "{{count}} programas",
      "cohorts_one": "{{count}} coorte",
      "cohorts_other": "{{count}} coortes",
      "copilot_queries_monthly_one": "{{count}} pergunta ao CoPilot por mês",
      "copilot_queries_monthly_other": "{{count}} perguntas ao CoPilot por mês",
      "access_window_months_one": "Acesso por {{count}} mês",
      "access_window_months_other": "Acesso por {{count}} meses"
    },
    "seeAllInvoices": "Ver todas",
    "profile": {
      "validation": {
        "legalNameRequired": "Informe o nome para a fatura.",
        "countryRequired": "Escolha o país de cobrança.",
        "addressRequired": "Informe o endereço de cobrança.",
        "postalCodeRequired": "Informe o CEP.",
        "cityRequired": "Informe a cidade.",
        "taxIdInvalid": "Este número fiscal não é válido para o país escolhido.",
        "tooLong": "É longo demais.",
        "taxIdRequired": "Informe o número fiscal da empresa."
      },
      "title": "Dados de cobrança",
      "description": "Para quem suas faturas são emitidas. Uma alteração vale a partir do próximo pagamento.",
      "add": "Adicionar dados",
      "edit": "Editar",
      "empty": "Ainda sem dados de cobrança. Eles serão pedidos antes do seu primeiro pagamento.",
      "legalName": "Nome na fatura",
      "taxId": "Número fiscal",
      "taxIdHint": "Opcional. Informe se quiser que conste nas suas faturas.",
      "noTaxId": "Não informado",
      "country": "País de cobrança",
      "countryPlaceholder": "Escolha um país",
      "address": "Endereço",
      "addressLine1": "Endereço",
      "addressLine2": "Complemento",
      "postalCode": "CEP",
      "city": "Cidade",
      "save": "Salvar",
      "saveAndContinue": "Salvar e continuar para o pagamento",
      "saveFailed": "Não foi possível salvar os dados de cobrança. Tente de novo.",
      "beforePaymentTitle": "Dados para a sua fatura",
      "beforePaymentDescription": "Cada pagamento tem sua fatura-recibo. Diga para quem emiti-la e seguimos para o pagamento."
    },
    "invoiceDocument": {
      "certified": "Ver fatura-recibo",
      "invoice": "Ver fatura",
      "receipt": "Ver recibo"
    },
    "statusPastDue": "Pagamento em atraso",
    "statusCancelled": "Cancelado",
    "statusExpired": "Expirado",
    "loadError": "Não foi possível carregar seu plano."
  },
  "biometric": {
    "authenticating": "Autenticando...",
    "benefits": {
      "dataOnDevice": "Seus dados permanecem no dispositivo",
      "fastLogin": "Login rápido com um toque",
      "secure": "Seguro e criptografado"
    },
    "enable": "Ativar {{name}}",
    "maybeLater": "Talvez mais tarde",
    "settingUp": "Configurando...",
    "touchSensorOrLook": "Toque no sensor ou olhe para o seu dispositivo para autenticar",
    "tryAgain": "Tente novamente",
    "use": "Usar {{name}}",
    "usePasswordInstead": "Usar senha em vez disso",
    "type": {
      "iris": "Escaneamento de íris",
      "generic": "Biométrico"
    },
    "usePasscode": "Usar código de acesso",
    "authenticatePrompt": "Autentique-se para continuar",
    "verifyToEnablePrompt": "Verifique para habilitar o login biométrico",
    "error": {
      "initFailed": "Falha ao inicializar a autenticação biométrica",
      "notSupported": "Autenticação biométrica não suportada",
      "lockout": "Muitas tentativas falhadas. Por favor, tente novamente mais tarde.",
      "authFailed": "Autenticação falhou",
      "enableFailed": "Falha ao habilitar a autenticação biométrica",
      "disableFailed": "Falha ao desabilitar a autenticação biométrica"
    }
  },
  "sponsorships": {
    "offer": {
      "fallbackCompany": "Seu patrocinador",
      "headline": "{{company}} gostaria de patrocinar sua jornada",
      "subheadline": "Aceite para desbloquear a experiência Pro completa — sem custo para você.",
      "loading": "Carregando detalhes da oferta…",
      "unlocks": {
        "title": "O que o patrocínio inclui",
        "checkup": "Avaliação completa CheckUp",
        "teleportal": "Playbook de realocação TelePortal",
        "qultureup": "Integração cultural QultureUp",
        "care": "Care para a jornada de imigração",
        "passport": "Passport — seu registro portátil"
      },
      "route": "Rota: {{from}} → {{to}}",
      "declineNote": "Se você recusar, a empresa será reembolsada automaticamente. Você manterá seu acesso ao nível básico de qualquer forma.",
      "declineCta": "Recusar",
      "acceptCta": "Aceitar patrocínio",
      "decline": {
        "title": "Recusar este patrocínio?",
        "body": "{{company}} será reembolsado integralmente. Você ainda pode completar seu CheckUp no nível básico.",
        "reasonLabel": "Diga a {{company}} o porquê (opcional)",
        "cancel": "Cancelar",
        "confirmCta": "Recusar mesmo assim",
        "bodyKeepsAccess": "A {{company}} será reembolsada integralmente. Sua jornada fica exatamente como está."
      },
      "accepted": {
        "toast": "Bem-vindo a bordo! Sua jornada agora está totalmente patrocinada."
      },
      "declined": {
        "toast": "Patrocínio recusado. {{company}} foi reembolsada."
      },
      "errors": {
        "load": "Não conseguimos carregar esta oferta de patrocínio.",
        "accept": "Não foi possível aceitar o patrocínio agora.",
        "decline": "Não foi possível recusar o patrocínio agora.",
        "notOpen": "Esta oferta não está mais disponível — ela já foi respondida ou retirada."
      },
      "dedicatedNote": "A {{company}} vai patrocinar uma nova jornada só sua nesta rota. Sua jornada atual fica como está, com as empresas que já a acompanham.",
      "takeover": {
        "subheadline": "A {{company}} passa a cobrir esta jornada — sem custo para você.",
        "pro": {
          "title": "Você já tem acesso completo com o Pro",
          "body": "A {{company}} assume esta jornada. Seu Pro continua cobrindo suas outras jornadas, e esta volta para o seu Pro se o patrocínio for cancelado."
        },
        "paid": {
          "title": "Você já pagou por esta jornada",
          "refund": "A {{company}} assume a jornada, e reembolsamos {{amount}} — a parte não usada do desbloqueio da jornada — no seu método de pagamento original. Os reembolsos costumam chegar em 5 a 10 dias úteis.",
          "noRefund": "A {{company}} assume a jornada. Não há mais nada a reembolsar do desbloqueio da jornada."
        },
        "declineNote": "Se você recusar, a empresa é reembolsada automaticamente e sua jornada fica exatamente como está."
      },
      "card": {
        "eyebrow": "Oferta de patrocínio",
        "detail": "Sua jornada para {{country}}",
        "detailDedicated": "Uma nova jornada só sua para {{country}}",
        "review": "Ver oferta",
        "actionFailed": "Não deu certo. Verifique sua conexão e tente de novo."
      },
      "notNow": "Agora não",
      "deferredUntil": "Você adiou esta oferta por enquanto. Ela fica aqui esperando até você decidir e volta para o Início em {{date}}.",
      "list": {
        "title": "{{company}} quer patrocinar você",
        "kind": "Patrocínio",
        "sent": "Enviada em {{date}}"
      }
    }
  },
  "business": {
    "externalWorlds": {
      "course": "Curso: {{language}}",
      "line": "{{world}} · {{language}}",
      "status": {
        "never_synced": "Ainda sem progresso",
        "active": "Ativo",
        "stalled": "Parado",
        "paused": "Pausado",
        "goal_reached": "Meta alcançada"
      },
      "hint": {
        "never_synced": "Ainda não chegou progresso de {{world}}.",
        "stalled": "Sem progresso há {{days}} dias.",
        "paused": "O cidadão retirou o consentimento para compartilhar com {{world}}: o progresso deixou de chegar e é mostrado como estava.",
        "goal_reached": "Alcançou a meta do curso em {{date}}."
      },
      "bands": {
        "start": "Início",
        "current": "Atual",
        "goal": "Meta"
      },
      "bandProgress": "{{percent}} do caminho em {{band}}",
      "completion": "Trilha concluída",
      "noMissions": "Ainda sem missões",
      "progress": "Progresso geral: {{percent}}",
      "paceLabel": "Ritmo",
      "pace_one": "{{count}} missão nos últimos 30 dias",
      "pace_other": "{{count}} missões nos últimos 30 dias",
      "lastActivityLabel": "Último progresso",
      "reduced": "Por enquanto, {{world}} envia só o nível atual, então as porcentagens são sobre esse nível.",
      "summaryOnly": "Apenas um resumo: as missões e seus títulos ficam com o cidadão."
    },
    "activity": {
      "title": "Atividade",
      "subtitle": "Tudo o que está acontecendo em seus talentos",
      "empty": "Nenhuma atividade ainda",
      "untitled": "Atividade"
    },
    "pipeline": {
      "stages": {
        "acquisition": "Aquisição",
        "vetting": "Verificação",
        "mobility": "Mobilidade",
        "integration": "Integração",
        "adaptation": "Adaptação",
        "care": "Care",
        "evidence": "Evidência",
        "sponsored": "Patrocinado",
        "pending_invite": "Convite pendente",
        "archived": "Arquivado",
        "cohort_assigned": "Coorte atribuída",
        "unknown": "Desconhecido"
      },
      "talentActions": "Ações de talento"
    },
    "about": {
      "aboutUs": "Sobre nós",
      "backToDashboard": "Voltar ao painel",
      "heroCare": "Gerenciamento de pontos de verificação de Care e rastreamento de bem-estar",
      "heroCheckup": "Resultados CheckUp, pontuações MESH e insights iQulture para triagem",
      "heroEvidence": "Evidências Passport/IRR e resultados do programa",
      "heroPrograms": "Gerenciamento de programas e coortes",
      "heroQultureup": "Progresso de adaptação QultureUp via Mundos, Trilhas e Missões",
      "heroSponsored": "Alocações e cobrança de jornada patrocinada",
      "heroTeleportal": "Progresso TelePortal nas trilhas Legal, Viagem e Configuração",
      "heroes": "Heróis",
      "heroesDesc": "Conheça os heróis por trás da Tonnie — a equipe dedicada a transformar a mobilidade global de talentos.",
      "learnMore": "Saiba mais sobre Tonnie Business",
      "platformOverview": "Visão geral da plataforma",
      "platformOverviewDesc": "Nossa plataforma ajuda as empresas a gerenciar todo o ciclo de vida da mobilidade de talentos — desde a busca e triagem até a realocação e cuidados contínuos.",
      "termsAndPrivacy": "Termos & privacidade",
      "title": "Sobre",
      "tonnieBusiness": "Tonnie Business",
      "tonnieBusinessDesc": "Tonnie Business é uma plataforma abrangente para gerenciar mobilidade internacional de talentos, contratação e programas de integração.",
      "version": "Versão {{version}}"
    },
    "adaptationPage": {
      "active": "Ativo",
      "activeFilter": "Ativo",
      "activeTab": "Ativo",
      "archivedTab": "Arquivado",
      "activelyLearning": "Aprendendo ativamente",
      "attentionReason": {
        "inactive": "Sem atividade em mais de 2 semanas",
        "declining": "Atividade em declínio",
        "not_begun": "Avaliação concluída — sem missões ainda",
        "streak_at_risk": "Sequência prestes a quebrar"
      },
      "levels": {
        "beginner": "Iniciante",
        "intermediate": "Intermediário",
        "advanced": "Avançado"
      },
      "clearFilters": "Limpar filtros",
      "coach": "Treinador",
      "errors": {
        "messageTooShort": "A mensagem deve ter pelo menos 5 caracteres",
        "messageTooLong": "A mensagem deve ter 500 caracteres ou menos"
      },
      "nudge": "Empurrar",
      "nudgeAria": "Envie um lembrete rápido para {{name}}",
      "sendCoachAria": "Enviar mensagem de coaching para {{name}}",
      "sendMessage": "Enviar mensagem",
      "streakAtRisk": "Sequência em risco",
      "talentRowActionsAria": "Ações para {{name}}",
      "tryAdjustFilters": "Tente ajustar sua busca ou filtros",
      "view": "Ver",
      "viewTalentAria": "Ver detalhes para {{name}}",
      "aiCoachDesc": "Coaching sugerido para cada talento, com base no progresso no QultureUp",
      "aiCoachRecommendations": "Recomendações do coach de IA",
      "alertDescription": "{{inactive}} talentos inativos, {{atRisk}} em risco, e {{streaks}} sequências em risco",
      "allCohorts": "Todas as coortes",
      "allEngagement": "Todo o engajamento",
      "allTalents": "Todos os talentos",
      "atRiskExcl": "Em risco!",
      "atRiskFilter": "Em risco",
      "avgMiles": "Média de Miles",
      "avgQultureUpCompletion": "Média de conclusão QultureUp",
      "boostMotivation": "Aumentar a motivação",
      "celebrateTopPerformers": "Celebrar os melhores desempenhos",
      "coachAlert": "Alerta do treinador",
      "coachTip1": "Mensagens personalizadas têm 3x mais engajamento do que as genéricas",
      "coachTip2": "Talentos que recebem check-ins semanais têm 40% mais chances de completar sua jornada",
      "coachTip3": "Celebrar pequenas vitórias aumenta a motivação e a retenção de sequências",
      "coachingCenter": "Centro de coaching",
      "coachingToolkit": "Kit de ferramentas de coaching",
      "coachingToolkitDesc": "Ferramentas de coaching personalizadas e modelos de mensagens",
      "description": "Acompanhe e gerencie o progresso de adaptação de talentos, métricas de engajamento e insights de coaching",
      "engagement": "Engajamento",
      "engagementDistDesc": "Visualizar o engajamento dos talentos em diferentes níveis",
      "engagementDistribution": "Distribuição de engajamento",
      "engagementLegendAria": "Como as bandas de engajamento são calculadas",
      "engagementLegendTitle": "Como as bandas são calculadas",
      "engagementLegendDesc": "Cada talento é classificado com base em quão recentemente esteve ativo, sua sequência diária e quantas missões completou esta semana.",
      "quickActionsAllClear": "Tudo claro",
      "quickActionsAllClearDesc": "Nenhuma ação de coaching é necessária no momento.",
      "coachingQueueTitle": "Fila de coaching",
      "coachingQueueDesc": "Cada talento agrupado por engajamento — os mais urgentes primeiro.",
      "coachAllCount": "Coache todos os {{count}}",
      "noCoachingTalents": "Nenhum talento em Adaptação ainda",
      "noCoachingTalentsDesc": "Os talentos aparecem aqui assim que começam sua jornada QultureUp.",
      "engagementTrends": "Aprendizado em resumo",
      "engagementTrendsDesc": "Onde seus talentos estão nesta semana",
      "filterByCohort": "Filtrar por coorte",
      "gentleNudge": "Empurrão gentil",
      "healthDashboard": "Painel de saúde",
      "healthScore": "Pontuação de saúde",
      "inactiveFilter": "Inativo",
      "insights": "Insights",
      "messageFailed": "Falha ao enviar mensagem",
      "messageSent": "Mensagem {{type}} enviada para {{name}}",
      "miles": "Miles",
      "missions": "Missões",
      "missionsThisWeek": "Missões esta semana",
      "motivateActiveLearners": "Motivar aprendizes ativos com novos desafios",
      "needAttention": "Precisa de atenção",
      "needsEncouragement": "Precisa de encorajamento",
      "noTalentsFound": "Nenhum talento encontrado",
      "notificationInApp": "O talento receberá uma notificação no aplicativo",
      "overallProgress": "Progresso geral",
      "quickCoachActions": "Ações rápidas de coaching",
      "quickCoachActionsDesc": "Ações com um clique para apoiar seus talentos",
      "quickNudgeSent": "Empurrão rápido enviado para {{name}}",
      "reachInactiveTalents": "Alcançar talentos inativos",
      "recognizeAchievements": "Reconhecer conquistas",
      "saveStreaks": "Salvar sequências",
      "score": "Pontuação",
      "searchTalents": "Pesquisar talentos...",
      "sendPersonalizedMessage": "Escolha uma ação e depois adicione uma nota pessoal ou envie a mensagem da sua empresa.",
      "sendWeeklyChallenge": "Enviar desafio semanal",
      "setGoals": "Definir metas",
      "showYouCare": "Mostrar que você se importa",
      "slowing": "Diminuindo o ritmo",
      "slowingDownFilter": "Diminuindo o ritmo",
      "streak": "Sequência",
      "thriving": "Prosperando",
      "thrivingFilter": "Prosperando",
      "title": "Adaptação",
      "topPerformers": "Melhores desempenhos",
      "topPerformersDesc": "Talentos com o maior engajamento e progresso",
      "worlds": "Mundos",
      "writeYourMessage": "Escreva sua mensagem",
      "engagementDescriptions": {
        "thriving": "Altamente engajado, progresso consistente",
        "active": "Atividade regular, progresso constante",
        "slowing": "Atividade diminuindo, pode precisar de incentivo",
        "at_risk": "Engajamento em declínio, precisa de atenção",
        "inactive": "Sem atividade recente, atenção urgente necessária"
      },
      "engagementCriteria": {
        "thriving": "Uma sequência de {{thrivingStreak}}+ dias com forte impulso esta semana",
        "active": "Ativo recentemente com impulso semanal constante",
        "slowing": "Inativo por mais de {{slowingDays}} dias, ou recente mas perdendo impulso",
        "at_risk": "Inativo por mais de {{atRiskDays}} dias, ou estagnado sem progresso esta semana",
        "inactive": "Sem atividade em {{inactiveDays}}+ dias"
      },
      "coachingBandMessage": {
        "thriving": "Celebre o progresso deles para reforçar o hábito.",
        "active": "Mantenha o impulso com um novo desafio.",
        "slowing": "Um empurrão oportuno agora os impede de escorregar ainda mais.",
        "at_risk": "Entre em contato para remover bloqueios e reconstruir o impulso.",
        "inactive": "Reengaje com um check-in pessoal antes que eles se desconectem."
      },
      "coachingBandLabel": {
        "thriving": "Celebre talentos prósperos",
        "active": "Desafie talentos ativos",
        "slowing": "Treine talentos em desaceleração",
        "at_risk": "Treine talentos em risco",
        "inactive": "Treine talentos inativos"
      },
      "coachTipsTitle": "Dicas de coaching",
      "coachActions": {
        "encourage": "Incentivar",
        "challenge": "Desafiar",
        "checkin": "Check In",
        "celebrate": "Celebrar",
        "remind": "Lembrar"
      },
      "insightsRecommendations": {
        "topWorldRecommend": "O Mundo de Exploração Cultural tem o maior engajamento — recomende-o a talentos em dificuldade",
        "sendReminders": "Enviar lembretes",
        "celebrate": "Celebrar",
        "recommend": "Recomendar",
        "checkIn": "Check In",
        "streaksAtRisk_one": "{{count}} talento está prestes a perder sua sequência — envie um lembrete agora",
        "streaksAtRisk_other": "{{count}} talentos estão prestes a perder suas sequências — envie lembretes agora",
        "thrivingCelebrate_one": "{{count}} talento está prosperando — considere celebrar suas conquistas",
        "thrivingCelebrate_other": "{{count}} talentos estão prosperando — considere celebrar suas conquistas",
        "inactiveCheckIn_one": "{{count}} talento não acessa há mais de 2 semanas — pode precisar de um check-in",
        "inactiveCheckIn_other": "{{count}} talentos não acessaram por mais de 2 semanas — eles podem precisar de um check-in"
      },
      "trendMetrics": {
        "activeLearners": "Aprendizes ativos",
        "weeklyMissions": "Missões semanais",
        "avgMiles": "Média de Miles"
      },
      "noOneNeedsAttention": "Ninguém precisa de atenção imediata",
      "confirmBulkSend": "Enviar {{count}}",
      "personalNote": "Nota pessoal (opcional)",
      "personalNoteHint": "Deixe em branco para enviar a mensagem de {{action}} da sua empresa, definida em Mensagens.",
      "ofTotal": "{{value}} de {{total}}",
      "viewAllInBand": "Ver todos ({{count}})",
      "dayStreak_one": "Sequência de {{count}} dia",
      "dayStreak_other": "Sequência de {{count}} dias",
      "engagementBandAria_one": "Mostrar {{count}} talento {{band}}",
      "engagementBandAria_other": "Mostrar {{count}} talentos {{band}}",
      "needsAttentionCount_one": "{{count}} precisa de atenção",
      "needsAttentionCount_other": "{{count}} precisam de atenção",
      "milesCount_one": "{{count}} Mile",
      "milesCount_other": "{{count}} Miles",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talentos",
      "viewAllNeedingAttention_one": "Ver o {{count}} que precisa de atenção",
      "viewAllNeedingAttention_other": "Visualizar todos os {{count}} precisando de atenção",
      "confirmBulkTitle_one": "Enviar {{count}} mensagem de coaching?",
      "confirmBulkTitle_other": "Enviar {{count}} mensagens de coaching?",
      "confirmBulkDescription_one": "Prestes a enviar \"{{action}}\" para {{count}} talento. Ele receberá uma notificação em seu aplicativo móvel.",
      "confirmBulkDescription_other": "Prestes a enviar \"{{action}}\" para {{count}} talentos. Cada um receberá uma notificação em seu aplicativo móvel.",
      "searchTalentsLabel": "Buscar talentos",
      "sentCheckIns_one": "Check-in enviado para {{count}} talento",
      "sentCheckIns_other": "Check-in enviado para {{count}} talentos",
      "sendCheckInsTo_one": "Enviar um check-in para {{count}} talento inativo",
      "sendCheckInsTo_other": "Enviar um check-in para {{count}} talentos inativos",
      "sentStreakReminders_one": "Lembrete de sequência enviado para {{count}} talento",
      "sentStreakReminders_other": "Lembrete de sequência enviado para {{count}} talentos",
      "remindAboutStreaks_one": "Lembrar {{count}} talento com a sequência em risco",
      "remindAboutStreaks_other": "Lembrar {{count}} talentos com a sequência em risco",
      "recognizeThriving_one": "Reconhecer {{count}} talento em destaque",
      "recognizeThriving_other": "Reconhecer {{count}} talentos em destaque",
      "sentRecognition_one": "Reconhecimento enviado para {{count}} talento",
      "sentRecognition_other": "Reconhecimento enviado para {{count}} talentos",
      "sentChallenges_one": "Desafio semanal enviado para {{count}} talento",
      "sentChallenges_other": "Desafio semanal enviado para {{count}} talentos",
      "sentCoaching_one": "Coaching enviado para {{count}} talento",
      "sentCoaching_other": "Coaching enviado para {{count}} talentos"
    },
    "addTalentsWizard": {
      "addCohortToOrganize": "Adicionar uma nova coorte para organizar talentos",
      "atsIntegration": "Integração ATS",
      "atsMethodDesc": "Conecte seu sistema ATS e importe candidatos diretamente para seu pipeline. Sincronize em tempo real com suas ferramentas de recrutamento existentes.",
      "biWeekly": "Quinzenal (primeiras 8 semanas)",
      "cancel": "Cancelar",
      "chooseCohortForCandidates": "Escolha a qual cohorte adicionar esses candidatos",
      "chooseCohortForTalents": "Escolha a coorte para adicionar esses talentos",
      "clear": "Limpar",
      "close": "Fechar",
      "cohortCreated": "Coorte \"{{name}}\" criada com sucesso",
      "cohortNamePlaceholder": "ex.: Q2 2024 — Engenheiros Backend",
      "cohortNameRequired": "Nome do cohorte *",
      "cohortsCanExistWithoutProgram": "Coortes podem existir sem um programa. As rotas são definidas por talento ao patrocinar.",
      "connectAdditionalATS": "Você pode conectar sistemas ATS adicionais nas configurações de integrações.",
      "createCohortButton": "Criar cohorte",
      "createCohortDesc": "Crie uma nova coorte. Você pode atribuí-la a um programa mais tarde ou deixá-la não atribuída.",
      "createNewCohort": "Criar novo cohorte",
      "createNewProgram": "Criar novo programa",
      "createProgramButton": "Criar programa",
      "createProgramDesc": "Crie um novo programa para organizar suas iniciativas de contratação internacional.",
      "defaultFeedbackCadence": "Cadência de feedback padrão",
      "describeProgramPlaceholder": "Descreva os objetivos e o escopo do programa...",
      "descriptionOptional": "Descrição (opcional)",
      "deselectAll": "Desmarcar todos",
      "downloadTemplateCsv": "Baixar modelo CSV",
      "dropFileHere": "Solte seu arquivo aqui ou clique para navegar",
      "email": "Email",
      "enterProgramName": "Por favor, insira um nome de programa",
      "errorReason": "Razão",
      "errorReason_duplicate": "Duplicar",
      "errorReason_invalid": "Inválido",
      "errorReason_system": "Erro de sistema",
      "errors": {
        "cohortNameRequired": "O nome da coorte é obrigatório",
        "createCohortFailed": "Não foi possível criar o grupo. Por favor, tente novamente.",
        "createProgramFailed": "Não foi possível criar o programa. Por favor, tente novamente.",
        "emptyFile": "O arquivo está vazio ou não possui linhas de dados",
        "endDateInvalid": "Insira uma data de término válida",
        "malformedFile": "Não conseguimos ler este arquivo. Tente salvá-lo como .csv e reenvie.",
        "mustMapEmail": "Mapeie pelo menos uma coluna para Email antes de continuar",
        "mustMapName": "Mapeie pelo menos uma coluna para Primeiro nome (ou Nome completo) antes de continuar",
        "noValidRows": "Nenhuma linha passou na validação. Corrija os erros acima e tente novamente.",
        "programNameRequired": "O nome do programa é obrigatório",
        "selectCohort": "Selecione um grupo antes de continuar",
        "startDateInvalid": "Insira uma data de início válida",
        "startDateRequired": "A data de início é obrigatória",
        "systemFailure": "Algo deu errado. Por favor, tente novamente.",
        "tooManyRows": "Os arquivos são limitados a {{max}} linhas. Divida seu arquivo e tente novamente.",
        "unsupportedFile": "Por favor, envie um arquivo .csv, .xlsx ou .xls",
        "planLimit": "O plano gratuito permite até 100 candidatos. Faça upgrade para Enterprise para adicionar mais.",
        "fileTooLarge": "O arquivo é maior que 10 MB. Corte o arquivo e tente novamente.",
        "cohortAtCapacity": "Esta turma está cheia ({{max}} talentos). Escolha outra turma ou aumente o limite dela.",
        "programAtCapacity": "Este programa está cheio ({{max}} talentos). Escolha outro programa ou aumente o limite dele."
      },
      "excelColumn": "Coluna do Excel",
      "excelCsvUpload": "Upload de Excel/CSV",
      "excelMethodDesc": "Importe talentos de arquivos de planilhas. Suporta formatos Excel e CSV com mapeamento automático de colunas.",
      "expectedTalentCount": "Contagem de talentos esperada (opcional)",
      "fieldLabels": {
        "email": "Email",
        "firstName": "Primeiro nome",
        "ignore": "Ignorar",
        "lastName": "Último nome",
        "location": "Localização",
        "name": "Nome completo (será dividido)",
        "role": "Função",
        "skills": "Habilidades"
      },
      "fileReady": "Arquivo pronto!",
      "fillRequiredFields": "Por favor, preencha todos os campos obrigatórios",
      "firstName": "Primeiro nome",
      "fixValidationErrors": "Por favor, corrija os erros de validação antes de continuar",
      "importCandidatesFrom": "Importar candidatos diretamente do {{name}}",
      "importMethodLabel": "Método de importação",
      "importSummary": "Resumo da importação",
      "invalidEmail": "Email inválido",
      "invalidFileType": "Por favor, faça upload de um arquivo Excel ou CSV válido",
      "inviteToVetting": "Convidar para avaliação",
      "inviteToVettingFailed": "Falha ao convidar talentos",
      "lastName": "Último nome",
      "location": "Localização",
      "mapColumnsInstruction": "Mapeie colunas do Excel para campos Tonnie. Primeiras 5 linhas mostradas:",
      "mapTo": "Mapear Para",
      "match": "corresponder",
      "missingName": "Nome ausente",
      "monthly": "Mensal (meses 3-6)",
      "name": "Nome",
      "needDifferentATS": "Precisa conectar um ATS diferente?",
      "noDataYet": "Sem dados ainda — talentos nesta fase preencherão esta visualização",
      "noProgramUnassigned": "Sem programa (não atribuído)",
      "plusMore": "+ Mais",
      "poolMethodDesc": "Navegue e adicione talentos do seu Tonnie Talent Pool diretamente ao seu pipeline.",
      "programCreated": "Programa \"{{name}}\" criado com sucesso",
      "programNamePlaceholder": "ex.: Iniciativa de Talentos em Tecnologia",
      "programNameRequired": "Nome do programa *",
      "programOptional": "Programa (opcional)",
      "quarterly": "Trimestral (meses 6-12)",
      "readyToImport": "Pronto para importar talentos",
      "readyToMapColumns": "Pronto para mapear colunas",
      "requiredFields": "Nome e Email são campos obrigatórios",
      "resultDuplicates": "Duplicados",
      "resultFailed": "Falhou",
      "resultImported": "Importado",
      "resultPartial": "Alguns talentos não foram importados",
      "role": "Função",
      "samplePreview": "Valor de exemplo",
      "searchPlaceholder": "Pesquisar por nome, cargo ou localização...",
      "select": "Selecionar",
      "selectATSError": "Por favor, selecione um sistema ATS",
      "selectAllCount": "Selecionar todos ({{count}})",
      "selectCandidateError": "Por favor, selecione pelo menos um candidato",
      "selectCohortError": "Por favor, selecione uma coorte",
      "selectFile": "Selecionar arquivo",
      "selectProgramOptional": "Selecionar programa (opcional)",
      "selectedLabel": "Selecionado",
      "startDateRequired": "Data de início *",
      "status": "Status",
      "stepATS": "ATS",
      "stepCohort": "Coorte",
      "stepConfirm": "Confirmar",
      "stepMap": "Mapear",
      "stepMethod": "Método",
      "stepReview": "Revisão",
      "stepSelect": "Selecionar",
      "stepUpload": "Carregar",
      "supportsFileTypes": "Suporta arquivos Excel (.xlsx, .xls) e CSV de até 10MB",
      "targetArrivalDate": "Data de chegada alvo",
      "toastImportedHint": "Abra o Pipeline > coluna de Aquisição e clique em Enviar Convite para Avaliação quando estiver pronto para enviar um e-mail a cada candidato.",
      "toastNothingImported": "Nenhum talento importado",
      "totalCandidates": "Total de candidatos",
      "totalTalents": "Total de talentos",
      "unassigned": "Não atribuído",
      "uploadDifferentFile": "Carregar um arquivo diferente",
      "vettingNotStarted": "A avaliação ainda não começou para este talento",
      "whatHappensNext": "O que acontece a seguir?",
      "whatHappensNextDesc": "Após a importação, os talentos aparecerão na fase de Aquisição. Você pode então convidá-los para CheckUp e patrocinar aqueles que estão prontos.",
      "addingToPill": "Adicionando a: {{name}}",
      "guard": {
        "archivedTitle": "Este grupo está arquivado",
        "pausedTitle": "Este grupo está pausado",
        "programPausedTitle": "O programa pai está pausado",
        "archivedBody": "Grupos arquivados não podem aceitar novos talentos. Restaure o grupo primeiro para convidar pessoas.",
        "pausedBody": "Grupos pausados não podem aceitar novos talentos. Retome o grupo primeiro para convidar pessoas.",
        "programPausedBody": "O programa pai está pausado. Retome o programa para começar a aceitar novos talentos neste grupo.",
        "cohortPill": "Grupo: {{name}}"
      },
      "issues": {
        "emailInvalid": "Email inválido ou ausente",
        "emailDuplicate": "Duplicado da linha {{row}}",
        "nameMissing": "Primeiro nome ausente",
        "textTooLong": "{{field}} tem mais de {{max}} caracteres",
        "skillsTooMany": "Mais de {{max}} habilidades",
        "skillTooLong": "Uma habilidade tem mais de {{max}} caracteres"
      },
      "candidatesAttached_one": "{{count}} candidato anexado à coorte",
      "candidatesAttached_other": "{{count}} candidatos anexados à coorte",
      "candidatesSelected_one": "{{count}} candidato selecionado",
      "candidatesSelected_other": "{{count}} candidatos selecionados",
      "candidatesWillBeAdded_one": "{{count}} candidato será adicionado a {{cohort}}",
      "candidatesWillBeAdded_other": "{{count}} candidatos serão adicionados a {{cohort}}",
      "candidatesWillBeAddedVetting_one": "{{count}} candidato será adicionado à coorte selecionada e pode ser convidado a iniciar a triagem.",
      "candidatesWillBeAddedVetting_other": "{{count}} candidatos serão adicionados à coorte selecionada e podem ser convidados a iniciar a triagem.",
      "errorsCount_one": "{{count}} erro",
      "errorsCount_other": "{{count}} erros",
      "errorsTitle_one": "{{count}} linha precisa de atenção",
      "errorsTitle_other": "{{count}} linhas precisam de atenção",
      "inviteToVettingSent_one": "{{count}} talento convidado para a triagem",
      "inviteToVettingSent_other": "{{count}} talentos convidados para a triagem",
      "ofShown_one": "(de {{count}} exibido)",
      "ofShown_other": "(de {{count}} exibidos)",
      "readyToAddCandidates_one": "Pronto para adicionar {{count}} candidato do seu ATS",
      "readyToAddCandidates_other": "Pronto para adicionar {{count}} candidatos do seu ATS",
      "readyToImportTalents_one": "Pronto para importar {{count}} talento da sua planilha",
      "readyToImportTalents_other": "Pronto para importar {{count}} talentos da sua planilha",
      "reviewImportedData_one": "Revise os dados importados ({{count}} linha)",
      "reviewImportedData_other": "Revise os dados importados ({{count}} linhas)",
      "rowsDetected_one": "{{count}} linha detectada",
      "rowsDetected_other": "{{count}} linhas detectadas",
      "talentsCount_one": "{{count}} talento",
      "talentsCount_other": "{{count}} talentos",
      "talentsImported_one": "{{count}} talento importado",
      "talentsImported_other": "{{count}} talentos importados",
      "talentsWillBeImported_one": "{{count}} talento será importado para {{cohort}}",
      "talentsWillBeImported_other": "{{count}} talentos serão importados para {{cohort}}",
      "talentsWillBeImportedAcquisition_one": "{{count}} talento será importado para a coorte selecionada e aparecerá na fase de Aquisição.",
      "talentsWillBeImportedAcquisition_other": "{{count}} talentos serão importados para a coorte selecionada e aparecerão na fase de Aquisição.",
      "toastDuplicates_one": "{{count}} já está na sua empresa",
      "toastDuplicates_other": "{{count}} já estão na sua empresa",
      "toastFailed_one": "{{count}} falhou",
      "toastFailed_other": "{{count}} falharam",
      "toastImported_one": "{{count}} adicionado à aquisição",
      "toastImported_other": "{{count}} adicionados à aquisição",
      "validCount_one": "{{count}} válido",
      "validCount_other": "{{count}} válidos",
      "mapColumnTo": "Mapear a coluna {{column}} para"
    },
    "sponsor": {
      "modal": {
        "title": "Patrocine a jornada de {{firstName}}",
        "subtitle": "Ative a experiência completa da Tonnie para este talento.",
        "steps": {
          "recap": "Recapitulação",
          "pricing": "Preços",
          "message": "Mensagem",
          "review": "Revisão"
        },
        "step1": {
          "noCheckup": "CheckUp pendente — a pontuação aparecerá assim que {{firstName}} concluir a avaliação.",
          "craHeading": "Perfil de risco",
          "verdictHeading": "Por que patrocinar agora",
          "verdict": {
            "pro": "Candidato PRO forte. O patrocínio desbloqueia toda a jornada para uma contratação de alta confiança.",
            "potential": "Alto potencial — o patrocínio acelera o caminho da avaliação para a evidência.",
            "emerging": "Sinal emergente — o patrocínio permite uma avaliação completa em todos os cinco heróis."
          },
          "unlocksHeading": "O que o patrocínio desbloqueia",
          "unlocksFootnote": "Uma vez que {{firstName}} aceite, todos os cinco heróis são ativados.",
          "continueCta": "Continuar para preços"
        },
        "step2": {
          "heading": "Preços",
          "planNameFree": "Pagamento por uso",
          "planNameEnterprise": "Tarifa Enterprise",
          "subtitle": "Cobrança única — reembolso proporcional se você cancelar depois.",
          "monthlyRate": "Taxa mensal",
          "duration": "Duração",
          "total": "Compromisso total",
          "billedOnce": "Cobrado uma vez via Stripe",
          "heroes": {
            "checkup": "CheckUp",
            "teleportal": "TelePortal",
            "qultureup": "QultureUp",
            "care": "Care",
            "passport": "Passport"
          },
          "familyAccess": "Acesso familiar",
          "familyAccessHint": "Incluir membros da família na jornada",
          "refundHeading": "Reembolsável de forma proporcional",
          "refundScenarios": {
            "decline": {
              "label": "Se eles recusarem",
              "body": "reembolso automático total, nenhuma ação necessária."
            },
            "cancel": {
              "label": "Se você cancelar no meio",
              "body": "o reembolso é igual aos meses restantes × taxa mensal."
            },
            "lock": {
              "label": "Heróis bloqueados até a aceitação",
              "body": "sem risco antes que o talento aceite."
            }
          },
          "refundFootnote": "Os reembolsos são processados automaticamente através do Stripe.",
          "continueCta": "Continue a mensagem",
          "durationMonths_one": "{{count}} mês",
          "durationMonths_other": "{{count}} meses"
        },
        "step3": {
          "subtitle": "Tonnie envia um e-mail de ativação curado com o link de aceitar/rejeitar. Adicione uma nota pessoal opcional que aparecerá no e-mail acima da chamada para ação.",
          "customMessageLabel": "Sua nota (opcional)",
          "customMessagePlaceholder": "Bem-vindo a bordo — adoraríamos tê-lo conosco em {{destination}}.",
          "charsCounter": "{{count}} / {{max}}",
          "previewHeading": "Prévia do e-mail",
          "previewSubheading": "O que {{firstName}} realmente receberá",
          "previewAriaLabel": "Prévia do e-mail de ativação que {{firstName}} receberá",
          "previewDisclaimer": "Enviado automaticamente após o sucesso do pagamento. {{firstName}} tem tempo ilimitado para aceitar.",
          "toneHint": {
            "concise": "Conciso",
            "warm": "Aconchegante",
            "professional": "Detalhado"
          },
          "chips": {
            "label": "Inserções rápidas",
            "destination": "Adicionar destino",
            "destinationSnippet": "Mal podemos esperar para tê-lo conosco em {{destination}}.",
            "destinationAria": "Insira uma frase sobre o destino",
            "teamWelcome": "Adicionar boas-vindas da equipe",
            "teamWelcomeSnippet": "Toda a equipe {{company}} está torcendo por você.",
            "teamWelcomeAria": "Insira uma frase de boas-vindas da equipe",
            "signoff": "Adicionar despedida",
            "signoffSnippet": "Ansioso para construir esta jornada juntos.",
            "signoffAria": "Insira uma frase pessoal de despedida"
          },
          "continueCta": "Reveja e pague"
        },
        "step4": {
          "talentLabel": "Talento",
          "routeLabel": "Rota",
          "pricingLabel": "Preços",
          "rateTimesMonths": "{{rate}}/mês × {{count}}",
          "messageLabel": "Nota de ativação",
          "messageEmptyPlaceholder": "A mensagem de ativação padrão da Tonnie será enviada.",
          "routeEmpty": "Definido no perfil do talento.",
          "routeUnknown": "Não definido",
          "vatNote": "Impostos (se houver) são calculados no Stripe Checkout.",
          "previewToggle": "Prévia do e-mail de ativação",
          "previewToggleOpen": "Ocultar prévia do e-mail",
          "commitmentTitle": "Você está prestes a se comprometer",
          "commitmentBody": "{{total}} hoje. Reembolso proporcional disponível durante a janela de {{durationMonths}} meses. {{firstName}} tem tempo ilimitado para aceitar.",
          "trustAriaLabel": "Sinais de confiança de pagamento",
          "trust": {
            "stripe": "Protegido pelo Stripe",
            "refundable": "Reembolso proporcional",
            "noExpiry": "Sem expiração para o talento",
            "autoSent": "E-mail enviado automaticamente"
          },
          "nextTitle": "O que acontece a seguir",
          "next": {
            "s1": "Abrimos o Stripe Checkout nesta aba.",
            "s2": "Após o sucesso do pagamento, {{firstName}} recebe seu e-mail de ativação automaticamente.",
            "s3": "O cartão muda para Patrocinado — Aguardando aceitação."
          },
          "payCta": "Patrocinar e pagar {{total}}"
        },
        "preview": {
          "fromLabel": "De",
          "subject": "{{company}} gostaria de patrocinar sua jornada Tonnie",
          "greeting": "Oi {{firstName}},",
          "introTail": "acabou de pagar para patrocinar sua jornada completa Tonnie — pendente de sua aceitação.",
          "unlocksHeading": "O que você desbloqueia se aceitar",
          "heroes": {
            "checkup": "avaliação completa iQulture",
            "teleportal": "guia de visto, realocação e moradia",
            "qultureup": "missões de integração cultural",
            "care": "apoio ao bem-estar durante a mudança",
            "passport": "seu registro portátil de progresso"
          },
          "noCost": "Não custa nada para você. Se você recusar, {{company}} será automaticamente reembolsado e você manterá seu acesso básico.",
          "yourNoteHeading": "Uma nota da equipe",
          "ctaLabel": "Revise e responda à oferta de patrocínio",
          "noExpiry": "Esta oferta está à sua espera — não há expiração. Leve o tempo que precisar.",
          "signOff": "Bem-vindo a bordo,",
          "signature": "A equipe Tonnie",
          "fallbackCompany": "Sua empresa"
        },
        "footer": {
          "back": "Voltar",
          "cancel": "Cancelar",
          "peekPreview": "Visualizar o e-mail"
        },
        "errors": {
          "checkoutFailed": "Não foi possível abrir o Stripe Checkout. Tente novamente ou entre em contato com o suporte.",
          "customMessageTooLong": "Sua nota deve ter 2000 caracteres ou menos.",
          "planNotFound": "Não foi possível encontrar o plano de patrocínio. Entre em contato com o suporte.",
          "planMisconfigured": "O plano de patrocínio não está configurado corretamente. Entre em contato com o suporte.",
          "discountUnavailable": "Esse desconto não está mais disponível. Revise o preço e tente novamente.",
          "planLimitExceeded": "Você atingiu o limite do seu plano. Faça upgrade para patrocinar mais talentos.",
          "needsInvitation": "Sua empresa ainda não tem uma relação com esta pessoa, então ela não pode ser patrocinada diretamente. Convide-a primeiro pelo Pool.",
          "inviteFromPool": "Convidar pelo Pool",
          "alreadySponsored": "Esta jornada já tem um patrocínio em andamento, então não pode ser patrocinada de novo até que ele termine.",
          "sharedWithAnotherCompany": "Outra empresa também acompanha esta pessoa nesta jornada, e uma jornada patrocinada pertence a uma só empresa. Você pode patrociná-la em uma jornada só sua na mesma rota — ela aceita com a sua oferta.",
          "sponsoredByAnotherCompany": "Outra empresa já patrocina esta jornada.",
          "routeFull": "Esta pessoa já tem o máximo de jornadas que uma rota permite, então não é possível criar uma nova para você. Ela pode arquivar uma primeiro.",
          "sponsorDedicated": "Patrocinar em uma jornada própria",
          "notSponsorable": "Esta jornada já é financiada de um jeito que um patrocínio de empresa não pode assumir, então nada foi cobrado."
        }
      },
      "return": {
        "verifyingPayment": "Confirmando seu pagamento…",
        "paymentFailed": "O pagamento não pôde ser confirmado",
        "paymentFailedDescription": "Tonnie não recebeu uma sessão de checkout paga do Stripe. Se você completou o pagamento, atualize em um momento — webhooks podem levar alguns segundos para chegar. Caso contrário, tente novamente a partir da gaveta de Triagem.",
        "backToVetting": "Voltar para avaliação",
        "stepConfirm": {
          "title": "Patrocínio pago — aguardando aceitação",
          "subtitleHint": "O talento fica em Verificação, marcado como “Patrocínio oferecido”, até aceitar.",
          "headline": "Patrocínio pago — e-mail de ativação enviado",
          "awaitingTitle": "Aguardando aceitação do talento",
          "body": "O talento vai receber um e-mail e pode aceitar ou recusar. Ele passa para Patrocinado quando aceitar; se recusar, você é reembolsado automaticamente. Até lá, você o encontra em Verificação, onde pode reenviar a oferta ou abandoná-la.",
          "backToVetting": "Voltar para avaliação",
          "viewTalent": "Ver talento",
          "resendCta": "Reenviar e-mail de ativação",
          "resendSuccess": "E-mail de ativação reenviado.",
          "resendAlready": "E-mail de ativação já foi enviado — nenhum duplicado foi despachado."
        },
        "errors": {
          "missingSponsorship": "Tonnie ainda está confirmando o pagamento. Atualize em alguns segundos e tente novamente.",
          "resendFailed": "Não foi possível reenviar o e-mail de ativação."
        }
      }
    },
    "talentDetail": {
      "loading": "Carregando…",
      "viewFullVettingReport": "Ver relatório completo de avaliação",
      "header": {
        "couple": "Casal",
        "familyWithKids": "Família +{{count}}",
        "singleParent": "Família monoparental +{{count}}",
        "openLinkedIn": "Abrir perfil do LinkedIn",
        "solo": "Solo",
        "sponsorCta": "Patrocinar este talento"
      },
      "iqultureBlock": {
        "ariaLabel": "Pontuação iQulture {{score}} de 100, nível {{tier}}",
        "label": "iQulture"
      },
      "kebab": {
        "label": "Mais ações"
      },
      "insights": {
        "vettingInsights": "O veredicto da Tonnie em um relance — pontuação, fundações MESH, riscos culturais e evidências de pilares em um painel de decisão.",
        "vettingMesh": "Motivação, inglês, habilidades interpessoais, habilidades técnicas — os quatro sinais em que toda decisão de patrocínio confiante é baseada.",
        "vettingArchetypes": "Arquetipos culturais revelam como {{name}} se adapta. Arquetipos de baixo risco são suas apostas mais seguras de patrocínio.",
        "vettingPillars": "Cada pilar é pontuado de forma independente com bandeiras verdes, bandeiras vermelhas e evidências — o histórico de auditoria por trás da pontuação iQulture.",
        "vettingSkills": "O que {{name}} traz para a mesa: habilidades interpessoais, habilidades técnicas e a adequação cultural.",
        "vettingPitch": "{{name}}'s pitch de 60 segundos — veja-os em suas próprias palavras antes de patrocinar.",
        "vettingProfile": "Identidade, histórico, contexto familiar — o perfil completo que {{name}} construiu na Tonnie.",
        "vettingActivity": "Cada sinal que Tonnie capturou: mensagens enviadas, transições de fase, marcos de heróis.",
        "sponsoredOverview": "Onde {{name}} está agora em sua jornada de realocação.",
        "sponsoredVetting": "Por que você patrocinou {{name}}: sua pontuação iQulture e evidência MESH.",
        "sponsoredMobility": "Jurídico e documentos, instalação local, viagem e logística — três trilhas de mobilidade. Um bloqueio aqui atrasa todo o resto.",
        "sponsoredAdaptation": "QultureUp transforma o choque cultural em adaptação mensurável. A consistência supera sprints.",
        "sponsoredCare": "Estabilidade é sucesso patrocinado. O check-in barato hoje evita a recuperação cara depois.",
        "sponsoredEvidence": "Prova tangível da jornada de {{name}}: emblemas, milhas, marcos.",
        "sponsoredActivity": "Sinal ao vivo de cada herói — a resposta para 'o que está acontecendo?' que os administradores sempre precisam."
      },
      "toneRibbon": {
        "label": "Tonnie recomenda",
        "phase": {
          "invited": "Convidado",
          "started": "CheckUp em progresso",
          "submitted": "CheckUp enviado",
          "scored": "Pontuado",
          "verdict": "Pronto para o veredicto"
        },
        "tone": {
          "green": "Ajuste forte — prossiga com confiança",
          "amber": "Algumas ressalvas — revise os insights antes de patrocinar",
          "red": "Preocupações significativas — leia as bandeiras com cuidado",
          "neutralAwaiting": "Aguardando sinal CheckUp",
          "neutralScored": "Pontuação disponível — sinal qualitativo pendente"
        }
      },
      "recommendation": {
        "green": {
          "title": "Tonnie recomenda patrocinar"
        },
        "amber": {
          "title": "Patrocine com os olhos abertos"
        },
        "red": {
          "title": "Preocupações significativas"
        },
        "neutral": {
          "title": "Recomendação pendente"
        }
      },
      "radar": {
        "tooltip": {
          "pillar": {
            "scoreAt": "Em {{min}}–{{max}}",
            "evaluationQuestion": "Perguntas do cérebro",
            "band": {
              "excellent": "Excelente",
              "solid": "Sólido",
              "mixed": "Misturado",
              "weak": "Fraca",
              "tier": "Nível {{tier}}"
            }
          },
          "archetype": {
            "persona": "Persona {{persona}}",
            "bucketLow": "Baixo risco ({{score}})",
            "bucketModerate": "Risco moderado ({{score}})",
            "bucketHigh": "Alto risco ({{score}})"
          }
        },
        "axis": {
          "ariaLabel": "Mais sobre {{label}}"
        }
      },
      "insightsTab": {
        "label": "Insights",
        "emptyTitle": "Insights são desbloqueados uma vez que o CheckUp é pontuado",
        "verdict": {
          "scoreSuffix": "/ 100",
          "badgeLabel": "badge iQulture",
          "scoreLabel": "pontuação iQulture",
          "confidenceBand": {
            "high": "Alta confiança",
            "moderate": "Confiança moderada",
            "low": "Baixa confiança"
          },
          "confidenceTooltip": "A confiança da Tonnie nesta avaliação: {{percent}}% (média entre os 7 pilares de avaliação).",
          "scoredToday": "Pontuado hoje",
          "scoredAgo_one": "Pontuado há {{count}}d",
          "scoredAgo_other": "Pontuado há {{count}}d",
          "fallbackRationale": "Tonnie avaliou este perfil em MESH fundações e 10 arquétipos culturais — as abas de suporte abaixo trazem a divisão completa.",
          "rationaleStrong": "Forte {{strongest}} ({{strongestScore}}%) sustenta este perfil.",
          "rationaleWeak": "Fraqueza em {{weakest}} ({{weakestScore}}%) é a principal preocupação.",
          "rationaleAlert": "Alerta principal: {{alert}}",
          "eyebrow": "Recomendação da Tonnie"
        },
        "deepLink": {
          "openActivity": "Abrir atividade",
          "openArchetypes": "Abrir arquétipos",
          "openMesh": "Abrir MESH",
          "openPillars": "Abrir pilares",
          "openPitch": "Abrir pitch",
          "openSkills": "Abrir habilidades"
        },
        "deepDive": {
          "activity": "Linha do tempo de engajamento e atividade deste perfil",
          "pillars": "Para o histórico de auditoria e evidências pilar por pilar",
          "pitch": "Para ver este candidato em suas próprias palavras",
          "skills": "Para o inventário completo de capacidades",
          "title": "Onde olhar a seguir"
        },
        "badgeAndScore": {
          "title": "pontuação iQulture & badge",
          "scoreLabel": "Pontuação",
          "badgeLabel": "Emblema"
        },
        "mesh": {
          "title": "Fundações MESH",
          "subtitle": "Os quatro sinais sobre os quais todo patrocínio confiante é construído."
        },
        "conclusion": {
          "title": "Conclusão da Tonnie"
        },
        "snapshot": {
          "title": "À primeira vista"
        },
        "cra": {
          "title": "Arquétipos de risco cultural",
          "severityChip": "{{low}} baixo · {{moderate}} moderado · {{high}} alto",
          "severityTier": {
            "low": "baixo",
            "moderate": "moderado",
            "high": "alto"
          },
          "radarSeries": "Pontuação de risco",
          "radarA11yLabel": "Radar de arquétipos de risco cultural — {{summary}}",
          "empty": "Nenhum dado de arquétipo disponível ainda.",
          "description_one": "Onde {{name}} se posiciona no {{count}} arquétipo — mais próximo do centro = menor risco cultural.",
          "description_other": "Onde {{name}} se posiciona entre os {{count}} arquétipos — mais próximo do centro = menor risco cultural."
        },
        "pillars": {
          "title": "Avaliação de pilares",
          "description": "Todos os sete pilares de avaliação em um radar — mais próximo da borda externa significa uma pontuação de pilar mais forte.",
          "confidenceChip": "{{band}} · confiança média",
          "radarSeries": "Pontuação de pilar",
          "radarA11yLabel": "Radar de avaliação de Pilar — {{summary}}",
          "legendUnknownCodes": "Os rótulos dos eixos são códigos de pilares. Abra a aba Pilares para a análise completa."
        }
      },
      "tabs": {
        "testit": "TestIt",
        "activity": "Atividade",
        "adaptation": "Adaptação",
        "archetypes": "Arquétipos",
        "care": "Care",
        "checkup": "CheckUp",
        "evidence": "Evidência",
        "insights": "Insights",
        "mesh": "MESH",
        "mobility": "Mobilidade",
        "overview": "Visão geral",
        "pillars": "Pilares",
        "pitch": "Apresentação",
        "profile": "Perfil",
        "skills": "Habilidades",
        "vetting": "Verificação",
        "decisionRecords": "Registros de decisão",
        "stripLabel": "Seções do talento",
        "scrollPrevious": "Mostrar seções anteriores",
        "scrollNext": "Mostrar mais seções"
      },
      "communications": {
        "privacyNote": "Você vê o que foi enviado e o que aconteceu com a mensagem — nunca o conteúdo, o endereço de destino nem o motivo de uma mensagem não ter sido entregue.",
        "empty": "Nada foi enviado a este talento ainda.",
        "loadError": "Não foi possível carregar as comunicações. Tente novamente em instantes.",
        "loadMore": "Carregar mensagens anteriores",
        "channelEmail": "Email",
        "channelInApp": "No app",
        "channelPush": "Push",
        "kindSystem": "Mensagem automática",
        "kindAdmin": "Mensagem da sua equipe",
        "kindInApp": "Notificação no app",
        "statusQueued": "Na fila",
        "statusDispatched": "Enviada · resultado não registrado",
        "statusSent": "Enviada",
        "statusDelivered": "Entregue",
        "statusOpened": "Aberta",
        "statusFailed": "Falhou",
        "statusBounced": "Devolvida",
        "statusNotDelivered": "Não entregue",
        "deliveredAt": "Entregue em {{date}}",
        "openedAt": "Aberta em {{date}}",
        "readInAppAt": "Lida na Tonnie em {{date}}"
      },
      "activity": {
        "empty": "Nenhuma atividade ainda — eventos aparecerão aqui quando o talento avançar pelo pipeline, completar uma etapa CheckUp ou receber uma mensagem.",
        "error": "Não foi possível carregar a atividade. Tente novamente em um momento.",
        "eventCount_one": "{{count}} evento",
        "eventCount_other": "{{count}} eventos",
        "loadMore": "Carregar atividade anterior",
        "loadingMore": "Carregando atividade anterior…",
        "live": "Ao vivo",
        "polling": "Atualização periódica",
        "withheldBody": "Este cidadão não compartilhou a própria atividade com a sua empresa. Os eventos exibidos são da própria empresa: movimentos no pipeline e mensagens que você enviou.",
        "eventCountPartial_one": "{{count}} evento apenas da sua empresa",
        "eventCountPartial_other": "{{count}} eventos apenas da sua empresa",
        "viewLabel": "Mostrar",
        "view": {
          "all": "Tudo",
          "progress": "Progresso do talento",
          "pipeline": "Pipeline",
          "messages": "Mensagens"
        },
        "viewEmpty": "Ainda não há nada nesta visualização.",
        "hero": {
          "checkup": "CheckUp",
          "mobility": "Mobilidade",
          "adaptation": "Adaptação",
          "care": "Care",
          "evidence": "Evidência",
          "pipeline": "Pipeline",
          "system": "Tonnie"
        },
        "actorNotRecorded": "Autor não registrado"
      },
      "sponsored": {
        "ribbon": {
          "status": {
            "awaitingAcceptance": "Aguardando aceitação do talento",
            "active": "Patrocínio ativo",
            "cancelling": "Processamento de reembolso",
            "talentDeclined": "Talento recusou",
            "refunded": "Reembolsado",
            "cancelled": "Cancelado",
            "pastDue": "Pagamento atrasado",
            "failed": "Pagamento falhou",
            "unknown": "Sem patrocínio ativo",
            "completed": "Concluído"
          },
          "monthsRemaining_one": "{{count}} meses restantes",
          "monthsRemaining_other": "{{count}} meses restantes",
          "refundAtRisk": "{{amount}} reembolso em risco",
          "acceptedOn": "Aceito {{date}}",
          "awaitingTalent": "Aguardando aceitação do talento"
        },
        "health": {
          "totalMonths_one": "{{count}} meses",
          "totalMonths_other": "{{count}} meses",
          "elapsed": "{{elapsed}} de {{total}} meses transcorridos",
          "awaitingActivationSent": "Ativação enviada {{ago}}",
          "awaitingBody": "O talento recebeu um link de ativação por e-mail. O patrocínio ativa no momento em que eles aceitam.",
          "cancellingBody": "O reembolso está sendo processado. A Stripe nos notificará quando os fundos forem liberados; o patrocínio será movido para reembolsado automaticamente.",
          "declinedBody": "O talento recusou a oferta de patrocínio. Um reembolso total foi emitido.",
          "closedBody": "O patrocínio está encerrado e a empresa não financia mais esta jornada. O talento mantém o próprio acesso e ainda pode completar seu CheckUp.",
          "closedOn": "Fechado {{date}}",
          "paymentFailedBody": "O último pagamento do patrocínio falhou. Atualize o método de pagamento para manter o talento ativo.",
          "refundAmount": "Valor do reembolso: {{amount}}",
          "completedBody": "O patrocínio de 12 meses chegou ao fim. Nada é reembolsado; o talento continua com o próprio plano.",
          "completedOn": "Terminou em {{date}}"
        },
        "heroes": {
          "mobility": "Mobilidade",
          "adaptation": "Adaptação",
          "care": "Care",
          "evidence": "Evidência",
          "notStarted": "Ainda não iniciado"
        },
        "heroesGrid": {
          "mobilitySubtitle": "Visto, documentação, prontidão para viagem",
          "adaptationSubtitle": "Preparação cultural, missões, sequência",
          "careSubtitle": "Bem-estar, estabilidade, intervenções",
          "evidenceSubtitle": "Distintivos, selos e milhas acumuladas",
          "blockers_one": "{{count}} bloqueador",
          "blockers_other": "{{count}} bloqueadores",
          "worldsLabel": "Mundos",
          "missionsLabel": "Missões",
          "tracksLabel": "Faixas",
          "streakDays_one": "sequência de {{count}}",
          "streakDays_other": "sequência de {{count}}",
          "wellbeingLabel": "Pontuação de bem-estar",
          "lastCheckin": "Último {{ago}}",
          "openInterventions_one": "{{count}} abertos",
          "openInterventions_other": "{{count}} abertos",
          "moodLabel": "Humor",
          "settlementLabel": "Liquidação",
          "checkpointsValue": "{{done}}/{{total}} pontos de verificação",
          "docsReady": "Docs prontos",
          "assessmentDone": "Avaliação concluída",
          "awaitingData": "Aguardando o primeiro check-in para ver a pontuação de bem-estar.",
          "miles": "Miles",
          "badges": "Emblemas",
          "stamps": "Selos",
          "openTabHint": "Abra a aba para lembrar"
        },
        "activity": {
          "preview": {
            "title": "Atividade recente",
            "viewAll": "Ver atividade completa",
            "empty": "Nenhum evento de patrocínio ainda"
          }
        },
        "meta": {
          "familyAccess": "Acesso familiar",
          "familyAccessOn": "Ativado",
          "familyAccessOff": "Desativado",
          "familyAccessOnToast": "Acesso familiar ativado",
          "familyAccessOffToast": "Acesso familiar desativado",
          "familyAccessFailed": "Falha ao atualizar o acesso familiar",
          "startedAt": "Iniciado",
          "endsAt": "Termina",
          "amountPaid": "Valor pago",
          "refundIfCancelledToday": "Reembolso se cancelar hoje",
          "monthsLeft_one": "Falta {{count}} mês",
          "monthsLeft_other": "Faltam {{count}} meses"
        },
        "banner": {
          "headline": "Jornada de {{name}}",
          "miles": "Miles da jornada",
          "monthsLeft": "Meses restantes",
          "ctaViewVetting": "Ver avaliação",
          "ctaOpenMobility": "Abrir mobilidade",
          "ctaOpenAdaptation": "Abrir adaptação",
          "ctaOpenCare": "Abrir Care",
          "statusNotStarted": "Não iniciado",
          "statusLocked": "Bloqueado",
          "statusDone": "Concluído",
          "day": "Dia {{day}}",
          "dayLabel": "da jornada",
          "nextEyebrow": "Onde olhar em seguida"
        },
        "footer": {
          "action": {
            "resendActivation": "Reenviar e-mail de ativação",
            "abandon": "Abandonar patrocínio",
            "cancel": "Cancelar patrocínio",
            "close": "Fechar",
            "reoffer": "Reoferecer patrocínio",
            "updatePayment": "Atualizar pagamento"
          },
          "refundProcessing": "Processando reembolso — nenhuma ação enquanto o Stripe finaliza"
        },
        "smartNudge": {
          "sending": "Enviando…",
          "cta": {
            "mobility": "Enviar tarefa de mobilidade",
            "adaptation": "Enviar lembrete de adaptação",
            "care": "Enviar check-in Care"
          },
          "sent": {
            "mobility": "Lembrete da tarefa de mobilidade enviado para {{name}}",
            "adaptation": "Lembrete de adaptação enviado para {{name}}",
            "care": "Solicitação de check-in Care enviada para {{name}}"
          },
          "errorMissingEmail": "Não é possível enviar — o talento não tem e-mail cadastrado.",
          "templateMissing": "O modelo \"{{code}}\" não está configurado para este inquilino. Adicione ou restaure-o em Mensagens → Modelos.",
          "sendFailed": "Falha ao enviar lembrete",
          "fallback": {
            "mobilityTask": "seu próximo passo de mobilidade",
            "adaptationMission": "sua próxima missão QultureUp"
          }
        },
        "abandon": {
          "confirmTitle": "Abandonar este patrocínio?",
          "confirmDescription": "{{name}} receberá um reembolso total e a jornada reverterá para acesso apenas por convite. Esta ação não pode ser desfeita.",
          "confirmCancel": "Manter patrocínio",
          "confirmAction": "Abandonar e reembolsar",
          "successToast": "Patrocínio abandonado · reembolso emitido",
          "failedToast": "Falha ao abandonar patrocínio"
        },
        "resendActivation": {
          "successToast": "E-mail de ativação reenviado",
          "failedToast": "Falha ao reenviar e-mail de ativação"
        },
        "noSponsorshipTitle": "Nenhum patrocínio ativo para esta jornada",
        "noSponsorshipBody": "O talento não tem linha de patrocínio ativa para esta jornada. Verifique a aba Patrocinado no pipeline se uma jornada diferente estiver patrocinada, ou inicie uma nova a partir da gaveta de Triagem.",
        "relative": {
          "justNow": "agora mesmo",
          "minAgo_one": "{{count}}m atrás",
          "minAgo_other": "{{count}}m atrás",
          "hourAgo_one": "{{count}}h atrás",
          "hourAgo_other": "{{count}}h atrás",
          "dayAgo_one": "{{count}}d atrás",
          "dayAgo_other": "{{count}}d atrás"
        },
        "alreadyAnswered": "O talento já respondeu a esta oferta de patrocínio."
      },
      "nudge": {
        "cta": "Enviar lembrete",
        "description": "Escolha uma mensagem modelada para acordá-los. Você pode substituir o corpo antes de enviar.",
        "failed": "Falha ao enviar lembrete",
        "noTemplates": "Nenhum modelo configurado para esta etapa. Adicione um em Mensagens → Modelos.",
        "overrideHint": "Deixe em branco para enviar o modelo como está. Qualquer coisa que você digitar aqui substituirá o corpo do modelo.",
        "overrideLabel": "Mensagem personalizada (opcional)",
        "overridePlaceholder": "Adicione uma nota pessoal antes de enviar…",
        "recommended": "Recomendado",
        "send": "Enviar lembrete",
        "sending": "Enviando…",
        "sent": "“{{name}}” enviado",
        "templateLabel": "Modelo",
        "title": "Enviar um lembrete"
      },
      "mobility": {
        "blocked": "Bloqueado",
        "blockers": {
          "onTrack": "No caminho — sem bloqueios ou tarefas atrasadas.",
          "blockedTracks_one": "{{count}} caminho bloqueado",
          "blockedTracks_other": "{{count}} caminhos bloqueados",
          "overdueTasks_one": "{{count}} tarefa atrasada",
          "overdueTasks_other": "{{count}} tarefas atrasadas"
        },
        "docStatus": {
          "pending": "Pendente",
          "uploaded": "Enviado",
          "validated": "Validado",
          "rejected": "Rejeitado",
          "missing": "Faltando"
        },
        "documents": {
          "title": "Documentos",
          "otherTrack": "Outro",
          "certified": "Certificado",
          "expiringSoon": "Expirando em breve",
          "downloadAll": "Baixar tudo",
          "downloadSelected": "Baixar {{count}}",
          "downloadError": "Não foi possível baixar os documentos.",
          "select": "Selecionar documento",
          "withheldBody": "Este cidadão não compartilhou os seus documentos com a sua empresa. A lista abaixo continua correta — o que não pode mais ser baixado são os arquivos em si."
        },
        "error": "Não foi possível carregar os dados de mobilidade.",
        "header": {
          "title": "Jornada de realocação",
          "subtitle": "Tarefas, documentos e marcos em cada caminho"
        },
        "noTracks": "Nenhum caminho de mobilidade foi iniciado ainda.",
        "nudge": "Enviar lembrete de mobilidade",
        "progress": "{{percent}}% completo",
        "taskStatus": {
          "pending": "A fazer",
          "in_progress": "Em progresso",
          "completed": "Completo",
          "blocked": "Bloqueado",
          "skipped": "Ignorado",
          "archived": "Arquivado"
        },
        "tasks": {
          "title": "Tarefas de talento",
          "talent": "Talento",
          "otherTrack": "Outro",
          "blocking": "Bloqueando",
          "blockedBy": "Bloqueado por {{count}}",
          "overdue": "Atrasado",
          "certified": "Certificado",
          "docCount_one": "{{count}} documento",
          "docCount_other": "{{count}} documentos",
          "location": {
            "home_country": "País de origem",
            "target_country": "Destino",
            "online": "Online",
            "either": "Qualquer"
          },
          "ownership": {
            "company": "Empresa",
            "government": "Governo",
            "dual": "Compartilhado"
          }
        },
        "timeline": {
          "title": "Marcos",
          "summary": "{{reached}} de {{total}} alcançados",
          "reached": "Alcançado"
        }
      },
      "adaptation": {
        "error": "Não foi possível carregar os dados de adaptação.",
        "header": {
          "assessedOn": "Avaliado em {{date}}",
          "miles": "Miles",
          "missions": "Missões",
          "notAssessed": "Não avaliado",
          "streak": "Sequência",
          "streakDays": "{{count}}d",
          "timeLearning": "Tempo de aprendizado",
          "title": "Adaptação"
        },
        "overviewTab": "Visão geral",
        "tracksTab": "Mundos e caminhos",
        "thisWeek": "Esta semana",
        "ariaWeekly": "Gráfico de engajamento semanal",
        "missionsProgress": "{{completed}} de {{total}} missões",
        "tracksProgress": "{{completed}}/{{total}} caminhos",
        "noWorlds": "Nenhum mundo QultureUp iniciado ainda.",
        "tracksTitle": "Mundos e caminhos",
        "levelAll": "Todos",
        "noTracksForLevel": "Nenhum caminho neste nível.",
        "noMissions": "Nenhuma missão neste caminho ainda.",
        "recommendedNext": "Próximo recomendado",
        "status": {
          "completed": "Completo",
          "in_progress": "Em progresso",
          "locked": "Bloqueado",
          "not_started": "Não iniciado"
        },
        "suggest": "Sugerir",
        "suggestionSent": "Sugerido “{{mission}}” — enviado por e-mail",
        "worldsTitle": "Mundos",
        "missionsCount_one": "missão",
        "missionsCount_other": "missões"
      },
      "evidence": {
        "error": "Não foi possível carregar os dados de evidência.",
        "export": {
          "title": "Registro de jornada",
          "description": "Exporte o registro completo da jornada do talento como relatório PDF ou arquivo CSV.",
          "pdf": "Exportar PDF",
          "csv": "Exportar CSV"
        },
        "header": {
          "title": "Jornada Passport",
          "subtitle": "Selos, emblemas e milhas acumuladas ao longo da jornada",
          "miles": "Total de Miles",
          "level": "Nível Citizen",
          "stamps": "Selos",
          "badges": "Emblemas",
          "thisWeek": "Esta semana"
        }
      },
      "care": {
        "checkins": {
          "empty": "Nenhum check-in ainda.",
          "last30Days": "Últimos 30 dias",
          "lastCheckin": "Último check-in {{date}}",
          "moodTrend": "Tendência de humor",
          "privacyNote": "Entradas individuais de humor permanecem privadas para o talento — apenas a frequência e a tendência são mostradas.",
          "streak": "Sequência de dias",
          "title": "Atividade de check-in",
          "trend": {
            "down": "Caindo",
            "stable": "Estável",
            "up": "Subindo"
          }
        },
        "commitment": {
          "component": {
            "careResponsiveness": "Responsividade Care",
            "checkinConsistency": "Consistência de check-in",
            "engagementLevel": "Engajamento",
            "integrationProgress": "Progresso de integração",
            "pillarStability": "Estabilidade do pilar",
            "tenureStability": "Estabilidade de tempo de serviço"
          },
          "empty": "O Índice de Compromisso aparecerá uma vez que o talento tenha check-ins ou pontos de verificação.",
          "history": {
            "empty": "Histórico insuficiente ainda — a linha de tendência aparece após um segundo cálculo.",
            "range": "{{min}}–{{max}}",
            "title": "Histórico do índice",
            "ariaLabel_one": "Histórico do Índice de Compromisso, {{count}} ponto de dados de {{min}} a {{max}}",
            "ariaLabel_other": "Histórico do Índice de Compromisso, {{count}} pontos de dados de {{min}} a {{max}}"
          },
          "level": {
            "at_risk": "Em risco",
            "champion": "Campeão",
            "committed": "Comprometido",
            "engaged": "Engajado",
            "flight_risk": "Risco de saída"
          },
          "noRisks": "Nenhum sinal de risco ativo.",
          "risks": "Sinais de risco",
          "risksRestricted": "Os sinais de risco são restritos nesta empresa. Fale com um administrador se precisar deles.",
          "title": "Índice de compromisso",
          "trend": {
            "declining": "Declinando",
            "improving": "Melhorando",
            "stable": "Estável"
          }
        },
        "checkpoints": {
          "empty": "Nenhum ponto de verificação agendado ainda.",
          "status": {
            "cancelled": "Cancelado",
            "completed": "Completo",
            "due": "Vencido",
            "in_progress": "Em andamento",
            "overdue": "Atrasado",
            "scheduled": "Agendado",
            "skipped": "Ignorado"
          },
          "title": "Checkpoints"
        },
        "error": "Não foi possível carregar os dados de care.",
        "header": {
          "title": "Care",
          "stage": "Fase: {{stage}}"
        },
        "pillars": {
          "concerns": "Preocupações:",
          "empty": "Nenhum pilar de bem-estar ainda.",
          "title": "Pilares de bem-estar"
        },
        "interventions": {
          "empty": "Nenhuma intervenção agendada ainda.",
          "loadError": "Não foi possível carregar as intervenções.",
          "past": "Passado",
          "retry": "Tente novamente",
          "subtitle": "Agende acompanhamentos de cuidados recorrentes ou únicos para este talento.",
          "title": "Intervenções Care",
          "upcoming": "Próximos"
        },
        "withheldBody": "Este cidadão não compartilhou o seu registro Care com a sua empresa. A pontuação de bem-estar, os pilares e os checkpoints estão retidos. As intervenções exibidas abaixo são o registro da própria empresa sobre o que ela enviou."
      },
      "consent": {
        "withheld": {
          "srLabel": "Retido — não compartilhado por este cidadão",
          "tooltip": "Este cidadão não compartilhou esta informação com a sua empresa. Está retida, não é zero.",
          "title": "Retido pelo cidadão",
          "body": "Este cidadão não compartilhou esta informação com a sua empresa. Está retida — não é zero nem está faltando.",
          "householdGroup": "Membro da família — nome retido"
        }
      },
      "checkup": {
        "withheldBody": "Este cidadão não compartilhou o seu CheckUp com a sua empresa. As pontuações, a análise MESH e a análise do pitch estão retidas — não estão faltando nem são zero.",
        "completedOn": "CheckUp concluído em {{date}}",
        "awaitingConsentBody": "{{name}} concluiu o CheckUp e não compartilhou o resultado com a sua empresa. A decisão de compartilhar cabe ao talento. Até lá, as pontuações, a análise MESH e a análise do pitch estão retidas — não estão faltando nem são zero.",
        "withdrawnBody": "{{name}} deixou de compartilhar o resultado do CheckUp com a sua empresa. As pontuações, a análise MESH e a análise do pitch estão retidas — não estão faltando nem são zero."
      }
    },
    "askTonnieServices": {
      "budgetLabel": "Faixa de orçamento (opcional)",
      "budgetPlaceholder": "Se você tiver uma faixa de orçamento em mente, por favor compartilhe...",
      "description": "Solicite Tonnie para gerenciar todo o processo de forma turnkey (Pacote Tonnie). Os Serviços Tonnie elaborarão uma proposta para sua aprovação.",
      "descriptionLabel": "Descrição das necessidades",
      "descriptionPlaceholder": "Descreva suas necessidades e requisitos específicos...",
      "scopes": {
        "adaptationDesc": "QultureUp e adaptação cultural",
        "adaptationLabel": "Adaptação",
        "careDesc": "Suporte pós-chegada e Care",
        "careLabel": "Care & estabilidade",
        "hireDesc": "Aquisição e sourcing de talentos",
        "hireLabel": "Contratar",
        "mobilityDesc": "Visto, viagem e realocação",
        "mobilityLabel": "Mobilidade",
        "sponsorDesc": "Decisões de triagem e patrocínio",
        "sponsorLabel": "Patrocinador"
      },
      "serviceScopeHint": "Selecione quais partes do processo você gostaria que Tonnie gerenciasse:",
      "serviceScopeLabel": "Escopo do serviço",
      "submitFailed": "Falha ao enviar solicitação",
      "submitRequest": "Enviar solicitação",
      "submitSuccess": "Solicitação enviada — os Serviços Tonnie entrarão em contato em breve",
      "submitting": "Enviando…",
      "timelineLabel": "Expectativas de cronograma",
      "timelinePlaceholder": "Quando você precisa que isso seja concluído? Algum prazo específico?",
      "title": "Pergunte sobre os serviços Tonnie",
      "whatHappensNextBody": "Tonnie Os serviços revisarão sua solicitação e elaborarão uma proposta (taxa diária / honorário / pacote) para sua aprovação. Uma vez aprovada, o modo Tonnie Pack será ativado e o progresso será refletido em seu pipeline.",
      "whatHappensNextTitle": "O que acontece a seguir?"
    },
    "auth": {
      "backToSignIn": "Voltar para fazer login",
      "inviteRoleAdmin": "Admin",
      "inviteRoleMember": "Membro da equipe",
      "joinCompanySubtitle": "Crie sua conta para se juntar como {{role}}",
      "joinCompanyTitle": "Junte-se à {{company}}",
      "noAccess": {
        "acceptInvitation": "Aceitar um convite",
        "contactAdmin": "Entre em contato com seu admin",
        "description": "Você está conectado como {{email}}, mas esta conta ainda não tem acesso ao Tonnie Business.",
        "hint": "Peça a um colega para te convidar, aceite um convite pendente ou saia para usar uma conta diferente.",
        "signingOut": "Desconectando…",
        "switchAccount": "Sair e usar uma conta diferente",
        "title": "Sem acesso ao negócio"
      },
      "signUp": "Inscrever-se"
    },
    "billing": {
      "statusLabel": {
        "active": "Ativo",
        "pending": "Pendente",
        "paid": "Pago",
        "cancelling": "Cancelando",
        "cancelled": "Cancelado",
        "past_due": "Vencido",
        "overdue": "Atrasado",
        "failed": "Falhou",
        "completed": "Completo"
      },
      "active": "Ativo",
      "activeSponsorships": "Patrocínios ativos",
      "checkoutCancelled": "Checkout cancelado",
      "checkoutSuccessPending": "Pagamento recebido — sua conta será atualizada em breve.",
      "checkoutSuccessVerified": "Pagamento confirmado — sua conta foi atualizada.",
      "checkoutVerifyError": "Recebemos seu pagamento, mas não conseguimos confirmá-lo em tempo real. Atualize em um momento.",
      "coPilot": "CoPilot",
      "cohorts": "Cohortes",
      "description": "Seu plano, patrocínios, faturas e forma de pagamento",
      "downgradeDialog": {
        "confirmDowngrade": "Confirmar rebaixamento",
        "description": "Veja o que muda antes de mudar para um plano inferior",
        "discountedRate": "Taxa com desconto",
        "keepEnterprise": "Manter Enterprise",
        "loseAccess": "Você perderá acesso a:",
        "periodEndNote": "O Enterprise continua ativo até o fim do período já pago; depois, a empresa passa para o plano Gratuito.",
        "sponsorshipNote": "Nota: Patrocínios ativos continuarão na sua taxa atual até expirarem. Novos patrocínios serão cobrados na taxa do plano Gratuito.",
        "title": "Caixa de diálogo de rebaixamento",
        "unlimitedProgramsCohorts": "Cohortes de programas ilimitados",
        "unlimitedTeam": "Equipe ilimitada"
      },
      "downgradeFailed": "Não foi possível cancelar a assinatura.",
      "downgradeSuccess": "Rebaixado para o plano Gratuito. Alguns recursos agora estão limitados.",
      "downgradeScheduled": "O Enterprise termina em {{date}}. Até lá, nada muda.",
      "enterprisePlanMissing": "Plano Enterprise não configurado. Contate o suporte.",
      "familyAccessDesc": "O acesso familiar inclui membros do núcleo familiar na mesma jornada.",
      "familyAddonToggled": "Complemento familiar {{action}} para {{name}}",
      "familyToggleFailed": "Não foi possível alternar o acesso familiar.",
      "invoices": {
        "description": "Todas as faturas da sua empresa, prontas para baixar",
        "empty": "Nenhuma fatura ainda",
        "emptyHint": "As faturas aparecerão após seu primeiro pagamento.",
        "title": "Faturas",
        "view": "Ver",
        "viewAllInStripe": "Ver todas no Stripe",
        "paymentReference": "Ref. de pagamento {{reference}}",
        "refunded": "Reembolsado {{amount}}",
        "documentUnavailable": "Não foi possível abrir este documento agora. Tente novamente."
      },
      "limitedFeaturesDesc": "O que seu plano atual não inclui",
      "managePlan": "Gerenciar plano",
      "monthlySpend": "Gasto mensal",
      "nextInvoice": "Próxima fatura",
      "payment": {
        "addressLabel": "Endereço de cobrança",
        "billingSummary": "Resumo da cobrança",
        "currency": "Moeda",
        "dueOn": "Vencimento {{date}}",
        "enterpriseSubscription": "Assinatura Enterprise",
        "nextInvoiceEstimate": "Estimativa da próxima fatura",
        "noAddress": "Nenhum endereço registrado",
        "openStripePortal": "Abrir portal Stripe",
        "paymentsSecuredBy": "Pagamentos garantidos por",
        "portalSummary": "Abra o portal de cobrança para gerenciar sua assinatura, métodos de pagamento e faturas.",
        "securePaymentVia": "Pagamento seguro via"
      },
      "planLabel": "Plano {{plan}}",
      "planUpdated": "Seu plano foi atualizado. Nenhum novo pagamento necessário.",
      "plans": {
        "anonymizedReporting": "Relatório anonimizado",
        "breakEvenPoint": "Ponto de equilíbrio",
        "checkupTeleportalQultureupCare": "CheckUp, TelePortal, QultureUp e Care",
        "complianceAuditTools": "Ferramentas de auditoria de conformidade",
        "contactSales": "Contato de vendas",
        "currentPlan": "Plano atual",
        "custom": "Personalizado",
        "customIntegrations": "Integrações personalizadas",
        "customJourneyTemplates": "Modelos de jornada personalizados",
        "dedicatedSupport": "Suporte dedicado",
        "downgradeToFree": "Rebaixar para gratuito",
        "eachSponsorshipIncludes": "Cada patrocínio inclui",
        "enterprise": "Empresarial",
        "enterpriseRate": "Taxa empresarial",
        "familyAccessOptional": "Acesso familiar opcional",
        "free": "Gratuito",
        "freePlanRate": "Taxa do plano gratuito",
        "fullJourneyCitizenAccess": "Acesso completo à jornada Citizen",
        "fullMobilityAdaptation": "Adaptação completa de mobilidade",
        "fullMobilityAdaptationTitle": "Mobilidade e adaptação completa",
        "getStarted": "Começar",
        "government": "Governo",
        "governmentContactDesc": "Entre em contato com nossa equipe de vendas para configurar um contrato personalizado para programas públicos.",
        "intelligenceDesc": "Desbloqueie suporte completo de Mobilidade e Adaptação com análises avançadas e acesso à API.",
        "inviteWholeTeamDesc": "Convide toda a sua equipe com assentos, programas e coortes ilimitados.",
        "mobilityAdaptationLocked": "Adaptação de mobilidade bloqueada",
        "multiYearContracts": "Contratos de vários anos",
        "percentOff": "{{percent}}% de desconto",
        "passportAchievements": "Passport conquistas",
        "perTalentJourney": "Por jornada de talento",
        "perTalentPerMonth": "Por talento por mês",
        "publicPrograms": "Programas públicos",
        "quickRoi": "Retorno rápido",
        "recommended": "Recomendado",
        "savePercent": "Economize {{percent}}%",
        "savePerYear": "Economize em patrocínios",
        "scaleYourMobility": "Escale sua mobilidade",
        "sponsorship": "Patrocínio",
        "sponsorshipRate": "Taxa de patrocínio",
        "sponsorshipsDropDesc": "As taxas de patrocínio caem para o nível Empresarial, então cada jornada de talento custa menos.",
        "tailoredToYourNeeds": "Personalizado para suas necessidades",
        "unlimitedTeamScale": "Escala de equipe ilimitada",
        "whyUpgrade": "Por que atualizar",
        "totalSuffix": "total",
        "sponsorshipMonthlyCaption_one": "{{rate}}/mês · acesso de {{count}} mês",
        "sponsorshipMonthlyCaption_other": "{{rate}}/mês · acesso de {{count}} meses",
        "sponsorshipRateError": "Não foi possível carregar a taxa de patrocínio. Por favor, atualize."
      },
      "portalUnavailable": "O Portal do Cliente Stripe ainda não está disponível. Complete um checkout primeiro.",
      "programs": "Programas",
      "redirectingToStripe": "Redirecionando para o checkout do Stripe...",
      "renewsOn": "Renova em {{date}}",
      "enterpriseEndsOn": "O Enterprise termina em {{date}}",
      "sponsorships": {
        "access": "Acesso",
        "activeSponsorships": "Patrocínios ativos",
        "addFamilyAccess": "Adicionar acesso familiar",
        "description": "As jornadas que sua empresa patrocina, com datas e custo",
        "empty": "Nenhum patrocínio ainda",
        "enterpriseDiscount": "Desconto empresarial",
        "family": "Família",
        "removeFamilyAccess": "Remover acesso familiar",
        "title": "Patrocínios",
        "totalSponsored": "Total patrocinado",
        "rowActionsAria": "Ações para {{name}}",
        "viewDetails": "Ver detalhes",
        "yourRate": "Sua taxa",
        "accessMonths_one": "{{count}} mês",
        "accessMonths_other": "{{count}} meses",
        "monthsLeft_one": "{{count}} mês restante",
        "monthsLeft_other": "{{count}} meses restantes",
        "journeyProgress": "Progresso da jornada"
      },
      "subscriptionError": "Não foi possível carregar a assinatura. Por favor, atualize.",
      "tabs": {
        "invoices": "Faturas",
        "payment": "Pagamento",
        "plans": "Planos",
        "sponsorships": "Patrocínios",
        "fiscal": "Faturamento certificado"
      },
      "title": "Cobrança",
      "totalSponsored": "Total patrocinado",
      "unlimitedAccessDesc": "Tudo o que seu plano inclui, sem limites",
      "upgradeDialog": {
        "continueToPayment": "Continuar para pagamento",
        "description": "Desbloqueie assentos ilimitados, candidatos, programas e suporte total à mobilidade.",
        "monthlyLabel": "Mensal",
        "saveYearly": "Economize {{amount}} por ano",
        "whatYouGet": "O que você recebe",
        "yearlyLabel": "Anual"
      },
      "upgradeFailed": "Não foi possível iniciar o checkout. Por favor, tente novamente.",
      "upgradeToEnterprise": "Atualizar para Enterprise",
      "vetting": "Verificação",
      "stage": {
        "preMobility": "Pré-Mobilidade",
        "mobility": "Mobilidade",
        "adaptation": "Adaptação",
        "care": "Care",
        "stable": "Estável"
      },
      "planUnavailable": "Este plano não pode ser contratado no momento. Entre em contato com o suporte, por favor.",
      "details": {
        "title": "Dados de cobrança",
        "description": "Para quem as faturas da empresa são emitidas. Uma alteração vale a partir do próximo pagamento.",
        "edit": "Editar",
        "legalName": "Razão social",
        "taxId": "Número fiscal / IVA",
        "country": "País de cobrança",
        "countryPlaceholder": "Escolha um país",
        "addressLine1": "Endereço",
        "addressLine2": "Complemento",
        "postalCode": "CEP",
        "city": "Cidade",
        "save": "Salvar",
        "saveAndContinue": "Salvar e continuar para o pagamento",
        "saveFailed": "Não foi possível salvar os dados de cobrança. Tente de novo.",
        "beforePaymentTitle": "Dados para a fatura",
        "beforePaymentDescription": "Cada pagamento tem uma fatura-recibo emitida para sua empresa. Complete os dados e seguimos para o pagamento."
      },
      "fiscal": {
        "title": "Faturamento certificado — conciliação",
        "description": "Cada pagamento da plataforma e sua fatura-recibo, em todas as empresas e cidadãos. Só a equipe Tonnie vê isto.",
        "enabled": "Emissão ligada",
        "disabled": "Emissão desligada",
        "providerJasmin": "Jasmin",
        "providerSimulated": "Simulado — nada real é emitido",
        "issueFrom": "Emissão desde {{date}}",
        "configMissing": "Configuração ausente ou inválida",
        "count": {
          "issued": "Emitidas",
          "pending": "Pendentes",
          "failed": "Com falha",
          "creditNotesPending": "Notas de crédito a emitir",
          "retroactive": "Pagamentos anteriores a faturar"
        },
        "attentionTitle": "Precisa de alguém",
        "attentionEmpty": "Nada precisa de atenção.",
        "reason": {
          "failed": "Não foi possível emitir a fatura-recibo",
          "pending": "Aguardando há mais de uma hora",
          "creditNotePending": "Reembolsado — emita a nota de crédito no Jasmin"
        },
        "refunded": "{{amount}} reembolsados",
        "retry": "Tentar de novo",
        "creditNoteIssued": "Nota de crédito emitida",
        "done": "Feito.",
        "actionFailed": "Não deu certo. Tente de novo.",
        "loadFailed": "Não foi possível carregar a conciliação.",
        "alert": {
          "nextYearSeriesMissing": "A série de {{year}} ainda não está configurada — crie-a e comunique-a no Jasmin antes de 31 de dezembro.",
          "euConsumerThreshold": "Vendas a consumidores de outros países da UE em {{year}}: {{amount}} do limite de {{threshold}} — decida o OSS com a contadora.",
          "failedDocuments_one": "{{count}} fatura-recibo falhou — veja abaixo.",
          "failedDocuments_other": "{{count}} faturas-recibo falharam — veja abaixo."
        }
      }
    },
    "businessMessages": {
      "analytics": {
        "attemptedCount_one": "{{count}} tentativa",
        "attemptedCount_other": "{{count}} tentativas",
        "byEngagement": "Por engajamento",
        "channelPerformance": "Desempenho do canal",
        "channelPerformanceDesc": "Como cada canal entrega e é aberto",
        "deliveryRate": "Taxa de entrega",
        "messagesByCategory": "Mensagens por categoria",
        "messagesByCategoryDesc": "Mensagens enviadas em cada categoria",
        "noChannelDataYet": "Nenhuma mensagem foi enviada ainda — as taxas aparecem aqui assim que a primeira sair.",
        "noTemplatesYet": "Crie seu primeiro template para ver o engajamento aqui.",
        "openRate": "Taxa de abertura",
        "templatesCount_one": "{{count}} modelo",
        "templatesCount_other": "{{count}} modelos",
        "topTemplates": "Templates principais"
      },
      "cohortAllSuppressed": "Ninguém recebeu esta mensagem — todos nesta coorte desativaram estes e-mails.",
      "cohortSentWithSuppressed": "Enviada para {{queued}}. {{suppressed}} não receberam — desativaram estes e-mails.",
      "suppressedByPreferenceGeneric": "O destinatário desativou esses e-mails — nada foi enviado",
      "suppressedByPreference": "{{name}} desativou esses e-mails — nada foi enviado",
      "channels": {
        "channelIntegrations": "Integrações de canal",
        "channelIntegrationsDesc": "Os canais pelos quais suas mensagens podem sair",
        "comingSoon": "Em breve",
        "configure": "Configurar",
        "connected": "Conectado",
        "delivered": "Entregues",
        "email": "Email",
        "getHelp": "Obter ajuda",
        "openRate": "Taxa de abertura",
        "opened": "Aberto",
        "push": "Push",
        "setupRequired": "Configuração necessária",
        "sms": "SMS",
        "test": "Teste",
        "viewDocumentation": "Ver documentação",
        "whatsapp": "WhatsApp",
        "names": {
          "email": "Email",
          "whatsapp": "WhatsApp",
          "sms": "SMS",
          "push": "Citizen push"
        },
        "descriptions": {
          "email": "Envie e-mails HTML ricos com anexos e rastreamento",
          "whatsapp": "Envie mensagens WhatsApp via Business API",
          "sms": "Envie mensagens SMS para notificações urgentes",
          "push": "Notificações push para o aplicativo móvel Citizen"
        },
        "attempts": "Tentativas"
      },
      "composer": {
        "bold": "Negrito (**texto**)",
        "boldHtml": "Negrito (<strong>texto</strong>)",
        "boldShort": "Negrito",
        "channelsLabel": "Canais de entrega",
        "formattingToolbar": "Formatação de texto",
        "italic": "Itálico (*texto*)",
        "italicHtml": "Itálico (<em>texto</em>)",
        "italicShort": "Itálico",
        "link": "Link ([texto](url))",
        "linkHtml": "Link (<a href=\"…\">texto</a>)",
        "linkShort": "Vincular",
        "message": "Mensagem",
        "messageBodyHtml": "Corpo da mensagem (HTML)",
        "messagePlaceholder": "Escreva sua mensagem aqui…",
        "noSubject": "(sem assunto)",
        "noTemplate": "Mensagem em branco — escreva a sua própria",
        "previewDesktop": "Desktop",
        "previewEmpty": "Comece a escrever para ver a prévia.",
        "previewLabel": "Prévia ao vivo",
        "previewMobile": "Móvel",
        "previewPlain": "Texto simples",
        "recipientsCount_one": "{{count}} destinatário",
        "recipientsCount_other": "{{count}} destinatários",
        "rendering": "Renderizando…",
        "startFromTemplate": "Começar a partir de um modelo (opcional)",
        "subject": "Assunto",
        "subjectPlaceholder": "Um lembrete amigável — seu CheckUp está esperando",
        "tagsLabel": "Inserir uma tag",
        "tagsUsed": "Usado nesta mensagem",
        "templatePlaceholder": "Escolha um modelo ou deixe em branco",
        "viaEmail": "Email"
      },
      "description": "Modelos, envios e entregas de cada mensagem da sua empresa",
      "editor": {
        "bodyRequired": "Corpo é obrigatório",
        "bodyTooLong": "Corpo é muito longo",
        "cancel": "Cancelar",
        "category": "Categoria",
        "channelRequired": "Selecione pelo menos um canal",
        "createNewTemplate": "Criar novo modelo",
        "editTemplate": "Editar modelo",
        "editorDescription": "Configure seu modelo de mensagem com canais, conteúdo e tags de personalização.",
        "hintPlain": "Use a barra de ferramentas (ou **negrito**, *itálico*, [link](url)) para formatação. Use {{variable}} como marcadores para inserir valores dinâmicos.",
        "nameRequired": "Nome é obrigatório",
        "nameTooLong": "Nome é muito longo",
        "saveChanges": "Salvar alterações",
        "saving": "Salvando…",
        "sendTest": "Enviar teste",
        "templateName": "Nome do modelo",
        "templateNamePlaceholder": "Digite o nome do modelo...",
        "testSendSaveFirst": "Salve suas alterações antes de enviar um teste",
        "testSending": "Enviando teste…",
        "unsaved": "Alterações não salvas",
        "unsavedConfirm": "Você tem alterações não salvas. Descartá-las e continuar?"
      },
      "newTemplate": "Novo modelo",
      "stats": {
        "activeTemplates": "Modelos ativos",
        "avgOpenRate": "Taxa média de abertura",
        "delivered": "Entregues",
        "sendAttempts": "Tentativas de envio"
      },
      "tabs": {
        "analytics": "Análises",
        "channels": "Canais",
        "messageTemplates": "Modelos de mensagem"
      },
      "templates": {
        "activated": "Modelo ativado",
        "allCategories": "Todas as categorias",
        "allChannels": "Todos os canais",
        "createFailed": "Não foi possível criar o modelo",
        "createFirstTemplate": "Criar primeiro modelo",
        "createTemplate": "Criar modelo",
        "created": "Modelo criado",
        "deactivated": "Modelo desativado",
        "delete": "Excluir",
        "deleteFailed": "Não foi possível excluir o modelo",
        "deleteTitle": "Excluir modelo?",
        "deleteWarning": "Isso remove permanentemente \"{{name}}\". Esta ação não pode ser desfeita.",
        "deleted": "Modelo excluído",
        "deleting": "Excluindo…",
        "duplicate": "Duplicar",
        "duplicateFailed": "Não foi possível duplicar o modelo",
        "duplicated": "Modelo duplicado",
        "edit": "Editar",
        "filterCategory": "Categoria",
        "filterChannel": "Canal",
        "inactive": "Inativo",
        "loadError": "Não foi possível carregar os modelos.",
        "noTemplatesFound": "Nenhum modelo encontrado",
        "restoreDefault": "Restaurar padrão",
        "restoreFailed": "Falha ao restaurar o modelo padrão",
        "restored": "Modelo padrão restaurado",
        "saveFailed": "Não foi possível salvar o modelo",
        "saved": "Modelo salvo",
        "searchPlaceholder": "Digite a pesquisa...",
        "sendTest": "Enviar teste",
        "testSendFailed": "Falha ao enviar a mensagem de teste",
        "testSent": "Mensagem de teste enviada",
        "toggleFailed": "Não foi possível atualizar o status do template",
        "tryAdjustingSearch": "Tente ajustar a pesquisa",
        "talentTagWithoutSubject": "Esta mensagem vai para a sua equipe sem se referir a nenhum talento, então {{tags}} não tem ninguém a quem se referir. Use {{readerTag}} para se dirigir ao leitor.",
        "activeToggle": "Ativo: {{name}}",
        "moreActions": "Mais ações para {{name}}",
        "alwaysOn": "Sempre ativo: a própria plataforma envia os e-mails de conta e segurança.",
        "sourceDuplicate": "Duplicado",
        "sourceCustom": "Personalizado",
        "sourceCustomized": "Alterado",
        "sourceSystem": "Padrão do sistema",
        "deliveredCount_one": "{{count}} entregue",
        "deliveredCount_other": "{{count}} entregues",
        "opened_one": "{{count}} aberto",
        "opened_other": "{{count}} abertos",
        "sent_one": "{{count}} enviado",
        "sent_other": "{{count}} enviados",
        "searchLabel": "Pesquisar modelos"
      },
      "title": "Mensagens",
      "categories": {
        "names": {
          "vetting": "Verificação",
          "sponsorship": "Patrocínio",
          "mobility": "Mobilidade",
          "adaptation": "Adaptação",
          "care": "Care",
          "evidence": "Evidência",
          "general": "Geral",
          "account": "Conta e segurança",
          "fiscal_document": "Faturas",
          "inout": "Avisos do InOut",
          "inout_agency": "Correio para a assessoria",
          "qultureup": "Avisos QultureUp"
        },
        "descriptions": {
          "vetting": "CheckUp convites, resultados e acompanhamentos",
          "sponsorship": "Convites de jornada e comunicações de patrocínio",
          "mobility": "TelePortal tarefas, documentos e atualizações de status",
          "adaptation": "QultureUp missões e recomendações de aprendizado",
          "care": "Check-ins, intervenções e suporte ao bem-estar",
          "evidence": "Passport atualizações, emblemas e conquistas",
          "general": "Anúncios gerais e mensagens personalizadas",
          "account": "Códigos e avisos de segurança que a plataforma envia. Chegam às pessoas independentemente das configurações de notificação.",
          "fiscal_document": "O aviso que a plataforma envia quando a fatura-recibo de um pagamento é emitida. Chega a todos, quaisquer que sejam as configurações de notificação.",
          "inout": "Avisos sobre o registro de residência de uma pessoa: um limite se aproximando, uma pergunta de presença, uma janela de renovação. A plataforma os envia; cada pessoa escolhe como nas configurações do InOut.",
          "inout_agency": "O que a plataforma envia sobre o ticket de uma pessoa com uma assessoria — à caixa de tickets da assessoria ou à da Tonnie — a pedido dessa pessoa. Chega quaisquer que sejam as configurações de notificação.",
          "qultureup": "Avisos sobre o progresso de uma pessoa em um World do QultureUp com um parceiro (a Languages Academy): uma missão concluída, um nível ou a meta alcançados, um lembrete depois de um tempo parado. A plataforma envia; cada pessoa escolhe como nas configurações de notificações."
        }
      },
      "variables": {
        "talentFirstName": "Primeiro nome do talento",
        "talentLastName": "Último nome do talento",
        "talentFullName": "Nome completo do talento",
        "talentEmail": "Endereço de e-mail do talento",
        "recipientFirstName": "Primeiro nome do destinatário",
        "recipientLastName": "Último nome do destinatário",
        "recipientFullName": "Nome completo do destinatário",
        "recipientEmail": "Endereço de e-mail do destinatário",
        "talentRole": "Cargo do talento",
        "companyName": "Nome da empresa patrocinadora",
        "companyContact": "Pessoa de contato da empresa",
        "programName": "Nome do programa",
        "cohortName": "Nome do grupo",
        "journeyStage": "Estágio atual da jornada",
        "checkupBadge": "iQulture nível de emblema",
        "mobilityArrivalDate": "Data estimada de chegada",
        "mobilityNextTask": "Próxima tarefa de mobilidade",
        "missionName": "QultureUp nome da missão",
        "actionUrl": "URL/link de ação",
        "actionDeadline": "Prazo de ação"
      },
      "cohortRecipientCount_one": "{{count}} membro",
      "cohortRecipientCount_other": "{{count}} membros",
      "cohortSent_one": "Mensagem enviada para {{count}} pessoa.",
      "cohortSent_other": "Mensagem enviada para {{count}} pessoas."
    },
    "businessNotifications": {
      "allCaughtUp": "Tudo atualizado",
      "allNotifications": "Todas as notificações",
      "allTab": "Todas ({{count}})",
      "delete": "Excluir",
      "deleteCount": "Excluir ({{count}})",
      "filter": "Filtrar",
      "markAllRead": "Marcar todos como lidos",
      "markAsRead": "Marcar como lido",
      "new": "Novo",
      "noNotifications": "Sem notificações",
      "noNotificationsDesc": "A nova atividade dos seus talentos aparecerá aqui",
      "noUnreadNotifications": "Sem notificações não lidas",
      "selectAll": "Selecionar todos",
      "settings": "Configurações",
      "summary": {
        "completed": "Completo",
        "unread": "Não lidas",
        "urgent": "Urgente",
        "warnings": "Avisos"
      },
      "title": "Notificações",
      "unreadTab": "Não lido ({{count}})",
      "unreadUrgent": "{{unread}} não lidas, {{urgent}} urgentes",
      "urgentBadge": "Distintivo urgente",
      "viewDetails": "Ver detalhes",
      "viewDetailsButton": "Botão ver detalhes",
      "categories": {
        "all": "Todos",
        "mobility": "Mobilidade",
        "care": "Care",
        "vetting": "Verificação",
        "evidence": "Evidência",
        "cohorts": "Cohortes"
      },
      "unreadCount_one": "{{count}} notificação não lida",
      "unreadCount_other": "{{count}} notificações não lidas",
      "actionsFor": "Ações para “{{title}}”",
      "selectNotification": "Selecionar “{{title}}”"
    },
    "businessOnboarding": {
      "addTalents": {
        "addFromATSOrExcel": "Adicione candidatos do seu ATS ou faça upload de um arquivo Excel/CSV",
        "addTalentsButton": "Adicionar talentos",
        "added": "Adicionado",
        "afterOnboarding": "Após concluir a integração, convide esses talentos para o CheckUp a partir do menu de Aquisição",
        "emptyStateDescription": "Importe candidatos do seu ATS ou faça upload de um arquivo Excel/CSV. Um coorte padrão será criado automaticamente.",
        "importDescription": "Importe seus candidatos para começar. Talentos importados aparecerão no menu de Aquisição, onde você pode convidá-los para CheckUp (vetting). Uma coorte padrão será criada automaticamente quando você adicionar seus primeiros talentos.",
        "importTalents": "Importar talentos",
        "startImport": "Iniciar importação",
        "step1": "Selecione um grupo de talentos para convidar para CheckUp (vetting e avaliação)",
        "step2": "Após a conclusão do CheckUp, você pode patrocinar talentos avaliados e definir sua rota de migração",
        "step3": "Talentos patrocinados começarão a jornada através de: Mobilidade -> Adaptação -> Care -> Evidência",
        "step4": "Organize suas iniciativas de contratação criando programas e coortes a qualquer momento",
        "step5": "Use CoPilot para operações guiadas e suporte durante todo o processo",
        "title": "Adicionar talentos",
        "whatsNext": "Qual é o próximo passo?",
        "whatsNextDescription": "Após importar talentos, eles aparecerão no menu de Aquisição. A partir daí:",
        "readyForCheckUp_one": "{{count}} talento pronto para o CheckUp",
        "readyForCheckUp_other": "{{count}} talentos prontos para o CheckUp",
        "talentsAdded_one": "{{count}} talento adicionado",
        "talentsAdded_other": "{{count}} talentos adicionados"
      },
      "additionalDetails": {
        "billing": {
          "billingAddressHint": "Usado para faturas e notificações de cobrança",
          "billingAddressLabel": "Endereço de cobrança",
          "billingAddressPlaceholder": "Endereço da rua",
          "businessTypeLabel": "Tipo de negócio",
          "city": "Cidade",
          "complement": "Apartamento, suíte, etc. (opcional)",
          "complementPlaceholder": "ex. Suíte 200",
          "country": "País",
          "description": "Obrigatório antes que você possa atualizar para um plano pago.",
          "legalNameLabel": "Nome da entidade legal",
          "postalCodeLabel": "Código postal",
          "state": "Estado / Região",
          "street": "Rua",
          "taxIdLabel": "ID fiscal / VAT",
          "title": "Cobrança & legal"
        },
        "contact": {
          "description": "Telefone direto e ano de fundação da empresa.",
          "foundedLabel": "Ano de fundação",
          "phoneLabel": "Telefone de contato",
          "title": "Informações de contato & empresa"
        },
        "description": "Cada campo é opcional. Expanda as seções que você deseja preencher — o restante permanecerá como lembretes no seu painel.",
        "geographic": {
          "branchesLabel": "Filiais",
          "cityPlaceholder": "Cidade",
          "countryPlaceholder": "País",
          "description": "Filiais, requisitos de idioma e arranjo de trabalho.",
          "languagesLabel": "Requisitos de idioma",
          "title": "Detalhes geográficos",
          "workArrangement": "Arranjo de trabalho",
          "minimumLevel": "Nível mínimo",
          "languageLabel": "Idioma"
        },
        "hiring": {
          "challengesLabel": "Principais desafios (máx. 3)",
          "description": "Objetivos, prazo, maturidade, funções-alvo e desafios.",
          "goalsLabel": "Principais objetivos de contratação",
          "maturityLabel": "Maturidade do programa de mobilidade",
          "rolesLabel": "Tipos de funções-alvo",
          "timeframeLabel": "Prazo de contratação",
          "title": "Detalhes da contratação"
        },
        "title": "Preencha os detalhes restantes"
      },
      "companyProfile": {
        "businessDetails": {
          "description": "Ajude-nos a entender seu modelo de negócios e presença online",
          "title": "Detalhes do negócio"
        },
        "businessType": "Tipo de negócio",
        "businessTypes": {
          "agency": "Agência",
          "enterprise": "Empresarial",
          "scaleup": "Escalação",
          "startup": "Startup",
          "startupDesc": "Início de estágio, alto crescimento",
          "scaleupDesc": "Modelo comprovado, escalando rapidamente",
          "enterpriseDesc": "Grande empresa estabelecida",
          "agencyDesc": "Fornecedor de serviços"
        },
        "companyInfo": {
          "description": "Detalhes básicos sobre sua organização",
          "title": "Informações da empresa"
        },
        "companyName": "Nome da empresa",
        "companySize": "Tamanho da empresa",
        "description": "Conte-nos sobre sua organização. Essas informações nos ajudam a personalizar sua experiência e preparar para requisitos de conformidade.",
        "emailPlaceholder": "john@company.com",
        "emailRequired": "Email *",
        "enterCompanyName": "Digite o nome da empresa",
        "enterPhoneNumber": "Digite seu número de telefone",
        "forContractsAndLegal": "Para contratos e documentos legais",
        "foundedYear": "Ano de fundação",
        "fullNamePlaceholder": "John Doe",
        "fullNameRequired": "Nome completo *",
        "industry": "Indústria",
        "legalEntityName": "Nome da entidade legal",
        "legalEntityPlaceholder": "ex: Company Inc., Company Ltd.",
        "legalInfo": {
          "description": "Para preparação de conformidade e contratos (opcional, mas recomendado para empresas)",
          "title": "Informações legais"
        },
        "linkedinCompanyPage": "Página da empresa no LinkedIn",
        "phone": "Telefone",
        "primaryContact": {
          "description": "O principal ponto de contato para sua organização",
          "title": "Contato principal"
        },
        "registeredCountry": "País registrado",
        "registeredCountryDesc": "Onde sua empresa está legalmente registrada",
        "registeredCountryRequired": "País registrado *",
        "requiredForEnterprise": "Necessário para cobrança empresarial",
        "roleJobTitle": "Função / Cargo",
        "selectCountry": "Selecione o país",
        "selectIndustry": "Selecione a indústria",
        "selectRole": "Selecione a função",
        "selectSize": "Selecione o tamanho",
        "selectYear": "Selecione o ano",
        "taxIdPlaceholder": "ex: DE123456789",
        "taxIdVat": "ID fiscal / Número de IVA",
        "title": "Perfil da empresa",
        "website": "Site",
        "industries": {
          "technology": "Tecnologia",
          "healthcare": "Saúde",
          "finance": "Finanças",
          "manufacturing": "Manufatura",
          "retail": "Varejo",
          "hospitality": "Hospitalidade",
          "construction": "Construção",
          "education": "Educação",
          "consulting": "Consultoria",
          "logistics": "Logística",
          "energy": "Energia",
          "telecommunications": "Telecomunicações",
          "mediaEntertainment": "Mídia e entretenimento",
          "realEstate": "Imóveis",
          "other": "Outro"
        },
        "companySizes": {
          "size1to50": "1-50 funcionários",
          "size51to200": "51-200 funcionários",
          "size201to500": "201-500 funcionários",
          "size501to1000": "501-1000 funcionários",
          "size1000plus": "1000+ funcionários"
        },
        "contactRoles": {
          "ceoFounder": "CEO / Fundador",
          "hrDirector": "Diretor de RH",
          "headOfTalentAcquisition": "Chefe de aquisição de talentos",
          "mobilityManager": "Gerente de mobilidade",
          "hrBusinessPartner": "Parceiro de negócios de RH",
          "peopleOperations": "Operações de pessoas",
          "recruiter": "Recrutador",
          "other": "Outro"
        }
      },
      "complete": "Onboarding completo!",
      "confirmCard": {
        "backToConfirm": "Voltar para a visualização preenchida automaticamente",
        "dataFrom": "Dados de",
        "description": "Nós puxamos isso do site público da sua empresa. Confirme se está correto.",
        "editDetails": "Editar detalhes",
        "loading": "Buscando sua empresa...",
        "loadingDesc": "Isso geralmente leva de 2 a 3 segundos.",
        "manualDesc": "Não conseguimos detectar sua empresa automaticamente. Por favor, preencha os básicos abaixo.",
        "multipleSources": "múltiplas fontes",
        "retry": "Tentar detectar automaticamente novamente",
        "thatsUs": "Esse somos nós",
        "title": "É você?",
        "yourRole": "Seu papel na {{company}}"
      },
      "errors": {
        "cohortCreation": "Falha ao criar o grupo. Por favor, tente novamente.",
        "completion": "Falha ao finalizar a integração. Por favor, tente novamente.",
        "programCreation": "Falha ao criar o programa. Por favor, tente novamente."
      },
      "geographicSetup": {
        "addAnotherCountry": "Adicionar outro país...",
        "addBranchOffice": "Adicionar escritório filial",
        "branchOfficesDesc": "Adicione outros locais que podem receber talentos realocados (opcional)",
        "branchOfficesTitle": "Filiais",
        "canReceiveTalent": "Pode receber talentos",
        "city": "Cidade",
        "cityName": "Nome da cidade",
        "cityPlaceholder": "ex: Lisboa, Berlim, Amsterdã",
        "cityRequired": "Cidade *",
        "country": "País",
        "countryRequired": "País *",
        "description": "Configure os locais da sua empresa e os mercados de contratação-alvo. Isso nos ajuda a pré-configurar rotas de migração e requisitos de conformidade.",
        "headquartersDesc": "Sua localização principal onde os talentos realocados trabalharão principalmente",
        "headquartersTitle": "Localização da sede",
        "languageRequirementsDesc": "Quais idiomas os candidatos devem falar? (Opcional)",
        "languageRequirementsTitle": "Requisitos de idioma",
        "migrationRoutesDesc": "Com base na sua configuração, essas rotas de migração serão pré-configuradas",
        "migrationRoutesPreview": "Pré-visualização das rotas de migração",
        "officeName": "Nome do escritório",
        "officeNamePlaceholder": "ex: Escritório de Berlim",
        "popularSourceMarkets": "Mercados de origem populares",
        "selectCountry": "Selecione o país",
        "selectedMarkets": "Mercados selecionados ({{count}})",
        "targetHiringMarketsDesc": "De onde você planeja contratar? Selecione seus mercados de origem.",
        "targetHiringMarketsTitle": "Mercados de contratação alvo",
        "workArrangementDesc": "Qual arranjo de trabalho você oferece para talentos realocados?",
        "workArrangementTitle": "Arranjo de trabalho",
        "languages": {
          "english": "Inglês",
          "spanish": "Spanish",
          "portuguese": "Português",
          "german": "German",
          "french": "French",
          "dutch": "Dutch",
          "italian": "Italian",
          "polish": "Polish",
          "arabic": "Arabic",
          "chineseMandarin": "Chinês (Mandarim)",
          "japanese": "Japanese",
          "korean": "Korean"
        },
        "languageLevels": {
          "a1": "A1 — Iniciante",
          "a2": "A2 — Elementar",
          "b1": "B1 — Intermediário",
          "b2": "B2 — Intermediário superior",
          "c1": "C1 — Avançado",
          "c2": "C2 — Proficiente"
        },
        "workArrangements": {
          "onsite": "Presencial",
          "onsiteDesc": "Presença total no escritório",
          "hybrid": "Híbrido",
          "hybridDesc": "Mistura de escritório e remoto",
          "flexible": "Flexível",
          "flexibleDesc": "Escolha do funcionário"
        },
        "minimumLevelFor": "Nível mínimo de {{language}}",
        "otherMarketLabel": "Outro mercado de contratação",
        "addMarket": "Adicionar mercado",
        "addLanguage": "Adicionar {{language}}"
      },
      "hiringContext": {
        "annualHiringVolume": "Volume anual de contratação internacional",
        "description": "Ajude-nos a entender suas metas e estratégia de contratação. Isso nos permite personalizar sua experiência e fornecer recomendações relevantes.",
        "hiringGoalsDesc": "O que você deseja alcançar? Selecione todas as opções que se aplicam.",
        "hiringGoalsTitle": "Metas de contratação",
        "mobilityProgramMaturity": "Maturidade do programa de mobilidade",
        "primaryUseCaseDesc": "Qual é o seu principal motivo para usar a Tonnie? Selecione a opção que melhor descreve sua situação.",
        "primaryUseCaseTitle": "Caso de uso principal",
        "scaleTimelineDesc": "Ajude-nos a entender o escopo e a urgência de suas necessidades de contratação.",
        "scaleTimelineTitle": "Escala & cronograma",
        "targetRoleTypesDesc": "Quais tipos de funções você está contratando principalmente? Selecione todas as opções que se aplicam.",
        "targetRoleTypesTitle": "Tipos de funções alvo",
        "topChallengesDesc": "Quais são seus maiores desafios com a contratação internacional? Selecione seus 3 principais.",
        "topChallengesTitle": "Principais desafios",
        "useCases": {
          "costOptimization": "Otimização de custos",
          "costOptimizationDesc": "Acesso a talentos de diferentes mercados",
          "diversity": "Diversidade & inclusão",
          "diversityDesc": "Construindo equipes internacionais diversas",
          "globalExpansion": "Expansão global",
          "globalExpansionDesc": "Expandindo operações para novos mercados com talentos locais",
          "internationalHiring": "Contratação internacional",
          "internationalHiringDesc": "Contratando talentos internacionais para se mudar para seus escritórios",
          "remoteToRelocation": "Remoto para realocação",
          "remoteToRelocationDesc": "Convertendo trabalhadores remotos em funcionários realocados",
          "talentShortage": "Escassez de talentos",
          "talentShortageDesc": "Abordando lacunas de talentos locais com sourcing global"
        },
        "volumes": {
          "enterprise": "Escala empresarial",
          "established": "Programa estabelecido",
          "growing": "Programa em crescimento",
          "starting": "Começando"
        },
        "whenPlanToStart": "Quando você planeja começar?",
        "goals": {
          "reduceTimeToHire": "Reduza o tempo de contratação para candidatos internacionais",
          "improveCandidateExperience": "Melhore a experiência do candidato durante a realocação",
          "increaseRetention": "Aumente a retenção de funcionários realocados",
          "streamlineCompliance": "Simplifique os processos de conformidade e visto",
          "trackMobilityRoi": "Rastreie e meça o ROI da mobilidade",
          "reduceRelocationCosts": "Reduza os custos de realocação",
          "buildTalentPipeline": "Construa um pipeline de talentos sustentável",
          "improveOnboarding": "Melhore a integração e adaptação pós-chegada"
        },
        "challenges": {
          "immigrationVisa": "Complexidade de imigração e visto",
          "findingCandidates": "Encontrar candidatos internacionais qualificados",
          "candidateDropoff": "Desistência de candidatos durante a realocação",
          "postArrival": "Adaptação e retenção pós-chegada",
          "complianceLegal": "Complexidade de conformidade e legal",
          "costManagement": "Gestão de custos",
          "trackingReporting": "Rastreamento e relatórios"
        },
        "timeframes": {
          "immediate": "Imediato",
          "immediateDesc": "Pronto para começar agora",
          "planningDesc": "Fase de planejamento",
          "futureDesc": "Pipeline futuro",
          "strategicDesc": "Planejamento estratégico"
        },
        "maturity": {
          "firstTime": "Primeira vez",
          "firstTimeDesc": "Novo em contratações internacionais",
          "someExperience": "Alguma experiência",
          "someExperienceDesc": "Fez algumas realocações",
          "establishedProgram": "Programa estabelecido",
          "establishedProgramDesc": "Função de mobilidade madura"
        },
        "roleTypes": {
          "engineering": "Engenharia",
          "product": "Produto",
          "design": "Design",
          "dataScience": "Ciência de dados",
          "devops": "DevOps / Infraestrutura",
          "marketing": "Marketing",
          "sales": "Vendas",
          "customerSuccess": "Sucesso do cliente",
          "finance": "Finanças",
          "hrPeople": "RH / Pessoas",
          "operations": "Operações",
          "executive": "Executivo / Liderança",
          "other": "Outro"
        }
      },
      "hiringSignals": {
        "annualVolume": "Volume anual de contratações",
        "annualVolumeDesc": "Quantas contratações internacionais você espera nos próximos 12 meses?",
        "description": "Duas perguntas rápidas para que possamos personalizar seu espaço de trabalho.",
        "primaryUseCase": "Caso de uso principal",
        "title": "O que traz você à Tonnie?"
      },
      "loadingProgress": "Carregando seu progresso...",
      "markets": {
        "description": "Escolha até 3 mercados. Você sempre pode adicionar mais depois.",
        "headquarters": "Sede",
        "targetMarkets": "Mercados de contratação alvo",
        "title": "De onde você está contratando?"
      },
      "progressRestored": "Seu progresso foi restaurado",
      "progressSaved": "Progresso salvo",
      "validation": {
        "requiredFields": "Por favor, complete os campos obrigatórios antes de continuar."
      },
      "review": {
        "editDescription": "Revise seus detalhes e salve quando estiver pronto. Você sempre pode voltar a este assistente a partir da página de Configurações.",
        "editTitle": "Seu perfil organizacional",
        "firstTimeDescription": "Aqui está o que capturamos para você começar. Você sempre pode adicionar mais detalhes depois a partir do seu painel.",
        "firstTimeNotice": "Toque em Completar Configuração para ativar seu espaço de trabalho. Detalhes opcionais ausentes aparecerão como lembretes no seu painel.",
        "firstTimeTitle": "Você está pronto",
        "jumpToAdditional": "Voltar para detalhes adicionais",
        "missingFieldsNotice_one": "Você ainda tem {{count}} detalhe opcional para preencher. Preenchê-lo melhora a correspondência por IA e desbloqueia a cobrança.",
        "missingFieldsNotice_other": "Você ainda tem {{count}} detalhes opcionais para preencher. Preenchê-los melhora a correspondência por IA e desbloqueia a cobrança."
      },
      "roles": {
        "founderExec": "Fundador / Executivo",
        "hrPeople": "RH / Pessoas",
        "mobilityManager": "Gerente de mobilidade",
        "talentAcquisition": "Aquisição de talentos"
      },
      "saveFailed": "Falha ao salvar progresso",
      "steps": {
        "addTalents": {
          "badge": "Chave",
          "description": "Ative sua conta adicionando talentos",
          "title": "Adicionar primeiros talentos"
        },
        "additionalDetails": {
          "description": "Campos opcionais para melhorar a correspondência e desbloquear a cobrança.",
          "title": "Detalhes adicionais"
        },
        "companyProfile": {
          "description": "Conte-nos sobre sua organização",
          "title": "Perfil da empresa"
        },
        "geographicSetup": {
          "description": "Locais e rotas de migração",
          "title": "Configuração geográfica"
        },
        "hiringContext": {
          "description": "Seus objetivos e estratégia de contratação",
          "title": "Contexto de contratação"
        },
        "review": {
          "description": "Confirme o que capturamos e finalize a configuração.",
          "title": "Revisar & completar"
        }
      },
      "updated": "Perfil atualizado",
      "wizard": {
        "completeSetup": "Completar configuração",
        "completing": "Configurando...",
        "progressSaved": "Seu progresso será salvo automaticamente",
        "saveChanges": "Salvar alterações",
        "skipInfo": "Você pode pular e completar depois",
        "subtitle": "Integração da empresa",
        "title": "Tonnie Business"
      }
    },
    "businessSettings": {
      "branding": {
        "a11yBrandConsistency": "Mantenha a consistência da marca enquanto garante acessibilidade",
        "a11yColorBlind": "Teste com simuladores de daltonismo",
        "a11yContrast": "Garanta contraste suficiente entre texto e fundo (WCAG AA: 4.5:1)",
        "accessibilityGuidelines": "Diretrizes de acessibilidade",
        "activateTheme": "Ativar tema",
        "activateThisTheme": "Ativar este tema",
        "active": "Ativo",
        "appIcon": "Ícone do aplicativo",
        "appIconDesc": "O ícone quadrado mostrado nas abas do navegador e nos celulares",
        "assets": "Ativos",
        "colors": "Cores",
        "customDesc": "As cores da sua marca",
        "customMode": "Modo personalizado",
        "dark": "Escuro",
        "darkDesc": "Texto claro sobre fundo escuro",
        "dashboard": "Painel",
        "description": "Seu logotipo, cores e tema em todo o portal",
        "draft": "Rascunho",
        "enterPreviewDesc": "Veja o portal com sua marca antes de salvar",
        "enterPreviewMode": "Entrar no modo de visualização",
        "exitPreview": "Sair da visualização",
        "favicon": "Favicon",
        "faviconDesc": "O pequeno ícone na aba do navegador",
        "fileFormatsHint": "{{formats}} (máx {{maxSize}})",
        "heroImageN": "Imagem hero {{number}}",
        "heroImages": "Imagens hero",
        "heroImagesDesc": "Imagens de destaque mostradas no topo das suas páginas",
        "light": "Claro",
        "lightDesc": "Texto escuro sobre fundo claro",
        "loginPage": "Página de login",
        "preview": "Pré-visualizar",
        "previewModeActive": "Modo de visualização ativo",
        "primaryLogo": "Logo primário",
        "primaryLogoDesc": "Mostrado na barra lateral e nos documentos que você compartilha",
        "replace": "Substituir",
        "saveDraft": "Salvar rascunho",
        "secondaryLogo": "Logo secundário",
        "secondaryLogoDesc": "Uma versão compacta para espaços pequenos",
        "switchToCustomAssets": "Mudar para ativos personalizados",
        "switchToCustomColors": "Mudar para cores personalizadas",
        "switchToCustomPreview": "Mudar para visualização personalizada",
        "themeMode": "Modo de tema",
        "themeModeDesc": "Claro, escuro ou suas cores",
        "title": "Branding",
        "upload": "Carregar",
        "uploading": "Carregando…",
        "colorNames": {
          "primary": "Primária",
          "secondary": "Secundária",
          "accent": "Destaque",
          "success": "Sucesso",
          "warning": "Aviso",
          "error": "Erro",
          "background": "Fundo",
          "foreground": "Texto"
        },
        "colorPickerLabel": "Seletor de cor: {{name}}",
        "colorHexLabel": "Código hexadecimal: {{name}}"
      },
      "care": {
        "description": "Como o Care funciona para seus talentos: pilares, check-ins e objetivos",
        "enterpriseDescription": "As configurações personalizadas do Care fazem parte do plano Enterprise",
        "features": {
          "checkpointSchedule": "Cronograma de checkpoint",
          "checkpointScheduleDesc": "Quando os talentos fazem os check-ins do Care",
          "customPillars": "Pilares personalizados",
          "customPillarsDesc": "Quais pilares de bem-estar seus talentos avaliam",
          "feedbackConfig": "Configuração de feedback",
          "feedbackConfigDesc": "Quem dá feedback sobre objetivos, e com que frequência",
          "talentObjectives": "Objetivos dos talentos",
          "talentObjectivesDesc": "Os objetivos em que seus talentos trabalham",
          "title": "Recursos"
        },
        "saveFailed": "Não foi possível salvar a configuração de Care. Por favor, tente novamente.",
        "saved": "Configuração do Care salva",
        "title": "Care"
      },
      "compliance": {
        "actionLabels": {
          "system_template_dispatched_pre_clerk": "Email do sistema enviado",
          "talent_bulk_imported": "Talentos importados em massa",
          "talent_invitation_created": "Convite criado",
          "talent_invitation_email_failed": "E-mail do convite não enviado",
          "talent_invitation_revoked": "Convite revogado",
          "talent_invitation_sent": "Convite enviado",
          "talent_invited_to_vetting": "Convidado para avaliação",
          "account_email_changed": "E-mail da conta alterado",
          "account_name_changed": "Nome da conta alterado",
          "affiliate_payout_cancelled": "Pagamento de afiliado cancelado",
          "affiliate_payout_invoice_attached": "Nota fiscal anexada ao pagamento de afiliado",
          "affiliate_payout_requested": "Pagamento de afiliado solicitado",
          "affiliate_platform_overview_viewed": "Visão geral da plataforma de afiliados visualizada",
          "communications_relinked_to_account": "Mensagens vinculadas à conta",
          "evidence_blob_read": "Arquivo de evidência aberto",
          "evidence_blob_released": "Arquivo de evidência liberado",
          "evidence_capture_expired": "Registro de decisão expirado",
          "evidence_capture_read": "Registro de decisão aberto",
          "evidence_diff_viewed": "Registro de decisão comparado com hoje",
          "evidence_item_redacted": "Item de evidência ocultado",
          "feature_flags_write": "Funcionalidades ativadas alteradas",
          "invitation_claimed": "Convite resgatado",
          "pool_bulk_imported": "Candidatos importados em massa",
          "pool_candidate_ingested": "Candidato adicionado ao banco",
          "pool_cv_viewed": "Currículo do candidato visualizado",
          "service_credential_created": "Credencial de serviço criada",
          "service_credential_revoked": "Credencial de serviço revogada",
          "talent_invitation_deleted": "Convite excluído",
          "talent_invitation_superseded": "Convite substituído por um novo",
          "account_name_reconciled": "Nome da conta reconciliado",
          "ops_vault_orphan_delete": "Arquivo órfão removido",
          "talent_invitation_declined": "Convite recusado",
          "fiscal_document_retried": "Fatura-recibo reenviada para emissão",
          "fiscal_credit_note_recorded": "Nota de crédito registrada",
          "fiscal_config_written": "Configuração de faturamento alterada",
          "fiscal_retroactive_queued": "Faturas de pagamentos anteriores na fila",
          "inout_cases_listed": "Tickets InOut listados",
          "inout_case_viewed": "Ticket InOut consultado",
          "inout_case_event_recorded": "Evento de ticket InOut registrado",
          "inout_tracking_file_previewed": "Arquivo de acompanhamento InOut pré-visualizado",
          "inout_tracking_file_loaded": "Arquivo de acompanhamento InOut carregado",
          "inout_refund_request_handled": "Pedido de reembolso InOut tratado",
          "inout_reconciliation_viewed": "Reconciliação InOut consultada",
          "inout_portal_saved": "Portal InOut salvo"
        },
        "allActions": "Todas as ações",
        "allUsers": "Todos os usuários",
        "auditLogs": "Registros de auditoria",
        "auditLogsDesc": "Acompanhe quem fez o quê, quando e onde em seu negócio.",
        "date": "Data",
        "description": "Logs de auditoria, retenção de dados e configurações de privacidade da empresa",
        "loadMore": "Carregar mais",
        "loading": "Carregando…",
        "noResults": "Nenhum evento de auditoria corresponde aos seus filtros.",
        "resourceLabels": {
          "journey_invitation": "Convite de jornada",
          "message_template": "Modelo de mensagem",
          "tenant": "Organização",
          "affiliate_payout": "Pagamento de afiliado",
          "affiliate_platform": "Plataforma de afiliados",
          "engagement_evidence_blob": "Arquivo de evidência",
          "engagement_evidence_capture": "Registro de decisão",
          "engagement_evidence_item": "Item de evidência",
          "platform_configs": "Configurações da plataforma",
          "service_credential": "Credencial de serviço",
          "talent": "Talento",
          "user": "Usuário",
          "vault_file": "Arquivo do cofre",
          "billing_invoice": "Pagamento",
          "inout_case": "Ticket InOut",
          "inout_reconciliation": "Reconciliação InOut",
          "inout_tracking_import": "Arquivo de acompanhamento InOut",
          "inout_portal": "Portal InOut"
        },
        "showing": "Mostrando {{shown}} de {{total}}",
        "systemActor": "Sistema",
        "title": "Conformidade",
        "filterByUser": "Filtrar por usuário",
        "filterByAction": "Filtrar por ação"
      },
      "description": "Sua organização, equipe, marca e preferências",
      "enterpriseLock": {
        "badge": "Empresarial",
        "description": "Este recurso está disponível no plano Enterprise.",
        "title": "Bloqueado",
        "upgrade": "Atualizar para Enterprise"
      },
      "organization": {
        "annualVolume": "Volume anual",
        "billingAddress": "Endereço de cobrança",
        "billingCity": "Cidade",
        "billingCountry": "País",
        "billingLegal": "Informações legais",
        "billingLegalDesc": "Usado em faturas, contratos e documentos fiscais.",
        "billingState": "Estado / Região",
        "branchOffices": "Filiais",
        "businessType": "Tipo de negócio",
        "companyName": "Nome da empresa",
        "companyProfile": "Perfil da empresa",
        "companyProfileDesc": "O nome, o setor e os contatos da sua empresa",
        "companySetup": "Configuração da empresa",
        "companySize": "Tamanho da empresa",
        "complement": "Apartamento, suíte, etc.",
        "contactEmail": "Email de contato",
        "contactPhone": "Telefone de contato",
        "contactRole": "Função de contato",
        "description": "O perfil da sua empresa, localizações e contexto de contratação",
        "editInOnboardingWizard": "Editar no assistente de onboarding",
        "foundedYear": "Fundado",
        "geographicSetup": "Configuração geográfica",
        "geographicSetupDesc": "Onde sua empresa está sediada e para onde os talentos se mudam",
        "headquarters": "Sede",
        "hiringContext": "Contexto de contratação",
        "hiringContextDesc": "As funções para as quais você contrata e os desafios que enfrenta",
        "hiringGoals": "Metas de contratação",
        "industry": "Indústria",
        "languageRequirements": "Requisitos de idioma",
        "legalName": "Nome legal",
        "linkedin": "LinkedIn",
        "maturityLevel": "Nível de maturidade",
        "postalCode": "Código postal",
        "primaryContact": "Contato principal",
        "primaryUseCase": "Caso de uso principal",
        "registeredCountry": "País registrado",
        "targetHiringMarkets": "Mercados de contratação alvo",
        "targetRoles": "Funções alvo",
        "taxId": "ID fiscal / VAT",
        "timeframe": "Prazo",
        "title": "Organização",
        "topChallenges": "Principais desafios",
        "website": "Site",
        "workArrangement": "Arranjo de trabalho"
      },
      "preferences": {
        "dateFormat": "Formato de data",
        "description": "Idioma, notificações e como o portal funciona para você",
        "discardChanges": "Descartar",
        "emailNotifications": "Notificações por email",
        "emailNotificationsDesc": "Quais atualizações você recebe por e-mail",
        "language": "Idioma",
        "localization": "Localização",
        "localizationDesc": "Seu idioma, fuso horário e formato de data",
        "moreComingSoon": "Mais preferências estão a caminho — idiomas adicionais, fusos horários e controles de notificação aparecerão aqui à medida que os lançarmos.",
        "pushNotifications": "Notificações push",
        "pushNotificationsDesc": "Quais atualizações aparecem como notificações do navegador",
        "saveFailed": "Não foi possível salvar as preferências. Por favor, tente novamente.",
        "savePreferences": "Salvar preferências",
        "quietHours": "Horário de silêncio",
        "quietHoursDesc": "Pausar notificações push durante este período.",
        "quietHoursEnd": "Até",
        "quietHoursStart": "De",
        "saved": "Preferências atualizadas",
        "timezone": "Fuso horário",
        "title": "Preferências",
        "unsavedChanges": "Você tem alterações não salvas",
        "channelsTitle": "Canais de notificação",
        "channelsDesc": "Como você recebe notificações.",
        "categoriesTitle": "Sobre o que você é notificado",
        "categoriesDesc": "Escolha quais tipos de novidades chegam até você.",
        "category": {
          "hero": "Jornada do talento",
          "heroDesc": "Progresso de CheckUp, Care e mobilidade dos seus talentos.",
          "system": "Conta e sistema",
          "systemDesc": "Segurança, conta e manutenção da plataforma.",
          "social": "Pessoas e pipeline",
          "socialDesc": "Avaliações, equipe e interações com candidatos.",
          "alert": "Alertas e cobrança",
          "alertDesc": "Sensíveis a tempo ou dinheiro: cobrança, pagamentos e prazos."
        }
      },
      "sections": {
        "branding": "Branding",
        "brandingDesc": "Tema, cores e ativos",
        "care": "Care",
        "careDesc": "Configuração e pilares do Care",
        "compliance": "Conformidade",
        "complianceDesc": "Registros de auditoria, retenção de dados e exportações",
        "organization": "Organização",
        "organizationDesc": "Perfil e configuração da empresa",
        "preferences": "Preferências",
        "preferencesDesc": "Notificações, idioma e localidade",
        "profile": "Perfil",
        "profileDesc": "Suas informações pessoais e avatar",
        "security": "Segurança",
        "securityDesc": "Autenticação, senhas e acesso",
        "team": "Equipe",
        "teamDesc": "Membros, funções e permissões",
        "serviceCredentials": "Credenciais de serviço",
        "serviceCredentialsDesc": "Tokens somente de leitura para scripts e ferramentas de relatórios"
      },
      "security": {
        "accountDeleteFailed": "Falha ao excluir conta",
        "accountDeleted": "Conta excluída",
        "confirmDelete": "Excluir para sempre",
        "confirmDeleteOrg": "Excluir organização para sempre",
        "dangerZone": "Zona de perigo",
        "dangerZoneDesc": "Ações irreversíveis. Por favor, tenha certeza.",
        "deleteAccount": "Excluir conta",
        "deleteAccountConfirmPrompt": "Digite DELETE para confirmar:",
        "deleteAccountDesc": "Remover permanentemente sua conta de usuário e todos os dados associados.",
        "deleteAccountTitle": "Excluir conta",
        "deleteAccountWarning": "Esta ação é permanente e não pode ser desfeita. Todos os seus dados serão removidos.",
        "deleteOrg": "Excluir organização",
        "deleteOrgConfirmPrompt": "Digite o nome da organização para confirmar:",
        "deleteOrgFailed": "Falha ao excluir a organização. Por favor, tente novamente ou entre em contato com o suporte.",
        "deleteOrgSuccess": "Organização excluída.",
        "deleteOrgTitle": "Excluir organização",
        "deleteOrgWarning": "Isso excluirá permanentemente a organização, todas as associações de equipe, programas, coortes e dados de talentos.",
        "deleteOrganization": "Excluir esta organização",
        "deleteOrganizationDesc": "Remover a organização, todos os membros da equipe, programas e dados. Isso não pode ser desfeito.",
        "deleting": "Excluindo…",
        "description": "Login, sessões e exclusão da sua organização",
        "title": "Segurança",
        "deleteOrgStripeWarning_one": "Organização excluída. {{count}} assinatura não pôde ser cancelada automaticamente — entre em contato com o suporte se surgirem dúvidas de cobrança.",
        "deleteOrgStripeWarning_other": "Organização excluída. {{count}} assinaturas não puderam ser canceladas automaticamente — entre em contato com o suporte se surgirem dúvidas de cobrança."
      },
      "team": {
        "description": "Gerenciar membros da equipe e convites",
        "enterpriseDescription": "Gerenciamento completo da equipe com acesso baseado em função",
        "features": {
          "activityTracking": "Rastreamento de atividade",
          "activityTrackingDesc": "Veja quando os membros da equipe acessaram pela última vez a plataforma",
          "roleBasedAccess": "Acesso baseado em função",
          "roleBasedAccessDesc": "Atribuir funções para controlar o que cada membro pode ver e fazer",
          "stakeholderIdentification": "Gerenciamento de stakeholders",
          "stakeholderIdentificationDesc": "Identificar proprietários de orçamento e campeões de programa",
          "title": "Recursos",
          "unlimitedMembers": "Membros ilimitados",
          "unlimitedMembersDesc": "Convide toda a sua equipe — sem limites de assentos"
        },
        "invitationResent": "Convite reenviado",
        "invitationRevoked": "Convite revogado",
        "invitations": {
          "description": "Gerenciar convites pendentes para seu espaço de trabalho.",
          "expired": "Expirado",
          "pending": "Pendente",
          "resend": "Reenviar",
          "revoke": "Revogar",
          "sentOn": "Enviado",
          "title": "Convites pendentes"
        },
        "inviteDesc": "Envie um convite por e-mail para se juntar à sua organização.",
        "inviteEmailLabel": "Endereço de e-mail",
        "inviteFailed": "Falha ao enviar convite",
        "inviteRoleLabel": "Função",
        "inviteSent": "Convite enviado",
        "inviteTitle": "Convidar membro da equipe",
        "memberRemoved": "Membro da equipe removido",
        "members": {
          "description": "Membros ativos da equipe com acesso à sua organização",
          "inviteMember": "Convidar membro",
          "title": "Membros"
        },
        "removeConfirm": "Remover {{name}} da equipe?",
        "removeFailed": "Falha ao remover membro da equipe",
        "resendFailed": "Falha ao reenviar convite",
        "revokeFailed": "Falha ao revogar convite",
        "roleAdmin": "Admin",
        "roleTeamMember": "Membro da equipe",
        "roles": {
          "adminDesc": "Acesso total — gerenciar equipe, cobrança, programas e configurações",
          "description": "Funções disponíveis e suas permissões",
          "teamMemberDesc": "Acesso a programas, talentos e painéis de mobilidade",
          "title": "Funções"
        },
        "sendInvite": "Enviar convite",
        "sending": "Enviando…",
        "stats": {
          "pendingInvitations": "Convites pendentes",
          "teamMembers": "Total de membros"
        },
        "title": "Equipe"
      },
      "title": "Configurações",
      "inviteEmailPlaceholder": "colega@empresa.com",
      "serviceCredentials": {
        "title": "Credenciais de serviço",
        "description": "Tokens somente de leitura que permitem a um script ou ferramenta de relatórios puxar dados do cohort sem que alguém faça login.",
        "howToTitle": "Como usar uma credencial",
        "howToBody": "Envie o token no cabeçalho Authorization: Authorization: Bearer <token>. Ele só lê snapshots de cohort e programa, não altera nada e para de funcionar no momento em que você o revoga ou ele expira.",
        "empty": "Nenhuma credencial ainda",
        "emptyHint": "Crie uma quando um script ou ferramenta de relatórios precisar ler dados do cohort por conta própria.",
        "create": "Nova credencial",
        "createTitle": "Nova credencial de serviço",
        "createDescription": "Você verá o token uma única vez. Guarde-o antes de fechar.",
        "nameLabel": "Nome",
        "namePlaceholder": "Relatório trimestral do cohort",
        "nameHint": "Para você distinguir esta credencial das outras depois.",
        "scopeLabel": "Acesso",
        "scopeCohortRead": "Ler dados do cohort",
        "scopeHint": "Somente leitura. Uma credencial nunca altera dados nem gerencia credenciais.",
        "cohortModeLabel": "Cohorts",
        "cohortAll": "Todos os cohorts",
        "cohortPick": "Somente os cohorts que eu escolher",
        "cohortsLabel": "Quais cohorts",
        "cohortsHint": "Escolha pelo menos um.",
        "expiryLabel": "Expira em",
        "expiryHint": "Credenciais sempre expiram. Noventa dias é o máximo.",
        "revealTitle": "Copie seu token agora",
        "revealWarning": "Este token é exibido apenas uma vez. Guarde-o agora — não será possível exibi-lo novamente.",
        "copy": "Copiar",
        "copied": "Copiado",
        "storedConfirm": "Guardei este token em local seguro",
        "done": "Concluído",
        "statusActive": "Ativa",
        "statusExpired": "Expirada",
        "statusRevoked": "Revogada",
        "allCohorts": "Todos os cohorts",
        "neverUsed": "Nunca usada",
        "revoke": "Revogar",
        "revokeTitle": "Revogar esta credencial?",
        "revokeDescription": "Tudo que a utiliza para de funcionar imediatamente. Isso não pode ser desfeito.",
        "revokeReasonLabel": "Motivo (opcional)",
        "revokeConfirm": "Revogar credencial",
        "issued": "Credencial criada",
        "revoked": "Credencial revogada",
        "issueFailed": "Não foi possível criar a credencial",
        "revokeFailed": "Não foi possível revogar a credencial",
        "loadFailed": "Não foi possível carregar as credenciais",
        "expiryDays_one": "{{count}} dia",
        "expiryDays_other": "{{count}} dias",
        "cohortCount_one": "{{count}} cohort",
        "cohortCount_other": "{{count}} cohorts",
        "expiringSoon_one": "Expira em {{count}} dia",
        "expiringSoon_other": "Expira em {{count}} dias"
      }
    },
    "care": {
      "config": {
        "addCustomObjective": "Adicionar objetivo personalizado",
        "addToCatalog": "Adicionar ao catálogo",
        "baselineDescription": "Configure as configurações padrão do Care para sua organização. Essas configurações serão automaticamente herdadas por todos os Programas e Coortes. Programas ou Coortes individuais podem personalizar se necessário.",
        "cadences": {
          "monthly": "Mensal",
          "quarterlyRecommended": "Trimestral (recomendado)",
          "semiannual": "Semestral"
        },
        "careModelSummary": "Resumo do modelo Care",
        "carePillars": "Pilares Care",
        "carePillarsDescription": "Selecione quais dimensões de estabilidade os talentos irão se auto-relatar durante os check-ins. Programas e Coortes podem habilitar/desabilitar esses.",
        "pillarCatalog": {
          "housing_stability": {
            "name": "Estabilidade habitacional",
            "description": "Monitorar transições e estabilidade habitacional após a chegada"
          },
          "schooling_childcare": {
            "name": "Educação e cuidados infantis",
            "description": "Acompanhe a educação e os arranjos de cuidados infantis das crianças"
          },
          "work_fit": {
            "name": "Adequação ao trabalho",
            "description": "Acompanhar a adaptação ao local de trabalho, adequação à equipe e produtividade"
          },
          "wellbeing_social": {
            "name": "Bem-estar e social",
            "description": "Monitore o bem-estar, conexões sociais e engajamento comunitário"
          }
        },
        "carePillarsScheduleDesc": "Pilares Care + cronograma de checkpoint: Talentos completam auto-check-ins em dimensões de bem-estar selecionadas em intervalos de marcos. Programas/Coortes podem habilitar/desabilitar pilares e ajustar o tempo dos checkpoints.",
        "catalogWorkDescription": "Ative objetivos aqui para torná-los disponíveis para Programas e Cohortes. Cada Programa/Cohorte pode então escolher quais objetivos rastrear para seus talentos.",
        "changesApplyNote": "As alterações se aplicarão a todos os Programas e Cohortes que não personalizaram suas configurações",
        "checkpointSchedule": "Cronograma de checkpoint",
        "checkpointScheduleDescription": "Tempo padrão para check-ins do Pilar Care (marcos pós-chegada). Programas e Coortes podem ajustar a recorrência.",
        "common": "Comum",
        "companyCareBaseline": "Linha de base da empresa Care",
        "customObjectiveAdded": "Objetivo personalizado adicionado ao catálogo",
        "detailedFeedbackDescription": "Selecione os papéis que podem ver o texto de feedback detalhado (outros veem apenas resumos)",
        "detailedFeedbackVisibility": "Visibilidade de feedback detalhado",
        "feedbackCadenceDescription": "Com que frequência os agentes da empresa e os talentos trocam feedback sobre os objetivos",
        "feedbackCadenceLabel": "Frequência de feedback",
        "feedbackConfigDescription": "Com que frequência os agentes da empresa fornecem feedback sobre os Objetivos de Talento e quando os talentos se autoavaliam",
        "feedbackConfiguration": "Configuração de feedback",
        "feedbackFlowDescription": "Em cada intervalo de cadência, os provedores selecionados enviam feedback sobre os objetivos de talento. O talento recebe uma notificação e pode visualizar o feedback + enviar sua própria autoavaliação.",
        "feedbackFlowTitle": "Fluxo de feedback:",
        "feedbackProviders": "Provedores de feedback",
        "forObjectives": "Para objetivos",
        "forPillars": "Para pilares",
        "howCatalogWorks": "Como o catálogo funciona:",
        "milestones": {
          "monthNine": "Mês 9",
          "monthOne": "Mês 1",
          "monthSix": "Mês 6",
          "monthThree": "Mês 3",
          "monthTwelve": "Mês 12"
        },
        "objectivePlaceholder": "por exemplo, Completar treinamento de conscientização sobre segurança",
        "objectivesCatalogDescription": "Biblioteca da empresa de objetivos de adaptação. Ative os que são comumente usados — Programas e Cohortes podem então selecionar quais aplicar.",
        "primaryConfig": "Configuração primária",
        "providers": {
          "admin": {
            "description": "Possui o programa de cuidado — revisa sinais sensíveis e fornece feedback estratégico sobre os objetivos."
          },
          "teamMember": {
            "description": "Contato do dia a dia — fornece feedback sobre adaptação, adequação ao trabalho e progresso em relação aos objetivos."
          }
        },
        "recommended": "Recomendado",
        "riskSignalsDescription": "Selecione os papéis que podem ver indicadores de risco sensíveis e alertas de estabilidade",
        "riskSignalsVisibility": "Visibilidade de sinais de risco",
        "saveConfiguration": "Salvar configuração",
        "schedules": {
          "intensive": "Intensivo",
          "intensiveCadence": "Cadência: a cada trimestre + verificação de ajuste do mês-1 (5 checkpoints)",
          "intensiveDescription": "Programas de alto contato que precisam de monitoramento próximo em estágios iniciais e sinal extra trimestral.",
          "light": "Toque leve",
          "lightCadence": "Cadência: semestral (2 checkpoints)",
          "lightDescription": "Cuidado viável mínimo — apenas o sinal do primeiro trimestre e o ponto de decisão anual.",
          "standard": "Padrão",
          "standardCadence": "Cadência: primeiro mês, depois trimestral até o mês 12 (4 checkpoints)",
          "standardDescription": "Checkpoints equilibrados cobrindo ajuste, adaptação e retenção anual."
        },
        "talentCheckIns": "Check-ins de talento",
        "talentObjectivesCatalog": "Catálogo de objetivos de talento",
        "talentObjectivesFeedbackDesc": "Objetivos de talento + feedback: Ative objetivos em seu catálogo. Programas/Cohortes selecionam quais objetivos rastrear. Agentes da empresa fornecem feedback e talentos se autoavaliam.",
        "visibilityDescription": "Controle quem pode ver dados sensíveis do Care com base em seu papel",
        "visibilityPrivacy": "Visibilidade & privacidade",
        "pillarRequired": "Requerido",
        "pillarMakeRequired": "Tornar obrigatório",
        "objectives": {
          "language_level": "Alcance proficiência de trabalho no idioma local",
          "office_visits": "Compareça ao escritório regularmente a cada período",
          "onboarding": "Complete o programa de integração da empresa",
          "team_integration": "Estabeleça relacionamentos de trabalho produtivos com a equipe",
          "role_competency": "Demonstre competência no papel por meio da revisão de marcos",
          "culture_fit": "Entenda e abrace a cultura e os valores da empresa",
          "communication": "Comunicação eficaz com as partes interessadas",
          "tools_systems": "Proficiência com ferramentas e sistemas da empresa",
          "network_building": "Construa uma rede profissional interna",
          "feedback_giving": "Participe ativamente dos ciclos de feedback",
          "goal_setting": "Defina e acompanhe metas de desenvolvimento pessoal",
          "mentorship": "Engaje-se com o mentor/amigo designado"
        },
        "objectiveCategory": {
          "Adaptation": "Adaptação",
          "Onboarding": "Integração",
          "Performance": "Desempenho",
          "Culture": "Cultura",
          "Skills": "Habilidades",
          "Technical": "Técnico",
          "Growth": "Crescimento",
          "Custom": "Personalizado"
        },
        "enabled_one": "{{count}} habilitado",
        "enabled_other": "{{count}} habilitados",
        "pillarsEnabledCount_one": "{{count}} pilar habilitado. Programas e coortes o herdam e podem escolher quais pilares estão ativos em seu contexto.",
        "pillarsEnabledCount_other": "{{count}} pilares habilitados. Programas e coortes os herdam e podem escolher quais pilares estão ativos em seu contexto."
      },
      "customizeModal": {
        "cancel": "Cancelar",
        "carePillars": "Pilares Care",
        "carePillarsDesc": "Dimensões para check-ins de talento",
        "checkpointSchedule": "Cronograma de checkpoint",
        "checkpointScheduleDesc": "Quando os talentos completam check-ins do Care",
        "cohorts": "Cohortes",
        "configSaved": "Configuração do Care personalizada para {{name}}",
        "customized": "Personalizado",
        "feedbackConfig": "Configuração de feedback",
        "feedbackConfigDesc": "Com que frequência o feedback é fornecido sobre os objetivos",
        "feedbackFrequencyInfo": "HRBP e gerentes fornecem feedback sobre os objetivos de talento com essa frequência",
        "feedbackMonthly": "Mensal",
        "feedbackMonthlyDesc": "Uma vez por mês",
        "feedbackQuarterly": "Trimestral",
        "feedbackQuarterlyDesc": "A cada 3 meses",
        "inherited": "Herdado",
        "inheritedInfo": "As configurações são herdadas de {{from}}. Ative seções abaixo para personalizar para este {{level}}.",
        "objectivesAllApply": "Nenhum objetivo selecionado — todos os objetivos da empresa se aplicam. Escolha um subconjunto para restringi-los a este escopo.",
        "objectivesNoneEnabled": "Nenhum objetivo está habilitado na configuração da empresa Care ainda. Habilite alguns nas Configurações da Empresa para escopá-los aqui.",
        "oneMonth": "1 mês",
        "overrideDesc": "Substitua as configurações do Care para {{name}}. {{inheritors}} herdarão isso, a menos que tenham suas próprias personalizações.",
        "pillarHousing": "Habitação",
        "pillarHousingDesc": "Estabilidade da situação de moradia",
        "pillarWellbeing": "Bem-estar",
        "pillarWellbeingDesc": "Saúde e bem-estar mental",
        "pillarWork": "Trabalho",
        "pillarWorkDesc": "Adaptação de emprego e carreira",
        "resetAllToInherited": "Redefinir tudo para herdado",
        "saveChanges": "Salvar alterações",
        "scheduleIntensive": "Intensivo",
        "scheduleIntensiveDesc": "Check-ins frequentes para novos chegados",
        "scheduleLight": "Toque leve",
        "scheduleLightDesc": "Check-ins mínimos para talentos estabelecidos",
        "scheduleStandard": "Padrão",
        "scheduleStandardDesc": "Cronograma de pontos de verificação equilibrado",
        "sixMonths": "6 meses",
        "talentObjectives": "Objetivos dos talentos",
        "talentObjectivesDesc": "Escolha quais objetivos da empresa se aplicam a este escopo",
        "talents": "Talentos",
        "threeMonths": "3 meses",
        "title": "Personalizar modal",
        "twelveMonths": "12 meses",
        "pillarSchooling": "Educação e cuidados infantis",
        "pillarSchoolingDesc": "Acompanhe a educação e os arranjos de cuidados infantis das crianças",
        "nineMonths": "9 meses",
        "feedbackSemiannual": "Semestral",
        "feedbackSemiannualDesc": "Feedback coletado duas vezes por ano",
        "objectivesSelected_one": "{{count}} objetivo selecionado. Os agentes da empresa dão feedback sobre ele",
        "objectivesSelected_other": "{{count}} objetivos selecionados. Agentes da empresa fornecem feedback sobre estes",
        "pillarsActive_one": "{{count}} pilar ativo. Os talentos o avaliam durante os check-ins",
        "pillarsActive_other": "{{count}} pilares ativos. Os talentos avaliarão cada pilar durante os check-ins"
      },
      "effectiveCard": {
        "cadence": "Cadência",
        "careConfiguration": "Configuração do Care",
        "carePillars": "Pilares Care",
        "customized": "Personalizado",
        "customizedFor": "Personalizado para {{level}}",
        "inherited": "Herdado",
        "inheritedFrom": "Herdado de {{source}}",
        "providers": "Fornecedores",
        "talentObjectives": "Objetivos dos talentos",
        "programSource": "Programa: {{name}}"
      },
      "feedback": {
        "commentWithheld": "Comentário ocultado pelas configurações de visibilidade da sua empresa",
        "modal": {
          "description": "Avalie cada objetivo em relação à sua meta, depois revise todo o histórico.",
          "provideTab": "Fornecer",
          "historyTab": "Histórico",
          "submit": "Enviar feedback",
          "giveFeedback": "Dar feedback",
          "cycleDue": "Vencimento {{date}}",
          "awaitingSelfEval": "Aguardando autoavaliação",
          "noOpenCycle": "Nenhum ciclo aberto",
          "historyEmpty": "Nenhum feedback foi registrado ainda.",
          "archivedObjective": "Objetivo arquivado",
          "providerValue": "Empresa",
          "selfValue": "Auto"
        }
      },
      "objective": {
        "measureType": {
          "number": "Contagem",
          "scale": "Nível",
          "percent": "Porcentagem",
          "milestone": "Marco",
          "rating": "Classificação"
        },
        "currentLabel": "Atual",
        "targetLabel": "Alvo",
        "baselineLabel": "Linha de base",
        "recordValueLabel": "Este período",
        "valuePlaceholder": "Selecionar…",
        "milestoneDone": "Concluído",
        "milestoneNotYet": "Ainda não",
        "editTarget": "Editar meta",
        "dashboard": {
          "byObjective": "Por objetivo",
          "onTargetShare": "Na meta",
          "avgProgress": "Progresso médio",
          "empty": "Nenhum objetivo está sendo rastreado ainda. Configure-os na estratégia do Care e eles aparecerão à medida que os talentos forem integrados.",
          "talentsCount_one": "{{count}} talento",
          "talentsCount_other": "{{count}} talentos"
        },
        "targetSaved": "Meta atualizada",
        "targetSaveFailed": "Não foi possível salvar a meta. Por favor, tente novamente.",
        "nothingToSubmit": "Registre um valor ou comentário para pelo menos um objetivo primeiro.",
        "feedbackSubmitted": "Feedback registrado",
        "feedbackSubmitFailed": "Não foi possível registrar o feedback. Por favor, tente novamente.",
        "errors": {
          "unitTooLong": "A unidade deve ter 24 caracteres ou menos",
          "targetRequired": "Defina uma linha de base ou uma meta",
          "ratingRange": "A avaliação deve ser de 1 a 5",
          "commentTooLong": "O comentário deve ter 2000 caracteres ou menos",
          "entryEmpty": "Adicionar um valor, avaliação ou comentário"
        },
        "noOpenCycle": "Ainda não há um ciclo de feedback aberto para este talento, então não há nada para enviar."
      },
      "intervention": {
        "actAria": "Intervir em {{name}}",
        "actLabel": "Intervir",
        "assigneeLabel": "Proprietário",
        "assigneeUnassigned": "Não atribuído",
        "inbox": {
          "title": "Acompanhamentos",
          "empty": "Você está em dia — sem acompanhamentos abertos.",
          "overdue": "Atrasado",
          "open": "Abrir",
          "done": "Concluído",
          "mine": "Meu",
          "all": "Todos",
          "due": "Vencimento {{date}}",
          "search": "Pesquisar por talento…",
          "groupByTalent": "Por talento",
          "flat": "Lista",
          "noMatch": "Nenhuma interação corresponde a esse talento.",
          "expandAll": "Expandir tudo",
          "collapseAll": "Colapsar tudo",
          "overdueCount_one": "{{count}} atrasado",
          "overdueCount_other": "{{count}} atrasados"
        },
        "manageLabel": "Agenda e proprietário",
        "markDoneLabel": "Registrar resultado + minutos",
        "markDoneHint": "Cole e cole as atas da reunião ou notas da gravação aqui (se você as tiver) — apenas interno, mantido para avaliação futura.",
        "markDone": "Marcar como concluído",
        "ataPlaceholder": "Cole os minutos / o que foi discutido aqui (apenas interno)…",
        "commentsLabel": "Comentários",
        "commentsEmpty": "Nenhum comentário ainda.",
        "commentPlaceholder": "Adicionar um comentário…",
        "commentSend": "Enviar",
        "rescheduledToast": "Interação reagendada",
        "reassignedToast": "Interação reatribuída",
        "actionFailed": "Ação falhou. Por favor, tente novamente.",
        "bulkAllFailed": "Nenhuma ação pôde ser criada. Por favor, tente novamente.",
        "bulkPartial": "{{m}} não pôde ser criado",
        "bulkSummary": "{{n}} agendado, {{m}} falhou",
        "cancel": "Cancelar",
        "cancelFailed": "Falha ao cancelar.",
        "cancelledToast": "Intervenção cancelada",
        "descriptionLabel": "Descrição",
        "descriptionPlaceholder": "Adicione qualquer contexto para esta ação…",
        "dialogDescription": "Registre uma ação ou entre em contato — escolha um tipo e nós cuidaremos do resto. Ações voltadas para o talento são sempre sem pontuação.",
        "dialogTitle": "Intervir",
        "effect": {
          "logOnly": "Registro interno apenas — nunca chega ao talento.",
          "talentTouch": "Elegível para um contato caloroso, sem pontuação, com o talento."
        },
        "errors": {
          "descriptionTooLong": "A descrição deve ter 2000 caracteres ou menos",
          "editClosed": "Esta interação está fechada e não pode mais ser editada.",
          "invalidDate": "Insira uma data válida",
          "resolutionTooLong": "A resolução deve ter 2000 caracteres ou menos",
          "titleRequired": "Um título é necessário",
          "titleTooLong": "O título deve ter 200 caracteres ou menos"
        },
        "errorToast": "Não foi possível criar a ação. Por favor, tente novamente.",
        "edit": "Editar",
        "save": "Salvar alterações",
        "saveSuccess": "Interação atualizada",
        "saveFailed": "Não foi possível salvar as alterações. Por favor, tente novamente.",
        "wizard": {
          "stepType": "Tipo",
          "stepDetails": "Detalhes",
          "stepReview": "Revisão",
          "next": "Próximo",
          "back": "Voltar",
          "progressLabel": "Progresso da configuração da interação",
          "reviewBulk_one": "Isso será criado para {{count}} talento.",
          "reviewBulk_other": "Isso será criado para {{count}} talentos."
        },
        "notesLabel": "Notas",
        "notesPlaceholder": "Notas internas (opcional)…",
        "outcome": {
          "completed": "Completo",
          "noShow": "Falta",
          "rescheduled": "Reagendado",
          "declined": "Recusado"
        },
        "outcomeLabel": "Resultado",
        "priority": {
          "high": "Alto",
          "low": "Baixo",
          "medium": "Médio",
          "urgent": "Urgente"
        },
        "priorityLabel": "Prioridade",
        "resolutionLabel": "Nota de resolução",
        "resolutionPlaceholder": "O que aconteceu? (opcional)",
        "resolve": "Resolver",
        "resolveFailed": "Falha ao resolver.",
        "resolvedToast": "Intervenção resolvida",
        "submit": "Criar",
        "submitting": "Salvando…",
        "successToast": "Ação criada",
        "titleLabel": "Título",
        "titlePlaceholder": "por exemplo, check-in de bem-estar 1:1",
        "scheduledAtLabel": "Data e hora",
        "locationOrLinkLabel": "Link / local da reunião",
        "locationOrLinkPlaceholder": "por exemplo, https://meet… ou um endereço",
        "requestCheckinHint": "Adiciona um check-in único à linha do tempo do talento que alimenta seu índice de bem-estar.",
        "type": {
          "call": "Chamada",
          "video_call": "Chamada de vídeo",
          "in_person_meeting": "Reunião presencial",
          "message": "Mensagem",
          "internal_note": "Nota interna",
          "request_checkin": "Solicitar um check-in",
          "buddy_connect": "Conectar com um amigo",
          "checkpoint_trigger": "Acionar um ponto de verificação",
          "coaching_note": "Nota de coaching",
          "manager_alert": "Alertar um gerente",
          "mission_recommend": "Recomendar uma missão",
          "personal_check_in": "Check-in pessoal",
          "reminder": "Definir um lembrete",
          "support_resource": "Compartilhar um recurso de apoio"
        },
        "typeLabel": "Tipo de interação",
        "bulkAppliesTo_one": "Este plano se aplica a {{count}} talento:",
        "bulkAppliesTo_other": "Este plano se aplica a {{count}} talentos:",
        "dialogTitleBulk_one": "Intervir em {{count}} talento",
        "dialogTitleBulk_other": "Intervir em {{count}} talentos",
        "submitBulk_one": "Criar {{count}} ação",
        "submitBulk_other": "Criar {{count}} ações",
        "bulkAppliesToMatching_one": "Este plano alcança o {{count}} talento que corresponde aos seus filtros e precisa de uma intervenção.",
        "bulkAppliesToMatching_other": "Este plano alcança todos os {{count}} talentos que correspondem aos seus filtros e precisam de uma intervenção."
      },
      "effectiveCare": {
        "scheduleLabel": "{{schedule}} programação",
        "providersList": "Provedores: {{providers}}",
        "customize": "Personalizar",
        "detailsTitle": "Detalhes da configuração Care",
        "fullConfigFor": "Configuração completa para {{name}}",
        "inheritedFromSuffix": "(herdado de {{source}})",
        "activeCarePillars": "Pilares ativos Care",
        "checkpointSchedule": "Cronograma de checkpoint",
        "scheduleTitle": "Programação {{schedule}}",
        "talentObjectivesCount": "Objetivos de talento ({{count}})",
        "feedbackConfiguration": "Configuração de feedback",
        "inheritanceInfoCustomized": "Este {{level}} tem configurações personalizadas de Care. Clique em \"Redefinir\" para reverter às configurações de {{source}}.",
        "inheritanceInfoInherited": "Este {{level}} herda todas as configurações de Care de {{source}}. Clique em \"Personalizar\" para substituir configurações específicas apenas para este {{level}}.",
        "activeCount_one": "{{count}} ativo",
        "activeCount_other": "{{count}} ativos",
        "moreObjectives_one": "+{{count}} objetivo",
        "moreObjectives_other": "+{{count}} mais objetivos"
      }
    },
    "carePage": {
      "act": "Intervir",
      "actAria": "Intervir para {{name}}",
      "activeTab": "Ativo",
      "activeTracking": "Rastreamento ativo",
      "archivedTab": "Arquivado",
      "commitmentDistribution": "Distribuição de compromisso",
      "startedSummary": "{{started}} de {{total}} iniciados",
      "awaitingCheckin": "Aguardando o primeiro check-in",
      "pillarsCardSubtitle": "Bem-estar por pilar em toda a coorte",
      "pillarsEmptyHint": "A saúde do pilar aparece assim que os talentos completam seu primeiro check-in do Care.",
      "bandChampion": "Campeão",
      "bandCommitted": "Comprometido",
      "bandEngaged": "Engajado",
      "bandAtRisk": "Em risco",
      "bandFlightRisk": "Risco de saída",
      "bandTracked": "Rastreado",
      "clearSelection": "Limpar seleção",
      "errors": {
        "notesTooLong": "As notas devem ter 2000 caracteres ou menos"
      },
      "feedbackPending": "Feedback pendente",
      "interveneAria": "Intervir para {{name}}",
      "talentRowActionsAria": "Ações para {{name}}",
      "viewAllRisks": "Ver todos os riscos",
      "viewDetails": "Ver detalhes",
      "viewDetailsAria": "Ver detalhes de cuidado para {{name}}",
      "aiCommitmentInsights": "Insights de compromisso AI",
      "allCohorts": "Todas as coortes",
      "allLevels": "Todos os níveis",
      "allPillars": "Todos os pilares",
      "atRiskFilter": "em risco",
      "carePillar": "Pilar Care",
      "carePillarsHealth": "Saúde dos pilares Care",
      "champions": "Campeões",
      "championsDesc": "Seus talentos mais comprometidos, do maior Commitment Index para o menor",
      "championsFilter": "Campeões",
      "commitment": "Compromisso",
      "commitmentChampions": "Campeões do compromisso",
      "commitmentLabel": "Compromisso",
      "commitmentPercent": "{{value}}%",
      "commitmentRiskAlert": "Alerta de risco de compromisso",
      "coldStartDesc": "Assim que um talento convidado completa sua avaliação do Care ou primeiro check-in, seu Índice de Compromisso e saúde do pilar aparecem aqui.",
      "coldStartTitle": "Nenhuma atividade do Care ainda",
      "committedFilter": "Comprometido",
      "description": "Bem-estar, compromisso e intervenções dos seus talentos patrocinados",
      "engagedFilter": "Engajado",
      "filterByCohort": "Filtrar por coorte",
      "filterByPillar": "Pilar",
      "flightRiskCount_one": "{{count}} talentos em risco de saída",
      "flightRiskCount_other": "{{count}} talentos em risco de saída",
      "flightRiskFilter": "Risco de saída",
      "healthy": "Saudável",
      "inCare": "Em Care",
      "insights": "Insights",
      "intervene": "Intervir",
      "interventionQueue": "Fila de intervenção",
      "interventionQueueDesc": "Talentos que precisam de intervenção ou devem feedback, os mais urgentes primeiro",
      "needCare": "Necessita de Care",
      "decliningCommitment": "Declinando",
      "commitmentIndexLabel": "Índice de compromisso",
      "awaitingSelfEvalCount_one": "+{{count}} aguardando autoavaliação",
      "awaitingSelfEvalCount_other": "+{{count}} aguardando autoavaliação",
      "overdueCheckpoints": "Checkpoints atrasados",
      "needIntervention": "Necessita de intervenção",
      "noTalentsFound": "Nenhum talento encontrado",
      "overallTalentLoyalty": "Lealdade geral dos talentos",
      "overdue": "Atrasado",
      "pendingFeedback": "Feedback pendente",
      "pillars": "Pilares",
      "searchTalents": "Buscar talentos",
      "selectAllVisible": "Selecionar todos nesta página",
      "selectTalentAria": "Selecionar {{name}} para intervenção em massa",
      "smartRecommendations": "Recomendações inteligentes",
      "talentsLabel": "Talentos",
      "title": "Care",
      "tracked": "Rastreado",
      "tryAdjustingFilters": "Tente ajustar filtros",
      "frequency": {
        "weekly": "Semanal",
        "biweekly": "Quinzenal",
        "monthly": "Mensal",
        "quarterly": "Trimestral",
        "semiannual": "Semestral"
      },
      "commitmentIndexHeading": "Índice de compromisso",
      "gettingStartedBadge": "Começando",
      "allClearTitle": "Tudo claro",
      "allClearDescription": "Nenhum talento precisa de intervenção imediata",
      "clearFilters": "Limpar filtros",
      "routineStatus": {
        "overdue": "Atrasado",
        "in_progress": "Em progresso",
        "scheduled": "Agendado",
        "completed": "Completo",
        "open": "Abrir",
        "resolved": "Resolvido",
        "cancelled": "Cancelado"
      },
      "commitmentHealth": "Saúde do compromisso",
      "viewPillarTalentsAria": "Ver talentos sob {{pillar}}",
      "weakOnPillar": "Fraco em {{pillar}}",
      "pillarName": {
        "housing_stability": "Habitação",
        "schooling_childcare": "Educação",
        "work_fit": "Trabalho",
        "wellbeing_social": "Bem-estar"
      },
      "pillarStatus": {
        "healthy": "Saudável",
        "moderate": "Moderado",
        "concern": "Preocupação"
      },
      "insightsRecommendations": {
        "socialPillar": "O pilar social está em {{value}}% — considere atividades de integração de equipe",
        "schedule1on1s": "Agendar 1:1s",
        "planActivities": "Planejar atividades",
        "createProgram": "Criar programa",
        "flightRisk_one": "{{count}} talento está em risco de saída — agende um 1:1 imediato com o HRBP",
        "flightRisk_other": "{{count}} talentos estão em risco de saída — agende 1:1s imediatos com o HRBP",
        "championsProgram_one": "{{count}} campeão identificado — considere um programa de embaixadores",
        "championsProgram_other": "{{count}} campeões identificados — considere um programa de embaixadores"
      },
      "trendMetrics": {
        "avgCommitmentIndex": "Média do índice de compromisso",
        "champions": "Campeões",
        "flightRisk": "Risco de saída"
      },
      "scored": "Pontuado",
      "objectivesTitle": "Objetivos & feedback",
      "objectivesEmpty": "Nenhum objetivo foi atribuído a este talento ainda. Configure-os na estratégia do Care.",
      "objectivesLoadError": "Não foi possível carregar os objetivos.",
      "objectivesRetry": "Tentar novamente",
      "objectiveFeedbackCycleStatus": {
        "provider_submitted": "Prestador enviado",
        "completed": "Completo",
        "overdue": "Atrasado"
      },
      "objectiveFeedbackNoCycle": "Nenhum ciclo de feedback está aberto no momento. Os objetivos estão listados abaixo; um formulário aparece quando o próximo ciclo se abre.",
      "objectiveFeedbackProviderLabel": "Prestador",
      "objectiveFeedbackSelfLabel": "Autoavaliação",
      "objectiveFeedbackCommentLabel": "Comentário (opcional)",
      "objectiveFeedbackCommentPlaceholder": "Compartilhe feedback específico e acionável…",
      "objectiveFeedbackSubmitting": "Enviando…",
      "objectiveFeedbackDueTitle": "Feedback devido",
      "objectiveFeedbackDueEmpty": "Nenhum ciclo de feedback aberto no momento. Você está em dia.",
      "objectiveFeedbackDueLoadError": "Não foi possível carregar a lista de feedback devido.",
      "objectiveFeedbackDueRow": "Vencimento {{date}}",
      "objectiveFeedbackDueCurrent": "Visualizando",
      "feedbackStrategyScope": "Configuração de feedback resolvida · {{scope}}",
      "feedbackStrategyLoading": "Carregando…",
      "feedbackStrategyError": "Não foi possível carregar a estratégia de feedback.",
      "feedbackCadenceLabel": "Cadência",
      "feedbackProvidersLabel": "Fornecedores",
      "feedbackProvidersNone": "Nenhum fornecedor configurado",
      "feedbackProvider": {
        "admin": "Admin",
        "team_member": "Membro da equipe"
      },
      "scopeCompanyWide": "Em toda a empresa",
      "scopeCohort": "Coorte selecionada",
      "tabs": {
        "feedback": "Feedback",
        "interactions": "Interações"
      },
      "objectivesProgress": {
        "title": "Progresso dos objetivos",
        "desc": "Participação no alvo e progresso médio por objetivo, entre todos os talentos."
      },
      "objectiveFeedback": {
        "title": "Feedback do objetivo",
        "desc": "Feedback estruturado, baseado em objetivos, na cadência configurada. Avalie cada talento em relação aos seus objetivos; eles completam uma autoavaliação em troca.",
        "dueKpi": "Feedback devido",
        "awaitingSelfEvalKpi": "Aguardando autoavaliação",
        "caughtUp": "Tudo em dia — nenhum feedback devido no momento.",
        "rowStatusOpen": "Precisa da sua avaliação",
        "rowStatusProviderSubmitted": "Aguardando autoavaliação do talento",
        "notProvider": "Você não é um provedor de feedback configurado para este escopo. Peça a um Admin para adicionar seu papel nas configurações do Care.",
        "loadError": "Não foi possível carregar a caixa de entrada de feedback."
      },
      "objectiveFeedbackNotGoverning": "Outra empresa gerencia o Care deste talento, então só ela dá feedback e define metas. Você pode ler as autoavaliações do próprio talento.",
      "commitmentAtAGlance": "Compromisso em resumo",
      "commitmentAtAGlanceDesc": "Onde seus talentos avaliados estão hoje",
      "ofScored": "{{value}} de {{total}} avaliados",
      "bulkInterveneCta_one": "Agendar uma intervenção para {{count}} talento",
      "bulkInterveneCta_other": "Agendar uma intervenção para {{count}} talentos",
      "pendingCount_one": "{{count}} pendente",
      "pendingCount_other": "{{count}} pendentes",
      "selectedCount_one": "{{count}} selecionado",
      "selectedCount_other": "{{count}} selecionados",
      "gettingStartedNote_one": "+ {{count}} começando (ainda sem histórico de check-in suficiente para pontuar)",
      "gettingStartedNote_other": "+ {{count}} começando (ainda sem histórico de check-in suficiente para pontuar)",
      "interveneAllMatching_one": "Intervir no {{count}} correspondente",
      "interveneAllMatching_other": "Intervir em todos os {{count}} correspondentes",
      "interveneAllFlightRisk_one": "Intervir no {{count}} em risco de saída",
      "interveneAllFlightRisk_other": "Intervir em todos os {{count}} em risco de saída"
    },
    "heroOverview": {
      "title": "Visão geral da jornada",
      "subtitle": "Acompanhar progresso",
      "acquisition": {
        "title": "Aquisição",
        "description": "Talentos convidados que ainda não aceitaram.",
        "open": "Abrir aquisição no Pipeline",
        "pendingInvites": "convite pendente",
        "statusLabel": "Status",
        "awaitingAcceptance": "Aguardando aceitação",
        "ttl": "TTL de convite de 14 dias",
        "viewInPipeline": "Ver no pipeline",
        "empty": "Todos os convidados aceitaram. Novos convites aparecerão aqui."
      },
      "vetting": {
        "title": "Verificação",
        "description": "Funil pré-patrocínio — convidados, triagem, concluídos.",
        "open": "Abrir triagem",
        "inVetting": "Em triagem",
        "passRate": "Taxa de aprovação",
        "funnel": "Funil",
        "inProgress": "triagem",
        "completed": "concluídos",
        "done": "feito"
      },
      "sponsored": {
        "title": "Patrocinado",
        "empty": "Nenhum talento patrocinado ainda. Assim que um talento for patrocinado, sua Mobilidade, Adaptação e engajamento no Care aparecerão aqui.",
        "headcount_one": "{{count}} talento",
        "headcount_other": "{{count}} talentos"
      },
      "mobility": {
        "title": "Mobilidade",
        "activeOfTotal_one": "{{count}} de {{total}} ativo",
        "activeOfTotal_other": "{{count}} de {{total}} ativos"
      },
      "adaptation": {
        "title": "Adaptação",
        "activeOfTotal_one": "{{count}} de {{total}} ativo",
        "activeOfTotal_other": "{{count}} de {{total}} ativos"
      },
      "care": {
        "title": "Care",
        "activeOfTotal_one": "{{count}} de {{total}} ativo",
        "activeOfTotal_other": "{{count}} de {{total}} ativos"
      },
      "notStartedYet_one": "{{count}} patrocinado · ainda não iniciado",
      "notStartedYet_other": "{{count}} patrocinados · ainda não iniciados",
      "notStartedMore_one": "+{{count}}",
      "notStartedMore_other": "+{{count}} mais"
    },
    "cohorts": {
      "activeCohorts": "Coortes em andamento",
      "addTalents": "Adicionar talentos",
      "adjustFilters": "Ajustar filtros",
      "alerts": "Alertas",
      "all": "Todos",
      "allPrograms": "Todos os programas",
      "allStatus": "Todos os status",
      "askCoPilot": "Perguntar ao CoPilot",
      "atRisk": "em risco",
      "atRiskLabel": "em risco",
      "avgProgress": "Média de progresso",
      "backToCohorts": "Voltar para coortes",
      "biWeekly": "Quinzenal",
      "blocked": "Bloqueado",
      "care": "Care",
      "careRequiresEnterprise": "Care requer Enterprise",
      "careSettingsReset": "Redefinição das configurações do Care",
      "careSettingsSaved": "Estratégia do Care salva",
      "cohortCreated": "Coorte criada",
      "cohortDeleted": "Coorte excluída",
      "cohortNameLabel": "Nome da coorte",
      "cohortNamePlaceholder": "Digite o nome da coorte...",
      "cohortPaused": "Coorte pausada",
      "cohortResumed": "Coorte retomada",
      "cohortUpdated": "Coorte atualizada",
      "createCohort": "Criar cohorte",
      "createDialogDescription": "Uma coorte é um grupo de talentos que você está movendo juntos na jornada — mesma janela de início, mesmo destino, mesmo programa.",
      "createFirstCohort": "Criar primeira coorte",
      "createNewCohort": "Criar novo cohorte",
      "deleteCohort": "Excluir coorte",
      "deleteConfirmDescription": "Isso excluirá permanentemente a coorte. Esta ação não pode ser desfeita.",
      "deleteConfirmTitle": "Excluir esta coorte?",
      "deleteFailed": "Falha ao excluir a coorte",
      "description": "Agrupe talentos por turma para acompanhá-los em conjunto",
      "editCohort": "Editar coorte",
      "editDialogDescription": "Atualize os detalhes da coorte abaixo.",
      "exportCsv": "Exportar CSV",
      "exportCsvFailed": "Não foi possível exportar esta coorte. Tente novamente.",
      "exportCsvTruncated": "Esta exportação inclui apenas os primeiros 500 talentos — esta coorte tem mais.",
      "exportingCsv": "Exportando…",
      "warningRosterTruncated": "Mostrando {{exported}} de {{total}} talentos — esta coorte é maior do que a lista pode exibir.",
      "warningAcceptedWithoutJourney_one": "{{count}} convite aceito ainda não tem uma jornada registrada.",
      "warningAcceptedWithoutJourney_other": "{{count}} convites aceitos ainda não têm uma jornada registrada.",
      "feedbackCadence": "Frequência de feedback",
      "fillRequiredFields": "Preencha os campos obrigatórios",
      "filterByProgram": "Filtrar por programa",
      "getMoreInsights": "Obter mais insights",
      "insights": "Insights",
      "insightsDescription": "Como esta coorte está progredindo",
      "insightCompletionRate": "{{percent}}% dos talentos ativos desta coorte chegaram à etapa Evidência.",
      "insightSponsoredWithoutCare_one": "{{count}} talento patrocinado não tem pontos de contato Care ativos — verifique a cadência de acompanhamento.",
      "insightSponsoredWithoutCare_other": "{{count}} talentos patrocinados não têm pontos de contato Care ativos — verifique a cadência de acompanhamento.",
      "insightsEmpty": "Ainda não há conclusões para esta coorte.",
      "inviteToVetting": "Convidar para Triagem",
      "iqulture": "iQulture",
      "journeyOverview": "Visão geral da jornada",
      "latestUpdates": "Últimas atualizações",
      "messageCohort": "Mensagem para a coorte",
      "monthly": "Mensal",
      "noCohortsFound": "Nenhuma coorte encontrada",
      "noProgramUnassigned": "Nenhum programa não atribuído",
      "notFound": "Coorte não encontrada",
      "notFoundDesc": "Esta coorte não existe ou foi excluída. Tente voltar à lista de coortes.",
      "onTrack": "No caminho certo",
      "overview": "Visão geral",
      "pauseCohort": "Pausar coorte",
      "programOptional": "Programa opcional",
      "progress": "Progresso",
      "quarterly": "Trimestral",
      "recentActivity": "Atividade recente",
      "requestUpdate": "Solicitar atualização",
      "resumeCohort": "Retomar coorte",
      "searchCohorts": "Pesquisar coortes",
      "searchTalents": "Buscar talentos",
      "selectProgram": "Selecionar programa",
      "sendMessage": "Enviar mensagem",
      "stability": "Estabilidade",
      "startDateLabel": "Data de início",
      "started": "Iniciado",
      "status": "Status",
      "statusChangeFailed": "Falha ao mudar o status da coorte",
      "targetArrival": "Chegada prevista",
      "talents": "Talentos",
      "title": "Cohortes",
      "totalTalents": "Total de talentos",
      "trackProgress": "Acompanhar progresso",
      "unassigned": "Não atribuído",
      "updateFailed": "Falha ao atualizar a coorte",
      "viewDetails": "Ver detalhes",
      "viewProfile": "Ver perfil",
      "whatHappensNext": "O que acontece a seguir",
      "whatHappensNextDescription": "Você será direcionado para a página de detalhes da coorte onde pode convidar talentos diretamente, atribuí-los do Pool e acompanhar seu progresso através do Vetting e dos heróis patrocinados paralelos (Mobilidade, Adaptação, Care).",
      "errors": {
        "nameRequired": "O nome da coorte é obrigatório",
        "nameTooLong": "O nome da coorte deve ter 200 caracteres ou menos",
        "descriptionTooLong": "A descrição deve ter 2000 caracteres ou menos",
        "planLimit": "O plano gratuito permite 1 coorte ativa. Faça upgrade para o Enterprise para coortes ilimitadas."
      },
      "cohortActionsAria": "Ações para {{name}}",
      "emptyTalentsTitle": "Ainda não há talentos nesta coorte",
      "emptyTalentsDescription": "Convide talentos ou importe uma lista para começar a rastreá-los através da Avaliação e Patrocínio.",
      "addTalentsAria": "Adicionar talentos a {{name}}",
      "descriptionLabel": "Descrição",
      "descriptionPlaceholder": "Notas opcionais sobre esta coorte",
      "targetShort": "Alvo",
      "startDateUnset": "Data de início não definida",
      "feedbackCadenceAria": "Cadência de feedback: {{cadence}}",
      "targetArrivalAria": "Chegada alvo: {{date}}",
      "talentRowActionsAria": "Ações para {{name}}",
      "archiveSuccess": "{{name}} movido para arquivado.",
      "archiveFailed": "Falha ao arquivar coorte",
      "restoreSuccess": "{{name}} restaurado.",
      "restoreFailed": "Falha ao restaurar coorte",
      "activeTab": "Ativo",
      "archivedTab": "Arquivado",
      "manageArchivedOnPipeline": "Gerenciar no pipeline",
      "archivedReadOnly": "Os engajamentos arquivados são somente leitura aqui. Restaure-os pelo Pipeline.",
      "archivedEmptyTitle": "Nenhum engajamento arquivado nesta coorte",
      "selectAllAria": "Selecionar todos os talentos",
      "selectAllCount": "Selecionar todos ({{selected}}/{{total}})",
      "viewInPipeline": "Ver talentos no Pipeline",
      "disabledPausedCohort": "Retome a coorte para habilitar esta ação",
      "disabledPausedProgram": "Retome o programa pai para habilitar esta ação",
      "archive": "Arquivar",
      "restore": "Restaurar",
      "archiveConfirmTitle": "Arquivar coorte?",
      "archiveConfirmDescription": "{{name}} se move para a aba Arquivado. Restaure a qualquer momento a partir daí. Talentos existentes não são afetados.",
      "scope": {
        "active": "Ativo",
        "archived": "Arquivado"
      },
      "form": {
        "talentCountPlaceholder": "por exemplo, 20"
      },
      "atRiskCount_one": "{{count}} em risco",
      "atRiskCount_other": "{{count}} em risco",
      "blockedCount_one": "{{count}} bloqueado",
      "blockedCount_other": "{{count}} bloqueados",
      "inviteCountToVetting_one": "Convidar {{count}} para Vetting",
      "inviteCountToVetting_other": "Convidar {{count}} para Vetting",
      "selectedCount_one": "{{count}} selecionado",
      "selectedCount_other": "{{count}} selecionados"
    },
    "common": {
      "add": "Adicionar",
      "back": "Voltar",
      "cancel": "Cancelar",
      "change": "Alterar",
      "clear": "Limpar",
      "close": "Fechar",
      "confidence": "confiança",
      "confirm": "Confirmar",
      "continue": "Continuar",
      "founded": "Fundado",
      "loading": "Carregando...",
      "of": "de",
      "optional": "Opcional",
      "other": "Outro",
      "save": "Salvar",
      "select": "Selecionar",
      "tryAgain": "Tente novamente",
      "view": "Ver",
      "yourCompany": "sua empresa",
      "error": {
        "sectionTitle": "Não foi possível carregar esta seção",
        "sectionDescription": "Algo deu errado ao buscar os dados. Tente novamente — se o problema persistir, entre em contato com o suporte.",
        "retry": "Tentar novamente"
      },
      "relativeTime": {
        "justNow": "agora mesmo",
        "today": "Hoje",
        "yesterday": "Ontem",
        "weekAgo": "1 semana atrás",
        "monthAgo": "1 mês atrás"
      },
      "contactPlaceholder": "contact@tonnie.ai"
    },
    "components": {
      "addTalentsWizard": {
        "assignToCohort": "Atribuir ao cohorte",
        "back": "Voltar",
        "cancel": "Cancelar",
        "chooseCohortTalentsDesc": "Escolha a coorte em que esses talentos entram",
        "bringFromPool": "Trazer do Tonnie Pool",
        "browsePool": "Explorar Pool",
        "chooseImportMethod": "Escolher método de importação",
        "confirmAndImport": "Confirmar & importar",
        "confirmImport": "Confirmar importação",
        "createNewCohort": "Criar novo cohorte",
        "createNewProgram": "Criar novo programa",
        "importing": "Importando...",
        "mapColumns": "Mapear colunas",
        "mapColumnsDesc": "Relacione as colunas da planilha com os campos da Tonnie",
        "needHelpChoosing": "Precisa de ajuda para escolher",
        "needHelpDescriptionNoATS": "Envie arquivos Excel ou CSV, ou traga talentos do seu Tonnie Talent Pool (Enterprise), para adicioná-los ao seu pipeline. A integração com ATS estará disponível em uma versão futura.",
        "next": "Próximo",
        "reviewData": "Revisar dados",
        "reviewDataDesc": "Confira cada linha antes de importar",
        "selectImportDesc": "Importe de uma planilha ou do seu ATS",
        "selectTargetCohort": "Selecionar coorte alvo",
        "uploadExcelCsv": "Fazer upload de Excel csv",
        "uploadFile": "Carregar arquivo",
        "uploadFileDesc": "Um arquivo Excel ou CSV com um talento por linha"
      },
      "addToCohort": {
        "addToCohortBtn": "Adicionar à coorte",
        "afterAdding": "Após adicionar",
        "cancel": "Cancelar",
        "chooseCohort": "Escolher coorte",
        "cohortDetails": "Detalhes do grupo",
        "currentTalents": "Talentos atuais",
        "pleaseSelectCohort": "Por favor, selecione uma coorte",
        "program": "Programa",
        "selectCohort": "Selecionar grupo",
        "title": "Adicionar à coorte",
        "unassigned": "Não atribuído",
        "description_one": "Selecione uma coorte para adicionar o {{count}} talento selecionado",
        "description_other": "Selecione uma coorte para adicionar os {{count}} talentos selecionados",
        "talentsAdded_one": "{{count}} talento adicionado à coorte",
        "talentsAdded_other": "{{count}} talentos adicionados à coorte",
        "talentsSelected_one": "{{count}} talento selecionado",
        "talentsSelected_other": "{{count}} talentos selecionados",
        "talentCount_one": "{{count}} talento",
        "talentCount_other": "{{count}} talentos"
      },
      "confirmDialog": {
        "processing": "Processando"
      },
      "countrySelect": {
        "noResults": "Sem resultados",
        "placeholder": "Marcador de posição",
        "search": "Buscar"
      },
      "pageHeader": {
        "coPilot": "CoPilot",
        "goBack": "Voltar"
      }
    },
    "consent": {
      "objectivesNotShared": "Este talento não compartilha o Care com sua empresa, então os objetivos dele não são exibidos.",
      "withheld": {
        "care_one": "{{count}} talento não compartilha o Care",
        "care_other": "{{count}} talentos não compartilham o Care",
        "checkup_one": "{{count}} talento não compartilha o resultado do CheckUp",
        "checkup_other": "{{count}} talentos não compartilham o resultado do CheckUp",
        "passport_stamps_one": "{{count}} talento não compartilha o Passport",
        "passport_stamps_other": "{{count}} talentos não compartilham o Passport",
        "qultureup_one": "{{count}} talento não compartilha o QultureUp",
        "qultureup_other": "{{count}} talentos não compartilham o QultureUp",
        "teleportal_one": "{{count}} talento não compartilha o TelePortal",
        "teleportal_other": "{{count}} talentos não compartilham o TelePortal"
      }
    },
    "copilot": {
      "open": "Abrir CoPilot"
    },
    "dashboard": {
      "activeJourneys": "Jornadas ativas",
      "addToTalentPool": "Adicionar ao pool de talentos",
      "aiCoPilot": "AI CoPilot",
      "allClear": "Tudo claro",
      "allClearTitle": "Tudo claro",
      "askCoPilot": "Perguntar ao CoPilot",
      "attention": "Precisa de atenção",
      "averageScore": "Pontuação média",
      "coPilotDescription": "Pergunte ao seu assistente de IA sobre insights de mobilidade de talentos, recomendações de programas e análise de dados.",
      "conversionRate": "{{rate}}% de conversão",
      "createCohort": "Criar cohorte",
      "critical": "Crítico",
      "evidence": "Evidência",
      "exploreHeroes": "Explorar heróis",
      "healthy": "Saudável",
      "heroes": {
        "assessReadiness": "Avaliar a prontidão dos talentos e a adequação cultural",
        "checkupAndPool": "CheckUp & Pool",
        "commitment": "Compromisso",
        "culturalAdaptation": "Adaptação cultural & iQulture",
        "legalTravelSetup": "Configuração legal, de viagem e relocação",
        "wellbeingLoyalty": "Monitoramento de bem-estar e lealdade",
        "inTransitCount_one": "{{count}} em trânsito",
        "inTransitCount_other": "{{count}} em trânsito",
        "learningCount_one": "{{count}} aprendendo",
        "learningCount_other": "{{count}} aprendendo",
        "talentsCount_one": "{{count}} talento",
        "talentsCount_other": "{{count}} talentos",
        "thrivingCount_one": "{{count}} prosperando",
        "thrivingCount_other": "{{count}} prosperando"
      },
      "importTalents": "Importar talentos",
      "inCheckUp": "Em CheckUp",
      "iqulture": "iQulture",
      "journeyFlow": "Fluxo da jornada",
      "launchProgram": "Lançar programa",
      "milesAndStamps": "{{miles}} milhas · {{stamps}} selos",
      "navigateToDashboards": "Navegar para painéis especializados",
      "needAttention": "Precisa de atenção",
      "needsAttention": "Precisa de atenção",
      "attentionMyTasks": "Minhas tarefas",
      "attentionAtRisk": "Em risco",
      "noRecentEvents": "Sem eventos recentes",
      "noUrgentItems": "Sem itens urgentes que requerem atenção",
      "onTrack": "No caminho certo",
      "organizeTalents": "Organizar talentos em grupos",
      "pipeline": "Pipeline",
      "portfolioHealth": "Saúde do portfólio",
      "portfolioSummary": "Gerenciando {{programs}} programas e {{cohorts}} coortes",
      "profileCompletion": {
        "addRemainingDetails": "Adicionar detalhes restantes",
        "complexFieldNotice": "Este campo é editável a partir do assistente de integração. Clique em 'Finalizar no assistente de integração' para atualizá-lo.",
        "description": "Adicione mais alguns detalhes para desbloquear um melhor pareamento e cobrança mais rápido.",
        "descriptionAlmostThere": "Você está quase lá — complete mais alguns detalhes para finalizar seu perfil.",
        "dialogDesc": "Isso leva alguns segundos e torna o pareamento de talentos mais preciso.",
        "fields": {
          "annualHiringVolume": "Volume anual de contratações",
          "branches": "Filiais",
          "businessType": "Tipo de negócio",
          "companyName": "Nome da empresa",
          "companySize": "Tamanho da empresa",
          "contactPhone": "Telefone de contato",
          "contactRole": "Função de contato",
          "foundedYear": "Ano de fundação",
          "hiringGoals": "Metas de contratação",
          "hiringTimeframe": "Prazo de contratação",
          "hqCountry": "País da sede",
          "industry": "Indústria",
          "languages": "Requisitos de idioma",
          "legalName": "Nome da entidade legal",
          "mobilityMaturity": "Maturidade de mobilidade",
          "primaryUseCase": "Caso de uso principal",
          "targetMarkets": "Mercados-alvo",
          "targetRoleTypes": "Tipos de funções-alvo",
          "taxId": "ID fiscal / VAT",
          "topChallenges": "Principais desafios",
          "website": "Site",
          "workArrangement": "Arranjo de trabalho"
        },
        "finishInWizard": "Concluir no assistente de integração",
        "seeAll": "Ver todos ({{count}})",
        "title": "Complete seu perfil",
        "descriptionWithCount_one": "{{count}} detalhe ainda para preencher — leva cerca de um minuto.",
        "descriptionWithCount_other": "{{count}} detalhes ainda a capturar — leva cerca de um minuto."
      },
      "quickActions": "Ações rápidas",
      "recentActivity": "Atividade recente",
      "sendCheckUp": "Enviar CheckUp",
      "sponsored": "Patrocinado",
      "stages": {
        "adaptation": "Adaptação",
        "care": "Care",
        "mobility": "Mobilidade",
        "vetting": "Verificação"
      },
      "startNewMobility": "Iniciar novo programa de mobilidade",
      "startVettingProcess": "Iniciar processo de verificação",
      "talentDistribution": "Distribuição de talentos ao longo das etapas da jornada",
      "topPerformers": "Melhores desempenhos",
      "urgent": "Urgente",
      "myCareTasks": {
        "title": "Minhas tarefas críticas",
        "viewAll": "Ver tudo em Care"
      },
      "viewAllEvents": "Ver todos os eventos",
      "viewAllIssues": "Ver todos os problemas",
      "viewAnalytics": "Ver análises",
      "welcomeBackBusiness": "Bem-vindo de volta, {{name}}!",
      "onboarding": {
        "title": "Bem-vindo à Tonnie. Vamos configurar seus primeiros talentos.",
        "body": "Seu painel se preenche assim que você importa talentos e os agrupa em um programa. Dois passos e você está ativo em aquisição, triagem e patrocínio.",
        "importTitle": "Importar talentos",
        "importBody": "Carregue um CSV ou XLSX, ou adicione candidatos um a um. Convites serão enviados assim que você confirmar.",
        "programTitle": "Crie seu primeiro programa",
        "programBody": "Programas agrupam coortes e apresentam métricas de aquisição / triagem / patrocínio em um só lugar.",
        "helperHint": "Dica: você pode fazer qualquer um dos passos primeiro — eles se conectam automaticamente assim que ambos existem.",
        "skipToPipeline": "Ir para pipeline",
        "skipToPool": "Navegar na Pool"
      },
      "todayPanel": {
        "blockedSubtitle": "Abra a gaveta para limpar o bloqueador",
        "atRiskSubtitle": "Um empurrão hoje mantém essa jornada nos trilhos",
        "title": "Prioridades de hoje",
        "blockedItem": "{{name}}: bloqueado",
        "atRiskItem": "{{name}}: em risco",
        "countLabel_one": "{{count}} ação",
        "countLabel_other": "{{count}} ações",
        "goodNewsItem": "{{name}}: boas notícias"
      },
      "weeklySummary": {
        "thisWeek": "Esta semana"
      },
      "blockedFallback": "Processo bloqueado",
      "riskFallback": "Em risco",
      "attentionAdaptationRisk": "Baixo engajamento na adaptação",
      "attentionCareRisk": "Comprometimento em risco",
      "atRiskCount_one": "{{count}} em risco",
      "atRiskCount_other": "{{count}} em risco",
      "blockedCount_one": "{{count}} bloqueado",
      "blockedCount_other": "{{count}} bloqueados",
      "attentionOverdue_one": "{{count}} atrasado",
      "attentionOverdue_other": "{{count}} atrasados",
      "welcomeBackBusinessNoName": "Bem-vindo de volta!",
      "attentionGoodNews": "Boas notícias"
    },
    "evidence": {},
    "evidencePage": {
      "activeTab": "Ativo",
      "activity": "Atividade",
      "archivedTab": "Arquivado",
      "adaptation": "Adaptação",
      "allClear": "Tudo claro",
      "allCohorts": "Todas as coortes",
      "allStages": "Todas as etapas",
      "analysis": "Análise",
      "cohortLabel": "Coorte",
      "irrTrendsEmpty": "Dados do IRR ainda não são suficientes — o gráfico de evolução é desbloqueado após pelo menos dois meses de atividade.",
      "mesh": {
        "motivation": "Motivação",
        "english": "Inglês",
        "softSkills": "Habilidades interpessoais",
        "hardSkills": "Habilidades técnicas"
      },
      "openPassportAria": "Abrir passaporte para {{name}}",
      "sponsoredBadge": "Patrocinado",
      "stageNotShared": "Não compartilhado",
      "talentRowActionsAria": "Ações para {{name}}",
      "totalBadges": "Total de insígnias",
      "totalStamps": "Total de selos",
      "averageIQultureScore": "Pontuação Média iQulture",
      "avgIQulture": "Média iQulture",
      "avgProgress": "Média de progresso",
      "careLabel": "Care",
      "carePillarsHealth": "Saúde dos pilares Care",
      "carePillarsHealthDesc": "Como seus talentos avaliam cada pilar do Care",
      "checkUpProgress": "Progresso do CheckUp",
      "citizenBadges": "Distintivos Citizen",
      "citizenBadgesDesc": "Insígnias que seus talentos conquistaram nas jornadas",
      "common": "Comum",
      "description": "A prova da jornada de cada talento: passaportes, selos e insígnias",
      "epic": "Épico",
      "estimatedContribution": "Contribuição estimada",
      "events": "Eventos",
      "iqultureBadgeDist": "Distância do badge iQulture",
      "irrEvolution": "Evolução do IRR",
      "irrEvolutionDesc": "Como as evidências dos seus talentos evoluíram ao longo do tempo",
      "legendary": "Legendário",
      "levelsDistributionDesc": "Quantos talentos alcançaram cada nível de cidadão",
      "meshScoreBreakdown": "Detalhamento MESH",
      "meshScoreDesc": "Pontuações MESH médias dos seus talentos avaliados",
      "milesAndStamps": "{{miles}} milhas · {{stamps}} selos",
      "milesFromAchievements": "Miles de conquistas",
      "mobility": "Mobilidade",
      "needsAttention": "Precisa de atenção",
      "overallHealthScore": "Pontuação geral de saúde",
      "overview": "Visão geral",
      "passports": "Passaportes",
      "rare": "Raro",
      "uncommon": "Incomum",
      "noEvents": "Nenhum evento ainda",
      "noPassports": "Nenhum passaporte corresponde aos seus filtros.",
      "rarityDistribution": "Distribuição de raridade",
      "recentEvents": "Eventos recentes",
      "searchTalents": "Buscar talentos",
      "sponsoredTalents": "Talentos patrocinados",
      "stageLabel": "Estágio",
      "stampsBadges": "Conquistas",
      "stampsCollection": "Coleção de selos",
      "stampsCollectionDesc": "Selos que seus talentos coletaram em cada marco",
      "talentReadinessLevels": "Níveis de prontidão dos talentos",
      "title": "Evidência",
      "topPerformers": "Melhores desempenhos",
      "totalMiles": "Total de Miles",
      "vettingPool": "Pool de avaliação",
      "talentStatus": {
        "on-track": "No caminho",
        "at-risk": "Em risco",
        "blocked": "Bloqueado",
        "completed": "Completo",
        "unknown": "Status pendente"
      },
      "pillarScoresPending": "As pontuações Care por pilar aparecerão aqui assim que a projeção do backend Care for enviada.",
      "stages": {
        "vetting": "Verificação",
        "mobility": "Mobilidade",
        "adaptation": "Adaptação",
        "care": "Care"
      },
      "blockedCount_one": "{{count}} bloqueado",
      "blockedCount_other": "{{count}} bloqueados",
      "earned_one": "{{count}} conquistado",
      "earned_other": "{{count}} conquistados",
      "passportCount_one": "{{count}} passaporte",
      "passportCount_other": "{{count}} passaportes",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talentos"
    },
    "feedback": {
      "additionalFeedbackHint": "Você pode fornecer feedback detalhado, anexar capturas de tela ou arquivos para nos ajudar a entender melhor sua experiência.",
      "attachFiles": "Anexar arquivos",
      "categoryDescription": "Selecione a categoria que melhor descreve seu feedback",
      "categoryQuestion": "Que tipo de feedback é este?",
      "characterCount": "{{current}}/{{max}} caracteres",
      "context": {
        "hero": "Herói",
        "heroPlaceholder": "ex.: CheckUp, TelePortal",
        "notDetected": "Nenhum contexto detectado",
        "page": "Página",
        "pagePlaceholder": "ex.: /dashboard, /checkup"
      },
      "contextInfo": "Informações do contexto",
      "contextSaved": "Informações do contexto salvas",
      "detailsDescription": "Por favor, forneça detalhes sobre seu feedback",
      "detailsPlaceholder": "Descreva seu feedback em detalhes...",
      "detailsQuestion": "Conte-nos mais",
      "editContext": "Editar",
      "fileSizeError": "O tamanho do arquivo excede o limite de {{maxSize}}",
      "fileUploadDescription": "Adicione capturas de tela, PDFs ou outros arquivos (até 20MB cada) para nos ajudar a entender melhor seu feedback.",
      "optional": "Opcional",
      "privacyNote": "Seu feedback é anônimo e nos ajuda a melhorar Tonnie",
      "ratingDescription": "Avalie sua satisfação geral",
      "ratingQuestion": "Como foi sua experiência?",
      "selectRatingAndCategory": "Por favor, selecione tanto a avaliação quanto a categoria",
      "submit": "Enviar",
      "submitError": "Falha ao enviar feedback. Por favor, tente novamente.",
      "submitSuccess": "Obrigado! Seu feedback foi enviado.",
      "submitting": "Enviando...",
      "subtitle": "Ajude-nos a melhorar sua experiência",
      "successMessage": "Agradecemos por dedicar seu tempo para nos ajudar a melhorar Tonnie. Seu feedback foi recebido e será revisado pela nossa equipe.",
      "successTitle": "Obrigado pelo seu feedback!",
      "title": "Feedback",
      "toggle": "Enviar feedback",
      "totalFileSize": "{{size}} / {{maxSize}}",
      "uploadFiles": "Enviar arquivos",
      "validationError": "Por favor, preencha todos os campos obrigatórios"
    },
    "affiliate": {
      "availableBalance": "Saldo disponível",
      "codeCopied": "Código do cupom copiado",
      "colActions": "Ações",
      "colAmount": "Valor",
      "colAmountPaid": "Valor pago",
      "colCommission": "Comissão",
      "colDate": "Data",
      "colProgress": "Progresso",
      "colRequested": "Solicitado",
      "colRoute": "Rota",
      "colScenario": "Cenário",
      "colStatus": "Status",
      "daysWaiting": "{{count}}d aguardando",
      "paidOn": "Pago {{date}}",
      "commission": "Comissão",
      "copyCode": "Copiar código",
      "discountGiven": "Desconto concedido",
      "exportCsv": "Exportar CSV",
      "exporting": "Exportando…",
      "exportReady": "Exportação pronta",
      "exportFailed": "Não foi possível exportar os resgates",
      "filters": {
        "granularityLabel": "Agrupar por",
        "granularity": {
          "day": "Dia",
          "month": "Mês",
          "year": "Ano"
        },
        "rangeLabel": "Período",
        "range": {
          "30d": "30 dias",
          "90d": "90 dias",
          "12m": "12 meses",
          "all": "Todo o tempo"
        },
        "scenarioLabel": "Cenário",
        "scenarioAll": "Todos os cenários",
        "statusLabel": "Status",
        "statusAll": "Todos os status"
      },
      "scenario": {
        "unlock": "Desbloqueio da jornada",
        "renewal": "Renovação",
        "pro": "Pro",
        "other": "Outro"
      },
      "noRedemptionsForFilters": "Nenhum resgate corresponde a esses filtros.",
      "redemptionsTitle": "Resgates",
      "rowsPerPage": "Linhas por página",
      "showingRange": "{{from}}–{{to}} de {{total}}",
      "goToPage": "Ir para a página {{page}}",
      "prev": "Anterior",
      "next": "Próximo",
      "checkout": "Tonnie checkout",
      "checkoutSecure": "Seguro · Stripe",
      "customerView": "O que seu cliente vê",
      "howTitle": "Como o programa funciona",
      "howStep1Title": "Compartilhe seu código",
      "howStep1Body": "Dê {{code}} para as pessoas que você indicar para a Tonnie.",
      "howStep2Title": "Eles economizam {{percent}}%",
      "howStep2Body": "O código é aplicado no checkout — o preço cai antes de eles pagarem.",
      "howStep3Title": "Você ganha {{rate}}%",
      "howStep3Body": "Em cada conversão paga, {{rate}}% do que eles pagam é creditado na sua conta.",
      "howStep4Title": "Retirar",
      "howStep4Body": "Uma vez que seu saldo atinja {{amount}}, solicite um pagamento e envie sua fatura para ser pago.",
      "refundsNote": "A comissão é acumulada apenas quando um pagamento é bem-sucedido. Reembolsos dentro da janela reverterão automaticamente a comissão correspondente.",
      "sampleProduct": "Jornada Pro",
      "sampleProductSub": "Assinatura mensal",
      "invoiceOnFile": "Fatura recebida",
      "invoiceUploaded": "Fatura enviada",
      "invoiceUploadFailed": "Falha ao enviar fatura",
      "minimumPayout": "Pagamento mínimo: {{amount}}",
      "noPayoutsYet": "Nenhum pagamento solicitado ainda.",
      "noRedemptionsYet": "Nenhuma troca ainda.",
      "notEnrolledBody": "Esta organização não está inscrita no programa de afiliados Tonnie. Entre em contato com a Tonnie para começar.",
      "notEnrolledTitle": "Ainda não é um afiliado",
      "awaitingApproval": "Aguardando aprovação",
      "cancel": "Cancelar",
      "payoutCancelled": "Pagamento cancelado — saldo liberado",
      "payoutCancelFailed": "Não foi possível cancelar o pagamento",
      "payoutFailed": "Não foi possível solicitar pagamento",
      "payoutHistory": "Histórico de pagamentos",
      "payoutRequested": "Pagamento solicitado",
      "payoutStep1Title": "Solicitação",
      "payoutStep1Body": "Você solicita um pagamento do seu saldo disponível.",
      "payoutStep2Title": "Aprovação",
      "payoutStep2Body": "Tonnie revisa e aprova sua solicitação.",
      "payoutStep3Title": "Fatura",
      "payoutStep3Body": "Você envia sua fatura pelo valor.",
      "payoutStep4Title": "Pagamento",
      "payoutStep4Body": "Tonnie te paga por transferência bancária.",
      "payoutStatus": {
        "approved": "Aprovado",
        "cancelled": "Cancelado",
        "invoice_received": "Fatura recebida",
        "paid": "Pago",
        "rejected": "Rejeitado",
        "requested": "Solicitado"
      },
      "percentOff": "{{percent}}% de desconto",
      "platform": {
        "colCommission": "Comissão",
        "colDiscount": "Desconto",
        "colIssuer": "Afiliado",
        "colPaid": "Pago",
        "colRedemptions": "Resgates",
        "errorHint": "Tente novamente ou verifique seu acesso de equipe Tonnie.",
        "errorTitle": "Não foi possível carregar a visão da plataforma",
        "issuersTitle": "Por afiliado",
        "noIssuers": "Ainda sem resgates pagos.",
        "totalCommission": "Comissão total",
        "totalDiscount": "Desconto total concedido",
        "totalPaid": "Total pago",
        "totalRedemptions": "Total de resgates"
      },
      "yourCommission": "Você ganha {{rate}}%",
      "discountHint": "O desconto que seus clientes recebem na finalização da compra.",
      "commissionHint": "Sua comissão sobre cada valor que eles pagam.",
      "redemptionsOverTime": "Resgates ao longo do tempo",
      "redemptionStatus": {
        "paid": "Pago",
        "pending": "Pendente",
        "refunded": "Reembolsado"
      },
      "requestPayout": "Solicitar pagamento",
      "subtitle": "Acompanhe os resgates do seu cupom e retire sua comissão.",
      "tabHowItWorks": "Como funciona",
      "tabOverview": "Visão geral",
      "tabPayouts": "Pagamentos",
      "tabPlatform": "Plataforma",
      "title": "Programa de afiliados",
      "totalCommission": "Comissão total",
      "totalRedemptions": "Resgates",
      "uploadInvoice": "Enviar fatura",
      "uploading": "Carregando…",
      "yourCode": "Seu código de cupom"
    },
    "layout": {
      "adaptation": "Adaptação",
      "affiliates": "Afiliados",
      "billing": "Cobrança",
      "business": "Business",
      "care": "Care",
      "cohorts": "Cohortes",
      "evidence": "Evidência",
      "home": "Início",
      "logout": "Sair",
      "messages": "Mensagens",
      "mobility": "Mobilidade",
      "pipeline": "Pipeline",
      "pool": "Pool",
      "programs": "Programas",
      "settings": "Configurações",
      "vetting": "Verificação",
      "inoutOperations": "Operação InOut"
    },
    "legal": {
      "aboutUs": "Sobre nós",
      "backToDashboard": "Voltar ao painel",
      "dataProtection": "Proteção de dados",
      "dataProtectionBody": "Órgão de proteção de dados",
      "gdprBody": "Órgão GDPR",
      "gdprCompliance": "Conformidade GDPR",
      "privacyBody": "Órgão de privacidade",
      "privacyDescription": "Como a Tonnie coleta, usa e protege dados pessoais",
      "privacyPolicy": "Política de privacidade",
      "rightsDescription": "Seus direitos sobre os dados que a Tonnie guarda, e como exercê-los",
      "subtitle": "Legenda",
      "termsBody": "Órgão de termos",
      "termsDescription": "Os termos que regem o uso da Tonnie pela sua empresa",
      "termsOfService": "Termos de serviço",
      "title": "Termos & privacidade",
      "viewPrivacy": "Ver privacidade",
      "viewTerms": "Ver termos",
      "yourRights": "Seus direitos"
    },
    "mobilityPage": {
      "activeTab": "Ativo",
      "archivedTab": "Arquivado",
      "allStatus": "Todos os status",
      "allTracks": "Todas as trilhas",
      "analytics": "Análises",
      "acrossAllTracks": "Em todas as trilhas",
      "avgProgress": "Média de progresso",
      "blocked": "Bloqueado",
      "blockingDocs": "Documentos bloqueadores",
      "complete": "Completo",
      "viewAll": "Ver todos",
      "detailsBtn": "Detalhes",
      "detailsAria": "Abrir detalhes de CoPilot para {{name}}",
      "viewTalentAria": "Ver detalhes para {{name}}",
      "talentRowActionsAria": "Ações para {{name}}",
      "blockingDocsPending": "Documentos bloqueadores pendentes",
      "coTasks": "Tarefas",
      "companyActions": "Ações da empresa",
      "atRiskTalents": "Em risco",
      "overdueTasks": "Tarefas atrasadas",
      "companyActionsRequired": "Ações da empresa necessárias",
      "companyDocsPending": "Documentos da empresa pendentes",
      "companyActionsSectionTitle": "Tarefas da empresa",
      "companyTasksDesc": "Obrigações de propriedade da empresa entre seus talentos patrocinados — agrupadas por talento.",
      "companyTasksPending": "Tarefas da empresa pendentes",
      "companyTasksPendingCount_one": "{{count}} tarefa da empresa pendente",
      "companyTasksPendingCount_other": "{{count}} tarefas da empresa pendentes",
      "companyTasksTitle": "Tarefas da empresa",
      "companyTasksOpenTab": "Aberto ({{count}})",
      "companyTasksCompletedTab": "Concluído ({{count}})",
      "companyTasksEmpty": "Nenhuma tarefa aqui.",
      "attachUpload": "Anexar e enviar",
      "awaitingUpload": "Aguardando upload",
      "docsAttachedCount": "{{uploaded}}/{{total}} docs",
      "noDocsRequired": "Nenhum documento necessário — marque como completo quando terminar.",
      "replaceDocument": "Substituir",
      "reopenTaskAria": "Reabrir {{title}}",
      "requiredDocuments": "Documentos necessários",
      "docsRequiredToCompleteTitle": "Enviar documentos necessários",
      "docsUploadedProgress": "{{uploaded}} de {{total}} documentos enviados",
      "allDocsUploadedReadyToComplete": "Todos os documentos enviados — você pode concluir esta tarefa.",
      "taskReopened": "Reaberto \"{{title}}\"",
      "taskReopenFailed": "Falha ao reabrir \"{{title}}\". Por favor, tente novamente.",
      "completed": "Completo",
      "completionRate": "Taxa de conclusão",
      "description": "Vistos, viagem e instalação nas mudanças dos seus talentos patrocinados",
      "documentUploadedSuccess": "{{name}} enviado",
      "done": "Concluído",
      "dueDate": "Vencido: {{date}}",
      "filterStatus": "Status",
      "filterTrack": "Rastrear",
      "for": "Para",
      "forTalent": "Para {{name}}",
      "inMobility": "Em Mobilidade",
      "inMobilitySplit": "{{inProgress}} em progresso · {{completed}} concluídos",
      "statusInProgress": "Em andamento",
      "engaged": "Engajado",
      "inProgressShort": "em progresso",
      "noTalentsInTrack": "Nenhum talento nesta trilha ainda",
      "viewCompletedTalents": "Ver talentos concluídos",
      "viewBlockedTalents": "Ver talentos bloqueados",
      "viewAtRiskTalents": "Ver talentos em risco",
      "trackCompletion": "Conclusão da trilha",
      "trackCompletionDescription": "Quantos talentos terminaram cada trilha",
      "doneOfEngaged": "{{name}} · {{done}}/{{engaged}}",
      "legal": "Legal",
      "milestones": "Marcos",
      "mobilityTracks": "Trilhas de mobilidade",
      "overall": "Geral",
      "noDueDate": "Sem data de vencimento",
      "noPendingTasks": "Nenhuma tarefa pendente",
      "noTalentsFound": "Nenhum talento encontrado",
      "noTalentsInMobility": "Nenhum talento em mobilidade",
      "onTrack": "No caminho certo",
      "pendingTasks": "Tarefas pendentes",
      "reminderSent": "Lembrete enviado para {{title}}",
      "searchTalents": "Buscar talentos",
      "setup": "Configuração",
      "statusAtRisk": "Status em risco",
      "statusBlocked": "Status bloqueado",
      "statusOnTrack": "Status no caminho",
      "talentProgress": "Progresso do talento",
      "talentsBlocked": "Talentos bloqueados",
      "taskMarkedComplete": "{{title}} marcado como completo",
      "taskCompleteFailed": "Falha ao marcar \"{{title}}\" como completo. Por favor, tente novamente.",
      "title": "Mobilidade",
      "trackOverview": "Visão geral do rastreamento",
      "travel": "Viagem",
      "tryAdjustingFilters": "Tente ajustar filtros",
      "underReview": "Em revisão",
      "validated": "Validado",
      "waitingOnCompanyCount": "Aguardando a empresa",
      "actionNeeded": "Ação necessária",
      "allTasksCompletedTitle": "Todas as tarefas concluídas!",
      "clearFiltersButton": "Limpar filtros",
      "trackProgressOverview": "Visão geral do progresso do rastreamento",
      "companyActionsSection": "Ações da empresa",
      "completeTaskAria": "Marcar {{title}} como completo",
      "waitingOnCompany": "Aguardando a empresa",
      "statusLabels": {
        "completed": "Completo",
        "on-track": "No caminho",
        "blocked": "Bloqueado",
        "at-risk": "Em risco"
      },
      "trackStatusLegend": {
        "done": "Concluído",
        "inProgress": "Em progresso",
        "blocked": "Bloqueado",
        "notStarted": "Não iniciado"
      },
      "lastActivityUnknown": "Nenhuma atividade ainda",
      "tracks": {
        "legal": {
          "name": "Legal",
          "description": "Visto, permissões de trabalho, documentação"
        },
        "travel": {
          "name": "Viagem",
          "description": "Voos, logística, coordenação de chegada"
        },
        "setup": {
          "name": "Configuração",
          "description": "Habitação, banco, registro local"
        }
      },
      "urgentTasksSummary_one": "{{count}} tarefa urgente precisa de atenção",
      "urgentTasksSummary_other": "{{count}} tarefas urgentes precisam de atenção",
      "documentUploadFailed": "Falha ao carregar. Tente novamente.",
      "reminderTooSoonGeneric": "Lembrete enviado recentemente.",
      "reminderFailed": "Falha ao enviar lembrete. Tente novamente.",
      "uploadTooLarge": "Arquivo é maior que 25 MB. Reduza ou comprima e tente novamente.",
      "docsStillOutstanding_one": "{{count}} documento necessário",
      "docsStillOutstanding_other": "{{count}} documentos necessários",
      "daysOverdue_one": "{{count}} dia de atraso",
      "daysOverdue_other": "{{count}} dias de atraso",
      "dueInDays_one": "Vence em {{count}} dia",
      "dueInDays_other": "Vence em {{count}} dias",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talentos",
      "pendingCount_one": "{{count}} pendente",
      "pendingCount_other": "{{count}} pendentes",
      "talentCountCompleted_one": "{{count}} de {{total}} {{label}}",
      "talentCountCompleted_other": "{{count}} de {{total}} {{label}}",
      "reminderTooSoon_one": "Lembrete enviado recentemente. Tente novamente em {{count}} hora.",
      "reminderTooSoon_other": "Lembrete enviado recentemente. Tente novamente em {{count}} horas."
    },
    "nav": {
      "home": "Início"
    },
    "notFound": {
      "description": "A página que você está procurando não existe ou foi movida.",
      "goHome": "Ir para a página inicial",
      "title": "Página não encontrada"
    },
    "notifications": {
      "justNow": "Agora mesmo",
      "noNotifications": "Sem notificações",
      "title": "Notificações",
      "tabAll": "Todas",
      "unread": "Não lidas",
      "noUnread": "Nenhuma notificação não lida",
      "markAllRead": "Marcar todas como lidas",
      "bellLabel_one": "Notificações, {{shown}} não lida",
      "bellLabel_other": "Notificações, {{shown}} não lidas",
      "clearRead": "Limpar lidas",
      "moreActions": "Mais ações",
      "markReadAction": "Marcar como lida",
      "dismiss": "Dispensar",
      "dismissed": "Notificação dispensada",
      "undo": "Desfazer",
      "viewDismissed": "Ver dispensadas",
      "dismissedTitle": "Dispensadas",
      "restore": "Restaurar",
      "noDismissed": "Nenhuma notificação dispensada",
      "seeAll": "Ver todas as notificações",
      "showMore": "Ver mais",
      "showLess": "Ver menos",
      "daysAgo_one": "Há {{count}} dia",
      "daysAgo_other": "Há {{count}} dias",
      "hoursAgo_one": "Há {{count}} hora",
      "hoursAgo_other": "Há {{count}} horas",
      "minutesAgo_one": "Há {{count}} minuto",
      "minutesAgo_other": "Há {{count}} minutos"
    },
    "onboarding": {
      "challenges": {
        "candidateDropoff": "Desistência de candidatos durante a realocação",
        "complianceLegal": "Complexidade de conformidade e legal",
        "costManagement": "Gestão de custos",
        "findingCandidates": "Encontrar candidatos internacionais qualificados",
        "immigrationVisa": "Complexidade de imigração e visto",
        "postArrival": "Adaptação e retenção pós-chegada",
        "trackingReporting": "Rastreamento e relatórios"
      },
      "exitSetup": "Configuração de saída",
      "geographicSetup": {
        "moreRoutes_one": "+{{count}}",
        "moreRoutes_other": "+{{count}}"
      },
      "hiringContext": {
        "selectedChallenges": "Selecionado: {{count}}/3 desafios"
      },
      "hiringGoals": {
        "buildPipeline": "Construa um pipeline de talentos sustentável",
        "improveExperience": "Melhore a experiência do candidato durante a realocação",
        "improveOnboarding": "Melhore a integração e adaptação pós-chegada",
        "increaseRetention": "Aumente a retenção de funcionários realocados",
        "reduceCosts": "Reduza os custos de realocação",
        "reduceTime": "Reduza o tempo de contratação para candidatos internacionais",
        "streamlineCompliance": "Simplifique os processos de conformidade e visto",
        "trackRoi": "Rastreie e meça o ROI da mobilidade"
      },
      "hiringTimeframes": {
        "immediate": "Imediato — pronto para começar agora",
        "long": "Longo prazo (6–12 meses)",
        "medium": "Médio prazo (3–6 meses)",
        "short": "Curto prazo (1–3 meses)"
      },
      "maturity": {
        "established": "Programa estabelecido — função de mobilidade madura",
        "firstTime": "Primeira vez — novo em contratações internacionais",
        "someExperience": "Alguma experiência — fez algumas realocações"
      },
      "personalInfo": {
        "addressDetailsError": "Falha ao obter detalhes do endereço. Por favor, tente novamente.",
        "addressHint": "Selecione seu endereço a partir das sugestões",
        "addressPlaceholder": "Comece a digitar seu endereço...",
        "addressSearchError": "Falha ao buscar endereços. Por favor, tente novamente.",
        "loadingAddressDetails": "Carregando detalhes do endereço...",
        "searchAddress": "Buscar endereço",
        "searchAddressDescription": "Digite seu endereço e selecione entre as sugestões do Google Places"
      },
      "saving": "Salvando...",
      "step": "Passo",
      "workArrangements": {
        "flexible": "Flexível",
        "hybrid": "Híbrido",
        "onsite": "Presencial"
      }
    },
    "pipelinePage": {
      "activeTab": "Ativo",
      "addTalents": "Adicionar talentos",
      "allCohorts": "Todas as coortes",
      "allPrograms": "Todos os programas",
      "archivedSubtitle": "Candidatos cujas jornadas terminaram — contas arquivadas pelo administrador ou autoexcluídas",
      "archivedTab": "Arquivado",
      "avgIQulture": "Média iQulture",
      "bucketAcquisition": "Aquisição",
      "bucketAcquisitionDescription": "Fonte / Importado",
      "bucketSponsored": "Patrocinado",
      "bucketSponsoredDescription": "Mobilidade · Adaptação · Care",
      "bucketVetting": "Verificação",
      "bucketVettingDescription": "CheckUp em andamento",
      "clearAll": "Limpar tudo",
      "cohort": "Coorte",
      "description": "Cada talento do primeiro contato ao patrocínio, etapa por etapa",
      "filters": "Filtros",
      "formerCandidate": "Ex-candidato",
      "inPipeline": "Em pipeline",
      "needAttention": "Precisa de atenção",
      "noCohortFound": "Nenhuma coorte encontrada",
      "noProgramFound": "Nenhum programa encontrado",
      "onTrack": "No caminho certo",
      "pipelineView": "Visualização do pipeline",
      "scrollNext": "Próxima coluna",
      "scrollPrev": "Coluna anterior",
      "program": "Programa",
      "searchCohorts": "Pesquisar coortes",
      "searchPlaceholder": "Digite a pesquisa...",
      "searchPrograms": "Pesquisar programas",
      "status": "Status",
      "statusAtRisk": "Em risco",
      "statusBlocked": "Bloqueado",
      "statusCompleted": "Completo",
      "statusOnTrack": "No caminho certo",
      "title": "Pipeline",
      "bulkBarAria": "Ações em massa para talentos selecionados",
      "bulkAddToCohort": "Adicionar à coorte",
      "bulkAddToCohortFailed": "Falha ao atribuir talentos selecionados",
      "bulkAddToCohortPartial": "{{added}} atribuídos ao grupo · {{skipped}} não puderam ser atribuídos",
      "cardTag": "Etiqueta do card",
      "selectWholeColumn": "Selecionar a coluna inteira",
      "talentsInPipeline_one": "{{count}} talento no pipeline",
      "talentsInPipeline_other": "{{count}} talentos no pipeline",
      "bulkAddToCohortSuccess_one": "{{count}} talento atribuído à coorte",
      "bulkAddToCohortSuccess_other": "{{count}} talentos atribuídos à coorte",
      "searchLabel": "Buscar talentos"
    },
    "vettingCard": {
      "acceptedAgo": "Aceito {{when}}",
      "checkupProgress": "CheckUp {{percent}}% · {{done}} de {{total}} etapas",
      "iqultureProgress": "iQulture {{percent}}%",
      "lastSeenAgo": "Visto pela última vez {{when}}",
      "missingSteps": "Faltando: {{steps}}",
      "notYetActive": "Ainda não ativo",
      "startedAgo": "Iniciado {{when}}",
      "stateAwaitingScore": "Calculando iQulture…",
      "stateNotStarted": "Não iniciado",
      "step": {
        "assistantChat": "Chat do assistente",
        "languageTests": "Testes de idioma",
        "motivationalAnswers": "Motivação",
        "pitchVideo": "Vídeo de apresentação",
        "videosWatched": "Assistir vídeos"
      },
      "submittedAgo": "Enviado {{when}}",
      "testitComplete": "TestIt concluído",
      "testitInvited": "TestIt convidado",
      "testitProgress": "TestIt · {{done}}/{{total}}",
      "scoredAgo": "Pontuado {{when}}",
      "completedAgo": "Concluído {{when}}",
      "sharingWithdrawnAgo": "Compartilhamento retirado {{when}}"
    },
    "pipelineView": {
      "activateAgain": "Ativar novamente",
      "addTalentsCta": "Adicionar talentos",
      "archive": "Arquivar",
      "archiveSponsoredConfirmDescription": "Isso arquiva a jornada patrocinada de {{name}}: o cartão sai do seu pipeline e {{name}} perde o acesso a esta oportunidade. Os resultados do CheckUp e o histórico da jornada ficam guardados para fins de conformidade. Você pode restaurá-la na aba Arquivados.",
      "archiveSponsoredConfirmTitle": "Arquivar talento patrocinado",
      "archiving": "Arquivando…",
      "askForCheckup": "Convidar para CheckUp completo",
      "askForTestit": "Convidar para testes específicos",
      "bulkArchiveCta": "Arquivar {{count}}",
      "bulkArchiveFailed": "Falha ao arquivar talentos",
      "bulkArchivePartial": "{{archived}} arquivados · {{failed}} falharam",
      "bulkClear": "Limpar",
      "bulkSendConfirmCta": "Enviar convites",
      "bulkSendConfirmTitle": "Enviar convites para Avaliação",
      "bulkSendPartial": "{{sent}} enviados · {{failed}} falharam",
      "bulkSending": "Enviando…",
      "bulkSendingProgress": "Enviando convites… {{sent}}/{{total}}",
      "bulkSponsorCta": "Patrocinar {{count}}",
      "bulkSponsorFailed": "Falha ao patrocinar talentos",
      "bulkSponsorPartial": "{{sponsored}} patrocinados · {{failed}} falharam",
      "citizenLeft": "Candidato saiu da plataforma",
      "citizenLeftTooltip": "Este candidato excluiu sua conta Tonnie. Sua jornada é preservada para auditoria; detalhes identificáveis são redigidos.",
      "clearSearch": "Limpar filtro",
      "delete": "Excluir",
      "deleteConfirmDescription": "Isso removerá permanentemente {{name}} e todo o histórico de importação (eventos do pipeline, jornadas, mensagens). Esta ação não pode ser desfeita.",
      "deleteConfirmTitle": "Excluir talento",
      "deleteInvitationConfirmDescription": "Isso removerá permanentemente o convite para {{name}}. Eles não poderão aceitar o link do e-mail. Esta ação não pode ser desfeita.",
      "deleteInvitationConfirmTitle": "Excluir convite",
      "deleteInvitationFailed": "Falha ao excluir convite",
      "deleteInvitationSuccess": "Convite excluído",
      "deleting": "Excluindo…",
      "dragNotAllowed": "Não é possível mover de {{from}} para {{to}} — use o menu kebab para a ação correta",
      "imported": "Importado {{when}}",
      "invitationDeleteFailed": "Falha ao remover convite",
      "invitationDeleted": "Convite de {{name}} removido",
      "invitationResendFailed": "Falha ao reenviar",
      "invitationResent": "Convite reenviado",
      "invitationRevokeFailed": "Falha ao revogar",
      "invitationRevoked": "Convite revogado",
      "invitationSendFailed": "Falha ao enviar convite",
      "invitationSent": "Convite enviado",
      "invitationSentHint": "{{name}} receberá o e-mail e o cartão se move para Vetting.",
      "inviteToVetting": "Convidar para Vetting",
      "noMatches": "Nenhuma correspondência para \"{{query}}\"",
      "noTalentsInStage": "Nenhum talento nesta fase",
      "removeFromPipeline": "Remover do pipeline",
      "removeVettingConfirmDescription": "Isso remove {{name}} do seu pipeline e {{name}} perde o acesso a esta oportunidade. Os dados do CheckUp e o histórico ficam guardados para fins de conformidade. Você pode restaurá-lo na aba Arquivados.",
      "removeVettingConfirmTitle": "Remover talento do pipeline",
      "invitationEmailNotSent": "O convite foi salvo, mas não foi possível enviar o e-mail",
      "resendInvitationFailed": "Falha ao reenviar convite",
      "resendInvitationSuccess": "Convite reenviado",
      "revokeInvitationFailed": "Falha ao revogar convite",
      "revokeInvitationSuccess": "Convite revogado",
      "searchPlaceholder": "Filtrar nome, e-mail, função…",
      "selectAllCount": "Selecionar tudo ({{selected}}/{{total}})",
      "selectAllMatching": "Selecionar todos os correspondentes ({{visible}})",
      "statusArchived": "Arquivado",
      "stageStatus": {
        "onTrack": "No caminho",
        "blocked": "Bloqueado",
        "atRisk": "Em risco",
        "completed": "Completo"
      },
      "statusAwaitingAcceptance": "Aguardando aceitação",
      "statusDraft": "Rascunho",
      "subStage": {
        "mobility": "Mobilidade",
        "adaptation": "Adaptação",
        "care": "Care",
        "evidence": "Evidência"
      },
      "talentArchiveFailed": "Falha ao arquivar talento",
      "talentArchived": "{{name}} arquivado",
      "talentDeleteFailed": "Falha ao excluir talento",
      "talentDeleted": "{{name}} foi removido",
      "talentSponsored": "Talento patrocinado! Instância da jornada criada com rota {{origin}} → {{destination}}",
      "talentSponsoredFailed": "Falha ao patrocinar talento",
      "unarchiveFailed": "Falha ao restaurar talento",
      "unarchiveSuccess": "Talento restaurado — jornada ativa novamente",
      "updated": "Atualizado {{when}}",
      "selectCandidate": "Selecionar candidato",
      "signedUpNotAccepted": "Cadastrou-se, não aceitou",
      "signedUpNotAcceptedTooltip": "Esta pessoa já tem conta Tonnie mas não aceitou seu convite. Reenviar tem boas chances de alcançá-la. A jornada e o CheckUp permanecem privados até que ela aceite.",
      "tag": {
        "inviteProblem": "Problema no convite",
        "onboardingIncomplete": "Completando perfil",
        "waitingForCheckup": "Aguardando CheckUp",
        "checkupInProgress": "CheckUp em andamento",
        "awaitingScore": "Calculando pontuação",
        "awaitingReview": "Pronto para análise",
        "testitPending": "Testes pendentes",
        "testitComplete": "Testes concluídos",
        "testitPassed": "Aprovado",
        "testitDeclined": "Recusado",
        "checkupNotRequested": "CheckUp não solicitado",
        "inviteDeclined": "Recusou",
        "inviteExpired": "Convite expirado",
        "sponsorshipOffered": "Patrocínio oferecido",
        "checkupWithheld": "Aguardando o consentimento do talento",
        "consentWithdrawn": "Compartilhamento retirado"
      },
      "since": {
        "delivered": "Entregue {{when}}",
        "opened": "Aberto {{when}}",
        "landed": "Acessou a página {{when}}",
        "bounced": "Rejeitado {{when}}",
        "sent": "Convidado {{when}}",
        "signedUp": "Cadastrou-se {{when}}",
        "asked": "Solicitado {{when}}",
        "expired": "Expirou {{when}}"
      },
      "alreadyArchived": "Este talento já estava arquivado. O quadro está atualizado.",
      "alreadyRestored": "Esta jornada já havia sido restaurada. O quadro está atualizado.",
      "invitationAlreadyAccepted": "Este convite já foi aceito.",
      "bulkArchiveConfirmTitle_one": "Arquivar {{count}} talento",
      "bulkArchiveConfirmTitle_other": "Arquivar {{count}} talentos",
      "bulkArchiveConfirmCta_one": "Arquivar {{count}} talento",
      "bulkArchiveConfirmCta_other": "Arquivar {{count}} talentos",
      "bulkArchiveConfirmDescription_one": "{{count}} talento sai do seu pipeline ativo. Os resultados do CheckUp e o histórico da jornada ficam guardados para fins de conformidade. Você pode restaurá-lo na aba Arquivados.",
      "bulkArchiveConfirmDescription_other": "{{count}} talentos saem do seu pipeline ativo. Os resultados do CheckUp e o histórico da jornada ficam guardados para fins de conformidade. Você pode restaurá-los na aba Arquivados.",
      "bulkArchiveSuccess_one": "{{count}} talento arquivado",
      "bulkArchiveSuccess_other": "{{count}} talentos arquivados",
      "atRiskCount_one": "{{count}} em risco",
      "atRiskCount_other": "{{count}} em risco",
      "blockedCount_one": "{{count}} bloqueado",
      "blockedCount_other": "{{count}} bloqueados",
      "bulkSelectedCount_one": "{{count}} selecionado",
      "bulkSelectedCount_other": "{{count}} selecionados",
      "bulkSendCta_one": "Enviar {{count}} convite para Vetting",
      "bulkSendCta_other": "Enviar {{count}} convites para Vetting",
      "searchLabel": "Filtrar talentos em {{stage}}",
      "declinedWhen": "Recusou {{when}}",
      "expiredWhen": "Expirou {{when}}",
      "invitationSentAgain": "Convite enviado novamente",
      "leftProgramme": "Saiu do programa · {{date}}",
      "leftProgrammeTooltip": "Este talento saiu do seu programa, o que encerrou a relação. Você não vê mais o que ele compartilhou. Envie um novo convite para voltar a trabalhar com ele.",
      "restoreRefusedLeft": "Este talento saiu do seu programa. Envie um novo convite para voltar a trabalhar com ele.",
      "resendInvitationMessageMismatch": "A mensagem deste convite foi escrita para outro pedido. Envie-o novamente pela janela do convite para escrever a mensagem."
    },
    "pool": {
      "smartSearch": {
        "downloadCv": "Baixar currículo",
        "cvUnavailable": "Currículo indisponível",
        "selectCandidate": "Selecionar candidato",
        "clearSelection": "Limpar",
        "bulkAddTitle": "Adicionar à aquisição",
        "stepReview": "Revisar e classificar",
        "how1": "Cole uma ou mais descrições de vaga.",
        "how2": "A IA extrai as habilidades, a senioridade e o foco.",
        "how3": "Classificamos seu Pool de Talentos por aderência.",
        "extracting": "Lendo a descrição da vaga…",
        "extractError": "Não foi possível analisar essa descrição de vaga. Tente novamente.",
        "skillsTitle": "Habilidades encontradas",
        "skillsHint": "Remova as que não se aplicam ou adicione as suas — a classificação atualiza em tempo real.",
        "ranking": "Classificando…",
        "noSkills": "Nenhuma habilidade extraída",
        "noSkillsHint": "Adicione abaixo as habilidades-chave para esta vaga.",
        "addSkillPlaceholder": "Adicionar uma habilidade…",
        "viewResults": "Ver resultados classificados",
        "rankedTitle": "Pool classificado por aderência à vaga",
        "rankedForTitle": "Classificado para {{title}}",
        "clear": "Limpar",
        "nSelected_one": "{{count}} selecionado",
        "nSelected_other": "{{count}} selecionados",
        "addNToAcquisition_one": "Adicionar {{count}} à aquisição",
        "addNToAcquisition_other": "Adicionar {{count}} à aquisição",
        "bulkAddDesc_one": "Adicionar {{count}} candidato selecionado à etapa de Aquisição do seu pipeline.",
        "bulkAddDesc_other": "Adicionar {{count}} candidatos selecionados à etapa de Aquisição do seu pipeline.",
        "bulkAdded_one": "{{count}} adicionado à aquisição",
        "bulkAdded_other": "{{count}} adicionados à aquisição",
        "bulkFailed_one": "{{count}} não foi adicionado",
        "bulkFailed_other": "{{count}} não foram adicionados",
        "analyzing_one": "Analisando {{count}} descrição de vaga…",
        "analyzing_other": "Analisando {{count}} descrições de vaga…",
        "resultsFound_one": "{{count}} candidato corresponde",
        "resultsFound_other": "{{count}} candidatos correspondem",
        "bulkDuplicates_one": "{{count}} já está nesta coorte",
        "bulkDuplicates_other": "{{count}} já estão nesta coorte",
        "addSkillLabel": "Adicionar uma habilidade"
      },
      "matchReason": {
        "mustHaves": "Requisitos: {{met}}/{{total}}",
        "seniority": "Senioridade {{level}}",
        "semantic": "{{score}}% de correspondência de perfil",
        "skills": "{{count}}/{{total}} habilidades: {{skills}}",
        "readiness": "Prontidão {{score}}",
        "location": "Em {{location}}",
        "niceToHaves_one": "+{{count}} desejável",
        "niceToHaves_other": "+{{count}} desejáveis"
      },
      "savedSearch": {
        "title": "Buscas salvas",
        "savedCount": "Salvas ({{count}})",
        "save": "Salvar",
        "saved": "Busca salva",
        "saveFailed": "Não foi possível salvar a busca",
        "delete": "Excluir busca salva",
        "deleteFailed": "Não foi possível excluir a busca",
        "noSkills": "Sem habilidades",
        "saveTitle": "Salvar esta busca",
        "saveDesc": "Dê um nome para reexecutar esta busca por descrição de vaga depois.",
        "nameLabel": "Nome",
        "namePlaceholder": "ex.: Engenheiro Backend Sênior",
        "errors": {
          "name": "É necessário um nome"
        }
      },
      "detail": {
        "unavailable": "Candidato indisponível",
        "unavailableHint": "Este candidato não está mais no pool.",
        "curriculum": "Currículo",
        "openCv": "Abrir em nova aba",
        "noCv": "Sem CV disponível",
        "noCvHint": "Este candidato ainda não anexou um currículo.",
        "experience": "Experiência",
        "seniority": "Senioridade",
        "origin": "Origem",
        "inPoolSince": "No pool desde",
        "languages": "Idiomas",
        "linkedin": "Perfil no LinkedIn",
        "availOpen": "Aberto a propostas",
        "availConsideration": "Em consideração",
        "availUnavailable": "Indisponível",
        "experienceValue_one": "{{count}} ano",
        "experienceValue_other": "{{count}} anos"
      },
      "view": {
        "cards": "Cartões",
        "list": "Lista"
      },
      "advancedSearch": {
        "addAtLeastOneJob": "Por favor, adicione pelo menos uma descrição de trabalho",
        "addedSuccessfully": "Adicionado com sucesso",
        "enterJobDescription": "Por favor, insira uma descrição de trabalho ou URL",
        "stepInput": "Entrada",
        "titleAi": "Busca de talentos potencializada por IA",
        "subtitle": "Extraia habilidades de descrições de trabalho e encontre candidatos correspondentes",
        "jobDescriptionN": "Descrição do trabalho {{count}}",
        "jobPlaceholder": "Cole uma descrição de trabalho aqui...\n\nExemplo: Estamos procurando um Engenheiro de Software Sênior com mais de 5 anos de experiência em React, TypeScript e Node.js...",
        "addToList": "Adicionar à lista",
        "emptyTitle": "Nenhuma descrição de trabalho ainda",
        "emptyHint": "Adicione descrições de trabalho para extrair palavras-chave",
        "jobN": "Trabalho {{count}}",
        "howItWorks": "Como funciona",
        "extractBtn": "Extrair palavras-chave",
        "jobsAdded_one": "{{count}} descrição de vaga adicionada",
        "jobsAdded_other": "{{count}} descrições de trabalho adicionadas",
        "wordCount_one": "{{count}} palavra",
        "wordCount_other": "{{count}} palavras",
        "jobDescriptionLabel": "Descrição de trabalho"
      },
      "startAdvancedSearch": "Iniciar pesquisa avançada",
      "addToPipeline": "Adicionar ao pipeline",
      "searching": "Buscando no banco de talentos…",
      "talentCard": {
        "noCheckup": "Sem CheckUp ainda",
        "preVetted": "Tonnie pré-aprovado",
        "inPipeline": "Em pipeline",
        "whyMatched": "Por que combinado:",
        "iqultureScore": "Pontuação iQulture",
        "skills": "Habilidades",
        "added": "Adicionado",
        "addToVet": "Adicionar à avaliação",
        "matchPercent": "{{score}}% de correspondência",
        "top": "TOP",
        "moreCount_one": "+{{count}}",
        "moreCount_other": "+{{count}}"
      },
      "nSelected_one": "{{count}} selecionado",
      "nSelected_other": "{{count}} selecionados",
      "talentsFound_one": "{{count}} talento encontrado",
      "talentsFound_other": "{{count}} talentos encontrados"
    },
    "poolImport": {
      "errors": {
        "country": "O país deve ser um código de 3 letras",
        "email": "Email inválido",
        "empty": "Nenhuma linha para importar",
        "tooMany": "Linhas demais (máx 1000)"
      },
      "failed": "Importação falhou",
      "placeholder": "Cole CSV ou TSV com uma linha de cabeçalho: email, primeiro nome, sobrenome, cargo, país, cidade, habilidades",
      "subtitle": "Cole candidatos selecionados para adicioná-los ao Banco de Talentos público. Perfis existentes são atualizados.",
      "success": "Importado: {{created}} criado, {{updated}} atualizado",
      "title": "Importar perfis",
      "import_one": "Importar {{count}} perfil",
      "import_other": "Importar {{count}} perfis",
      "parsedCount_one": "{{count}} linha válida pronta para importar",
      "parsedCount_other": "{{count}} linhas válidas prontas para importar"
    },
    "poolPage": {
      "addToVettingDesc": "Adicionar {{name}} ao seu pipeline de avaliação",
      "addToVettingPipeline": "Adicionar ao pipeline de avaliação",
      "advancedSearch": "Pesquisa avançada",
      "advancedSearchDesc": "Encontre talentos que correspondem a uma descrição de vaga",
      "alphabetical": "Alfabética",
      "alreadyInPipeline": "Já no pipeline",
      "available": "Disponível",
      "description": "Pesquise talentos que escolheram ser encontrados",
      "failedToAdd": "Falha ao adicionar",
      "inPipeline": "Em pipeline",
      "iqultureHighToLow": "iQulture alto para baixo",
      "iqultureLowToHigh": "iQulture baixo para alto",
      "iqultureScore": "Pontuação iQulture",
      "location": "Localização",
      "noCohortsYet": "Ainda não há grupos — crie um para adicionar talentos ao seu pipeline.",
      "noLocationsFound": "Nenhum local encontrado",
      "noRolesFound": "Nenhum cargo encontrado",
      "noSkillsFound": "Nenhuma habilidade encontrada",
      "noTalentsFound": "Nenhum talento encontrado",
      "relevance": "Relevância",
      "role": "Função",
      "searchError": "A busca falhou",
      "searchErrorHint": "Algo deu errado ao carregar os talentos. Tente novamente.",
      "searchLocations": "Pesquisar locais",
      "searchPlaceholder": "Digite a pesquisa...",
      "searchRoles": "Pesquisar cargos",
      "searchSkills": "Pesquisar habilidades",
      "selectACohort": "Selecionar um grupo",
      "selectCohort": "Selecionar grupo",
      "selectLocations": "Selecionar locais",
      "selectRoles": "Selecionar cargos",
      "selectSkills": "Selecionar habilidades",
      "skills": "Habilidades",
      "sortBy": "Classificar Por",
      "talentAdded": "{{name}} adicionado ao pipeline",
      "title": "Pool",
      "tryAdjustingFilters": "Tente ajustar filtros",
      "upgradeDescription": "Busque e adicione talentos pré-avaliados do Tonnie Talent Pool diretamente ao seu pipeline.",
      "results": "Resultados",
      "bestMatch": "Melhor correspondência",
      "lowestMatch": "Menor correspondência",
      "searchLabel": "Buscar talentos"
    },
    "profile": {
      "accountDescription": "Detalhes sobre sua conta que não podem ser alterados aqui.",
      "accountTitle": "Conta",
      "avatarDescription": "Exibido no menu superior direito e em toda a plataforma.",
      "avatarHelper": "PNG, JPG ou GIF de até 5 MB. Arraste e solte ou clique para navegar.",
      "avatarRemoveConfirm": "Sua foto de perfil será substituída por suas iniciais. Você pode enviar uma nova a qualquer momento.",
      "avatarRemoveConfirmAction": "Remover foto",
      "avatarRemoveFailed": "Não foi possível remover a foto. Por favor, tente novamente.",
      "avatarRemoveTitle": "Remover foto de perfil?",
      "avatarRemoved": "Foto removida",
      "avatarTitle": "Foto de perfil",
      "avatarTooLarge": "A foto é muito grande. Máx 5 MB.",
      "avatarUploadFailed": "Falha ao enviar a foto. Por favor, tente novamente.",
      "avatarUploaded": "Foto atualizada",
      "avatarWrongType": "Apenas arquivos de imagem são suportados.",
      "changeAvatar": "Alterar foto de perfil",
      "description": "Gerencie suas informações pessoais, avatar e detalhes da conta.",
      "email": "Email",
      "emailManagedByClerk": "Gerenciado via login",
      "firstName": "Primeiro nome",
      "lastName": "Último nome",
      "memberSince": "Membro desde",
      "nameDescription": "Como seu nome aparece em toda a plataforma.",
      "nameTitle": "Seu nome",
      "remove": "Remover",
      "role": "Função",
      "roleDescription": "Definido pelo administrador da sua organização.",
      "saveChanges": "Salvar alterações",
      "saveFailed": "Não foi possível salvar as alterações. Por favor, tente novamente.",
      "saved": "Perfil atualizado",
      "title": "Perfil",
      "uploadPhoto": "Enviar foto"
    },
    "programs": {
      "activePrograms": "Programas em andamento",
      "adjustFilters": "Ajustar filtros",
      "allCohorts": "Todas as coortes",
      "allStatus": "Todos os status",
      "askCoPilot": "Perguntar ao CoPilot",
      "avgProgress": "Média de progresso",
      "backToPrograms": "Voltar para programas",
      "care": "Care",
      "careRequiresEnterprise": "Care requer Enterprise",
      "careSettingsReset": "Redefinição das configurações do Care",
      "cohorts": "Cohortes",
      "createCohort": "Criar cohorte",
      "createDialogDescription": "Um programa é a camada organizacional de nível superior para talentos que você patrocina ou convida. Cohortes e jornadas vivem dentro dele.",
      "createFirstProgram": "Criar primeiro programa",
      "createNewProgram": "Criar novo programa",
      "createProgram": "Criar programa",
      "created": "Criado",
      "description": "Seus programas de relocação e as coortes que incluem",
      "descriptionLabel": "Descrição",
      "descriptionPlaceholder": "Digite a descrição...",
      "editDialogDescription": "Atualize os detalhes do programa abaixo.",
      "editProgram": "Editar programa",
      "filterByStatus": "Filtrar por status",
      "getMoreInsights": "Obter mais insights",
      "insightPassRate": "Taxa de aprovação",
      "insights": "Insights",
      "insightsDescription": "Como este programa está progredindo",
      "iqulture": "iQulture",
      "latestUpdates": "Últimas atualizações",
      "manageCohorts": "Gerenciar cohortes",
      "noProgramsFound": "Nenhum programa encontrado",
      "notFound": "Programa não encontrado",
      "notFoundDesc": "Este programa não existe ou foi excluído. Tente retornar à lista de programas.",
      "overview": "Visão geral",
      "pauseProgram": "Pausar programa",
      "programCreated": "Programa criado",
      "programNameLabel": "Nome do programa",
      "programNamePlaceholder": "Digite o nome do programa...",
      "programPaused": "Programa pausado",
      "programResumed": "Programa retomado",
      "programUpdated": "Programa atualizado",
      "progress": "Progresso",
      "progressLabel": "Progresso",
      "recentActivity": "Atividade recente",
      "resumeProgram": "Retomar programa",
      "searchPrograms": "Pesquisar programas",
      "stability": "Estabilidade",
      "stabilityValue": "{{value}}% de estabilidade",
      "statusChangeFailed": "Falha ao alterar o status do programa",
      "talents": "Talentos",
      "title": "Programas",
      "totalCohorts": "Total de cohortes",
      "totalTalents": "Total de talentos",
      "viewDetails": "Ver detalhes",
      "whatHappensNext": "O que acontece a seguir",
      "whatHappensNextDescription": "Você será levado à página de detalhes do programa onde poderá criar coortes, convidar talentos e acompanhar sua jornada nas fases de Vetting e Patrocinado.",
      "errors": {
        "nameRequired": "O nome do programa é obrigatório",
        "nameTooLong": "O nome do programa deve ter 200 caracteres ou menos",
        "descriptionTooLong": "A descrição deve ter 2000 caracteres ou menos",
        "planLimit": "O plano gratuito permite 1 programa ativo. Faça upgrade para o Enterprise para programas ilimitados.",
        "createFailed": "Falha ao criar programa"
      },
      "programActionsAria": "Ações para {{name}}",
      "updateFailed": "Falha ao atualizar programa",
      "archiveSuccess": "{{name}} movido para arquivado.",
      "archiveFailed": "Falha ao arquivar programa",
      "restoreSuccess": "{{name}} restaurado.",
      "restoreFailed": "Falha ao restaurar programa",
      "activeTab": "Ativo",
      "archivedTab": "Arquivado",
      "viewInPipeline": "Ver talentos no Pipeline",
      "archive": "Arquivar",
      "restore": "Restaurar",
      "archiveConfirmTitle": "Arquivar programa?",
      "archiveConfirmDescription": "{{name}} se move para a aba Arquivado. Cada coorte ativa sob este programa também é arquivada. Restaurar o programa mais tarde NÃO restaura automaticamente as coortes — você as reativa individualmente a partir da aba Coortes Arquivadas.",
      "insightCareGap": "Talentos patrocinados, mas sem pontos de contato ativos Care — verifique a cadência de check-in.",
      "cohortScopeAria": "Escopo da coorte",
      "cohortsEmptyActive": "Ainda não há coortes ativas neste programa. Crie uma para começar a convidar talentos.",
      "cohortsEmptyArchived": "Sem coortes arquivadas. Coortes que você arquivar — ou que foram arquivadas em cascata com o programa — aparecerão aqui.",
      "cohortCreated": "Coorte criada.",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talentos",
      "archiveSuccessWithCascade_one": "{{base}} {{count}} coorte foi arquivada com ele.",
      "archiveSuccessWithCascade_other": "{{base}} {{count}} coortes foram arquivadas com ele.",
      "restoreSuccessWithCohorts_one": "{{base}} {{count}} coorte continua arquivada — restaure-a na aba Coortes.",
      "restoreSuccessWithCohorts_other": "{{base}} {{count}} coortes continuam arquivadas — restaure-as na aba Coortes."
    },
    "sendToVetting": {
      "assessmentIntroTalent": "Estes talentos já têm uma jornada com esta empresa, então apenas a avaliação é nova — o destino permanece o mesmo.",
      "back": "Voltar",
      "branchCustom": "Destino personalizado…",
      "branchLabel": "Filial / escritório",
      "branchPlaceholder": "Escolha uma filial ou insira personalizada",
      "bulkSendingProgress": "Enviando convites… {{sent}}/{{total}}",
      "bulkTitle": "Enviar convites para Avaliação",
      "customizeToggle": "Personalizar mensagem",
      "description": "Vamos criar um esboço de jornada CheckUp gratuito e enviar um e-mail para o candidato. Você pode patrocinar a jornada completa mais tarde, se decidir.",
      "descriptionTestit": "Vamos criar um esqueleto de jornada gratuito para os testes específicos que você escolher e enviar um e-mail ao candidato. Os resultados são reutilizáveis.",
      "destinationLabel": "País de destino",
      "destinationPlaceholder": "Onde eles estarão trabalhando?",
      "destinationSettingsLink": "Configurações da empresa",
      "destinationSource": "A partir das configurações da empresa (sede e filiais).",
      "destinationUnset": "Sem sede nem filial nas Configurações — escolha uma para este lote, ou adicione-a uma vez nas Configurações.",
      "failed": "Falha ao enviar o convite. Por favor, tente novamente.",
      "freeCheckUpHint": "Sem cobrança até você decidir patrocinar a jornada. O candidato recebe o CheckUp e você vê os resultados de MESH + iQulture na Avaliação.",
      "freeCheckUpTitle": "CheckUp gratuito · Patrocine mais tarde se quiser",
      "freeTestitHint": "Sem custo — o candidato completa apenas os testes que você escolher, e os resultados podem ser reutilizados em oportunidades futuras. Você os vê em Vetting.",
      "freeTestitTitle": "Grátis · resultados reutilizáveis",
      "next": "Avançar",
      "opportunityIntro": "Escolha o que o candidato completa e onde fica a vaga.",
      "outcomeAwaiting": "Permanecem em Aquisição até aceitarem.",
      "outcomeMixed": "{{moved}} passaram para Triagem · {{awaiting}} aguardando aceitação.",
      "partial": "{{sent}} enviados · {{failed}} falharam",
      "reviewAssessment": "Vão completar",
      "reviewDestination": "Destino",
      "reviewEmailHint": "É isto que chega na caixa de entrada.",
      "reviewRecipients": "Destinatários",
      "sending": "Enviando…",
      "singleCta": "Enviar convite",
      "singleSuccess": "Convite enviado para {{name}}",
      "singleTitle": "Enviar convite para {{name}}",
      "stepMessage": "Mensagem",
      "stepOf": "Etapa {{current}} de {{total}}",
      "stepOpportunity": "Avaliação",
      "stepReview": "Revisar e enviar",
      "workLocationLabel": "Local de trabalho",
      "workLocationPlaceholder": "Cidade, escritório ou remoto",
      "bulkCta_one": "Enviar {{count}} convite",
      "bulkCta_other": "Enviar {{count}} convites",
      "bulkRecipientCount_one": "{{count}} candidato",
      "bulkRecipientCount_other": "{{count}} candidatos",
      "bulkSuccess_one": "{{count}} convite enviado",
      "bulkSuccess_other": "{{count}} convites enviados",
      "outcomeRequested_one": "Foi pedido que compartilhe mais — nada muda até responder.",
      "outcomeRequested_other": "Foi pedido a {{count}} que compartilhem mais — nada muda até responderem.",
      "outcomeMoved_one": "Passou para Triagem.",
      "outcomeMoved_other": "{{count}} passaram para Triagem.",
      "reviewAskNotice_one": "Este talento já trabalha com você, então recebe a mensagem adequada à situação dele: um pedido para compartilhar o que já tem, ou um lembrete do que ainda falta fazer.",
      "reviewAskNotice_other": "Estes {{count}} talentos já trabalham com você, então cada um recebe a mensagem adequada à sua situação: um pedido para compartilhar o que já tem, ou um lembrete do que ainda falta fazer."
    },
    "settings": {
      "customModeActiveDesc": "Modo personalizado está ativo. Personalize suas cores na aba Cores e faça upload de ativos na aba Ativos.",
      "draftSaved": "Rascunho salvo com sucesso!",
      "fileSizeError": "O tamanho do arquivo deve ser inferior a 2MB",
      "invalidFileFormat": "Formato de arquivo inválido. Por favor, use PNG, JPG ou SVG",
      "itemRemoved": "{{title}} removido",
      "themeActivated": "Tema ativado com sucesso! Mudado para o modo Personalizado.",
      "uploadSuccess": "{{type}} enviado com sucesso!"
    },
    "shared": {
      "noPhoneCodeFound": "Nenhum código de telefone encontrado.",
      "searchPhoneCode": "Pesquisar código de telefone..."
    },
    "shell": {
      "viewportGuard": {
        "description": "Este aplicativo é otimizado para telas de desktop. Por favor, use um dispositivo com uma tela maior para a melhor experiência.",
        "hint": "Largura mínima da tela: 1024px",
        "title": "Desktop requerido"
      }
    },
    "theme": {
      "configure": "Configurar",
      "custom": "Personalizado",
      "dark": "Escuro",
      "light": "Claro",
      "system": "Sistema",
      "theme": "Tema"
    },
    "userMenu": {
      "billing": "Cobrança",
      "logout": "Sair",
      "preferences": "Preferências",
      "profile": "Perfil",
      "roleAdmin": "Admin",
      "roleMember": "Membro da equipe"
    },
    "vetting": {
      "adjustFilters": "Ajustar filtros",
      "allBadges": "Todos os distintivos",
      "allCohorts": "Todas as coortes",
      "allStatus": "Todos os status",
      "allTalents": "Todos os talentos",
      "analytics": "Análises",
      "avgIQulture": "Média iQulture",
      "badgeDistribution": "Distribuição de distintivos",
      "badgeDistributionDesc": "Quantos talentos têm cada insígnia iQulture",
      "byCohort": "Por coorte",
      "checkUpCompleted": "CheckUp concluído",
      "clearFilters": "Limpar filtros",
      "description": "Avalie talentos com o CheckUp antes de patrociná-los",
      "explain": "Explicar",
      "explainAria": "Explicar o resultado de {{name}} com o CoPilot",
      "openTalentAria": "Abrir perfil de talento para {{name}}",
      "percentDone": "{{value}}% concluído",
      "insightBodies": {
        "proInsightBody_one": "{{count}} talento obteve 80%+ no iQulture — uma prontidão excepcional para a mobilidade internacional.",
        "proInsightBody_other": "{{count}} talentos pontuaram 80%+ no iQulture, indicando uma prontidão excepcional para mobilidade internacional.",
        "potentialInsightBody_one": "{{count}} talento mostra forte potencial. Considere o QultureUp para aumentar sua pontuação.",
        "potentialInsightBody_other": "{{count}} talentos mostram forte potencial. Considere QultureUp para aumentar suas pontuações.",
        "pendingInsightBody_one": "{{count}} talento ainda não concluiu o CheckUp. Envie um lembrete para acelerar a triagem.",
        "pendingInsightBody_other": "{{count}} talentos ainda não completaram CheckUp. Envie lembretes para acelerar a avaliação."
      },
      "sponsorAria": "Patrocinar {{name}}",
      "filterByCohort": "Filtrar por coorte",
      "inVetting": "Em Triagem",
      "iqultureAssessed": "iQulture avaliado",
      "iqultureBadge": "iQulture insígnia",
      "loading": "Carregando…",
      "loadingDescription": "Carregando detalhes do talento",
      "mesh": {
        "englishNative": "Inglês",
        "hardOther": "Habilidades técnicas",
        "motivation": "Motivação",
        "notScored": "Sem pontuação",
        "softCultural": "Soft skills e cultura"
      },
      "noTalentsFound": "Nenhum talento encontrado",
      "noTalentsInVetting": "Nenhum talento em triagem",
      "noobOnly": "Somente novato",
      "notFound": "Talento não encontrado",
      "notFoundDesc": "Este talento não existe ou você não tem acesso para visualizar seu registro.",
      "pendingAction": "Ação pendente",
      "pendingCheckUp": "Pendente CheckUp",
      "percentageReadyForMobility": "Porcentagem pronto para mobilidade",
      "potential": "Potencial",
      "potentialInsight": "Insight de potencial",
      "potentialOnly": "Somente potencial",
      "proAndPotentialWithCheckUp": "Profissional e potencial com CheckUp",
      "proBadges": "Insígnias Pro",
      "proInsight": "Insight Pro",
      "proOnly": "Pro apenas",
      "readyToSponsor": "Pronto para patrocinar",
      "searchTalents": "Buscar talentos",
      "sponsor": "Patrocinador",
      "sponsorshipFunnel": "Funil de patrocínio",
      "sponsorshipFunnelDesc": "Do convite ao patrocínio, etapa por etapa",
      "sponsorshipReadyRate": "Taxa de prontidão para patrocínio",
      "statusCompleted": "Status concluído",
      "statusInProgress": "Status em andamento",
      "statusLabel": "Status",
      "statusPending": "Status pendente",
      "talentDetail": {
        "analysis": "Análise",
        "archivedReadOnly": "Esta jornada não está mais ativa. O registro é preservado para auditoria; ações não estão disponíveis.",
        "exportCsv": "Exportar CSV",
        "exportFailed": "Não foi possível exportar este relatório. Tente novamente.",
        "exportPdf": "Exportar PDF",
        "vettingCompleteReadOnly": "A avaliação está completa — este é um instantâneo somente leitura da avaliação.",
        "askCoPilot": "Pergunte sobre CoPilot",
        "confidence": "Confiança",
        "copyEmail": "Copiar e-mail",
        "copyEmailSuccess": "E-mail copiado para a área de transferência",
        "culturalRiskAnalysis": "Análise de risco cultural",
        "lowRiskCras": "CRAs de baixo risco",
        "moderateRiskCras": "CRAs de risco moderado",
        "highRiskCras": "CRAs de alto risco",
        "archetypesSeverityChip": "{{low}} baixo · {{moderate}} moderado · {{high}} alto",
        "topRisksTitle": "Principais riscos culturais",
        "topRisksDescription": "Os arquétipos Tonnie sinalizaram o maior risco de patrocínio para este candidato.",
        "topRisksEmpty": "Nenhum arquétipo de alto risco sinalizado.",
        "topRisks": {
          "severityShort": {
            "high": "Alto",
            "moderate": "Mod"
          },
          "a11yLabel": {
            "high": "Alto risco: {{score}} por cento",
            "moderate": "Risco moderado: {{score}} por cento"
          }
        },
        "meshTagline": {
          "motivation": "Por que este candidato deseja se realocar.",
          "english": "Prontidão para o idioma de trabalho.",
          "softCultural": "Adequação cultural e como eles colaboram.",
          "hardOther": "Capacidade técnica e operacional."
        },
        "pillars": {
          "spreadTitle": "Distribuição de pilares",
          "spreadDescription": "Todos os sete pilares em um radar — quanto mais próximo cada eixo chega da borda externa, mais forte é a avaliação do candidato naquele pilar.",
          "topGreenFlagsTitle": "Principais forças entre os pilares",
          "topRedFlagsTitle": "Principais preocupações entre os pilares",
          "topFlagsEmpty": "Nada sinalizado.",
          "plan90Days": {
            "title": "Plano sugerido de 90 dias",
            "description": "Sequência recomendada da Tonnie para os primeiros 90 dias após o patrocínio.",
            "empty": "Nenhum plano gerado.",
            "stepDuration": "Dia {{day}}"
          },
          "fullName": {
            "ICM": "Motivação internacional Career",
            "MA": "Adaptabilidade multicultural",
            "WMF": "Flexibilidade no modelo de trabalho",
            "CP": "Proficiência em comunicação",
            "CP_ENGLISH": "Comunicação em Inglês",
            "CP_NATIVE_TARGET": "Idioma nativo / Alvo",
            "GPE": "Experiência profissional global",
            "AR": "Prontidão acadêmica",
            "PRM": "Resiliência psicológica para mobilidade"
          }
        },
        "pitch": {
          "sentimentLabel": "Sentimento",
          "sentimentValue": {
            "positive": "Positivo",
            "neutral": "Neutro",
            "negative": "Negativo"
          },
          "deliveryMetric": {
            "communicationClarity": "Clareza na comunicação",
            "confidenceLevel": "Nível de confiança",
            "energyLevel": "Nível de energia",
            "pacing": "Ritmo",
            "articulation": "Articulação",
            "fillerWords": "Palavras de preenchimento"
          },
          "noPitchTitle": "Nenhuma apresentação registrada ainda",
          "noPitchDescription": "{{name}} ainda não gravou sua introdução de 60 segundos. Envie um lembrete para incentivá-lo — a apresentação é um dos sinais qualitativos mais fortes antes de patrocinar.",
          "pendingAnalysisTitle": "Apresentação gravada — análise em andamento",
          "pendingAnalysisDescription": "A apresentação de {{name}} foi enviada, mas o Brain ainda não terminou de analisá-la. A transcrição e os insights da IA aparecerão aqui dentro de alguns minutos.",
          "playbackMissingTitle": "Análise pronta — reprodução indisponível",
          "playbackMissingDescription": "A Tonnie tem a transcrição e análise do pitch abaixo, mas o arquivo de vídeo não pôde ser carregado no momento. Atualize em um momento para tentar novamente ou verifique o cofre do cidadão.",
          "videoOnlyTitle": "Apresentação gravada — análise pendente",
          "videoOnlyDescription": "O pitch de {{name}} está pronto para assistir acima, mas a transcrição, sentimento e análise de entrega da Tonnie ainda não estão anexadas a este CheckUp. Na maioria das vezes, isso significa que o analisador não foi executado para esta execução — reative-o abaixo para preencher os sinais ausentes.",
          "rerunAnalysis": "Reexecutar análise da apresentação",
          "rerunAnalysisInProgress": "Reexecutando análise da apresentação…",
          "rerunAnalysisError": "Não foi possível reexecutar a análise da apresentação",
          "videoFallback": "Seu navegador não consegue reproduzir este formato de vídeo.",
          "duration": "Duração: {{value}}",
          "recordedAt": "Gravado em {{date}}",
          "statusReady": "Pronto para revisão",
          "statusAnalyzing": "Analisando",
          "statusPending": "Aguardando upload",
          "statusFailed": "Análise falhou",
          "statusEstimated": "Estimativa",
          "failedTitle": "Não foi possível analisar o pitch",
          "failedDescription": "A gravação de {{name}} não produziu análise. Nada nesta aba é uma avaliação dela.",
          "heuristicTitle": "Estes sinais são estimativas, não uma análise de IA",
          "heuristicDescription": "A análise de IA não estava disponível, então o sentimento e as métricas de apresentação abaixo vêm de uma heurística simples baseada na contagem de palavras. Não baseie uma decisão nelas — execute a análise novamente.",
          "failedReason": {
            "noInput": "A análise foi executada sem gravação. Execute a análise novamente.",
            "videoNotFound": "Nenhuma gravação de {{name}} foi encontrada no armazenamento.",
            "storageFetchFailed": "Não foi possível ler a gravação do armazenamento. Execute a análise novamente.",
            "serviceComponentMissing": "Falta ao serviço de análise um componente necessário. Nossa equipe foi alertada — execute a análise novamente quando for corrigido.",
            "noAudioTrack": "A gravação não tem som. Peça a {{name}} para gravar novamente com o microfone ligado.",
            "unreadableRecording": "Não foi possível decodificar o formato da gravação. Peça a {{name}} para gravar novamente.",
            "timedOut": "O processamento da gravação demorou demais. Execute a análise novamente.",
            "noSpeech": "Nenhuma fala foi detectada na gravação. Peça a {{name}} para gravar novamente.",
            "serviceRejected": "O serviço de transcrição recusou a gravação. Nossa equipe foi alertada.",
            "serviceUnavailable": "O serviço de transcrição estava indisponível. Execute a análise novamente.",
            "internalError": "Um erro inesperado interrompeu a análise. Nossa equipe foi alertada.",
            "unrecorded": "Este resultado foi produzido antes de os motivos de falha serem registrados. Execute a análise novamente para saber o motivo."
          },
          "heuristicReason": {
            "modelUnavailable": "Motivo: nenhum modelo de IA estava configurado para a análise.",
            "invalidResponse": "Motivo: não foi possível usar a resposta da IA.",
            "serviceRejected": "Motivo: o serviço de IA recusou a solicitação.",
            "serviceUnavailable": "Motivo: o serviço de IA estava indisponível.",
            "unrecorded": "Motivo: não registrado — este resultado é anterior a esse registro."
          }
        },
        "skills": {
          "softHardCombinedTitle": "Principais habilidades suaves e duras",
          "softHardCombinedDescription": "O perfil de cada lista num relance e, abaixo, cada habilidade ordenada pela pontuação de força, com o nível em que a Tonnie a classificou. O número de cada eixo é a sua linha.",
          "additionalSkillsTitle": "Habilidades adicionais",
          "additionalSkillsDescription": "Capacidades além da lista de principais habilidades suaves/duras, classificadas por pontuação de poder.",
          "additionalSkillsEmpty": "Nenhuma habilidade adicional identificada.",
          "softEmpty": "Nenhuma habilidade interpessoal surgiu até agora — a análise da Tonnie não retornou um conjunto de habilidades principais para este candidato.",
          "hardEmpty": "Nenhuma habilidade técnica surgiu até agora — a análise da Tonnie não retornou um conjunto de habilidades principais para este candidato.",
          "softShapeLabel": "Perfil das principais habilidades interpessoais, eixos numerados por posição — {{summary}}",
          "hardShapeLabel": "Perfil das principais habilidades técnicas, eixos numerados por posição — {{summary}}"
        },
        "deliveryMetrics": "Métricas de entrega",
        "drawerDescription": "Revisão da avaliação para {{name}} — progresso do CheckUp, dados do perfil e ações administrativas.",
        "evaluationPillars": "Pilares de avaliação",
        "evaluationPillarsDesc": "Pontuação por pilar, confiança e evidência — o histórico de auditoria por trás do veredicto {{name}}'s iQulture.",
        "evidenceLabel": "Evidência",
        "greenFlags": "Sinais verdes",
        "hideDetails": "Ocultar detalhes",
        "interviewFirst": "Entrevista primeiro",
        "interviewConfirmTitle": "Enviar convite para entrevista?",
        "interviewConfirmDescription": "A Tonnie enviará um convite para entrevista pré-patrocínio para {{name}}. Você pode retirar mais tarde, mas o e-mail será enviado imediatamente.",
        "interviewConfirmCancel": "Cancelar",
        "interviewConfirmAction": "Enviar convite",
        "lastSeenAgo_one": "Visto pela última vez há {{count}} dia",
        "lastSeenAgo_other": "Visto pela última vez há {{count}} dias",
        "lastSeenToday": "Visto hoje",
        "menuLabel": "Mais ações",
        "messageSendError": "Não conseguimos enviar a mensagem. Por favor, tente novamente.",
        "messageSent": "Mensagem enviada para {{name}}",
        "messageSentDescription": "Está a caminho — você verá no registro de mensagens em breve.",
        "meshAnalysis": "Análise MESH",
        "meshAnalysisDesc": "Como {{name}} se sai nas quatro bases sobre as quais todo patrocínio confiante é construído.",
        "neverSeen": "Ainda não abriu o aplicativo",
        "calculating": {
          "title": "A pontuação do CheckUp está sendo calculada",
          "description": "A nova pontuação de {{name}} aparece aqui assim que o cálculo terminar."
        },
        "noneIdentified": "Nenhum identificado",
        "pitchVideoAnalysis": "Análise de vídeo de pitch",
        "pitchVideoDesc": "{{name}}'s pitch de 60 segundos — transcrição, sentimento e métricas de entrega em suas próprias palavras.",
        "recommendations": "Recomendações",
        "redFlags": "Sinais de alerta",
        "reminderSendError": "Não conseguimos enviar o lembrete. Por favor, tente novamente.",
        "reminderSent": "Lembrete enviado para {{name}}",
        "reminderSentDescription": "{{name}} receberá um lembrete por e-mail para completar o CheckUp.",
        "reminderTemplateMissing": "O modelo de lembrete do CheckUp ainda não foi configurado. Visite Mensagens para criá-lo.",
        "sendMessage": "Enviar mensagem",
        "sendMessageDescription": "Personalize o assunto e a mensagem antes de enviar — o talento recebe como um e-mail.",
        "sendMessageTitle": "Enviar uma mensagem",
        "sendNow": "Enviar agora",
        "sendReminder": "Enviar lembrete",
        "sending": "Enviando…",
        "showDetails": "Mostrar detalhes",
        "sponsoredDrawerDescription": "Monitoramento de talentos patrocinados para {{name}} — progresso do herói, evidências e ações administrativas.",
        "sponsorJourney": "Jornada do patrocinador",
        "sponsorship": {
          "cancelTitle": "Cancelar patrocínio?",
          "cancelLoading": "Calculando o valor do reembolso…",
          "cancelDescription": "A Tonnie reembolsará {{refundAmount}} ({{monthsRemaining}} de {{durationMonths}} meses restantes) e a jornada de {{name}} reverterá para acesso básico. Esta ação não pode ser desfeita.",
          "cancelNoRefundDescription": "Este patrocínio não tem saldo reembolsável — a janela total de {{durationMonths}} meses foi consumida. Cancelar reverterá a jornada de {{name}} para acesso básico sem reembolso.",
          "cancelKeep": "Manter patrocínio",
          "cancelAction": "Cancelar e reembolsar {{refundAmount}}",
          "cancelNoRefund": "Cancelar patrocínio (sem reembolso)",
          "cancelSuccess": "Patrocínio cancelado — {{amount}} reembolsados para seu cartão.",
          "cancelFailed": "Não foi possível cancelar o patrocínio agora."
        },
        "tagsHint": "Dica: começar a partir de um modelo preenche automaticamente o nome e outros detalhes do talento. Mensagens personalizadas são enviadas como estão.",
        "waitingDays_one": "Aguardando {{count}}d",
        "waitingDays_other": "Aguardando {{count}}d",
        "waitingOverdue_one": "{{count}}d atrasado",
        "waitingOverdue_other": "{{count}}d atrasado",
        "phase": {
          "adaptation": {
            "awaiting": {
              "description": "QultureUp está desbloqueado. {{name}} ainda não começou nenhuma missão de preparação cultural.",
              "title": "Aguardando a primeira atividade"
            },
            "locked": {
              "description": "QultureUp ativa após {{name}} ser patrocinado. As missões de preparação cultural são construídas automaticamente com base no destino.",
              "title": "A adaptação é desbloqueada após o patrocínio"
            }
          },
          "action": {
            "careIntervention": "Intervenção Care",
            "sendReminder": "Enviar lembrete",
            "viewKit": "Ver kit"
          },
          "care": {
            "awaiting": {
              "description": "Care está desbloqueado. {{name}} ainda não registrou um check-in — um lembrete gentil pode ajudar.",
              "title": "Aguardando o primeiro check-in"
            },
            "locked": {
              "description": "Care ativa após {{name}} ser patrocinado. O programa de bem-estar é construído em torno de sua adaptação.",
              "title": "Care desbloqueia após o patrocínio"
            }
          },
          "checkup": {
            "awaiting": {
              "description": "{{name}} aceitou o convite, mas ainda não começou CheckUp. Um lembrete geralmente os incentiva a começar.",
              "title": "CheckUp ainda não iniciado"
            },
            "locked": {
              "description": "CheckUp ativa assim que {{name}} aceita o convite e uma jornada é criada.",
              "title": "CheckUp ainda não ativado"
            },
            "inProgress": {
              "title": "CheckUp em andamento",
              "description": "{{name}} está fazendo o CheckUp — {{done}} de {{total}} etapas concluídas."
            },
            "awaitingScore": {
              "title": "CheckUp enviado",
              "description": "{{name}} concluiu o CheckUp. Estamos calculando a pontuação iQulture."
            }
          },
          "evidence": {
            "awaiting": {
              "description": "Nenhum carimbo de passaporte ainda. Carimbos e milhas se acumulam à medida que {{name}} avança pelos heróis.",
              "title": "Aguardando os primeiros marcos"
            },
            "locked": {
              "description": "Passport ativa após o patrocínio. Marcos de cada herói ganham selos automaticamente.",
              "title": "A evidência é desbloqueada após o patrocínio"
            }
          },
          "mobility": {
            "awaiting": {
              "description": "O kit TelePortal está pronto. {{name}} ainda não começou nenhuma tarefa.",
              "title": "Aguardando a primeira atividade"
            },
            "locked": {
              "description": "O TelePortal construirá automaticamente um kit de realocação personalizado assim que {{name}} for patrocinado.",
              "title": "A mobilidade é desbloqueada após o patrocínio"
            }
          }
        },
        "phaseStrip": {
          "scrollNext": "Mostrar próximas fases",
          "scrollPrevious": "Mostrar fases anteriores",
          "sponsored": {
            "accepted": "Aceito",
            "ariaLabel": "Fase de patrocínio",
            "offered": "Oferecido",
            "sponsored": "Patrocinado",
            "thriving": "Prosperando"
          },
          "vetting": {
            "ariaLabel": "Fase de verificação",
            "invited": "Convidado",
            "scored": "Pontuado",
            "started": "Iniciado",
            "submitted": "Enviado",
            "verdict": "Veredicto"
          }
        },
        "summary": "Resumo",
        "topHardSkills": "Principais habilidades técnicas",
        "topSoftSkills": "Principais habilidades interpessoais",
        "transcript": "Transcrição",
        "citizenAccountDeletedTitle": "Conta Citizen excluída",
        "citizenAccountDeletedBody": "Este candidato excluiu sua conta Tonnie. Seu perfil + atividade são preservados em forma somente leitura para seus registros; nenhuma ação adicional pode ser tomada.",
        "interviewInvitationQueued": "Solicitação de entrevista enfileirada para {{name}}. E-mail enviado; integração com o corretor ATS pendente.",
        "interviewInvitationFailed": "Falha ao enviar solicitação de entrevista. Tente novamente.",
        "scoreEstimate": {
          "title": "Partes desta pontuação são estimativas, não medições",
          "pitchFailed": "Pitch: não analisado — a pontuação foi calculada sem ele.",
          "pitchHeuristic": "Apresentação do pitch (Motivação): estimada a partir da contagem de palavras — a análise de IA não estava disponível.",
          "pillarsM": "Motivação: alguns pilares foram estimados com um método simplificado — a avaliação de IA não estava disponível.",
          "pillarsE": "Inglês: alguns pilares foram estimados com um método simplificado — a avaliação de IA não estava disponível.",
          "pillarsS": "Competências interpessoais e culturais: alguns pilares foram estimados com um método simplificado — a avaliação de IA não estava disponível.",
          "pillarsH": "Competências técnicas: alguns pilares foram estimados com um método simplificado — a avaliação de IA não estava disponível."
        },
        "languages": {
          "title": "Idiomas",
          "none": "Ainda sem resultado de idioma."
        },
        "leftProgrammeTitle": "Saiu do seu programa em {{date}}",
        "leftProgrammeBody": "A relação terminou, então este registro é somente leitura e o que ele compartilhou não está mais visível. Envie um novo convite para voltar a trabalhar com ele — ele decide se aceita."
      },
      "title": "Verificação",
      "topCandidates": "Principais candidatos",
      "topCandidatesDescription": "As pontuações mais fortes, prontas para patrocínio",
      "topPick": "Escolha principal",
      "totalCandidates": "Total de candidatos",
      "viewPending": "Ver pendentes",
      "viewPotentialTalents": "Ver talentos potenciais",
      "viewProTalents": "Ver talentos profissionais",
      "completed": "Completo",
      "badge": {
        "pro": "PRO",
        "potential": "POTENCIAL",
        "noob": "NOOB",
        "pending": "Pendente CheckUp"
      },
      "talentsCount_one": "{{count}} talento",
      "talentsCount_other": "{{count}} talentos",
      "readyOfTotal": "{{completed}} de {{total}} pronto",
      "talentRowActionsAria": "Ações para {{name}}",
      "testitCandidates": "Candidatos TestIt",
      "readyCount_one": "{{count}} pronto",
      "readyCount_other": "{{count}} prontos"
    },
    "invitationDetail": {
      "acceptedAt": "Aceito",
      "accessibleDescription": "Status do convite: {{status}}",
      "accessibleDescriptionLoading": "Carregando detalhes do convite",
      "accessibleTitle": "Detalhes do convite",
      "acquisitionEyebrow": "Aquisição",
      "assessment": "Avaliação",
      "branch": "Filial",
      "createdAt": "Criado",
      "delete": "Excluir",
      "destination": "Destino",
      "email": "Email",
      "errorDescription": "O convite pode ter sido excluído ou o servidor está inacessível.",
      "errorTitle": "Não foi possível carregar o convite",
      "expiresAt": "Expira",
      "historyTitle": "Histórico",
      "name": "Nome",
      "noHistory": "Nenhuma alteração de status registrada.",
      "opportunityTitle": "Oportunidade",
      "recipientTitle": "Destinatário",
      "resend": "Reenviar",
      "resendHint": "Reenviar regenerará o token e redefinirá a expiração.",
      "revoke": "Revogar",
      "scenario": "Cenário",
      "scenarioValue": {
        "pre_immigration": "Pré-imigração",
        "already_abroad": "Já no exterior",
        "relocation_only": "Realocação apenas",
        "integration_only": "Integração apenas"
      },
      "send": "Enviar convite",
      "sentAt": "Enviado",
      "status": {
        "draft": "Rascunho",
        "pending": "Aceitação pendente",
        "accepted": "Aceito",
        "expired": "Expirado",
        "revoked": "Revogado",
        "declined": "Recusado",
        "email_queued": "E-mail na fila",
        "email_skipped": "E-mail ignorado",
        "email_failed": "E-mail não enviado",
        "email_sent": "E-mail enviado",
        "email_delivered": "Entregue",
        "email_opened": "Aberto",
        "email_clicked": "Link clicado",
        "email_bounced": "Devolvido",
        "landed": "Abriu a página do convite",
        "email_mismatch": "A conta conectada não corresponde",
        "matched_signup": "Cadastrou-se na Tonnie",
        "deferred": "Adiado pelo candidato",
        "email_reminded": "Lembrete enviado",
        "claimed": "Assumido a partir de outra conta"
      },
      "tokenPreview": "Pré-visualização do token",
      "tokenTitle": "Token e expiração",
      "workLocation": "Local de trabalho",
      "reason": {
        "deleted_sentinel": "Não enviado — o destinatário excluiu sua conta Tonnie.",
        "email_mismatch": "Estava conectado com uma conta diferente.",
        "email_unverified": "O endereço está na conta mas ainda não foi verificado.",
        "expired": "O convite já havia expirado.",
        "expiry_sweep": "Expirou sem resposta.",
        "jit": "Detectado no primeiro login.",
        "lazy_expire_on_open": "Já estava fora do prazo quando a página foi aberta.",
        "matched_signup_unaccepted": "Expirou embora esta pessoa já esteja na Tonnie — reenviar tem boas chances de alcançá-la.",
        "ok": "O convite estava aberto e pronto para ser aceito.",
        "onboarding": "Detectado durante o onboarding.",
        "opted_out": "Não enviado — o destinatário optou por não receber e-mails.",
        "revoked": "O convite já havia sido revogado.",
        "webhook": "Detectado quando a conta foi criada."
      },
      "byActor": "por {{name}}",
      "hasAccountChip": "Cadastrou-se, não aceitou",
      "resendNudge": "Esta pessoa já tem conta Tonnie — reenviar tem boas chances de alcançar alguém que consegue entrar imediatamente.",
      "resendPromoted": "Reenviar convite",
      "candidateRole": "Função",
      "candidateLocation": "Localização",
      "candidateSkills": "Habilidades",
      "inviteAgain": "Convidar novamente",
      "closed": {
        "declinedTitle": "Recusou o convite em {{when}}",
        "expiredTitle": "O convite expirou em {{when}}",
        "body": "Convide novamente para enviar um novo e-mail com um link novo, ou exclua o convite para tirá-lo do seu pipeline."
      }
    },
    "talentRowMenu": {
      "viewDetails": "Ver detalhes",
      "sendInvitation": "Enviar convite",
      "resendInvitation": "Reenviar convite",
      "revoke": "Revogar",
      "delete": "Excluir",
      "sponsorJourney": "Patrocinar a jornada",
      "askCoPilot": "Pergunte sobre CoPilot",
      "askTonnieServices": "Pergunte sobre os serviços Tonnie",
      "inviteAgain": "Convidar novamente"
    },
    "vettingPage": {
      "activeTab": "Ativo",
      "archivedTab": "Arquivado"
    },
    "motivationalForm": {
      "questionCard": {
        "required": "Requerido",
        "optional": "Opcional",
        "maxCharsHint_one": "Máx. {{max}} caractere • Responda apenas em inglês",
        "maxCharsHint_other": "Máx. {{max}} caracteres • Responda apenas em inglês",
        "answerLabel": "Sua resposta",
        "answerPlaceholder": "Escreva sua resposta aqui em inglês…",
        "answerPlaceholderOptional": "Escreva sua resposta aqui em inglês… (opcional)",
        "noComment": "Sem comentários",
        "optionalHint": "Pergunta opcional – você pode deixá-la em branco.",
        "validationComment": "Comentário de validação:"
      }
    },
    "quickEdit": {
      "companyPlaceholder": "Acme Corporation, Inc.",
      "taxIdPlaceholder": "EIN, VAT ou ID fiscal nacional"
    },
    "additionalDetails": {
      "languagePlaceholder": "Inglês"
    },
    "acceptInvite": {
      "notFound": "Convite não encontrado",
      "failedToLoad": "Falha ao carregar convite",
      "failedToAccept": "Falha ao aceitar convite",
      "roleAdmin": "Admin",
      "roleTeamMember": "Membro da equipe",
      "invalidLink": "Link de convite inválido. Nenhum token fornecido.",
      "goToLogin": "Ir para login",
      "welcomeTo": "Bem-vindo ao {{company}}!",
      "joinedAs": "Você se juntou como {{role}}. Redirecionando para o painel...",
      "expiredTitle": "Convite expirado",
      "expiredBody": "Este convite para se juntar ao {{company}} expirou. Por favor, peça ao administrador da equipe para enviar um novo convite.",
      "alreadyTitle": "Já aceito",
      "alreadyBody": "Este convite já foi aceito.",
      "title": "Convite para a equipe",
      "joinCompany": "Junte-se à {{company}}",
      "invitedAsRole": "Você foi convidado a se juntar como {{role}}",
      "signedInAs": "Conectado como {{email}}",
      "accepting": "Aceitando...",
      "accept": "Aceitar convite",
      "emailMismatch": "Este convite foi enviado para {{invited}}, mas você está logado como {{current}}. Por favor, saia e faça login com o endereço de e-mail correto.",
      "invitedToJoin": "Você foi convidado a se juntar à {{company}}",
      "joinAsRole": "Junte-se como {{role}}",
      "invitationSentTo": "Convite enviado para {{email}}",
      "signUpOrLogIn": "Cadastre-se ou faça login para aceitar este convite e se juntar à equipe.",
      "haveAccount": "Já tem uma conta? Fazer Login",
      "emailUnverified": "Verifique {{email}} na sua conta e depois aceite o convite novamente."
    },
    "weeklySummary": {
      "title": "Resumo semanal",
      "insightsFor": "Insights gerados por IA para {{period}}",
      "keyAchievements": "Principais conquistas",
      "areasNeedingAttention": "Áreas precisando de atenção",
      "trends": "Tendências",
      "insights": "Insights",
      "viewFullReport": "Ver relatório completo"
    },
    "nextBestActions": {
      "title": "Próximas melhores ações",
      "empty": "Nenhuma ação requer atenção imediata. Ótimo trabalho!",
      "explainCopilot": "Recomendações impulsionadas por IA para seus programas de mobilidade",
      "pipelineCopilot": "Recomendações impulsionadas por IA alinhadas ao seu pipeline",
      "categoryCheckup": "CheckUp pendente",
      "categorySponsorship": "Decisão de patrocínio",
      "categoryMobility": "Bloqueador de mobilidade",
      "categoryCare": "Ponto de verificação Care",
      "categoryRisk": "Sinal de risco",
      "urgency": {
        "high": "alto",
        "medium": "médio",
        "low": "baixo"
      },
      "reason": "Razão: {{reason}}",
      "explain": "Explicar"
    },
    "iqultureBadge": {
      "pending": "Pendente",
      "description": {
        "pro": "Prontidão excepcional para oportunidades internacionais",
        "potential": "Forte potencial com espaço para crescimento",
        "noob": "Iniciando a jornada de prontidão",
        "noBadge": "CheckUp ainda não concluído"
      },
      "corporateInsight": {
        "pro": "Talento de alto nível pronto para mobilidade imediata",
        "potential": "Candidato forte — considere com plano de preparação",
        "noob": "Estágio inicial — monitore o progresso via QultureUp",
        "noBadge": "Aguardando avaliação de iQulture"
      }
    },
    "routeFlags": {
      "srLabel": "{{origin}} para {{destination}}"
    },
    "inviteMessage": {
      "bodyHint": "Edite livremente. As etiquetas são preenchidas por destinatário — a pré-visualização mostra o resultado.",
      "editingSource": "Você está editando a mensagem apenas para este envio. O modelo do tenant não muda.",
      "linkPresent": "Link de aceitação presente",
      "linkRequired": "Mantenha o link de aceitação — sem ele o candidato não tem como começar."
    },
    "attentionReason": {
      "invitation_never_sent": "Convite nunca enviado",
      "invitation_bounced": "E-mail rejeitado — verifique o endereço",
      "invitation_expired": "Convite expirado",
      "signed_up_not_accepted": "Cadastrou-se mas não aceitou — reenviar",
      "invite_ignored": "Sem resposta há {{days}} dias",
      "onboarding_stalled": "Perfil incompleto há {{days}} dias",
      "checkup_never_requested": "CheckUp nunca solicitado",
      "checkup_never_started": "CheckUp não iniciado há {{days}} dias",
      "checkup_stalled": "CheckUp parado há {{days}} dias",
      "scoring_stalled": "Cálculo atrasado há {{days}} dias",
      "awaiting_company_review": "Aguardando sua análise há {{days}} dias",
      "testit_awaiting_review": "Testes concluídos — aguardando seu parecer",
      "citizen_left": "Candidato saiu da plataforma",
      "mobility_track_blocked": "Patrocinado mas sem trilha iniciada",
      "sponsorship_offer_unanswered": "Oferta de patrocínio sem resposta há {{days}} dias",
      "checkup_not_shared": "Resultado do CheckUp não compartilhado há {{days}} dias",
      "sharing_withdrawn": "Compartilhamento retirado há {{days}} dias",
      "academyStalled": "Sem progresso na Languages Academy há {{days}} dias",
      "academyGoalReached": "Alcançou a meta do curso na Languages Academy"
    },
    "companyProfile": {
      "industry": {
        "technology": "Tecnologia",
        "healthcare": "Saúde",
        "finance": "Finanças",
        "manufacturing": "Manufatura",
        "retail": "Varejo",
        "hospitality": "Hotelaria e restaurantes",
        "construction": "Construção",
        "education": "Educação",
        "consulting": "Consultoria",
        "logistics": "Logística",
        "energy": "Energia",
        "telecommunications": "Telecomunicações",
        "mediaEntertainment": "Mídia e entretenimento",
        "realEstate": "Imobiliário",
        "other": "Outra"
      },
      "roleType": {
        "engineering": "Engenharia",
        "product": "Produto",
        "design": "Design",
        "dataScience": "Ciência de dados",
        "devops": "DevOps e infraestrutura",
        "marketing": "Marketing",
        "sales": "Vendas",
        "customerSuccess": "Sucesso do cliente",
        "finance": "Finanças",
        "hrPeople": "Recursos humanos",
        "operations": "Operações",
        "executive": "Diretoria e liderança",
        "other": "Outra"
      },
      "employeesRange": "{{range}} funcionários",
      "hiresRange": "{{range}} contratações por ano",
      "openLinkedIn": "Abrir perfil ↗"
    },
    "lifecycleStatus": {
      "draft": "Rascunho",
      "active": "Em andamento",
      "paused": "Pausado",
      "completed": "Concluído",
      "archived": "Arquivado"
    },
    "taskPriority": {
      "high": "Alta prioridade"
    },
    "iqulture": {
      "provisional": {
        "label": "Provisório",
        "tooltip": "Faltam alguns dados deste talento, por isso a pontuação é o mínimo possível. Com os dados completos, pode chegar a {{max}}."
      }
    },
    "shareRequest": {
      "badge": {
        "pendingCheckup": "CheckUp pedido — aguardando o talento",
        "pendingTests": "Mais testes pedidos — aguardando o talento",
        "declinedCheckup": "Pedido de CheckUp recusado · {{date}}",
        "declinedTests": "Pedido de testes recusado · {{date}}",
        "pendingTooltip": "Pedido em {{date}}. Nada mais é compartilhado até o talento responder.",
        "declinedTooltip": "Você vê o que o talento compartilhou antes. Pode pedir de novo mais tarde."
      },
      "notice": {
        "pendingCheckupTitle": "CheckUp pedido — aguardando o talento",
        "pendingTestsTitle": "Mais testes pedidos — aguardando o talento",
        "pendingBody": "Pedido em {{date}}. Nada mais é compartilhado até responderem — você continua vendo o que aceitaram antes.",
        "declinedCheckupTitle": "O talento recusou seu pedido para ver o CheckUp",
        "declinedTestsTitle": "O talento recusou seu pedido de mais testes",
        "declinedBody": "Recusado em {{date}}. Nada mudou: você vê o que compartilharam antes. Pode pedir de novo mais tarde."
      }
    },
    "inoutOperations": {
      "title": "Operação InOut",
      "subtitle": "Os tickets InOut das assessorias. Só para a equipe Tonnie — cada acesso fica registrado.",
      "tabs": {
        "cases": "Tickets",
        "files": "Arquivos da assessoria",
        "reconciliation": "Reconciliação",
        "portals": "Portais"
      },
      "loading": "Carregando…",
      "loadError": "Não foi possível carregar. Tente de novo.",
      "cases": {
        "empty": "Ainda não há tickets.",
        "caseRef": "Ticket",
        "agency": "Assessoria",
        "state": "Status",
        "opened": "Aberto em",
        "consultations": "Consultas pagas",
        "requisition": "Requisição",
        "noRequisition": "Nenhuma",
        "refunds": "Reembolsos pedidos",
        "lastEvent": "Último evento",
        "noEvent": "Ainda nenhum",
        "open": "Abrir"
      },
      "detail": {
        "title": "Ticket {{caseRef}}",
        "recorded": "A abertura deste ticket fica registrada.",
        "person": "Pessoa",
        "personWithheld": "Não mostrada — a pessoa não tem um consentimento em vigor para a assessoria.",
        "consultations": "Consultas",
        "noConsultations": "Nenhuma consulta.",
        "requisition": "Requisição",
        "paid": "{{amount}} pagos · {{credit}} de crédito aplicado",
        "credit": "Crédito disponível: {{amount}}",
        "events": "Eventos",
        "noEvents": "Ainda nenhum evento.",
        "refunds": "Pedidos de reembolso",
        "noRefunds": "Nenhum pedido de reembolso.",
        "markHandled": "Reembolsado no Stripe — marcar tratado",
        "links": "Links do dossiê",
        "noLinks": "Ainda nenhum dossiê enviado.",
        "linkRevoked": "Revogado — o consentimento foi retirado",
        "loadingTitle": "Ticket",
        "handled": "Pedido de reembolso marcado como tratado.",
        "handleFailed": "Não foi possível marcar o pedido de reembolso como tratado. Tente novamente.",
        "linkSent": "Enviado em {{date}}",
        "linkValidUntil": "Válido até {{date}}",
        "linkOpens_one": "Aberto uma vez",
        "linkOpens_other": "Aberto {{opens}} vezes"
      },
      "event": {
        "title": "Registrar um evento da assessoria",
        "code": "Evento",
        "note": "Nota",
        "noNote": "Sem nota",
        "when": "Quando aconteceu",
        "submit": "Registrar",
        "done": "Evento registrado",
        "refused": "O evento não serve para este ticket — confira o código ou se o ticket está encerrado.",
        "failed": "Não foi possível registrar o evento. Tente de novo.",
        "whenRequired": "Informe quando aconteceu.",
        "codeRequired": "Escolha o evento."
      },
      "files": {
        "agency": "Assessoria",
        "noAgency": "Ainda nenhuma assessoria tem tickets.",
        "choose": "Escolha o arquivo da assessoria (CSV, formato v1)",
        "readFailed": "Não foi possível ler o arquivo.",
        "tooBig": "O arquivo é maior do que a operação lê.",
        "browserPreview": "O que o seu navegador leu",
        "serverReport": "A verificação do servidor",
        "line": "Linha",
        "event": "Evento",
        "when": "Quando",
        "outcome": "Resultado",
        "problems": "Problemas",
        "check": "Verificar e guardar o arquivo",
        "fixFirst": "Corrija primeiro os problemas do arquivo — um arquivo carrega inteiro ou não carrega.",
        "load": "Carregar o arquivo",
        "loaded": "Arquivo carregado",
        "closed": "Este arquivo não pode ser carregado — foi recusado, já foi carregado ou a verificação expirou.",
        "failed": "Não funcionou. Tente de novo.",
        "history": "Arquivos recebidos",
        "noHistory": "Ainda nenhum arquivo recebido.",
        "received": "Recebido",
        "fileName": "Arquivo",
        "rows": "Linhas",
        "state": "Status"
      },
      "reconciliation": {
        "month": "Mês",
        "empty": "Nada foi pago neste mês.",
        "problem": "A base sem IVA não pode ser calculada agora.",
        "agency": "Assessoria",
        "charged": "Cobrado (com IVA)",
        "refunded": "Reembolsado",
        "net": "Base sem IVA",
        "share": "Parte da assessoria",
        "notYet": "Ainda não — um pagamento não tem linha de IVA",
        "payments": "Pagamentos",
        "documentsMissing": "Documentos não emitidos",
        "cases": "Tickets"
      },
      "portals": {
        "intro": "Os sites onde a calculadora InOut funciona — o da Tonnie e os dos parceiros. A calculadora de um portal em rascunho não carrega.",
        "empty": "Ainda não há portais.",
        "new": "Novo portal",
        "code": "Código",
        "name": "Nome",
        "status": "Status",
        "origins": "Sites autorizados",
        "updated": "Atualizado",
        "edit": "Editar",
        "statusDraft": "Rascunho",
        "statusActive": "Ativo",
        "originsCount_one": "{{count}} site",
        "originsCount_other": "{{count}} sites",
        "newTitle": "Novo portal",
        "editTitle": "Portal {{code}}",
        "description": "O que a calculadora mostra neste portal, quais sites podem incorporá-la e como ela aparece. Uma alteração salva chega à calculadora na próxima vez que ela carregar.",
        "codeHint": "Letras maiúsculas, números e _ — as páginas do portal o chamam assim (data-portal). Não pode mudar depois.",
        "active": "Ativo — a calculadora carrega neste portal",
        "nameHint": "Aparece no cabeçalho da calculadora.",
        "nameGender": "Como se diz o nome",
        "nameGenderFeminine": "Feminino — «na Tonnie», «na Ei!»",
        "nameGenderMasculine": "Masculino — «no portal»",
        "nameGenderHint": "O gênero do nome em português: o cadastro diz que o cálculo foi feito «na Tonnie», «na Ei!» ou «no portal».",
        "website": "Site",
        "logo": "Logotipo",
        "logoHint": "Opcional — um endereço https://, ou uma imagem servida pela calculadora (/assets/partners/…). Exibido com 32 px de altura: um logotipo horizontal ou um símbolo quadrado.",
        "originsHint": "Os sites autorizados a incorporar a calculadora, cada um como https://host. Um portal ativo precisa de pelo menos um.",
        "originPlaceholder": "https://www.exemplo.com",
        "addOrigin": "Adicionar",
        "removeOrigin": "Remover {{origin}}",
        "country": "Começa em",
        "countryNone": "O visitante escolhe",
        "language": "Idioma",
        "languageNone": "O do visitante",
        "partner": "Assessoria",
        "partnerNone": "Nenhuma",
        "partnerDraft": "{{name}} (rascunho)",
        "look": "Aparência",
        "customTheme": "Usar as cores do portal",
        "accent": "Cor de ação",
        "accentForeground": "Texto sobre a cor de ação",
        "pageColours": "Usar as cores de página do portal",
        "background": "Página",
        "foreground": "Texto sobre a página",
        "radius": "Cantos",
        "radiusNone": "Retos",
        "radiusSm": "Leves",
        "radiusMd": "Médios",
        "radiusLg": "Arredondados",
        "radiusXl": "Redondos",
        "font": "Fonte",
        "fontSystem": "A do dispositivo",
        "contrast": "Contraste {{ratio}}:1",
        "contrastOk": "Legível",
        "contrastLow": "Baixo demais — pelo menos 4,5:1",
        "preview": "Pré-visualização",
        "embed": "Colocar no portal",
        "embedHint": "Cole isto nas páginas do portal: o botão abre a calculadora em uma janela; o bloco vazio a mostra na página.",
        "copy": "Copiar",
        "copied": "Copiado",
        "saved": "Portal salvo.",
        "failed": "Não foi possível salvar o portal. Tente novamente.",
        "refused": "Alguns valores foram recusados — verifique os campos.",
        "partnerUnknown": "Essa assessoria não está no registro de parceiros.",
        "copyFailed": "O navegador não permitiu copiar. Selecione o código abaixo e copie."
      }
    }
  },
  "capture": {
    "uploadFailedDefault": "Upload falhou. Por favor, tente novamente."
  },
  "care": {
    "additionalComments": "Comentários adicionais (opcional)",
    "allStatuses": "Todos os status",
    "alreadyCheckedIn": "Já fez check-in hoje",
    "appOnlyNotice": {
      "message": "Este painel é sua visão geral somente leitura. Abra o aplicativo Tonnie para registrar seu humor, realizar check-ins rápidos e completar pontos de verificação.",
      "title": "Check-ins diários acontecem no aplicativo"
    },
    "askCopilotAboutThis": "Pergunte sobre CoPilot isso",
    "askCopilotFirst": "Pergunte sobre CoPilot cérebro primeiro",
    "assessedOn": "Avaliado em {{date}}",
    "assessment": {
      "completeTitle": "Avaliação completa",
      "completed": "Completo",
      "gateTitle": "Avaliação Care",
      "loading": "Carregando avaliação…",
      "redirecting": "Redirecionando…",
      "retake": "Refazer avaliação",
      "saving": "Salvando…",
      "subtitle": "Um breve check-in para avaliar como você está se adaptando. Leva cerca de 5 minutos.",
      "title": "Avaliação Care"
    },
    "assessmentEstimatedTime": "Cerca de 5 minutos",
    "assessmentInfoDescription": "Suas respostas ajudam Care a personalizar check-ins, sugerir recursos locais e oferecer suporte quando você precisar.",
    "assessmentInfoIntro": "Faremos algumas perguntas sobre seu bem-estar em saúde, finanças e comunidade.",
    "baseline": {
      "anxiety": "Ansiedade atual sobre a realocação",
      "concerns": "Principais áreas de preocupação",
      "desc": "Selecione a opção que melhor descreve seu estado emocional atual.",
      "familyConfidence": "Confiança sobre a adaptação da família",
      "minimal": "Minimalista",
      "notConfident": "Não confiante",
      "selectMultiple": "selecione todas que se aplicam",
      "significant": "Significativo",
      "supportNeed": "Quanto suporte você acha que precisará?",
      "title": "Como você está se sentindo sobre a mudança?",
      "veryConfident": "Muito confiante"
    },
    "carePillars": "Pilares Care",
    "challengePlaceholder": "Descreva seu desafio ou pergunta...",
    "checkin": {
      "responseField": {
        "qc_concern": "Preocupações",
        "qc_notes": "Notas"
      },
      "responses": "Respostas"
    },
    "checkinType": {
      "daily_mood": "Humor diário",
      "evening_checkin": "Check-in noturno",
      "morning_checkin": "Check-in matutino",
      "quick_checkin": "Check-in rápido",
      "weekly_checkin": "Check-in semanal"
    },
    "checkpoint": {
      "complete": {
        "milesEarned": "+{{miles}} Miles ganhas",
        "nextCheckpoint": "Próximo ponto de verificação: {{date}}",
        "recorded": "Respostas registradas em seu Passport",
        "subtitle": "Obrigado por compartilhar. Suas respostas nos ajudam a te apoiar melhor.",
        "title": "Ponto de verificação completo!"
      },
      "completed": "Completo",
      "confirmSubmit": {
        "message": "Você está pronto para enviar suas respostas do ponto de verificação? Você não poderá alterar suas respostas após o envio.",
        "title": "Enviar ponto de verificação?"
      },
      "due": "Vencido",
      "feedbackLabel": "Algum feedback adicional? (opcional)",
      "feedbackPlaceholder": "Compartilhe seus pensamentos...",
      "loading": "Carregando ponto de verificação...",
      "notFound": "Ponto de verificação não encontrado",
      "unavailableTitle": "Check-in indisponível",
      "unavailableBody": "Não conseguimos carregar as perguntas para este check-in no momento. Por favor, tente novamente mais tarde.",
      "overallScore": "Pontuação geral",
      "overdue": "Atrasado",
      "previous": "Anterior",
      "reviewSubmit": "Revisar & enviar",
      "scaleLabels": [
        "Muito insatisfeito",
        "Insatisfeito",
        "Neutro",
        "Satisfeito",
        "Muito satisfeito"
      ],
      "scheduled": "Agendado",
      "scoresSummary": "Resumo das suas pontuações:",
      "skipped": "Ignorado",
      "stepOf": "Passo {{current}} de {{total}}",
      "submit": "Enviar",
      "title": "Checkpoint",
      "typeNames": {
        "ad_hoc": "Check-in",
        "annual": "Checkpoint anual",
        "custom": "Checkpoint",
        "month_1": "Checkpoint de 1 mês",
        "month_12": "Checkpoint de 12 meses",
        "month_3": "Checkpoint de 3 meses",
        "month_6": "Checkpoint de 6 meses",
        "month_9": "Checkpoint de 9 meses",
        "onboarding": "Checkpoint de onboarding",
        "pre_move_baseline": "Linha de base pré-movimento",
        "week_1": "Checkpoint da semana 1",
        "week_2": "Checkpoint da semana 2"
      },
      "framing": {
        "expectations": "Antes da sua mudança — suas expectativas",
        "reality": "Ajustando-se — como as coisas realmente estão",
        "settling": "Encontrando seu ritmo",
        "established": "Estabelecendo-se",
        "thriving": "Olhando para frente"
      },
      "focusPillar": "Foco",
      "miles_one": "{{count}} Mile",
      "miles_other": "{{count}} Miles",
      "pillarsTime_one": "{{count}} pilar · {{time}} min",
      "pillarsTime_other": "{{count}} pilares · {{time}} min"
    },
    "checkpointCommentsPlaceholder": "Compartilhe quaisquer pensamentos ou preocupações sobre a estabilidade e integração do seu núcleo familiar...",
    "checkpointCompleted": "Checkpoint concluído com sucesso!",
    "checkpointDescription": "Autoavaliação para bem-estar e integração",
    "checkpointEvolution": "Evolução do checkpoint",
    "checkpointFormDescription": "Complete este checkpoint para acompanhar seu progresso. Você também pode completá-lo no celular.",
    "checkpointHistory": "Histórico de checkpoints",
    "checkpointMonth": "Checkpoint de {{month}} meses",
    "checkpointTitle": "Ponto de verificação Care",
    "checkpoints": {
      "status": {
        "completed": "Completo",
        "due": "Vencido agora",
        "in_progress": "Em andamento",
        "overdue": "Atrasado",
        "pending": "Próximos",
        "scheduled": "Próximos",
        "skipped": "Ignorado"
      },
      "title": "Checkpoints"
    },
    "checkpointsCompleted": "Checkpoints concluídos",
    "checkpointsDescription": "Veja os checkpoints e complete-os no aplicativo móvel",
    "commitment": {
      "at_risk": "Em risco",
      "champion": "Campeão",
      "committed": "Comprometido",
      "engaged": "Engajado",
      "flight_risk": "Precisa de atenção"
    },
    "companyFeedback": "Feedback da empresa",
    "companyRating": "Avaliação da empresa",
    "completeCheckinMobile": "Complete o check-in no celular",
    "completeCheckpointMobile": "Completo no celular",
    "completeFirstCycle": "Complete seu primeiro ciclo de feedback para vê-lo aqui",
    "completedOn": "Concluído em",
    "concern": {
      "family": "Família",
      "finances": "Finanças",
      "healthcare": "Saúde",
      "housing": "Habitação",
      "language": "Idioma",
      "loneliness": "Solidão",
      "schooling": "Educação",
      "title": "Preocupações",
      "work": "Trabalho"
    },
    "continue": {
      "description": "Você começou sua avaliação Care. Retome exatamente de onde parou no Citizen Web — suas respostas até agora estão salvas.",
      "title": "Continue sua avaliação Care"
    },
    "continueOnWeb": "Continue no Citizen Web",
    "continueOnWebDesc": "Retome sua avaliação Care de onde parou no Portal Web Citizen.",
    "copilotSuggestions": "💡 sugestões do cérebro CoPilot",
    "copilotSuggestionsText": "Antes de enviar, tente perguntar ao Cérebro CoPilot por ajuda imediata. Ele pode sugerir lições, tarefas ou recursos.",
    "createdOn": "Criado em",
    "current": "Atual",
    "description": "Acompanhe seu bem-estar",
    "due": "Vencido",
    "dueNow": "Vencido agora",
    "error": {
      "description": "Puxe para atualizar ou toque em tentar novamente. Se continuar falhando, verifique sua conexão.",
      "title": "Não conseguimos carregar seus dados do Care"
    },
    "excellent": "5 — Excelente",
    "familyMasterOnly": "Apenas o Family Master pode responder aos pontos de verificação do Care",
    "feedbackComment1": "Ótimo desempenho no projeto recente. Continue assim!",
    "feedbackComment2": "Bom progresso, continue praticando português.",
    "feedbackComment3": "Sentindo-se mais confiante em conversas em português no trabalho.",
    "feedbackComment4": "Ainda se ajustando à cultura de trabalho, mas fazendo progresso.",
    "feedbackPillars": "Pilares de feedback",
    "from": "De",
    "getHelpWith": "Obtenha ajuda com {{topic}}",
    "heroBanner": {
      "assessmentComplete": "Avaliação completa",
      "awaitingFirstCheckin": "Comece seu primeiro check-in de humor",
      "focusFromAssessment": "Áreas de foco da sua avaliação",
      "title": "Seu bem-estar",
      "wellbeing": "Bem-estar",
      "gettingStarted": "Começando"
    },
    "heroMiles": "Miles Care",
    "householdAware": "Ciente da Família",
    "householdAwareDescription": "Este pilar considera o contexto do seu núcleo familiar (parceiro, filhos) na avaliação",
    "improving": "Melhorando",
    "manager": "Gerente",
    "mood": {
      "amazing": "Incrível",
      "checkedIn": "Check-in feito hoje!",
      "earnMiles": "Ganhe milhas fazendo check-in diariamente",
      "good": "Bom",
      "great": "Ótimo",
      "howAreYou": "Como você está se sentindo hoje?",
      "label1": "Tendo dificuldades",
      "label2": "Ok",
      "label3": "Bom",
      "label4": "Ótimo",
      "label5": "Incrível",
      "okay": "Ok",
      "struggling": "Tendo dificuldades",
      "streakDays_one": "Sequência de {{count}} dia",
      "streakDays_other": "Sequência de {{count}} dias"
    },
    "mySupportRequests": "Meus pedidos de suporte",
    "mySupportRequestsDesc": "Acompanhe e revise seus pedidos de suporte enviados",
    "needSupport": "Precisa de suporte?",
    "needsImprovement": "1 — Precisa melhorar",
    "newRequest": "Novo pedido",
    "noCheckins": "Nenhum check-in ainda. Comece a acompanhar seu humor!",
    "noCheckpointsScheduled": "Nenhum ponto de verificação agendado ainda",
    "noDataYet": "Nenhum dado ainda",
    "noHistory": "Nenhuma história de feedback ainda",
    "noSupportRequests": "Nenhum pedido de suporte corresponde a este filtro",
    "noUpdatesYet": "Nenhuma atualização ainda",
    "objectiveChildcareArrangement": "Organizar cuidados infantis",
    "objectiveDefinitiveHousing": "Garantir moradia definitiva",
    "objectiveHousingStress": "Reduzir o estresse relacionado à habitação",
    "objectiveSchoolEnrollment": "Completar a matrícula escolar",
    "objectiveSocialIntegration": "Construir conexões sociais",
    "objectiveTemporaryHousing": "Garantir moradia temporária",
    "objectiveWellbeingSupport": "Acessar suporte ao bem-estar",
    "objectiveWorkAdaptation": "Adaptar-se à cultura do local de trabalho",
    "objectiveWorkplaceCulture": "Entender a cultura do local de trabalho",
    "objectives": {
      "title": "Seus objetivos",
      "subtitle": "O que sua equipe de patrocinadores está ajudando você a alcançar.",
      "categoryFallback": "Meta",
      "currentLabel": "Agora",
      "targetLabel": "Meta",
      "milestoneDone": "Concluído",
      "milestoneNotYet": "Ainda não",
      "feedbackReadyBadge": "Feedback pronto",
      "viewFeedbackCta": "Ver feedback e autoavaliar",
      "sourceCompany": "Da sua empresa",
      "sourcePersonal": "Sua própria meta",
      "currentCycleHeading": "Feedback deste ciclo",
      "selfEmpty": "Você ainda não adicionou sua autoavaliação para este objetivo.",
      "ratingValue": "{{label}} ({{value}}/5)",
      "cadenceNote": "O feedback é revisado {{cadence}}.",
      "cadence": {
        "bi-weekly": "a cada duas semanas",
        "monthly": "mensalmente",
        "quarterly": "trimestralmente"
      },
      "selfEvalBanner": {
        "title": "Sua equipe compartilhou novo feedback",
        "message": "Há um ciclo de feedback aberto aguardando sua autoavaliação. Adicione-o no aplicativo Tonnie para refletir sobre cada objetivo.",
        "cta": "Adicione sua autoavaliação no aplicativo"
      }
    },
    "objectiveFeedback": {
      "title": "Objetivos & feedback",
      "intro": "Sua equipe de patrocinadores compartilhou feedback sobre seus objetivos. Reflita sobre cada um e adicione sua própria autoavaliação honesta — fica entre você e sua equipe.",
      "providerHeading": "O feedback da sua equipe",
      "providerEmpty": "Sua equipe ainda não adicionou uma nota para este objetivo.",
      "selfHeading": "Sua autoavaliação",
      "ratingPrompt": "Como você está se saindo nisso?",
      "valuePlaceholder": "Digite seu número",
      "ratingLabel1": "Apenas começando",
      "ratingLabel2": "Encontrando meu caminho",
      "ratingLabel3": "Fazendo progresso",
      "ratingLabel4": "Indo bem",
      "ratingLabel5": "Prosperando",
      "commentLabel": "Algo que você gostaria de adicionar? (opcional)",
      "commentPlaceholder": "O que está indo bem, o que tem sido difícil, o que você precisa…",
      "submit": "Enviar autoavaliação",
      "submitting": "Enviando…",
      "noRatingHint": "Avalie pelo menos um objetivo para enviar.",
      "loadingTitle": "Carregando seus objetivos…",
      "emptyTitle": "Nenhum objetivo ainda",
      "emptyBody": "Assim que sua equipe de patrocinadores definir objetivos para você, eles aparecerão aqui.",
      "allCaughtUpTitle": "Você está por dentro de tudo",
      "allCaughtUpBody": "Não há ciclo de feedback aberto no momento. Avisaremos quando sua equipe compartilhar novos feedbacks.",
      "errorTitle": "Não conseguimos carregar seus objetivos",
      "errorBody": "Puxe para atualizar ou toque em tentar novamente. Se continuar falhando, verifique sua conexão.",
      "successTitle": "Autoavaliação compartilhada",
      "successBody": "Obrigado por refletir. Sua equipe pode ver sua avaliação junto com o feedback deles.",
      "successDone": "Concluído",
      "dueOn": "Vencimento {{date}}",
      "cadenceNote": "Sua equipe revisa esses {{cadence}}.",
      "cadence": {
        "weekly": "semanalmente",
        "bi-weekly": "a cada duas semanas",
        "biweekly": "a cada duas semanas",
        "monthly": "mensalmente",
        "quarterly": "trimestralmente",
        "semiannual": "duas vezes por ano",
        "annual": "anualmente"
      },
      "trust": {
        "why": "Sua autoavaliação ajuda sua equipe de patrocinadores a entender seus objetivos do seu ponto de vista.",
        "who": "Apenas você e sua equipe de patrocinadores Tonnie podem ver suas respostas. Nunca é compartilhado com outros colegas.",
        "how": "Refletir sobre seus objetivos mantém seu suporte pessoal e no caminho certo."
      }
    },
    "overdue": "Atrasado",
    "phase": {
      "adapting": "Se adaptando",
      "preMove": "Antes da mudança",
      "settlingIn": "Se instalando",
      "thriving": "Prosperando"
    },
    "pillar": {
      "housing_stability": {
        "desc": "Habitação temporária e definitiva, estresse e risco",
        "name": "Estabilidade habitacional"
      },
      "schooling_childcare": {
        "desc": "Arranjos de educação e cuidados infantis",
        "name": "Educação e cuidados infantis"
      },
      "wellbeing_social": {
        "desc": "Saúde mental, conexões sociais e bem-estar geral",
        "name": "Bem-estar e social"
      },
      "work_fit": {
        "desc": "Adequação ao trabalho e adaptação no local de trabalho",
        "name": "Adequação ao trabalho e adaptação"
      },
      "housing": {
        "name": "Estabilidade habitacional",
        "description": "Encontrar, acomodar-se e sentir-se seguro em sua casa.",
        "obj1": "Habitação estável, adequada e segura",
        "obj2": "Reduzir o estresse relacionado à habitação",
        "obj3": "Acomodar-se no bairro",
        "q1": "Quão satisfeito você está com sua situação habitacional atual?",
        "q1_hh": "Quão satisfeita está sua família com sua situação habitacional atual?",
        "q2": "Quão seguro você se sente em relação aos seus arranjos habitacionais?",
        "q2_hh": "Quão segura sua família se sente em relação aos arranjos habitacionais?",
        "q3": "Quão bem você conhece sua área local e comodidades?",
        "qPreMove": "Quão preparado você se sente em relação aos seus arranjos habitacionais para a mudança?"
      },
      "schooling": {
        "name": "Educação e cuidados infantis",
        "description": "Arranjos de educação e cuidados infantis para seus filhos.",
        "obj1": "Matricular crianças em escolas adequadas",
        "obj2": "Organizar cuidados infantis confiáveis",
        "obj3": "Ajudar crianças a se acomodarem socialmente",
        "q1": "Quão satisfeito você está com os arranjos de educação de seus filhos?",
        "q2": "Quão bem seus filhos se acomodaram em sua nova escola?",
        "q3": "Quão gerenciável é sua situação de cuidados infantis?"
      },
      "work": {
        "name": "Adequação ao trabalho",
        "description": "Quão bem você se adaptou ao seu novo papel e local de trabalho.",
        "obj1": "Adaptar-se ao novo papel",
        "obj2": "Integrar-se à equipe",
        "obj3": "Entender a cultura do local de trabalho",
        "q1": "Quão bem você se sente se encaixando em seu local de trabalho?",
        "q2": "Quão claras são suas funções e responsabilidades?",
        "q3": "Quão apoiado você se sente por sua equipe?",
        "q4": "Quão confiante você está em seu trabalho diário?",
        "qMonth3": "Três meses depois, quão acomodado você se sente em seu papel?"
      },
      "wellbeing": {
        "name": "Bem-estar e social",
        "description": "Seu bem-estar geral e conexões sociais.",
        "obj1": "Manter o bem-estar emocional",
        "obj2": "Construir conexões sociais",
        "obj3": "Apoiar a integração de companheiros",
        "q1": "Como você avaliaria seu bem-estar geral?",
        "q1_hh": "Como você avaliaria o bem-estar geral de sua família?",
        "q2": "Quão conectado você se sente às pessoas ao seu redor?",
        "q2_hh": "Quão conectada sua família se sente às pessoas ao redor deles?",
        "q3": "Quão bem você está gerenciando a vida cotidiana aqui?",
        "q4": "Quão otimista você se sente em relação à adaptação?",
        "q4_hh": "Quão otimista sua família se sente em relação à adaptação?",
        "qMonth1": "Um mês depois, quão conectado você se sente às pessoas aqui até agora?"
      }
    },
    "pillarCommunication": "Comunicação",
    "pillarHousingStability": "Estabilidade habitacional",
    "pillarHousingStabilityDesc": "Habitação temporária/definitiva, estresse, risco",
    "pillarIntegration": "Comportamento e Adaptação",
    "pillarSchoolingChildcare": "Estabilidade na educação/Cuidados infantis",
    "pillarSchoolingChildcareDesc": "Arranjos de educação e cuidados infantis (se aplicável)",
    "pillarSelector": {
      "conditional": "Condicional",
      "desc": "Recomendamos esses pilares com base no seu perfil. Você pode ajustá-los.",
      "selected": "selecionado",
      "title": "Escolha suas áreas de foco"
    },
    "pillarTechnical": "Habilidades técnicas",
    "pillarWellbeing": "Bem-estar e adaptação social",
    "pillarWellbeingDesc": "Saúde mental, conexões sociais e bem-estar geral",
    "pillarWorkFit": "Adequação ao trabalho e adaptação",
    "pillarWorkFitDesc": "Adequação ao trabalho e adaptação no local de trabalho",
    "pillars": {
      "housingStability": "Estabilidade habitacional",
      "schoolingChildcare": "Educação e cuidados infantis",
      "title": "Pilares Care",
      "wellbeingSocial": "Bem-estar e social",
      "workFit": "Adequação ao trabalho e adaptação"
    },
    "plan": {
      "active": "Devido agora",
      "assessmentDone": "Avaliação completa",
      "completed": "Completo",
      "encouragement": "Cada ponto de verificação nos ajuda a entender como você está se adaptando e como podemos apoiá-lo melhor.",
      "focusAreas": "Suas áreas de foco",
      "locked": "Próximos",
      "milesReward": "+{{miles}} Miles",
      "milestones": "Marcos de ponto de verificação"
    },
    "preferences": {
      "afternoon": "Tarde",
      "daily": "Diário",
      "desc": "Diga ao Care quando e com que frequência verificar como você está. Você pode mudar isso a qualquer momento.",
      "evening": "Noite",
      "frequencyLabel": "Frequência",
      "moodReminder": "Lembrete de humor",
      "moodReminderDesc": "Receba um lembrete gentil para registrar como você está se sentindo.",
      "morning": "Manhã",
      "timeLabel": "Hora preferida",
      "title": "Preferências Care",
      "weekdays": "Dias de semana",
      "weekly": "Semanal"
    },
    "proFeature": "Recurso Pro — Atualize para acessar",
    "proFeatureDescription": "Atualize para Pro para acessar todos os recursos, ciclos de feedback e suporte do Care.",
    "proFeatureTitle": "Care & suporte — Recurso Pro",
    "progressOverTime": "Seu progresso ao longo do tempo",
    "quickCheckin": {
      "concern": "Alguma área que você gostaria de sinalizar?",
      "continue": "Continuar",
      "notes": "Algo mais que você gostaria de compartilhar?",
      "overall": "Como você está se sentindo esta semana no geral?",
      "copilotPrompts": {
        "concern": "Alguma área que você gostaria de sinalizar?",
        "notes": "Algo mais que você gostaria de compartilhar?",
        "overall": "Como você está se sentindo no geral esta semana?"
      },
      "error": {
        "message": "Não conseguimos salvar seu check-in. Por favor, tente novamente.",
        "title": "Algo deu errado"
      },
      "finish": "Finalizar",
      "intro": {
        "quickEasy": "Rápido e fácil",
        "quickEasyDesc": "Apenas 3-5 perguntas, leva 2 minutos",
        "subtitle": "CoPilot irá guiá-lo por algumas perguntas",
        "trackProgress": "Acompanhar progresso",
        "trackProgressDesc": "Comparar com seus check-ins anteriores"
      },
      "processing": {
        "subtitle": "CoPilot está preparando suas percepções...",
        "title": "Analisando suas respostas"
      },
      "questionOf": "Pergunta {{current}} de {{total}}",
      "questions": {
        "notesPlaceholder": "Digite seus pensamentos aqui...",
        "qcConcern": "Alguma área que você gostaria de sinalizar?",
        "qcNotes": "Algo mais que você gostaria de compartilhar?",
        "qcOverall": "Como você está se sentindo esta semana no geral?",
        "qcOverallLabels": ["Muito mal", "Mal", "Mais ou menos", "Bem", "Ótimo"]
      },
      "results": {
        "areasOfConcern": "Áreas de preocupação",
        "milesEarned": "+{{miles}} Miles ganhas",
        "moodScoreOf": "Pontuação de humor de {{score}}",
        "nextStep1": "Continue seus check-ins diários para acompanhar seu bem-estar ao longo do tempo",
        "title": "Check-in completo!",
        "today": "Hoje",
        "trendTitle": "Tendência",
        "whatsNext": "O que vem a seguir",
        "yesterday": "Ontem",
        "yourNotes": "Suas notas",
        "concernHint": "CoPilot fará acompanhamento nessas áreas",
        "nextStep2": "CoPilot acompanhará suas tendências ao longo do tempo",
        "nextStep3": "Você receberá dicas personalizadas para áreas sinalizadas"
      },
      "selectAll": "Selecione todas as que se aplicam",
      "alreadyDone": {
        "title": "Você está pronto para hoje",
        "message": "Você já completou o check-in de hoje. Volte amanhã!"
      },
      "doneToday": "Concluído hoje",
      "shortDesc": "Check-in rápido de bem-estar diário",
      "startButton": "Iniciar check-in",
      "title": "Check-in rápido",
      "milesReward_one": "+{{count}} Mile",
      "milesReward_other": "+{{count}} Miles"
    },
    "rateProgress": "Como você avaliaria seu progresso?",
    "recentCycles": "Seus pontos de verificação recentes",
    "requestSupport": "Solicitar suporte",
    "responses": "respostas",
    "retakeAssessment": "Refazer avaliação",
    "retakeOnWeb": "Refazer avaliação na web",
    "retakeOnWebDesc": "Para refazer sua avaliação Care, use o Portal Web Citizen.",
    "returnToDashboard": "Voltar ao painel",
    "risk": {
      "checkinGap": "Uma longa pausa desde o último check-in",
      "crossHeroStall": "Sem atividade TelePortal ou QultureUp em mais de 30 dias",
      "isolation": "Baixas pontuações sociais/bem-estar em pontos de verificação recentes",
      "missedCheckpoint": "Um ponto de verificação está {{overdueDays}} dias atrasado",
      "moodDecline": "Humor baixo por {{consecutive}} check-ins consecutivos",
      "pillarDrop": "{{pillar}} caiu {{drop}} pts desde o último ponto de verificação"
    },
    "selectPillarOrTheme": "Selecionar pilar ou tema",
    "selectPillarOrThemePlaceholder": "Escolha um pilar ou tema",
    "selectSeverity": "Selecionar gravidade (opcional)",
    "selfFeedback": "Autoavaliação",
    "severity": {
      "high": "Alto",
      "low": "Baixo",
      "medium": "Médio",
      "urgent": "Urgente"
    },
    "severityHigh": "Alto",
    "severityLow": "Baixo",
    "severityMedium": "Médio",
    "shareThoughts": "Compartilhe seus pensamentos sobre {{pillar}}...",
    "startCheckpoint": "Iniciar ponto de verificação",
    "startOnWeb": "Comece no Citizen Web",
    "startOnWebDesc": "Configure sua avaliação Care no Portal Web Citizen (cerca de 5 minutos). Uma vez concluído, os check-ins diários e pontos de verificação acontecem aqui no aplicativo.",
    "status": {
      "closed": "Fechado",
      "in_progress": "Em andamento",
      "open": "Abrir",
      "resolved": "Resolvido"
    },
    "statusInProgress": "Em andamento",
    "statusOpen": "Abrir",
    "statusResolved": "Resolvido",
    "streak": {
      "awesome": "Incrível!",
      "dayStreak": "{{days}}-dia de sequência!",
      "badges": {
        "starter": "Primeiros passos",
        "weeklyWarrior": "Uma semana inteira",
        "consistent": "Duas semanas de cuidado",
        "monthlyChampion": "Um mês inteiro",
        "dedicated": "Dois meses de cuidado",
        "unstoppable": "Imparável"
      }
    },
    "submitCheckpoint": "Enviar ponto de verificação",
    "submitRequest": "Enviar solicitação",
    "suggestionMicroLearning": "Recomendações de micro-aprendizagem",
    "suggestionQultureUp": "Aulas recomendadas QultureUp",
    "suggestionSelfHelp": "Conteúdo de autoajuda",
    "suggestionTelePortal": "Tarefas TelePortal",
    "support": {
      "footer": "Escolha sobre o que é para pedir ajuda a quem acompanha sua mudança.",
      "openRequests": "Solicitações de suporte abertas",
      "statusInProgress": "Em andamento",
      "statusOpen": "Abrir",
      "subtitle": "Obtenha ajuda com desafios específicos",
      "title": "Precisa de suporte?"
    },
    "supportCommunication": "Comunicação",
    "supportCultural": "Adequação cultural",
    "supportDescription": "Obtenha ajuda com desafios específicos",
    "supportHelpText": "Selecione um tópico para obter recomendações personalizadas do Tonnie CoPilot ou solicite suporte humano da nossa equipe.",
    "supportHousing": "Habitação",
    "supportRequestActions": "Ações",
    "supportRequestDetails": "Detalhes da solicitação de suporte",
    "supportRequestDetailsDesc": "Veja detalhes e atualizações para sua solicitação de suporte",
    "supportRequestSubmitted": "Solicitação de suporte enviada! Nossa equipe retornará em breve.",
    "supportRequestsOpen": "Solicitações abertas",
    "supportSchooling": "Educação",
    "supportTeamWillRespond": "Nossa equipe de suporte responderá à sua solicitação em breve.",
    "supportTechnical": "Técnico",
    "supportWellbeing": "Bem-estar",
    "tabs": {
      "checkins": "Check-ins",
      "checkpoints": "Checkpoints",
      "objectives": "Objetivos",
      "overview": "Visão geral",
      "support": "Suporte"
    },
    "teamLead": "Líder de equipe",
    "thermometer": {
      "mood": "Humor",
      "settlement": "Liquidação",
      "wellbeing": "Bem-estar"
    },
    "title": "Care & suporte",
    "todaysCare": "Care de hoje",
    "tonnieSupport": "Suporte Tonnie",
    "topic": "Tópico",
    "trust": {
      "checkpoint": {
        "how": "Ajuda Tonnie a fornecer suporte e orientação direcionados.",
        "who": "Suas respostas são privadas. As empresas veem apenas resumos agregados.",
        "why": "Os pontos de verificação nos ajudam a entender como você está se adaptando e onde o suporte é necessário."
      },
      "questions": {
        "how": "Isso nos ajuda a identificar opções de suporte adaptadas a você.",
        "who": "Apenas você e o suporte Tonnie podem ver suas respostas. As empresas veem tendências agregadas.",
        "why": "Fazemos essas perguntas para entender sua adaptação atual."
      },
      "quickCheckin": {
        "how": "Isso nos ajuda a personalizar o suporte e manter sua adaptação no caminho certo.",
        "who": "Apenas você e o suporte Tonnie podem ver suas respostas. As empresas veem tendências agregadas apenas.",
        "why": "Check-ins rápidos nos ajudam a entender seu bem-estar diário e identificar necessidades de suporte precocemente."
      },
      "results": {
        "how": "As percepções ajudam CoPilot a dar melhores recomendações.",
        "who": "Apenas você e o suporte Tonnie. As empresas veem tendências agregadas apenas.",
        "why": "Seus dados de check-in nos ajudam a acompanhar seu bem-estar ao longo do tempo."
      }
    },
    "tryAgainLater": "Por favor, tente novamente mais tarde.",
    "unableToLoadData": "Não foi possível carregar os dados Care",
    "upcoming": "Próximos",
    "updates": "Atualizações",
    "weekPulse": {
      "title": "Pulso semanal"
    },
    "welcome": {
      "description": "Care apoia você durante toda a sua jornada de realocação. Esta configuração única leva cerca de 5 minutos no Citizen Web — depois disso, seus check-ins diários e suporte ao bem-estar ficam bem aqui no aplicativo.",
      "familyStep": "Família e trabalho",
      "familyStepDesc": "Acompanhe a adaptação da família, escolaridade e integração no local de trabalho",
      "letsStart": "Vamos começar",
      "settlingStep": "Acomodando-se",
      "settlingStepDesc": "Acompanhe a estabilidade da sua moradia e o conforto da vida diária",
      "timeEstimate": "Leva cerca de 5 minutos para completar",
      "title": "Bem-vindo ao Care",
      "wellbeingStep": "Bem-estar e social",
      "wellbeingStepDesc": "Verifique sua saúde emocional e conexões sociais"
    },
    "yourChallenge": "seu desafio",
    "yourRating": "Sua avaliação",
    "interactions": {
      "title": "Com sua equipe",
      "subtitle": "Chamadas e reuniões que sua equipe patrocinadora organizou",
      "upcoming": "Próximos",
      "past": "Concluído",
      "type": {
        "call": "Chamada",
        "video_call": "Chamada de vídeo",
        "in_person_meeting": "Reunião presencial",
        "message": "Mensagem",
        "request_checkin": "Check-in"
      }
    },
    "momentum": {
      "event": {
        "checkin": "Você fez check-in",
        "checkpoint": "Checkpoint concluído",
        "feedback": "Você compartilhou feedback",
        "intervention": "Sua equipe entrou em contato",
        "generic": "Atividade Care"
      }
    },
    "zone": {
      "youToday": "Você hoje",
      "forYou": "Para você",
      "yourProgress": "Seu progresso"
    },
    "assessmentDimension": {
      "baseline": "Base emocional",
      "baselineDesc": "Seu humor atual, níveis de energia e estresse",
      "pillars": "Pilares do bem-estar",
      "pillarsDesc": "Selecione as áreas de foco que mais importam para você",
      "preferences": "Preferências de check-in",
      "preferencesDesc": "Como e quando você deseja ser apoiado"
    },
    "milesAwarded_one": "+{{count}} Mile",
    "milesAwarded_other": "+{{count}} Miles",
    "supportRequest": {
      "title": "Pedir apoio",
      "subtitle": "Conte a quem acompanha sua mudança do que você precisa.",
      "pillarLabel": "Sobre o que é?",
      "severityLabel": "Qual é a urgência?",
      "descriptionLabel": "O que está acontecendo?",
      "descriptionPlaceholder": "Com suas palavras — o que aconteceu e o que ajudaria.",
      "descriptionHint": "Pelo menos {{min}} caracteres.",
      "descriptionCount": "{{count}}/{{max}}",
      "send": "Enviar solicitação",
      "sent": "Sua solicitação foi enviada.",
      "failed": "Sua solicitação não foi enviada. Tente novamente.",
      "waitingForConnection": "Você está sem conexão — a solicitação será enviada quando a conexão voltar.",
      "trustWhy": "Para que a solicitação chegue às pessoas certas, com o que elas precisam para ajudar.",
      "trustWho": "Você e a empresa que patrocina esta jornada, se você compartilhar o Care com ela.",
      "trustHow": "A solicitação fica guardada no Care desta jornada.",
      "validation": {
        "pillarRequired": "Escolha sobre o que é.",
        "descriptionShort": "Conte um pouco mais — pelo menos {{min}} caracteres.",
        "descriptionLong": "Use no máximo {{max}} caracteres."
      }
    }
  },
  "career": {
    "achievementsSummary": "Conquistas Career-relevantes",
    "allLocations": "Todas as localizações",
    "allOpportunities": "Todas as oportunidades",
    "allTypes": "Todos os tipos",
    "apply": "Aplicar",
    "avgMatch": "Média de correspondência",
    "careerOverviewDesc": "Visão geral da sua prontidão para a carreira e perfil",
    "careerReadiness": "Prontidão Career",
    "careerReady": "Career pronto",
    "categoryCareer": "Serviços Career",
    "categoryEducation": "Educação",
    "categoryNetworking": "Networking",
    "checkBackLater": "Volte mais tarde para novas correspondências",
    "contract": "Contrato",
    "copilotAnalysis": "Análise cerebral CoPilot para {{title}}",
    "createCV": "Criar CV",
    "createOrEditCV": "Criar ou editar CV",
    "createYourFirstCV": "Crie seu primeiro CV profissional para mostrar suas habilidades",
    "cv": {
      "downloadError": "Falha ao baixar CV",
      "generateError": "Falha ao gerar CV"
    },
    "cvDownloaded": "{{format}} CV para {{opportunityTitle}} baixado com sucesso",
    "cvView": "Construtor de CV",
    "cvViewDescription": "Crie e gerencie seu CV profissional para candidaturas a empregos",
    "cvsGenerated": "CVs gerados",
    "description": "Descubra oportunidades e cresça sua carreira",
    "disableProactive": "Desativar candidaturas proativas",
    "downloadCV": "Baixar CV",
    "downloadPDF": "Baixar PDF",
    "downloadWord": "Baixar word",
    "ecosystemPartners": "Parceiros do ecossistema",
    "editCV": "Editar CV",
    "enableProactive": "Ativar candidaturas proativas",
    "experience": "Experiência",
    "experienceMatchDesc": "Sua experiência corresponde ao cargo",
    "fullTime": "Tempo integral",
    "gotIt": "Entendi",
    "highMatchOpportunities": "Oportunidades de alta correspondência",
    "iWantIt": "Eu quero...",
    "improveMatchText": "Considere melhorar habilidades relevantes ou níveis de idioma para aumentar sua pontuação de correspondência.",
    "languages": "Idiomas",
    "lastGenerated": "Última geração",
    "lastUpdated": "Última atualização",
    "learnMore": "Saiba mais",
    "letCompaniesFind": "Deixe as empresas encontrarem você",
    "levelLabel": "Nível",
    "lisbon": "Lisboa",
    "location": "Localização",
    "locationMatchDesc": "A localização do trabalho se encaixa nas suas preferências",
    "mainRole": "Função principal",
    "match": "Correspondência",
    "matchQuality": "Qualidade da correspondência",
    "matchScore": "Pontuação de correspondência",
    "matchScoreLabel": "Pontuação de correspondência",
    "matchingOpportunities": "Oportunidades de correspondência",
    "mostRecentCV": "CV mais recente",
    "noCVsYet": "Nenhum CV criado ainda",
    "noDescription": "Nenhuma descrição disponível",
    "noOpportunities": "Nenhuma oportunidade encontrada",
    "noSavedOpportunities": "Nenhuma oportunidade salva ainda",
    "notSpecified": "Não especificado",
    "opportunitiesFound": "Oportunidades encontradas",
    "opportunitiesSaved": "Oportunidades salvas",
    "opportunitiesView": "Oportunidades",
    "opportunityRemoved": "Oportunidade removida dos salvos",
    "opportunityRequirements": "Requisitos da oportunidade",
    "opportunitySaved": "Oportunidade salva",
    "partTime": "Meio período",
    "partnerCVDesc": "Revisão e otimização de CV",
    "partnerLinguaDesc": "Cursos de idiomas profissionais",
    "partnerNetworkDesc": "Eventos de networking profissional",
    "partnersDescription": "Parceiros Tonnie-Checked para acelerar sua jornada de carreira",
    "porto": "Porto",
    "proactiveApplications": "Aplicações proativas",
    "proactiveDescription": "Ative seu perfil para ser visível para recrutadores e empresas em busca de talentos como você.",
    "proactiveDisabled": "Aplicações proativas desativadas. Seu perfil não está mais visível para recrutadores.",
    "proactiveEnabled": "Aplicações proativas ativadas! As empresas agora podem encontrar você.",
    "professionalCV": "CV profissional",
    "profileComplete": "Perfil completo",
    "profileCompleteness": "Completude do perfil",
    "profileLabel": "Perfil",
    "readinessLabel": "Prontidão",
    "readinessMessage": "Você está bem preparado para oportunidades internacionais. Continue melhorando suas habilidades linguísticas!",
    "readyToApply": "Pronto para se inscrever",
    "recentCVs": "CVs Recentes",
    "remote": "Remoto",
    "removeFromSaved": "Remover dos salvos",
    "requiredSkills": "Habilidades necessárias",
    "save": "Salvar",
    "saveOpportunitiesMessage": "Salve oportunidades para visualizá-las aqui mais tarde",
    "saved": "Salvo",
    "savedJobs": "Empregos salvos",
    "savedOpportunities": "Oportunidades salvas ({{count}})",
    "savedOpportunitiesTab": "Oportunidades salvas",
    "savedOpportunitiesTitle": "Oportunidades salvas",
    "sharedKeyAchievements": "Principais conquistas e marcos Passport",
    "sharedProfileSnapshot": "Resumo do perfil (função, habilidades, experiência)",
    "sharedReadinessScore": "Pontuação de prontidão (iQulture) e detalhamento MESH",
    "skills": "Habilidades",
    "skillsMatchDesc": "Suas habilidades estão alinhadas com os requisitos do trabalho",
    "targetCountries": "Países alvo",
    "tipsToImprove": "💡 dicas para melhorar a correspondência:",
    "title": "Career, oportunidades & criador de CV",
    "total": "Total",
    "type": "Tipo",
    "unsave": "Desfazer",
    "untitledCV": "CV Sem Título",
    "viewAllCVs": "Ver todos os CVs ({{count}})",
    "whatWillBeShared": "O que será compartilhado:",
    "why": "Por quê?",
    "whyMatch": "Por que esta correspondência?",
    "years": "anos",
    "yourCV": "Seu CV",
    "yourReadiness": "Sua prontidão",
    "highMatchCount_one": "{{count}} alta correspondência",
    "highMatchCount_other": "{{count}} altas correspondências",
    "rolesFound_one": "{{count}} função encontrada",
    "rolesFound_other": "{{count}} funções encontradas",
    "savedOpportunitiesDescription_one": "{{count}} oportunidade salva para revisar depois",
    "savedOpportunitiesDescription_other": "{{count}} oportunidades salvas para revisar depois"
  },
  "checkup": {
    "aboutDescription": "Esta avaliação avalia sua prontidão em múltiplas dimensões:",
    "achievement": "Conquista",
    "additionalSkills": "Habilidades adicionais",
    "aiTalentSnapshot": "Instantâneo de talentos AI",
    "allSet": "Você está pronto",
    "allSetDesc": "Seu CheckUp está completo. Agora podemos construir sua jornada.",
    "analyzingTitle": "Analisando seu Perfil iQulture",
    "areasToWatch": "Áreas a observar",
    "assessmentDescription": "Avalie sua prontidão internacional",
    "assessmentHistory": "Histórico de avaliações",
    "assessmentResults": "Resultados da avaliação",
    "assessmentSubmitted": "Avaliação enviada",
    "assessmentTitle": "Avaliação CheckUp",
    "badge": {
      "explorer": "Explorador",
      "explorerTagline": "Iniciando sua jornada internacional",
      "globalPro": "Global Pro",
      "globalProTagline": "Pronto para o sucesso internacional",
      "risingStar": "Estrela em ascensão",
      "risingStarTagline": "Construindo bases fortes"
    },
    "badgeAlt": "{{badge}} distintivo",
    "band": {
      "noob": "NOOB",
      "potential": "POTENCIAL",
      "pro": "PRO"
    },
    "bandLabels": {
      "emerging": "Emergente",
      "growing": "Crescendo",
      "power": "Poder",
      "strong": "Forte"
    },
    "buildJourneyCta": "Construir minha jornada",
    "buildJourneyTitle": "Pronto para construir sua jornada?",
    "calcTimeEstimate": "Cerca de 30 segundos",
    "calculateScore": "Calcular minha pontuação",
    "calculating": "Calculando…",
    "calculatingAriaLabel": "Calculando sua pontuação",
    "calculatingDesc": "Analisando suas respostas para gerar sua avaliação personalizada MESH...",
    "calculatingScore": "Calculando sua pontuação…",
    "calculatingTitle": "Calculando sua pontuação iQulture…",
    "calculationComplete": "Cálculo completo",
    "calculationError": "Falha ao iniciar o cálculo. Por favor, tente novamente.",
    "calculationTimedOut": "Seu cálculo CheckUp expirou. Por favor, inicie-o novamente.",
    "cancelConfirm": {
      "error": "Não foi possível cancelar seu CheckUp. Por favor, tente novamente.",
      "success": "CheckUp cancelado. Você pode iniciar um novo a qualquer momento."
    },
    "capture": {
      "acceptedFormats": "Aceita fotos, PDFs, documentos do Word e mais",
      "backToTask": "Voltar à tarefa",
      "backToTelePortal": "Voltar para TelePortal",
      "cameraPermissionRequired": "O acesso à câmera é necessário para escanear documentos.",
      "cameraScanHint": "Aponte sua câmera para o documento para a melhor qualidade de escaneamento",
      "chooseAnother": "Escolher outro",
      "fieldDocType": "Tipo de documento",
      "fieldFile": "Arquivo",
      "removeFile": "Remover",
      "retakeCamera": "Refazer",
      "selectDocType": "Selecionar tipo de documento",
      "sourceCamera": "Escaneamento com câmera",
      "sourceFiles": "Procurar arquivos",
      "sourceGallery": "Biblioteca de fotos",
      "tapSelectDocType": "Toque para selecionar tipo de documento",
      "tryAgain": "Tente novamente",
      "uploadButton": "Carregar documento",
      "uploadFailed": "Falha ao enviar",
      "uploaded": "Documento carregado",
      "uploadedDesc": "Seu {{type}} foi enviado e anexado.",
      "uploading": "Enviando seu documento…",
      "uploadingNote": "Isso pode levar um momento"
    },
    "chat": {
      "clickToUpload": "Clique para enviar",
      "notAtAll": "De forma alguma",
      "typeMessage": "Digite uma mensagem…",
      "typeYourAnswer": "Digite sua resposta…",
      "veryMuch": "Muito"
    },
    "checkAgain": "Verifique novamente",
    "checkAgainHelp": "Complete os requisitos acima e clique em 'Verifique Novamente'",
    "checkupHistory": "Histórico CheckUp",
    "checkupHistoryDesc": "Veja suas avaliações anteriores CheckUp",
    "companyAverage": "A média da sua empresa",
    "companyCohort": "Cohorte da empresa",
    "comparisonsDescription": "Sua pontuação em comparação com os outros",
    "comparisonsTitle": "Como você se compara",
    "completeMoreCheckUps": "Complete mais CheckUps para ver sua evolução",
    "completeTitle": "Avaliação completa!",
    "conclusionDesc": "Análise completa da sua prontidão internacional",
    "congratulations": "Parabéns por Completar Seu iQulture CheckUp!",
    "copilotGuideDescription": "Responda perguntas sobre seu histórico e objetivos",
    "copilotGuideTitle": "Guia CoPilot",
    "couldNotLoadResults": "Não conseguimos carregar seus resultados CheckUp. Por favor, tente novamente.",
    "description": "Avaliação abrangente de prontidão internacional 360°",
    "didYouKnow": "Você sabia?",
    "dimensionInternational": "Experiência internacional",
    "dimensionLanguage": "Proficiência em idiomas",
    "dimensionMotivation": "Motivação e mentalidade",
    "dimensionProfessional": "Histórico profissional e habilidades",
    "dontCloseWarning": "Por favor, não feche esta página.",
    "downloadReport": "Baixar relatório completo",
    "elapsed": "decorrido",
    "errorDescription": "Algo deu errado ao carregar seu CheckUp. Por favor, tente novamente.",
    "errorMessage": "Falha ao calcular seu CheckUp. Por favor, tente novamente.",
    "errorTitle": "Ops! Algo deu errado",
    "estimated": "Estimado",
    "estimatedRemaining": "~{{minutes}}m restantes",
    "estimatedTime": "Tempo estimado",
    "evaluationRadar": "Radar de avaliação",
    "exportGenerating": "Gerando exportação...",
    "exportPDFDescription": "Em produção, isso geraria um PDF com seus resultados CheckUp.",
    "exportResults": "Exportar resultados",
    "exportSuccess": "Resultados CheckUp exportados com sucesso",
    "filePickUnavailable": "A seleção de arquivos está atualmente indisponível.",
    "finalMessage": "Você completou uma avaliação abrangente de prontidão internacional 360°. Seu distintivo {{badge}} reflete bases sólidas em motivação, adaptabilidade cultural e comunicação. Foque no {{plan}} para fortalecer suas habilidades técnicas e você estará pronto para oportunidades globais.",
    "finalScore": "Pontuação final",
    "goToCheckUp": "Ir para CheckUp",
    "goToQultureUp": "Ir para QultureUp",
    "goToTelePortal": "Ir para TelePortal",
    "greenFlags": "Sinais verdes",
    "heroMiles": "Miles CheckUp",
    "iqultureBand": "Banda iQulture",
    "journeyStepsSubtitle": "Aqui está o que precisamos para avaliar sua prontidão.",
    "languageTests": {
      "analyzeResult": "Enviar & analisar",
      "analyzing": "Analisando...",
      "attention": "Atenção:",
      "attentionText": "Salve seu resultado como captura de tela, ou baixe-o como PDF com texto selecionável ",
      "changeFile": "Alterar arquivo",
      "completedTest": "Teste concluído",
      "dropHere": "Clique para selecionar o arquivo do seu resultado",
      "englishTests": "Testes de inglês",
      "iUnderstand": "Eu entendo, continuar",
      "immediatelyAfter": "imediatamente após concluir o teste",
      "importantInstructions": "Instruções importantes",
      "instructions": "Envie seu resultado como captura de tela (PNG, JPG, WEBP ou GIF), PDF com texto selecionável ou documento Word (.docx). Lemos o nível automaticamente.",
      "languageTests": "Testes de idioma",
      "listening": "Ouvindo",
      "lowConfidenceHint": "Detectamos um resultado, mas não conseguimos lê-lo com confiança. Por favor, revise e confirme.",
      "modalDesc": "Adicione um resultado de teste de idioma para fortalecer seu perfil.",
      "openPlatform": "Abrir plataforma de teste",
      "openPlatformHint": "Abra a plataforma de teste para baixar seu certificado.",
      "portugueseTests": "Testes de português",
      "reUpload": "Reenviar",
      "readCarefully": "Por favor, leia o certificado cuidadosamente antes de enviar.",
      "reading": "Leitura",
      "readyToStart": "Pronto para fazer o teste?",
      "referenceHint": "Use um certificado recente (menos de 2 anos).",
      "referenceImage": "Referência: Página de resultados esperados",
      "resultDetected": "Resultado detectado",
      "resultLowConfidence": "Resultado detectado — por favor, confirme",
      "retakeWarning": "Você já possui um resultado para este teste. O envio de um novo substituirá a pontuação anterior.",
      "sampleHint": "Certificados de exemplo: PDF, JPG, PNG.",
      "sampleResults": "Página de resultados de exemplo",
      "screenshotReminder": "Lembre-se de capturar seus resultados",
      "screenshotReminderDetail": "Certifique-se de que seu nome e a pontuação estejam visíveis no arquivo que você enviar.",
      "speaking": "Falando",
      "stepConfirm": "Confirmar",
      "stepInstructions": "Instruções",
      "stepTakeTest": "Fazer teste",
      "stepUpload": "Carregar",
      "submitResult": "Enviar resultado",
      "submitted": "Resultado enviado!",
      "submittedHint": "Você enviou um resultado. Vamos revisá-lo e atualizar sua pontuação em breve.",
      "supportedFormats": "Formatos suportados: PNG, JPG, WEBP, GIF, PDF (com texto selecionável), DOCX. Um PDF digitalizado ou uma imagem dentro de um arquivo Word não pode ser lido.",
      "testOpened": "Plataforma de teste aberta em nova aba",
      "uploadFailed": "Falha ao fazer upload. Por favor, tente novamente.",
      "uploadFailedError": "Upload falhou. Por favor, tente novamente.",
      "uploadSuccess": "Resultado do teste enviado para seu Vault",
      "uploading": "Enviando...",
      "useThisExtension": "use esta extensão",
      "alt": {
        "screenshotPreview": "Pré-visualização da captura de tela",
        "reference": "Referência",
        "sampleResults": "Resultados de amostra",
        "uploadedResult": "Resultado enviado"
      },
      "failed": {
        "title": "Não conseguimos ler um resultado neste arquivo",
        "languageMismatch": "Este certificado parece certificar um idioma diferente do deste teste. Envie o certificado do idioma deste teste.",
        "unsupportedDocument": "Não conseguimos ler este arquivo. Envie uma imagem PNG, JPG, WEBP ou HEIC, um PDF ou um documento Word (.docx).",
        "archiveTooLarge": "Este documento Word é grande demais para conseguirmos ler. Envie o resultado como imagem (PNG, JPG ou HEIC) ou PDF.",
        "docxEmpty": "Este documento Word não tem texto nem imagem que consigamos ler. Envie o resultado como imagem (PNG, JPG ou HEIC) ou PDF.",
        "tooManyPages": "Este documento tem mais de {{max}} páginas. Envie apenas as páginas que mostram seu resultado.",
        "noLevelFound": "Não encontramos um nível QECR (A1–C2) neste arquivo. Confira se o resultado mostra seu nível e tente novamente.",
        "serviceUnavailable": "Nosso serviço de análise não conseguiu processar o arquivo agora. Tente novamente em alguns minutos.",
        "notCompletedHint": "Este teste só fica concluído quando um nível for lido no seu certificado."
      },
      "cefrLevel": {
        "a1": "Iniciante",
        "a2": "Elementar",
        "b1": "Intermediário",
        "b2": "Intermediário superior",
        "c1": "Avançado",
        "c2": "Proficiente",
        "native": "Falante nativo"
      },
      "notDone": "A fazer"
    },
    "lastAssessment": "Última avaliação: {{date}}",
    "lastCheckup": "Último CheckUp",
    "legend": {
      "attention": "Atenção",
      "critical": "Crítico",
      "excellent": "Excelente",
      "good": "Bom"
    },
    "loadingAssessment": "Carregando avaliação…",
    "measureReadiness": "Meça sua prontidão",
    "mesh": {
      "english": "Inglês / Realidade linguística",
      "englishDesc": "Suas habilidades linguísticas são fortes, com excelente proficiência em inglês e bom progresso em português.",
      "englishRec1": "Continue praticando português em conversas diárias",
      "englishRec2": "Considere cursos de idiomas avançados",
      "hardSkills": "Hard skills / Competência profissional",
      "hardSkillsDesc": "Sua expertise técnica é excelente e bem alinhada com o mercado-alvo.",
      "hardSkillsRec1": "Mantenha-se atualizado com as últimas tecnologias",
      "hardSkillsRec2": "Considere certificações em sua área",
      "motivation": "Motivação",
      "motivationDesc": "Sua motivação e mentalidade em relação à realocação internacional são fortes. Você demonstra metas claras e uma atitude positiva.",
      "motivationRec1": "Mantenha sua atitude positiva",
      "motivationRec2": "Defina metas e marcos claros",
      "softSkills": "Soft skills & comportamentos",
      "softSkillsDesc": "Você tem uma boa compreensão das diferenças culturais, mas há espaço para melhoria na adaptação ao ambiente de trabalho.",
      "softSkillsRec1": "Complete QultureUp lições sobre a cultura local",
      "softSkillsRec2": "Engaje-se com comunidades locais"
    },
    "meshAnalysisDesc": "Motivação • Inglês • soft cultural • hard & outros",
    "meshAssessmentIntro": "A avaliação MESH mede os quatro pilares da prontidão para uma carreira internacional: Motivação, Inglês, Soft skills e Hard skills.",
    "meshBreakdown": "MESH análise",
    "meshBreakdownDesc": "Sua prontidão em Motivação, Inglês, Soft skills e Hard skills",
    "meshInfo": {
      "E": "Inglês",
      "H": "Habilidades técnicas",
      "M": "Motivação",
      "S": "Habilidades interpessoais"
    },
    "meshReadinessEvaluation": "Avaliação de prontidão MESH",
    "monthsAgo": "meses atrás",
    "motivational": {
      "questionNumber": "Pergunta {{number}}"
    },
    "nextStepsDesc": "Ações para melhorar sua prontidão",
    "noAssessmentYet": "Nenhuma avaliação ainda",
    "noCheckUpForJourney": "Esta jornada ainda não tem um CheckUp.",
    "noHistory": "Ainda não há CheckUps anteriores",
    "noResultsDesc": "Você ainda não completou seu CheckUp. Complete-o para ver sua pontuação de prontidão.",
    "noResultsForJourneyDesc": "Esta jornada ainda não tem resultados de CheckUp. Complete a avaliação para ver sua pontuação.",
    "noResultsForJourneyTitle": "Nenhum resultado para esta jornada",
    "noResultsTitle": "Nenhum resultado ainda",
    "notReadyMessage": "Conclua primeiro estes passos e depois faça o seu CheckUp.",
    "notReadyTitle": "Quase lá!",
    "now": "Agora",
    "phase": {
      "dataCollection": "Coleta de dados",
      "iqultureScoring": "Pontuação iQulture",
      "meshAnalysis": "Análise MESH",
      "reportGeneration": "Geração de relatório"
    },
    "photoLibraryUnavailable": "A biblioteca de fotos está atualmente indisponível.",
    "pillar": {
      "AR": {
        "brief": "Suas credenciais, certificações e aprendizado contínuo",
        "name": "Prontidão acadêmica"
      },
      "CP": {
        "brief": "Sua eficácia geral em linguagem e comunicação",
        "name": "Proficiência em comunicação"
      },
      "CP_ENGLISH": {
        "brief": "Sua proficiência em inglês para contextos profissionais",
        "name": "Comunicação em Inglês"
      },
      "CP_NATIVE_TARGET": {
        "brief": "Sua proficiência em idiomas nativos e do mercado-alvo",
        "name": "Idioma nativo/Alvo"
      },
      "GPE": {
        "brief": "Seu histórico de trabalho internacional/fronteiriço",
        "name": "Experiência profissional global"
      },
      "ICM": {
        "brief": "Quão claro e comprometido está o seu plano de carreira internacional",
        "name": "Motivação internacional Career"
      },
      "MA": {
        "brief": "Sua capacidade de se adaptar e prosperar em diferentes culturas",
        "name": "Adaptabilidade multicultural"
      },
      "PRM": {
        "brief": "Sua prontidão mental e estratégias de enfrentamento para relocação",
        "name": "Resiliência psicológica para mobilidade"
      },
      "WMF": {
        "brief": "Sua abertura para diferentes arranjos de trabalho (remoto/híbrido/presencial)",
        "name": "Flexibilidade no modelo de trabalho"
      }
    },
    "pillarsDesc": "Sete dimensões-chave da prontidão internacional",
    "pillarsPassed": "Pilares aprovados",
    "plan90Days": "Plano de ação de 90 dias",
    "pollingError": "Falha ao verificar o status do cálculo. Por favor, tente novamente.",
    "previousScore": "Sua pontuação anterior",
    "processingInitializing": "Inicializando cálculo de iQulture...",
    "processingStatus": "Status do processamento",
    "processingSubtitle": "Isso pode levar até 5 minutos. Por favor, não feche esta página.",
    "processingTitle": "Analisando seu Perfil iQulture",
    "progressTitle": "Progresso da avaliação",
    "readinessCheckError": "Falha ao verificar a prontidão. Por favor, tente novamente.",
    "readinessScore": "Você receberá sua pontuação de prontidão",
    "readyForJourney": "Você está pronto para sua jornada",
    "recommendation1Description": "Comece a aprender sobre a cultura portuguesa e normas de trabalho",
    "recommendation1Title": "Complete a avaliação QultureUp",
    "recommendation2Description": "Obtenha sua lista de verificação personalizada para relocação",
    "recommendation2Title": "Iniciar avaliação TelePortal",
    "recommendation3Description": "Sua pontuação de comunicação é boa, mas a prática leva à perfeição",
    "recommendation3Title": "Continue aprendendo idiomas",
    "recommendations": "Recomendações",
    "recommendedNextSteps": "Próximos passos recomendados",
    "redirecting": "Redirecionando para seus resultados...",
    "requirementMissing": "Requisito ausente",
    "requirementsTitle": "Lista de verificação de requisitos",
    "results": {
      "activateSubtitle": "Seu CheckUp está completo. Aqui está seu caminho a seguir.",
      "activateTitle": "Ative sua jornada",
      "activeJourney": "Ativo",
      "areasRequiringAttention": "Áreas que requerem atenção",
      "areasToWatch": "Áreas a observar",
      "assessedOn": "Avaliado {{date}}",
      "backToTop": "Voltar ao topo",
      "bandAttention": "Atenção",
      "bandAttentionDesc": "Em desenvolvimento — melhoria direcionada recomendada",
      "bandAttentionRange": "60-69",
      "bandCritical": "Crítico",
      "bandCriticalDesc": "Necessita foco prioritário antes de seguir em frente",
      "bandCriticalRange": "Abaixo de 60",
      "bandExcellent": "Excelente",
      "bandExcellentDesc": "Forte e consistente — um ativo claro",
      "bandExcellentRange": "80-100",
      "bandGood": "Bom",
      "bandGoodDesc": "Base sólida com espaço para aprimorar",
      "bandGoodRange": "70-79",
      "careDesc": "Obtenha suporte pós-chegada e assistência à integração",
      "caveat": {
        "lowMotivationSignal": "Suas respostas motivacionais foram muito breves, então esta pontuação é menos confiável que as outras. Uma resposta mais completa a deixaria mais precisa.",
        "noMotivationData": "Você não escreveu nada na avaliação motivacional, então não conseguimos pontuar Motivação. Complete-a e recalcule para ver esta dimensão.",
        "noPitch": "Você ainda não gravou um vídeo de apresentação, então Motivação é baseada apenas nas suas respostas escritas.",
        "pitchAnalysisFailed": "Não foi possível analisar seu vídeo de apresentação, então Motivação se baseia apenas nas suas respostas escritas.",
        "pitchHeuristicScoring": "A análise completa do seu vídeo de apresentação não estava disponível, então a parte desta pontuação que depende dele é uma estimativa simplificada.",
        "pillarsEstimated": "Parte desta pontuação foi estimada com um método simplificado porque nossa análise completa não estava disponível.",
        "skillsInferenceEmpty": "Ainda não conseguimos identificar suas habilidades com o que você compartilhou, então Habilidades técnicas & outras habilidades não tem pontuação. Adicione suas habilidades e experiência ao perfil e recalcule."
      },
      "confidence": "Confiança: {{value}}%",
      "description": "Sua avaliação de prontidão internacional",
      "doctorsRecommendation": "Recomendação do médico",
      "errorDescription": "Houve um problema ao buscar seus resultados de CheckUp. Por favor, tente novamente.",
      "errorTitle": "Não foi possível carregar os resultados",
      "examCount_one": "{{count}} exame",
      "examCount_other": "{{count}} exames",
      "explore": "Explorar",
      "freeAssessmentNote": "Avaliação gratuita completa • Atualize para acessar todos os heróis",
      "greenFlags": "Sinais verdes",
      "growthSubtitle": "Onde seu impulso pode acelerar",
      "growthTitle": "Suas áreas de crescimento",
      "historyTitle": "Histórico CheckUp",
      "journeys": "Jornadas",
      "meshDnaSubtitle": "Quatro pilares que definem sua prontidão internacional",
      "meshDnaTitle": "Seu DNA MESH",
      "meshE": "Inglês & comunicação",
      "meshELbl": "Inglês",
      "meshH": "Habilidades técnicas & outras habilidades",
      "meshHLbl": "Habilidades técnicas",
      "meshM": "Motivação",
      "meshMLbl": "Motivação",
      "meshS": "Habilidades culturais suaves",
      "meshSLbl": "Cultural",
      "moreCheckupsNeeded": "Complete mais CheckUps para ver sua evolução ao longo do tempo",
      "navActivate": "Ativar jornada",
      "navGrowth": "Suas áreas de crescimento",
      "navHistory": "Histórico CheckUp",
      "navMeshDna": "DNA MESH",
      "navPillars": "Resultados da avaliação",
      "navPrescription": "Prescrição de 90 dias",
      "navStrengths": "Seus pontos fortes",
      "nextSection": "Próximo: {{label}}",
      "notScored": "Sem pontuação",
      "overallScore": "Pontuação geral de prontidão",
      "pillarOverview": "Visão geral dos pilares",
      "pillarPerformance": "Seu desempenho em todas as dimensões de avaliação",
      "pillarTapHint": "Toque em um pilar para ver o que ele mede",
      "pillarSubtitle": "Como um relatório de laboratório médico, cada pilar mede uma dimensão específica da sua prontidão internacional — quão preparado você está para sua jornada em outro país. Cada dimensão é pontuada de 0 a 100: quanto maior a pontuação, mais forte é essa área.",
      "pillarTitle": "Seus resultados da avaliação",
      "positiveIndicators": "Indicadores positivos",
      "prescriptionSubtitle": "Um plano estruturado para converter potencial em desempenho",
      "prescriptionTitle": "Sua prescrição de 90 dias",
      "progressOverTime": "Seu progresso ao longo do tempo",
      "qultureupDesc": "Aprimore sua prontidão cultural com treinamento personalizado",
      "scaleCaption": "Sua posição na escala",
      "scaleToNext": "{{points}} pts para {{tier}}",
      "scaleMax": "Você alcançou o nível máximo",
      "readingResults": "Lendo seus resultados",
      "recommendedNextSteps": "Próximos passos recomendados",
      "scoreOutOf": "/ 100",
      "scrollBackTop": "Role para cima",
      "scrollToNext": "Role para a próxima seção",
      "strengthsSubtitle": "O que faz seu perfil se destacar",
      "strengthsTitle": "Seus pontos fortes",
      "teleportalDesc": "Comece seu plano de mobilidade com verificação de documentos e orientação de visto",
      "title": "Resultados CheckUp",
      "topHardSkills": "Principais habilidades técnicas",
      "topSoftSkills": "Principais habilidades interpessoais",
      "unlockJourney": "Desbloqueie sua jornada completa",
      "snapshotFallback": "Sua avaliação iQulture está completa.",
      "badgeReasonFallback": "Com base no seu desempenho geral de avaliação.",
      "provisional": {
        "label": "Provisório",
        "body": "Faltam alguns dos seus dados, por isso esta é a pontuação mínima possível. Com os dados completos, ela pode chegar a {{max}}.",
        "unlock": {
          "M": "Complete as respostas de Motivação ou grave seu pitch — até +{{gain}}",
          "E": "Adicione seus níveis de idiomas, incluindo a língua materna — até +{{gain}}",
          "S": "Complete o CheckUp para medirmos suas soft skills — até +{{gain}}",
          "H": "Adicione suas habilidades e experiência ao perfil — até +{{gain}}"
        }
      },
      "skillsNotEnoughEvidence": "Ainda não há informações suficientes para medir essas habilidades."
    },
    "resultsError": "Falha ao buscar resultados. Por favor, tente novamente.",
    "retakeAssessment": "Refazer avaliação",
    "retakeOnWeb": "Refazer avaliação na web",
    "retakeOnWebDesc": "Para refazer sua avaliação CheckUp, use o Portal Web Citizen em um navegador de desktop.",
    "score": "Pontuação",
    "scoreEvolution": "Evolução da pontuação",
    "scrollForDetails": "Role para detalhes",
    "scrollForDetailsHint": "Toque para rolar para seus resultados detalhados",
    "selected": "Selecionado",
    "selectedCheckupDetails": "Detalhes selecionados CheckUp",
    "shareResults": "Compartilhar resultados",
    "similarProfiles": "Perfis semelhantes",
    "somethingWentWrong": "Algo deu errado",
    "startFailed": "Não foi possível iniciar CheckUp. Por favor, tente novamente.",
    "startOnWeb": "Comece no Citizen Web",
    "startOnWebDesc": "Complete sua primeira avaliação CheckUp no Portal Web Citizen para a experiência completa.",
    "step": {
      "assistantChat": "Chat do assistente",
      "assistantChatMsg": "Converse com nosso assistente de IA para nos dar mais contexto sobre sua situação.",
      "chatDone": "Chat completo",
      "chatDoneDesc": "Você terminou o chat com o assistente.",
      "journeyInstance": "Configuração da jornada",
      "journeyInstanceMsg": "Diga-nos para onde você está se mudando e de onde.",
      "languageTests": "Testes de idioma",
      "languageTestsDesc": "Adicione resultados de proficiência em idiomas.",
      "languageTestsMsg": "Envie seus certificados de idioma para fortalecer sua pontuação de prontidão.",
      "motivational": "Motivação",
      "motivationalMsg": "Ajude-nos a entender o que está motivando sua mudança.",
      "onboarding": "Informações básicas do perfil",
      "onboardingMsg": "Detalhes rápidos sobre você para personalizar o restante.",
      "pitch": "Vídeo de apresentação",
      "pitchMsg": "Grave um vídeo de 30 segundos se apresentando.",
      "pitchRecorded": "Pitch gravado",
      "pitchRecordedDesc": "Seu vídeo de pitch está pronto para revisão.",
      "videos": "Assistir vídeos",
      "videosMsg": "Assista a alguns vídeos curtos sobre seu destino.",
      "profileComplete": "Complete seu perfil",
      "profileCompleteMsg": "Sua pontuação precisa de alguns dados de identificação.",
      "profileCompletePercentMsg": "Seu perfil está {{percent}}% completo. A pontuação precisa dele inteiro."
    },
    "stuckMessage": "Empacado? Deixe-nos saber — podemos ajudar.",
    "suggestedNextSteps": "Próximos passos sugeridos",
    "tabAnalysis": "Análise",
    "tabComparisons": "Comparações",
    "tabConclusion": "Conclusão 360°",
    "tabHistory": "Histórico",
    "tabInsights": "Insights",
    "tabMESH": "Análise MESH",
    "tabNextSteps": "Próximos passos",
    "tabOverview": "Visão Geral",
    "tabPillars": "Pilares de avaliação",
    "tabSkills": "Termômetro de habilidades",
    "tapToCollapse": "Toque para colapsar",
    "tapToReadMore": "Toque para ler o resumo completo",
    "tip": {
      "1": "Sua pontuação MESH mede Motivação, Inglês, Habilidades interpessoais e Habilidades técnicas — os 4 pilares da prontidão para carreira internacional.",
      "2": "Os distintivos iQulture (Explorador, Estrela em Ascensão, Profissional Global) refletem sua preparação geral para trabalhar no exterior.",
      "3": "Nossa IA analisa seu vídeo de pitch, proficiência em idiomas e respostas motivacionais para construir um perfil 360°.",
      "4": "Seu plano de ação personalizado de 90 dias incluirá etapas específicas para melhorar suas áreas mais fracas.",
      "5": "A Avaliação de Risco Cultural identifica desafios potenciais de adaptação e como superá-los."
    },
    "title": "iQulture CheckUp",
    "tonnieDatabaseAverage": "Média do banco de dados Tonnie",
    "top10Hard": "Top 10 habilidades técnicas",
    "top10Soft": "Top 10 habilidades interpessoais",
    "topHardSkills": "Principais habilidades técnicas",
    "topSoftSkills": "Principais habilidades interpessoais",
    "triggerFailed": "Falha ao iniciar o cálculo. Por favor, tente novamente.",
    "tryAgain": "Tente novamente",
    "unableToLoad": "Não foi possível carregar CheckUp",
    "unknownDate": "Data desconhecida",
    "verifiedByTonnieGuard": "Verificado por Tonnie guard",
    "vsAverage": "vs média",
    "vsPrevious": "vs anterior",
    "welcome": {
      "chatStep": "Conversa guiada",
      "chatStepDesc": "Responda a algumas perguntas com nosso assistente de IA",
      "description": "Descubra sua prontidão internacional com nossa avaliação MESH. Ela avalia sua Motivação, Inglês, Habilidades Interpessoais e Habilidades Técnicas para gerar sua pontuação personalizada iQulture.",
      "languageStep": "Verificação de idioma",
      "languageStepDesc": "Avaliação rápida de suas habilidades linguísticas",
      "letsStart": "Vamos começar",
      "pitchStep": "Vídeo de pitch curto",
      "pitchStepDesc": "Grave um vídeo breve se apresentando",
      "timeEstimate": "Leva cerca de 10-15 minutos para completar",
      "title": "Bem-vindo ao CheckUp"
    },
    "scoreOutOfSuffix": "/100",
    "missingSteps": {
      "journey_instance": {
        "label": "Instância da jornada",
        "message": "Você precisa criar uma Jornada antes de iniciar seu CheckUp."
      },
      "onboarding_complete": {
        "label": "Integração",
        "message": "Complete sua integração de perfil para desbloquear CheckUp."
      },
      "assistant_chat": {
        "label": "Chat de avaliação",
        "message": "Complete a conversa de avaliação guiada."
      },
      "motivational_answers": {
        "label": "Perguntas motivacionais",
        "message": "Responda às perguntas motivacionais sobre seus objetivos."
      },
      "pitch_video": {
        "label": "Vídeo de apresentação",
        "message": "Grave ou faça upload do seu vídeo de apresentação."
      },
      "generic": "Esta etapa precisa ser concluída.",
      "videos_watched": {
        "label": "Assistir aos vídeos de introdução",
        "message": "Uma breve introdução antes de começar."
      },
      "language_tests": {
        "label": "Testes de idiomas",
        "message": "Conte quais idiomas você fala e em que nível."
      },
      "profile_complete": {
        "label": "Complete seu perfil",
        "message": "Sua pontuação precisa de alguns dados de identificação. Complete no portal web."
      }
    },
    "reuse": {
      "title": "Reutilizar seu resultado salvo?",
      "subtitle": "Você já concluiu este teste. Reutilize-o nesta avaliação ou faça um novo.",
      "takenOn": "Feito em {{date}}",
      "reuseCta": "Reutilizar este resultado",
      "newCta": "Fazer um novo",
      "daysLeft_one": "{{count}} dia restante",
      "daysLeft_other": "{{count}} dias restantes"
    },
    "calculatingPct": "Calculando… {{pct}}%",
    "requestedBy": {
      "badge": "Pedido por {{company}}",
      "purpose": "Sua pontuação define as recomendações que você recebe e o apoio que eles podem oferecer.",
      "whatTheySee": "Eles veem sua pontuação e sua prontidão, nunca suas respostas."
    },
    "reusedFrom": {
      "title": "Reaproveitado do seu CheckUp para {{destination}}",
      "body": "Suas respostas e os testes ainda válidos foram aproveitados desse CheckUp. Sua pontuação é calculada novamente para este destino."
    },
    "profileGate": {
      "progressLabel": "Perfil",
      "percent": "{{percent}}%",
      "cta": "Completar perfil",
      "field": {
        "name": "Nome",
        "dateOfBirth": "Data de nascimento",
        "nationality": "Cidadania",
        "currentCountry": "País atual",
        "currentCity": "Cidade atual",
        "phone": "Telefone"
      },
      "fieldMissing": "Pendente"
    },
    "readyToCalculate": {
      "title": "Sua avaliação está completa",
      "description": "Está tudo respondido. Sua pontuação ainda não foi gerada.",
      "ctaTitle": "Gerar sua pontuação",
      "ctaDescription": "Um toque. Leva alguns minutos, e enviamos uma notificação quando sua pontuação ficar pronta.",
      "cta": "Calcular minha pontuação"
    },
    "awaitingProfile": {
      "assessmentDone": "Avaliação concluída",
      "assessmentDoneDetail": "Todos os passos estão feitos — suas respostas estão salvas.",
      "calculateLocked": "Complete o seu perfil para desbloquear a sua pontuação."
    },
    "calculationFailedTitle": "Não foi possível calcular sua pontuação",
    "calculationFailedBody": "Suas respostas estão salvas. Calcule a pontuação de novo — leva cerca de um minuto.",
    "calculateAgain": "Calcular de novo"
  },
  "common": {
    "active": "Ativo",
    "appName": "Tonnie Citizen",
    "appShortName": "Citizen",
    "applicationError": "Erro de aplicação",
    "availableSoon": "Disponível em breve",
    "back": "Voltar",
    "backToDashboard": "Voltar ao painel",
    "cancel": "Cancelar",
    "clear": "Limpar",
    "clearFilters": "Limpar filtros",
    "close": "Fechar",
    "collapse": "Colapsar",
    "comingSoon": "Em breve",
    "completed": "Completo",
    "confirm": "Confirmar",
    "continue": "Continuar",
    "continueAssessment": "Continuar avaliação",
    "continueSetup": "Continuar configuração",
    "copiedToClipboard": "{{label}} copiado para a área de transferência",
    "copilot": "CoPilot",
    "copyFailed": "Falha ao copiar {{label}}",
    "countries": {
      "AE": "Emirados Árabes Unidos",
      "AU": "Austrália",
      "BR": "Brasil",
      "CA": "Canadá",
      "CN": "China",
      "DE": "Alemanha",
      "ES": "Espanha",
      "FR": "França",
      "GB": "Reino Unido",
      "IE": "Irlanda",
      "IN": "Índia",
      "IT": "Itália",
      "JP": "Japão",
      "KR": "Coreia do Sul",
      "NL": "Países Baixos",
      "NZ": "Nova Zelândia",
      "PT": "Portugal",
      "SG": "Cingapura",
      "UK": "Reino Unido",
      "US": "Estados Unidos",
      "AF": "Afeganistão",
      "AL": "Albânia",
      "DZ": "Argélia",
      "AD": "Andorra",
      "AO": "Angola",
      "AG": "Antígua e Barbuda",
      "AR": "Argentina",
      "AM": "Armênia",
      "AT": "Áustria",
      "AZ": "Azerbaijão",
      "BS": "Bahamas",
      "BH": "Barein",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Bielorrússia",
      "BE": "Bélgica",
      "BZ": "Belize",
      "BJ": "Benin",
      "BT": "Butão",
      "BO": "Bolívia",
      "BA": "Bósnia e Herzegovina",
      "BW": "Botsuana",
      "BN": "Brunei",
      "BG": "Bulgária",
      "BF": "Burquina Faso",
      "BI": "Burundi",
      "CV": "Cabo Verde",
      "KH": "Camboja",
      "CM": "Camarões",
      "CF": "República Centro-Africana",
      "TD": "Chade",
      "CL": "Chile",
      "CO": "Colômbia",
      "KM": "Comores",
      "CG": "Congo",
      "CD": "Congo (RDC)",
      "CR": "Costa Rica",
      "CI": "Costa do Marfim",
      "HR": "Croácia",
      "CU": "Cuba",
      "CY": "Chipre",
      "CZ": "Tchéquia",
      "DK": "Dinamarca",
      "DJ": "Djibuti",
      "DM": "Dominica",
      "DO": "República Dominicana",
      "EC": "Equador",
      "EG": "Egito",
      "SV": "El Salvador",
      "GQ": "Guiné Equatorial",
      "ER": "Eritreia",
      "EE": "Estônia",
      "SZ": "Essuatíni",
      "ET": "Etiópia",
      "FJ": "Fiji",
      "FI": "Finlândia",
      "GA": "Gabão",
      "GM": "Gâmbia",
      "GE": "Geórgia",
      "GH": "Gana",
      "GR": "Grécia",
      "GD": "Granada",
      "GT": "Guatemala",
      "GN": "Guiné",
      "GW": "Guiné-Bissau",
      "GY": "Guiana",
      "HT": "Haiti",
      "HN": "Honduras",
      "HK": "Hong Kong",
      "HU": "Hungria",
      "IS": "Islândia",
      "ID": "Indonésia",
      "IR": "Irã",
      "IQ": "Iraque",
      "IL": "Israel",
      "JM": "Jamaica",
      "JO": "Jordânia",
      "KZ": "Cazaquistão",
      "KE": "Quênia",
      "KI": "Quiribati",
      "KW": "Kuwait",
      "KG": "Quirguistão",
      "LA": "Laos",
      "LV": "Letônia",
      "LB": "Líbano",
      "LS": "Lesoto",
      "LR": "Libéria",
      "LY": "Líbia",
      "LI": "Liechtenstein",
      "LT": "Lituânia",
      "LU": "Luxemburgo",
      "MO": "Macau",
      "MG": "Madagascar",
      "MW": "Malaui",
      "MY": "Malásia",
      "MV": "Maldivas",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Ilhas Marshall",
      "MR": "Mauritânia",
      "MU": "Maurício",
      "MX": "México",
      "FM": "Micronésia",
      "MD": "Moldávia",
      "MC": "Mônaco",
      "MN": "Mongólia",
      "ME": "Montenegro",
      "MA": "Marrocos",
      "MZ": "Moçambique",
      "MM": "Mianmar",
      "NA": "Namíbia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NI": "Nicarágua",
      "NE": "Níger",
      "NG": "Nigéria",
      "KP": "Coreia do Norte",
      "MK": "Macedônia do Norte",
      "NO": "Noruega",
      "OM": "Omã",
      "PK": "Paquistão",
      "PW": "Palau",
      "PS": "Palestina",
      "PA": "Panamá",
      "PG": "Papua-Nova Guiné",
      "PY": "Paraguai",
      "PE": "Peru",
      "PH": "Filipinas",
      "PL": "Polônia",
      "QA": "Catar",
      "RO": "Romênia",
      "RU": "Rússia",
      "RW": "Ruanda",
      "KN": "São Cristóvão e Névis",
      "LC": "Santa Lúcia",
      "VC": "São Vicente e Granadinas",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "São Tomé e Príncipe",
      "SA": "Arábia Saudita",
      "SN": "Senegal",
      "RS": "Sérvia",
      "SC": "Seicheles",
      "SL": "Serra Leoa",
      "SK": "Eslováquia",
      "SI": "Eslovênia",
      "SB": "Ilhas Salomão",
      "SO": "Somália",
      "ZA": "África do Sul",
      "SS": "Sudão do Sul",
      "LK": "Sri Lanka",
      "SD": "Sudão",
      "SR": "Suriname",
      "SE": "Suécia",
      "CH": "Suíça",
      "SY": "Síria",
      "TW": "Taiwan",
      "TJ": "Tadjiquistão",
      "TZ": "Tanzânia",
      "TH": "Tailândia",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TO": "Tonga",
      "TT": "Trinidad e Tobago",
      "TN": "Tunísia",
      "TR": "Turquia",
      "TM": "Turcomenistão",
      "TV": "Tuvalu",
      "UG": "Uganda",
      "UA": "Ucrânia",
      "UY": "Uruguai",
      "UZ": "Uzbequistão",
      "VU": "Vanuatu",
      "VA": "Cidade do Vaticano",
      "VE": "Venezuela",
      "VN": "Vietnã",
      "YE": "Iêmen",
      "ZM": "Zâmbia",
      "ZW": "Zimbábue"
    },
    "delete": "Excluir",
    "destination": "Destino",
    "discard": "Descartar",
    "discardChanges": "Descartar alterações?",
    "discardChangesBody": "Suas alterações não salvas serão perdidas.",
    "discardProgress": "Descartar progresso?",
    "discardProgressBody": "Seu progresso nesta tela será perdido.",
    "dismiss": "Dispensar",
    "done": "Concluído",
    "download": "Baixar",
    "earned": "Ganho",
    "earnedDateMiles": "Ganho {{date}} • +{{miles}} Miles",
    "edit": "Editar",
    "email": "Email",
    "error": "Erro",
    "errorTitle": "Erro",
    "estimatedTime": "Tempo estimado",
    "expand": "Expandir",
    "familyWillLose": "Seus membros da família perderão",
    "filter": "Filtrar",
    "free": "Gratuito",
    "goBack": "Voltar",
    "heroes": {
      "care": "Care",
      "checkup": "CheckUp",
      "qultureup": "QultureUp",
      "teleportal": "TelePortal",
      "inout": "InOut"
    },
    "inProgress": "Em andamento",
    "info": "Info",
    "keepEditing": "Continuar editando",
    "keepFamily": "Manter família",
    "keepPro": "Manter Pro",
    "loading": "Carregando...",
    "locked": "Bloqueado",
    "logout": "Sair",
    "miles": "Miles",
    "minutes": "minutos",
    "more": "mais",
    "next": "Próximo",
    "no": "Não",
    "notAvailable": "Não disponível",
    "of": "de",
    "openInApp": "Abrir no app",
    "optional": "Opcional",
    "origin": "Origem",
    "other": "Outro",
    "page": "Página",
    "pending": "Pendente",
    "plan": {
      "basic": "Básico",
      "pro": "Pro"
    },
    "pleaseRetryLater": "Por favor, tente novamente mais tarde.",
    "previous": "Anterior",
    "progress": "Progresso",
    "refresh": "Atualizar",
    "remove": "Remover",
    "reset": "Redefinir",
    "resumeWhereYouLeftOff": "Retomar de onde você parou",
    "retry": "Tentar novamente",
    "routeSrLabel": "{{origin}} para {{destination}}",
    "review": "Revisão",
    "save": "Salvar",
    "selectLanguage": "Selecionar idioma",
    "send": "Enviar",
    "settings": "Configurações",
    "skip": "Pular",
    "soon": "Em breve",
    "submit": "Enviar",
    "success": "Sucesso",
    "successTitle": "Sucesso",
    "time": {
      "daysAgo": "há {{n}}d",
      "hoursAgo": "há {{n}}h",
      "minutesAgo": "há {{n}}m",
      "monthsAgo": "há {{n}}mo",
      "now": "agora mesmo",
      "weeksAgo": "há {{n}}w",
      "yesterday": "ontem"
    },
    "to": "Para",
    "toast": {
      "documentUploaded": "Documento enviado",
      "moodFailed": "Não foi possível salvar o humor, tente novamente",
      "moodRecorded": "Humor registrado",
      "settingFailed": "Não foi possível atualizar a configuração",
      "settingSaved": "Configuração salva",
      "somethingWentWrong": "Algo deu errado, por favor tente novamente",
      "taskCompleted": "Tarefa concluída",
      "taskFailed": "Não foi possível atualizar a tarefa",
      "taskReopened": "Tarefa reaberta"
    },
    "today": "Hoje",
    "tonnieChecked": "Tonnie-Verificado",
    "traveler": "Viajante",
    "trust": {
      "howItHelps": "Como isso ajuda você",
      "tapToSee": "Toque para ver como protegemos seus dados",
      "whoCanSee": "Quem pode ver isso",
      "whyAsking": "Por que estamos perguntando",
      "yourDataProtected": "Seus Dados estão Protegidos"
    },
    "tryAgain": "Tente novamente",
    "upload": "Carregar",
    "uploading": "Carregando…",
    "view": "Ver",
    "viewAll": "Ver todos",
    "welcome": "Bem-vindo",
    "yes": "Sim",
    "yesterday": "Ontem",
    "youWillLose": "Você perderá acesso a",
    "beta": {
      "bannerMessage": "Acesso antecipado — ajude a moldar a Tonnie 💜",
      "bannerMessageMobile": "Acesso antecipado — evolua com a Tonnie 💜",
      "bannerCta": "Dar feedback"
    },
    "openActionTitle": "Abrir {{action}}",
    "copy": "Copiar",
    "network": {
      "a11y": {
        "retry": "Tentar novamente solicitações falhadas",
        "dismiss": "Dispensar banner de erro de rede",
        "showDetails": "Mostrar detalhes do erro",
        "hideDetails": "Ocultar detalhes do erro",
        "copy": "Copiar detalhes do erro para a área de transferência",
        "dismissOffline": "Fechar o aviso de falta de conexão"
      },
      "hideDetails": "Ocultar detalhes",
      "detailsCount": "Detalhes · {{count}}",
      "noDetails": "Nenhum detalhe capturado ainda.",
      "copy": {
        "unstable": {
          "title": "Conexão instável",
          "subtitle": "Pausamos as tentativas automáticas para economizar bateria. Toque em Tentar Novamente para tentar novamente.{{countHint}}"
        },
        "network": {
          "title": "Não conseguimos alcançar o servidor",
          "subtitle": "Verifique sua conexão com a internet.{{countHint}}"
        },
        "timeout": {
          "title": "Conexão lenta",
          "subtitle": "As solicitações estão levando mais tempo do que o habitual.{{countHint}}"
        },
        "server": {
          "title": "Algo deu errado",
          "subtitle": "Nossa equipe foi notificada. Tente novamente em um momento.{{countHint}}"
        },
        "default": {
          "title": "Problema de conexão",
          "subtitle": "Estamos tendo problemas para carregar seus dados.{{countHint}}"
        },
        "countHint_one": " ({{count}} solicitação com falha)",
        "countHint_other": " ({{count}} solicitações com falha)"
      },
      "offline": {
        "title": "Você está sem conexão",
        "subtitle": "Você está vendo o que já tinha sido carregado. O que você salvar é enviado quando a conexão voltar; o CoPilot e os envios de arquivos precisam de conexão."
      }
    },
    "apiError": {
      "network": "Não conseguimos alcançar o servidor. Verifique sua conexão.",
      "timeout": "A solicitação demorou muito. Tentaremos novamente automaticamente.",
      "unauthorized": "Sua sessão expirou. Por favor, faça login novamente.",
      "forbidden": "Você não tem permissão para isso.",
      "notFound": "Recurso não encontrado.",
      "badRequest": "Algo na solicitação estava inválido.",
      "serverError": "Algo deu errado do nosso lado. Estamos investigando.",
      "unknown": "Algo deu errado."
    },
    "relativeTime": {
      "justNow": "Agora mesmo",
      "minutesAgo_one": "{{count}} minuto atrás",
      "minutesAgo_other": "{{count}} minutos atrás",
      "hoursAgo_one": "{{count}} hora atrás",
      "hoursAgo_other": "{{count}} horas atrás",
      "daysAgo_one": "{{count}} dia atrás",
      "daysAgo_other": "{{count}} dias atrás"
    },
    "device": {
      "unknown": "Dispositivo desconhecido",
      "mobile": "Móvel",
      "desktop": "Desktop"
    },
    "browser": {
      "unknown": "Navegador desconhecido"
    },
    "location": {
      "unknown": "Localização desconhecida"
    },
    "searchCountry": "Pesquisar país...",
    "noCountryFound": "Nenhum país encontrado.",
    "phoneCode": "Código",
    "searchPhoneCode": "Pesquisar código de telefone...",
    "noPhoneCodeFound": "Nenhum código de telefone encontrado.",
    "untitled": "Sem título",
    "unassigned": "Não atribuído",
    "unknown": "Desconhecido",
    "member": "Membro",
    "phoneCountryCodeLabel": "Código do país",
    "pageOf": "Página {{page}} de {{total}}",
    "pagination": "Páginas",
    "daysAgo_one": "Há {{count}} dia",
    "daysAgo_other": "Há {{count}} dias",
    "rewardMiles_one": "Recompensa: {{count}} Mile",
    "rewardMiles_other": "Recompensa: {{count}} Miles",
    "removeItem": "Remover {{name}}",
    "milesGained_one": "+{{miles}} Mile",
    "milesGained_other": "+{{miles}} Miles",
    "aiBadge": "IA",
    "list": {
      "two": "{{first}} e {{second}}"
    },
    "heroTabs": {
      "label": "Seções de {{hero}}",
      "strip": "Seções",
      "scrollPrevious": "Mostrar as seções anteriores",
      "scrollNext": "Mostrar mais seções"
    },
    "timeRange": "{{from}}–{{to}}",
    "dateFormat": {
      "day": "dd",
      "month": "mm",
      "year": "aaaa"
    },
    "openSettings": "Abrir Configurações",
    "choosePhotoInstead": "Escolher uma foto",
    "photoLibraryUnavailable": "Não foi possível abrir suas fotos.",
    "aiUnavailable": {
      "title": "Alguns recursos estão temporariamente indisponíveis",
      "description": "Isto precisa da IA da Tonnie, que não consegue responder agora. Estamos tentando novamente — todo o resto na Tonnie funciona normalmente.",
      "retry": "Tentar novamente"
    }
  },
  "copilot": {
    "beta": {
      "badge": "Beta",
      "tooltipTitle": "Tonnie CoPilot está em beta",
      "tooltipBody": "Estamos melhorando ativamente — avalie as respostas com 👍 ou 👎 para nos ajudar a torná-las melhores.",
      "ariaLabel": "Sobre o beta Tonnie CoPilot"
    },
    "action": {
      "dismiss": "Dispensar",
      "goTo": "Ir para",
      "open": "Abrir"
    },
    "aiDisclaimer": "CoPilot usa IA. As respostas podem não ser sempre precisas.",
    "answered": "Respondido",
    "answersSubmitted": "Suas respostas foram enviadas",
    "askAnything": "Pergunte qualquer coisa...",
    "billingPage": "Página de cobrança",
    "brainAssessment": {
      "errorTitle": "Não foi possível carregar perguntas",
      "evaluating": {
        "subtitle": "Nossa IA está verificando sua resposta",
        "title": "Avaliando sua resposta…"
      },
      "feedback": {
        "correct": "Correto!",
        "incorrectEncouragement": "Espere um momento — você verá esse conceito novamente.",
        "incorrectHeadline": "Quase — aqui está a resposta",
        "movingOn": "Movendo para a próxima pergunta…",
        "next": "Próxima pergunta",
        "theAnswerIs": "A resposta é"
      },
      "level": {
        "advanced": {
          "label": "Avançado",
          "desc_one": "Excelente! {{count}} missão está marcada como opcional.",
          "desc_other": "Excelente! {{count}} missões estão marcadas como opcionais."
        },
        "beginner": {
          "desc": "Você está começando sua jornada! Todas as lições estão desbloqueadas e prontas para você.",
          "label": "Iniciante"
        },
        "intermediate": {
          "label": "Intermediário",
          "desc_one": "Ótimo conhecimento! {{count}} missão de iniciante está marcada como opcional.",
          "desc_other": "Ótimo conhecimento! {{count}} missões de iniciante estão marcadas como opcionais."
        }
      },
      "loading": "Carregando perguntas de avaliação…",
      "noQuestions": "Nenhuma pergunta disponível para este mundo.",
      "question": {
        "next": "Próxima pergunta",
        "openAnswerHint": "Sua resposta será avaliada pela IA. Leve seu tempo!",
        "openAnswerCounter": "{{count}} / {{max}} caracteres",
        "openAnswerMinHint": "Mínimo {{min}} caracteres ({{remaining}} restantes)",
        "openAnswerPlaceholder": "Digite sua resposta aqui…",
        "submitFinal": "Enviar & ver resultados"
      },
      "results": {
        "continue": "Continuar",
        "correct": "Correto",
        "questionDetails": "Detalhes da pergunta",
        "retake": "Refazer",
        "score": "Pontuação",
        "total": "Total",
        "yourAnswer": "Sua resposta",
        "skipNote_one": "{{count}} missão será marcada como opcional para o seu nível. Você ainda pode concluí-la para ganhar Miles.",
        "skipNote_other": "{{count}} missões serão marcadas como opcionais para o seu nível. Você ainda pode concluí-las para ganhar Miles."
      }
    },
    "brainSubtitle": "Powered by Tonnie Brain",
    "bringFamily": "Você está trazendo sua família?",
    "bringingFamilyNoProgram": "Trazendo família (sem programa)",
    "cameraError": "Erro na câmera",
    "cameraErrorTitle": "Câmera indisponível",
    "cameraPermissionDenied": "Permissão da câmera negada. Permita o acesso à câmera no seu navegador para gravar um vídeo.",
    "chatLog": "Mensagens de chat",
    "playVideo": "Reproduzir vídeo",
    "clickToPlay": "Clique para iniciar o vídeo",
    "close": "Fechar CoPilot",
    "confidence": "Confiança",
    "contextualGreeting": "Olá! Eu sou Tonnie CoPilot, seu assistente de IA contextual. {{context}}O que você gostaria de saber?",
    "couldImprove": "Pode melhorar",
    "createMyJourney": "Criar minha jornada",
    "dailyQuotaReached": "Cota diária atingida",
    "destination": "Para onde você está indo?",
    "disclaimer": "Suas respostas são privadas e usadas apenas para personalizar sua jornada.",
    "errorLoadingQuestions": "Erro ao carregar perguntas",
    "errorTitle": "Algo deu errado",
    "familyAddon": "Complemento Familiar incluído",
    "familyComingSoonNote": "O Programa Familiar estará disponível em breve. Por enquanto, sua jornada está configurada para uso individual.",
    "familyConfig": "Configuração familiar",
    "familyFeature1": "Convide membros da família (Companheiro & Membros da Família)",
    "familyFeature2": "Controle as permissões de acesso por herói",
    "familyFeature3": "Acompanhe o progresso ciente do núcleo familiar",
    "familyFeature4": "Gerencie a jornada da família juntos",
    "familyJoinQuestion": "Membros da família se juntarão a você nesta jornada?",
    "familyJoining": "Membros da família se juntarão à sua jornada",
    "familyProgramAddon": "Complemento do programa familiar",
    "familyProgramDesc": "Gerencie a jornada da sua família juntos com acesso compartilhado e rastreamento de progresso",
    "familyProgramEnabled": "Programa familiar ativado",
    "findings": {
      "emptyProfile": "Seu perfil ainda não tem nenhuma descoberta.",
      "expand": "Expandir",
      "looksGood": "Parece bom",
      "profile": "Perfil",
      "profileIntro": "Aqui está o que reunimos sobre seu perfil a partir de suas respostas.",
      "profileTitle": "Descobertas do perfil"
    },
    "fixErrors": "Corrigir erros",
    "formSubmittedNote": "Seu formulário foi enviado. Obrigado!",
    "goBack": "Voltar",
    "greeting": "Olá! Eu sou Tonnie CoPilot, seu assistente de IA. {{context}}O que você gostaria de saber?",
    "guide": {
      "newMessages": "Novas mensagens",
      "typeHere": "Digite aqui...",
      "avatarAlt": "CoPilot assistente de IA",
      "aria": {
        "stepOf": "Passo {{step}} de {{total}}"
      },
      "taskFallback": "Avaliação"
    },
    "guideCompleted": "Guia concluído",
    "guideCompletedDesc": "Você completou este guia.",
    "guideTitle": "Guia Tonnie CoPilot",
    "household": {
      "addChild": "Adicionar criança",
      "addPet": "Adicionar animal de estimação",
      "cat": "Gato",
      "child": "Criança",
      "childN": "Criança {{n}}",
      "children": "Crianças",
      "childrenDetails": "Conte-nos sobre cada criança que está se mudando com você.",
      "description": "Conte-nos quem está se mudando com você para que possamos personalizar sua jornada.",
      "dog": "Cachorro",
      "hasPassport": "Tem passaporte",
      "name": "Nome",
      "namePlaceholder": "Nome completo",
      "nationality": "Nacionalidade",
      "other": "Outro",
      "partner": "Parceiro",
      "partnerDetails": "Conte-nos sobre seu parceiro.",
      "pet": "Animal de estimação",
      "petN": "Animal de estimação {{n}}",
      "petName": "Nome do animal de estimação",
      "petNamePlaceholder": "Qual é o nome do seu animal de estimação?",
      "petVaccination": "Vacinações em dia",
      "pets": "Animais de estimação",
      "petsDetails": "Conte-nos sobre cada animal de estimação que está se mudando com você.",
      "relocating": "Mudando-se comigo",
      "selectCountry": "Selecione o país",
      "species": "Espécie",
      "title": "Seu núcleo familiar",
      "vaccinationOk": "Vacinações OK",
      "prefilledFromOnboarding": "Pré-preenchido com as respostas que você deu no cadastro. Confira e altere o que for diferente — nada é salvo até você confirmar.",
      "you": "Você"
    },
    "hybrid": {
      "complete": "Tudo pronto! Suas respostas foram registradas.",
      "error": "Algo deu errado. Vamos tentar novamente.",
      "escapeHatch": "Prefiro não responder a isso",
      "placeholder": "Digite sua resposta...",
      "progress": "Progresso",
      "selectOption": "Selecione uma opção",
      "stepOf": "Passo {{current}} de {{total}}",
      "title": "Entrevista guiada",
      "typeAnswer": "Digite sua resposta",
      "openingFallback": "Vamos começar."
    },
    "includedFeatures": "Recursos incluídos",
    "individualJourney": "Jornada individual",
    "inputPlaceholder": "Pergunte qualquer coisa a Tonnie...",
    "journeyPurpose": "Propósito da jornada",
    "journeyPurposes": "Propósitos da jornada",
    "journeyReady": "Sua jornada está pronta para ser desbloqueada!",
    "journeyRoute": "Rota da jornada",
    "journeyRouteDesc": "Selecione seus países de origem e destino",
    "journeySummary": "Resumo da sua jornada",
    "justMe": "Só eu",
    "lifecycle": {
      "acknowledge": {
        "default": "Entendo que esta ação não pode ser desfeita."
      },
      "autosave": {
        "justNow": "agora mesmo",
        "offline": "Offline — tentará novamente",
        "saved": "Salvo · {{relative}}",
        "saving": "Salvando…",
        "unsaved": "Salvamento pendente"
      },
      "completion": {
        "errorBody": "Algo deu errado ao salvar suas respostas. Você pode tentar novamente — seu trabalho ainda está aqui.",
        "errorTitle": "Não foi possível salvar seus resultados",
        "saving": "Salvando seus resultados…",
        "successBody": "Suas respostas estão salvas. Levando você ao seu painel.",
        "successContinue": "Continuar",
        "successRedirect": "Redirecionando em {{seconds}}…",
        "successStay": "Fique aqui",
        "successTitle": "Tudo pronto!"
      },
      "confirm": {
        "stepLabel": "Passo {{currentStep}} de {{totalSteps}} · {{progress}}%"
      },
      "discard": {
        "body": "Você está {{progress}}% concluído. Se você cancelar agora, seu trabalho nesta tentativa será excluído.",
        "bodyTeleportalSetup": "Suas tarefas existentes de TelePortal permanecem como estão. Suas respostas em rascunho desta sessão não serão salvas.",
        "confirm": "Sim, descartar",
        "keep": {
          "history": "Qualquer resultado anterior concluído",
          "teleportalTasks": "Suas tarefas existentes de TelePortal"
        },
        "lose": {
          "answers": "Suas respostas atuais ({{progress}}%)",
          "position": "Seu lugar no passo {{currentStep}}",
          "teleportalDraft": "Respostas em rascunho desta sessão",
          "teleportalPosition": "Você perderá seu progresso TelePortal nesta jornada"
        },
        "titleTeleportalSetup": "Pular a configuração por enquanto?",
        "confirmTeleportalSetup": "Sim, descartar esta tentativa",
        "titleCheckup": "Descartar o progresso do seu CheckUp?",
        "titleCareAssessment": "Descartar o progresso da sua avaliação Care?",
        "titleQultureup": "Descartar o progresso do seu teste de nível QultureUp?",
        "titleJourneyBuilder": "Descartar a jornada que você está criando?"
      },
      "keep": {
        "empty": "Nada é transferido.",
        "title": "Mantendo"
      },
      "leave": {
        "body": "Seu progresso até o passo {{currentStep}} já está salvo. Retome isso a qualquer momento.",
        "confirm": "Sim, afastar-se",
        "keep": {
          "answers": "Cada resposta que você completou",
          "progress": "Seu progresso até agora ({{progress}}%)"
        },
        "title": "Afastar-se por enquanto?"
      },
      "lose": {
        "empty": "Nada é excluído.",
        "title": "Perdendo"
      },
      "restart": {
        "body": "Suas respostas atuais serão limpas. Você começará do zero no passo 1.",
        "bodyJourneyBuilder": "Você começará o construtor de jornada novamente. Suas respostas em andamento serão limpas.",
        "bodyTeleportalSetup": "Suas respostas anteriores serão preenchidas automaticamente. A conversa começa novamente do início, e sua lista de tarefas será reconstruída.",
        "confirm": "Sim, reiniciar",
        "keep": {
          "history": "Seu resultado anterior (se houver)"
        },
        "lose": {
          "answers": "Suas respostas atuais ({{progress}}%)",
          "builderAnswers": "Suas respostas em andamento do construtor",
          "position": "Seu lugar no passo {{currentStep}}"
        },
        "title": "Reiniciar do passo 1?",
        "titleJourneyBuilder": "Reiniciar o construtor de jornada?",
        "titleTeleportalSetup": "Redefinir sua configuração TelePortal?"
      },
      "retake": {
        "bodyCare": "Sua avaliação anterior Care está arquivada. A conversa começa do zero a partir do passo 1.",
        "bodyCheckup": "Seu resultado anterior CheckUp está arquivado. A conversa começa do zero a partir do passo 1.",
        "bodyQultureup": "Apenas o teste de nível inicial é executado novamente — suas missões e conquistas permanecem intactas.",
        "confirm": "Sim, refazer",
        "keep": {
          "archived": "Seu resultado anterior (mantido na história)",
          "miles": "Todas as suas Miles conquistadas",
          "missions": "Seu progresso na missão"
        },
        "lose": {
          "activeScore": "Sua pontuação ativa e distintivo"
        },
        "titleCheckup": "Refazer seu CheckUp?",
        "titleCare": "Refazer sua avaliação Care?",
        "titleQultureup": "Refazer seu teste de nível QultureUp?"
      },
      "reversible": {
        "no": "Não pode ser desfeito",
        "yes": "Você pode voltar a isso"
      },
      "stay": "Ficar",
      "toolbar": {
        "discard": "Descartar",
        "discardHint": "Cancelar esta tentativa e sair. Suas respostas são excluídas.",
        "restart": "Reiniciar",
        "restartHint": "Limpar suas respostas e começar de novo da etapa 1."
      },
      "aria": {
        "whatChanges": "Quais mudanças"
      }
    },
    "loadingQuestions": "Carregando perguntas…",
    "maxChars": "Máx {{max}} caracteres",
    "validation": {
      "required": "Esta pergunta é obrigatória.",
      "thin": "Uma resposta curta está ok — mais algumas frases nos dão mais com o que trabalhar ({{words}} palavras até agora).",
      "tooLong": "Muito longo — por favor, mantenha abaixo de {{max}} caracteres.",
      "ok": "Parece ótimo — claro e detalhado."
    },
    "suggestedWords": "Tente escrever {{min}}+ palavras",
    "typeAnswer": "Escreva sua resposta",
    "words_one": "{{count}} palavra",
    "words_other": "{{count}} palavras",
    "motivationalAssessment": "Avaliação de motivação",
    "motivationalDesc": "Uma breve reflexão para nos ajudar a entender o que motiva seu movimento.",
    "needsFix": "Precisa de correção",
    "nextVideo": "Próximo vídeo",
    "noCountriesFound": "Nenhum país encontrado",
    "noQuestionsForPersona": "Ainda não temos perguntas para este perfil.",
    "noVideoData": "Nenhum dado de vídeo",
    "noVideos": "Nenhum vídeo disponível.",
    "notAnsweredYet": "Ainda não respondido",
    "optional": "Opcional",
    "origin": "De onde você é?",
    "pitch": {
      "fileTooLarge": "Este arquivo de vídeo é grande demais para enviar. Escolha um arquivo menor ou grave seu pitch aqui.",
      "tooLong": "Este vídeo tem mais de {{minutes}} minutos. Escolha um vídeo mais curto ou grave seu pitch aqui.",
      "uploadStalled": "O envio parou porque sua conexão deixou de enviar dados. Verifique sua conexão e tente novamente.",
      "unreadable": "Não conseguimos ler este vídeo, então não é possível verificar a duração. Escolha um vídeo MP4 ou WebM que seja reproduzido neste dispositivo ou grave seu pitch aqui."
    },
    "pitchRecorder": "Gravador de pitch",
    "practiceNote": "Dica: pratique uma vez antes de gravar.",
    "previousVideo": "Vídeo anterior",
    "progressComplete": "{{percent}}% completo",
    "questionN": "Pergunta {{n}}",
    "questionNofM": "Pergunta {{n}} de {{m}}",
    "questions": "Perguntas",
    "questionsLoadError": "Falha ao carregar perguntas",
    "questionsUnavailable": "Perguntas indisponíveis",
    "quota": {
      "exceeded": "Limite diário alcançado. Atualize seu plano para mais mensagens.",
      "remaining": "Mensagens restantes",
      "upgrade": "Atualize para mais"
    },
    "quotaReached": "Cota alcançada! Faça upgrade para Pro para acesso ilimitado.",
    "ready": "Pronto",
    "readyQ": "Pronto para começar?",
    "recordAnswer": "Gravar resposta",
    "recordYourPitch": "Gravar sua apresentação",
    "required": "Requerido",
    "responseCare": "Seu feedback Care mostra melhoria em Comunicação e Habilidades Técnicas. Continue o ótimo trabalho! Para Comportamento e Adaptação, considere se juntar a comunidades locais e eventos de networking.",
    "responseCareer": "Com base no seu perfil, você está bem posicionado para oportunidades em Portugal. Suas habilidades técnicas são fortes e seu nível de inglês é excelente. Eu sugeriria focar na prática do idioma português para aumentar sua taxa de correspondência.",
    "responseCheckup": "Com base nos seus resultados CheckUp, vejo que você está indo bem! Sua pontuação de prontidão de 85 mostra forte preparação. Eu recomendaria focar na adaptação cultural, que está em 75. Considere completar lições de QultureUp para melhorar essa área.",
    "responseDefault": "Entendo sua pergunta. Deixe-me ajudá-lo com isso.",
    "responseHelp": "Estou aqui para ajudar! Posso auxiliá-lo a entender seus resultados CheckUp, navegar nas tarefas TelePortal, aprender sobre a cultura em QultureUp, acompanhar seu progresso em Care e encontrar oportunidades de carreira. Em que área específica você gostaria de ajuda?",
    "responseQultureup": "Ótimo que você está interessado em QultureUp! Recomendo começar com o mundo 'Cultura Local' para se familiarizar com os costumes e tradições portuguesas. Isso ajudará você a se adaptar mais rápido quando chegar.",
    "responseScore": "Sua pontuação atual de prontidão é 85/100, o que é excelente! Você está na categoria 'Quase Pronto'. As principais áreas a focar são Adaptação Cultural (75) e Experiência Internacional (70). Você gostaria de recomendações específicas?",
    "responseTeleportal": "Para sua jornada TelePortal, vejo que você está na fase de Preparação de Visto. Certifique-se de reunir todos os documentos necessários e agendar sua entrevista. Você gostaria que eu o ajudasse com uma tarefa específica?",
    "responseVisa": "Para sua relocação, recomendo começar com a Avaliação TelePortal para obter uma lista de verificação personalizada. Certifique-se de ter todos os documentos necessários prontos. O processo de visto geralmente leva de 2 a 3 meses, então planeje-se adequadamente.",
    "restartFlow": "Reiniciar",
    "reviewAnswers": "Revisar respostas",
    "reviewDesc": "Reserve um momento para revisar suas respostas antes de enviar.",
    "reviewJourney": "Revise sua configuração de jornada antes de prepará-la para você",
    "reviewYourAnswers": "Revisar suas respostas",
    "safety": {
      "critical": "Você não precisa passar por isso sem ajuda — basta uma ligação.",
      "elevated": "Este tópico requer consideração cuidadosa. CoPilot fornece orientações gerais apenas — consulte um profissional para conselhos específicos.",
      "standard": "CoPilot usa IA. As respostas podem não ser sempre precisas. Sempre verifique informações importantes.",
      "getHelp": "Obter ajuda",
      "help": {
        "title": "Ajuda, agora",
        "intro": "Se você ou alguém perto de você estiver em perigo, ligue agora — estas linhas atendem dia e noite.",
        "lines": {
          "emergency": "Número europeu de emergência",
          "sns24": "SNS 24 — saúde e apoio psicológico"
        },
        "availability": {
          "always": "24 horas, todos os dias"
        },
        "care": "Falar com o suporte do Care",
        "careHint": "O Care tem uma equipe e recursos para o que você está sentindo."
      }
    },
    "sameCountryWarning": "Origem e destino não podem ser o mesmo país.",
    "saved": "Salvo",
    "saving": "Salvando…",
    "searchCountry": "Pesquisar país...",
    "selectCountry": "Selecionar...",
    "selectedAsDest": "Selecionado como destino",
    "selectedAsOrigin": "Selecionado como origem",
    "send": "Enviar",
    "situation": {
      "answered": "Respondido",
      "companyProvides": "Minha empresa fornece isso",
      "companySponsored": "Patrocinado pela empresa",
      "companySponsoredDesc": "Meu empregador está patrocinando minha realocação.",
      "description": "Escolha a opção que melhor descreve sua situação.",
      "digitalNomad": "Nômade digital",
      "digitalNomadDesc": "Vou trabalhar remotamente do meu novo país.",
      "employedSelf": "Estou empregado e me mudando por conta própria",
      "employedSponsored": "Estou empregado e minha empresa patrocina a mudança",
      "entrepreneur": "Empreendedor",
      "euCitizen": "Cidadão da UE",
      "euCitizenDesc": "Sou cidadão da UE e não preciso de visto.",
      "familyReunion": "Reunião familiar",
      "familyReunionDesc": "Estou me juntando à família que já está no exterior.",
      "haveHousing": "Já tenho moradia arranjada",
      "haveVisa": "Já tenho um visto",
      "haveVisaDesc": "Consegui meu visto para esta mudança.",
      "housingTitle": "Situação de moradia",
      "jobSeeking": "Procurando um emprego",
      "legalTitle": "Situação legal",
      "needFind": "Preciso encontrar moradia",
      "needTemp": "Preciso de moradia temporária",
      "needVisa": "Preciso obter um visto",
      "needVisaDesc": "Ainda não solicitei um visto.",
      "pathwayTitle": "Caminho do visto",
      "pathwaysUnavailable": "Não foi possível carregar os caminhos de visto. Você pode continuar sem escolher um.",
      "credentialTitle": "Profissão regulamentada",
      "credentialQuestion": "Você trabalha em uma profissão regulamentada (por exemplo medicina, enfermagem, engenharia ou direito) no país para onde vai se mudar? Se sim, sua qualificação precisa ser reconhecida lá antes de você poder exercer.",
      "credentialYes": "Sim, minha profissão é regulamentada",
      "credentialNo": "Não",
      "pathway": {
        "workPermit": "Permissão de trabalho (patrocinada)",
        "workPermitDesc": "Residência patrocinada pelo empregador",
        "techVisa": "Visto tech",
        "techVisaDesc": "Contratação de tecnologia por empresa certificada",
        "d7": "D7 — Renda passiva / remota",
        "d7Desc": "Baseado em renda ou trabalho remoto",
        "euFamily": "Reunião familiar da UE",
        "euFamilyDesc": "Nacional da UE ou se juntando à família",
        "d1": "D1 — Visto de trabalho",
        "d1Desc": "Emprego assalariado com um empregador",
        "d2": "D2 — Empreendedor / trabalhador autônomo",
        "d2Desc": "Negócio próprio ou atividade autônoma",
        "d8": "D8 — Nômade digital",
        "d8Desc": "Trabalho remoto para empregadores ou clientes no exterior",
        "startup": "Visto de startup",
        "startupDesc": "Criação de uma startup inovadora",
        "notSure": "Ainda não tenho certeza",
        "notSureDesc": "Tonnie ajudará a determinar isso"
      },
      "professionalTitle": "Situação profissional",
      "retired": "Aposentado",
      "selfEmployed": "Autônomo",
      "student": "Estudante",
      "studentVisa": "Visto de estudante",
      "studentVisaDesc": "Estou me mudando com um visto de estudante.",
      "title": "Sua situação"
    },
    "submitFailed": "Falha ao enviar",
    "subtitle": "Seu assistente de IA está aqui para ajudar",
    "suggestedQuestions": "Perguntas sugeridas:",
    "thinking": "Pensando...",
    "title": "Tonnie CoPilot",
    "launcher": {
      "label": "Perguntar à Tonnie"
    },
    "toggle": "Alternar CoPilot",
    "trace": {
      "artifactUpdate": "Artifact atualizado",
      "cancel": "Cancelar",
      "completeness": "Integridade",
      "confirm": "Confirmar",
      "error": "Erro",
      "retry": "Tentar novamente",
      "widget": "Widget"
    },
    "tryAgain": "Tente novamente",
    "unavailable": "CoPilot está temporariamente indisponível. Por favor, tente novamente em um momento.",
    "unlimited": "Plano Pro: Consultas ilimitadas",
    "unlimitedQuestions": "Perguntas ilimitadas",
    "unlockNote": "Sua jornada personalizada foi criada. Desbloqueie-a a partir do",
    "upgrade": "Atualizar",
    "upgradeToPro": "Atualizar para Pro",
    "uploadNote": "Manteremos seu vídeo privado — apenas você e nossa IA o verão.",
    "uploadingVideo": "Carregando vídeo…",
    "verifiedByTonnieGuard": "Verificado por Tonnie guard",
    "videoCompleted": "Completo",
    "videoPlayerDesc": "Reprodutor de vídeo para {{title}}. Clique em play para iniciar o vídeo.",
    "videoResume": "Retomar",
    "videoSent": "Vídeo enviado",
    "videoStateInProgress": "Em andamento",
    "videoStatePending": "Não assistido",
    "videoStateWatched": "Assistido",
    "videoSubmitted": "Vídeo submetido",
    "videoToWatch": "Assistir",
    "videoUploadFailed": "Falha no upload do vídeo",
    "videoWatchedLabel": "Assistido",
    "videosWatched": "vídeos assistidos",
    "voice": {
      "error": "Desculpe, não entendi. Tente novamente.",
      "status": {
        "listening": "Estou ouvindo...",
        "transcribing": "Transcrevendo…"
      },
      "a11y": {
        "pause": "Pausar escuta",
        "start": "Iniciar entrada de voz"
      }
    },
    "whyWeAsk": "Por que perguntamos",
    "widgetError": "Este widget falhou ao carregar.",
    "widgetNotFound": "Widget \"{{name}}\" não encontrado",
    "yesBringingFamily": "Sim, trazendo a família",
    "aria": {
      "conversation": "Conversa",
      "messageInput": "Mensagem",
      "sendMessage": "Enviar mensagem",
      "answerInput": "Sua resposta"
    },
    "tools": {
      "checkingCohorts": "Verificando seus programas…",
      "checkingJourney": "Verificando sua jornada…",
      "checkingTasks": "Verificando suas tarefas…",
      "checkingCheckup": "Verificando seu CheckUp…",
      "checkingCare": "Verificando seu bem-estar…",
      "checkingObjectives": "Verificando seus objetivos Care…",
      "checkingPassport": "Verificando seu Passport…",
      "checkingMiles": "Verificando suas milhas…",
      "checkingNotifications": "Verificando suas notificações…",
      "checkingHousehold": "Verificando seu núcleo familiar…",
      "checkingBilling": "Verificando sua cobrança…",
      "checkingCareer": "Verificando oportunidades de carreira…",
      "submittingCheckpoint": "Enviando seu ponto de verificação…",
      "creatingSupport": "Abrindo um pedido de suporte…",
      "schedulingCheckpoints": "Agendando seus pontos de verificação…",
      "submittingSelfEval": "Enviando sua autoavaliação…",
      "completingMission": "Concluindo sua missão…",
      "submittingQuiz": "Enviando seu quiz…",
      "markingRead": "Atualizando suas notificações…",
      "addingMember": "Adicionando um membro da família…",
      "updatingMember": "Atualizando um membro da família…",
      "savingOpportunity": "Salvando a oportunidade…",
      "expressingInterest": "Enviando seu interesse…",
      "checkingDocuments": "Verificando seus documentos…",
      "checkingProfile": "Verificando seu perfil…",
      "checkingMesh": "Verificando seu MESH…",
      "checkingQultureup": "Verificando seu QultureUp…",
      "checkingWorlds": "Verificando seus mundos…",
      "savingToVault": "Salvando no seu Vault…",
      "attachingFile": "Anexando o arquivo…",
      "updatingTask": "Atualizando a tarefa…",
      "startingMission": "Iniciando a missão…",
      "checkingProgramSetup": "Verificando a configuração do seu programa…",
      "reopeningTask": "Reabrindo a tarefa…",
      "completingTask": "Concluindo a tarefa…",
      "submittingCheckin": "Registrando seu check-in…",
      "startingRetake": "Iniciando seu CheckUp…",
      "recallingMemories": "Verificando o que eu lembro…",
      "rememberingFact": "Fazendo uma anotação…",
      "forgettingFact": "Esquecendo isso…",
      "searchingKnowledge": "Verificando a base de conhecimento…",
      "readingNote": "Lendo sobre isso…",
      "listingPipelineTalents": "Verificando seu pipeline de talentos…",
      "checkingTalentOverview": "Verificando a visão geral dos talentos…",
      "checkingTalentReadiness": "Verificando a prontidão dos talentos…",
      "checkingTalentMobility": "Verificando o progresso de realocação dos talentos…",
      "checkingTalentAdaptation": "Verificando a adaptação dos talentos…",
      "checkingTalentRisk": "Verificando o bem-estar e risco dos talentos…",
      "checkingTalentEvidence": "Verificando as evidências dos talentos…",
      "checkingCohort": "Verificando a coorte…",
      "checkingProgram": "Verificando o programa…",
      "checkingPipeline": "Verificando seu pipeline…",
      "checkingAffiliate": "Verificando sua conta de afiliado…",
      "checkingPoolCounts": "Contando seu pool de talentos…",
      "checkingPoolTalent": "Verificando o talento do pool…",
      "searchingWeb": "Pesquisando na web…",
      "sponsoringTalent": "Preparando o patrocínio…",
      "addingTalentToCohort": "Adicionando o talento à coorte…",
      "addingTalentNote": "Adicionando uma nota interna…",
      "savingVettingDocument": "Salvando o documento de triagem…",
      "checkingMyWorkQueue": "Verificando o que precisa de você…",
      "messagingTalent": "Preparando sua mensagem…",
      "requestingCheckin": "Preparando um pedido de check-in…",
      "schedulingMeeting": "Preparando o convite…",
      "checkingCompany": "Verificando o perfil da sua empresa…",
      "checkingPrograms": "Verificando seus programas…",
      "checkingDashboard": "Verificando seu painel…",
      "checkingActivity": "Verificando a atividade recente…",
      "checkingAnalytics": "Verificando suas análises…",
      "checkingVetting": "Verificando sua visão geral de triagem…",
      "checkingMobility": "Verificando sua visão geral de mobilidade…",
      "checkingAdaptation": "Verificando sua visão geral de adaptação…",
      "checkingEvidence": "Verificando sua visão geral de evidências…",
      "checkingCareConfig": "Verificando a configuração do seu Care…",
      "checkingInvoices": "Verificando suas faturas…",
      "checkingSponsorships": "Verificando seus patrocínios…",
      "checkingTeam": "Verificando sua equipe…",
      "checkingMessageTemplates": "Verificando seus modelos de mensagem…",
      "checkingMessageAnalytics": "Verificando suas análises de mensagem…",
      "checkingAuditLog": "Verificando seu log de auditoria…",
      "creatingProgram": "Preparando o novo programa…",
      "creatingCohort": "Preparando a nova coorte…",
      "invitingTeamMember": "Preparando o convite para a equipe…",
      "removingTeamMember": "Preparando para remover o membro da equipe…",
      "resolvingInteraction": "Atualizando a interação do Care…",
      "reschedulingInteraction": "Reprogramando a interação do Care…",
      "cancellingInteraction": "Cancelando a interação do Care…",
      "commentingInteraction": "Adicionando seu comentário…",
      "working": "Trabalhando…",
      "preparingNextStep": "Preparando seu próximo passo…",
      "checkingInOut": "Verificando seus relógios do InOut…",
      "simulatingTrip": "Simulando sua viagem…"
    },
    "errors": {
      "quota_exceeded": "Você atingiu seu limite diário de mensagens. Ele será redefinido à meia-noite.",
      "budget_degraded": "Estou operando em um modo limitado agora — ainda posso ajudar com respostas concretas.",
      "provider_unavailable": "Estou tendo dificuldades para alcançar minhas capacidades completas agora. Por favor, tente novamente em um momento.",
      "capability_disabled": "Essa capacidade está temporariamente indisponível.",
      "stale_proposal": "Isso mudou desde que eu sugeri — pergunte-me novamente e eu darei uma nova olhada.",
      "aborted": "Parado.",
      "internal": "Algo deu errado do meu lado. Por favor, tente novamente.",
      "messageRequired": "Por favor, digite uma mensagem primeiro.",
      "uploadFailed": "Upload falhou. Por favor, tente novamente.",
      "ref": "Referência"
    },
    "source": {
      "from": "De",
      "why": "Por que você pode confiar nisso",
      "cases": "{{n}} realocações semelhantes",
      "webSources": "Fontes"
    },
    "webSearch": {
      "toggle": "Pesquisar na web",
      "toggleHint": "Deixe Tonnie procurar informações atuais na web para esta pergunta"
    },
    "feedback": {
      "helpful": "Útil",
      "notHelpful": "Não útil",
      "thanks": "Obrigado pelo feedback"
    },
    "toolResult": {
      "success": "Concluído",
      "failed": "Isso não funcionou"
    },
    "suggestions": {
      "complete_checkup": {
        "title": "Conclua seu CheckUp"
      },
      "explore_qultureup": {
        "title": "Explore o QultureUp"
      },
      "check_passport": {
        "title": "Veja seu progresso"
      },
      "checkup_incomplete": {
        "title": "Quer terminar seu CheckUp? Posso te ajudar com isso."
      },
      "tasks_blocked": {
        "title_one": "Você tem {{count}} tarefa bloqueada — quer ajuda para desbloqueá-la?",
        "title_other": "Você tem {{count}} tarefas bloqueadas — quer ajuda para desbloqueá-las?"
      },
      "care_pending": {
        "title_one": "Você tem {{count}} check-in aguardando — vamos fazê-lo?",
        "title_other": "Você tem {{count}} check-ins aguardando — vamos fazê-los?"
      },
      "docs_expiring": {
        "title_one": "{{count}} documento está prestes a expirar — quer revisá-lo?",
        "title_other": "{{count}} documentos estão prestes a expirar — quer revisá-los?"
      },
      "checkup_result_published": {
        "title": "Seus resultados estão prontos — quer que eu te explique?"
      },
      "vetting_backlog": {
        "title_one": "{{count}} talento está aguardando no Vetting — quer revisá-lo?",
        "title_other": "{{count}} talentos estão aguardando no Vetting — quer revisá-los?"
      },
      "care_overdue": {
        "title_one": "{{count}} checkpoint de Care está atrasado — quer ver quem precisa de atenção?",
        "title_other": "{{count}} checkpoints de Care estão atrasados — quer ver quem precisa de atenção?"
      }
    },
    "proposal": {
      "aria": "Confirmação de ação",
      "confirm": "Confirmar",
      "confirming": "Confirmando…",
      "dismiss": "Agora não",
      "expired": "Esta oferta expirou — pergunte-me novamente.",
      "stale": "Isso mudou desde que eu sugeri — pergunte-me novamente.",
      "error": "Algo deu errado. Por favor, tente novamente.",
      "untrustedWarning": "Isso veio de um arquivo enviado — revise antes de confirmar.",
      "typeToConfirm": "Digite {{token}} para confirmar",
      "confirmed": "✓ Feito — eu completei isso para você.",
      "alreadyCheckedIn": "Você já registrou um check-in hoje, então nada novo foi adicionado.",
      "attachedCompletionPending": "✓ Arquivo anexado — mas a tarefa ainda não está completa; alguns documentos obrigatórios ainda estão faltando."
    },
    "attachFile": "Anexar um arquivo",
    "proactive": {
      "dismiss": "Dispensar"
    },
    "newConversation": "Nova conversa",
    "choices": {
      "label": "Opções sugeridas",
      "other": "Outros…"
    },
    "removeAttachment": "Remover arquivo",
    "depth": {
      "label": "Comprimento da resposta",
      "brief": "Breve",
      "balanced": "Equilibrado",
      "detailed": "Detalhado",
      "briefHint": "Respostas curtas e diretas",
      "balancedHint": "Detalhe equilibrado (padrão)",
      "detailedHint": "Respostas completas e detalhadas"
    },
    "rewrite": {
      "shorter": "Mais curto",
      "longer": "Mais longo",
      "shorterCommand": "Torne sua resposta anterior mais curta e direta, na mesma língua.",
      "longerCommand": "Expanda sua resposta anterior com mais detalhes e explicações, na mesma língua."
    },
    "attach": {
      "takePhoto": "Tire uma foto",
      "choosePhoto": "Escolha uma foto",
      "recordVideo": "Grave um vídeo",
      "chooseVideo": "Escolha um vídeo",
      "videoTooLarge": "Esse vídeo é muito grande. Grave um clipe mais curto (até 25 MB) e tente novamente."
    },
    "permissions": {
      "cameraTitle": "Câmera indisponível",
      "cameraDenied": "Permita o acesso à câmera nas configurações do seu dispositivo para que você possa mostrar uma foto ou vídeo para a Tonnie.",
      "libraryTitle": "Biblioteca de fotos indisponível",
      "libraryUnavailable": "Não conseguimos abrir sua biblioteca de fotos. Tente novamente ou permita o acesso nas configurações do seu dispositivo.",
      "microphoneDenied": "Permita o acesso ao microfone nas configurações do seu dispositivo para que você possa falar com a Tonnie em vez de digitar."
    },
    "history": {
      "title": "Conversas",
      "back": "Voltar para o chat",
      "newChat": "Novo chat",
      "searchPlaceholder": "Pesquisar conversas",
      "empty": "Nenhuma conversa ainda",
      "emptySearch": "Sem correspondências",
      "untitled": "Sem título",
      "rename": "Renomear",
      "delete": "Excluir",
      "actions": "Ações da conversa",
      "deleteTitle": "Excluir conversa?",
      "deleteBody": "Esta conversa será removida do seu histórico. Isso não pode ser desfeito.",
      "cancel": "Cancelar"
    },
    "familyFromProfile": "Do seu perfil — altere se agora for diferente.",
    "originShort": "Origem",
    "destinationShort": "Destino",
    "actionsAvailable_one": "{{count}} ação disponível",
    "actionsAvailable_other": "{{count}} ações disponíveis",
    "questionsRemaining_one": "{{count}} pergunta restante hoje",
    "questionsRemaining_other": "{{count}} perguntas restantes hoje",
    "offer": {
      "title": "Seu próximo passo com a {{partner}}",
      "kind": {
        "CONSULTATION": "Consulta especializada",
        "REQUISITION": "Requisição — a assessoria cuida do seu pedido"
      },
      "vatIncluded": "Impostos incluídos",
      "credit": "O valor pago pela consulta é abatido da requisição.",
      "open": "Continuar",
      "openOnWeb": "Continuar na web",
      "website": "Sobre a {{partner}}"
    },
    "aiUnavailable": {
      "description": "O CoPilot não consegue responder agora. Estamos tentando novamente — todo o resto na Tonnie funciona normalmente."
    }
  },
  "coupon": {
    "applied": "Cupom {{code}} aplicado com sucesso!",
    "apply": "Aplicar",
    "enterCode": "Digite o código do cupom",
    "error": "Falha ao aplicar o cupom. Por favor, tente novamente.",
    "invalid": "Código de cupom inválido"
  },
  "cvBuilder": {
    "addExperience": "Adicionar experiência",
    "addSkill": "Adicionar habilidade",
    "aiOptimize": "Otimizar IA para o mercado de Portugal",
    "clickEditToExpand": "Clique em Editar para expandir esta seção",
    "complete": "completo",
    "completeAllSections": "Complete todas as seções para os melhores resultados",
    "copilotSuggestions": "Sugestões de CoPilot",
    "cvCompleteness": "Integridade do CV",
    "cvSections": "Seções do CV",
    "deleteExperience": "Excluir experiência",
    "description": "Crie um CV profissional adaptado ao seu mercado-alvo",
    "editExperience": "Editar experiência",
    "editSection": "Editar seção",
    "education": "Educação",
    "exportDescription": "Na produção, isso geraria seu arquivo de CV.",
    "exportFileDesc": "CV_{{firstName}}_{{lastName}}.{{format}} seria baixado.",
    "exportPDF": "Exportar PDF",
    "exportSuccess": "{{format}} exportado com sucesso!",
    "exportWord": "Exportar word",
    "fullName": "Nome completo",
    "generatingExport": "Gerando exportação {{format}}...",
    "importLinkedIn": "Importar do PDF do LinkedIn",
    "items": "itens",
    "languages": "Idiomas",
    "location": "Localização",
    "mockEducation1": {
      "degree": "Bacharel em ciência da computação",
      "institution": "Universidade de tecnologia",
      "period": "2014–2018"
    },
    "mockExperience1": {
      "company": "Tech solutions inc.",
      "description": "Liderou o desenvolvimento de aplicações web escaláveis. Colaborou com equipes internacionais.",
      "period": "2020 — Presente",
      "role": "Engenheiro de software sênior"
    },
    "mockExperience2": {
      "company": "StartupXYZ",
      "description": "Construiu e manteve aplicações web usando React e Node.js.",
      "period": "2018–2020",
      "role": "Desenvolvedor full-stack"
    },
    "personalInfo": "Informações pessoais",
    "phone": "Telefone",
    "preview": "Pré-visualizar",
    "professionalSummary": "Resumo profissional",
    "quickActions": "Ações rápidas",
    "removeSkill": "Remover habilidade",
    "skills": "Habilidades",
    "suggestAddSkills": "Adicione mais habilidades relevantes para sua função alvo (5 mais recomendadas)",
    "suggestExpandSummary": "Expanda seu resumo profissional com conquistas chave",
    "template": "Modelo",
    "templates": {
      "classic": "Clássico",
      "creative": "Criativo",
      "minimal": "Minimalista",
      "modern": "Moderno"
    },
    "title": "Construtor de CV",
    "translateToPortuguese": "Traduzir para Português",
    "wizard": {
      "applyChanges": "Aplicar alterações",
      "applying": "Aplicando...",
      "backToEdit": "Voltar para editar",
      "characters": "caracteres",
      "clickNextToGenerate": "Clique em Gerar para criar seu CV personalizado",
      "company": "Empresa",
      "companyPlaceholder": "ex: TechCorp Solutions",
      "completeAllSteps": "Por favor, complete todas as etapas antes de salvar",
      "createFirstCV": "Crie seu primeiro CV para começar",
      "cvDeleted": "CV excluído com sucesso!",
      "cvGeneratedDescription": "Seu CV foi gerado e salvo. Você pode agora revisar e editar cada seção, ou exportá-lo diretamente.",
      "cvGeneratedSuccess": "CV gerado com sucesso!",
      "cvSaved": "CV salvo com sucesso!",
      "cvUpdated": "CV atualizado com sucesso!",
      "defaultJobTitle": "esta posição",
      "deleteConfirm": "Você tem certeza de que deseja excluir este CV?",
      "deleteConfirmTitle": "Excluir CV",
      "description": "Gere CVs profissionais adaptados às descrições de trabalho usando seus dados de Jornada",
      "done": "Concluído",
      "dragDropFile": "Arraste e solte um arquivo aqui, ou clique para selecionar",
      "edit": "Editar",
      "enterPrompt": "Por favor, insira instruções de refinamento",
      "fileSelected": "Arquivo selecionado",
      "fileUploaded": "Arquivo enviado: {{fileName}}",
      "generateCV": "Gerar CV",
      "generatedEducation": "{{degree}} da {{institution}} ({{period}})",
      "generatedExperience": "{{role}} na {{company}} ({{period}})\n{{description}}",
      "generatedReadiness": "Pontuação de prontidão internacional: {{iqulture}}/100\nanálise de MESH: Motivação {{motivation}}% • Inglês {{english}}% • Habilidades sociais {{softSkills}}% • Habilidades técnicas {{hardSkills}}%",
      "generatedSummary": "Profissional experiente com pontuação de prontidão internacional de {{iqulture}}/100. {{name}} traz forte expertise técnica e comprovada adaptabilidade a ambientes internacionais, tornando-os um candidato ideal para {{jobTitle}}.",
      "generating": "Gerando...",
      "generatingCV": "Gerando seu CV...",
      "generatingDescription": "A IA está analisando seu perfil e os requisitos do trabalho",
      "invalidFileType": "Tipo de arquivo inválido. Por favor, envie arquivos .txt, .doc, .docx ou .pdf.",
      "jobDescription": "Descrição do trabalho",
      "jobDescriptionPlaceholder": "Cole a descrição completa do trabalho aqui...",
      "jobTitle": "Título do trabalho",
      "jobTitlePlaceholder": "ex: Engenheiro de Software Sênior",
      "newCV": "Novo CV",
      "next": "Próximo",
      "noCVs": "Nenhum CV ainda",
      "of": "de",
      "optional": "(Opcional)",
      "orCreateNew": "ou crie um novo",
      "orUploadFile": "Ou carregue o arquivo da descrição do trabalho",
      "preview": "Pré-visualizar",
      "previous": "Anterior",
      "promptPlaceholder": "Ex: Adicione mais detalhes sobre infraestrutura de nuvem, foque nos serviços AWS...",
      "readyToGenerate": "Pronto para gerar",
      "refine": "Refinar",
      "refineDescription": "Insira instruções para modificar esta seção:",
      "refineSection": "Refinar seção",
      "refinedBasedOn": "Refinado com base em",
      "refinementSuccess": "Seção refinada com sucesso!",
      "saveCV": "Salvar CV",
      "savedCVs": "CVs Salvos",
      "sections": {
        "education": "Educação",
        "internationalReadiness": "Prontidão internacional",
        "professionalSummary": "Resumo profissional",
        "skills": "Habilidades",
        "workExperience": "Experiência profissional"
      },
      "selectCVToPreview": "Selecione um CV para pré-visualizar",
      "step": "Passo",
      "step1": {
        "description": "Insira a descrição do trabalho para a posição à qual você está se candidatando. Isso nos ajudará a personalizar seu CV.",
        "title": "Descrição do trabalho"
      },
      "step2": {
        "description": "A IA analisará a descrição do trabalho e gerará seções de CV personalizadas com base nos seus dados de Jornada.",
        "title": "Geração de CV"
      },
      "step3": {
        "description": "Revise e refine cada seção. Use prompts para personalizar o conteúdo para requisitos específicos.",
        "title": "Refinamento"
      },
      "step4": {
        "description": "Revise seu CV final e salve-o ou exporte-o no formato de sua preferência.",
        "title": "Revisar & exportar"
      },
      "steps": {
        "generation": "Geração",
        "jobDescription": "Descrição do trabalho",
        "refinement": "Refinamento",
        "review": "Revisão"
      },
      "subtitle": "Crie CVs específicos para o trabalho adaptados a cada oportunidade",
      "supportedFormats": "Suporta: .txt, .doc, .docx, .pdf",
      "title": "Assistente de geração de CV",
      "unsavedChanges": "Você tem alterações não salvas. Tem certeza de que deseja sair?",
      "unsavedChangesTitle": "Alterações não salvas"
    },
    "workExperience": "Experiência profissional"
  },
  "dashboard": {
    "activity": {
      "checkupUpdated": "Avaliação de CheckUp atualizada",
      "portugueseBasicsCompleted": "Concluído nível 1 de Português básico",
      "twoDaysAgo": "Há 2 dias",
      "twoHoursAgo": "Há 2 horas",
      "visaVerificationPending": "Verificação de documentos de visto pendente",
      "yesterday": "Ontem",
      "title": "Atividade recente",
      "showAll": "Mostrar tudo"
    },
    "allCheckpointsDone": "Todos os pontos de verificação concluídos",
    "banner": {
      "completed": "Concluído",
      "notStarted": "Não iniciado",
      "progress": "Progresso"
    },
    "care": {
      "allComplete": "Todos os pontos de verificação concluídos",
      "assessmentDone": "Avaliação concluída",
      "awaitingData": "Aguardando dados",
      "mood": "Humor:",
      "moodCta": "Como você está se sentindo hoje?",
      "notStarted": "Acompanhe seu bem-estar em 5 pilares da vida com check-ins regulares.",
      "startCta": "Iniciar Care",
      "subtitle": "Apoio ao bem-estar & check-ins"
    },
    "checkup": {
      "assessmentDone": "Avaliação completa",
      "calculateCta": "Calcular pontuação",
      "calculating": "Calculando...",
      "calculatingDesc": "Analisando sua prontidão em Motivação, Inglês, Habilidades Interpessoais e Habilidades Técnicas.",
      "iqulture": "Pontuação iQulture",
      "lastAssessment": "Último: {{date}}",
      "notStarted": "Descubra sua pontuação de prontidão em Motivação, Inglês, Habilidades Interpessoais e Habilidades Técnicas.",
      "readyToCalculate": "Sua pontuação de prontidão MESH está pronta para ser calculada.",
      "startCta": "Iniciar avaliação",
      "subtitle": "Meça sua prontidão com MESH",
      "awaitingProfile": "Perfil pendente",
      "awaitingProfileDesc": "Sua avaliação está pronta. Complete o seu perfil para obter a sua pontuação."
    },
    "continueJourney": "Continuar jornada",
    "cta": {
      "continueQultureUp": "Continuar QultureUp",
      "continueTelePortal": "Continuar TelePortal",
      "startCare": "Iniciar Care",
      "startCheckUp": "Iniciar CheckUp",
      "startQultureUp": "Iniciar QultureUp",
      "startTelePortal": "Iniciar TelePortal",
      "viewCheckUp": "Ver CheckUp",
      "viewPassport": "Ver Passport",
      "completeProfile": "Complete o seu perfil",
      "continueCare": "Continuar Care"
    },
    "emptyState": {
      "description": "Crie sua jornada internacional de carreira para desbloquear seu painel personalizado com acompanhamento de progresso em todos os heróis.",
      "title": "Construa sua jornada"
    },
    "errorState": {
      "description": "Algo deu errado ao carregar os dados do seu painel. Por favor, tente atualizar a página.",
      "title": "Não foi possível carregar o painel"
    },
    "heroInsight": {
      "care": {
        "checkpoints": "{{done}} de {{total}} checkpoints",
        "notStarted": "Acompanhe seu bem-estar",
        "startCheckin": "Registre seu primeiro check-in",
        "streak": "{{n}} dias de sequência",
        "subtitle": "Acompanhe seu bem-estar"
      },
      "checkup": {
        "notStarted": "Faça sua avaliação",
        "subtitle": "Meça sua prontidão"
      },
      "qultureup": {
        "allDone": "Todas as missões completas!",
        "missionsLabel": "missões",
        "notStarted": "Descubra seu nível cultural",
        "subtitle": "Aprenda sua nova cultura",
        "todaysMission": "A missão de hoje"
      },
      "teleportal": {
        "allDone": "Nenhum prazo se aproximando",
        "next": "Próximo: {{name}}",
        "notStarted": "Construa seu plano de realocação",
        "overdue_one": "{{count}} atrasado",
        "overdue_other": "{{count}} atrasados",
        "subtitle": "Planeje sua realocação",
        "tasksLabel": "tarefas"
      }
    },
    "journeyProgress": "Sua jornada {{route}} está {{percent}}% completa.",
    "journeyProgressDescription": "Acompanhe seu progresso em cada etapa",
    "journeyProgressTitle": "Seu progresso na jornada",
    "journeyReady": "Sua jornada está pronta para começar.",
    "miles": "Miles da jornada",
    "moodLabel": "Humor:",
    "noActivity": "Nenhuma atividade recente ainda. Comece a explorar seus heróis!",
    "noJourney": "Nenhuma jornada",
    "passport": {
      "badges": "Emblemas",
      "citizenLevelValue": "Nível {{level}}",
      "level": "Nível",
      "noData": "Sua pontuação vai aparecer aqui",
      "readiness": "Prontidão",
      "recentStamps": "Selos recentes",
      "stamps": "Selos",
      "subtitle": "Seu registro completo de jornada",
      "totalMiles": "Total de Miles"
    },
    "qultureup": {
      "missions": "Missões",
      "notStarted": "Explore mundos culturais e complete missões para se adaptar ao seu novo lar.",
      "startCta": "Iniciar avaliação",
      "streak": "Sequência de {{days}} dias",
      "subtitle": "Adaptação cultural através da aprendizagem",
      "tracks": "Faixas",
      "worlds": "Mundos"
    },
    "recentActivity": "Atividade recente",
    "recentActivityDescription": "Seus últimos marcos e atualizações",
    "teleportal": {
      "docs": "Documentos prontos:",
      "notStarted": "Configure seu plano de realocação com as trilhas Legal, Viagem e Configuração.",
      "startCta": "Iniciar configuração",
      "subtitle": "Planeje e execute sua realocação"
    },
    "welcomeBack": "Bem-vindo de volta, {{name}}! 👋",
    "hero": {
      "scoreIn": "Sua pontuação chegou",
      "hello": "Olá, {{name}}",
      "helloNoName": "Olá de novo",
      "strongest": "Ponto forte: {{dimension}}",
      "toGrow": "Para desenvolver: {{dimension}}",
      "resultsLink": "Ver os resultados completos",
      "day": "Dia {{day}}",
      "dayLabel": "da sua jornada"
    }
  },
  "deepLink": {
    "copyUrl": "Copiar URL",
    "downloadApp": "Baixar app",
    "error": {
      "invalidAction": "Ação de link profundo inválida",
      "noUser": "Usuário não autenticado"
    },
    "fallbackDescription": "Se o aplicativo não abrir automaticamente, instale-o na loja de aplicativos.",
    "landing": {
      "continueIn": "Continuar em",
      "continueOnWeb": "Continuar na web",
      "copied": "Link copiado",
      "copyLink": "Copiar link",
      "desktopBody": "Você está em um navegador de desktop. Abra o aplicativo Tonnie no seu telefone ou continue na web.",
      "goHome": "Ir para a página inicial",
      "installApp": "Instalar o aplicativo",
      "invalidBody": "Este link não é válido ou expirou.",
      "invalidTitle": "Link inválido",
      "mobileBody": "Abra este link no aplicativo Tonnie para a melhor experiência.",
      "openApp": "Abrir no aplicativo",
      "publicNote": "Esta página é pública. Qualquer pessoa com o link pode visualizá-la até que expire.",
      "retryAgain": "Tente novamente"
    },
    "openInMobile": "Abrir no aplicativo móvel",
    "qr": {
      "copied": "Link copiado",
      "copyLink": "Copiar link",
      "description": "Escaneie este código QR com seu telefone para abrir o aplicativo Tonnie e continuar.",
      "dontHaveApp": "Ainda não tem o aplicativo?",
      "note": "O link expira após o tempo mostrado acima.",
      "title": "Continue no seu telefone"
    },
    "urlCopied": "URL do link profundo copiado para a área de transferência"
  },
  "error": {
    "goHome": "Ir para a página inicial",
    "pageDescription": "Lamentamos pelo inconveniente. Por favor, tente novamente ou retorne à página inicial.",
    "pageTitle": "Algo deu errado",
    "retry": "Tentar novamente",
    "sectionDescription": "Esta seção encontrou um erro. Tente atualizar ou continue com outras seções.",
    "sectionTitle": "Erro na seção",
    "tryAgain": "Tente novamente",
    "clerkMissing": {
      "title": "Serviço de autenticação não configurado",
      "body": "Esta versão está faltando EXPO_PUBLIC_CLERK_PUBLISHABLE_KEY. Reinstale uma versão mais nova do EAS ou entre em contato com o suporte se isso persistir."
    }
  },
  "errorBoundary": {
    "goHome": "Ir para a página inicial",
    "pageEncounteredError": "Esta página encontrou um erro",
    "pageMessage": "Lamentamos pelo inconveniente. Por favor, tente novamente ou retorne à tela inicial.",
    "reloadPage": "Recarregar página",
    "retry": "Tentar novamente",
    "sectionError": "Erro na seção",
    "sectionMessage": "Esta seção encontrou um erro. Tente atualizar ou continue com outras seções.",
    "somethingWentWrong": "Algo deu errado",
    "tryAgain": "Tente novamente",
    "unexpectedError": "Ocorreu um erro inesperado.",
    "appErrorTitle": "Erro de aplicação"
  },
  "evidence": {
    "kind": {
      "adaptationProgress": "Progresso de adaptação",
      "careCheckins": "Check-ins do Care",
      "careOverview": "Visão geral do Care",
      "checkupProgress": "Progresso do CheckUp",
      "checkupResults": "Resultados do CheckUp",
      "cv": "Currículo",
      "household": "Família",
      "mobilityDocuments": "Documentos de mobilidade",
      "mobilityPlan": "Plano de mobilidade",
      "passportEvidence": "Evidências do Passport",
      "pitchVideo": "Vídeo de apresentação",
      "testitResults": "Resultados do TestIt"
    },
    "redaction": {
      "reason": {
        "controllerMinimisation": "Removido pela empresa para manter apenas o necessário",
        "dataSubjectRequest": "Removido a pedido da pessoa",
        "legalObligation": "Removido para cumprir uma obrigação legal"
      }
    },
    "retention": {
      "reason": {
        "decisionInForce": "Mantido como registro da empresa de uma decisão que continua em vigor. Será excluído na data indicada, ou antes disso se a relação chegar primeiro a um desfecho.",
        "engagementEnded": "Mantido como registro da empresa de uma decisão de contratação, para defender ou responder a demandas judiciais, até o fim do período de retenção após o encerramento da relação.",
        "notProgressed": "Mantido como registro da empresa de uma decisão de não seguir adiante, para defender ou responder a demandas judiciais, até o fim do período de retenção."
      },
      "until": "Mantido até {{date}}",
      "noEndDate": "Ainda sem data de término — ela é definida quando a relação chega a um desfecho."
    },
    "trigger": {
      "engagementEnd": "Relação encerrada",
      "engagementStart": "Início da relação",
      "onDemand": "Salvo sob demanda",
      "sponsorshipActivation": "Patrocínio ativado",
      "stageTransition": "Etapa alterada",
      "verdict": "Decisão do TestIt"
    },
    "withheld": {
      "scopeNotGranted": "Não compartilhado com esta empresa quando a decisão foi tomada"
    },
    "record": {
      "title": "Registros de decisão",
      "description": "O que sua empresa podia ver sobre {{name}} a cada decisão. Um registro permanece exatamente como foi salvo — mudanças posteriores no perfil não o alteram.",
      "captureNow": "Salvar um registro agora",
      "capturing": "Salvando…",
      "captureSuccess": "Registro salvo",
      "captureRefusedEnded": "Esta relação está arquivada ou foi encerrada, então não é possível salvar um novo registro.",
      "captureFailed": "Não foi possível salvar o registro.",
      "listLabel": "Registros de decisão, do mais recente ao mais antigo",
      "empty": "Ainda não há registros de decisão. Um registro é salvo cada vez que sua empresa move, decide sobre, patrocina ou encerra a relação com este candidato.",
      "loadError": "Não foi possível carregar os registros de decisão.",
      "detailLoadError": "Não foi possível carregar este registro.",
      "retry": "Tentar novamente",
      "itemsTitle": "O que o registro contém",
      "actorBy": "Por {{name}}",
      "actorSystem": "Salvo automaticamente",
      "actorOutsideTeam": "Por uma ação de alguém de fora da sua equipe",
      "decision": {
        "stageMove": "Movido de {{from}} para {{to}}",
        "stageEntered": "Entrou em {{to}}"
      },
      "origin": {
        "backfill": "Registro legado",
        "backfillNote": "Salvo antes de os registros serem mantidos no servidor. Contém apenas o que o navegador enviou na época, e o consentimento vigente então não foi registrado."
      },
      "listTitle": "Registros · do mais recente",
      "count_one": "{{count}} registro",
      "count_other": "{{count}} registros"
    },
    "item": {
      "legacy": "Enviado pelo navegador · não verificado",
      "legacyNote": "Isto é o que o navegador enviou com a decisão. Nunca foi verificado no servidor.",
      "redact": "Remover",
      "redactAria": "Remover {{kind}} deste registro",
      "redacted": "Removido do registro",
      "redactedOn": "Removido do registro em {{date}}",
      "viewerRedacted": "Alguns detalhes estão ocultos para a sua função."
    },
    "redact": {
      "title": "Remover {{kind}} deste registro",
      "description": "O conteúdo é removido permanentemente. O registro guarda uma nota de que foi removido, quando e por quê. Não é possível desfazer.",
      "reasonLabel": "Motivo",
      "reasonRequired": "Escolha um motivo.",
      "confirm": "Remover permanentemente",
      "success": "Removido do registro",
      "notRedactable": "Este item não tem mais nada a remover.",
      "failed": "Não foi possível remover o item."
    },
    "file": {
      "open": "Abrir",
      "opening": "Abrindo…",
      "openAria": "Abrir {{name}}",
      "auditNote": "Cada abertura é registrada.",
      "openFailed": "Não foi possível abrir o arquivo.",
      "unavailable": "Este arquivo não está mais disponível: foi removido do registro ou o período de retenção do registro terminou.",
      "notInStorage": "O arquivo não estava armazenado quando o registro foi salvo, então nenhuma cópia é mantida."
    },
    "compare": {
      "title": "Na decisão · Atual",
      "show": "Comparar com o atual",
      "hide": "Ocultar comparação",
      "atDecision": "Na decisão",
      "current": "Atual",
      "comparedAt": "Comparado em {{date}}",
      "same": "Igual ao da decisão",
      "different": "Não é igual ao da decisão",
      "notComparable": "Não comparável",
      "currentDated": "valor atual datado de {{date}}",
      "withheldNow": "Atualmente não compartilhado com esta empresa",
      "loadError": "Não foi possível carregar a comparação."
    },
    "summary": {
      "nothingAtTheTime": "Nada a registrar naquele momento",
      "none": "Nada registrado",
      "notScored": "Sem pontuação",
      "percent": "{{value}}%",
      "fraction": "{{done}} de {{total}}",
      "score": "Pontuação",
      "calculatedAt": "Calculado",
      "completedAt": "Concluído",
      "progress": "Progresso",
      "tasks": "Tarefas",
      "documents": "Documentos prontos",
      "missions": "Missões",
      "wellbeing": "Bem-estar",
      "checkpoints": "Pontos de controle",
      "results": "Resultados",
      "resultsSent": "Resultados enviados",
      "miles": "Miles",
      "stamps": "Carimbos",
      "badges": "Selos",
      "fileName": "Arquivo",
      "fileSize": "Tamanho",
      "uploadedAt": "Enviado",
      "members": "Membros",
      "checkins": "Check-ins",
      "lastCheckin": "Último check-in",
      "nothingNow": "Nada a mostrar agora",
      "files": "Arquivos"
    },
    "verdict": {
      "title": "Histórico de decisões",
      "earlier": "Decisões anteriores ({{count}})",
      "replacedValue": "Substituiu uma decisão anterior: {{verdict}}",
      "replacedNotRecorded": "Uma eventual decisão anterior não foi registrada",
      "viewRecord": "Ver registro",
      "loadError": "Não foi possível carregar o histórico de decisões."
    },
    "notice": {
      "title": "Algumas empresas mantêm um registro",
      "introFile": "O arquivo saiu do seu cofre. Estas empresas tomaram uma decisão sobre você que o incluía e mantêm o próprio registro dessa decisão:",
      "introAccount": "Sua conta foi excluída. Estas empresas tomaram uma decisão sobre você e mantêm o próprio registro dela:",
      "listLabel": "Empresas que mantêm um registro",
      "what": "O quê",
      "until": "Até",
      "why": "Por quê",
      "noEndDate": "Ainda sem data de término — ela é definida quando a decisão deles chegar a um desfecho",
      "acknowledge": "Entendi"
    }
  },
  "family": {
    "admin": "Admin",
    "children": "Crianças",
    "complete": "completo",
    "emailPlaceholder": "membro@exemplo.com",
    "enableFamilyPlan": "Ativar plano familiar",
    "familyPlan": "Plano familiar",
    "hasPartner": "Tem parceiro",
    "hasPets": "Tem animais de estimação",
    "householdConfig": "Sua configuração de residência",
    "householdContext": "Contexto familiar",
    "invalidEmail": "Por favor, insira um endereço de e-mail válido",
    "inviteFamilyMember": "Convidar membro da família",
    "inviteMember": "Convidar membro",
    "inviteSent": "Convite enviado para {{email}}",
    "journeys": "Jornadas",
    "manageMembers": "Gerenciar membros",
    "master": "Mestre",
    "member": "Membro",
    "members": "Membros",
    "membersAccess": "Membros da família com acesso a jornadas compartilhadas",
    "noMembers": "Nenhum membro da família adicionado ainda",
    "pendingName": "Pendente",
    "removeMember": "Remover membro",
    "removeMemberConfirm": "Remover este membro da família?",
    "role": "Função",
    "sendInvitation": "Enviar um convite para se juntar ao seu plano familiar",
    "sendInvite": "Enviar convite",
    "shareJourney": "Compartilhe sua jornada com membros da família e acompanhe o progresso juntos.",
    "sharedJourneys": "Instâncias de jornada compartilhada",
    "sharedJourneysSubtitle": "Jornadas compartilhadas com membros da família",
    "title": "Programa familiar",
    "invite": {
      "emailPlaceholder": "membro@exemplo.com"
    }
  },
  "familyProgram": {
    "accepted": "Aceito",
    "accessRevoked": "Acesso revogado com sucesso",
    "accessRules": "Regras de acesso",
    "accessRulesDesc": "Quem pode acessar quais recursos",
    "addFamilyMember": "Adicionar membro da família",
    "addMember": "Adicionar membro",
    "care": "Care",
    "careRule": "Apenas o Family Master pode responder aos pontos de verificação Care. Companion não tem acesso.",
    "career": "Career & oportunidades",
    "careerRule": "Family Master e Companion podem acessar seus próprios Career & Oportunidades",
    "checkup": "CheckUp",
    "checkupRule": "Family Master e Companion podem completar sua própria avaliação CheckUp",
    "children": "Crianças",
    "childrenCount": "Contagem de crianças",
    "complete": "Completo",
    "copilotTip": "Dica CoPilot",
    "description": "Gerenciar acesso e permissões do núcleo familiar",
    "disabled": "Desativado",
    "docs": "Documentos",
    "docsComplete": "Documentos completos",
    "documents": "Documentos",
    "documentsIncompleteMessage": "Os documentos de {{name}} estão incompletos. Faça o upload dos documentos necessários para prosseguir com a solicitação de visto.",
    "editMember": "Editar membro",
    "educationSupport": "Suporte educacional",
    "educationSupportDesc": "Assistência para colocação escolar, aulas de idiomas e recursos educacionais.",
    "emailAddress": "Endereço de E-mail",
    "enabled": "Ativado",
    "familyAddonRequired": "Complemento familiar necessário",
    "familyAddonRequiredDesc": "O Programa Familiar requer Pro Journey, Journey Pack ou plano patrocinado. Faça upgrade para ativar o Programa Familiar.",
    "familyAdmin": "Administrador familiar",
    "familyAdminDesc": "Pode gerenciar membros da família e configurações",
    "familyMaster": "Família master",
    "familyMember": "Membro da família",
    "familyMemberDesc": "Membro da família com acesso apenas Citizen",
    "familySponsored": "Patrocinado pela família",
    "familySupportBenefits": "Benefícios de suporte familiar",
    "householdContext": "Contexto familiar",
    "householdContextDesc": "Sua configuração de residência",
    "householdCouple": "Casal",
    "householdCouplePets": "Casal + animais de estimação",
    "householdFamily": "Família",
    "householdFamilyPets": "Família + animais de estimação",
    "householdReadinessOverTime": "Progresso de prontidão do núcleo familiar ao longo do tempo",
    "householdSingle": "Solteiro",
    "householdSingleParent": "Pai solteiro",
    "householdSinglePets": "Solteiro + animais de estimação",
    "householdType": "Tipo de residência",
    "incomplete": "Incompleto",
    "invalidEmail": "Por favor, insira um endereço de e-mail válido",
    "inviteError": "Falha ao enviar convite",
    "inviteMember": "Convidar membro",
    "inviteMemberDesc": "Convide um membro da família para se juntar à sua jornada",
    "inviteNote": "Os membros da família receberão um convite por e-mail para se juntar à sua jornada. Eles terão acesso ao conteúdo QultureUp e poderão acompanhar seu próprio progresso.",
    "inviteSent": "Convite enviado para {{email}}",
    "journeyInstance": "Instância da jornada",
    "management": "Gerenciamento",
    "members": "Membros da família",
    "membersDescription": "Gerenciar acesso para membros da família",
    "milesAndLessonsPerMember": "Miles e lições concluídas por membro",
    "monitoring": "Care",
    "monitoringSection": {
      "achievements": "Conquistas",
      "acrossAllMembers": "em todos os membros",
      "active": "ativo",
      "badgesEarned": "insígnias conquistadas",
      "careNote": "Os pontos de verificação Care são respondidos pelo Family Master em nome do domicílio",
      "checkup": "CheckUp",
      "dayStreak": "sequência de dias",
      "events": "eventos",
      "householdStability": "Estabilidade da residência",
      "householdStabilityDesc": "Pontuações atuais dos pilares Care (conhecendo o domicílio, respondido pelo Family Master)",
      "lessons": "lições",
      "lessonsCompleted": "lições concluídas",
      "memberProgress": "Progresso do membro",
      "memberProgressDesc": "Rastreamento de progresso individual para cada membro da família",
      "memberReadiness": "Prontidão do membro",
      "noActivity": "Nenhuma atividade ainda",
      "noMembersToMonitor": "Nenhum membro da família para seguir ainda",
      "noReadinessData": "Nenhum dado de prontidão disponível para o Acompanhante",
      "noRecentActivity": "Nenhuma atividade recente",
      "notAvailable": "Não disponível",
      "progressTrends": "Tendências de progresso",
      "progressTrendsDesc": "Visualize o progresso da família ao longo do tempo",
      "qultureupMiles": "QultureUp Miles",
      "qultureupProgress": "Progresso QultureUp",
      "readinessEvolution": "Evolução da prontidão",
      "recentActivity": "Atividade recente",
      "teleportalProgress": "TelePortal",
      "totalAchievements": "Total de conquistas",
      "totalMembers": "Total de membros",
      "totalMiles": "Total de Miles",
      "totalQultureupMiles": "Total de Miles QultureUp"
    },
    "noJourneyInstance": "Nenhuma jornada ativa",
    "noMembers": "Nenhum membro da família convidado ainda",
    "noSharedJourneys": "Nenhuma instância de jornada compartilhada",
    "passport": "Passport",
    "passportRule": "Cada membro vê sua própria visão filtrada. O acompanhante acessa via aplicativo móvel Tonnie Citizen.",
    "pending": "Pendente",
    "petsPresence": "Animais de estimação",
    "pillar": {
      "housingStability": "Estabilidade habitacional",
      "schoolingChildcare": "Educação e cuidados infantis",
      "wellbeing": "Bem-estar",
      "workFit": "Adequação ao trabalho"
    },
    "purchaseFamilyAddon": "Comprar adicional familiar",
    "qultureup": "QultureUp",
    "qultureupPercent": "QultureUp %",
    "qultureupRule": "Todos os membros da família acessam via aplicativo móvel Tonnie Citizen (o acompanhante não pode acessar via Citizen Web)",
    "readinessPercent": "Prontidão %",
    "removeError": "Falha ao remover membro",
    "removeMember": "Remover membro",
    "revokeAccess": "Revogar acesso",
    "role": "Função",
    "schoolReady": "Pronto para a escola",
    "sendInvite": "Enviar convite",
    "servicesAvailable": "Serviços disponíveis para sua família",
    "sharedJourneyInstances": "Instâncias de jornada compartilhada",
    "sharedJourneyInstancesDesc": "Instâncias de jornada compartilhadas com membros da família",
    "spouseEmployment": "Emprego do cônjuge",
    "spouseEmploymentDesc": "Apoio na busca de emprego, oportunidades de networking e orientação sobre permissões de trabalho.",
    "status": "Status do programa familiar",
    "statusDescription": "Status atual do seu Programa Familiar",
    "teleportal": "TelePortal",
    "teleportalRule": "Apenas o Family Master pode controlar as tarefas TelePortal. Companion não tem acesso.",
    "title": "Programa familiar",
    "totalMiles": "Total de Miles",
    "tryAgainLater": "Por favor, tente novamente mais tarde",
    "unableToLoad": "Não foi possível carregar os membros da família",
    "viewDetails": "Ver detalhes",
    "visa": "Visto",
    "visaApproved": "Aprovado",
    "visaDenied": "Negado",
    "visaInProgress": "Em andamento",
    "visaNotStarted": "Não iniciado",
    "visaStatus": "Status do visto",
    "visasApproved": "Visas aprovados",
    "wellbeingCare": "Bem-estar Care",
    "wellbeingCareDesc": "Inscrição em saúde, apoio à saúde mental e integração social.",
    "yearsOld": "{{age}} anos",
    "you": "Você",
    "sharedJourneyCount_one": "{{count}} jornada compartilhada",
    "sharedJourneyCount_other": "{{count}} jornadas compartilhadas"
  },
  "feedback": {
    "additionalFeedbackHint": "Você pode fornecer feedback detalhado, anexar capturas de tela ou arquivos para nos ajudar a entender melhor sua experiência.",
    "attachFiles": "Anexar arquivos",
    "attachFilesOptional": "Anexar arquivos (opcional)",
    "category": {
      "bug": {
        "description": "Algo não está funcionando",
        "label": "Relatório de erro"
      },
      "other": {
        "description": "Algo mais",
        "label": "Outro"
      },
      "praise": {
        "description": "Eu adoro este recurso",
        "label": "Elogio"
      },
      "question": {
        "description": "Eu preciso de ajuda",
        "label": "Pergunta"
      },
      "suggestion": {
        "description": "Eu tenho uma ideia",
        "label": "Sugestão"
      }
    },
    "categoryDescription": "Selecione a categoria que melhor descreve seu feedback",
    "categoryQuestion": "Que tipo de feedback é este?",
    "characterCount": "{{current}} / {{max}} caracteres",
    "characters": "{{current}}/{{max}} caracteres",
    "close": "Fechar feedback",
    "context": {
      "hero": "Herói",
      "heroPlaceholder": "ex.: CheckUp, TelePortal",
      "notDetected": "Nenhum contexto detectado",
      "page": "Página",
      "pagePlaceholder": "ex.: /dashboard, /checkup"
    },
    "contextInfo": "Informações do contexto",
    "contextSaved": "Informações do contexto salvas",
    "detailsDescription": "Por favor, forneça detalhes sobre seu feedback",
    "detailsPlaceholder": "Descreva seu feedback, sugestão ou problema...",
    "detailsQuestion": "Conte-nos mais",
    "editContext": "Editar",
    "fileSizeError": "O tamanho do arquivo excede o limite máximo de {{maxSize}}",
    "fileSizeLimit": "Os arquivos devem ter menos de 20MB",
    "fileUploadDescription": "Adicione capturas de tela, PDFs ou outros arquivos (até 20MB cada) para nos ajudar a entender melhor seu feedback.",
    "optional": "Opcional",
    "placeholder": "Compartilhe seus pensamentos...",
    "pleaseDescribe": "Por favor, descreva seu feedback em detalhes",
    "privacyNote": "Seu feedback é anônimo e nos ajuda a melhorar Tonnie",
    "rating": {
      "1": "Muito insatisfeito",
      "2": "Insatisfeito",
      "3": "Neutro",
      "4": "Satisfeito",
      "5": "Muito satisfeito",
      "veryDissatisfied": "Muito insatisfeito",
      "dissatisfied": "Insatisfeito",
      "neutral": "Neutro",
      "satisfied": "Satisfeito",
      "verySatisfied": "Muito satisfeito"
    },
    "ratingDescription": "Avalie sua satisfação geral",
    "ratingQuestion": "Como foi sua experiência?",
    "selectRatingAndCategory": "Por favor, selecione tanto a avaliação quanto a categoria",
    "submit": "Enviar feedback",
    "submitError": "Falha ao enviar feedback. Por favor, tente novamente.",
    "submitFeedback": "Enviar feedback",
    "submitSuccess": "Obrigado! Seu feedback foi enviado.",
    "submitted": "Seu feedback foi enviado.",
    "submitting": "Enviando...",
    "subtitle": "Ajude-nos a melhorar sua experiência",
    "successMessage": "Agradecemos por dedicar seu tempo para nos ajudar a melhorar Tonnie. Seu feedback foi recebido e será revisado pela nossa equipe.",
    "successTitle": "Obrigado pelo seu feedback!",
    "tellUsMore": "Conte-nos mais",
    "thankYou": "Obrigado!",
    "thankYouMessage": "Seu feedback nos ajuda a melhorar Tonnie.",
    "title": "Compartilhar feedback",
    "toggle": "Enviar feedback",
    "totalFileSize": "Total: {{size}} / {{maxSize}}",
    "totalSize": "Total: {{size}} / 20MB max",
    "uploadFiles": "Enviar arquivos",
    "validationError": "Por favor, preencha todos os campos obrigatórios",
    "attachImages": "Anexar capturas de tela",
    "removeImage": "Remover {{name}}",
    "aria": {
      "description": "Descrição do feedback",
      "uploadFiles": "Enviar arquivos",
      "removeFile": "Remover {{name}}",
      "satisfactionRating": "Avaliação de satisfação",
      "ratingOption": "{{label}} – {{value}} de 5"
    }
  },
  "form": {
    "addressSearch": {
      "city": "Cidade: ",
      "country": "País: ",
      "postalCode": "Código postal: "
    },
    "datePicker": {
      "cancel": "Cancelar",
      "done": "Concluído",
      "months": [
        "janeiro",
        "fevereiro",
        "março",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "placeholder": "Selecionar data",
      "selectDate": "Selecionar data",
      "day": "Dia",
      "month": "Mês",
      "year": "Ano"
    },
    "phoneCountryCode": {
      "clearSearch": "Limpar busca",
      "noCountriesFound": "Nenhum país encontrado",
      "placeholder": "+XX",
      "searchPlaceholder": "Buscar país ou código...",
      "selectCountryCode": "Selecionar código do país"
    },
    "countrySelect": {
      "searchPlaceholder": "Buscar países"
    },
    "countryList": {
      "remove": "Remover {{country}}"
    },
    "timePicker": {
      "hour": "Hora",
      "minute": "Minuto"
    }
  },
  "gating": {
    "upgrade": "Atualizar",
    "lockedLabel": "Bloqueado",
    "upgradeToUnlock": "Faça upgrade para desbloquear",
    "unlockJourney": {
      "title": "Desbloqueie sua Jornada",
      "qultureup": "Para desbloquear esta missão do QultureUp, abra o Portal Web e desbloqueie sua jornada para acesso completo.",
      "teleportal": "Para desbloquear esta tarefa do TelePortal, abra o Portal Web e desbloqueie sua jornada para acesso completo."
    },
    "upgradeBanner": {
      "passport": "Atualize para Pro para desbloquear análises de passaporte, exportação e recursos de compartilhamento.",
      "qultureup": "Faça upgrade para Pro para acessar todos os mundos, lições e conteúdos de criadores em QultureUp.",
      "teleportal": "Faça upgrade para Pro para enviar documentos, validar com revisão de IA e desbloquear todas as fases de TelePortal."
    }
  },
  "heroes": {
    "care": {
      "description": "Checkpoints e suporte pós-chegada",
      "title": "Care"
    },
    "career": {
      "description": "Oportunidades & construtor de CV",
      "title": "Career"
    },
    "checkup": {
      "description": "Avaliação de prontidão pré-imigração",
      "readinessScore": "Pontuação de prontidão",
      "title": "CheckUp"
    },
    "passport": {
      "badges": "Emblemas",
      "description": "Sua linha do tempo de jornada",
      "stamps": "Selos",
      "timeline": "Cronograma",
      "title": "Passport"
    },
    "qultureup": {
      "description": "Adaptação Cultural",
      "level2Basics": "Nível 2: Básicos",
      "title": "QultureUp"
    },
    "teleportal": {
      "actionRequired": "Ação necessária",
      "description": "Realocação & Mobilidade",
      "title": "TelePortal",
      "visaProcess": "Processo de visto"
    },
    "vault": {
      "allDocuments": "Todos os documentos",
      "category": {
        "other": "Outro"
      },
      "chooseCategoryDesc": "Selecione o herói ao qual este documento pertence.",
      "chooseCategoryTitle": "Escolha uma categoria",
      "detail": {
        "by": "Por",
        "certification": "Certificação",
        "details": "Detalhes",
        "documentIdentity": "Identidade do documento",
        "expires": "Expira",
        "issuingAuthority": "Autoridade emissora",
        "location": "Localização",
        "size": "Tamanho",
        "status": "Status",
        "tags": "Tags",
        "type": "Tipo",
        "uploaded": "Enviado",
        "validation": "Validação",
        "validityPeriod": "Período de validade"
      },
      "documents": "documentos",
      "downloadAll": "Baixar tudo",
      "downloadSelected": "Baixar {{count}}",
      "downloadToView": "Baixar para visualizar",
      "selectDocument": "Selecionar documento",
      "emptyState": "Seus documentos de todos os heróis aparecerão aqui",
      "fetchError": "Falha ao carregar o cofre",
      "filter": {
        "allStatus": "Todos os status",
        "certification": {
          "label": "Certificação",
          "none": "Sem certificação"
        },
        "clear": "Limpar",
        "expired": "Expirado",
        "expiringSoon": "Expirando em breve",
        "expiry": "Data de vencimento",
        "sort": "Classificar",
        "status": "Status",
        "tags": "Tags",
        "valid": "Válido"
      },
      "noDocuments": "Nenhum documento ainda",
      "noResults": "Nenhum documento encontrado",
      "previewError": "A pré-visualização não pôde ser carregada",
      "previewUnavailable": "Pré-visualização não disponível para este tipo de arquivo",
      "removeConfirmDesc": "Esta ação não pode ser desfeita. O documento será removido permanentemente.",
      "removeDocument": "Remover documento?",
      "searchPlaceholder": "Pesquisar documentos...",
      "sort": {
        "largestFirst": "Maior primeiro",
        "nameAZ": "Nome A-Z",
        "nameZA": "Nome Z-A",
        "newestFirst": "Mais novo primeiro",
        "oldestFirst": "Mais antigo primeiro",
        "smallestFirst": "Menor primeiro"
      },
      "status": {
        "all": "Todos os status",
        "pending": "Pendente",
        "rejected": "Rejeitado",
        "uploaded": "Enviado",
        "validated": "Validado"
      },
      "subtitle": "Todos os seus documentos de viagem em um lugar seguro",
      "tag": {
        "approved": "Aprovado",
        "archived": "Arquivado",
        "expiringSoon": "Expirando em breve",
        "important": "Importante",
        "pendingReview": "Aguardando revisão",
        "urgent": "Urgente"
      },
      "title": "Cofre",
      "track": {
        "legal": "Legal",
        "setup": "Configuração",
        "travel": "Viagem"
      },
      "verifiedByTonnie": "Verificado por Tonnie",
      "view": {
        "grid": "Visualização em grade",
        "list": "Visualização em lista",
        "timeline": "Visão da linha do tempo"
      },
      "viewDetails": "Ver detalhes",
      "documentActions": "Ações de documentos",
      "searchLabel": "Pesquisar documentos",
      "topic": {
        "pitchVideo": "Vídeo de apresentação",
        "languageTest": "Teste de idioma",
        "cv": "CV"
      },
      "links": {
        "title": "Usado em",
        "trip": "Viagem de {{from}} a {{to}}",
        "tripAway": "Viagem desde {{from}}, ainda fora",
        "task": "Tarefa do TelePortal: {{document}}",
        "taskUnnamed": "Uma tarefa do TelePortal",
        "removeWarning": "Ao removê-lo, ele sai também de onde é usado — cada viagem perde esta prova e cada tarefa vai precisar de um documento de novo:",
        "count_one": "Usado em 1 lugar",
        "count_other": "Usado em {{count}} lugares"
      }
    }
  },
  "invitations": {
    "error": {
      "acceptFailedTitle": "Não conseguimos aceitar este convite",
      "alreadyAcceptedDescription": "Este convite já foi aceito por outra conta.",
      "alreadyAcceptedTitle": "Já aceito",
      "backHome": "Voltar para a página inicial",
      "declinedDescription": "Este convite foi recusado. Peça à {{company}} para enviar um novo se foi por engano.",
      "declinedTitle": "Convite recusado",
      "emailMismatchDescription": "Este convite é para {{email}}. Desconecte-se e faça login com esse endereço para aceitar.",
      "emailMismatchTitle": "Conta errada",
      "emailUnverifiedDescription": "O endereço para onde este convite foi enviado está na sua conta, mas ainda não foi verificado.",
      "emailUnverifiedTitle": "Verifique este endereço primeiro",
      "expiredDescription": "Peça à empresa com a qual você tem conversado para enviar um novo convite.",
      "expiredTitle": "Este convite expirou",
      "invalidLinkDescription": "Este link está faltando o token de convite. Verifique o e-mail que você recebeu e tente novamente.",
      "invalidLinkTitle": "Link de convite inválido",
      "notFoundDescription": "O link pode estar incompleto. Certifique-se de ter usado o e-mail mais recente.",
      "notFoundTitle": "Não conseguimos encontrar esse convite",
      "revokedDescription": "A empresa retirou este convite. Entre em contato com eles se você achar que isso é um erro.",
      "revokedTitle": "Este convite foi revogado",
      "tryAgain": "Por favor, tente novamente em um momento.",
      "wrongPortalDescription": "Este convite é para uma conta de cidadão Tonnie. Entre com sua conta de cidadão para abri-lo.",
      "wrongPortalTitle": "Use sua conta de cidadão",
      "requestNotYoursTitle": "Este pedido é para outra conta",
      "requestNotYoursDescription": "Entre com a conta com que esta empresa trabalha para responder.",
      "requestClosedTitle": "Este pedido não pode mais ser respondido",
      "requestClosedDescription": "Sua relação com esta empresa não está mais ativa, então nada mais pode ser compartilhado com ela."
    },
    "preview": {
      "acceptCta": "Aceitar convite",
      "accepting": "Aceitando…",
      "branch": "Filial",
      "declineCta": "Recusar",
      "declining": "Recusando…",
      "destination": "Destino",
      "emailHint": "Este convite é para {{email}}",
      "expires": "Este convite expira em {{date}}",
      "headline": "Você foi convidado",
      "invitingYou": "Convite de",
      "loading": "Carregando seu convite…",
      "location": "Localização",
      "opportunity": "Oportunidade",
      "signInCta": "Faça login para aceitar",
      "signUpCta": "Inscreva-se para aceitar",
      "subheadline": "A {{company}} gostaria que você fizesse um CheckUp para explorar uma oportunidade internacional. É gratuito e leva cerca de 20 minutos.",
      "subheadlineNamed": "Oi {{firstName}} — a {{company}} gostaria que você fizesse um CheckUp para explorar uma oportunidade internacional. É gratuito e leva cerca de 20 minutos.",
      "subheadlineTestit": "A {{company}} gostaria que você completasse alguns testes específicos para explorar uma oportunidade internacional. É grátis e seus resultados são reutilizáveis.",
      "subheadlineTestitNamed": "Olá {{firstName}} — a {{company}} gostaria que você completasse alguns testes específicos para explorar uma oportunidade internacional. É grátis e seus resultados são reutilizáveis.",
      "testitTestsLabel": "O que você vai completar"
    },
    "identity": {
      "addEmailBody": "A {{company}} enviou este convite para {{email}}. Adicione esse endereço à sua conta e verifique-o para aceitar sem começar de novo.",
      "addEmailCta": "Adicionar e verificar este endereço",
      "addEmailError": "Não conseguimos adicionar esse endereço. Tente novamente em instantes.",
      "addEmailTitle": "Este convite é para outro endereço",
      "cancelCta": "Cancelar",
      "codeInvalid": "Esse código não está certo. Confira e tente de novo.",
      "codeLabel": "Código de 6 dígitos",
      "codeSentBody": "Enviamos um código de 6 dígitos para {{email}}. Digite-o abaixo para concluir a verificação.",
      "codeSentHint": "Enviado para {{email}}. Expira em alguns minutos.",
      "codeSentTitle": "Confira sua caixa de entrada",
      "invitedAddress": "Convite enviado para",
      "sendCodeCta": "Enviar um código",
      "sending": "Enviando…",
      "signedInAs": "Você está conectado como",
      "switchAccountCta": "Entrar com outra conta",
      "switchAccountHint": "Você voltará a este convite depois de entrar.",
      "tryAgainCta": "Tentar de novo",
      "unverifiedBody": "{{email}} já está na sua conta, mas ainda não foi verificado. A {{company}} enviou este convite para lá, então verificá-lo prova que é seu.",
      "unverifiedTitle": "Verifique este endereço para continuar",
      "verifyCta": "Verificar e continuar",
      "verifyError": "Não conseguimos verificar esse endereço. Tente novamente em instantes.",
      "verifying": "Verificando…"
    },
    "card": {
      "eyebrow": "Convite",
      "titleCheckup": "A {{company}} convidou você para um CheckUp",
      "titleTestit": "A {{company}} pediu alguns testes a você",
      "detail": "Enviado para {{email}} · mudança para {{country}}",
      "detailNoCountry": "Enviado para {{email}}",
      "expires": "Expira em {{date}}",
      "review": "Ver convite",
      "notNow": "Agora não",
      "decline": "Recusar",
      "actionFailed": "Não deu certo. Verifique sua conexão e tente de novo.",
      "declineTitle": "Recusar o convite da {{company}}?",
      "declineBody": "A {{company}} vai saber que você recusou, e este convite não poderá mais ser usado.",
      "declineConfirm": "Recusar convite",
      "declineCancel": "Manter"
    },
    "review": {
      "title": "Entrar na {{company}}",
      "bodyCheckup": "A {{company}} pede que você faça um CheckUp para a sua mudança para {{country}}.",
      "bodyCheckupNoCountry": "A {{company}} pede que você faça um CheckUp.",
      "accept": "Aceitar convite",
      "accepting": "Aceitando…",
      "residenceBody": "Sua jornada com a {{company}} começa aqui e abre assim que você aceitar.",
      "deferredUntil": "Você adiou este convite por enquanto. Ele fica aqui esperando até você decidir e volta para o Início em {{date}}."
    },
    "claim": {
      "title": "Esse endereço tem sua própria conta Tonnie",
      "subtitle": "{{email}} pertence a outra conta Tonnie.",
      "body": "Se essa conta também é sua, você pode aceitar aqui o convite de {{company}}. Vamos enviar um código para esse endereço para confirmar que é seu.",
      "sendCta": "Enviar um código",
      "sending": "Enviando…",
      "switchInstead": "Entrar com essa conta",
      "codeSentBody": "Enviamos um código de 6 dígitos para {{email}}. Ele expira em {{minutes}} minutos.",
      "resendCta": "Enviar um novo código",
      "resendIn": "Enviar um novo código em {{seconds}} s",
      "codeWrong_one": "Esse código não está correto. Resta {{count}} tentativa.",
      "codeWrong_other": "Esse código não está correto. Restam {{count}} tentativas.",
      "codeExpired": "Esse código expirou ou já foi usado. Envie um novo.",
      "tooManyCodes": "Já enviamos vários códigos. Tente novamente mais tarde.",
      "noOtherAccount": "Nenhuma outra conta Tonnie usa esse endereço agora. Adicione-o a esta conta.",
      "failed": "Algo deu errado. Tente novamente.",
      "retireNote": "{{email}} foi confirmado como seu. Sua outra conta Tonnie com esse endereço não tem nada, então ela será encerrada quando você aceitar. Você ficará com uma só conta.",
      "keptNote": "{{email}} foi confirmado como seu. Sua outra conta Tonnie com esse endereço mantém a jornada dela, e você ainda pode entrar nela."
    },
    "choice": {
      "checking": "Verificando suas jornadas…",
      "loadFailed": "Não foi possível carregar suas jornadas. Tente novamente antes de aceitar.",
      "legend": "Qual jornada você compartilha com a {{company}}?",
      "route": "{{origin}} → {{destination}}",
      "companyJourney": "A {{company}} já acompanha você nesta jornada",
      "sharedWith": "Também compartilhada com {{companies}}",
      "checkupShared": "A {{company}} vai ver seu CheckUp de {{date}}",
      "newTitle": "Uma nova jornada para a {{company}}",
      "newBody": "Começa do zero: a {{company}} só vê o que você fizer nela a partir de agora.",
      "newCapped_one": "Você já tem {{count}} jornada nesta rota — o máximo possível. Arquive-a para começar outra.",
      "newCapped_other": "Você já tem {{count}} jornadas nesta rota — o máximo possível. Arquive uma para começar outra.",
      "newOnly": "Vamos começar uma nova jornada para {{country}} para a {{company}}.",
      "newOnlyNoCountry": "Vamos começar uma nova jornada para a {{company}}.",
      "blocked_one": "Sua jornada nesta rota pertence a outra empresa, e você já tem {{count}} — o máximo por rota. Arquive uma para aceitar o convite da {{company}}.",
      "blocked_other": "Suas jornadas nesta rota pertencem a outras empresas, e você já tem {{count}} — o máximo por rota. Arquive uma para aceitar o convite da {{company}}."
    },
    "list": {
      "title": "{{company}} convidou você",
      "deferredUntil": "Adiado até {{date}}",
      "expires": "Válido até {{date}}",
      "openHint": "Abre o convite para aceitar ou recusar"
    },
    "request": {
      "eyebrow": "Pedido",
      "titleCheckup": "A {{company}} pede para ver a pontuação do seu CheckUp",
      "titleTests": "A {{company}} pede para ver seus resultados em {{tests}}",
      "cardBody": "Nada é compartilhado até você decidir. Veja o que eles passariam a ver e depois decida.",
      "bodyCheckupScored": "Sua pontuação está pronta. Nada é compartilhado até você decidir.",
      "bodyCheckupPending": "Se você compartilhar, eles veem sua pontuação quando o CheckUp estiver calculado. Nada é compartilhado até você decidir.",
      "bodyTests": "Os resultados que você já tem são reutilizados. Nada é compartilhado até você decidir.",
      "willSeeTitle": "Se você compartilhar, a {{company}} vê",
      "wontSeeTitle": "A {{company}} continua sem ver",
      "new": "Novo",
      "share": "Compartilhar",
      "sharing": "Compartilhando…",
      "declineTitle": "Recusar o pedido da {{company}}?",
      "declineBody": "A {{company}} é informada. Nada mais muda: continua vendo apenas o que você compartilhou antes.",
      "declineConfirm": "Recusar pedido",
      "sharedToast": "Compartilhado com a {{company}}",
      "sharedToastBody": "Eles já podem ver. Você pode mudar o que eles veem a qualquer momento em Minhas jornadas.",
      "declinedToast": "Você recusou o pedido da {{company}}",
      "listTitle": "A {{company}} pede para ver mais",
      "kindCheckup": "A pontuação do seu CheckUp",
      "kindTests": "Seus resultados de testes",
      "signInBody": "Entre na conta com que a {{company}} trabalha para ver exatamente o que ela pede, e decidir.",
      "signIn": "Entrar",
      "notWaitingTitle": "Este pedido não está esperando por você",
      "notWaitingBody": "Já foi respondido ou retirado, ou é para outra conta."
    },
    "testit": {
      "title": "A {{company}} pede os resultados dos seus testes",
      "body": "A {{company}} pede a você os testes abaixo. Você faz os que ainda não fez depois de aceitar.",
      "bodyAllDone": "Você já fez todos os testes que a {{company}} pede. Não há nada novo para fazer.",
      "listLabel": "O que a {{company}} pede",
      "testDone": "Já feito — seu resultado de {{date}} será compartilhado",
      "testPending": "Para fazer depois de aceitar",
      "scopeTestsOnly": "Ao aceitar, você compartilha os resultados destes testes com a {{company}}. Seu CheckUp não é compartilhado.",
      "scopeUnchanged": "Ao aceitar, você acrescenta os resultados destes testes. A {{company}} continua vendo o que você já compartilha com ela.",
      "accept": "Aceitar e fazer os testes",
      "acceptShare": "Compartilhar meus resultados",
      "confirmTitle": "Seus resultados foram compartilhados com a {{company}}",
      "confirmBody": "A {{company}} já pode ver seus resultados nestes testes. Não falta nada para você fazer.",
      "confirmDone": "Concluir"
    }
  },
  "journey": {
    "arrives": "Chega {{date}}",
    "buildFirstJourney": "Construa sua primeira jornada internacional para começar",
    "buildYourFirstJourney": "Construa sua primeira jornada",
    "builder": {
      "title": "Construtor de jornada",
      "createErrorFallback": "Falha ao criar jornada",
      "notAuthenticated": "Você deve estar logado para continuar",
      "missingCountries": "Não conseguimos identificar onde começa e termina a sua jornada. Escolha o seu país atual e o seu destino e tente novamente.",
      "alsoToDestination": "Você também tem uma jornada para {{destination}} a partir de {{origins}}.",
      "advice": {
        "title": "Você já tem esta rota",
        "body": "Você já tem uma jornada de {{origin}} para {{destination}}. Abra-a, ou crie outra.",
        "capTitle": "Esta rota está completa",
        "capBody_one": "Você já tem {{count}} jornada de {{origin}} para {{destination}} — o máximo por rota. Abra-a.",
        "capBody_other": "Você já tem {{count}} jornadas de {{origin}} para {{destination}} — o máximo por rota. Abra uma delas.",
        "listLabel": "Suas jornadas nesta rota",
        "open": "Abrir",
        "buildAnother": "Criar outra",
        "notNow": "Agora não"
      }
    },
    "daysOnJourney": "Dias na jornada",
    "details": {
      "amount": "Valor",
      "featuresIncluded": "Recursos incluídos",
      "paymentInfo": "Informações de pagamento",
      "scenario": "Cenário",
      "scenario_already_abroad": "Já no exterior",
      "scenario_integration_only": "Apenas integração",
      "scenario_pre_immigration": "Pré-Imigração",
      "scenario_relocation_only": "Apenas realocação",
      "status": "Status",
      "title": "Detalhes da jornada",
      "type": "Tipo"
    },
    "expires": "Expira",
    "family": "Família",
    "govSponsored": "Patrocinado pelo governo",
    "guard": {
      "buildDescription": "Antes de acessar este recurso, você precisa criar sua jornada de carreira internacional. Isso leva apenas alguns minutos.",
      "buildFirst": "Construa sua primeira jornada",
      "buildNew": "Criar nova jornada",
      "buildTitle": "Construa sua jornada primeiro",
      "builderHint": "O construtor de jornada ajudará você a definir sua origem, destino e objetivos de carreira.",
      "expiredDescription": "Esta jornada atingiu o fim de seu plano. Renove ou atualize para continuar usando seus heróis.",
      "expiredTitle": "Sua jornada expirou",
      "goToDashboard": "Ir para o painel",
      "loadErrorDescription": "Algo deu errado ao carregar suas jornadas. Seus dados estão seguros — por favor, tente novamente.",
      "loadErrorTitle": "Não conseguimos carregar suas jornadas",
      "noActiveDescription": "Todas as suas jornadas podem estar pausadas, expiradas ou concluídas. Selecione uma do cabeçalho ou crie uma nova.",
      "noActiveTitle": "Nenhuma jornada ativa",
      "pausedDescription": "O acesso está temporariamente pausado — geralmente porque o pagamento de um patrocinador não foi processado ou a jornada foi pausada por um administrador. Entre em contato com seu patrocinador ou verifique a cobrança para retomar.",
      "pausedTitle": "Sua jornada está pausada",
      "pendingSetupDescription": "Reservamos esta jornada para você. Conte de onde você está se mudando e ela abre na hora.",
      "pendingSetupTitle": "Finalize a configuração da sua jornada",
      "renewJourney": "Renovar",
      "selectDescription": "Você precisa selecionar uma instância de jornada ativa para acessar este recurso. Use o seletor de jornada no cabeçalho acima para escolher uma.",
      "selectTitle": "Selecione uma jornada",
      "selectorHint": "Dica: Use o seletor de jornada na barra de navegação superior para alternar entre suas jornadas.",
      "unavailableDescription": "Esta jornada não está mais acessível. Escolha outra ou crie uma nova jornada para continuar.",
      "unavailableTitle": "Jornada indisponível",
      "viewBilling": "Ver cobrança",
      "errorTitle": "Não conseguimos carregar suas jornadas",
      "errorDescription": "Não conseguimos alcançar o servidor. Verifique sua conexão e tente novamente.",
      "openSelector": "Abrir seletor de jornada",
      "openJourney": "Abrir minha jornada"
    },
    "loadingJourneys": "Carregando jornadas…",
    "milesToGo": "Miles a percorrer",
    "nextMilestone": "Próximo marco",
    "pro": "Pro",
    "progress": "Progresso",
    "selectJourney": "Selecionar jornada",
    "selector": {
      "andMore_one": "e mais 1",
      "andMore_other": "e mais {{count}}",
      "basicAccess": "Acesso básico",
      "buildFirst": "Construa sua primeira jornada",
      "buildNew": "Criar nova jornada",
      "buildOne": "Construir uma jornada",
      "buildOneShort": "Construir jornada",
      "companiesHint": "Mostra todas as empresas desta jornada",
      "companiesTitle": "Empresas nesta jornada",
      "company": "Empresa",
      "expired": "Expirado",
      "expiresOn": "Expira",
      "family": "Família",
      "from": "de {{country}}",
      "fromUnknown": "De desconhecido",
      "fullAccess": "Acesso completo",
      "government": "Governo",
      "invitedBy": "Convidado por {{company}}",
      "invitedOnly": "Apenas convidado",
      "loadingJourneys": "Carregando jornadas…",
      "locked": "Bloqueado",
      "noJourneys": "Nenhuma jornada ainda",
      "noJourneysDescription": "Você ainda não tem nenhuma jornada. Comece uma para iniciar sua realocação.",
      "noJourneysTitle": "Nenhuma jornada ainda",
      "paused": "Pausado",
      "setupPending": "Configuração pendente",
      "sponsored": "Patrocinado",
      "unlocked": "Desbloqueado",
      "sharedWith": "Compartilhada com {{company}}"
    },
    "sponsored": "Patrocinado",
    "status": {
      "active": "Ativo",
      "completed": "Completo",
      "draft": "Rascunho",
      "expired": "Expirado",
      "limited": "Limitado",
      "paused": "Pausado"
    },
    "statusActive": "Ativo",
    "statusExpired": "Expirado",
    "statusLimited": "Limitado",
    "switchBetweenJourneys": "Alternar entre suas jornadas ativas",
    "yourJourneyTo": "Sua jornada para {{country}}",
    "originPending": "Origem pendente",
    "invited": "Convidado",
    "yourJourneyToUnknown": "A sua jornada",
    "relationship": {
      "live": "Ativo",
      "archivedByCompany": "Arquivado pela empresa",
      "ended": "Encerrado",
      "left": "Você saiu"
    },
    "manage": {
      "accessUntil": "Acesso até {{date}}",
      "activeDescription": "Cada jornada guarda seu próprio progresso no CheckUp, TelePortal e Care. A jornada atual é a que seu painel mostra.",
      "activeSection": "Jornadas ativas",
      "archive": "Arquivar",
      "archiveCanRestore": "Você pode recuperá-la nesta página quando quiser.",
      "archiveConfirm": "Arquivar jornada",
      "archiveDialogDescription": "Ela sai da sua lista de jornadas. Nada do que ela contém é perdido.",
      "archiveDialogTitle": "Arquivar sua jornada para {{destination}}?",
      "archiveFailed": "Não foi possível arquivar esta jornada. Tente novamente.",
      "archiveKeepsProgress": "Nada é excluído — o progresso no CheckUp, TelePortal e Care fica guardado com ela.",
      "archiveSwitchesCurrent": "Esta é sua jornada atual, então a Tonnie muda você para outra, se você tiver.",
      "archivedDescription": "As jornadas arquivadas guardam tudo. Recupere uma para continuar de onde parou.",
      "archivedOn": "Arquivada em {{date}}",
      "archivedSection": "Arquivadas",
      "archivedToastBody": "Sua jornada para {{destination}} está arquivada. Nada foi excluído.",
      "archivedToastTitle": "Jornada arquivada",
      "blockedLiveProgramBody": "Saia do programa primeiro — isso encerra sua relação com a empresa — e depois você poderá arquivar esta jornada.",
      "blockedLiveProgramTitle": "Uma empresa ainda mantém este programa",
      "blockedSponsorshipBody": "O patrocínio precisa terminar antes que esta jornada possa ser arquivada.",
      "blockedSponsorshipTitle": "Esta jornada é patrocinada",
      "continueJourney": "Continuar jornada",
      "current": "Atual",
      "emptyWithArchived": "Você não tem nenhuma jornada ativa. Comece uma nova ou recupere uma que você arquivou.",
      "leaveConfirm": "Sair do programa",
      "leaveDialogTitle": "Sair do programa da {{company}}?",
      "leaveFailed": "Não foi possível tirar você do programa. Tente novamente.",
      "leaveFinerHint": "Só quer ocultar algumas coisas? Escolha exatamente o que eles podem ver.",
      "leaveKeepsJourney": "Sua jornada, o progresso e seus documentos continuam sendo seus.",
      "leaveProgramme": "Sair do programa",
      "leaveCompanyProgramme": "Sair do programa, {{company}}",
      "leaveWithdrawsAccess": "Você retira o acesso da {{company}} aos dados que compartilhou nesta jornada.",
      "leftToastCanArchive": "Eles não veem mais seus dados e a relação terminou. Você já pode arquivar esta jornada.",
      "leftToastTitle": "Você saiu do programa da {{company}}",
      "manageConsents": "O que eles veem",
      "manageJourneys": "Gerenciar jornadas",
      "newJourney": "Nova jornada",
      "openExisting": "Abrir",
      "recoverArchived": "Recuperar uma jornada arquivada ({{count}})",
      "restore": "Recuperar",
      "restoreFailed": "Não foi possível recuperar esta jornada. Tente novamente.",
      "restoredToastTitle": "Jornada recuperada",
      "startedOn": "Iniciada em {{date}}",
      "subtitle": "Alterne entre suas jornadas, arquive as que você não está usando e decida o que as empresas podem ver.",
      "switchToJourney": "Mudar para esta jornada",
      "title": "Minhas jornadas",
      "undo": "Desfazer",
      "actionsLabel": "Gerenciar jornada",
      "actionsHint": "Mantenha pressionado, ou use o menu de ações, para arquivar ou sair",
      "restoreCapTitle": "Esta rota está completa",
      "restoreCapBody_one": "Você já tem {{count}} jornada ativa para {{destination}} a partir desta origem. Abra-a, ou arquive-a antes de restaurar esta.",
      "restoreCapBody_other": "Você já tem {{count}} jornadas ativas para {{destination}} a partir desta origem. Abra uma, ou arquive uma antes de restaurar esta.",
      "labelField": "Nome da jornada",
      "labelPlaceholder": "ex.: Trabalho — Lisboa",
      "nameIt": "Dar nome",
      "rename": "Renomear",
      "renamedToast": "Jornada renomeada",
      "nameClearedToast": "Nome da jornada removido",
      "renameFailed": "Não foi possível salvar o nome. Tente novamente.",
      "leaveDialogDescriptionInvited": "A {{company}} convidou você para sua jornada para {{destination}}.",
      "leaveDialogDescriptionShared": "Você compartilhou sua jornada para {{destination}} com a {{company}}.",
      "leaveEndsRelationship": "Sua relação com a {{company}} nesta jornada termina. Eles podem convidar você de novo, e você decide se aceita.",
      "leftToastOtherProgramme": "Eles não veem mais seus dados e a relação terminou. O programa de outra empresa continua nesta jornada, então ela permanece.",
      "leftToastSponsorshipHolds": "Eles não veem mais seus dados e a relação terminou. Um patrocínio continua ativo nesta jornada, então ela permanece até o patrocínio terminar.",
      "archiveAfterSponsorship": "Esta jornada é patrocinada até {{date}}. Você pode arquivá-la quando o patrocínio terminar.",
      "archiveAfterSponsorshipNoDate": "Há um patrocínio ativo nesta jornada. Você pode arquivá-la quando o patrocínio terminar."
    },
    "consent": {
      "action": {
        "granted": "Compartilhado",
        "narrowed": "Compartilhou menos",
        "revoked": "Deixou de compartilhar",
        "widened": "Compartilhou mais"
      },
      "allRevoked": "Eles não veem mais seus resultados nesta jornada.",
      "archivedByCompany": "Arquivado pela empresa",
      "changeFailed": "A alteração não foi aplicada. Nada mudou.",
      "changedToastBody": "{{company}} · {{scope}}",
      "empty": "Nenhuma empresa tem acesso aos seus dados nesta jornada.",
      "grantedOn": "Compartilhado desde {{date}}",
      "grantedToast": "Voltou a compartilhar",
      "grantedUnknown": "Compartilhado antes de começarmos a registrar datas de consentimento",
      "groupJourney": "Nesta jornada",
      "groupProfile": "Do seu perfil",
      "revokedToast": "Deixou de compartilhar",
      "scope": {
        "care": "Meu registro do Care",
        "care_checkins": "Meus check-ins diários",
        "checkup": "Meus resultados do CheckUp",
        "cv": "Meu currículo",
        "household": "Os dados da minha família",
        "irr": "Meu histórico de atividade",
        "passport_stamps": "Meus selos e milhas Passport",
        "pitch_video": "Minha gravação de apresentação",
        "qultureup": "Meu progresso no QultureUp",
        "teleportal": "Meu plano de mudança",
        "testit": "Meus resultados do TestIt"
      },
      "sharingCount": "{{shared}} de {{total}} compartilhados",
      "subtitle": "Cada empresa abaixo tem acesso a uma parte da sua jornada. Desligue o que quiser e elas deixam de ver; ligue de novo quando quiser. Nada do que você fez é apagado.",
      "title": "Quem vê meus dados",
      "trailTitle": "O que mudou",
      "leftOn": "Você saiu em {{date}}",
      "endedOn": "Encerrado em {{date}}",
      "stoppedOn": "Parou de compartilhar em {{date}}",
      "leftReadOnly": "Esta relação terminou. Nada volta a ser compartilhado com a {{company}}, a menos que você aceite um novo convite deles."
    }
  },
  "journeyBuilder": {
    "aboutDescription": "Crie sua configuração de jornada internacional personalizada",
    "creatingMessage": "Configurando sua jornada — isso leva apenas um momento.",
    "creatingTitle": "Criando sua jornada…",
    "creationErrorTitle": "Não foi possível criar sua jornada",
    "description": "Vamos configurar sua jornada internacional",
    "estimatedTime": "Tempo estimado",
    "infoCountries": "Escolha seus países de origem e destino",
    "infoDescription": "Conte-nos algumas coisas sobre sua mudança para que possamos personalizar sua jornada.",
    "infoDestination": "Destino",
    "infoDestinationDesc": "Para onde você está se mudando.",
    "infoFeatures": "Selecione quais recursos incluir em sua jornada",
    "infoHousehold": "Configure sua composição familiar e estrutura familiar",
    "infoIntro": "Construir uma jornada leva alguns minutos. Uma vez concluído, você verá seu roteiro personalizado.",
    "infoJourney": "Jornada",
    "infoJourneyDesc": "O plano completo da origem ao destino.",
    "infoOrigin": "Origem",
    "infoOriginDesc": "De onde você está se mudando.",
    "infoProfile": "Perfil",
    "infoProfileDesc": "Seus dados pessoais — usados para personalizar recomendações.",
    "infoScenario": "Selecione o propósito da sua jornada e o que você está procurando",
    "progress": "Progresso",
    "progressTitle": "Progresso",
    "purposeCare": "Apoio e cuidado para chegar lá",
    "purposeCheckup": "Verifique suas Habilidades Internacionais",
    "purposeCulture": "Conheça a Cultura e torne-se um Citizen",
    "purposeJob": "Tenha uma oportunidade de trabalho e apoio",
    "purposeRelocation": "Apoio no processo de realocação",
    "redirectingMessage": "Redirecionando você para seu painel...",
    "scenario": "Qual é a sua situação?",
    "scenarioAlreadyAbroad": "Já estou morando no exterior",
    "scenarioAlreadyAbroadDesc": "Você já se mudou e quer melhorar sua integração",
    "scenarioIntegration": "Apoio à integração apenas",
    "scenarioIntegrationDesc": "Você quer se concentrar em cultura, idioma e desenvolvimento de carreira",
    "scenarioPreImmigration": "Estou planejando me mudar para o exterior",
    "scenarioPreImmigrationDesc": "Você ainda está em seu país de origem e planejando sua mudança internacional",
    "scenarioRelocation": "Apoio à realocação apenas",
    "scenarioRelocationDesc": "Você precisa de ajuda com a parte logística da mudança: visto, moradia, legal",
    "successTitle": "Jornada configurada! 🎉",
    "successToast": "Jornada configurada com sucesso!",
    "title": "Construtor de jornada",
    "mobile": {
      "stepOf": "Crie sua jornada · {{current}} de {{total}}",
      "create": "Criar minha jornada",
      "sameCountry": "Escolha o país que você está deixando — ele não pode ser o seu destino.",
      "createFailed": "Não conseguimos criar sua jornada. Verifique sua conexão e tente de novo.",
      "gateBody": "Três perguntas e sua jornada está pronta — aqui mesmo no seu celular.",
      "adviceFailed": "Não foi possível verificar suas jornadas nesta rota. Tente novamente."
    }
  },
  "language": {
    "languages": {
      "de": "Deutsch",
      "en": "Inglês",
      "es": "Español",
      "fr": "Français",
      "it": "Italiano",
      "pt": "Português"
    }
  },
  "legal": {
    "privacy": {
      "changes": {
        "content": "Podemos atualizar esta Política de Privacidade de tempos em tempos. Nós o notificaremos sobre quaisquer alterações publicando a nova política nesta página.",
        "title": "10. Alterações a esta política"
      },
      "children": {
        "content": "Nosso Serviço não é destinado a crianças menores de 16 anos. Não coletamos intencionalmente dados pessoais de crianças menores de 16 anos.",
        "title": "9. Privacidade das crianças"
      },
      "collect": {
        "account": "Informações da conta (nome, e-mail, número de telefone)",
        "assessment": "Respostas de avaliação e dados de progresso",
        "documents": "Documentos carregados em nosso serviço Vault",
        "intro": "Coletamos informações que você nos fornece diretamente, incluindo:",
        "location": "Dados de localização (país atual, país de destino)",
        "profile": "Informações do perfil (profissão, educação, habilidades)",
        "title": "1. Informações que coletamos"
      },
      "contact": {
        "content": "Para perguntas sobre esta Política de Privacidade ou para exercer seus direitos de dados, entre em contato com nosso Encarregado de Proteção de Dados em",
        "title": "11. Fale Conosco"
      },
      "cookies": {
        "content": "Usamos cookies e tecnologias semelhantes para melhorar sua experiência, analisar padrões de uso e fornecer conteúdo personalizado. Você pode gerenciar preferências de cookies através das configurações do seu navegador.",
        "title": "7. Cookies e rastreamento"
      },
      "international": {
        "content": "Suas informações podem ser transferidas e processadas em países diferentes do seu país de residência. Garantimos que salvaguardas apropriadas estão em vigor para proteger seus dados de acordo com esta Política de Privacidade.",
        "title": "8. Transferências internacionais de dados"
      },
      "lastUpdated": "Última atualização: {{date}}",
      "retention": {
        "content": "Retemos seus dados pessoais enquanto sua conta estiver ativa ou conforme necessário para fornecer serviços. Você pode solicitar a exclusão de seus dados a qualquer momento entrando em contato conosco.",
        "title": "5. Retenção de dados"
      },
      "rights": {
        "access": "Acessar seus dados pessoais",
        "correct": "Corrigir dados imprecisos",
        "delete": "Solicitar a exclusão de seus dados",
        "intro": "De acordo com as leis de proteção de dados aplicáveis, você tem o direito de:",
        "object": "Opor-se ao processamento de seus dados",
        "portability": "Solicitar portabilidade de dados",
        "title": "6. Seus direitos"
      },
      "security": {
        "content": "Implementamos medidas técnicas e organizacionais apropriadas para proteger seus dados pessoais contra acesso não autorizado, alteração, divulgação ou destruição. Todos os dados são criptografados em trânsito e em repouso.",
        "title": "4. Segurança dos dados"
      },
      "sharing": {
        "employers": "Com empregadores que patrocinam sua jornada (com seu consentimento explícito)",
        "intro": "Podemos compartilhar suas informações:",
        "legal": "Quando exigido por lei ou para proteger nossos direitos",
        "providers": "Com prestadores de serviços que ajudam a operar nossa plataforma",
        "title": "3. Compartilhamento de informações"
      },
      "title": "Política de privacidade",
      "use": {
        "communicate": "Comunicar-se com você sobre o progresso da sua jornada",
        "intro": "Usamos as informações que coletamos para:",
        "personalize": "Personalizar sua experiência e recomendações de jornada",
        "process": "Processar suas avaliações de iQulture e gerar insights",
        "protect": "Proteger contra fraudes e acesso não autorizado",
        "provide": "Fornecer, manter e melhorar nosso Serviço",
        "title": "2. Como usamos suas informações"
      }
    },
    "terms": {
      "acceptance": {
        "content": "Ao acessar e usar a Plataforma Tonnie (\"Serviço\"), você concorda em estar vinculado a estes Termos de Serviço (\"Termos\"). Se você não concorda com estes Termos, não use o Serviço.",
        "title": "1. Aceitação dos termos"
      },
      "accounts": {
        "content": "Para usar certos recursos do Serviço, você deve criar uma conta. Você é responsável por manter a confidencialidade das credenciais da sua conta e por todas as atividades que ocorrem sob sua conta.",
        "title": "3. Contas de usuário"
      },
      "changes": {
        "content": "Reservamos o direito de modificar estes Termos a qualquer momento. Notificaremos você sobre quaisquer alterações publicando os novos Termos nesta página e atualizando a data de \"Última atualização\".",
        "title": "8. Alterações aos termos"
      },
      "contact": {
        "content": "Se você tiver perguntas sobre estes Termos, entre em contato conosco em",
        "title": "9. Contato"
      },
      "ip": {
        "content": "O Serviço e seu conteúdo original, recursos e funcionalidades são de propriedade da Tonnie e estão protegidos por direitos autorais internacionais, marcas registradas e outras leis de propriedade intelectual.",
        "title": "5. Propriedade intelectual"
      },
      "lastUpdated": "Última atualização: {{date}}",
      "liability": {
        "content": "Em nenhum caso Tonnie será responsável por quaisquer danos indiretos, incidentais, especiais, consequenciais ou punitivos decorrentes ou relacionados ao seu uso do Serviço.",
        "title": "7. Limitação de responsabilidade"
      },
      "responsibilities": {
        "accurate": "Fornecer informações precisas e completas",
        "compliance": "Usar o Serviço em conformidade com as leis aplicáveis",
        "intro": "Você concorda em:",
        "noMisuse": "Não abusar ou tentar contornar os recursos de segurança do Serviço",
        "title": "4. Responsabilidades do usuário",
        "upToDate": "Manter suas informações de conta atualizadas"
      },
      "serviceDesc": {
        "care": "Care — Suporte ao bem-estar",
        "checkup": "CheckUp — Avaliações de prontidão",
        "content": "Tonnie fornece uma plataforma global de mobilidade de talentos que auxilia indivíduos (\"Talentos\") com realocação internacional e ajuda empresas (\"Empregadores\") a gerenciar programas globais de talentos. O Serviço inclui:",
        "passport": "Passport — Acompanhamento de progresso e verificação",
        "qultureup": "QultureUp — Módulos de aprendizado cultural",
        "teleportal": "TelePortal — Gestão de tarefas de realocação",
        "title": "2. Descrição do serviço"
      },
      "termination": {
        "content": "Podemos encerrar ou suspender sua conta e acesso ao Serviço imediatamente, sem aviso prévio, por conduta que acreditamos violar estes Termos ou ser prejudicial a outros usuários, a nós ou a terceiros.",
        "title": "6. Rescisão"
      },
      "title": "Termos de serviço"
    }
  },
  "mission": {
    "almostThere": "Quase lá!",
    "answerPlaceholder": "Digite sua resposta aqui...",
    "complete": "Completar missão",
    "completeToEarn": "Complete para ganhar",
    "completedBadge": "Concluído!",
    "completedSuccess": "Missão completa!",
    "correct": "Correto",
    "correctOf": "{{correct}} de {{total}} corretos",
    "exitForNow": "Sair por enquanto",
    "milesEarnedLabel": "Miles ganhas",
    "milesHint": "Miles acompanha seu progresso de aprendizado cultural em QultureUp",
    "needToPass": "Você precisa de 75% para passar. Revise o conteúdo e tente novamente.",
    "next": "Próximo",
    "notFound": "Missão não encontrada",
    "notPassed": "Não aprovado",
    "passed": "Aprovado",
    "perfectScoreBonus": "Bônus de pontuação perfeita",
    "previous": "Anterior",
    "progressWarning": "Você perderá seu progresso. Tem certeza?",
    "progressWarningTitle": "Sair da missão?",
    "questionBreakdown": "Análise das perguntas",
    "quizResults": "Resultados do quiz",
    "review": "Revisão",
    "reviewAndTryAgain": "Rever & tentar novamente",
    "startMission": "Iniciar missão",
    "watchVideo": "Assistir vídeo",
    "scrollToContinue": "Role até o final para continuar",
    "startQuiz": "Iniciar quiz",
    "submit": "Enviar",
    "submitAnyway": "Enviar mesmo assim",
    "submitError": "Falha ao enviar o quiz. Por favor, tente novamente.",
    "tipReread": "Dica: Leia o conteúdo novamente",
    "tipRereadDetail": "Preste atenção nas seções que você perdeu. As perguntas do quiz vêm diretamente do material da lição.",
    "title": "Missão",
    "unansweredTitle": "Perguntas não respondidas",
    "whatYoullLearn": "O que você vai aprender",
    "wrong": "Errado",
    "lockedError": "Esta missão ainda está bloqueada. Conclua primeiro as missões anteriores.",
    "milesEarned_one": "+{{count}} Mile",
    "milesEarned_other": "+{{count}} Miles",
    "questionsCount_one": "{{count}} pergunta",
    "questionsCount_other": "{{count}} perguntas",
    "unansweredMessage_one": "Você tem {{count}} pergunta sem resposta. Enviar mesmo assim?",
    "unansweredMessage_other": "Você tem {{count}} perguntas sem resposta. Enviar mesmo assim?",
    "sectionOf": "{{current}} de {{total}}",
    "questionOf": "Pergunta {{current}} de {{total}}"
  },
  "nav": {
    "billing": "Cobrança",
    "care": "Care",
    "career": "Career",
    "checkup": "CheckUp",
    "family": "Família",
    "home": "Início",
    "passport": "Passport",
    "profile": "Perfil",
    "qultureup": "QultureUp",
    "settings": "Configurações",
    "teleportal": "TelePortal",
    "testit": "TestIt",
    "userMenu": {
      "billing": "Cobrança",
      "loggingOut": "Desconectando…",
      "logout": "Sair",
      "preferences": "Preferências",
      "profile": "Perfil",
      "howItWorks": "Como a Tonnie funciona"
    },
    "vault": "Cofre",
    "inout": "InOut"
  },
  "notFound": {
    "description": "A página que você está procurando não existe ou foi movida.",
    "goBack": "Voltar",
    "goHome": "Ir para a página inicial",
    "message": "A página que você está procurando não existe.",
    "title": "Página não encontrada"
  },
  "inbox": {
    "title": "Caixa de entrada",
    "subtitle": "Todas as mensagens enviadas para você — por email e no app — em um só lugar.",
    "tabInbox": "Caixa de entrada",
    "tabUnread": "Não lidas",
    "tabArchived": "Arquivadas",
    "unreadCount_one": "{{count}} mensagem não lida",
    "unreadCount_other": "{{count}} mensagens não lidas",
    "unreadLabel": "Não lida",
    "emptyInbox": "Ainda não há mensagens.",
    "emptyUnread": "Você leu todas as mensagens.",
    "emptyArchived": "Nenhuma mensagem arquivada.",
    "loadError": "Não conseguimos carregar suas mensagens.",
    "retry": "Tentar novamente",
    "loadMore": "Carregar mais",
    "archive": "Arquivar",
    "restore": "Mover para a caixa de entrada",
    "back": "Voltar para as mensagens",
    "fromPlatform": "Tonnie",
    "channelEmail": "Email",
    "channelInApp": "No app",
    "channelPush": "Notificação push",
    "notRetainedTitle": "Conteúdo não armazenado",
    "notRetainedBody": "Este email foi enviado antes de a Tonnie guardar uma cópia das mensagens que envia, por isso o texto não pode ser exibido aqui.",
    "openAction": "Abrir",
    "selectPrompt": "Selecione uma mensagem para ler.",
    "actionError": "Não deu certo. Tente novamente.",
    "sentAt": "Enviada em {{date}}",
    "openFromBell": "Abrir caixa de entrada",
    "markAllRead": "Marcar tudo como lido",
    "markAllReadDone": "Todas as mensagens foram marcadas como lidas",
    "allCaughtUp": "Nenhuma mensagem não lida",
    "archived": "Mensagem arquivada",
    "restored": "Movida para a caixa de entrada",
    "undo": "Desfazer",
    "markUnread": "Marcar como não lida",
    "markRead": "Marcar como lida",
    "markedUnread": "Marcada como não lida",
    "markedRead": "Marcada como lida",
    "groupToday": "Hoje",
    "groupYesterday": "Ontem",
    "groupThisWeek": "Esta semana",
    "groupEarlier": "Mais antigas",
    "selectTitle": "Nenhuma mensagem selecionada",
    "emptyInboxHint": "Os e-mails e as mensagens do app enviados pela Tonnie e pelas empresas com que você trabalha aparecem aqui.",
    "emptyUnreadHint": "As novas mensagens aparecem aqui assim que chegarem.",
    "emptyArchivedHint": "As mensagens que você arquivar ficam aqui e podem voltar para a caixa de entrada a qualquer momento.",
    "loadErrorHint": "Verifique sua conexão e tente novamente.",
    "loading": "Carregando suas mensagens",
    "readerLabel": "Mensagem",
    "messageNotFound": "Esta mensagem não está aqui",
    "messageNotFoundHint": "Ela pode ter sido excluída ou enviada para outra conta.",
    "notRetainedPreview": "O texto deste e-mail não foi guardado.",
    "opensInNewTab": "(abre em uma nova aba)",
    "viewArchived": "Ver arquivadas",
    "invitationsSection": "Convites · {{count}}",
    "invitationsWaiting_one": "{{count}} convite esperando sua resposta",
    "invitationsWaiting_other": "{{count}} convites esperando sua resposta",
    "notificationSettings": "Configurações de notificações"
  },
  "notifications": {
    "care": {
      "checkpointOverdueTitle": "Seu check-in está aguardando",
      "coachingAssignedTitle": {
        "encourage": "Atribuído a você: enviar uma mensagem de incentivo",
        "challenge": "Atribuído a você: lançar um novo desafio",
        "checkin": "Atribuído a você: saber como a pessoa está",
        "celebrate": "Atribuído a você: comemorar o progresso",
        "remind": "Atribuído a você: enviar um lembrete amigável"
      },
      "coachingTouchTitle": {
        "encourage": "Sua equipe enviou uma mensagem de incentivo para você",
        "challenge": "Sua equipe lançou um novo desafio para você",
        "checkin": "Sua equipe quer saber como você está",
        "celebrate": "Sua equipe está comemorando seu progresso",
        "remind": "Um lembrete amigável da sua equipe"
      },
      "checkpointOverdueBody": "Um check-in de Care está atrasado — leva apenas cerca de 3 minutos. Abra Care para completá-lo.",
      "interactionAssignedBody": "Uma interação de Care foi atribuída a você.",
      "interventionTouchBody": "Sua equipe de patrocinadores agendou algum suporte para você. Abra Care para ver mais.",
      "objectiveFeedbackCycleOpenTitle": "Nova rodada de feedback",
      "objectiveFeedbackCycleOpenBody": "Sua equipe vai compartilhar o feedback em breve — depois você poderá adicionar sua autoavaliação. Abra Care para ver seus objetivos.",
      "objectiveFeedbackDueTitle": "Feedback solicitado",
      "objectiveFeedbackDueBody": "É hora de compartilhar seu feedback sobre os objetivos desta rodada. Abra Care para dá-lo.",
      "objectiveFeedbackReceivedTitle": "Novo feedback recebido",
      "objectiveFeedbackReceivedBody": "Sua equipe compartilhou feedback sobre seus objetivos. Abra Care para revisá-lo e adicionar sua autoavaliação."
    },
    "checkup": {
      "scoreReadyBody": "{{score}} — veja o que ela significa, pilar por pilar.",
      "scoreReadyTitle": "Sua pontuação iQulture saiu"
    },
    "billing": {
      "actionRequiredBody": "Seu banco precisa que você autorize este pagamento. Abra o Cobrança para concluir.",
      "actionRequiredTitle": "Confirme seu pagamento",
      "paymentFailedBody": "Não foi possível processar seu pagamento. Atualize a forma de pagamento para manter seu acesso.",
      "paymentFailedTitle": "Pagamento falhou"
    },
    "testit": {
      "reminderBody": "Conclua seu TestIt para que a empresa que avalia você possa ver seus resultados.",
      "reminderTitle": "Seu TestIt está aguardando"
    },
    "justNow": "Agora mesmo",
    "bellLabel_one": "Notificações, {{shown}} não lida",
    "bellLabel_other": "Notificações, {{shown}} não lidas",
    "title": "Notificações",
    "moreActions": "Mais ações",
    "tabAll": "Todas",
    "markReadAction": "Marcar como lida",
    "unsubscribe": {
      "confirmBody": "Vamos parar de enviar emails de “{{category}}” para {{email}}.",
      "confirmCta": "Cancelar inscrição",
      "confirmTitle": "Cancelar a inscrição nesses emails?",
      "confirming": "Cancelando…",
      "doneBody": "Você não receberá mais emails de “{{category}}”.",
      "doneTitle": "Inscrição cancelada",
      "failed": "Não foi possível concluir. Tente novamente.",
      "invalidBody": "Ele pode já ter sido usado, ou a conta à qual pertencia foi encerrada. Nada foi alterado.",
      "invalidTitle": "Este link não é mais válido",
      "loading": "Verificando seu link…",
      "malformedBody": "O link de cancelamento parece truncado. Alguns aplicativos de email cortam links longos — tente abrir a mensagem em um navegador ou use o botão Cancelar inscrição que seu aplicativo de email mostra no topo da mensagem.",
      "malformedTitle": "Este link está incompleto",
      "stillReceive": "Emails essenciais da conta — redefinições de senha e avisos de segurança — continuarão chegando."
    },
    "showMore": "Ver mais",
    "showLess": "Ver menos",
    "journey": {
      "relationshipMovedTitle": "Suas jornadas mudaram",
      "relationshipMovedBody": "A {{company}} agora acompanha você em uma jornada própria, na mesma rota. Veja em Minhas jornadas."
    },
    "bellLabelNeedsYou_one": "Notificações, {{shown}} esperando você, incluindo um convite",
    "bellLabelNeedsYou_other": "Notificações, {{shown}} esperando você, incluindo convites",
    "tabInvitations": "Convites",
    "company": {
      "programmeLeftTitle": "Um talento saiu do programa",
      "programmeLeftBody": "O cartão de {{name}} foi para a aba Arquivado do seu Pipeline e você não vê mais o que foi compartilhado.",
      "programmeLeftSponsoredBody": "{{name}} saiu e você não vê mais o que foi compartilhado. O seu patrocínio continua até {{date}}, o fim do período pago.",
      "programmeLeftSponsoredOpenEndedBody": "{{name}} saiu e você não vê mais o que foi compartilhado. O seu patrocínio continua até o fim do período pago.",
      "shareRequestDeclinedTitle": "Pedido recusado",
      "shareRequestDeclinedBody": "{{name}} recusou. Nada mudou: você vê exatamente o que já havia sido compartilhado. Você pode pedir de novo mais tarde pelo cartão.",
      "testitCompletedTitle": "Testes pedidos concluídos",
      "testitCompletedBody": "{{name}} concluiu os testes que você pediu. Abra o cartão no seu Pipeline para revisá-los e registrar a sua decisão.",
      "sponsorshipAcceptedTitle": "Patrocínio aceito",
      "sponsorshipAcceptedBody": "{{name}} aceitou. O cartão está agora na coluna Patrocinado do seu Pipeline, onde você pode acompanhar o progresso.",
      "sponsorshipDeclinedTitle": "Patrocínio recusado",
      "sponsorshipDeclinedBody": "{{name}} recusou. O que você pagou é reembolsado automaticamente. Você pode fazer uma nova oferta pelo cartão no seu Pipeline.",
      "nudgeDigestTitle": "Aguardando a sua equipe",
      "nudgeDigestBody": "Aguardando você: {{count}}. Convites não enviados ou devolvidos e ofertas de patrocínio sem resposta — só a sua equipe pode movê-los."
    },
    "inout": {
      "confirmationBody": "Você esteve no país de residência todos os dias de {{from}} a {{to}}, fora as ausências registradas? Responda no InOut.",
      "confirmationTitle": "Confirme se você esteve aqui",
      "leadTimeBody": "Com a ausência e as viagens planejadas, um limite de residência seria atingido em {{date}}. Veja no InOut o que fazer antes de sair.",
      "leadTimeTitle": "Limite de residência próximo",
      "renewalWindowBody": "Você já pode pedir a renovação do seu título de residência, até {{date}}.",
      "renewalWindowTitle": "Janela de renovação aberta",
      "consultationBookedTitle": "Consulta marcada",
      "consultationBookedBody": "Sua consulta com a assessoria está marcada. Veja o dia, o horário e o link para entrar no InOut.",
      "consultationRebookTitle": "Escolha outro horário",
      "consultationRebookBody": "O horário que você escolheu foi ocupado enquanto você pagava. Escolha outro no InOut — você não paga de novo.",
      "consultationCancelledTitle": "Consulta cancelada",
      "consultationCancelledBody": "A assessoria cancelou sua consulta. Escolha um novo horário no InOut — você não paga de novo.",
      "documentsRequestedTitle": "Documentos para o seu ticket",
      "documentsRequestedBody": "A sua assessoria pediu documentos para o seu ticket. Veja no email dela o que ela precisa.",
      "refundHandledTitle": "Seu reembolso foi tratado",
      "refundHandledBody": "A assessoria tratou o reembolso que você pediu. Veja seu ticket no InOut.",
      "dossierDeliveredTitle": "Seu dossiê foi entregue",
      "dossierDeliveredBody": "Seu dossiê foi entregue à assessoria. O próximo passo é da assessoria — veja seu ticket no InOut."
    },
    "qultureup": {
      "academyInactiveTitle": "Hora de uma aula",
      "academyInactiveBody": "Faz um tempo desde o seu último progresso na Languages Academy. Uma aula curta mantém o seu idioma em movimento."
    }
  },
  "onboarding": {
    "completed": "Completar integração",
    "education": {
      "addEducation": "Adicionar educação",
      "bachelor": "Bacharelado",
      "degree": "Grau",
      "description": "Adicione seu histórico educacional",
      "emptyDescription": "Adicione seu histórico educacional para nos ajudar a entender melhor seu histórico e qualificações.",
      "emptyTitle": "Nenhuma entrada educacional ainda",
      "entry": "Entrada educacional",
      "field": "Área de estudo",
      "fieldPlaceholder": "ex: Ciência da Computação",
      "graduationYear": "Ano de graduação",
      "institution": "Instituição",
      "institutionPlaceholder": "Nome da Universidade",
      "master": "Mestrado",
      "phd": "Doutorado",
      "selectDegree": "Selecione o tipo de grau",
      "title": "Histórico educacional"
    },
    "experience": {
      "addExperience": "Adicionar experiência",
      "company": "Empresa",
      "companyPlaceholder": "Nome da Empresa",
      "current": "Atual",
      "currentJob": "Deixe em branco se for atual",
      "description": "Descrição",
      "descriptionPlaceholder": "Descreva seu papel e conquistas...",
      "emptyDescription": "Adicione sua experiência de trabalho para mostrar seu histórico profissional e habilidades.",
      "emptyTitle": "Nenhuma experiência de trabalho ainda",
      "endDate": "Data de término",
      "endDateHint": "Deixe em branco se esta for sua posição atual",
      "entry": "Entrada de experiência",
      "locationCity": "Cidade",
      "locationCityPlaceholder": "ex: São Francisco",
      "locationCountry": "País",
      "locationCountryPlaceholder": "Selecione o país",
      "role": "Função / Título",
      "rolePlaceholder": "Título do trabalho",
      "startDate": "Data de início",
      "title": "Experiência profissional"
    },
    "family": {
      "childrenCount": "Número de filhos",
      "description": "Conte-nos sobre seu núcleo familiar",
      "familyProgramHint": "Você pode configurar o Programa Familiar mais tarde para convidar membros da família para sua jornada",
      "hasChildren": "Eu tenho filhos",
      "hasPartner": "Eu tenho um parceiro/cônjuge",
      "hasPets": "Eu tenho animais de estimação",
      "householdInfo": "Informações sobre o núcleo familiar",
      "householdInfoDesc": "Isso nos ajuda a personalizar seus checkpoints de TelePortal e Care",
      "title": "Configuração familiar"
    },
    "fieldFilledFromImport": "Preenchido a partir do perfil importado",
    "fieldImportHint": "Importar perfil para preencher este campo",
    "languages": {
      "addLanguage": "Adicionar Idioma",
      "advanced": "Avançado",
      "beginner": "Iniciante",
      "description": "Conte-nos sobre suas habilidades linguísticas",
      "elementary": "Elementar",
      "emptyDescription": "Adicione idiomas que você fala para nos ajudar a avaliar sua prontidão para comunicação.",
      "emptyTitle": "Nenhum idioma adicionado ainda",
      "entry": "Idioma",
      "intermediate": "Intermediário",
      "language": "Idioma",
      "level": "Nível de Proficiência",
      "native": "Nativo",
      "proficient": "Proficiente",
      "selectLanguage": "Selecione um idioma",
      "selectLevel": "Selecione o nível de proficiência",
      "title": "Idiomas",
      "upperIntermediate": "Intermediário Superior"
    },
    "linkedin": {
      "dropPdfSubtitle": "ou clique para navegar",
      "dropPdfTitle": "Solte seu PDF do Perfil do LinkedIn aqui",
      "fileTooLarge": "Arquivo muito grande. O tamanho máximo é 10 MB.",
      "invalidFileType": "Tipo de arquivo não suportado. Por favor, envie um PDF, documento Word ou arquivo de texto.",
      "parseFailed": "Falha ao extrair dados do documento. Por favor, tente um arquivo diferente.",
      "pdfInstructions": {
        "step1": "Vá para o LinkedIn e faça login",
        "step2": "Navegue até Configurações e Privacidade → Privacidade de Dados → Obter uma cópia dos seus dados",
        "step3": "Selecione 'Perfil' e baixe como PDF",
        "step4": "Envie o arquivo PDF abaixo",
        "title": "Como obter seu PDF do Perfil do LinkedIn"
      },
      "pdfUploadError": "Falha ao enviar PDF. Por favor, tente novamente.",
      "selectPdfFile": "Selecionar arquivo PDF",
      "uploadDifferentFile": "Enviar arquivo diferente",
      "uploading": "Enviando...",
      "wizard": {
        "compliance": {
          "description": "Seus dados permanecem privados. Nós apenas lemos o documento que você envia — nada é armazenado ou compartilhado sem o seu consentimento.",
          "title": "Conformidade com GDPR e LinkedIn"
        },
        "confirmAndContinue": "Confirmar e continuar",
        "getStarted": "Começar",
        "guide": {
          "cv": {
            "subtitle": "Algumas dicas para obter os melhores resultados do seu CV",
            "tip1": {
              "description": "Envie seu CV mais atualizado para a importação de perfil mais precisa.",
              "title": "Use uma versão recente"
            },
            "tip2": {
              "description": "CVs com seções claras (Experiência, Educação, Habilidades) oferecem os melhores resultados de extração.",
              "title": "Formatos estruturados funcionam melhor"
            },
            "tip3": {
              "description": "Aceitamos arquivos PDF, DOCX, DOC e TXT de até 10 MB.",
              "title": "Formatos suportados"
            },
            "title": "Dicas para o envio do seu CV"
          },
          "linkedin": {
            "openLinkedIn": "Abra o LinkedIn",
            "step1": {
              "description": "Vá para linkedin.com, faça login e navegue até sua página de perfil.",
              "title": "Abra seu perfil"
            },
            "step2": {
              "description": "Na sua página de perfil, clique no botão \"Mais\" abaixo do seu título, depois selecione \"Salvar como PDF\".",
              "title": "Clique em \"Mais\" e depois em \"Salvar como PDF\""
            },
            "step3": {
              "description": "O LinkedIn gerará um PDF. Salve-o no seu computador — você o enviará na próxima etapa.",
              "title": "Baixar o arquivo"
            },
            "subtitle": "Siga estas 3 etapas simples para baixar seu perfil",
            "tip": "O PDF é gerado instantaneamente a partir da sua página de perfil. Não é necessário solicitar uma exportação de dados.",
            "title": "Como obter seu PDF do LinkedIn"
          }
        },
        "processing": {
          "analyzing": "Analisando com IA",
          "extracting": "Extraindo conteúdo de texto",
          "structuring": "Estruturando seus dados",
          "subtitle": "Por favor, aguarde enquanto analisamos seu documento...",
          "title": "Extraindo seu perfil",
          "uploading": "Enviando documento"
        },
        "progress": "Progresso",
        "readyToUpload": "Estou pronto para enviar",
        "review": {
          "at": "em",
          "editHint": "Você pode editar todos os detalhes nos próximos passos de integração.",
          "fieldCertifications": "Certificações",
          "fieldEducation": "Educação",
          "fieldExperience": "Experiência profissional",
          "fieldHeadline": "Título profissional",
          "fieldLanguages": "Idiomas",
          "fieldNames": "Nome",
          "fieldSkills": "Habilidades",
          "fieldWebsites": "Sites & links",
          "noDataFound": "Nenhum dado pôde ser extraído. Por favor, certifique-se de que o arquivo é um documento de perfil válido (PDF, DOCX ou TXT).",
          "present": "Presente",
          "previewDescription": "Os seguintes campos serão preenchidos automaticamente em seu perfil Tonnie:",
          "subtitle": "Encontramos as seguintes informações em seu documento. Revise e confirme para continuar.",
          "title": "Seu perfil extraído",
          "entries_one": "{{count}} entrada",
          "entries_other": "{{count}} entradas",
          "languagesCount_one": "{{count}} idioma",
          "languagesCount_other": "{{count}} idiomas",
          "positions_one": "{{count}} cargo",
          "positions_other": "{{count}} cargos",
          "skillsCount_one": "{{count}} habilidade",
          "skillsCount_other": "{{count}} habilidades",
          "summaryStats_one": "{{count}} campo extraído do seu documento",
          "summaryStats_other": "{{count}} campos extraídos do seu documento"
        },
        "reviewData": "Revisar dados",
        "source": {
          "cvCard": {
            "description": "Carregue seu CV ou currículo existente em formato PDF, DOCX ou TXT. Funciona com qualquer layout.",
            "title": "CV / Currículo pessoal"
          },
          "linkedinCard": {
            "description": "Baixe seu perfil do LinkedIn e faça o upload do PDF. Melhor para dados estruturados e precisos.",
            "tag": "Recomendado",
            "title": "PDF do perfil do LinkedIn"
          },
          "subtitle": "Escolha como você gostaria de importar seu perfil profissional. Extrairemos sua experiência, educação e habilidades automaticamente.",
          "title": "Importar seu perfil"
        },
        "steps": {
          "guide": "Guia",
          "processing": "Processando",
          "review": "Revisão",
          "source": "Fonte",
          "upload": "Carregar"
        },
        "success": {
          "description": "Seus dados foram importados. Agora você pode gerar CVs profissionais e gerenciar várias versões.",
          "title": "Perfil importado com sucesso!"
        },
        "upload": {
          "subtitle": "Arraste e solte seu arquivo ou clique para navegar. Aceitamos arquivos PDF, DOCX e TXT.",
          "title": "Carregar seu documento"
        },
        "aria": {
          "progress": "Progresso do mago"
        }
      }
    },
    "linkedinBound": "Perfil importado",
    "linkedinConnectionError": "Falha ao importar perfil. Por favor, tente novamente.",
    "location": {
      "currentCountry": "País atual",
      "description": "Onde você está agora e para onde deseja ir?",
      "goal": "Seu objetivo",
      "goalHint": "Isso nos ajuda a personalizar sua jornada",
      "goalPlaceholder": "Conte-nos sobre seus objetivos e expectativas de realocação...",
      "selectCountry": "Selecione um país",
      "targetCountry": "País alvo",
      "title": "Localização e objetivos"
    },
    "mobility": {
      "citizenship": "Países de cidadania",
      "citizenshipHint": "Selecione todos os países onde você possui cidadania",
      "description": "Conte-nos sobre seus interesses de cidadania e realocação",
      "selectCitizenship": "Selecione um país...",
      "removeCitizenship": "Remover {{country}}",
      "title": "Mobilidade",
      "validPassport": "Você tem um passaporte válido?",
      "validPassportHint": "Os detalhes de Passport serão gerenciados em TelePortal"
    },
    "personalInfo": {
      "addAddress": "Adicionar endereço",
      "addWebsiteUrl": "Adicionar URL do site",
      "address": "Endereço",
      "addressDetails": "Detalhes do endereço",
      "addressDetailsError": "Falha ao obter detalhes do endereço. Por favor, tente novamente.",
      "addressHint": "Selecione seu endereço a partir das sugestões",
      "addressInitError": "Falha ao inicializar a busca de endereço. Por favor, tente novamente.",
      "addressInvalid": "Dados de endereço inválidos. Por favor, tente selecionar outro endereço.",
      "addressLoadError": "Falha ao carregar a busca de endereço. Por favor, atualize a página.",
      "addressPlaceholder": "Comece a digitar seu endereço...",
      "addressSearchError": "Falha ao buscar endereços. Por favor, tente novamente.",
      "addressSelected": "Endereço selecionado",
      "addressSuggestions": "Sugestões de Endereço",
      "avatarFileSizeError": "O tamanho do arquivo deve ser menor que 5MB",
      "avatarFileTypeError": "Por favor, envie um arquivo de imagem válido (JPG, PNG, GIF ou WEBP)",
      "avatarRemoved": "Foto removida com sucesso!",
      "avatarUploadFailed": "Falha ao enviar avatar",
      "avatarUploaded": "Foto enviada com sucesso!",
      "changePhoto": "Alterar foto",
      "city": "Cidade",
      "clickEditToAdd": "Clique em Editar para adicionar seu endereço",
      "clickToUpload": "Clique para enviar",
      "complement": "Complemento",
      "complementPlaceholder": "Apartamento, suíte, unidade, etc.",
      "country": "País",
      "dateOfBirth": "Data de nascimento",
      "description": "Conte-nos sobre você",
      "firstName": "Primeiro nome",
      "firstNamePlaceholder": "Digite seu primeiro nome",
      "lastName": "Último nome",
      "lastNamePlaceholder": "Digite seu último nome",
      "linkedinConnected": "Dados do perfil importados do LinkedIn",
      "loadingAddressDetails": "Carregando detalhes do endereço...",
      "noAddress": "Nenhum endereço adicionado ainda",
      "phone": "Número de telefone",
      "phoneHint": "Usaremos isso para entrar em contato sobre sua jornada",
      "phonePlaceholder": "Digite seu número de telefone",
      "photoFileTypes": "JPG, PNG, GIF ou WEBP. Máx 5MB.",
      "photoInstructions": "Adicione uma foto profissional para personalizar seu perfil. Isso ajuda recrutadores e empresas a reconhecê-lo.",
      "profilePhoto": "Foto do perfil",
      "removePhoto": "Remover foto",
      "searchAddress": "Buscar endereço",
      "searchAddressDescription": "Digite seu endereço e selecione entre as sugestões do Google Places",
      "state": "Estado/Província",
      "street": "Rua",
      "title": "Informações pessoais",
      "uploadPhoto": "Enviar foto",
      "websiteLabelPlaceholder": "Rótulo personalizado (ex.: Meu Blog)",
      "websiteType": {
        "blog": "Blog",
        "facebook": "Facebook",
        "github": "GitHub",
        "gitlab": "GitLab",
        "instagram": "Instagram",
        "linkedin": "LinkedIn",
        "other": "Outro",
        "personal": "Pessoal",
        "portfolio": "Portfólio",
        "twitter": "Twitter / X",
        "website": "Site",
        "youtube": "YouTube"
      },
      "websiteUrlPlaceholder": "https://...",
      "websiteUrls": "URLs de sites & links sociais",
      "websiteUrlsHint": "Adicione seu portfólio, site pessoal, GitHub, LinkedIn ou outros links profissionais",
      "workModel": {
        "flexible": "Flexível",
        "hybrid": "Híbrido",
        "on-site": "Presencial",
        "remote": "Remoto"
      },
      "workModelPreference": "Preferência de modelo de trabalho",
      "workModelPreferenceHint": "Selecione os modelos de trabalho que você está aberto",
      "zipCode": "Código postal",
      "websiteTypeLabel": "Tipo de link",
      "websiteUrlLabel": "URL do link",
      "websiteCustomLabel": "Rótulo personalizado",
      "removeWebsiteUrl": "Remover link"
    },
    "professional": {
      "advanced": "Avançado",
      "beginner": "Iniciante",
      "description": "Conte-nos sobre sua carreira",
      "elementary": "Elementar",
      "englishLevel": "Proficiência em Inglês",
      "englishLevelHint": "Isso nos ajuda a avaliar sua prontidão",
      "intermediate": "Intermediário",
      "junior": "Júnior",
      "mid": "Nível Médio",
      "proficient": "Proficiente",
      "role": "Cargo atual / Título do trabalho",
      "rolePlaceholder": "ex.: Engenheiro de Software",
      "selectEnglishLevel": "Selecione seu nível de inglês",
      "selectSeniority": "Selecione seu nível de senioridade",
      "senior": "Sênior",
      "seniority": "Nível de senioridade",
      "title": "Experiência profissional",
      "upperIntermediate": "Intermediário superior"
    },
    "review": {
      "address": "Endereço",
      "careerTime": "Career tempo",
      "certifications": "Certificações",
      "countriesOfInterest": "Países de interesse",
      "currentRole": "Função atual",
      "education": "Educação",
      "experience": "Experiência",
      "familyConfig": "Configuração familiar",
      "hardSkills": "Habilidades técnicas",
      "hasChildren": "Tem filhos",
      "hasPartner": "Tem parceiro",
      "hasPets": "Tem animais de estimação",
      "mobility": "Mobilidade",
      "passport": "Válido Passport",
      "personalInfo": "Informações pessoais",
      "profilePhoto": "Foto do perfil",
      "profilePhotoSet": "Foto de perfil foi definida",
      "skills": "Habilidades & especializações",
      "softSkills": "Habilidades interpessoais",
      "spokenLanguages": "Idiomas falados",
      "websiteUrls": "URLs de sites & links sociais",
      "workModel": "Preferência de modelo de trabalho",
      "years": "anos"
    },
    "saveError": "Falha ao salvar progresso. Por favor, tente novamente.",
    "saved": "Progresso salvo com sucesso",
    "skills": {
      "addCertification": "Adicionar certificação",
      "addHardSkill": "Adicionar habilidade técnica",
      "addLanguage": "Adicionar idioma",
      "addSoftSkill": "Adicionar habilidade interpessoal",
      "careerTime": "Career tempo",
      "certification": "Certificação",
      "certificationAuthority": "Autoridade emissora",
      "certificationAuthorityPlaceholder": "ex.: Amazon Web Services",
      "certificationExpiryDate": "Data de expiração",
      "certificationExpiryDatePlaceholder": "Deixe em branco se não houver expiração",
      "certificationIssueDate": "Data de emissão",
      "certificationLicenseNumber": "Número da licença",
      "certificationLicenseNumberPlaceholder": "Número da licença ou certificado (opcional)",
      "certificationName": "Nome da certificação",
      "certificationNamePlaceholder": "ex.: AWS Certified Solutions Architect",
      "certificationUrl": "URL do certificado",
      "certificationUrlPlaceholder": "https://...",
      "certifications": "Certificações",
      "certificationsHint": "Adicione certificações e licenças profissionais",
      "currentRole": "Função atual",
      "description": "Conte-nos sobre suas habilidades e experiências profissionais",
      "experienceYears": {
        "0_1": "0-1 anos",
        "11_15": "11-15 anos",
        "16_plus": "16+ anos",
        "2_3": "2-3 anos",
        "4_5": "4-5 anos",
        "6_10": "6-10 anos"
      },
      "hardSkills": "Habilidades técnicas",
      "hardSkillsHint": "Adicione habilidades técnicas e seus anos de experiência",
      "hardSkillsInfo": "Forneça pelo menos 5 de suas habilidades técnicas mais fortes e tempo de experiência.",
      "languageLevels": {
        "A1": "A1 — Iniciante",
        "A2": "A2 — Elementar",
        "B1": "B1 — Intermediário",
        "B2": "B2 — Intermediário superior",
        "C1": "C1 — Avançado",
        "C2": "C2 — Proficiente",
        "native": "Nativo"
      },
      "languages": "Idiomas falados",
      "languagesHint": "Adicione idiomas que você conhece e seu nível de proficiência",
      "languagesInfo": "Importante adicionar suas habilidades em inglês e no idioma nativo, pelo menos. Quanto mais você informar, mais oportunidades estarão disponíveis.",
      "noHardSkillFound": "Nenhuma habilidade técnica encontrada.",
      "noLanguageFound": "Nenhum idioma encontrado.",
      "noRoleFound": "Nenhum cargo encontrado.",
      "noSoftSkillFound": "Nenhuma habilidade interpessoal encontrada.",
      "searchHardSkill": "Pesquisar habilidades técnicas...",
      "searchLanguage": "Pesquisar idiomas...",
      "searchRole": "Pesquisar cargos...",
      "searchSoftSkill": "Pesquisar habilidades interpessoais...",
      "selectExperience": "Selecione experiência",
      "selectLevel": "Selecione nível",
      "selectRole": "Selecione seu cargo...",
      "skillExperience": {
        "0_1": "0-1 anos",
        "11_plus": "11+ anos",
        "2_3": "2-3 anos",
        "4_5": "4-5 anos",
        "6_10": "6-10 anos"
      },
      "softSkillLevels": {
        "advanced": "Avançado",
        "beginner": "Iniciante",
        "expert": "Especialista",
        "intermediate": "Intermediário"
      },
      "softSkills": "Habilidades interpessoais",
      "softSkillsHint": "Adicione habilidades interpessoais e seu nível de proficiência",
      "softSkillsInfo": "Forneça pelo menos 3 de suas habilidades interpessoais mais fortes.",
      "title": "Autoavaliação de habilidades",
      "levelFor": "Nível de {{name}}",
      "experienceFor": "Experiência em {{name}}"
    },
    "validation": {
      "address_city_country_required": "Por favor, forneça pelo menos sua cidade e país",
      "address_city_required": "Cidade é obrigatória",
      "address_country_required": "País é obrigatório",
      "career_experience_required": "Por favor, selecione sua experiência profissional",
      "certification_authority_required": "Autoridade emissora é obrigatória",
      "certification_name_required": "Nome da certificação é obrigatório",
      "citizenship_required": "Por favor, selecione pelo menos uma cidadania",
      "company_required": "Empresa é obrigatória",
      "dateOfBirth_invalid": "Por favor, insira uma data de nascimento válida",
      "dateOfBirth_invalid_format": "Formato de data inválido",
      "dateOfBirth_min_age": "Você deve ter pelo menos {{minAge}} anos",
      "dateOfBirth_required": "Data de nascimento é obrigatória",
      "degree_required": "Grau é obrigatório",
      "end_date_after_start": "A data de término deve ser após a data de início",
      "exp_role_required": "Função é obrigatória",
      "field_of_study_required": "Campo de estudo é obrigatório",
      "firstName_max_length": "O primeiro nome deve ter no máximo 100 caracteres",
      "firstName_min_length": "O primeiro nome deve ter pelo menos 2 caracteres",
      "firstName_required": "O primeiro nome é obrigatório",
      "fixErrors": "Por favor, corrija os campos destacados antes de continuar.",
      "graduation_year_invalid": "Por favor, insira um ano de graduação válido",
      "institution_required": "Instituição é obrigatória",
      "lastName_max_length": "O sobrenome deve ter no máximo 100 caracteres",
      "lastName_min_length": "O sobrenome deve ter pelo menos 2 caracteres",
      "lastName_required": "O sobrenome é obrigatório",
      "passport_required": "Por favor, indique se você possui um passaporte válido",
      "phone_invalid_characters": "O número de telefone contém caracteres inválidos",
      "phone_max_digits": "O número de telefone deve ter no máximo {{maxDigits}} dígitos",
      "phone_min_digits": "O número de telefone deve ter pelo menos {{minDigits}} dígitos",
      "phone_required": "O número de telefone é obrigatório",
      "role_select_required": "Por favor, selecione sua função atual",
      "start_date_required": "A data de início é obrigatória",
      "url_invalid": "Por favor, insira uma URL válida (ex: https://...)",
      "work_model_required": "Por favor, selecione pelo menos uma preferência de modelo de trabalho"
    }
  },
  "passport": {
    "achievementUnlocked": "🎉 Conquista desbloqueada: {{name}}!",
    "activeJourneys": "Jornadas ativas",
    "adjustFilters": "Ajuste seus filtros ou complete atividades para ver eventos",
    "allTime": "Todo o tempo",
    "badgeMilesReward": "+{{miles}} milhas",
    "badges": "Emblemas",
    "badgesCount": "{{earned}} de {{total}} emblemas conquistados",
    "badgesEarned": "{{earned}} de {{total}} conquistados",
    "badgesProgress": "Progresso dos badges",
    "bio": {
      "address": "Endereço",
      "citizenLevel": "Nível Citizen",
      "dateOfBirth": "Data de nascimento",
      "email": "Email",
      "fullName": "Nome completo",
      "nationality": "Cidadania",
      "phone": "Telefone"
    },
    "rarityHeading": "Raridade",
    "citizenBadges": "Distintivos Citizen",
    "citizenBadgesDesc": "Badges especiais ganhos ao demonstrar adaptação cultural e conclusão de jornada",
    "citizenBadgesSection": "Distintivos Citizen",
    "citizenLevel": {
      "starter": "Iniciante"
    },
    "companyCohort": "Cohort da empresa",
    "completeForBadges": "Complete atividades para ganhar badges de cidadão!",
    "coverSubtitle": "Passport",
    "coverTitle": "Citizen",
    "daysOnJourney": "Dias na jornada",
    "description": "Seu registro de jornada",
    "earnBadgesMessage": "Complete avaliações e lições para ganhar badges!",
    "earned": "Ganho",
    "earnedOn": "Ganho em",
    "errors": {
      "tryAgain": "Por favor, tente novamente mais tarde.",
      "unableToLoad": "Não foi possível carregar os dados de Passport"
    },
    "event": {
      "ACHIEVEMENT_EARNED.desc": "Ganhou uma conquista"
    },
    "eventCategory": "Categoria",
    "eventData": "Dados do evento",
    "eventDetails": "Detalhes do evento",
    "eventType": "Tipo de evento",
    "heroBanner": {
      "levelLabel": "Nível {{level}}",
      "milesToNextLevel": "{{miles}} milhas até {{nextLevel}}",
      "subtitle": "Acompanhe seus selos, distintivos e marcos em cada herói na sua jornada de realocação.",
      "title": "Sua jornada Passport"
    },
    "heroes": "Heróis",
    "identification": "Identificação",
    "insightCultural": "🌍 A integração cultural é fundamental",
    "insightCulturalDesc": "Concentre-se nas lições de QultureUp para aumentar sua prontidão para integração.",
    "insightProgress": "🎯 Você está progredindo mais rápido do que o esperado!",
    "insightProgressDesc": "Sua pontuação de prontidão melhorou em 15 pontos nas últimas 2 semanas.",
    "insightStreak": "📚 Mantenha sua sequência de aprendizado viva",
    "insightStreakDesc": "Você está em uma sequência de 7 dias. Mais um dia para desbloquear um novo distintivo!",
    "insights": "Insights",
    "issued": "Emitido: {{date}}",
    "journeyMiles": "Miles",
    "journeyStamps": "Selos de jornada",
    "journeySummary": "Resumo da jornada",
    "journeyTimeline": "Linha do tempo da jornada",
    "journeyTimelineDesc": "Um registro dos marcos e conquistas da sua jornada",
    "keepGoingMilestones": "Continue para ganhar marcos!",
    "kpiSectionDesc": "Evolução geral da prontidão e tendências dos pilares M/E/S/H",
    "last3Months": "Últimos 3 meses",
    "level": "Nível",
    "levelCurrent": "Atual",
    "levelMilesThreshold": "{{miles}} Miles",
    "levelMilesToReach": "{{miles}} Miles a mais para alcançar este nível",
    "levelProgress": "Progresso do nível",
    "levels": {
      "ambassador": "Embaixador",
      "explorer": "Explorador",
      "newcomer": "Recém-chegado",
      "pioneer": "Pioneiro",
      "voyager": "Viajante"
    },
    "levelsCollection": "Níveis de jornada",
    "levelsCount": "{{achieved}} de {{total}} níveis alcançados",
    "limitedJourneys": "Jornadas limitadas",
    "loading": "Carregando seu passaporte...",
    "locked": "Bloqueado",
    "maxLevel": "(Máx)",
    "meshPillarTrends": "Tendências do pilar m/E/S/H",
    "miles": "Miles",
    "milesAbbr": "mi",
    "milesThisWeek": "Miles esta semana",
    "milesToNextLevel": "Miles para o próximo nível",
    "milesValue": "Valor das Miles",
    "milestonesAchievements": "Marcos & conquistas",
    "milestonesSection": "Marcos",
    "mobileApp": {
      "description": "Veja seu passaporte completo, compartilhe suas conquistas e acompanhe o progresso da sua jornada com o aplicativo móvel.",
      "openApp": "Abrir no app",
      "title": "Passport no móvel"
    },
    "nextMilestone": "Próximo: {{name}}",
    "noAchievements": "Nenhuma conquista ainda",
    "noBadgesYet": "Nenhum distintivo de cidadão ainda. Complete atividades da jornada para ganhar distintivos.",
    "noRecentActivity": "Nenhuma atividade recente. Comece sua jornada para ganhar milhas!",
    "noStampsYet": "Nenhum carimbo ainda",
    "noTimelineYet": "Nenhum evento na linha do tempo ainda. Complete atividades da jornada para ver seu histórico.",
    "notReady": {
      "badges": "Distintivos Citizen",
      "badgesDesc": "Desbloqueie distintivos especiais que reconhecem sua adaptação cultural",
      "miles": "Miles da jornada",
      "milesDesc": "Acumule milhas à medida que avança em sua realocação",
      "progress": "Acompanhar progresso",
      "progressDesc": "Veja sua linha do tempo completa da jornada e marcos",
      "stamps": "Colete selos",
      "stampsDesc": "Ganhe selos completando atividades em todos os heróis",
      "startCheckup": "Iniciar avaliação de CheckUp",
      "subtitle": "Complete suas primeiras atividades de herói para começar a coletar carimbos, ganhar distintivos e construir seu registro de realocação.",
      "title": "Seu Passport aguarda!"
    },
    "openInApp": "Abrir no app",
    "overallReadinessEvolution": "Evolução geral da prontidão",
    "pagePrefix": "P.",
    "percentComplete": "{{percent}}% completo",
    "photo": "Foto",
    "progress": "Progresso",
    "progressLabel": "Progresso",
    "rarity": {
      "common": "Comum",
      "epic": "Épico",
      "legendary": "Legendário",
      "rare": "Raro",
      "uncommon": "Incomum"
    },
    "readinessScore": "Pontuação de prontidão",
    "recentActivity": "Atividade recente",
    "recentActivityDesc": "Suas últimas milhas da jornada ganhas",
    "returnToDashboard": "Voltar ao painel",
    "reward": "Recompensa",
    "searchEvents": "Buscar eventos...",
    "shareAchievement": "Compartilhar conquista",
    "shareMessage": "Eu ganhei o selo {{name}} na Tonnie! +{{miles}} Miles 🏆",
    "since": "Desde",
    "stampArrived": "Chegou ao destino",
    "stampArrivedDesc": "Você chegou ao seu país de destino",
    "stampCultureStarter": "Iniciador Cultural",
    "stampCultureStarterDesc": "Concluiu seu primeiro mundo QultureUp",
    "stampCategory": {
      "onboarding": "Primeiros passos",
      "checkup": "CheckUp",
      "teleportal": "TelePortal",
      "qultureup": "QultureUp",
      "care": "Care",
      "inout": "InOut",
      "cross_hero": "Entre heróis"
    },
    "stampDetail": {
      "earned": "Selo conquistado!",
      "locked": "Ainda não conquistado",
      "milesReward": "Recompensa de Miles",
      "milesValueUnit": "{{value}} Miles",
      "title": "Detalhes do selo",
      "source": "Origem: {{category}}"
    },
    "stampFirstCare": "Primeiro ciclo de Care",
    "stampFirstCareDesc": "Concluiu seu primeiro ciclo de feedback Care",
    "stampFirstCheckup": "Primeiro CheckUp",
    "stampFirstCheckupDesc": "Você completou sua primeira avaliação de prontidão",
    "stampNotFound": "Selo não encontrado",
    "stampVisaApproved": "Visto aprovado",
    "stampVisaApprovedDesc": "Sua solicitação de visto foi aprovada",
    "stamps": "Selos",
    "stampsCollection": "Coleção de selos",
    "stampsCollectionDesc": "Ganhe selos completando conquistas ao longo da sua jornada",
    "stampsCount": "{{earned}} de {{total}} selos conquistados",
    "stampsEarned": "Selos conquistados",
    "stampsSection": "Selos",
    "status": "Status",
    "swipeToOpen": "Deslize para abrir",
    "tabs": {
      "levels": "Níveis",
      "overview": "Visão geral",
      "stamps": "Selos",
      "timeline": "Cronograma"
    },
    "thisWeek": "Esta semana",
    "timelineCheckupCompleted": "CheckUp concluído",
    "timelineCheckupCompletedDesc": "Sua pontuação de prontidão: 85/100",
    "timelineCultureBadge": "Distintivo iniciador cultural conquistado",
    "timelineCultureBadgeDesc": "Você completou CheckUp + 5 lições de cultura",
    "timelineFeedbackChampion": "Campeão de feedback",
    "timelineFeedbackChampionDesc": "Você completou seu 3º ciclo de feedback",
    "timelineJourneyStarted": "Jornada iniciada",
    "timelineJourneyStartedDesc": "Bem-vindo à sua jornada internacional!",
    "timelineLessonsCompleted": "10 lições concluídas",
    "timelineLessonsCompletedDesc": "Você completou 10 lições de QultureUp",
    "timelineStreak": "Sequência de 7 dias",
    "timelineStreakDesc": "Você tem aprendido consistentemente por 7 dias",
    "timelineVisaDocs": "Documentos do visto enviados",
    "timelineVisaDocsDesc": "Todos os documentos necessários verificados e prontos",
    "toNextLevel": "Próximo nível",
    "tonnieAverage": "Média da Tonnie",
    "title": "Passport",
    "totalJourneys": "Total de jornadas",
    "totalMiles": "Total de Miles",
    "totalStamps": "Total de selos",
    "tryDifferentSearch": "Tente um termo de busca diferente",
    "unlocked": "Desbloqueado",
    "viewInMobile": "Ver no móvel",
    "visibility": "Visibilidade",
    "visibleToCompany": "Empresa",
    "visibleToTalent": "Talento",
    "visibleToTonnie": "Tonnie",
    "vsCompanyCohort": "vs coorte da empresa",
    "vsSelfHistory": "vs histórico pessoal",
    "vsTonnieDatabase": "vs banco de dados Tonnie",
    "welcome": {
      "badgesStep": "Distintivos Citizen",
      "badgesStepDesc": "Desbloqueie distintivos que reconhecem sua adaptação cultural",
      "description": "Seu Passport é seu registro de realocação. Complete atividades de herói para começar a coletar selos, ganhar emblemas e rastrear os marcos da sua jornada.",
      "hint": "Complete seu primeiro CheckUp para começar a coletar selos",
      "progressStep": "Acompanhe sua jornada",
      "progressStepDesc": "Veja sua linha do tempo completa, marcos e milhas",
      "stampsStep": "Colete selos",
      "stampsStepDesc": "Ganhe selos completando atividades em todos os heróis",
      "startJourney": "Comece sua jornada",
      "title": "Seu Passport aguarda"
    },
    "yourScore": "Sua pontuação"
  },
  "payment": {
    "addPaymentMethod": "Adicionar método de pagamento",
    "amount": "Valor",
    "basePrice": "Preço base",
    "cancelFamilyAddon": "Cancelar adicional familiar",
    "cancelFamilyAddonDesc": "Você tem certeza de que deseja cancelar seu Adicional Familiar? Você manterá o acesso até o final do seu período de cobrança.",
    "cancelFamilyAddonWarning": "Após o cancelamento, você perderá o acesso aos recursos do Programa Familiar no final do seu período de cobrança.",
    "cardEnding": "Cartão terminando em {{last4}}",
    "cardExpires": "Vence {{month}}/{{year}}",
    "checkoutCancelled": "Checkout cancelado",
    "checkoutError": "Falha ao iniciar o checkout. Por favor, tente novamente.",
    "checkoutSuccess": "Pagamento bem-sucedido! Processando seu pedido...",
    "citizenOnly": "Apenas Citizen",
    "confirmAndPay": "Confirmar & pagar",
    "coupon": {
      "apply": "Aplicar",
      "applied": "{{code}} · {{percent}}% de desconto aplicado",
      "applyOrClear": "Aplique o cupom para usá-lo, ou limpe-o para continuar sem um.",
      "invalid": "Este código de cupom não é válido.",
      "label": "Tem um cupom?",
      "placeholder": "Digite o código",
      "remove": "Remover",
      "errors": {
        "notFound": "Este código de cupom não existe. Confira e tente novamente.",
        "expired": "Este cupom expirou ou ainda não está ativo.",
        "disabled": "Este cupom não está mais disponível.",
        "exhausted": "Este cupom atingiu o limite de usos e não pode ser usado novamente.",
        "wrongProduct": "Este cupom não pode ser usado nesta compra."
      }
    },
    "confirmCancelFamily": "Confirmar cancelamento",
    "confirmCancelPro": "Confirmar cancelamento",
    "confirmDowngrade": "Você tem certeza de que deseja cancelar sua assinatura Pro? Você manterá o acesso até o final do seu período de cobrança.",
    "confirmRenewal": "Confirmar renovação",
    "createFirstJourney": "Crie sua primeira jornada",
    "createJourneyFirst": "Por favor, crie uma instância de jornada primeiro",
    "createNewJourney": "Criar nova jornada",
    "creditSourcePromotion": "Bônus de boas-vindas",
    "creditSourceReferral": "Convidou 2 amigos",
    "currentExpiration": "Expiração atual",
    "currentPlan": "Plano atual",
    "discount": "Desconto",
    "downgradeToJourney": "Cancelar assinatura Pro",
    "downgradeWarning": "Após o cancelamento, você manterá o acesso Pro até o fim do seu período de cobrança. Depois, as jornadas cobertas pelo Pro voltam ao acesso básico; uma jornada que você desbloqueou ou que uma empresa patrocina mantém o acesso total.",
    "downgradedToJourney": "Assinatura Pro cancelada. Você manterá o acesso até o final do seu período de cobrança.",
    "editPaymentMethod": "Editar",
    "expiresOn": "Vence em",
    "expiringSoon": "Expirando em breve",
    "familyAddon": "Adicional familiar",
    "familyAddonActive": "Programa Familiar está ativo",
    "familyAddonCancelled": "Adicional Familiar cancelado com sucesso!",
    "familyAddonDesc": "Reúna sua família em sua jornada. Convide membros da família para compartilhar acesso, gerenciar tarefas do núcleo familiar juntos e apoiar o sucesso de integração de todos.",
    "familyAddonFeature1": "Convide membros da família — todos recebem acesso Citizen e recursos Web Citizen",
    "familyAddonFeature2": "TelePortal e Care cientes da família — gerencie a realocação juntos",
    "familyAddonFeature3": "Progresso da jornada compartilhado — todos permanecem conectados e apoiados",
    "familyAddonFeatures": "Gerencie membros da família e permissões",
    "familyAddonPurchased": "Adicional Familiar adquirido com sucesso!",
    "familyAddonTitle": "Acesso ao programa familiar",
    "featureAdvancedCare": "Recursos completos de Care: pontos de verificação, ciclos de feedback e suporte",
    "featureAllHeroes": "Todos os 5 heróis desbloqueados",
    "featureBasicCareer": "Oportunidades de Career e criador de CV",
    "featureBasicCheckup": "Avaliação completa de CheckUp e resultados",
    "featureBasicPassport": "Passport: Miles, selos, distintivos Citizen e níveis",
    "featureCareer": "Oportunidades de Career, correspondência e aplicações proativas",
    "featureFullAccess": "Acesso total a todos os recursos da jornada",
    "featureFullCheckup": "Complete CheckUp com análise completa de MESH e pontuações de iQulture",
    "featureFullPassport": "Passport completo, incluindo o Cronograma da sua jornada",
    "featureFullQultureup": "Complete QultureUp: todos os mundos, lições e conteúdo do criador",
    "featureFullTeleportal": "TelePortal Completo: todas as fases, validação de documentos e revisão de IA",
    "featureLimitedCopilot": "Consultas limitadas de CoPilot",
    "featureLimitedQultureup": "Missões limitadas de QultureUp",
    "featureLimitedTeleportal": "Checklist de TelePortal apenas (sem upload de documentos)",
    "featureNoExtra": "Nenhum pagamento adicional necessário",
    "featurePriority": "Suporte prioritário e respostas mais rápidas",
    "featureProPeriod": "Acesso durante a duração da sua assinatura Pro",
    "featureUnlimitedCopilot": "CoPilot ilimitado (guia, cérebro e agente) — todos os modos",
    "featureEveryJourneyFull": "Acesso total em todas as jornadas que você criar",
    "freePlan": "Plano gratuito",
    "freePlanDesc": "Crie quantas jornadas precisar — cada uma começa com acesso básico aos recursos essenciais. Desbloqueie uma jornada ou assine o Pro para ter acesso total.",
    "fullAccessEnabled": "Acesso total habilitado",
    "includedInPro": "Incluído no seu plano Pro",
    "includedInSubscription": "Incluído na assinatura Pro",
    "installmentPeriod": "Período de parcelamento",
    "installmentPlan": "Plano de parcelamento",
    "installments": "Parcelas",
    "instantUnlock": "Desbloqueio instantâneo",
    "invoiceHistory": "Histórico de faturas",
    "invoiceHistoryDesc": "Visualize e baixe suas faturas",
    "journeyRenewed": "Jornada renovada com sucesso!",
    "journeyUnlocked": "Jornada desbloqueada com sucesso!",
    "managePaymentMethods": "Gerencie seus métodos de pagamento",
    "month": "mês",
    "monthly": "Mensal",
    "monthlyPayment": "Pagamento mensal",
    "newExpiration": "Nova expiração",
    "noInvoices": "Nenhuma fatura ainda",
    "noInvoicesHint": "As faturas aparecerão aqui após seu primeiro pagamento",
    "noJourneyInstances": "Nenhuma jornada configurada ainda",
    "oneTimePayment": "Pagamento único",
    "paymentMethods": "Métodos de pagamento",
    "paymentOption": "Opção de pagamento",
    "paymentSecurity": "Seu pagamento é seguro e criptografado. Aceitamos principais cartões de crédito e métodos de pagamento locais (SIBS para Portugal, Stripe para outros).",
    "paymentType": "Tipo de pagamento",
    "price": "Preço",
    "proJourney": "Plano Pro",
    "proJourneyDesc": "Acesso total em todas as jornadas que você criar — todos os heróis, recursos avançados e suporte premium.",
    "proEndsOn": "Seu plano Pro termina em {{date}}",
    "proUnlockDesc": "Desbloqueie esta jornada instantaneamente com sua assinatura Pro",
    "proUnlockError": "Falha ao desbloquear a jornada. Por favor, tente novamente.",
    "proUnlockSuccess": "Jornada desbloqueada instantaneamente com sua assinatura Pro!",
    "proceedToPayment": "Prosseguir para o pagamento",
    "processing": "Processando...",
    "purchaseFamilyAddon": "Comprar adicional familiar",
    "purchaseJourneyInstance": "Comprar instância da jornada",
    "purchaseJourneyInstanceDesc": "Desbloqueie todos os recursos desta jornada",
    "purchasedOn": "Comprado em",
    "recommended": "Recomendado",
    "removePaymentMethod": "Remover",
    "renewJourneyInstance": "Renovar instância da jornada",
    "renewJourneyInstanceDesc": "Estenda seu acesso a esta jornada",
    "renewNow": "Renovar agora",
    "renewalPrice": "Preço de renovação",
    "saveYearly": "Economize {{amount}} por ano!",
    "scenarioAlreadyAbroad": "Já no exterior",
    "scenarioIntegrationOnly": "Integração apenas",
    "scenarioPreImmigration": "Pré-imigração",
    "scenarioRelocationOnly": "Realocação apenas",
    "secureCheckout": "Checkout seguro powered by Stripe",
    "selectInstallmentPeriod": "Selecione o período de parcelamento",
    "selectJourneyToPurchase": "Por favor, selecione uma instância de jornada para comprar",
    "selfPaidJourneys": "Jornadas pagas pelo próprio usuário",
    "sponsoredJourneys": "Jornadas patrocinadas",
    "total": "Total",
    "totalAmount": "Valor total",
    "unlockInstant": "Desbloquear instantaneamente",
    "unlockJourney": "Desbloquear jornada",
    "unlockNow": "Desbloquear agora",
    "unlockedJourneys": "Jornadas configuradas",
    "unlockedJourneysDesc": "Todas as suas instâncias de jornada compradas e patrocinadas",
    "unlocking": "Desbloqueando...",
    "upfront": "Pagamento antecipado",
    "upfrontPrice": "Pagamento antecipado",
    "upgradeDescription": "Desbloqueie todos os recursos e acelere sua jornada",
    "upgradeToPro": "Atualizar para Pro",
    "upgradedToPro": "Atualizado para o plano Pro!",
    "whatYouGet": "O que você recebe",
    "year": "ano",
    "yearly": "Anual",
    "featureMonthsAccess_one": "{{count}} mês de acesso ilimitado",
    "featureMonthsAccess_other": "{{count}} meses de acesso ilimitado",
    "coveredByPro": "Sua assinatura Pro já cobre esta jornada — desbloqueie-a com o Pro, sem custo adicional.",
    "renewNotRenewable": "Esta jornada não pode ser renovada enquanto uma empresa a patrocina.",
    "paymentReference": "Ref. de pagamento {{reference}}",
    "refunded": "Reembolsado {{amount}}",
    "documentUnavailable": "Não foi possível abrir este documento agora. Tente novamente.",
    "invoicesLoadFailed": "Não foi possível carregar suas faturas."
  },
  "persona": {
    "familyMaster": {
      "badge": "Controlador",
      "controlsHousehold": "Você controla TelePortal e Care para sua família",
      "description": "Principal talento controlando a jornada da família. Acesso total a todos os recursos, além de responsabilidades de gerenciamento do núcleo familiar.",
      "title": "Família master"
    },
    "info": {
      "description": "Sua persona determina seu nível de acesso e recursos disponíveis. Você pode alterar isso mais tarde nas configurações do seu perfil, se necessário.",
      "title": "Sobre personas"
    },
    "loading": "Carregando...",
    "matrix": {
      "allowed": "Acesso completo",
      "billingCompanySponsored": "Cobrança gerenciada pela empresa patrocinadora",
      "billingDescription": "Gerenciamento de plano e cobrança",
      "billingGovernmentSponsored": "Cobrança gerenciada pelo governo/programa patrocinador",
      "careDescription": "Pontos de verificação e suporte pós-chegada",
      "careerDescription": "Oportunidades de emprego e ferramentas de carreira",
      "checkupDescription": "Avaliação de prontidão pré-imigração",
      "citizenMobile": "Citizen mobile",
      "controls": "Controles",
      "cvBuilder": "Construtor de CV",
      "cvBuilderDescription": "Gerador de CV estilo UE e modelos",
      "description": "Compare o acesso a recursos entre todas as personas. Selecione uma persona para continuar.",
      "familyProgramDescription": "Gerenciamento e convites do programa familiar",
      "familyProgramViaBilling": "Disponível via cobrança. Compre um plano para se tornar o mestre da família e gerenciá-lo",
      "features": "Recursos",
      "homeDescription": "Visão geral do painel e da jornada",
      "journeyBuilder": "Construtor de jornada",
      "journeyBuilderDescription": "Configure e construa sua jornada personalizada",
      "journeyBuilderViaBilling": "Disponível após a compra de um plano via Cobrança",
      "journeyBuilderViaBillingBecomesTalent": "Disponível via cobrança. Após a compra de créditos/pro, torna-se fluxo de talento",
      "legend": {
        "allowed": "Acesso completo",
        "citizenMobile": "Disponível via aplicativo móvel Citizen",
        "controls": "Recurso de controles",
        "limited": "Acesso limitado (apenas próprio)",
        "notAllowed": "Não disponível",
        "viaBilling": "Disponível via cobrança/Aprimoramento"
      },
      "limited": "Acesso limitado",
      "notAllowed": "Não disponível",
      "passportDescription": "Linha do tempo da jornada e conquistas",
      "profileDescription": "Configurações e preferências do perfil",
      "qultureupDescription": "Integração cultural e aprendizado",
      "selected": "Selecionado",
      "teleportalDescription": "Tarefas de realocação e mobilidade",
      "title": "Matriz de acesso a recursos",
      "viaBilling": "Via cobrança"
    },
    "select": "Selecione este papel",
    "subtitle": "Escolha a persona que melhor corresponde ao seu papel na jornada. Isso determinará quais recursos você pode acessar.",
    "talent": {
      "description": "Principal talento planejando uma mudança de carreira internacional. Acesso total a todos os recursos Citizen.",
      "title": "Talento (individual)"
    },
    "talentB2B2C": {
      "badge": "Patrocinado pela empresa",
      "description": "Talento com jornada patrocinada por uma empresa. Recursos de nível Pro, sem pagamento necessário.",
      "title": "Talento (patrocinado pela empresa)"
    },
    "talentB2G": {
      "badge": "Patrocinado pelo governo",
      "description": "Talento com jornada patrocinada por programa governamental/público. Recursos de nível Pro, sem pagamento necessário.",
      "title": "Talento (patrocinado pelo governo)"
    },
    "title": "Selecione seu papel na jornada"
  },
  "preferences": {
    "title": "Preferências"
  },
  "profile": {
    "aboutAndLegal": "Sobre & legal",
    "aboutTonnieJourney": "Sobre Tonnie Citizen",
    "address": "Endereço",
    "allowCohortComparisons": "Permitir benchmarking da empresa",
    "allowCohortComparisonsDesc": "Permita que empresas parceiras comparem seu perfil anonimizado para insights de talento",
    "backupCodesDesc": "Guarde esses códigos em um lugar seguro. Cada código pode ser usado apenas uma vez para acessar sua conta se você perder seu dispositivo de autenticação.",
    "backupCodesDone": "Eu salvei meus códigos",
    "backupCodesTitle": "Salve seus códigos de backup",
    "cantScanQr": "Não consegue escanear? Insira esta chave manualmente:",
    "changePhoto": "Alterar foto",
    "photo": {
      "actionSheetTitle": "Foto de perfil",
      "takePhoto": "Tirar foto",
      "chooseFromLibrary": "Escolher da biblioteca",
      "remove": "Remover foto",
      "removeConfirmTitle": "Remover foto de perfil?",
      "removeConfirmBody": "Sua foto será removida e suas iniciais serão exibidas em vez disso.",
      "uploadSuccess": "Foto de perfil atualizada",
      "uploadError": "Não foi possível atualizar sua foto. Por favor, tente novamente.",
      "removeSuccess": "Foto de perfil removida",
      "managedByTitle": "Gerenciado por {{provider}}",
      "genericProvider": "seu provedor de login",
      "cameraPermissionTitle": "Acesso à câmera necessário",
      "cameraPermissionMessage": "Para tirar uma nova foto de perfil, permita o acesso à câmera para a Tonnie nas Configurações do seu dispositivo.",
      "libraryUnavailableTitle": "Biblioteca de fotos indisponível",
      "libraryUnavailableMessage": "Não conseguimos abrir sua biblioteca de fotos. Por favor, tente novamente."
    },
    "completeOnWeb": "Complete o perfil na web",
    "completeOnWebDesc": "Defina suas metas de mobilidade e edite os detalhes da sua carreira no Portal Web Citizen.",
    "completeProfile": "Complete seu perfil",
    "confirmDeleteAccount": "Sim, excluir minha conta",
    "confirmDisable2FA": "Sim, Desativar 2FA",
    "connectLinkedInIdentity": "Conectar LinkedIn (para identidade)",
    "contactSupport": "Entre em contato com nossa equipe de suporte",
    "contactSupportButton": "Contato com suporte",
    "copyBackupCodes": "Copiar todos os códigos",
    "copyright": "© 2024 Tonnie. Todos os direitos reservados.",
    "currentRole": "Função atual",
    "currentSession": "Sessão atual",
    "dangerZone": "Zona de perigo",
    "dataProtection": "Proteção de dados",
    "dataProtectionDesc": "Você tem o direito de acessar, modificar ou excluir seus dados pessoais a qualquer momento. Para mais informações sobre como lidamos com seus dados, por favor, revise nossa Política de Privacidade.",
    "dateOfBirth": "Data de nascimento",
    "deleteAccount": "Excluir conta",
    "deleteAccountError": "Falha ao excluir a conta. Por favor, tente novamente.",
    "deleteAccountTitle": "Excluir sua conta",
    "deleteAccountWarning": "Esta ação é permanente. Todos os seus dados, progresso da jornada e documentos enviados serão excluídos permanentemente. Isso não pode ser desfeito.",
    "description": "Gerencie sua conta e preferências",
    "disable2FA": "Desativar 2FA",
    "disable2FATitle": "Desativar autenticação de dois fatores",
    "disable2FAWarning": "Você tem certeza de que deseja desativar a autenticação de dois fatores? Sua conta será menos segura sem isso.",
    "disconnectIdentity": "Desconectar identidade",
    "educationCount": "Educação ({{count}})",
    "educationalBackground": "Formação educacional",
    "email": "Email",
    "emailNotifications": "Notificações por email",
    "emailNotificationsDesc": "Receber atualizações por email",
    "enable2FA": "Ativar 2FA",
    "enabled": "Ativado",
    "experienceCount": "Experiência ({{count}})",
    "feature": {
      "billingManagement": "Gerenciamento de cobrança e assinatura",
      "careCheckpoints": "Gerenciamento de pontos de verificação de Care e rastreamento de bem-estar",
      "careerOpportunities": "Oportunidades de Career e criador de CV",
      "checkupAssessments": "Avaliações completas de CheckUp e rastreamento de prontidão",
      "familyProgram": "Gerenciamento do programa familiar",
      "passportTimeline": "Linha do tempo de Passport, selos e emblemas",
      "qultureupLearning": "Resumos de aprendizado de QultureUp e painéis de progresso",
      "teleportalManagement": "Gerenciamento de plano de TelePortal e coordenação de tarefas"
    },
    "firstName": "Primeiro nome",
    "firstNamePlaceholder": "Digite o primeiro nome",
    "fullName": "Nome completo",
    "gdprCompliance": "Conformidade com o GDPR",
    "gdprComplianceDesc": "Tonnie está em conformidade com o Regulamento Geral sobre a Proteção de Dados (GDPR) e outras leis de proteção de dados aplicáveis. Você pode exercer seus direitos entrando em contato conosco através do aplicativo ou site.",
    "keyFeatures": "Recursos principais",
    "languages": "Idiomas",
    "lastName": "Último nome",
    "lastNamePlaceholder": "Digite o último nome",
    "lastPdfUpload": "Último PDF enviado: {{date}}",
    "learnMoreAboutTonnie": "Saiba mais sobre Tonnie Citizen e nossa plataforma",
    "legalInformation": "Informações legais e políticas",
    "linkedInDisconnected": "LinkedIn desconectado",
    "logOut": "Sair",
    "mobility": "Mobilidade",
    "mobilityDescription": "Cidadania, passaporte e interesses de realocação",
    "needHelp": "Precisa de ajuda?",
    "notProvided": "—",
    "notificationSettings": "Configurações de notificação",
    "ongoing": "Em andamento",
    "personalInfo": "Informações do perfil",
    "personalInfoDescription": "Atualize suas informações pessoais e detalhes do perfil",
    "phone": "Telefone",
    "phoneInvalidFormat": "O número de telefone pode conter apenas dígitos, espaços, traços e +",
    "phoneNumber": "Número de telefone",
    "phonePlaceholder": "912 345 678",
    "phoneTooShort": "O número de telefone é muito curto (mínimo 6 dígitos)",
    "photoSet": "Foto definida",
    "platformOverview": "Visão geral da plataforma",
    "platformOverviewDescription": "Tonnie Citizen Web funciona perfeitamente com Tonnie Citizen Mobile para fornecer uma experiência completa de realocação. O aplicativo móvel é seu companheiro diário para ações rápidas e recursos mobile-first, enquanto o portal web oferece ferramentas de planejamento abrangentes, avaliações detalhadas e acompanhamento de progresso.",
    "preferenceSettings": "Configurações de preferência",
    "preferences": "Preferências",
    "preferencesSaveError": "Falha ao salvar preferência",
    "privacyImportance": "Sua privacidade é importante para nós. Nossa Política de Privacidade explica como coletamos, usamos e protegemos suas informações pessoais.",
    "privacyPolicy": "Política de privacidade",
    "privacyPolicyDesc": "Como lidamos e protegemos seus dados pessoais",
    "privacySettingUpdated": "Configuração de privacidade atualizada",
    "privacySettings": "Configurações de privacidade",
    "professionalWorkExperience": "Experiência de trabalho profissional",
    "profile": "Perfil",
    "profilePhoto": "Foto do perfil",
    "profileUpdateFailed": "Falha ao atualizar o perfil. Por favor, tente novamente.",
    "profileUpdated": "Perfil atualizado com sucesso!",
    "pushNotifications": "Notificações push",
    "pushNotificationsDesc": "Receba notificações no seu dispositivo",
    "readyToComplete": "Pronto para completar sua integração!",
    "reviewAndComplete": "Revise todas as informações acima e clique em \"Concluir\" para finalizar.",
    "scanQrCode": "Escaneie este código QR",
    "scanQrCodeDesc": "Use seu aplicativo autenticador (por exemplo, Google Authenticator, Authy) para escanear o código QR abaixo.",
    "security": "Segurança",
    "sessionBrowserOnDevice": "{{browser}} em {{device}}",
    "settingDisabled": "{{setting}} desativado",
    "settingEnabled": "{{setting}} ativado",
    "shareAnalytics": "Compartilhar análises",
    "shareAnalyticsDesc": "Ajude a melhorar nossa plataforma com dados de uso anonimizados",
    "showInTalentPool": "Mostre-me no Talent Pool",
    "showInTalentPoolDesc": "Deixe as empresas contratantes na Tonnie descobrirem seu perfil. Você pode sair a qualquer momento.",
    "skills": "Habilidades",
    "skillsDescription": "Habilidades e expertise profissionais",
    "quietHours": "Horário de silêncio",
    "quietHoursDesc": "Pausar notificações push durante este período.",
    "quietHoursEnd": "Até",
    "quietHoursTimezone": "Os horários estão em {{timeZone}}.",
    "quietHoursStart": "De",
    "termsAgreement": "Ao usar Tonnie Citizen, você concorda com nossos Termos de Serviço. Por favor, revise os termos completos para entender seus direitos e obrigações.",
    "termsAndPrivacy": "Termos & privacidade",
    "termsOfService": "Termos de serviço",
    "termsOfServiceDesc": "Nossos termos e condições para usar Tonnie Citizen",
    "title": "Perfil",
    "tonnieJourney": "Tonnie Citizen",
    "tonnieJourneyDescription": "Tonnie Citizen é sua plataforma abrangente para planejar e gerenciar sua jornada de realocação internacional. Acompanhe seu progresso, acesse painéis detalhados e coordene sua mudança com precisão.",
    "twoFactor": {
      "backupCodesLabel": "Códigos de backup",
      "disableError": "Falha ao desativar 2FA",
      "disabledToast": "Autenticação de dois fatores desativada",
      "enableError": "Falha ao iniciar a configuração de 2FA",
      "enabledToast": "Autenticação de dois fatores ativada",
      "copySecretKey": "Copiar chave secreta",
      "secretKeyLabel": "Chave secreta",
      "verifyError": "Código de verificação inválido. Por favor, tente novamente."
    },
    "twoFactorAuth": "Autenticação de dois fatores",
    "twoFactorAuthDesc": "Adicione uma camada extra de segurança",
    "verificationCode": "Código de verificação",
    "verify": "Verificar",
    "version": "Versão {{version}}",
    "viewPolicy": "Ver política",
    "viewTerms": "Ver termos",
    "yourRights": "Seus direitos",
    "notifCatHero": "Jornada e progresso",
    "notifCatHeroDesc": "Novidades de CheckUp, Care, QultureUp, TelePortal e Passport.",
    "notifCatSystem": "Conta e sistema",
    "notifCatSystemDesc": "Segurança, conta e manutenção da plataforma.",
    "notifCatSocial": "Pessoas e empresas",
    "notifCatSocialDesc": "Convites, avaliações, equipe e mensagens.",
    "notifCatAlert": "Alertas e lembretes",
    "notifCatAlertDesc": "Sensíveis a tempo ou dinheiro: cobrança, pagamentos e prazos.",
    "notifMatrixTitle": "Como você é avisado de cada atualização",
    "notifMatrixDesc": "Escolha email e push para cada tipo de atualização. Sua caixa de entrada sempre guarda uma cópia.",
    "notifMatrixCategory": "Categoria",
    "notifMatrixInApp": "No app",
    "notifMatrixEmail": "Email",
    "notifMatrixPush": "Push",
    "notifMatrixInAppAlways": "Sempre ativo — sua caixa de entrada guarda todas as mensagens",
    "notifMatrixEmailOff": "As Notificações por Email estão desativadas, então nenhuma categoria envia email. Ative-as para escolher aqui.",
    "notifMatrixPushOff": "As Notificações Push estão desativadas, então nenhuma categoria envia push. Ative-as para escolher aqui.",
    "notifMatrixCell": "{{channel}} para {{category}}",
    "identitySection": "Identidade",
    "currentCountry": "País atual",
    "currentCountryPlaceholder": "Selecione onde você mora agora",
    "currentCity": "Cidade atual",
    "currentCityPlaceholder": "A cidade onde você mora agora",
    "sections": {
      "add": "Adicionar {{section}}",
      "saved": "Salvo.",
      "saveFailed": "Não foi possível salvar. Tente novamente.",
      "importSaved": "Importado para o seu perfil.",
      "fixErrors_one": "{{count}} campo precisa de atenção",
      "fixErrors_other": "{{count}} campos precisam de atenção",
      "status": {
        "complete": "Completa",
        "empty": "Não preenchida"
      },
      "identity": {
        "title": "Identidade",
        "description": "Seu nome, data de nascimento, telefone e onde você mora."
      },
      "mobility": {
        "title": "Mobilidade e passaporte",
        "description": "Sua cidadania, passaporte, família e como você prefere trabalhar."
      },
      "skills": {
        "title": "Habilidades",
        "description": "Seu cargo, anos de experiência, idiomas e habilidades."
      },
      "education": {
        "title": "Formação",
        "description": "Seus cursos e diplomas."
      },
      "experience": {
        "title": "Experiência",
        "description": "Onde você trabalhou e o que fez."
      },
      "import": {
        "title": "Importar do seu currículo ou LinkedIn",
        "description": "Envie um currículo ou um PDF do LinkedIn e preenchemos suas habilidades, formação e experiência. Você revisa tudo antes de salvar.",
        "cta": "Importar currículo ou LinkedIn"
      }
    },
    "strengthen": {
      "title": "Fortaleça seu perfil",
      "description": "Sua pontuação está pronta. Conte mais sobre você às empresas: adicione qualquer um destes quando quiser. Nada disso é obrigatório."
    },
    "degreeInField": "{{degree}} em {{field}}",
    "strength": {
      "gaugeCaption": "força",
      "gaugeLabel": "Força do perfil: {{percent}} por cento",
      "headline": "Seu perfil está {{percent}}% completo",
      "headlineComplete": "Seu perfil está completo",
      "subline_one": "Falta {{count}} item. Os marcados abaixo influenciam sua pontuação iQulture.",
      "subline_other": "Faltam {{count}} itens. Os marcados abaixo influenciam sua pontuação iQulture.",
      "sublineComplete": "Seu CheckUp tem tudo o que o perfil pode oferecer, e as empresas veem tudo.",
      "level": {
        "getting_started": "Começando",
        "good": "Bom",
        "strong": "Forte",
        "complete": "Completo"
      },
      "next": {
        "label": "Próximo passo",
        "labelFastest": "Próximo passo · o mais rápido",
        "documentFills": "Um único envio preenche: {{items}}",
        "documentButton": "Enviar passaporte"
      },
      "why": {
        "start": "Necessário para iniciar seu CheckUp",
        "persona": "Necessário para iniciar · define como o iQulture lê você",
        "languages": "Seu nível de inglês influencia a pontuação de Comunicação",
        "experience": "Influencia sua pontuação de Experiência Global",
        "years": "Influencia suas pontuações de competências e experiência",
        "skills": "Influencia sua pontuação de competências",
        "education": "Influencia sua pontuação de Preparação Acadêmica",
        "workModel": "Influencia sua pontuação de Flexibilidade de Modelo de Trabalho",
        "passport": "Sua mudança precisa dele — o TelePortal usa"
      },
      "readiness": {
        "startTitle": "Necessário para iniciar seu CheckUp",
        "startDone": "Tudo pronto. Seu CheckUp pode começar quando você quiser.",
        "scoreTitle": "Influencia sua pontuação iQulture",
        "scoreHint": "A pontuação é calculada sem isto, mas com menos informação:",
        "scoreDone": "Sua pontuação tem tudo o que o perfil pode oferecer.",
        "more_one": "+{{count}}",
        "more_other": "+{{count}}"
      },
      "tag": {
        "start": "Necessário para iniciar",
        "score": "Influencia o iQulture",
        "journey": "Para sua jornada"
      },
      "item": {
        "name": "Nome completo",
        "date_of_birth": "Data de nascimento",
        "phone": "Telefone",
        "residence": "Onde você mora",
        "nationality": "Cidadania",
        "passport": "Passaporte válido",
        "work_model": "Como você prefere trabalhar",
        "current_role": "Cargo atual",
        "years_experience": "Anos de experiência",
        "skills": "Competências",
        "languages": "Nível de inglês",
        "education": "Um curso ou formação",
        "experience": "Um cargo que você ocupou"
      },
      "addItem": "Adicionar {{item}}",
      "sectionBar": "Seções do perfil",
      "sectionCount": "{{complete}} de {{total}}",
      "fillFaster": {
        "recommended": "Recomendado"
      },
      "missing": "Ainda falta",
      "fromCareerCv": "Seu CV no Career já dá isso ao seu score iQulture. Adicione aqui também para mostrar no seu perfil.",
      "loadFailed": "Não conseguimos carregar o quanto seu perfil está completo.",
      "tiles": {
        "start": "Para começar o CheckUp",
        "score": "Para o seu score iQulture",
        "sections": "Seções completas"
      }
    },
    "identityDocument": {
      "title": "Preencha com seu passaporte ou RG",
      "subtitle": "Envie uma vez. Nós lemos, você confirma.",
      "close": "Fechar",
      "typeGroup": "Tipo de documento",
      "passport": "Meu passaporte",
      "passportHint": "Uma página só. Preenche mais, e toda mudança de país precisa dele.",
      "idCard": "Meu documento de identidade",
      "idCardHint": "Frente e verso. Preenche seu nome, data de nascimento e nacionalidade.",
      "uploadPassport": "A página com foto do seu passaporte",
      "uploadFront": "Frente do seu documento de identidade",
      "uploadBack": "Verso do seu documento de identidade",
      "uploadHint": "Uma foto ou digitalização · JPG, PNG, HEIC ou PDF, até {{size}} MB",
      "chooseFile": "Escolher arquivo",
      "source": {
        "camera": "Tirar uma foto",
        "library": "Escolher uma foto",
        "files": "Escolher um arquivo"
      },
      "cameraPermission": "Precisamos de acesso à câmera para fotografar seu documento. Você pode permitir em Ajustes.",
      "pickUnavailable": "Não é possível escolher um arquivo agora.",
      "replaceFile": "Trocar",
      "aiNotice": "Seu documento é lido pelo nosso serviço de IA para preencher seu perfil. Nada é salvo no seu perfil até você confirmar. O arquivo fica no seu Cofre, e você pode excluí-lo quando quiser.",
      "continue": "Continuar",
      "back": "Voltar",
      "cancel": "Cancelar",
      "read": "Ler documento",
      "reading": {
        "saving": "Salvando no seu Cofre",
        "reading": "Lendo o documento"
      },
      "review": {
        "intro": "Marque o que usar. Onde seu perfil já diz algo diferente, fica desmarcado para que nada mude de surpresa.",
        "verified": "Conferido",
        "unverified": "Lido por IA — confira",
        "onFile": "No seu perfil: {{value}}",
        "passportValid": "Válido até {{date}}",
        "passportExpired": "Vencido em {{date}}",
        "profileYes": "Sim",
        "profileNo": "Não",
        "documentNumber": "Documento terminado em {{last4}}",
        "expiredWarning": "Este passaporte está vencido. Usá-lo registra que você não tem um passaporte válido.",
        "save": "Salvar no meu perfil",
        "discard": "Descartar",
        "matches": "Igual ao seu perfil"
      },
      "done": {
        "title": "Seu documento foi adicionado",
        "bodyPassport": "Salvo no seu Cofre e preenchido no seu perfil. O TelePortal vai usá-lo nas tarefas de passaporte, sem novo envio.",
        "bodyIdCard": "Salvo no seu Cofre e preenchido no seu perfil.",
        "close": "Concluir"
      },
      "error": {
        "notIdentity": "Isso não parece um passaporte nem um documento de identidade. Tente uma foto nítida da página com foto.",
        "unreadable": "Não conseguimos ler esse arquivo. Tente uma foto mais nítida ou um PDF digitalizado.",
        "unsupported": "Esse tipo de arquivo não é aceito. Use JPG, PNG, HEIC ou PDF.",
        "tooLarge": "Esse arquivo tem mais de {{size}} MB. Use uma foto ou digitalização menor.",
        "unavailable": "A leitura de documentos não está disponível agora. Tente novamente em instantes.",
        "generic": "Algo deu errado ao ler seu documento. Tente novamente.",
        "upload": "O envio não terminou. Tente novamente.",
        "save": "Não conseguimos salvar. Tente novamente.",
        "tryAgain": "Tentar outro arquivo"
      },
      "steps": {
        "document": "Documento",
        "upload": "Envio",
        "reading": "Leitura",
        "review": "Revisão"
      },
      "stepsAria": "Progresso do envio",
      "start": "Começar",
      "privacyTitle": "Privado por padrão.",
      "upload": {
        "title": "Adicione uma foto ou digitalização nítida",
        "tipFrame": "A página inteira, plana e em foco",
        "tipGlare": "Sem reflexo nem dedos sobre o texto",
        "tipMrzPassport": "As duas linhas de código no pé da página totalmente visíveis",
        "tipMrzIdCard": "As linhas de código do verso totalmente visíveis",
        "dropHint": "Arraste uma foto ou PDF para cá"
      },
      "readingView": {
        "title": "Lendo seu documento",
        "subtitle": "Leva alguns segundos. Nada vai para o seu perfil até você confirmar.",
        "savingCount": "Salvando no seu Vault · {{saved}} de {{total}}"
      },
      "reviewView": {
        "title": "Confira o que lemos",
        "mrzVerified": "A zona de leitura mecânica confere",
        "mrzUnverified": "Não conseguimos conferir uma zona de leitura mecânica — confira cada linha",
        "selected_one": "{{count}} linha para salvar",
        "selected_other": "{{count}} linhas para salvar"
      },
      "doneView": {
        "applied": "Agora no seu perfil",
        "nothingApplied": "Seu documento está no seu Vault. Nada mudou no seu perfil."
      },
      "line": {
        "name": "Nome legal, como no documento",
        "account_name": "Usar como nome da sua conta",
        "date_of_birth": "Data de nascimento",
        "nationality": "Nacionalidade",
        "passport": "Passaporte válido"
      },
      "legalName": {
        "label": "Nome no seu passaporte ou RG",
        "hint": "Lido do seu documento. Preenche os formulários em que o documento precisa coincidir; o nome da conta acima é o que as pessoas veem."
      },
      "sourceShort": {
        "camera": "Câmera",
        "library": "Fotos",
        "files": "Arquivos"
      },
      "slot": {
        "empty": "Ainda não adicionado",
        "added": "Adicionado"
      }
    },
    "emailChange": {
      "sameAsCurrent": "Este já é o seu e-mail de acesso.",
      "taken": "Este endereço pertence a outra conta Tonnie. Use outro.",
      "done": "Seu e-mail de acesso agora é {{email}}. Enviamos um aviso para o endereço anterior.",
      "oldKept": "Agora você entra com {{email}}, mas {{old}} continua na sua conta.",
      "oldLinked": "{{old}} continua na sua conta: você ainda entra com {{provider}} por meio dele.",
      "oldLinkedOther": "{{old}} continua na sua conta: um método de acesso que você usa está ligado a ele.",
      "removeOld": "Remover o endereço antigo",
      "sendError": "Não conseguimos enviar o código agora. Tente novamente em alguns minutos.",
      "verifyError": "Não conseguimos verificar o código agora. Tente novamente em alguns minutos.",
      "switchError": "O novo endereço está confirmado, mas não conseguimos torná-lo seu e-mail de acesso. Tente novamente."
    },
    "review": {
      "company": {
        "children_one": "1 filho",
        "children_other": "{{count}} filhos",
        "partner": "Cônjuge",
        "personalInfoDescription": "O que o talento compartilhou sobre si",
        "pets": "Animais de estimação",
        "validPassport": "Passaporte válido"
      },
      "present": "Atual",
      "showMore": "Ver mais",
      "showLess": "Ver menos"
    },
    "ways": {
      "document": {
        "title": "Passaporte ou RG",
        "body": "Preenche data de nascimento, nacionalidade e passaporte — a partir de uma foto.",
        "cta": "Escanear meu passaporte"
      },
      "import": {
        "title": "PDF do LinkedIn ou currículo",
        "body": "Preenche experiência, formação, habilidades e idiomas — a partir de um PDF.",
        "cta": "Importar um PDF"
      },
      "fastest": "Mais rápido"
    },
    "citizenshipsAdd": "Adicionar cidadania",
    "preferencesLoadError": "Não foi possível carregar suas preferências."
  },
  "qultureup": {
    "aboutDescription": "Esta avaliação avalia seu conhecimento sobre:",
    "aboveLevel": "Acima do nível",
    "achievementAdvanced": "Especialista cultural",
    "achievementAdvancedDesc": "Alcançar nível Avançado",
    "achievementCultureExplorer": "Explorador cultural",
    "achievementCultureExplorerDesc": "Iniciou 2+ mundos",
    "achievementFirstMission": "Primeira missão",
    "achievementFirstMissionDesc": "Concluiu sua primeira missão",
    "achievementStreak3": "3 dias seguidos",
    "achievementStreak3Desc": "Aprendendo por 3 dias seguidos",
    "achievementWorldMaster": "Mestre do mundo",
    "achievementWorldMasterDesc": "Complete um mundo inteiro",
    "achievements": "Conquistas",
    "ariaWeeklyActivityChart": "Gráfico de atividade semanal",
    "assessedOn": "Avaliado em {{date}}",
    "assessment": {
      "aboutDesc": "Uma breve avaliação de alinhamento cultural que leva cerca de 10 minutos.",
      "completeMessage": "Sua avaliação QultureUp está completa. Explore os mundos para continuar aprendendo.",
      "completeTitle": "Avaliação completa",
      "description": "Responda a algumas perguntas sobre sua orientação cultural para que possamos personalizar sua jornada.",
      "saving": "Salvando…",
      "subtitle": "Cerca de 10 minutos",
      "title": "Avaliação QultureUp"
    },
    "assessmentDescription": "Determine seu nível de aprendizado",
    "assessmentTitle": "Avaliação QultureUp",
    "coPilot": "CoPilot",
    "complete": "completo",
    "completeDescription": "Seu caminho de aprendizado foi personalizado.",
    "completePreviousTrack": "Complete a trilha anterior para desbloquear esta",
    "completePreviousWorld": "Complete o mundo anterior",
    "completeTitle": "Avaliação completa!",
    "continue": "Continuar",
    "continueDescription": "Você começou sua avaliação QultureUp. Continue exatamente de onde parou no Web Citizen — suas respostas até agora estão salvas.",
    "continueInApp": "Continuar no app",
    "continueInAppButton": "Continuar no app",
    "continueLearning": "Continuar aprendendo",
    "continueOnWeb": "Continue no Citizen Web",
    "continueOnWebDesc": "Retome sua avaliação QultureUp de onde parou no Portal Web Citizen.",
    "continueTitle": "Continue sua avaliação QultureUp",
    "copilotGuideDescription": "Responda perguntas sobre seu conhecimento cultural",
    "copilotGuideTitle": "Guia CoPilot",
    "dayStreak": "Sequência de dias",
    "description": "Aprenda sua nova cultura",
    "difficultyAdvanced": "Avançado",
    "difficultyBeginner": "Iniciante",
    "difficultyIntermediate": "Intermediário",
    "dimensionCulture": "Cultura e normas locais",
    "dimensionHistory": "História e vida cotidiana",
    "dimensionLanguage": "Realidade da língua (nativa + inglês e frases básicas do idioma-alvo)",
    "dimensionWorkplace": "Cultura do local de trabalho e noções básicas de direitos/deveres",
    "error": {
      "description": "Não conseguimos carregar seus dados QultureUp. Por favor, tente novamente.",
      "retry": "Tente novamente",
      "title": "Algo deu errado"
    },
    "estimatedTime": "Tempo estimado",
    "filterAdvanced": "Avançado",
    "filterAll": "Todos os níveis",
    "filterBeginner": "Iniciante",
    "filterIntermediate": "Intermediário",
    "heroBanner": {
      "subtitle": "Domine o lado cultural da sua mudança",
      "title": "QultureUp"
    },
    "heroMiles": "QultureUp Miles",
    "hours": "h",
    "learnOnTheGo": "Aprenda em movimento",
    "learnOnTheGoDesc": "Complete missões, ganhe Miles e acompanhe seu progresso de aprendizado cultural com o aplicativo móvel.",
    "loadingAssessment": "Carregando avaliação…",
    "miles": "Miles",
    "minutes": "min",
    "missionDetailsInApp": "Detalhes da missão disponíveis no aplicativo móvel",
    "missions": "Missões",
    "missionsCompleted": "{{completed}} de {{total}} missões concluídas",
    "missionsCount": "{{completed}}/{{total}} missões",
    "missionsLabel": "Missões",
    "nextMission": "Próximo",
    "noMissionsForLevel": "Nenhuma missão neste nível para esta trilha.",
    "noTracksAvailable": "Nenhuma trilha disponível para este mundo ainda.",
    "noUnlockedWorlds": "Nenhum mundo desbloqueado ainda.",
    "noWorldsAvailable": "Nenhum mundo disponível ainda. Volte em breve!",
    "ofTotal": "{{completed}} de {{total}}",
    "ofTotalCompleted": "{{completed}} de {{total}} concluídos",
    "openInApp": "Abrir no app",
    "openTonnieCitizen": "Abrir no app",
    "percentComplete": "{{percent}}% completo",
    "progressTitle": "Progresso da avaliação",
    "qultureupMiles": "QultureUp milhas",
    "recentlyCompleted": "Recentemente concluído",
    "retakeAssessment": "Refazer avaliação",
    "retakeOnWeb": "Refazer no web Citizen",
    "retakeOnWebDesc": "Refaça sua avaliação QultureUp no Portal Web Citizen para atualizar seu caminho de aprendizado personalizado.",
    "returnToDashboard": "Voltar ao painel",
    "score": "Pontuação: {{score}}%",
    "start": "Começar",
    "startInApp": "Começar no app",
    "startMission": "Iniciar missão",
    "startOnWeb": "Comece no Citizen Web",
    "startOnWebDesc": "Complete sua avaliação QultureUp no Portal Web Citizen para desbloquear seu caminho de aprendizado personalizado.",
    "tabOverview": "Visão geral",
    "tabTracksAndMissions": "Trilhas & missões",
    "tabWorlds": "Mundos",
    "thisWeek": "Esta semana",
    "timeLearning": "Tempo de aprendizado",
    "title": "QultureUp",
    "todaysMission": "Missão de hoje",
    "tracks": "Faixas",
    "tracksCompleted": "{{completed}} de {{total}} trilhas concluídas",
    "tryAgainLater": "Por favor, tente novamente mais tarde.",
    "unableToLoad": "Não foi possível carregar os dados QultureUp",
    "upNext": "Próximo",
    "welcome": {
      "cultureStep": "Cultura & história",
      "cultureStepDesc": "Explore tradições locais, patrimônio e vida cívica",
      "description": "Descubra sua prontidão cultural e desbloqueie um caminho de aprendizado personalizado. Nossa avaliação avalia seu conhecimento em dimensões-chave de cidadania para guiar sua jornada de integração.",
      "languageStep": "Linguagem e comunicação",
      "languageStepDesc": "Construa confiança em interações diárias e oficiais",
      "letsStart": "Vamos começar",
      "socialStep": "Normas sociais e de trabalho",
      "socialStepDesc": "Entenda os costumes do dia a dia e as expectativas profissionais",
      "timeEstimate": "Leva cerca de 5-10 minutos para completar",
      "title": "Bem-vindo ao QultureUp"
    },
    "world": {
      "completed": "Completo"
    },
    "worlds": "Mundos",
    "questionTier": {
      "easy": "Fácil",
      "medium": "Média",
      "hard": "Difícil"
    },
    "difficultyA11y": "Dificuldade: {{level}}",
    "min_one": "{{count}} min",
    "min_other": "{{count}} min",
    "sectionsLabel_one": "{{count}} seção",
    "sectionsLabel_other": "{{count}} seções",
    "comingSoon": {
      "body": "Estamos preparando os mundos e as missões para {{country}}. Eles vão abrir aqui assim que estiverem prontos.",
      "title": "O QultureUp para {{country}} chega em breve"
    },
    "academy": {
      "title": "Tonnie Languages Academy",
      "poweredBy": "Com a {{partner}}",
      "card": {
        "body": "Aprenda inglês, português europeu, espanhol ou italiano com professores ao vivo e estudo autônomo.",
        "cta": "Ver a Academy",
        "level": "Nível {{band}}",
        "completion": "{{percent}} do percurso",
        "next": "Próxima missão",
        "neverSynced": "Seu progresso aparece aqui depois da sua primeira visita.",
        "paused": "Progresso pausado — consentimento retirado",
        "goalReached": "Meta alcançada: {{band}}"
      },
      "page": {
        "description": "Cursos de idiomas com a {{partner}}, com sua conta Tonnie."
      },
      "about": {
        "title": "O que é a Academy",
        "live": "Aulas ao vivo com professores de verdade, individuais ou em pequenos grupos.",
        "selfStudy": "Estudo autônomo entre as aulas, com exercícios e feedback em cada atividade.",
        "billing": "Nada é vendido no app da Tonnie: a {{partner}} apresenta seus planos e cobra por eles no próprio site.",
        "noPassword": "Você entra na {{partner}} com sua conta Tonnie — sem nova senha."
      },
      "language": {
        "title": "Qual idioma você quer aprender?",
        "fixedTitle": "Seu idioma na Academy",
        "names": {
          "en": "English",
          "ptPT": "Português de Portugal",
          "es": "Español",
          "it": "Italiano"
        },
        "level": "Seu nível no TestIt: {{level}}",
        "levelHint": "A {{partner}} confirma seu ponto de partida com o próprio teste de nivelamento.",
        "required": "Escolha um idioma para abrir a Academy.",
        "fixed": "Fixo para esta escola: a {{partner}} cria seu curso no idioma do seu primeiro acesso e o mantém."
      },
      "consent": {
        "title": "O que a Tonnie compartilha com a {{partner}}",
        "intro": "Para abrir a Academy com sua conta, a Tonnie envia à {{partner}}:",
        "fields": {
          "name": "Seu nome",
          "email": "Seu e-mail verificado",
          "learningLanguage": "O idioma que você escolher",
          "level": "Seu nível no TestIt nesse idioma, se você tiver",
          "uiLanguage": "O idioma em que você usa o app",
          "birthDate": "Sua data de nascimento, se estiver no seu perfil",
          "phone": "Seu telefone, se estiver no seu perfil",
          "nationality": "Sua nacionalidade, se estiver no seu perfil"
        },
        "version": "Texto do consentimento, versão {{version}}",
        "give": "Concordo em compartilhar estes dados com a {{partner}}",
        "given": "Você concordou em {{date}}.",
        "withdraw": "Retirar o consentimento",
        "withdrawHint": "Depois de retirado, a Tonnie não compartilha mais nada e a {{partner}} não pode mais conectar você a partir da Tonnie.",
        "outdated": "O texto do consentimento mudou. Leia e concorde novamente para abrir a Academy."
      },
      "open": {
        "action": "Abrir a Academy",
        "opening": "Abrindo…",
        "hintWeb": "Abre em uma nova aba.",
        "hintPhone": "Abre no navegador do seu celular."
      },
      "demo": {
        "action": "Ver a Academy (demonstração)",
        "note": "Uma demonstração do site da {{partner}}, sem a sua conta Tonnie — nada seu é compartilhado."
      },
      "blocked": {
        "title": "Seu navegador bloqueou a nova aba",
        "body": "Abra a Academy pelo link abaixo — ele funciona por um minuto.",
        "link": "Abrir a Academy agora"
      },
      "unavailable": {
        "assessmentRequired": "Faça primeiro a avaliação do QultureUp — a Tonnie Languages Academy abre logo depois.",
        "notConfigured": "A Academy ainda não está aberta aqui.",
        "partnerPending": "A Academy abre assim que o acordo da Tonnie com a {{partner}} for assinado."
      },
      "refusal": {
        "consentRequired": "Concorde com o que é compartilhado antes de abrir a Academy.",
        "languageFixed": "Seu curso na {{partner}} já é em outro idioma — ele é fixo para esta escola. Abra a Academy nesse idioma.",
        "profileIncomplete": {
          "name": "A {{partner}} precisa do seu nome. Adicione-o ao seu perfil e abra a Academy.",
          "email": "A {{partner}} precisa de um e-mail verificado. Verifique seu e-mail e abra a Academy.",
          "both": "A {{partner}} precisa do seu nome e de um e-mail verificado. Adicione-os e abra a Academy."
        },
        "fixName": "Adicionar seu nome",
        "fixEmail": "Verificar seu e-mail",
        "generic": "Não foi possível abrir a Academy. Tente novamente."
      },
      "load": {
        "error": "Não foi possível carregar a Academy."
      },
      "progress": {
        "title": "Seu progresso na Academy",
        "neverSynced": {
          "title": "Ainda sem progresso",
          "body": "Seu percurso aparece aqui assim que a {{partner}} enviar seu primeiro progresso — normalmente logo depois da sua primeira visita."
        },
        "paused": {
          "title": "Progresso pausado",
          "body": "Você retirou seu consentimento, então a {{partner}} parou de enviar seu progresso. É assim que ele estava na última atualização."
        },
        "goalReached": {
          "title": "Meta alcançada",
          "body": "Você alcançou o nível {{band}}, a meta do seu curso. Você pode continuar aprendendo na {{partner}}."
        },
        "level": "Nível {{band}}",
        "bandProgress": "{{percent}} do nível {{band}}",
        "startTarget": "Começou em {{start}} · Meta {{target}}",
        "scale": "Nível {{level}} de {{max}} na escala da {{partner}}.",
        "completed": "{{completed}} de {{total}} missões",
        "completedPercent": "{{percent}} do percurso",
        "miles_one": "Você ganhou {{count}} Mile na Academy",
        "miles_other": "Você ganhou {{count}} Miles na Academy",
        "lastSync": "Última atualização da {{partner}}: {{date}}",
        "reduced": "Por enquanto, a {{partner}} envia só o seu nível atual; estas são as missões dele. Seu progresso geral é o seu nível na escala de 0 a {{max}}.",
        "next": {
          "title": "Próxima missão",
          "in": "Nível {{band}}"
        },
        "allDone": "Todas as missões do seu percurso estão concluídas.",
        "path": {
          "title": "Seu percurso",
          "titlesNote": {
            "en": "Missões em inglês, com os nomes que a {{partner}} dá a elas.",
            "ptPT": "Missões em português europeu, com os nomes que a {{partner}} dá a elas.",
            "es": "Missões em espanhol, com os nomes que a {{partner}} dá a elas.",
            "it": "Missões em italiano, com os nomes que a {{partner}} dá a elas."
          }
        },
        "module": {
          "band": "Nível {{band}}",
          "current": "Você está aqui",
          "count": "{{completed}}/{{total}}"
        },
        "mission": {
          "completed": "Concluída",
          "inProgress": "Em andamento · {{percent}}",
          "notStarted": "Não iniciada",
          "startingPoint": "Já sabia",
          "startingPointHint": "Você já sabia quando começou na Academy: conta para o seu percurso e não gera Miles.",
          "miles_one": "+{{count}} Mile",
          "miles_other": "+{{count}} Miles",
          "capped": "Limite diário de Miles"
        },
        "milestones": {
          "title": "Marcos",
          "band": "Nível {{band}} alcançado",
          "goal": "Meta alcançada"
        },
        "retired": {
          "title": "Concluídas antes",
          "body": "Missões que você concluiu e que não fazem mais parte do seu percurso."
        }
      }
    }
  },
  "settings": {
    "about": {
      "title": "Sobre"
    },
    "billing": "Cobrança",
    "dark": "Escuro",
    "deleteAccount": "Excluir conta",
    "deleteAccountConfirm": "Isso excluirá permanentemente sua conta e todos os dados. Isso não pode ser desfeito.",
    "deleteAccountFailed": "Falha ao excluir a conta. Por favor, tente novamente.",
    "freePlan": "Plano gratuito",
    "language": {
      "title": "Idioma"
    },
    "light": "Claro",
    "myCheckups": "Meus CheckUps",
    "myFamily": "Minha família",
    "myJourneys": "Minhas jornadas",
    "preferences": "Preferências",
    "profile": "Perfil",
    "security": "Segurança",
    "sendFeedback": "Enviar feedback",
    "signOut": "Sair",
    "signOutConfirm": "Você tem certeza de que deseja sair?",
    "termsPrivacy": "Termos & privacidade",
    "theme": {
      "title": "Tema"
    },
    "themeSystem": "Sistema ({{mode}})",
    "title": "Configurações",
    "sessions": {
      "notFound": "Sessão não encontrada",
      "signedOut": "Sessão desconectada",
      "signOutFailed": "Falha ao desconectar a sessão",
      "loadFailed": "Falha ao carregar sessões"
    },
    "preferencesLanguageFallback": "Inglês",
    "membersCount_one": "{{count}} membro",
    "membersCount_other": "{{count}} membros",
    "groups": {
      "journey": "Sua jornada",
      "app": "Aplicativo",
      "help": "Ajuda e informações legais"
    },
    "profileStrength": "Perfil: {{level}} · {{percent}}",
    "pro": "Pro",
    "inout": "InOut — dias fora",
    "inoutPaused": "Pausado",
    "inoutNotStarted": "Não iniciado",
    "myDocuments": "Meus documentos"
  },
  "splash": {
    "authenticateToContinue": "Autentique-se para continuar",
    "biometricFailed": "Autenticação biométrica falhou",
    "tryAgain": "Tente novamente",
    "unlockPrompt": "Desbloquear Tonnie Citizen",
    "usePasswordInstead": "Usar senha em vez disso"
  },
  "sponsorship": {
    "companySponsored": "Patrocinado pela empresa",
    "familySponsored": "Patrocinado pela família",
    "governmentSponsored": "Patrocinado pelo governo",
    "selfPaid": "Pago pelo Próprio"
  },
  "stepper": {
    "care": "Care",
    "checkup": "CheckUp",
    "passport": "Passport",
    "qultureup": "QultureUp",
    "start": "Começar",
    "teleportal": "TelePortal"
  },
  "tabs": {
    "care": "Care",
    "home": "Início",
    "passport": "Passport",
    "qultureup": "QultureUp",
    "teleportal": "TelePortal",
    "inout": "InOut"
  },
  "teleportal": {
    "aboutDescription": "Esta avaliação nos ajuda a entender suas necessidades de realocação:",
    "aboutTitle": "Sobre esta avaliação",
    "addNote": "Adicionar nota",
    "agentDate": "Data",
    "agentHistory": "Histórico de interação com o agente",
    "agentHistoryDescription": "Veja interações passadas com o Agente Consultor TelePortal",
    "agentInteraction": "Interação",
    "agentSummary": "Resumo",
    "all": "Todos",
    "allScope": "Todos os membros",
    "allStatus": "Todos os status",
    "allTracks": "Todas as trilhas",
    "applicationPackages": "Pacotes de aplicação",
    "applicationPackagesDescription": "Ver seus pacotes de documentos organizados",
    "askCoPilot": "Pergunte ao CoPilot sobre esta tarefa",
    "assessment": {
      "destination": "Destino",
      "education": "Educação",
      "educationBachelor": "Graduação",
      "educationHighSchool": "Ensino médio",
      "educationMaster": "Mestrado",
      "educationPhd": "Doutorado",
      "educationVocational": "Técnico / Vocacional",
      "experience": "Experiência",
      "experience0to2": "0-2 anos",
      "experience10Plus": "Mais de 10 anos",
      "experience3to5": "3-5 anos",
      "experience6to10": "6-10 anos",
      "infoDestination": "Preferências de país de destino",
      "infoPurpose": "Propósito da realocação",
      "infoQualifications": "Avaliação de qualificações",
      "infoTimeline": "Cronograma e urgência",
      "purpose": "Finalidade",
      "purposeEntrepreneur": "Iniciar um negócio",
      "purposeFamily": "Reunião familiar",
      "purposeRetire": "Aposentadoria",
      "purposeStudy": "Estudo / Educação",
      "purposeWork": "Emprego / Trabalho",
      "questionDestination": "Qual país você está visando para realocação?",
      "questionEducation": "Qual é o seu nível mais alto de educação?",
      "questionExperience": "Quantos anos de experiência profissional você tem?",
      "questionPurpose": "Qual é o seu principal propósito para realocar?",
      "questionTimeline": "Quando você planeja se realocar?",
      "timeline": "Cronograma",
      "timeline1Year": "Dentro de 1 ano",
      "timeline3Months": "Dentro de 3 meses",
      "timeline6Months": "Dentro de 6 meses",
      "timelineAsap": "Assim que possível",
      "timelineExploring": "Apenas explorando"
    },
    "assessmentCompleteMessage": "Analisamos seu perfil e identificamos possíveis caminhos de visto para seu destino alvo.",
    "assessmentDescription": "Configure sua jornada de realocação",
    "assessmentTitle": "Avaliação TelePortal",
    "associatedWithTasks": "Associado a tarefas",
    "attachExistingDocument": "Anexar documento existente",
    "backToDashboard": "Voltar ao painel",
    "blocked": "Bloqueado",
    "blockedBy": "Bloqueado Por",
    "blocking": "Bloqueando",
    "blockingOnly": "Bloqueando apenas tarefas",
    "brain": {
      "error": "Algo deu errado ao construir seu kit. Por favor, tente novamente em um momento.",
      "destinationNotSupported": "Ainda não conseguimos montar um kit de mudança para este destino. Sua jornada está salva — o TelePortal abre aqui assim que este destino for atendido.",
      "phase1": "Analisando seu perfil",
      "phase2": "Mapeando documentos necessários",
      "phase3": "Construindo lista de tarefas",
      "phase4": "Personalizando marcos",
      "phase5": "Finalizando seu kit",
      "ready": "Seu kit está pronto",
      "reviewKit": "Revise seu kit",
      "stat": {
        "docsNeeded": "Documentos necessários",
        "fromVault": "Do seu cofre",
        "members": "Membros",
        "tasks": "Tarefas"
      },
      "subtitle": "Construindo seu kit de realocação personalizado",
      "title": "Cérebro TelePortal",
      "complexity": {
        "simple": "Simples",
        "standard": "Padrão",
        "complex": "Complexo"
      }
    },
    "captureMobile": "Capturar no celular",
    "certificationLabel": "Certificação",
    "certificationRequired": "{{type}}",
    "clearFilters": "Limpar filtros",
    "clickToUpload": "Clique para enviar ou arraste e solte",
    "collapseDetails": "Colapsar detalhes",
    "comingSoon": "Em breve",
    "companionCareerProgress": "Progresso do companheiro Career",
    "companionEmploymentReadiness": "Avaliação de prontidão para emprego do acompanhante",
    "companionIntegrationSupport": "Marcos de suporte à adaptação do acompanhante",
    "companionProgram": "Programa do acompanhante",
    "companionProgramDesc": "Redução de risco para lares de dupla carreira — rastrear a prontidão para emprego e suporte à integração do acompanhante",
    "complete": "Completo",
    "completeInMobile": "Completo no celular",
    "completeTasksOnMobile": "Complete tarefas no celular",
    "completeTitle": "Avaliação completa!",
    "completed": "Completo",
    "completedDate": "Concluído {{date}}",
    "completedSection": "Completo",
    "completionNotesPlaceholder": "Adicionar notas de conclusão (opcional)...",
    "complexity": {
      "complex": "Complexo",
      "simple": "Simples",
      "standard": "Padrão"
    },
    "consultantAgent": "Agente consultor TelePortal",
    "consultantAgentDesc": "Obtenha orientação especializada de nossos consultores de imigração",
    "consultantAgentDescription": "Obtenha ajuda com seus documentos e tarefas TelePortal",
    "consultantAgentHelp": "O Agente Consultor pode ajudá-lo a validar, organizar e anexar documentos automaticamente",
    "continue": {
      "description": "Você começou sua configuração TelePortal. Continue exatamente de onde parou no Web Citizen — suas respostas até agora estão salvas.",
      "title": "Continue sua configuração TelePortal"
    },
    "continueOnWeb": "Continue no Citizen Web",
    "continueOnWebDesc": "Retome sua configuração TelePortal de onde parou no Portal Web Citizen.",
    "copilotGuideDescription": "Responda perguntas sobre suas necessidades de realocação",
    "copilotGuideTitle": "Guia CoPilot",
    "couldNotLoad": "Não conseguimos carregar seus dados TelePortal. Por favor, tente novamente.",
    "createApplicationPackage": "Criar pacote de aplicação",
    "createApplicationPackageDesc": "Prepare e organize todos os seus documentos de aplicação",
    "createApplicationPackageDescription": "Agrupe vários documentos para solicitações de visto e outras submissões",
    "createInMobile": "Criar no celular",
    "criticalTasks": "Tarefas críticas",
    "currentProofDocuments": "Documentos de prova atuais",
    "currentlyInProgress": "Atualmente em progresso",
    "daysLeft": "{{count}}d restantes",
    "deleteDocumentDescription": "Esta ação não pode ser desfeita. O documento será removido permanentemente.",
    "deleteDocumentTitle": "Excluir documento?",
    "dependencies": {
      "allTracks": "Todas as trilhas",
      "blockedBy": "Bloqueado por",
      "blocking": "Bloqueando",
      "blocks": "Bloqueios",
      "connectedTasks": "tarefas conectadas",
      "criticalPath": "Caminho crítico",
      "dependsOn": "Depende de",
      "description": "Visualize como as tarefas dependem umas das outras em diferentes trilhas",
      "empty": "Nenhuma dependência de tarefa para exibir",
      "emptyHint": "As dependências aparecerão quando seu kit de realocação tiver tarefas vinculadas",
      "enterFullscreen": "Entrar em tela cheia",
      "exitFullscreen": "Sair da tela cheia",
      "filterByTrack": "Filtrar por trilha",
      "graphLabel": "Gráfico de dependência de tarefas",
      "graphView": "Visualização gráfica",
      "independentTasks": "tarefas independentes",
      "insightBanner": "Insight de dependência",
      "listView": "Visualização em lista",
      "members": "Membros",
      "resetView": "Redefinir visualização",
      "shared": "Compartilhado",
      "tabTitle": "Dependências",
      "title": "Gráfico de dependência de tarefas",
      "zoomIn": "Aproximar",
      "zoomOut": "Afastar"
    },
    "dependenciesResolved": "Dependências (resolvidas)",
    "description": "Descrição",
    "dimensionFamily": "Configuração familiar",
    "dimensionStatus": "Status atual",
    "dimensionTimeline": "Cronograma e prazos",
    "dimensionVisa": "Tipo de visto e requisitos",
    "docDetail": {
      "actions": "Ações",
      "certification": "Certificação",
      "certificationNone": "Não requerido",
      "certificationRequired": "Requerido ({{type}})",
      "expired": "Expirado",
      "expiryDate": "Data de expiração",
      "issuingAuthority": "Autoridade emissora",
      "location": "Localização",
      "locationHomeCountry": "País de origem",
      "locationOnline": "Online",
      "locationTargetCountry": "País alvo",
      "noExpiry": "Sem data de expiração",
      "status": "Status",
      "title": "Detalhes do documento",
      "type": "Tipo de documento",
      "upload": "Carregar documento",
      "uploadedAt": "Enviado",
      "validityPeriod": "Período de validade",
      "view": "Ver documento",
      "viewFailed": "Falha ao abrir documento",
      "openWith": "Abrir documento com…",
      "expiresIn_one": "Expira em {{count}} dia",
      "expiresIn_other": "Expira em {{count}} dias",
      "validFor_one": "Válido por {{count}} dia",
      "validFor_other": "Válido por {{count}} dias"
    },
    "docEmployment": "Contrato de trabalho",
    "docIncome": "Comprovante de renda",
    "docInsurance": "Seguro de saúde",
    "docNeedsReview": "Documento precisa de revisão — formato pode não ser ideal",
    "docNotUploaded": "Documento ainda não enviado",
    "docPassport": "Passport",
    "docStatusMissing": "Faltando",
    "docStatusPending": "Pendente",
    "docStatusRejected": "Rejeitado",
    "docStatusUploaded": "Enviado",
    "docStatusVerified": "Verificado",
    "docSuggestion1": "Certifique-se de que o documento está claro e legível",
    "docSuggestion2": "Verifique a data de expiração",
    "docTypeEducation": "Educação",
    "docTypeFinancial": "Financeiro",
    "docTypeHousing": "Habitação",
    "docTypeIdentity": "Identidade",
    "docTypeLegal": "Legal",
    "docTypeOther": "Outro",
    "docTypeTravel": "Viagem",
    "docUploadedPendingValidation": "Documento enviado, pendente de validação",
    "docValid": "Documento verificado e válido",
    "document": {
      "apostille": "Apostila necessária",
      "certification": "Certificação",
      "certificationRequired": "Certificação necessária",
      "docExpired": "Este documento expirou",
      "docExpiring": "Este documento expira em {{days}} dias",
      "expired": "Expirado",
      "expiresIn": "Expira em {{days}} dias",
      "expiresSoon": "Expira em breve",
      "haia": "Apostila de haia",
      "validFor": "Válido por {{duration}}"
    },
    "documentDeleted": "Documento excluído",
    "documentDownloaded": "Documento baixado",
    "documentName": "Nome do documento",
    "documentNamePlaceholder": "por exemplo, Passport, Certidão de Nascimento...",
    "documentType": "Tipo de documento",
    "documentUploadError": "Falha ao enviar documento. Por favor, tente novamente.",
    "documentUploadRequired": "Envio de documento necessário",
    "documentUploadedSuccess": "Documento enviado com sucesso",
    "documentValidatedSuccess": "Documento validado com sucesso",
    "documentValidationError": "Falha ao validar documento. Por favor, tente novamente.",
    "documents": "documentos",
    "documentsDescription": "Envie e verifique os documentos necessários para sua solicitação de visto e realocação.",
    "documentsGathered": "Documentos reunidos",
    "documentsReady": "Documentos prontos",
    "documentsStatus": "Status dos documentos",
    "documentsUploaded": "Documentos enviados com sucesso",
    "done": "Concluído",
    "dueDate": "Data de vencimento",
    "dueToday": "Vencendo hoje",
    "dueTomorrow": "Vencendo amanhã",
    "editNote": "Editar nota",
    "editTask": "Editar tarefa",
    "employerFull": "Sim, patrocínio total",
    "employerNA": "Não aplicável",
    "employerNone": "Não, auto-patrocinado",
    "employerPartial": "Sim, apoio parcial",
    "entireFamily": "Toda a família",
    "estimatedDuration": "Duração estimada",
    "estimatedTime": "Tempo estimado",
    "eventTargetArrival": "Chegada prevista",
    "eventVisaDecision": "Decisão do visto",
    "eventVisaInterview": "Entrevista de visto",
    "expandDetails": "Expandir detalhes",
    "expired": "Expirado",
    "expiredCount": "Expirado",
    "expiresInDays": "Expira em {{count}}d",
    "downloadAllDocuments": "Baixar tudo ({{count}})",
    "downloadSelectedDocuments": "Baixar {{count}}",
    "selectDocument": "Selecionar documento",
    "expiresOn": "Expira: {{date}}",
    "expiringSoon": "Expirando em breve",
    "explainTask": "Explicar tarefa",
    "family": "Família",
    "familyBoth": "Com parceiro e filhos",
    "familyChildren": "Com filhos",
    "familyConfig": {
      "applicableTracks": "Trilhas aplicáveis",
      "childNumber": "Filho {{number}}",
      "companion": "Acompanhante",
      "configureTracksDescription": "Selecione quais trilhas (Legal, Viagem, Configuração) se aplicam a cada membro da família",
      "configureTracksTitle": "Configurar trilhas para cada membro",
      "dependent": "Dependente",
      "description": "Configurar acesso às trilhas para cada membro da família, animal de estimação, acompanhante ou dependente",
      "familyMember": "Membro da família",
      "justMe": "Só eu",
      "legal": "Legal",
      "mainQuestion": "Você vai se realocar com membros da família?",
      "partnerSpouse": "Parceiro/Cônjuge",
      "pet": "Animal de estimação",
      "pets": "Animais de estimação",
      "setup": "Configuração",
      "travel": "Viagem",
      "yesBringingFamily": "Sim, trazendo a família",
      "membersConfigured_one": "{{count}} membro configurado",
      "membersConfigured_other": "{{count}} membros configurados"
    },
    "familyJustMe": "Só eu",
    "familyMasterOnly": "Apenas o Mestre da Família pode modificar tarefas TelePortal",
    "familyMasterOnlyDesc": "Apenas o Mestre da Família pode iniciar ou controlar a avaliação e tarefas TelePortal. Entre em contato com seu Mestre da Família para assistência.",
    "familyPartner": "Com parceiro/cônjuge",
    "filter": {
      "allExpiry": "Todas as expirações",
      "clearAll": "Limpar",
      "expired": "Expirado",
      "expiringSoon": "Expirando em breve",
      "location": "Localização",
      "locationAll": "Todas as localizações",
      "locationHome": "País de origem",
      "locationOnline": "Online",
      "locationTarget": "País alvo",
      "member": "Membro",
      "memberAll": "Todos os membros",
      "selectMember": "Selecionar membro",
      "sort": "Classificar",
      "sortDefault": "Padrão",
      "sortDueDate": "Data de vencimento",
      "sortPriority": "Prioridade",
      "valid": "Válido"
    },
    "ganttView": "Visualização Gantt",
    "generatingChecklist": "Gerando sua lista de verificação personalizada...",
    "goToJourneyBuilder": "Ir para o construtor de jornada",
    "groupBy": {
      "byTrack": "Por trilha",
      "label": "Agrupar por",
      "location": "Agrupar por localização"
    },
    "guideSetupSubtitle": "Nós vamos guiá-lo pela configuração — responda a algumas perguntas e construiremos seu kit.",
    "heroBanner": {
      "complete": "Completo",
      "documents": "Documentos",
      "household": "Núcleo familiar",
      "milestones": "Marcos",
      "subtitle": "Seu centro de comando de realocação",
      "tasks": "Tarefas",
      "title": "TelePortal"
    },
    "heroMiles": "TelePortal Miles",
    "highPriority": "Alta prioridade",
    "household": {
      "everyone": "Todos",
      "bar": {
        "allMembers": "Todos os membros",
        "filterBy": "Filtrar por membro",
        "filterByMember": "Filtrar por membro"
      },
      "petSpecies": {
        "cat": "Gato",
        "dog": "Cachorro",
        "other": "Outro"
      },
      "schoolStages": {
        "higher": "Educação superior",
        "pre_school": "Pré-escola",
        "primary": "Escola primária",
        "secondary": "Escola secundária"
      },
      "talent": "Você"
    },
    "householdAware": "Ciente da família",
    "householdMembers": "Membros da família",
    "inProgressSection": "Em andamento",
    "keyDates": "Datas chave",
    "kit": {
      "activate": "Ativar kit",
      "activateModified": "Ativar kit modificado",
      "buildFailed": "Não foi possível construir seu kit",
      "buildFailedHint": "Tente novamente ou entre em contato com o suporte se isso persistir.",
      "byMember": "Por membro",
      "byTrack": "Por trilha",
      "complexity": {
        "complex": "Complexo",
        "simple": "Simples",
        "standard": "Padrão"
      },
      "defaultMember": "Você",
      "dependencyWarning": "Algumas tarefas dependem de outras. Remover uma pode bloquear o trabalho subsequente.",
      "docs": "Documentos",
      "docsLinked": "Do cofre",
      "docsNeeded": "Docs necessários",
      "editHint": "Clique em qualquer tarefa para editar, remover ou reordenar.",
      "loading": "Carregando kit…",
      "members": "Membros",
      "miles": "Miles",
      "modified": "Modificado",
      "rebuild": "Reconstruir",
      "rebuildConfirm": "Reconstruir kit",
      "rebuildConfirmDesc": "A reconstrução criará um novo kit com base no seu perfil mais recente. As modificações que você fez serão perdidas.",
      "rebuildConfirmTitle": "Reconstruir seu kit?",
      "removeTask": "Remover tarefa",
      "removedTasks": "Tarefas removidas",
      "required": "Requerido",
      "requiredTask": "Tarefa requerida",
      "restore": "Restaurar",
      "retry": "Tentar novamente",
      "tasks": "Tarefas",
      "title": "Seu kit TelePortal",
      "vaultLinked": "Vinculado do cofre",
      "taskCount_one": "{{count}} tarefa",
      "taskCount_other": "{{count}} tarefas",
      "milestoneCount_one": "{{count}} marco",
      "milestoneCount_other": "{{count}} marcos"
    },
    "location": {
      "all": "Todos",
      "either": "Qualquer país",
      "filter": "Localização",
      "filterLabel": "Localização",
      "homeCountry": "País de origem",
      "online": "Online",
      "other": "Outro",
      "targetCountry": "País alvo"
    },
    "locationEither": "Qualquer",
    "locationHome": "Casa",
    "locationOnline": "Online",
    "locationTarget": "Alvo",
    "manageJourney": "Planeje sua realocação",
    "markAsDone": "Marcar como concluído",
    "markComplete": "Marcar completo",
    "milesEarned": "+{{miles}} Miles de Jornada ganhas",
    "milestoneArrivalPlanning": "Planejamento de chegada",
    "milestoneDocumentCollection": "Coleta de documentos",
    "milestoneEssentialServices": "Serviços essenciais",
    "milestoneFinancialSetup": "Configuração financeira",
    "milestoneHousing": "Habitação",
    "milestoneTravelBooking": "Reserva de viagem",
    "milestoneVisaApplication": "Solicitação de visto",
    "milestones": {
      "admin_complete": "Admin completo",
      "arrived_in_destination": "Chegado ao destino",
      "arrived_in_portugal": "Chegou em Portugal",
      "documents_gathered": "Documentos reunidos",
      "documents_legalized": "Documentos legalizados",
      "fully_settled": "Totalmente estabelecido",
      "housing_secured": "Habitação garantida",
      "legal_registration_complete": "Registro legal completo",
      "travel_booked": "Viagem reservada",
      "visa_approved": "Visto aprovado"
    },
    "milestonesCount": "{{completed}}/{{total}} marcos",
    "milestonesLabel": "Marcos",
    "missing": "Faltando",
    "mobileAppDescription": "Use o aplicativo móvel para enviar documentos, completar tarefas e obter orientação em tempo real do Agente Consultor TelePortal.",
    "needHelp": "Precisa de ajuda?",
    "needsAttention": "Precisa de atenção",
    "noAgentHistory": "Nenhuma interação com agentes ainda",
    "noAgentHistoryDescription": "Use o Agente Consultor TelePortal no aplicativo móvel para obter ajuda com documentos",
    "noDocumentsAttached": "Nenhum documento anexado ainda",
    "noDocumentsInTrack": "Nenhum documento nesta trilha ainda",
    "noDocumentsUploaded": "Nenhum documento enviado ainda",
    "noJourneySelected": "Nenhuma jornada selecionada",
    "noJourneySelectedDesc": "Selecione uma jornada para visualizar suas tarefas e progresso TelePortal",
    "noMilestonesYet": "Nenhum marco ainda",
    "noPackages": "Nenhum pacote de aplicação criado ainda",
    "noPackagesDescription": "Crie pacotes no aplicativo móvel para organizar documentos para envios",
    "noProofAttached": "Nenhum documento de prova anexado ainda",
    "noTasksAnyTrack": "Nenhuma tarefa disponível em nenhuma trilha ainda",
    "noTasksFoundForFilter": "Nenhuma tarefa encontrada para o filtro selecionado",
    "noTasksInProgress": "Nenhuma tarefa atualmente em andamento",
    "noTasksInTrack": "Nenhuma tarefa disponível nesta trilha ainda",
    "noTasksMatchingFilters": "Nenhuma tarefa corresponde aos seus filtros atuais",
    "notePlaceholder": "Adicione suas notas aqui...",
    "noteSaved": "Nota salva",
    "notes": "Notas",
    "openInApp": "Abrir no app",
    "openInMobile": "Abrir no móvel",
    "openTonnieCitizen": "Abrir no app",
    "openingDocument": "Abrindo documento...",
    "orDragAndDrop": "PDF, JPG, PNG até 10MB",
    "orUploadNewProof": "Ou enviar novo documento de prova",
    "otherDocuments": "Outros documentos",
    "overallProgress": "Progresso geral",
    "overdue": "Atrasado",
    "packageCreated": "Criado",
    "packageDocuments": "Documentos",
    "packageDownload": "Baixar pacote",
    "packageName": "Nome do pacote",
    "packagePurpose": "Finalidade",
    "pending": "Pendente",
    "pendingReview": "Revisão pendente",
    "preparingSetup": "Preparando configuração…",
    "priorityBlockedTasks": "Tarefas prioritárias e bloqueadas",
    "priorityTasksRequiringAttention": "Tarefas prioritárias requerendo atenção",
    "proOnly": "Pro apenas",
    "processing": "Processando...",
    "progress": "Progresso",
    "progressComplete": "{{percent}}% completo",
    "progressSummary": "Você está {{progress}}% através da sua jornada de realocação. {{attention}} tarefas precisam da sua atenção.",
    "progressTitle": "Progresso da avaliação",
    "proof": "Prova",
    "proofOfDone": "Prova de conclusão",
    "proofOfDoneDescription": "Anexe um documento como prova de que esta tarefa foi concluída",
    "proofRequired": "Esta tarefa requer prova de conclusão. Por favor, anexe um documento.",
    "questionCurrentStatus": "Qual é o seu status atual?",
    "questionEmployerSupport": "Você tem apoio ou patrocínio do empregador?",
    "questionFamily": "Você vai se realocar com membros da família?",
    "questionTargetDate": "Qual é a sua data de mudança alvo?",
    "questionTargetDateFormatted": "Qual é a sua data de mudança alvo? (MM/AAAA)",
    "questionVisaType": "Que tipo de visto ou rota de realocação você está planejando?",
    "readOnly": "Visualização somente leitura",
    "readOnlyDescription": "As tarefas podem ser concluídas no aplicativo móvel",
    "redirectingIn": "Redirecionando...",
    "rejected": "Rejeitado",
    "required": "Requerido",
    "requiredDocuments": "Documentos necessários",
    "requiredForTask": "Requerido para",
    "requiresProof": "Requer prova",
    "resolveNow": "Resolver agora",
    "retakeOnWeb": "Refazer configuração no web Citizen",
    "retakeOnWebDesc": "Refaça o assistente de configuração TelePortal no Portal Web Citizen para atualizar seu plano de realocação personalizado.",
    "retakeSetup": {
      "label": "Refazer configuração",
      "acknowledge": "Eu entendo",
      "cleanDocs": "Limpar documentos vinculados",
      "cleanTasks": "Limpar tarefas modificadas",
      "confirmReset": "Redefinir e reconstruir",
      "preFilled": "Suas respostas anteriores estão pré-preenchidas. Atualize o que mudou.",
      "rebuildTasks": "Reconstruir lista de tarefas"
    },
    "returnToDashboard": "Voltar ao painel",
    "saveNote": "Salvar nota",
    "searchTasks": "Pesquisar tarefas...",
    "selectDocumentType": "Selecionar tipo...",
    "selected": "Selecionado",
    "setup": {
      "dimensions": {
        "household": {
          "addMember": "Adicionar membro da família",
          "memberTypes": {
            "child": "Criança",
            "extended_family": "Família estendida",
            "partner": "Parceiro / Cônjuge",
            "pet": "Animal de estimação",
            "talent": "Solicitante principal (você)"
          },
          "subtitle": "Quem está se realocando com você?",
          "title": "Sua família"
        },
        "housing": {
          "plans": {
            "buy": "Comprar um imóvel",
            "company_provided": "Moradia fornecida pela empresa",
            "rent": "Alugar um apartamento",
            "temporary": "Acomodação temporária primeiro"
          },
          "subtitle": "Onde você vai morar?",
          "title": "Plano de habitação"
        },
        "legalStatus": {
          "currentStatus": "Status de imigração atual",
          "subtitle": "Sua situação legal atual",
          "title": "Status legal e de imigração",
          "visaType": "Tipo de visto"
        },
        "professional": {
          "sponsorshipTypes": {
            "company_sponsored": "Patrocinado pela empresa",
            "freelancer": "Freelancer / Nômade digital",
            "intra_company": "Transferência entre empresas",
            "job_seeker": "Procurando emprego",
            "other": "Outro",
            "retired": "Aposentado",
            "self_employed": "Autônomo",
            "startup": "Iniciando um negócio",
            "student": "Estudante"
          },
          "subtitle": "Sua situação de trabalho",
          "title": "Contexto profissional"
        },
        "specialCircumstances": {
          "freeTextPlaceholder": "Conte-nos mais...",
          "options": {
            "custody_arrangement": "Acordo de custódia",
            "dietary_needs": "Necessidades dietéticas especiais",
            "disability_accommodation": "Acomodações para deficiência",
            "medical_needs": "Necessidades médicas ou tratamento contínuo",
            "military_service": "Obrigações de serviço militar",
            "pending_legal": "Questões legais pendentes",
            "religious_requirements": "Requisitos religiosos"
          },
          "subtitle": "Há mais alguma coisa que devemos saber?",
          "title": "Circunstâncias especiais"
        },
        "timeline": {
          "subtitle": "Quando você precisa se realocar?",
          "title": "Cronograma",
          "urgencies": {
            "flexible": "Flexível / Sem pressa",
            "immediate": "Imediatamente (dentro de 1 mês)",
            "within_3_months": "Dentro de 3 meses",
            "within_6_months": "Dentro de 6 meses"
          }
        },
        "travel": {
          "modes": {
            "already_there": "Já no destino",
            "one_way": "Viagem de ida",
            "round_trip": "Viagem de ida e volta (voltando primeiro)"
          },
          "subtitle": "Como e quando você está viajando?",
          "title": "Logística de viagem"
        },
        "vaultScan": {
          "linked": "Vinculado do vault",
          "outdated": "Precisa de atualização",
          "skip": "Pular por enquanto",
          "subtitle": "Vamos verificar quais documentos você já possui",
          "title": "Escaneamento de documentos"
        }
      },
      "processing": {
        "subtitle": "Tonnie está analisando sua situação e criando um plano personalizado...",
        "title": "Construindo seu kit de realocação"
      },
      "refresh": {
        "button": "Atualizar meu kit de realocação",
        "cancel": "Cancelar",
        "confirm": "Atualizar",
        "confirmMessage": "Suas tarefas concluídas serão preservadas. Novas tarefas podem ser adicionadas e algumas podem ser arquivadas.",
        "confirmTitle": "Atualizar kit de realocação?"
      },
      "subtitle": "Vamos personalizar seu plano de realocação",
      "summary": {
        "beginJourney": "Começar minha jornada",
        "complexityLabel": "Complexidade",
        "documentsLabel": "Documentos necessários",
        "householdLabel": "Membros da família",
        "tasksLabel": "Total de tarefas",
        "title": "Seu kit de realocação",
        "tracksLabel": "Faixas"
      },
      "title": "Monte seu kit de realocação",
      "welcome": {
        "prePopulated": "Preenchemos algumas informações do seu perfil",
        "subtitle": "Vamos construir um Kit de Realocação personalizado com base na sua situação",
        "title": "Bem-vindo à configuração TelePortal"
      },
      "aria": {
        "collapsePanel": "Colapsar painel",
        "pinPanel": "Fixar painel",
        "unpinPanel": "Desafixar painel"
      }
    },
    "setupActivateError": "Falha ao ativar o kit",
    "setupActivatingMessage": "Ativando seu kit — isso leva apenas um momento.",
    "setupActivatingTitle": "Ativando…",
    "setupComplete": "Configuração completa",
    "setupCompletedOn": "Configuração concluída em {{date}}",
    "setupConfigError": "Não conseguimos carregar sua configuração de setup",
    "setupError": "Erro de configuração",
    "setupEstimatedTime": "Cerca de 5 minutos",
    "setupInfoDescription": "Faremos algumas perguntas para personalizar seu kit — o que trazer, quem está vindo e seu cronograma.",
    "setupInfoIntro": "TelePortal é seu centro de comando de realocação. A configuração nos ajuda a adaptar o kit à sua mudança.",
    "setupMissingJourney": "Não conseguimos encontrar uma jornada para configurar.",
    "setupNoJourney": "Nenhuma jornada selecionada",
    "setupNoJourneyMessage": "Escolha uma jornada primeiro, depois construiremos seu kit TelePortal.",
    "setupOnWeb": "Configurar no web Citizen",
    "setupOnWebDesc": "Complete o assistente de configuração TelePortal no Portal Web Citizen para construir seu plano de realocação personalizado.",
    "setupProgress": "Progresso da configuração",
    "setupSubtitle": "Personalize seu kit de realocação",
    "setupSuccessMessage": "Seu kit está pronto. Vamos começar sua relocação.",
    "setupSuccessTitle": "Você está pronto",
    "setupTitle": "Configuração do TelePortal",
    "somethingWentWrong": "Algo deu errado",
    "startAssessment": "Iniciar avaliação",
    "startTask": "Iniciar tarefa",
    "status": "Status",
    "statusBlocked": "Bloqueado",
    "statusCompleted": "Completo",
    "statusHome": "Ainda no país de origem",
    "statusInProgress": "Em andamento",
    "statusMoved": "Já se mudou para o destino",
    "statusOverdue": "Atrasado",
    "statusTodo": "A fazer",
    "statusTransit": "Em trânsito",
    "stepOf": "Passo {{current}} de {{total}}",
    "summary": {
      "assessmentDetails": "Detalhes da avaliação",
      "checklistPreviewTitle": "Sua lista de verificação personalizada incluirá:",
      "currentStatus": "Status atual",
      "description": "Revise os detalhes da sua relocação antes de gerarmos sua lista de verificação personalizada",
      "destination": "Destino",
      "employerSupport": "Suporte do empregador",
      "familyConfiguration": "Configuração familiar",
      "generateChecklist": "Gerar lista de verificação",
      "journeyRoute": "Rota da jornada",
      "legalTrackDesc": "Rastro legal — Prontidão legal e documentos",
      "makeChanges": "Fazer alterações",
      "notSelected": "Não selecionado",
      "origin": "Origem",
      "setupTrackDesc": "Rastro de configuração — Acomodação, reconhecimento de credenciais e primeiras semanas",
      "targetMoveDate": "Data de mudança alvo",
      "title": "Resumo da avaliação TelePortal",
      "travelTrackDesc": "Rastro de viagem — Logística e planejamento de viagem",
      "viewModeDescription": "Complete as informações sobre sua avaliação de relocação",
      "visaType": "Tipo de visto"
    },
    "tabDocuments": "Documentos",
    "tabOverview": "Visão geral",
    "tabTasks": "Tarefas",
    "tabTimeline": "Cronograma",
    "tabTracks": "Rastros & tarefas",
    "targetDate": "Data alvo",
    "task": {
      "allMembers": "Todos os membros",
      "ask": "Perguntar",
      "askCopilotTask": "Pergunte ao CoPilot sobre esta tarefa",
      "blockedBy": "Bloqueado Por",
      "blockedComplete": "Bloqueado — Complete as dependências primeiro",
      "completeError": "Falha ao concluir a tarefa. Por favor, tente novamente.",
      "completionNotesPlaceholder": "Adicionar notas de conclusão (opcional)...",
      "confirmComplete": {
        "message": "Você tem certeza de que deseja marcar esta tarefa como concluída? Esta ação não pode ser desfeita.",
        "title": "Marcar tarefa como concluída?"
      },
      "dependenciesResolved": "Dependências (resolvidas)",
      "docStatusMissing": "Faltando",
      "docStatusPending": "Pendente",
      "docStatusRejected": "Rejeitado",
      "docStatusUploaded": "Enviado",
      "docStatusVerified": "Verificado",
      "documents": "Documentos",
      "documentsRequired": "Documentos necessários",
      "dueToday": "Vencendo hoje",
      "dueTomorrow": "Vencendo amanhã",
      "entireFamily": "Toda a família",
      "markComplete": "Marcar como completo",
      "needHelp": "Precisa de ajuda?",
      "noAdditionalDocs": "Nenhum documento adicional",
      "noDocsAttached": "Nenhum documento anexado ainda",
      "notFound": "Tarefa não encontrada",
      "notes": "Notas",
      "otherDocuments": "Outros documentos",
      "reopenError": "Falha ao reabrir a tarefa. Por favor, tente novamente.",
      "reopenTask": "Reabrir tarefa",
      "requiredDocuments": "Documentos necessários",
      "statusBlocked": "Bloqueado",
      "statusCompleted": "Completo",
      "statusInProgress": "Em andamento",
      "statusOverdue": "Atrasado",
      "statusTodo": "A fazer",
      "taskBlocked": "Tarefa bloqueada",
      "taskBlockedMsg": "Complete as tarefas bloqueadoras primeiro antes de marcar esta como concluída.",
      "title": "Tarefa",
      "trackLegal": "Legal",
      "trackSetup": "Configuração",
      "trackTravel": "Viagem",
      "uploadDocument": "Carregar documento",
      "uploadDocumentHint": "Use a câmera, biblioteca de fotos ou arquivos",
      "uploadRequired": "Carregar necessário",
      "uploaded": "Enviado",
      "validated": "Validado",
      "companyOwnedNote": "Esta tarefa é gerenciada pela sua empresa — eles a completarão do lado deles.",
      "companyProvidesDoc": "Sua empresa fornece isso",
      "daysOverdue_one": "{{count}} dia de atraso",
      "daysOverdue_other": "{{count}} dias de atraso",
      "documentsRequiredMsg_one": "Envie os documentos necessários antes de concluir esta tarefa. Ainda falta {{count}} documento.",
      "documentsRequiredMsg_other": "Envie os documentos necessários antes de concluir esta tarefa. Ainda faltam {{count}} documentos.",
      "dueInDays_one": "Vence em {{count}} dia",
      "dueInDays_other": "Vence em {{count}} dias",
      "milesReward_one": "+{{count}} Mile",
      "milesReward_other": "+{{count}} Miles",
      "missingCount_one": "{{count}} faltando",
      "missingCount_other": "{{count}} faltando",
      "uploadDocsFirst_one": "Envie primeiro {{count}} documento necessário",
      "uploadDocsFirst_other": "Envie primeiro {{count}} documentos necessários"
    },
    "taskArrangePickup": "Organizar transporte do aeroporto",
    "taskArrangePickupDesc": "Organizar transporte do aeroporto",
    "taskBookFlights": "Reservar voos",
    "taskBookFlightsDesc": "Reserve seus voos para o país de destino",
    "taskCompleted": "Tarefa concluída",
    "taskCompletedError": "Falha ao concluir a tarefa. Por favor, tente novamente.",
    "taskCompletedSuccess": "Tarefa concluída com sucesso!",
    "taskCredentialRecognition": "Complete o processo de reconhecimento de credenciais",
    "taskCredentialRecognitionDesc": "Complete o processo de reconhecimento de credenciais para profissões regulamentadas",
    "taskDefinitiveHousing": "Encontrar moradia definitiva",
    "taskDefinitiveHousingDesc": "Encontrar e garantir moradia permanente",
    "taskFillApplication": "Preencher formulário de solicitação de visto",
    "taskFillApplicationDesc": "Complete o formulário de solicitação de visto com informações precisas",
    "taskGatherDocuments": "Reunir documentos necessários",
    "taskGatherDocumentsDesc": "Colete todos os documentos necessários para sua solicitação de visto",
    "taskNotFound": "Tarefa não encontrada",
    "taskNoteDescription": "Adicione uma nota pessoal para esta tarefa",
    "taskNoteTitle": "Nota da tarefa: {{title}}",
    "taskPlanItinerary": "Planejar itinerário de chegada",
    "taskPlanItineraryDesc": "Planeje seu itinerário de chegada e primeiros dias",
    "taskPrepareMaterials": "Preparar materiais para entrevista",
    "taskPrepareMaterialsDesc": "Prepare todos os materiais necessários para a entrevista",
    "taskReopened": "Tarefa reaberta",
    "taskScheduleInterview": "Agendar entrevista de visto",
    "taskScheduleInterviewDesc": "Agende sua entrevista de visto",
    "taskSchoolingChildcare": "Organizar escolaridade e cuidados infantis",
    "taskSchoolingChildcareDesc": "Organizar escolaridade e cuidados infantis para crianças",
    "taskStatus": {
      "blocked": "Bloqueado",
      "completed": "Completo",
      "in_progress": "Em andamento",
      "not_started": "Não iniciado",
      "overdue": "Atrasado",
      "pending": "Pendente",
      "todo": "A fazer"
    },
    "taskTemporaryHousing": "Garantir moradia temporária",
    "taskTemporaryHousingDesc": "Garanta acomodação temporária para sua chegada",
    "tasks": {
      "apostille_documents": {
        "description": "Obtenha carimbos de apostila oficiais em todos os documentos necessários",
        "title": "Apostilar documentos"
      },
      "baggage_shipping": {
        "company_title": "Organizar envio de bagagem",
        "description": "Organizar o envio de pertences pessoais para o destino",
        "title": "Envio de bagagem"
      },
      "child_dependent_visa": {
        "description": "Enviar solicitação de visto de dependente para crianças",
        "title": "Visto de dependente infantil"
      },
      "collect_birth_certificate": {
        "description": "Obter certidões de nascimento certificadas para todos os membros da família que estão se mudando",
        "title": "Coletar certidão de nascimento"
      },
      "collect_marriage_certificate": {
        "description": "Obter certidão de casamento certificada para solicitações de visto",
        "title": "Coletar certidão de casamento"
      },
      "collect_passport": {
        "description": "Reunir passaportes válidos para todos os membros da família que estão se mudando",
        "title": "Coletar Passport"
      },
      "credential_recognition": {
        "description": "Solicitar reconhecimento de credenciais profissionais no país de destino",
        "title": "Reconhecimento de credenciais"
      },
      "criminal_record": {
        "description": "Solicitar certificado de antecedentes criminais do seu país de origem",
        "title": "Obter registro criminal"
      },
      "drivers_license_exchange": {
        "description": "Trocar sua carteira de motorista estrangeira por uma local",
        "title": "Troca de carteira de motorista"
      },
      "employment_contract": {
        "company_title": "Emitir contrato de trabalho",
        "description": "Garanta seu contrato de trabalho assinado com seu empregador",
        "title": "Contrato de trabalho"
      },
      "find_housing": {
        "company_title": "Organizar suporte habitacional",
        "description": "Pesquisar e encontrar acomodação permanente",
        "title": "Encontrar habitação"
      },
      "flight_booking": {
        "company_title": "Organizar reserva de voo",
        "description": "Reservar voos para todos os membros da família que estão se mudando",
        "title": "Reservar voos"
      },
      "get_codice_fiscale": {
        "description": "Obter seu código fiscal italiano",
        "title": "Obter codice fiscale"
      },
      "get_nie": {
        "description": "Obter seu número de identificação de estrangeiro espanhol",
        "title": "Obter NIE"
      },
      "get_nif": {
        "description": "Solicitar seu número de identificação fiscal português (NIF)",
        "title": "Obter NIF (número fiscal)"
      },
      "get_niss": {
        "description": "Registrar-se para o número de segurança social português (NISS)",
        "title": "Obter NISS (segurança social)"
      },
      "groupBy": {
        "member": "Agrupar por membro",
        "shared": "Compartilhado (domicílio)",
        "status": "Agrupar por status"
      },
      "health_insurance_enrollment": {
        "company_title": "Organizar seguro de saúde",
        "description": "Inscrever-se na cobertura de seguro de saúde",
        "title": "Seguro de saúde"
      },
      "health_registration": {
        "description": "Registrar-se no sistema de saúde local",
        "title": "Registro de saúde"
      },
      "local_sim": {
        "description": "Comprar um cartão SIM local ou eSIM para o seu país de destino",
        "title": "Obter cartão SIM local"
      },
      "marriage_certificate": {
        "description": "Coletar sua certidão de casamento",
        "title": "Certidão de casamento"
      },
      "municipality_registration": {
        "description": "Registrar-se na sua prefeitura local (Junta de Freguesia)",
        "title": "Registro municipal"
      },
      "nif_partner": {
        "description": "Solicitar o número de identificação fiscal português do seu parceiro",
        "title": "NIF do parceiro (número fiscal)"
      },
      "open_bank_account": {
        "description": "Abrir uma conta bancária no seu país de destino",
        "title": "Abrir conta bancária"
      },
      "ownership": {
        "company": "Tarefa da empresa",
        "dual": "Responsabilidade compartilhada",
        "government": "Processo governamental",
        "talent": "Sua tarefa"
      },
      "partner_visa_application": {
        "description": "Enviar solicitação de visto para seu parceiro/cônjuge",
        "title": "Solicitação de visto para parceiro"
      },
      "pet_microchip_verification": {
        "description": "Verifique se o microchip do seu pet está em conformidade com a ISO e legível",
        "title": "Verificação de microchip de pet"
      },
      "pet_passport": {
        "description": "Obter passaporte de pet da UE com registros de vacinação",
        "title": "Passaporte do animal de estimação"
      },
      "pet_transport": {
        "description": "Organizar transporte seguro para seu pet até o destino",
        "title": "Transporte de pet"
      },
      "pet_vaccination": {
        "description": "Garantir que todas as vacinas necessárias estejam em dia para seu pet",
        "title": "Vacinação de pet"
      },
      "portuguese_bank_transfer": {
        "description": "Configurar transferências internacionais para sua conta bancária portuguesa",
        "title": "Transferência bancária internacional"
      },
      "proof_of_address": {
        "description": "Obter prova oficial do seu endereço residencial",
        "title": "Comprovante de endereço"
      },
      "proof_of_income": {
        "description": "Reunir extratos bancários e comprovante de meios financeiros",
        "title": "Comprovante de renda"
      },
      "provide_employment_contract": {
        "company_title": "Fornecer contrato de trabalho ao talento",
        "description": "A empresa fornece o contrato de trabalho assinado",
        "title": "Fornecer contrato de trabalho"
      },
      "promise_contract": {
        "company_title": "Fornecer contrato de promessa de trabalho",
        "description": "A empresa emite a promessa de contrato de trabalho assinado para a solicitação de visto",
        "title": "Contrato de promessa de trabalho"
      },
      "consulate_invitation_letter": {
        "company_title": "Fornecer carta de convite para o consulado",
        "description": "A empresa emite a carta de convite / declaração que o talento apresenta no consulado",
        "title": "Carta de convite ao consulado"
      },
      "term_of_responsibility": {
        "company_title": "Fornecer termo de responsabilidade",
        "description": "A empresa assina o termo de responsabilidade notariado cobrindo a estadia do talento",
        "title": "Termo de responsabilidade"
      },
      "techvisa_endorsement": {
        "company_title": "Fornecer endosse de empresa para visto técnico",
        "description": "Empresa certificada emite o endosse do Visto Técnico / termo de responsabilidade para a contratação reconhecida pelo IAPMEI",
        "title": "Endosse de visto técnico"
      },
      "reopen": {
        "button": "Reabrir tarefa",
        "confirmMessage": "Isso moverá a tarefa de volta para o status pendente.",
        "confirmTitle": "Reabrir esta tarefa?",
        "reason": "Motivo para reabertura (opcional)"
      },
      "residence_permit_renewal": {
        "description": "Acompanhe e planeje o cronograma de renovação do seu visto de residência",
        "title": "Renovação do visto de residência"
      },
      "salary_proof": {
        "description": "Reúna contracheques ou comprovante de compensação",
        "title": "Comprovante de salário"
      },
      "school_enrollment": {
        "description": "Inscrever crianças em escolas locais",
        "title": "Inscrição escolar"
      },
      "school_records": {
        "description": "Coletar registros escolares e históricos para crianças",
        "title": "Registros escolares"
      },
      "sef_aima_appointment": {
        "description": "Agendar e comparecer à sua consulta com a autoridade de imigração",
        "title": "Atendimento na AIMA"
      },
      "sign_lease": {
        "description": "Revisar e assinar seu contrato de aluguel",
        "title": "Assinar contrato de aluguel"
      },
      "sns_registration": {
        "description": "Registrar-se no Serviço Nacional de Saúde de Portugal (SNS)",
        "title": "Registro no SNS"
      },
      "sponsor_letter": {
        "company_title": "Fornecer carta de patrocínio",
        "description": "Obter carta de patrocínio do seu empregador",
        "title": "Carta de patrocínio"
      },
      "temp_accommodation": {
        "company_title": "Organizar acomodação temporária",
        "description": "Organizar moradia temporária para suas primeiras semanas",
        "title": "Acomodação temporária"
      },
      "translate_documents": {
        "description": "Obter traduções certificadas de todos os documentos necessários",
        "title": "Traduzir documentos"
      },
      "travel_insurance": {
        "description": "Organizar cobertura de seguro de viagem para o período de realocação",
        "title": "Seguro de viagem"
      },
      "utilities_setup": {
        "description": "Configurar eletricidade, água, gás e internet em sua nova casa",
        "title": "Configuração de utilidades"
      },
      "visa_application": {
        "description": "Enviar sua solicitação de visto no consulado ou portal online",
        "title": "Solicitação de visto"
      },
      "visa_pickup": {
        "description": "Coletar visto aprovado no consulado ou embaixada",
        "title": "Retirada do visto"
      }
    },
    "tasksCompleted": "Tarefas concluídas",
    "tasksCount": "{{completed}}/{{total}} tarefas",
    "tasksDone": "Tarefas feitas",
    "tasksLabel": "Tarefas",
    "tasksOfTotal": "{{completed}}/{{total}} tarefas",
    "timelineDescription": "Linha do tempo visual das suas fases de realocação",
    "timelineTitle": "Linha do tempo & visão Gantt",
    "timelineView": "Visão da linha do tempo",
    "title": "TelePortal",
    "toDo": "A fazer",
    "tonnieChecked": "Tonnie-Verificado",
    "track": {
      "legal": "Legal",
      "setup": "Configuração",
      "travel": "Viagem"
    },
    "trackJourneyProgress": "Acompanhe o progresso da sua jornada de realocação",
    "trackLegal": "Rastreamento legal",
    "trackLegalDesc": "Prontidão legal baseada em rotas, listas de verificação de documentos (ciente do domicílio)",
    "trackLegalDescShort": "Visto, permissões e documentação legal",
    "trackProgress": "Acompanhar progresso",
    "trackSetup": "Configuração de rastreamento",
    "trackSetupDesc": "Camada de estabilização (primeiras semanas) incluindo acomodação, reconhecimento de credenciais, escolaridade/cuidado infantil e marcos do Programa Companion",
    "trackSetupDescShort": "Habitação, bancos e adaptação",
    "trackSuffix": "Rastrear",
    "trackTasksProgress": "{{completed}}/{{total}} tarefas",
    "trackTravel": "Rastreamento de viagem",
    "trackTravelDesc": "Prontidão logística, planejamento de viagem ciente do domicílio",
    "trackTravelDescShort": "Voos, acomodação e logística",
    "tracks": {
      "legal": "Legal & documentos",
      "setup": "Configuração local",
      "travel": "Viagem & logística"
    },
    "tracksCompleted": "Rastros concluídos",
    "tryAgain": "Tente novamente",
    "tryAgainLater": "Por favor, tente novamente mais tarde.",
    "unableToLoadData": "Não foi possível carregar os dados de TelePortal",
    "unlockPro": "Desbloquear com Pro",
    "upcomingDeadlines": "Prazos futuros",
    "upcomingTasks": "Tarefas futuras",
    "upgradeMessage": "Atualize para acessar todas as fases e recursos avançados de TelePortal.",
    "upload": "Carregar",
    "uploadDocument": "Carregar documento",
    "uploadDocumentDescription": "Adicione um documento à sua jornada de TelePortal",
    "uploadFromMobile": "Carregar do móvel",
    "uploadFromMobileDescription": "Use Tonnie Citizen para escanear e fazer upload de documentos instantaneamente",
    "uploadFromMobileTitle": "Enviar documentos do celular",
    "uploadInMobile": "Enviar no celular",
    "uploaded": "enviado",
    "uploading": "Enviando...",
    "validate": "Validar",
    "validated": "Validado",
    "vault": {
      "continue": "Continuar",
      "continueWithPending": "Continuar (pendente de revisão)",
      "documentsFound": "documentos encontrados no seu Cofre",
      "empty": "Cofre vazio",
      "emptyMessage": "Seu cofre está vazio. Vamos adicionar documentos aqui à medida que você concluir tarefas.",
      "expired": "Expirado",
      "expiringSoon": "Expirando em breve",
      "hint": "Vincule documentos do seu cofre para pular envios.",
      "link": "Vincular",
      "linked": "Vinculado",
      "remaining": "restante",
      "scanning": "Escaneando cofre…",
      "skip": "Pular",
      "undo": "Desfazer",
      "validUntil": "Válido até {{date}}",
      "skipped": "Pulado"
    },
    "verifiedByTonnieGuard": "Verificado por Tonnie guard",
    "viewDetails": "Ver detalhes",
    "viewDocumentInMobile": "Envie e gerencie este documento no aplicativo móvel",
    "viewMyOptions": "Ver minhas opções",
    "viewTaskInMobile": "Ver e concluir esta tarefa no aplicativo móvel",
    "visaBlueCard": "Cartão azul da UE",
    "visaFamily": "Reunião familiar",
    "visaNomad": "Nômade digital / Trabalhador remoto",
    "visaStudent": "Visto de estudante",
    "visaWork": "Visto de trabalho / Emprego",
    "welcome": {
      "description": "Construa seu plano de realocação personalizado. Vamos guiá-lo por uma configuração rápida para criar seu painel com tarefas, documentos e prazos adaptados à sua jornada.",
      "docsStep": "Documentos & tarefas",
      "docsStepDesc": "Obtenha uma lista de verificação personalizada de tudo que você precisa",
      "householdStep": "Sua família & visto",
      "householdStepDesc": "Diga-nos quem está se realocando e sua situação de imigração",
      "letsStart": "Vamos começar",
      "planStep": "Habitação & logística",
      "planStepDesc": "Configure seu plano de habitação, viagem e cronograma",
      "timeEstimate": "Leva cerca de 5-10 minutos para completar",
      "title": "Bem-vindo ao TelePortal"
    },
    "welcomeMessage": "Bem-vindo à Avaliação TelePortal! Vou ajudá-lo a criar uma lista de verificação personalizada para realocação. Vamos começar entendendo sua situação.",
    "you": "Você",
    "yourNextStep": "Seu próximo passo",
    "setupDimension": {
      "profile": "Perfil",
      "profileDesc": "Origem, destino e contexto de realocação",
      "household": "Núcleo familiar",
      "householdDesc": "Membros da família que estão se juntando à mudança",
      "documents": "Documentos",
      "documentsDesc": "Digitalização e vinculação de documentos do Vault",
      "preferences": "Preferências",
      "preferencesDesc": "Preferências de viagem, acomodação e estilo de vida"
    },
    "docType": {
      "accommodation": "Comprovante de hospedagem",
      "bank_statements": "Extratos bancários",
      "birth_certificate": "Certidão de nascimento",
      "boarding_pass": "Cartão de embarque",
      "certificate": "Certificado",
      "certified_translation": "Tradução certificada",
      "consulate_invitation_letter": "Carta de convite do consulado",
      "contract": "Contrato",
      "criminal_record": "Registro criminal",
      "drivers_license": "Carteira de motorista",
      "employer_declaration": "Declaração do empregador",
      "employment_contract": "Contrato de trabalho",
      "health_insurance_policy": "Apólice de seguro de saúde",
      "id_card": "Carteira de identidade",
      "insurance": "Seguro",
      "lease_agreement": "Contrato de locação",
      "marriage_certificate": "Certidão de casamento",
      "medical_documentation": "Documentação médica",
      "official_document": "Documento oficial",
      "other": "Outro documento",
      "passport": "Passaporte",
      "passport_stamp": "Carimbo no passaporte",
      "pet_passport": "Passaporte do animal de estimação",
      "photo": "Foto 3x4",
      "promise_contract": "Contrato de promessa",
      "proof_of_address": "Comprovante de endereço",
      "proof_of_income": "Comprovante de renda",
      "residence_permit": "Permissão de residência",
      "salary_proof": "Comprovante de salário",
      "school_records": "Registros escolares",
      "sponsor_letter": "Carta de patrocínio",
      "tax_document": "Documento fiscal",
      "techvisa_endorsement": "Endosse do TechVisa",
      "term_of_responsibility": "Termo de responsabilidade",
      "ticket": "Passagem",
      "travel_insurance": "Seguro de viagem",
      "visa": "Visto",
      "work_permit": "Permissão de trabalho"
    },
    "duration": {
      "1_2_days": "1-2 dias",
      "1_2_weeks": "1-2 semanas",
      "1_3_days": "1-3 dias",
      "1_day": "1 dia",
      "1_week": "1 semana",
      "2_3_weeks": "2-3 semanas",
      "2_4_weeks": "2-4 semanas",
      "2_6_weeks": "2-6 semanas",
      "2_8_weeks": "2-8 semanas",
      "3_5_days": "3-5 dias",
      "4_12_weeks": "4-12 semanas",
      "4_8_weeks": "4-8 semanas",
      "ongoing": "Em andamento"
    },
    "daysOverdue_one": "{{count}} dia de atraso",
    "daysOverdue_other": "{{count}} dias de atraso",
    "documentsAttached_one": "{{count}} documento anexado",
    "documentsAttached_other": "{{count}} documentos anexados",
    "documentsCount_one": "{{count}} documento",
    "documentsCount_other": "{{count}} documentos",
    "dueInDays_one": "Vence em {{count}} dia",
    "dueInDays_other": "Vence em {{count}} dias",
    "inProgressCount_one": "{{count}} em andamento",
    "inProgressCount_other": "{{count}} em andamento",
    "missingDocs_one": "{{count}} faltando",
    "missingDocs_other": "{{count}} faltando",
    "moreCompleted_one": "+{{count}} concluída",
    "moreCompleted_other": "+{{count}} concluídas",
    "needsAttentionCount_one": "{{count}} precisa de atenção",
    "needsAttentionCount_other": "{{count}} precisam de atenção",
    "pendingCount_one": "{{count}} pendente",
    "pendingCount_other": "{{count}} pendentes",
    "timeMinutes_one": "~{{count}} minuto",
    "timeMinutes_other": "~{{count}} minutos",
    "capture": {
      "reading": "Lendo o documento…",
      "readAsOther": "Parece ser {{type}} — confirme que é o documento que esta tarefa pede.",
      "saving": "Salvando no seu Cofre…",
      "savingProgress": "Salvando no seu Cofre… {{percent}}%"
    },
    "deleteDocumentError": "Não foi possível remover o documento. Tente novamente."
  },
  "termsPrivacy": {
    "gdprRights": "Sob o GDPR e as leis de proteção de dados aplicáveis, você tem o direito de acessar, retificar, apagar e portar seus dados pessoais. Você pode exercer esses direitos a qualquer momento através das Configurações ou entrando em contato com nosso Encarregado de Proteção de Dados.",
    "privacyPolicy": "Política de privacidade",
    "termsOfService": "Termos de serviço",
    "title": "Termos & privacidade",
    "yourRights": "Seus direitos"
  },
  "theme": {
    "autoMatchSystem": "O aplicativo irá combinar automaticamente as configurações de tema do seu dispositivo.",
    "configure": "Configurar",
    "custom": "Personalizado",
    "dark": "Escuro",
    "darkTheme": "Tema escuro",
    "followSystem": "Seguir sistema ({{mode}})",
    "light": "Claro",
    "lightTheme": "Tema claro",
    "system": "Sistema",
    "theme": "Tema",
    "themeSelection": "Seleção de tema",
    "useFixedTheme": "O aplicativo usará o tema {{mode}} independentemente das configurações do seu dispositivo."
  },
  "validation": {
    "passwordUpdateFailed": "Falha ao atualizar a senha. Por favor, tente novamente.",
    "passwordUpdated": "Senha atualizada com sucesso",
    "required": "Este campo é obrigatório",
    "email": {
      "invalid": "Endereço de e-mail inválido",
      "required": "Digite seu endereço de e-mail."
    },
    "password": {
      "min": "Sua senha precisa ter pelo menos {{passwordMinLength}} caracteres.",
      "mismatch": "As senhas não coincidem",
      "max": "Sua senha pode ter no máximo {{passwordMaxLength}} caracteres.",
      "required": "Digite sua senha.",
      "confirmRequired": "Confirme sua senha."
    },
    "firstName": {
      "required": "O primeiro nome é obrigatório",
      "tooLong": "Seu nome pode ter no máximo 50 caracteres."
    },
    "lastName": {
      "required": "O sobrenome é obrigatório",
      "tooLong": "Seu sobrenome pode ter no máximo 50 caracteres."
    },
    "uuid": {
      "invalid": "UUID inválido"
    },
    "phone": {
      "invalid": "Número de telefone inválido"
    },
    "url": {
      "invalid": "URL inválido"
    },
    "countryCode": {
      "length": "O código do país deve ter 2 caracteres (ISO 3166-1 alpha-2)"
    },
    "dateRange": {
      "endAfterStart": "A data de término deve ser após a data de início"
    },
    "field": {
      "required": "Este campo é obrigatório"
    },
    "iqulture": {},
    "city": {
      "required": "Informe a cidade onde você mora",
      "tooLong": "O nome da cidade é longo demais (máximo de 100 caracteres)"
    },
    "originCountry": {
      "required": "Escolha o país de onde você está saindo"
    },
    "nationality": {},
    "timeZone": {
      "invalid": "Esse fuso horário não é reconhecido."
    },
    "timeOfDay": {
      "invalid": "Use um horário como 22:00."
    },
    "code": {
      "sixDigits": "Digite o código de 6 dígitos."
    },
    "destination": {
      "notOpen": "Ainda não oferecemos este destino. Hoje, o destino disponível é Portugal."
    },
    "journey": {
      "requestIdRequired": "Uma nova jornada precisa de um identificador de solicitação",
      "newIntentOnly": "Só uma nova jornada aceita um identificador de solicitação ou um nome",
      "labelRequired": "Digite um nome ou apague-o",
      "labelTooLong": "Use 40 caracteres ou menos"
    },
    "inoutPortal": {
      "code": "Letras maiúsculas, números e _ — começando por uma letra, de 2 a 40 caracteres.",
      "colour": "Uma cor como #RRGGBB.",
      "origin": "Um site como https://host (http só para localhost).",
      "originTwice": "Este site está repetido.",
      "originsTooMany": "No máximo 20 sites.",
      "activeNeedsOrigin": "Um portal ativo precisa de pelo menos um site.",
      "httpsUrl": "Um endereço https://.",
      "logo": "Um endereço https://, ou uma imagem servida pela calculadora (/assets/partners/nome.png).",
      "nameTooLong": "No máximo 120 caracteres.",
      "partner": "Escolha uma assessoria do registro.",
      "accentUnreadable": "Ilegível sobre a cor de ação — contraste abaixo de 4,5:1.",
      "pagePair": "A página e o texto dela vêm juntos.",
      "pageUnreadable": "Ilegível sobre a página — contraste abaixo de 4,5:1."
    }
  },
  "vault": {
    "downloadError": "Falha ao baixar",
    "downloadSuccess": "Baixado",
    "downloadZipError": "Falha ao baixar documentos",
    "loadingPreview": "Carregando pré-visualização…",
    "removeError": "Falha ao remover",
    "removeSuccess": "Removido",
    "uploadError": "Falha ao enviar",
    "uploadSuccess": "Enviado",
    "uploadRejected": {
      "mimeNotAllowed": "Este tipo de arquivo não é aceito nesta seção. Escolha outro arquivo.",
      "unidentifiable": "Não conseguimos reconhecer este arquivo. Ele pode estar danificado — tente exportá-lo novamente.",
      "declaredMimeMismatch": "O conteúdo deste arquivo não corresponde ao tipo dele. Envie o arquivo original.",
      "pitchTooLong": "Este vídeo tem mais de {{minutes}} minutos. Escolha um vídeo mais curto.",
      "fileTooLarge": "Este arquivo é grande demais para enviar. Escolha um arquivo menor.",
      "uploadStalled": "O envio parou porque sua conexão deixou de enviar dados. Verifique a conexão e tente novamente.",
      "fileNotLinkable": "Esse documento não está mais no seu Cofre — escolha outro."
    },
    "downloadZipSuccess_one": "Baixando {{count}} documento",
    "downloadZipSuccess_other": "Baixando {{count}} documentos",
    "documentsCount_one": "{{count}} documento",
    "documentsCount_other": "{{count}} documentos",
    "pick": {
      "title": "Escolher do Cofre",
      "description": "Um documento que você já guarda — de qualquer herói.",
      "source": "Do seu Cofre",
      "sourceShort": "Cofre",
      "sourceHint": "Um documento que você já guarda",
      "whatItIs": "O que é",
      "yourDocuments": "Seus documentos",
      "attach": "Anexar",
      "empty": "Ainda não há no seu Cofre um documento que sirva aqui.",
      "errorTitle": "Não foi possível ler o seu Cofre",
      "errorBody": "Tente novamente em instantes.",
      "suggested": "Sugeridos"
    },
    "preview": {
      "openWith": "Abrir com…"
    },
    "add": {
      "title": "Adicionar um documento",
      "description": "Vai para o seu Cofre, no herói que escolher.",
      "where": "Onde guardar",
      "camera": "Tirar foto",
      "library": "Das fotos",
      "files": "Dos arquivos",
      "uploading": "Enviando…"
    }
  },
  "viewport": {
    "description": "O Web Tonnie Citizen é projetado para telas maiores. Para a melhor experiência móvel, faça o download do aplicativo móvel.",
    "downloadAppStore": "Baixar na app store",
    "downloadPlayStore": "Obtenha no Google play",
    "orAccessDesktop": "Ou acesse de um tablet ou desktop",
    "switchToMobile": "Mudar para Tonnie Citizen"
  },
  "webPortal": {
    "availableOnWeb": "Disponível no portal web Citizen",
    "copied": "Copiado!",
    "copyLink": "Copiar link para desktop",
    "hint": "O Portal Web Citizen requer um navegador de desktop.",
    "shareLink": "Compartilhar link"
  },
  "widgets": {
    "continue": "Continuar",
    "motivationalForm": {
      "sharePlaceholder": "Compartilhe seus pensamentos..."
    },
    "rating": {
      "notAtAll": "De forma alguma",
      "veryMuch": "Muito"
    },
    "timeline": {
      "12plusMonths": "12+ meses",
      "12plusMonthsDesc": "Planejamento futuro",
      "1to3months": "1-3 meses",
      "1to3monthsDesc": "Planejamento de curto prazo",
      "3to6months": "3-6 meses",
      "3to6monthsDesc": "Planejamento de médio prazo",
      "6to12months": "6-12 meses",
      "6to12monthsDesc": "Planejamento de longo prazo",
      "asap": "Assim que possível",
      "asapDesc": "Dentro do próximo mês",
      "flexible": "Flexível",
      "flexibleDesc": "Sem cronograma específico"
    }
  },
  "world": {
    "completeToUnlock": "Complete missões anteriores para desbloquear",
    "upgradeToUnlock": "Faça upgrade para desbloquear",
    "completed": "Completo",
    "notFound": "Mundo não encontrado",
    "backToQultureUp": "Voltar para o QultureUp",
    "ofMissions": "{{completed}} de {{total}} missões",
    "overallProgress": "Progresso geral",
    "remaining": "Restante",
    "title": "Mundo",
    "tracks": "Faixas",
    "milesReward_one": "+{{count}} Mile",
    "milesReward_other": "+{{count}} Miles"
  },
  "pricing": {
    "betaPriceLabel": "Preço de acesso antecipado",
    "percentOffLabel": "−{{percent}}%",
    "betaDisclaimer": "Preço de acesso antecipado — preço regular {{listPrice}} após o lançamento."
  },
  "ui": {
    "sidebar": {
      "toggle": "Alternar barra lateral"
    },
    "carousel": {
      "prev": "Slide anterior",
      "next": "Próximo slide"
    },
    "command": {
      "title": "Paleta de comandos",
      "description": "Pesquise um comando para executar..."
    }
  },
  "plan": {
    "upgrade": {
      "teleportal": "Desbloqueie esta jornada ou assine o Pro para abrir todas as fases de TelePortal",
      "qultureup": "Desbloqueie esta jornada ou assine o Pro para acessar todos os mundos de QultureUp",
      "care": "Desbloqueie esta jornada ou assine o Pro para acessar Care & Suporte",
      "passport": "Desbloqueie esta jornada ou assine o Pro para ter o Passport completo",
      "career": "Atualize para Pro para recursos de carreira aprimorados",
      "copilot": "Atualize para Pro para consultas ilimitadas de CoPilot",
      "familyProgram": "Desbloqueie esta jornada ou assine o Pro para ativar o Programa Familiar",
      "default": "Atualize para desbloquear este recurso"
    }
  },
  "appUpdate": {
    "required": {
      "title": "Atualização necessária",
      "body": "Esta versão da Tonnie não é mais suportada. Atualize para continuar.",
      "cta": "Atualizar agora"
    },
    "available": {
      "title": "Atualização disponível",
      "body": "Uma nova versão da Tonnie está disponível.",
      "cta": "Atualizar"
    },
    "dismiss": "Depois"
  },
  "setup": {
    "title": "De que país você está saindo?",
    "countryLabel": "País de onde você está saindo",
    "countryPlaceholder": "Selecione um país",
    "cityLabel": "Cidade onde você mora",
    "cityPlaceholder": "Comece a digitar a sua cidade…",
    "destinationLabel": "Destino",
    "destinationOpenToday": "{{country}} é o destino disponível hoje. Em breve teremos mais.",
    "submit": "Continuar",
    "saving": "Configurando a sua jornada…",
    "saveFailed": "Não foi possível salvar. Verifique sua conexão e tente de novo."
  },
  "profileComplete": {
    "known": "Já no seu perfil",
    "countryPlaceholder": "Selecione um país",
    "cityPlaceholder": "Comece a digitar a sua cidade…",
    "phonePlaceholder": "Seu número de telefone",
    "optionalNote": "Os dados do passaporte, o currículo e a família são opcionais. Eles nunca bloqueiam a sua pontuação.",
    "saving": "Salvando…",
    "saveFailed": "Não foi possível salvar. Verifique sua conexão e tente de novo.",
    "label": {
      "firstName": "Nome",
      "lastName": "Sobrenome",
      "dateOfBirth": "Data de nascimento",
      "currentCountry": "País onde você mora",
      "currentCity": "Cidade onde você mora",
      "phone": "Telefone"
    },
    "loadFailed": "Não foi possível carregar o seu perfil. Verifique sua conexão e tente de novo."
  },
  "profileBasics": {
    "title": "Seus dados básicos",
    "subtitle": "O que o seu CheckUp precisa para começar. Deixe um documento digitar por você — você confere tudo antes de salvar.",
    "progressLabel": "Essenciais para o seu CheckUp",
    "close": "Fechar",
    "back": "Voltar aos seus dados",
    "faster": {
      "title": "Preencha mais rápido",
      "fastest": "Mais rápido",
      "document": {
        "title": "Escanear passaporte ou RG",
        "fills": "Data de nascimento · cidadania"
      },
      "import": {
        "title": "PDF do LinkedIn ou currículo",
        "fills": "Experiência · formação · habilidades · idiomas"
      }
    },
    "orType": "ou digite",
    "filled": {
      "document_one": "Seu documento preencheu {{count}} dado. Veja o que falta abaixo.",
      "document_other": "Seu documento preencheu {{count}} dados. Veja o que falta abaixo.",
      "documentNone": "Nada foi adicionado a partir do documento.",
      "import": "Seu PDF do LinkedIn ou currículo já está no perfil — deixa sua pontuação mais precisa."
    },
    "done": {
      "title": "Seus dados básicos estão completos",
      "body": "Tudo o que o seu CheckUp precisa para começar já está registrado. Um PDF do LinkedIn ou currículo ainda deixa a pontuação mais precisa."
    },
    "doneCta": "Concluído",
    "privacy": "Nada é salvo até você tocar em Salvar.",
    "later": "Mais tarde",
    "save": "Salvar meus dados",
    "saved": "Seus dados foram salvos."
  },
  "citizenHome": {
    "needsYou": {
      "checkin": {
        "action": "Fazer check-in",
        "body": "Seu check-in diário leva um minuto.",
        "last": "Último check-in: {{date}}",
        "title": "Como você está hoje?"
      },
      "checkpoint": {
        "action": "Começar",
        "body": "Conte como está sendo sua adaptação.",
        "overdueTitle": "Um checkpoint do Care está atrasado",
        "title": "Você tem um checkpoint do Care pendente"
      },
      "invitation": {
        "action": "Revisar",
        "body": "Revise o convite para decidir se quer participar.",
        "title": "Convite de {{company}}"
      },
      "later": "Mais tarde",
      "laterA11y": "Mais tarde: {{title}}",
      "seeAll": "Ver tudo",
      "showLess": "Ver menos",
      "seeAllA11y_one": "Ver a {{count}} coisa que precisa de você",
      "seeAllA11y_other": "Ver as {{count}} coisas que precisam de você",
      "profile": {
        "action": "Completar perfil",
        "body": "Sua pontuação do CheckUp precisa de mais alguns dados seus.",
        "title": "Complete seu perfil",
        "secondary": "Enviar passaporte"
      },
      "taskOverdue": {
        "action": "Abrir tarefa",
        "body": "Alguns prazos da sua mudança já passaram.",
        "title_one": "{{count}} tarefa atrasada",
        "title_other": "{{count}} tarefas atrasadas"
      },
      "title": "Precisa de você",
      "unread": {
        "action": "Ler",
        "body": "Veja as novidades.",
        "title_one": "{{count}} mensagem não lida",
        "title_other": "{{count}} mensagens não lidas"
      },
      "dismiss": "Dispensar",
      "dismissA11y": "Dispensar: {{title}}",
      "sponsorship": {
        "title": "A {{company}} quer patrocinar sua jornada",
        "body": "Todos os capítulos são liberados — TelePortal, QultureUp, Care e Passport — sem nenhum custo para você.",
        "action": "Ver oferta"
      },
      "testit": {
        "title_one": "A {{company}} pediu {{count}} teste",
        "title_other": "A {{company}} pediu {{count}} testes",
        "body_one": "Falta {{count}}. Os resultados continuam seus para reutilizar.",
        "body_other": "Faltam {{count}}. Os resultados continuam seus para reutilizar.",
        "action": "Fazer os testes"
      },
      "checkupRequested": {
        "title": "A {{company}} está esperando seu CheckUp",
        "bodyStart": "Foi sua pontuação iQulture que eles pediram. Leva cerca de 10–15 minutos.",
        "actionStart": "Começar CheckUp",
        "bodyContinue": "Termine seu CheckUp — foi sua pontuação iQulture que eles pediram.",
        "actionContinue": "Continuar CheckUp",
        "bodyProfile": "Seu CheckUp está feito. Adicione alguns dados ao perfil e sua pontuação fica pronta.",
        "actionProfile": "Completar perfil",
        "bodyCalculate": "Todos os passos estão feitos. Calcule sua pontuação para responder ao pedido.",
        "actionCalculate": "Calcular pontuação",
        "bodyCalculating": "Sua pontuação está sendo calculada. Não vai demorar.",
        "actionCalculating": "Ver CheckUp",
        "bodyConsent": "Sua pontuação está pronta. Eles só a veem se você escolher compartilhá-la.",
        "actionConsent": "Escolher o que eles veem",
        "titleConsent": "A {{company}} pede para ver a pontuação do seu CheckUp"
      },
      "checkupShared": {
        "title": "A {{company}} pode ver seu CheckUp",
        "body": "Eles veem sua pontuação e sua prontidão, nunca suas respostas. Você pode mudar isso a qualquer momento.",
        "action": "Gerenciar compartilhamento"
      },
      "countAria_one": "{{count}} coisa precisa de você",
      "countAria_other": "{{count}} coisas precisam de você",
      "request": {
        "titleTests": "A {{company}} pede para ver mais resultados dos seus testes",
        "body": "Veja o que eles passariam a ver e decida. Nada é compartilhado até lá.",
        "action": "Revisar"
      },
      "inout": {
        "title": "Você esteve aqui?",
        "body": "O InOut pergunta sobre {{from}} – {{to}}. Sem resposta, esses dias ficam incertos.",
        "action": "Responder"
      },
      "inoutLimit": {
        "title": "Um limite de residência está perto",
        "body": "Com as viagens à frente, um limite seria atingido em {{date}}. Veja o que você pode fazer antes de sair.",
        "reachedTitle": "Um limite de residência foi ultrapassado",
        "reachedBody": "A regra que conta primeiro passou do limite. Veja o que significa e quem pode ajudar.",
        "action": "Abrir o InOut"
      },
      "inoutRenewal": {
        "title": "Sua janela de renovação está aberta",
        "body": "Você pode pedir a renovação do seu título de residência até {{date}}.",
        "action": "Abrir o InOut"
      }
    },
    "handoff": {
      "testit": {
        "title": "Faça seus testes",
        "description": "O TestIt funciona na Citizen Web, com a câmera e o microfone que alguns testes exigem."
      },
      "sharing": {
        "title": "Escolha o que as empresas veem",
        "description": "Quem vê seus dados, e o que vê, é gerenciado na Citizen Web, em Minhas jornadas."
      }
    },
    "welcome": {
      "badge": "Boas-vindas à Tonnie",
      "badgeInvited": "Convidado pela {{company}}",
      "title": "{{name}}, sua mudança para o exterior começa aqui.",
      "titleNoName": "Sua mudança para o exterior começa aqui.",
      "titleInvited": "Boas-vindas, {{name}}. A {{company}} está esperando você.",
      "titleInvitedNoName": "Boas-vindas. A {{company}} está esperando você.",
      "body": "Crie sua jornada, descubra o quanto você está preparado com um CheckUp tão completo quanto um check-up médico e planeje cada documento e cada prazo — até se tornar um Citizen.",
      "bodyInvited": "Aceite o convite e sua jornada começa: primeiro o que a {{company}} pediu, depois um plano para cada documento e prazo da sua mudança.",
      "ctaBuild": "Criar sua jornada",
      "ctaReview": "Ver convite",
      "ctaBasics": "Adicionar meus dados · 1 min",
      "ctaHow": "Como funciona",
      "routeAria": "Quatro capítulos: sua jornada, o CheckUp, planejar e mudar, tornar-se Citizen",
      "route": {
        "build": {
          "title": "Crie sua jornada",
          "sub": "Para onde você vai"
        },
        "accept": {
          "title": "Aceite o convite",
          "sub": "A jornada é criada"
        },
        "checkup": {
          "title": "CheckUp",
          "sub": "O quanto você está pronto"
        },
        "plan": {
          "title": "Planejar e mudar",
          "sub": "Documentos, prazos"
        },
        "citizen": {
          "title": "Tornar-se Citizen",
          "sub": "Cultura, cuidado, passaporte"
        }
      }
    },
    "quickStart": {
      "eyebrow": "Início rápido",
      "title": "Seus dados básicos em cerca de um minuto",
      "body": "Deixe um documento digitar por você — você confere tudo antes de salvar.",
      "progress": "Essenciais para o seu CheckUp: {{done}} de {{total}}",
      "type": {
        "title": "Digitar você mesmo",
        "body": "Só o que ainda falta — cerca de dois minutos.",
        "cta": "Adicionar manualmente"
      }
    },
    "path": {
      "eyebrow": "Primeiros passos",
      "title": "Seus primeiros cinco passos",
      "progress": "{{done}} de {{total}} concluídos",
      "progressAria": "{{done}} de {{total}} passos concluídos",
      "parts": "{{done}} de {{total}}",
      "note": "O CheckUp é gratuito para todos. Os passos 3 e 4 são mais rápidos com seu passaporte ou CV.",
      "status": {
        "done": "Concluído",
        "in_progress": "Em andamento",
        "available": "Disponível agora",
        "locked": "Bloqueado"
      },
      "optional": "Opcional · pontuação melhor",
      "missing": "Ainda falta: {{items}}",
      "steps": {
        "journey": {
          "title": "Crie sua jornada",
          "titleInvited": "Aceite o convite da {{company}}",
          "text": "Conte para onde você vai e montamos o plano em torno disso.",
          "textInvited": "Ao aceitar, sua jornada é criada, com a {{company}}.",
          "textDone": "Sua jornada está pronta.",
          "meta": "Cerca de 3 minutos",
          "metaInvited": "1 minuto",
          "cta": "Criar jornada",
          "ctaInvited": "Ver convite"
        },
        "essential": {
          "title": "Adicione os dados essenciais",
          "text": "O que o CheckUp precisa para começar: nome, data de nascimento, cidadania, onde você mora e telefone.",
          "textDone": "Tudo o que o CheckUp precisa para começar.",
          "meta": "2 minutos · ou uma foto do passaporte",
          "cta": "Adicionar em um minuto"
        },
        "assessment": {
          "title": "Faça a avaliação CheckUp",
          "text": "Cinco partes curtas: vídeos, seu pitch, idiomas, motivação e uma conversa.",
          "textLocked": "Abre quando sua jornada existir.",
          "textDone": "As cinco partes estão concluídas.",
          "next": "Próximo: {{part}}.",
          "meta": "Cerca de 20 minutos · pause quando quiser",
          "cta": "Começar",
          "ctaContinue": "Continuar",
          "parts": {
            "videos_watched": "os vídeos de introdução",
            "pitch_video": "seu vídeo de pitch",
            "language_tests": "seus testes de idiomas",
            "motivational_answers": "suas respostas sobre motivação",
            "assistant_chat": "a conversa com a Tonnie"
          }
        },
        "moreData": {
          "title": "Adicione mais dados",
          "text": "Habilidades, idiomas, formação e experiência deixam sua pontuação mais precisa.",
          "textDone": "Tudo o que a pontuação lê está preenchido.",
          "meta": "1 minuto com um PDF do LinkedIn ou currículo",
          "cta": "Importar LinkedIn ou currículo"
        },
        "score": {
          "title": "Receba sua pontuação iQulture",
          "titleShared": "Envie sua pontuação para a {{company}}",
          "text": "Sua prontidão, pilar por pilar — e o que trabalhar em seguida.",
          "textShared": "Calculada com um clique, e a {{company}} a vê.",
          "meta": "Um clique, depois dos passos 2 e 3",
          "cta": "Calcular minha pontuação",
          "ctaCalculating": "Ver progresso",
          "ctaDone": "Ver resultados"
        }
      }
    },
    "chapters": {
      "eyebrow": "Como funciona",
      "title": "Quatro capítulos até se tornar Citizen",
      "free": "Gratuito para todos",
      "planOrSponsor": "Plano ou patrocínio",
      "basics": {
        "title": "Tudo começa pelos seus dados básicos",
        "body": "Seu CheckUp precisa de alguns dados sobre você — e um documento pode digitar a maioria por você.",
        "document": "Uma foto do passaporte ou do RG preenche data de nascimento e cidadania.",
        "import": "Um PDF do LinkedIn ou currículo preenche experiência, formação, habilidades e idiomas.",
        "check": "Nada é salvo sem você conferir. Só digita onde mora e o telefone.",
        "cta": "Adicionar meus dados"
      },
      "checkup": {
        "title": "Um diagnóstico, não um questionário",
        "body": "Como um check-up médico para sua mudança: sua pontuação iQulture, pilar por pilar — o que está forte e o que trabalhar."
      },
      "teleportal": {
        "title": "Sua mudança, planejada dia a dia",
        "body": "Cada etapa do visto, documento e prazo da sua rota, com os documentos guardados no seu Vault."
      },
      "qultureup": {
        "title": "Conheça o país antes de chegar",
        "body": "Missões e mundos sobre a cultura, o trabalho e o dia a dia do seu destino. Ganhe milhas pelo caminho."
      },
      "care": {
        "label": "Care e Passport",
        "title": "Adapte-se, e mostre isso",
        "body": "Check-ins que cuidam de você depois da chegada, e um Passport que reúne cada carimbo da sua jornada."
      }
    },
    "unlock": {
      "badge": "Desbloqueie todos os capítulos",
      "title": "O CheckUp é gratuito. O resto da jornada é liberado de duas formas.",
      "body": "TelePortal, QultureUp, Care e Passport são liberados com um plano seu, ou quando uma empresa patrocina sua jornada.",
      "plan": {
        "title": "Escolha um plano",
        "body": "Todos os capítulos da sua jornada são liberados assim que você escolhe.",
        "cta": "Ver planos"
      },
      "sponsor": {
        "title": "Seja patrocinado por uma empresa",
        "body": "Empresas que contratam no exterior podem pagar toda a sua jornada. Quando uma fizer isso, a oferta aparece aqui."
      }
    },
    "error": {
      "title": "Não foi possível carregar o início",
      "body": "Verifique sua conexão e tente de novo."
    },
    "ready": {
      "chipInvited": "Convidado pela {{company}}",
      "chipSponsored": "Patrocinado pela {{company}}",
      "chipRoute": "Sua jornada · {{origin}} → {{destination}}",
      "title": "Olá, {{name}} — sua mudança para {{country}} começa aqui.",
      "titleNoName": "Sua mudança para {{country}} começa aqui.",
      "titleNoCountry": "Olá, {{name}} — sua mudança começa aqui.",
      "titleBare": "Sua mudança começa aqui.",
      "body": "Cinco passos até sua pontuação iQulture — sua prontidão, pilar por pilar, e o que trabalhar em seguida. Cada capítulo da sua mudança é ajustado por ela.",
      "bodyWaiting": "Cinco passos até sua pontuação iQulture. A {{company}} está esperando por ela — e cada capítulo da sua jornada é ajustado por ela.",
      "bodyYours": "Cinco passos até sua pontuação iQulture — ela é sua. Você decide se a {{company}} vê.",
      "stepsAria": "Cinco passos até sua pontuação iQulture",
      "ofTotal": "de {{total}} concluídos",
      "now": "Agora",
      "privacyShared": "A {{company}} vê sua pontuação e sua prontidão — nunca suas respostas.",
      "privacyOwn": "Suas respostas são suas. Ninguém vê sua pontuação a menos que você a compartilhe.",
      "next": {
        "eyebrow": "Seu próximo passo",
        "whatIs": "O que é o CheckUp?",
        "parts": {
          "videos_watched": "Vídeos",
          "pitch_video": "Seu pitch",
          "language_tests": "Idiomas",
          "motivational_answers": "Motivação",
          "assistant_chat": "Uma conversa curta"
        },
        "assessment": {
          "title": "Faça a avaliação CheckUp",
          "body": "Cinco partes curtas — cerca de 15 minutos. Você pode parar e continuar de onde parou.",
          "cta": "Começar CheckUp"
        },
        "assessmentContinue": {
          "title": "Termine a avaliação CheckUp",
          "body": "{{done}} de {{total}} partes feitas. A seguir: {{part}}.",
          "cta": "Continuar CheckUp"
        },
        "essential": {
          "title_one": "Adicione {{count}} dado para ter sua pontuação",
          "title_other": "Adicione {{count}} dados para ter sua pontuação",
          "body": "{{items}} — menos de um minuto. Suas respostas estão salvas; nada se perde.",
          "cta": "Adicionar os dados"
        },
        "moreData": {
          "title": "Refine sua pontuação",
          "body": "Habilidades, idiomas e experiência — opcional, e cada um conta.",
          "cta": "Importar LinkedIn ou CV"
        },
        "score": {
          "title": "Obtenha sua pontuação iQulture",
          "titleShared": "Calcule sua pontuação e envie para a {{company}}",
          "body": "Um clique. Sua prontidão, pilar por pilar — e o que trabalhar em seguida. Ela continua sua, a menos que você compartilhe.",
          "bodyShared": "Um clique. A {{company}} vê sua pontuação e sua prontidão — nunca suas respostas.",
          "cta": "Obter minha pontuação",
          "ctaShared": "Calcular minha pontuação"
        },
        "retry": {
          "title": "Tente o cálculo de novo",
          "body": "Algo deu errado do nosso lado. Suas respostas estão salvas — não há nada para refazer.",
          "cta": "Calcular de novo",
          "bodyAiUnavailable": "A IA da Tonnie ficou temporariamente indisponível — não foi nada que você fez. Suas respostas estão salvas — não há nada a refazer."
        },
        "calculating": {
          "title": "Sua pontuação está sendo calculada",
          "body": "Estamos avaliando suas respostas, seu pitch e seus idiomas. Você pode sair — ela vai estar aqui quando você voltar.",
          "status": "Calculando…",
          "cta": "Ver CheckUp"
        },
        "failed": {
          "title": "Não foi possível calcular sua pontuação",
          "body": "Algo deu errado do nosso lado. Abra seu CheckUp para continuar de onde parou.",
          "cta": "Abrir CheckUp",
          "bodyAiUnavailable": "A IA da Tonnie ficou temporariamente indisponível — não foi nada que você fez. Abra seu CheckUp para calcular de novo."
        }
      },
      "chapters": {
        "title": "O que se abre depois da sua pontuação",
        "body": "Sua pontuação iQulture ajusta cada capítulo da mudança para você.",
        "bodyPlan": "Tudo se abre com um plano, ou quando uma empresa patrocina sua jornada.",
        "seePlans": "Ver planos",
        "bodySponsored": "Patrocinado pela {{company}} — todos os capítulos estão abertos.",
        "teleportal": "Cada tarefa da mudança — legal, viagem, instalação — em ordem.",
        "qultureup": "Conheça a cultura antes de chegar, um mundo de cada vez.",
        "care": "Apoio depois de chegar — check-ins de bem-estar e marcos.",
        "passport": "Cada marco da sua jornada, carimbado.",
        "open": "Aberto",
        "basic": "Básico · aberto agora",
        "locked": "Abre com um plano ou um patrocínio",
        "passportStatus_one": "{{count}} carimbo · {{miles}} milhas",
        "passportStatus_other": "{{count}} carimbos · {{miles}} milhas",
        "passportStamps_one": "{{count}} carimbo",
        "passportStamps_other": "{{count}} carimbos",
        "explore": "Explorar",
        "view": "Ver"
      },
      "latest": {
        "eyebrow": "Mais recente",
        "empty": "Seus primeiros carimbos e milhas vão aparecer aqui."
      },
      "ask": {
        "title": "Dúvidas sobre o CheckUp?",
        "cta": "Perguntar à Tonnie"
      }
    },
    "phone": {
      "surface": {
        "phone": "No seu celular",
        "computer": "Em um computador",
        "either": "Celular ou computador"
      },
      "emailLink": "Me envie o link por e-mail",
      "shareLink": "Compartilhar o link",
      "emailSent": "Enviamos o link para o seu e-mail — abra no computador.",
      "emailHeld": "No momento não conseguimos enviar e-mails para você. Use “Compartilhar o link” para enviá-lo a si mesmo.",
      "emailFailed": "O e-mail não foi enviado. Tente de novo ou compartilhe o link.",
      "next": {
        "assessment": {
          "title": "Faça a avaliação do CheckUp em um computador",
          "body": "Cinco partes curtas — cerca de 15 minutos, com vídeo e o seu pitch, por isso foi feita para uma tela maior. Você pode parar e continuar de onde parou."
        },
        "assessmentContinue": {
          "title": "Termine a avaliação do CheckUp em um computador"
        },
        "calculating": {
          "body": "Estamos avaliando suas respostas, seu pitch e seus idiomas. Enviaremos uma notificação quando ficar pronto."
        },
        "score": {
          "body": "Um toque. Sua prontidão, pilar por pilar — e no que trabalhar em seguida. Ela é sua, a menos que você a compartilhe.",
          "bodyShared": "Um toque. A {{company}} vê sua pontuação e prontidão — nunca suas respostas."
        }
      },
      "header": {
        "route": "{{origin}} → {{destination}}",
        "switchJourney": "Trocar de jornada. Atual: {{route}}"
      },
      "welcome": {
        "meta": "3 perguntas · no seu celular"
      },
      "quickStart": {
        "eyebrow": "Já que você está aqui",
        "title": "Adicione seus dados básicos · 1 min",
        "body": "Uma foto do seu passaporte preenche sua data de nascimento e cidadania."
      },
      "meanwhile": {
        "title": "Enquanto isso, no seu celular",
        "essential": {
          "title_one": "Adicione {{count}} dado de que sua pontuação precisa",
          "title_other": "Adicione {{count}} dados de que sua pontuação precisa",
          "body": "{{items}} · uma foto do passaporte preenche a maioria"
        }
      },
      "stepsTitle": "Seus cinco passos",
      "steps": {
        "assessment": {
          "text": "Cinco partes curtas, cerca de 20 minutos — em um computador. Enviamos o link por e-mail."
        },
        "score": {
          "text": "Um toque, quando os passos 2 e 3 estiverem feitos.",
          "textShared": "Um toque, quando os passos 2 e 3 estiverem feitos — e a {{company}} a vê."
        }
      },
      "stepper": {
        "notStarted": "Não iniciado"
      }
    },
    "how": {
      "intro": {
        "eyebrow": "Seu companheiro",
        "title": "Tonnie, todos os dias da sua mudança",
        "body": "Dos primeiros planos até se instalar, a Tonnie caminha com você — no celular e na web."
      },
      "chapters": {
        "checkup": {
          "title": "Saiba onde você está",
          "body": "Sua pontuação de prontidão para a mudança e no que trabalhar em seguida. A avaliação é feita em um computador; sua pontuação vai com você para todo lado."
        },
        "teleportal": {
          "title": "A sua mudança, passo a passo",
          "body": "Acompanhe as suas tarefas e marcos da mudança e vá marcando conforme avança."
        },
        "qultureup": {
          "title": "Sinta-se em casa mais rápido",
          "body": "Missões rápidas para aprender a cultura, o idioma e o dia a dia do seu destino."
        },
        "care": {
          "title": "Apoio quando você precisa",
          "body": "Fale com a sua equipe de mudança — mensagens, check-ins e reuniões, tudo em um só lugar."
        },
        "passport": {
          "title": "Seu progresso, carimbado",
          "body": "Ganhe carimbos e veja o quanto você já avançou na sua jornada de mudança."
        }
      },
      "title": "Como a Tonnie funciona",
      "start": {
        "title": "Tudo começa pela sua jornada",
        "body": "Três perguntas — para onde você vai, sua situação, sua família — e sua jornada está pronta, no celular ou na web. É ela que move tudo o que vem depois."
      }
    }
  },
  "profileImport": {
    "phone": {
      "source": {
        "subtitle": "Lemos sua experiência, formação, habilidades e idiomas — você confere antes de qualquer coisa ser salva.",
        "linkedin": "Seu perfil do LinkedIn, salvo como PDF.",
        "cv": "Seu currículo — PDF, Word ou texto, até 10 MB."
      },
      "guide": {
        "title": "Pegue seu PDF do LinkedIn",
        "choose": "Escolher o PDF",
        "steps": {
          "computer": "Em um computador, abra seu perfil em linkedin.com",
          "save": "Escolha Mais e depois Salvar como PDF",
          "send": "Envie o PDF para este celular — por e-mail, Arquivos ou iCloud",
          "choose": "Volte aqui e escolha-o"
        }
      },
      "review": {
        "privacy": "Nada é salvo até você tocar em Salvar. Seu nome continua como está.",
        "save": "Salvar no meu perfil",
        "showAll": "Ver todos ({{count}})",
        "showLess": "Ver menos",
        "present": "Atual",
        "languageNoLevel_one": "{{names}}: o documento não informa o nível, então não é salvo — adicione no seu perfil.",
        "languageNoLevel_other": "{{names}}: o documento não informa o nível, então não são salvos — adicione no seu perfil."
      },
      "saved": {
        "title": "Seu perfil foi atualizado",
        "body": "Sua experiência, habilidades e idiomas agora deixam sua pontuação mais precisa."
      },
      "saveFailed": "Não conseguimos salvar. Verifique sua conexão e tente de novo."
    }
  },
  "profileQuality": {
    "calculate": {
      "anyway": "Calcular com o que tenho",
      "footnote": "Você pode adicionar detalhes e recalcular quando quiser."
    },
    "backTo": "Voltar para {{hero}}",
    "returnHint": "Cada detalhe que você adicionar aqui deixa o {{hero}} mais preciso."
  },
  "checkupCard": {
    "status": {
      "answersDone": "Respostas completas"
    },
    "title": {
      "welcome": "Sua pontuação iQulture, em duas partes",
      "ready": "Suas respostas estão completas"
    },
    "subtitle": {
      "welcome": "Sua pontuação lê suas respostas e seu perfil juntos — quanto mais completos estiverem, mais precisa ela será.",
      "ready": "Sua pontuação lê as respostas junto com seu perfil. Adicione o que falta para uma pontuação mais precisa, ou calcule agora.",
      "readyComplete": "Seu perfil também está completo — sua pontuação lê todos os detalhes."
    },
    "ring": {
      "caption": "sua pontuação",
      "label": "Sua pontuação iQulture aparece aqui quando for calculada"
    },
    "next": {},
    "part": {
      "answers": "Suas respostas",
      "done": "Concluído",
      "profileRead": "A pontuação lê {{complete}} de {{total}} detalhes",
      "profileOptional": "Opcional — deixa a pontuação mais precisa, e você pode começar agora.",
      "profileComplete": "Completo — a pontuação lê todos os detalhes."
    },
    "calculate": {
      "improveFirst": "Melhorar meu perfil primeiro"
    },
    "basics": {
      "title": "A um passo da sua pontuação",
      "subtitle": "Suas respostas estão salvas. Adicione os dados básicos para liberar o cálculo — e complete o perfil para a pontuação mais precisa.",
      "lockedHint": "Libera quando os dados básicos estiverem preenchidos.",
      "lockedLabel": "Calcular minha pontuação — bloqueado até preencher os dados básicos"
    },
    "path": {
      "label": "Seu caminho até a pontuação",
      "answers": "Suas respostas",
      "answersState": "Concluído",
      "basics": "Dados básicos",
      "basicsState": "Obrigatório · {{complete}} de {{total}}",
      "profile": "Perfil completo",
      "profileState": "Recomendado · {{percent}}",
      "calculate": "Sua pontuação",
      "calculateState": "Bloqueado"
    },
    "required": {
      "eyebrow": "Obrigatório para calcular",
      "title_one": "Adicione {{count}} detalhe para liberar a pontuação",
      "title_other": "Adicione {{count}} detalhes para liberar a pontuação",
      "addField": "Adicionar {{field}}",
      "fastest": "Mais rápido: escaneie seu passaporte — preenche {{items}} de uma vez."
    },
    "recommended": {
      "eyebrow": "Recomendado",
      "title": "Para a pontuação mais precisa",
      "body": "Sua pontuação lê {{complete}} de {{total}} detalhes do perfil. Cada um que você adiciona deixa os pilares e as recomendações mais precisos."
    }
  },
  "heroStart": {
    "status": {
      "notStarted": "Não iniciado",
      "inProgress": "Em andamento"
    },
    "next": {
      "eyebrow": "Seu próximo passo"
    },
    "part": {
      "profile": "Seu perfil",
      "addBasics": "Adicionar dados básicos",
      "improve": "Melhorar meu perfil"
    },
    "profileRead": "{{complete}} de {{total}} detalhes do perfil preenchidos",
    "profileComplete": "Completo — todos os detalhes estão preenchidos.",
    "teleportal": {
      "title": "Seu plano de mudança, em duas partes",
      "subtitle": "O TelePortal monta seu plano a partir da configuração e do seu perfil — quanto mais completos estiverem, mais precisas são as tarefas e os prazos.",
      "ringCaption": "seu plano",
      "steps": "Sua configuração",
      "why": "Sua nacionalidade, residência e família definem seu caminho de visto.",
      "optional": "Opcional — deixa seu plano mais preciso, e você pode começar agora."
    },
    "qultureup": {
      "title": "Sua trilha de aprendizado, em duas partes",
      "subtitle": "O QultureUp ajusta sua trilha à sua avaliação e ao seu perfil — quanto mais completos estiverem, mais ela combina com você.",
      "ringCaption": "sua trilha",
      "steps": "Sua avaliação",
      "why": "De onde você é e onde você mora definem seu ponto de partida.",
      "optional": "Opcional — aproxima a trilha de você, e você pode começar agora."
    },
    "care": {
      "title": "Care, ao lado da sua jornada",
      "subtitle": "O Care começa com uma breve avaliação de como você está se adaptando. Seu perfil é a base que toda a jornada lê.",
      "ringCaption": "seu cuidado",
      "steps": "Sua avaliação",
      "why": "Sua pontuação, seu plano de mudança e sua trilha de aprendizado leem seu perfil.",
      "optional": "Opcional — mantém toda a jornada precisa, e você pode começar agora."
    },
    "inout": {
      "title": "InOut, para sua autorização de residência",
      "subtitle": "Ele conta os dias que você passa fora em relação aos limites da sua autorização e avisa você a tempo. Quatro passos curtos para começar.",
      "ringCaption": "dias restantes",
      "steps": "A configuração",
      "why": "O InOut conta a partir da sua autorização e das suas viagens — seu perfil não altera os números.",
      "optional": "Opcional para o InOut — mantém o resto da sua jornada precisa."
    }
  },
  "inout": {
    "start": {
      "cta": "Começar o InOut",
      "timeEstimate": "Cerca de 3 minutos",
      "titleStep": "Seu título",
      "titleStepDesc": "O título de residência que você tem.",
      "tripsStep": "Suas viagens",
      "tripsStepDesc": "Cada vez que você esteve fora desde que foi emitido.",
      "countryStep": "Seu país",
      "countryStepDesc": "O país do seu título de residência.",
      "datesStep": "As datas",
      "datesStepDesc": "Quando foi emitido e até quando é válido.",
      "recover": "Recuperar do histórico"
    },
    "page": {
      "title": "InOut",
      "subtitle": "Seus dias fora do país de residência, contados em relação à sua autorização.",
      "errorTitle": "Não conseguimos ler seus contadores",
      "errorBody": "Seu registro está seguro. Tente novamente em instantes.",
      "short": "Dias fora, contados"
    },
    "tabs": {
      "overview": "Resumo",
      "trips": "Viagens",
      "documents": "Documentos",
      "notices": "Avisos",
      "agency": "Assessoria",
      "limits": "Limites",
      "history": "Histórico"
    },
    "banner": {
      "away": "Fora",
      "inHost": "Em {{country}}",
      "noTitle": "Nenhuma autorização em vigor hoje",
      "humanCheck": "Sua autorização segue regras próprias, ainda a ser lidas pela assessoria — uma pessoa verifica, por isso o InOut não mostra números.",
      "noBinding": "Nenhum limite se aplica hoje à sua autorização.",
      "bindingUnresolved": "{{rule}} é o primeiro limite, mas a leitura dele ainda está sendo definida — sem número até lá.",
      "daysStillNeeded": "dias de presença faltando",
      "noNumber": "ainda sem número",
      "hourglassLabel": "Ampulheta: restam {{left}} de {{limit}} dias",
      "daysLeft": "dias restantes",
      "toConfirmChip_one": "{{days}} dia a confirmar",
      "toConfirmChip_other": "{{days}} dias a confirmar",
      "otherSchengen_one": "Em outros países Schengen: até {{days}} dia",
      "otherSchengen_other": "Em outros países Schengen: até {{days}} dias",
      "noTitleOn": "Nenhuma autorização em vigor em {{date}}",
      "noBindingOn": "Nenhum limite se aplicava à sua autorização em {{date}}."
    },
    "answer": {
      "presenceNeeded_one": "Você precisa de mais {{days}} dia em {{country}}",
      "presenceNeeded_other": "Você precisa de mais {{days}} dias em {{country}}",
      "beyond": "{{rule}}: acima do limite",
      "unresolved": "Ainda sem número",
      "humanCheck": "Uma pessoa verifica sua autorização",
      "headline": "{{rule}}: {{counted}}",
      "headlineAndFirst": "{{headline}}. {{first}}",
      "oneTrip_one": "Você pode ficar fora de {{country}} por até {{days}} dia em uma única viagem",
      "oneTrip_other": "Você pode ficar fora de {{country}} por até {{days}} dias em uma única viagem",
      "thisTrip_one": "Você pode ficar fora de {{country}} mais {{days}} dia nesta viagem",
      "thisTrip_other": "Você pode ficar fora de {{country}} mais {{days}} dias nesta viagem",
      "oneTripOutsideEu_one": "Você pode ficar fora da UE por até {{days}} dia em uma única viagem",
      "oneTripOutsideEu_other": "Você pode ficar fora da UE por até {{days}} dias em uma única viagem",
      "thisTripOutsideEu_one": "Você pode ficar fora da UE mais {{days}} dia nesta viagem",
      "thisTripOutsideEu_other": "Você pode ficar fora da UE mais {{days}} dias nesta viagem",
      "unit": {
        "oneTrip": "dias em uma única viagem",
        "thisTrip": "dias a mais nesta viagem"
      },
      "short": {
        "oneTrip_one": "Você pode ficar fora até {{days}} dia",
        "oneTrip_other": "Você pode ficar fora até {{days}} dias",
        "thisTrip_one": "Você pode ficar fora mais {{days}} dia",
        "thisTrip_other": "Você pode ficar fora mais {{days}} dias"
      },
      "detail": {
        "oneTrip": "Em uma única viagem fora de {{country}}, a partir de hoje, sem passar nenhum limite da sua autorização.",
        "thisTrip": "Nesta viagem, sem passar nenhum limite da sua autorização.",
        "oneTripOutsideEu": "Em uma única viagem fora da UE, a partir de hoje, sem passar nenhum limite da sua autorização.",
        "thisTripOutsideEu": "Nesta viagem fora da UE, sem passar nenhum limite da sua autorização.",
        "oneTripFrom": "Em uma única viagem fora de {{country}}, a partir de {{date}}, sem passar nenhum limite da sua autorização.",
        "oneTripOutsideEuFrom": "Em uma única viagem fora da UE, a partir de {{date}}, sem passar nenhum limite da sua autorização.",
        "thisTripOn": "Na viagem em andamento em {{date}}, sem passar nenhum limite da sua autorização.",
        "thisTripOutsideEuOn": "Na viagem fora da UE em andamento em {{date}}, sem passar nenhum limite da sua autorização."
      }
    },
    "binding": {
      "alreadyReached": "{{rule}}: os dias que você registrou já ultrapassam o limite.",
      "mayBeReached": "{{rule}}: o limite pode ser ultrapassado se os dias a confirmar contarem.",
      "earliestExhaustion": "{{rule}} é o primeiro a chegar ao limite — em {{date}}, neste ritmo.",
      "leastRemaining": "{{rule}} é o mais perto do limite."
    },
    "switch": {
      "inHost": "Em {{country}}",
      "awaySince": "Fora desde {{date}}",
      "leave": "Vou sair hoje",
      "back": "Voltei hoje para {{country}}",
      "caption": "Um toque é um registro — você pode corrigi-lo logo em seguida.",
      "confirm": {
        "leftTitle": "Você está fora desde {{date}}",
        "leftBody": "Registrado. Boa viagem.",
        "leftTo": "Registrado — para {{country}}, como você planejou. Boa viagem.",
        "undo": "Desfazer",
        "correct": "Corrigir",
        "done": "Concluído",
        "undone": "Desfeito — nada foi registrado.",
        "backTitle": "Bem-vindo de volta",
        "backBody_one": "Você esteve fora de {{from}} a {{to}} — {{days}} dia.",
        "backBody_other": "Você esteve fora de {{from}} a {{to}} — {{days}} dias.",
        "adjust": "Ajustar as datas",
        "yes": "Sim, está certo",
        "correctTitle": "Saiu em outro dia ou quer dizer para onde foi?",
        "correctHint": "A data e o destino se ajustam aqui.",
        "undoTitle": "Tocou por engano?",
        "undoHint": "Nada fica registrado.",
        "adjustTitle": "As datas foram outras?",
        "adjustHint": "Ajuste o dia em que saiu e o dia em que voltou.",
        "continuedTitle": "Saiu de novo hoje",
        "continuedBody": "Sua viagem de {{from}} continua — o dia de hoje já contava e conta uma só vez.",
        "undoContinuedHint": "A viagem volta a terminar hoje, como estava."
      }
    },
    "clocks": {
      "title": "Seus limites",
      "humanCheck": "Sua autorização segue regras próprias, ainda a ser lidas pela assessoria. Uma pessoa verifica; enquanto isso, o InOut não mostra números.",
      "empty": "Nenhuma regra se aplica hoje à sua autorização.",
      "disclaimer": "O InOut faz a aritmética do seu registro — nunca é um parecer jurídico. Para uma decisão, fale com a assessoria.",
      "emptyOn": "Nenhuma regra se aplicava à sua autorização em {{date}}."
    },
    "clock": {
      "name": {
        "awayFromHost": "Dias fora de {{country}}",
        "outsideEu": "Dias fora da UE",
        "countedInHost": "Dias contados em {{country}}",
        "otherSchengen": "Dias em outros países Schengen",
        "eachTripFromHost": "Cada saída de {{country}}",
        "eachTripOutsideEu": "Cada saída da UE",
        "eachStayInHost": "Cada estadia em {{country}}",
        "eachStayOtherSchengen": "Cada estadia em outros países Schengen",
        "neededOutsideHost": "Dias necessários fora de {{country}}",
        "neededOutsideEu": "Dias necessários fora da UE",
        "neededInHost": "Dias necessários em {{country}}",
        "neededOtherSchengen": "Dias necessários em outros países Schengen",
        "unbrokenOutsideHost": "Tempo seguido necessário fora de {{country}}",
        "unbrokenOutsideEu": "Tempo seguido necessário fora da UE",
        "unbrokenInHost": "Tempo seguido necessário em {{country}}",
        "unbrokenOtherSchengen": "Tempo seguido necessário em outros países Schengen"
      },
      "window": "contados de {{from}} a {{to}}",
      "windowOpen": "contados desde {{from}}",
      "status": {
        "within": "Dentro do limite",
        "depends": "Depende de dias a confirmar",
        "beyond": "Acima do limite",
        "unresolved": "Em definição",
        "notApplicable": "Não se aplica"
      },
      "plannedBy": "Leitura mais estrita",
      "counted": "{{value}} de {{limit}} dias",
      "longestTrip": "A mais longa até agora: {{value}} de {{limit}} dias",
      "longestTripOn": "A mais longa até {{date}}: {{value}} de {{limit}} dias",
      "tripUpTo_one": "a partir de hoje, até {{days}} dia seguido fora",
      "tripUpTo_other": "a partir de hoje, até {{days}} dias seguidos fora",
      "left_one": "resta {{days}} dia",
      "left_other": "restam {{days}} dias",
      "stillNeeded_one": "falta {{days}} dia de presença",
      "stillNeeded_other": "faltam {{days}} dias de presença",
      "margin_one": "±{{days}} dia ainda a confirmar — depende de você.",
      "margin_other": "±{{days}} dias ainda a confirmar — depende de você.",
      "settleMargin": "Confirmar",
      "exhaustsOn": "Neste ritmo, o limite seria ultrapassado em {{date}}.",
      "riskZone": "Duas normas divergem entre {{from}} e {{to}} dias — uma zona de risco, não uma margem.",
      "inRiskZone": "Você está nessa zona.",
      "noNumber": "Ainda sem número para esta regra.",
      "owner": {
        "agency": "A assessoria está definindo a leitura — não há nada a fazer da sua parte.",
        "tonnie": "A Tonnie está definindo a leitura — não há nada a fazer da sua parte.",
        "user": "Só você pode resolver isso — o CoPilot explica o que falta."
      },
      "consequence": {
        "mayCancel": "Acima dele, a lei permite o cancelamento da autorização.",
        "losesStatus": "Acima dele, a lei diz que o status se perde.",
        "blocksAcquisition": "Acima dele, o tempo deixa de contar para um direito de longa duração.",
        "irregularStay": "Acima dele, a estadia nesses países fica irregular."
      },
      "info": "Sobre “{{rule}}”",
      "lawTitle": "O que diz a lei",
      "exceptionsTitle": "Exceções que a lei prevê",
      "exceptionTiming": "{{timing}} ({{source}})",
      "short": {
        "awayFromHost": "Dias fora",
        "outsideEu": "Fora da UE",
        "countedInHost": "Dias contados",
        "otherSchengen": "Schengen",
        "eachTripFromHost": "Cada saída",
        "eachTripOutsideEu": "Cada saída da UE",
        "eachStayInHost": "Cada estadia",
        "eachStayOtherSchengen": "Estadias Schengen",
        "neededOutsideHost": "Dias no exterior",
        "neededOutsideEu": "Fora da UE",
        "neededInHost": "Dias aqui",
        "neededOtherSchengen": "Dias Schengen",
        "unbrokenOutsideHost": "Tempo no exterior",
        "unbrokenOutsideEu": "Tempo fora da UE",
        "unbrokenInHost": "Tempo aqui",
        "unbrokenOtherSchengen": "Tempo Schengen"
      },
      "tripUpToFrom_one": "a partir de {{date}}, até {{days}} dia seguido fora",
      "tripUpToFrom_other": "a partir de {{date}}, até {{days}} dias seguidos fora",
      "marginOn_one": "±{{days}} dia não confirmado até {{date}}.",
      "marginOn_other": "±{{days}} dias não confirmados até {{date}}.",
      "exhaustsOnFrom": "No ritmo que tinha em {{asOf}}, o limite seria ultrapassado em {{date}}.",
      "inRiskZoneOn": "Em {{date}} você estava nessa zona."
    },
    "exceptions": {
      "timing": {
        "beforeDeparture": "a pedir antes de sair",
        "any": "pode ser pedida a qualquer momento"
      }
    },
    "precision": {
      "margin_one": "{{days}} dia que ninguém confirmou pode mudar um limite.",
      "margin_other": "{{days}} dias que ninguém confirmou podem mudar um limite.",
      "addTrip": "Adicionar viagem",
      "answerQuestion": "Responder ao InOut",
      "title": "Dias a confirmar",
      "complete": "Seu registro está {{percent}} completo.",
      "checkTrip": "Ver as viagens",
      "reason": {
        "openQuestion": "A pergunta aberta do InOut é sobre estes dias.",
        "unanswered": "A pergunta destes dias fechou sem resposta — você ainda pode adicionar uma viagem desse período.",
        "wasAway": "Você disse que esteve fora — falta adicionar a viagem.",
        "notAskedYet": "Nenhuma pergunta foi sobre estes dias ainda — a próxima será.",
        "uncertainTrip": "Uma viagem cujas datas não são certas."
      }
    },
    "renewal": {
      "title": "Janela de renovação",
      "none": "Sua autorização não tem janela de renovação.",
      "window": "De {{opens}} a {{closes}}",
      "planTrips": "Planeje as viagens em torno dela — a renovação é pedida presencialmente."
    },
    "acquisition": {
      "title": "Rumo a um direito de longa duração",
      "subtitle": "Aquilo para que seu tempo no país está contando.",
      "status": {
        "accruing": "Contando",
        "complete": "Período completo",
        "depends": "Depende de dias a confirmar",
        "toleranceExceeded": "Ausências acima da tolerância",
        "unresolved": "Em definição",
        "notApplicable": "Não se aplica"
      },
      "completesOn": "O período ficaria completo em {{date}} se as tolerâncias se mantiverem.",
      "cumulative": "Ausências no total: {{value}} de {{tolerance}} dias tolerados",
      "consecutive": "Ausência mais longa: {{value}} de {{tolerance}} dias tolerados",
      "info": "Sobre “{{right}}”",
      "completeOn": "Completo em {{date}}",
      "progress_one": "{{done}} de {{total}} ano",
      "progress_other": "{{done}} de {{total}} anos"
    },
    "chronology": {
      "title": "Suas viagens",
      "subtitle": "Todas as vezes que você esteve fora. Os dias que ninguém confirma ficam incertos — nunca contam como dias em que você esteve aqui.",
      "add": "Adicionar viagem",
      "error": "Não conseguimos ler suas viagens.",
      "short": "Todas as suas viagens",
      "group": {
        "now": "Agora",
        "done": "Feitas",
        "planned": "Planejadas"
      },
      "emptyTitle": "Ainda sem viagens",
      "emptyBody": "Use o interruptor quando sair, ou adicione uma que você já fez."
    },
    "absence": {
      "range": "{{from}} – {{to}}",
      "stillAway": "Desde {{from}} — ainda fora",
      "days_one": "{{days}} dia",
      "days_other": "{{days}} dias",
      "noDestination": "Destino não informado",
      "bySwitch": "Registrada com “Vou sair hoje”",
      "documents_one": "{{count}} documento",
      "documents_other": "{{count}} documentos",
      "edit": "Corrigir a viagem de {{from}}",
      "remove": "Remover a viagem de {{from}}",
      "addTitle": "Adicionar uma viagem",
      "editTitle": "Corrigir uma viagem",
      "description": "O dia em que você saiu e o dia em que voltou contam como dias fora.",
      "departedOn": "Saída",
      "returnedOn": "Retorno",
      "stillAwayHint": "Ainda fora? Deixe a data de retorno em branco.",
      "destination": "Para onde foi",
      "destinationPlaceholder": "Escolha um país (opcional)",
      "destinationHint": "Algumas regras só contam certos países. Sem destino, esses dias ficam incertos.",
      "saved": "Viagem salva.",
      "removeTitle": "Remover esta viagem?",
      "removeBody": "Só para uma viagem registrada por engano: os dias deixam de contar e os documentos ficam no seu Cofre.",
      "removeConfirm": "Remover viagem",
      "removed": "Viagem removida.",
      "fromPassTitle": "Confirmar a viagem do cartão de embarque",
      "fromPassDescription": "Lemos estas datas e o destino do seu cartão. Confira e salve.",
      "removeThis": "Remover esta viagem",
      "join": "Juntar numa só viagem",
      "joined": "Viagens juntadas numa só."
    },
    "form": {
      "dateRequired": "Escolha as datas.",
      "dateInvalid": "Digite uma data válida ou escolha no calendário.",
      "returnBeforeDeparture": "O retorno é antes da saída.",
      "pickDate": "Escolha uma data"
    },
    "planner": {
      "title": "Planejar uma viagem",
      "subtitle": "Veja o que uma viagem faz com seus limites antes de reservá-la. Uma viagem planejada permite que o aviso chegue antes de você sair.",
      "departsOn": "Saída",
      "returnsOn": "Retorno",
      "destination": "Para onde você vai",
      "simulate": "Ver o efeito",
      "plan": "Planejar",
      "planned": "Viagem planejada.",
      "onReturn": "No retorno, em {{date}}",
      "duringRenewalWindow": "Esta viagem cai na janela de renovação — a renovação é pedida presencialmente.",
      "outlastsTitle": "Você voltaria depois que sua autorização expirar.",
      "ahead": "Próximas viagens",
      "empty": "Nenhuma viagem planejada.",
      "listError": "Não conseguimos ler as viagens planejadas.",
      "remove": "Remover a viagem planejada de {{from}}",
      "removed": "Viagem planejada removida.",
      "now": "Hoje",
      "removeTitle": "Remover esta viagem planejada?",
      "removeBody": "Ela sai das próximas viagens e o InOut deixa de lembrar você dela.",
      "removeConfirm": "Remover viagem planejada",
      "limitMoved": "{{name}}: {{from}} → {{to}} de {{limit}} dias"
    },
    "timeline": {
      "title": "Seu registro no tempo",
      "window": "A janela de “{{rule}}”, com suas viagens",
      "today": "Hoje",
      "trip": "Viagem",
      "planned": "Planejada",
      "renewal": "Janela de renovação",
      "loadError": "Não foi possível ler suas viagens planejadas, então a linha não é exibida.",
      "away": "Ainda fora",
      "uncertain": "Dias a confirmar",
      "emptyWindow": "Ainda não há viagens na janela de {{from}} a {{to}}.",
      "empty": "Ainda não há viagens nesta janela — cada viagem que você adicionar aparece aqui."
    },
    "documents": {
      "title": "Documentos das suas viagens",
      "subtitle": "Os documentos de cada viagem: o que prova a viagem e o contexto da ausência.",
      "provisional": "Esta organização é provisória até a assessoria confirmar a lista.",
      "provisionalBadge": "Lista provisória",
      "scope": "Não dizemos de quais documentos você precisa — isso é uma avaliação jurídica, feita pela assessoria. Nós guardamos, organizamos e entregamos.",
      "info": "Sobre estes documentos",
      "empty": "Ainda sem viagens — os documentos são anexados a uma viagem.",
      "error": "Não conseguimos ler seus documentos.",
      "none": "Sem documentos",
      "whatItIs": "O que é",
      "uploading": "Salvando…",
      "attached": "Documento anexado à viagem.",
      "detach": "Retirar {{name}} desta viagem",
      "addTitle": "Adicionar um documento",
      "add": "Adicionar",
      "addDocument": "Adicionar documento",
      "whichDocument": "Que documento é?",
      "uploadingFile": "Salvando {{name}}…",
      "open": "Abrir {{item}} — {{name}}",
      "openError": "Não foi possível abrir este documento. Tente novamente.",
      "detached": "Documento tirado da viagem.",
      "short": "Provas de cada viagem",
      "reason": {
        "label": "Motivo da ausência",
        "none": "Sem motivo informado",
        "info": "Sobre o motivo",
        "hint": "Fica no seu registro e no dossiê para a assessoria. Não altera a contagem dos dias."
      },
      "addToFamily": "Adicionar a “{{family}}” — a viagem de {{from}}",
      "undo": "Desfazer",
      "reattached": "Documento anexado de novo à viagem.",
      "emptyTitle": "Ainda sem viagens",
      "emptyBody": "Os documentos ficam junto de uma viagem: adicione a primeira.",
      "fromVaultDescription": "Para “{{family}}” — a viagem de {{from}}."
    },
    "notices": {
      "leadTimeTitle": "Me avisar antes de um limite ser ultrapassado",
      "leadTimeWhy": "Tempo para pedir autorização prévia antes de sair — a lei exige isso antes da partida.",
      "leadTimeOption_one": "{{days}} dia antes",
      "leadTimeOption_other": "{{days}} dias antes",
      "cadenceTitle": "Me perguntar se estive no país",
      "cadenceWhy": "Mantém seu registro completo. Se você não responder, nada é presumido — esses dias ficam a confirmar.",
      "cadence": {
        "P15D": "A cada 15 dias",
        "P30D": "A cada 30 dias",
        "P1M": "Uma vez por mês",
        "OFF": "Nunca"
      },
      "channelsTitle": "Por onde chegam",
      "push": "Notificações push",
      "email": "E-mail",
      "error": "Não conseguimos ler seus avisos.",
      "questionsError": "Não foi possível ler as perguntas do InOut.",
      "questionsTitle": "Perguntas do InOut",
      "questionsSubtitle": "Só perguntamos se você esteve no país — nunca onde está.",
      "question": "Você esteve em {{country}} todos os dias de {{from}} a {{to}}, exceto as viagens que registrou?",
      "answerInHost": "Sim, estive",
      "answerWasAway": "Não, estive fora",
      "wasAwayHint": "As datas perguntadas abrem uma nova viagem, pronta para salvar.",
      "questionWhy": "Sem resposta, estes dias ficam a confirmar — nunca contam como dias em que você esteve aqui.",
      "thanksInHost": "Obrigado — esses dias estão confirmados.",
      "addTheTrip": "Você nos disse que esteve fora.",
      "noHistory": "Nenhuma pergunta anterior.",
      "whyLabel": "Por que isso importa",
      "confirmation": {
        "state": {
          "open": "Aguardando sua resposta",
          "inHost": "Você confirmou que esteve aqui",
          "wasAway": "Você disse que esteve fora",
          "noAnswer": "Sem resposta — dias a confirmar"
        }
      },
      "next": {
        "none": "Não há avisos à vista — o InOut avisa quando houver."
      },
      "upcomingTitle": "Próximos avisos",
      "upcomingSubtitle": "O que o InOut vai enviar para você, e quando — pelas regras de {{country}} e pelas suas escolhas.",
      "upcoming": {
        "leadTime": "Aviso antes de um limite",
        "leadTimeDetail_one": "Com as viagens em andamento e planejadas, “{{rule}}” chegaria ao limite em {{date}} — avisamos {{days}} dia antes.",
        "leadTimeDetail_other": "Com as viagens em andamento e planejadas, “{{rule}}” chegaria ao limite em {{date}} — avisamos {{days}} dias antes.",
        "confirmation": "Pergunta de presença",
        "confirmationDetail": "Se você esteve em {{country}} de {{from}} a {{to}} — sim ou não.",
        "renewalWindow": "Abre a janela de renovação",
        "renewalWindowDetail": "Você pode pedir a renovação do seu título de {{from}} a {{to}}.",
        "inDays_one": "daqui a {{days}} dia",
        "inDays_other": "daqui a {{days}} dias"
      },
      "chip": {
        "app": "App",
        "push": "Push",
        "email": "E-mail"
      },
      "appChannel": "No app",
      "appHint": "Aqui e no celular.",
      "pushHint": "No celular, mesmo com o app fechado.",
      "emailHint": "Para o e-mail da sua conta.",
      "preferencesTitle": "Suas preferências",
      "preferencesSubtitle": "Cada escolha é salva na hora.",
      "saving": "Salvando…",
      "savedShort": "Salvo",
      "recommended": "Recomendado",
      "cadenceOffNote": "Sem perguntas, os próximos dias ficam a confirmar até você confirmá-los no Resumo.",
      "upToDate": "Você está em dia",
      "noOpenQuestionNext": "Nenhuma pergunta esperando por você. A próxima chega em {{date}}.",
      "noOpenQuestionOff": "Nenhuma pergunta esperando por você — as perguntas estão desligadas.",
      "historyTitle": "Respostas anteriores",
      "seeTrips": "Ver as viagens",
      "leadTimeUnit_one": "dia antes",
      "leadTimeUnit_other": "dias antes",
      "always": "Sempre",
      "comesBy": "Chegam por",
      "screenSubtitle": "O que o InOut perguntou a você, e o que vem a seguir"
    },
    "errors": {
      "overlap": "Isso compartilha um dia com sua viagem de {{from}} – {{to}}. Corrija uma delas.",
      "overlapOpen": "Você já está fora desde {{from}}. Feche essa viagem primeiro.",
      "notSetUp": "Configure o InOut primeiro — as viagens contam em relação à sua autorização.",
      "deactivated": "Seu InOut está desativado — reative-o para voltar a registrar viagens.",
      "caseOpen": "O InOut continua funcionando enquanto seu ticket com a assessoria estiver aberto.",
      "handoffNotFound": "Este cálculo expirou ou já foi usado — calcule de novo, leva um minuto.",
      "ruleValue": "Essa opção não é uma das do seu país.",
      "datesOutOfOrder": "As datas estão fora de ordem.",
      "notAway": "Essa viagem já está fechada.",
      "calculationRefused": "As regras do país mudaram desde o seu cálculo. Faça de novo na calculadora do InOut — ela lê as regras como estão agora.",
      "lastTitle": "Seu InOut precisa de uma autorização de residência. Para recomeçar, comece um novo InOut.",
      "confirmationClosed": "Essa pergunta já está fechada.",
      "notFound": "Não encontramos isso no seu registro.",
      "generic": "Algo deu errado. Tente novamente em instantes.",
      "agencyUnavailable": "A assessoria do seu país ainda não aceita pedidos.",
      "consentRequired": "Aprove primeiro o que você compartilha com a assessoria.",
      "slotUnavailable": "Esse horário não está mais disponível. Escolha outro.",
      "tooCloseToMove": "Já está muito perto da consulta para remarcá-la.",
      "notMovable": "Esta consulta não pode ser remarcada.",
      "requisitionExists": "Este ticket já tem sua requisição.",
      "calendarUnavailable": "Não é possível acessar a agenda da assessoria agora.",
      "calendarAvailable": "A agenda da assessoria voltou a ficar disponível — escolha um horário.",
      "fileNotLinkable": "Esse documento não está mais no seu Cofre — escolha outro.",
      "aiUnavailable": "A calculadora do InOut não consegue responder agora. Tente novamente daqui a pouco — seu registro está salvo.",
      "touches": "Começa ou termina no dia da sua viagem de {{from}} – {{to}}. Junte-as numa só — esse dia conta uma vez.",
      "touchesOpen": "Termina no dia em que começou sua viagem ainda em curso, {{from}}. Junte-as numa só — esse dia conta uma vez.",
      "notJoinable": "Estas viagens já não se tocam num só dia — corrija as datas e salve de novo.",
      "caseOpenChange": "Seu InOut fica como está enquanto seu ticket com a assessoria estiver aberto — a assessoria trabalha nele.",
      "recordInUse": "Este InOut pertence a um ticket com a assessoria — não pode ser excluído.",
      "notClosed": "Só um InOut do seu histórico pode ser recuperado ou excluído.",
      "noTitle": "Este InOut não tem nenhuma autorização de residência — não pode voltar a ser seu InOut. Comece um novo."
    },
    "setup": {
      "notServed": "O InOut ainda não conta dias para {{country}}.",
      "regimesError": "Não conseguimos ler as autorizações deste país.",
      "regime": "A autorização que você tem",
      "regimeRequired": "Escolha sua autorização.",
      "subtype": "Qual tipo",
      "issuedOn": "Emitida em",
      "validUntil": "Válida até",
      "expiresBeforeIssued": "A validade é anterior à emissão."
    },
    "calculator": {
      "back": "Voltar",
      "poweredBy": "Powered by Tonnie",
      "name": "Calculadora de ausências",
      "stepOf": "Etapa {{step}} de {{total}}",
      "stepAnnouncement": "{{step}}: {{title}}",
      "progress": "Seu progresso",
      "country": {
        "question": "Qual país emitiu sua autorização de residência?",
        "hint": "O InOut conta seus dias pelas regras desse país.",
        "comingSoon": "Em breve",
        "required": "Escolha o país."
      },
      "title": {
        "question": "Qual autorização você tem?",
        "hint": "Cada uma tem seus próprios limites de tempo fora. O nome está no seu cartão.",
        "showAll_one": "Ver mais {{titles}} autorização",
        "showAll_other": "Ver mais {{titles}} autorizações",
        "subtypeNone": "Escolha o tipo",
        "notSure": "Não tenho certeza",
        "notSureHelp": "O tipo de título está impresso no seu cartão de residência. Ainda não tem o cartão? Escolha o título que você pediu — dá para corrigir no InOut depois. Uma assessoria migratória regulamentada pode dizer qual se aplica."
      },
      "dates": {
        "question": "Quando ela foi emitida?",
        "hint": "As duas datas estão no seu cartão. Seus dias contam a partir da data de emissão.",
        "issuedPlaceholder": "Escolha a data de emissão",
        "validPlaceholder": "Escolha a data de validade",
        "noEnd": "Minha autorização não tem data de validade",
        "noEndSet": "Sem data de validade."
      },
      "trips": {
        "question": "Quando você esteve fora?",
        "hint": "Todas as viagens desde a emissão da autorização — o dia em que saiu e o dia em que voltou contam os dois.",
        "add": "Adicionar uma viagem",
        "none": "Não saiu do país? Então não há nada a adicionar — veja seus dias agora mesmo.",
        "save": "Salvar viagem",
        "saveFirst": "Salve ou cancele primeiro a viagem que está escrevendo.",
        "calculate": "Ver meus dias"
      },
      "result": {
        "title": "Seus dias, contados",
        "subtitle": "Lidos pelo mesmo motor do InOut no Tonnie Citizen. Nada foi salvo.",
        "asOf": "Em {{date}}",
        "startTitle": "Começar o InOut com isto",
        "startWhy": "Seu registro fica como você descreveu, e o InOut avisa você antes de um limite. Você pode alterá-lo a qualquer momento.",
        "start": "Começar o InOut",
        "uncertainBetween": "Você não disse se esteve no país entre as viagens, então esses dias contam como talvez fora.",
        "countRest": "Eu estava em {{country}}",
        "whatIfTitle": "E se eu viajar?",
        "whatIfSubtitle": "Teste uma viagem antes de reservar: seus dias são lidos no dia em que você voltaria. Nada é salvo.",
        "change": "Mudar minhas respostas",
        "restart": "Recomeçar"
      },
      "dialogDescription": "Descreva sua autorização de residência e suas viagens; guardar a resposta começa o InOut com ela.",
      "discard": {
        "title": "Fechar a calculadora?",
        "body": "Suas respostas não ficam salvas — ao fechar, elas se perdem.",
        "confirm": "Fechar e descartar",
        "keep": "Continuar respondendo",
        "restartTitle": "Recomeçar?",
        "restartBody": "As respostas que você deu serão apagadas."
      }
    },
    "embed": {
      "language": "Idioma",
      "keepTitle": "Guarde na Tonnie e seja avisado antes de um limite",
      "keepWhy": "Suas respostas ficam neste navegador até você continuar. Ao continuar, elas são enviadas à Tonnie, que as guarda por 72 horas para você criar sua conta e começar o InOut com elas.",
      "keep": "Continuar na Tonnie",
      "handedOffTitle": "Continue na Tonnie",
      "handedOffBody": "A Tonnie abriu em uma nova aba com seu cálculo. Crie sua conta lá para guardá-lo. O link funciona uma vez, por 72 horas.",
      "blockedBody": "Seu navegador não abriu uma nova aba. Continue com o botão abaixo. O link funciona uma vez, por 72 horas.",
      "continue": "Abrir a Tonnie",
      "unavailableTitle": "A calculadora não está disponível aqui",
      "unavailableBody": "Esta página não está configurada para mostrar a calculadora InOut.",
      "loadFailedTitle": "Não foi possível carregar a calculadora",
      "loadFailedBody": "Não foi possível contatar a Tonnie. Verifique sua conexão e tente novamente."
    },
    "presence": {
      "restInHost": "No resto do tempo, eu estava em {{country}}",
      "restInHostHint": "Sem isso, os dias entre as suas viagens contam como talvez fora.",
      "title": "Seus anos, dia a dia",
      "subtitle": "Cada dia do seu registro — além da janela de qualquer regra.",
      "here": "Em {{country}}",
      "away": "Fora",
      "travel": "Dia de viagem",
      "uncertain": "A confirmar",
      "planned": "Planejado",
      "hereCount_one": "{{days}} dia em {{country}}",
      "hereCount_other": "{{days}} dias em {{country}}",
      "awayCount_one": "{{days}} dia fora",
      "awayCount_other": "{{days}} dias fora",
      "travelCount_one": "{{days}} dia de viagem",
      "travelCount_other": "{{days}} dias de viagem",
      "uncertainCount_one": "{{days}} dia a confirmar",
      "uncertainCount_other": "{{days}} dias a confirmar",
      "plannedCount_one": "{{days}} dia planejado",
      "plannedCount_other": "{{days}} dias planejados",
      "year": "{{year}}: {{summary}}",
      "travelNote": "Um dia de viagem — o dia em que você sai ou volta — conta como dizem as regras de {{country}}.",
      "loadError": "Não foi possível ler seus dias ao longo dos anos."
    },
    "adopt": {
      "working": "Configurando o InOut com o seu cálculo…",
      "recorded": "O InOut está configurado com o seu cálculo.",
      "already": "O InOut já estava configurado — seu registro continua como está.",
      "refusedTitle": "Não foi possível usar o seu cálculo",
      "waitingTitle": "Um cálculo esperando",
      "waitingBody": "Você calculou em um portal parceiro e já tem um InOut. Ele fica como está — ou comece um novo InOut com este cálculo, e o atual vai para o seu histórico.",
      "keepMine": "Manter meu InOut",
      "newWithIt": "Começar novo InOut com este cálculo",
      "newDone": "Seu novo InOut está funcionando com o cálculo do portal — o anterior está no seu histórico."
    },
    "signup": {
      "titleFeminine": "Guarde o cálculo InOut que você fez na {{portal}}",
      "titleMasculine": "Guarde o cálculo InOut que você fez no {{portal}}",
      "description_one": "Guardamos seu cálculo: {{count}} viagem. Crie sua conta para mantê-lo.",
      "description_other": "Guardamos seu cálculo: {{count}} viagens. Crie sua conta para mantê-lo.",
      "descriptionAnswer": "{{answer}}. Crie sua conta para salvar este cálculo.",
      "descriptionBeyond": "Um dos seus limites já foi ultrapassado. Crie sua conta para salvar este cálculo e ver qual.",
      "goneTitle": "Esse link do cálculo expirou",
      "goneDescription": "Ele funciona uma vez, por 72 horas. Crie sua conta — a calculadora do InOut está a um toque lá dentro.",
      "unreadTitle": "Seu cálculo está guardado",
      "unreadDescription": "Não foi possível mostrá-lo agora, mas ele fica guardado: o InOut usa assim que sua conta existir."
    },
    "phone": {
      "title": "Guarde seu cálculo no app Tonnie",
      "body": "O app guarda o cálculo, conta seus dias e avisa você antes de um limite. O link funciona uma vez, por 72 horas.",
      "openApp": "Abrir no app",
      "installApp": "Instalar o app",
      "installHint": "Depois de instalar, abra o app em até 15 minutos: seu cálculo vai junto.",
      "goneBody": "Funciona uma vez, por 72 horas. No app Tonnie, a calculadora do InOut está a um toque."
    },
    "keepCalculation": {
      "signUp": "Criar minha conta",
      "signIn": "Já tenho conta"
    },
    "sharedDossier": {
      "title": "Dossiê de um ticket InOut",
      "body": "Uma pessoa compartilhou o registro de residência dela com a sua assessoria para a requisição. O dossiê é gerado a partir do registro dela quando você baixar.",
      "download": "Baixar o dossiê (PDF)",
      "downloading": "Preparando o dossiê…",
      "failed": "Não foi possível baixar o dossiê. Tente de novo em instantes.",
      "unavailableTitle": "Este link não pode ser aberto",
      "unavailableBody": "Ele pode ter expirado, ou a pessoa pode ter retirado o consentimento. Fale com a Tonnie se você ainda precisar do dossiê."
    },
    "case": {
      "state": {
        "open": "Aberto",
        "inProgress": "Em andamento",
        "closed": "Encerrado"
      },
      "closedReason": {
        "completed": "Concluído",
        "withoutSubmission": "Encerrado sem envio"
      }
    },
    "consultation": {
      "state": {
        "pendingPayment": "Aguardando pagamento",
        "paid": "Paga — sendo marcada",
        "scheduled": "Marcada",
        "completed": "Realizada",
        "paymentReceivedRebook": "Paga — escolha outro horário",
        "cancelledByAgency": "Cancelada pela assessoria — marque de novo",
        "checkoutExpired": "Não paga"
      }
    },
    "requisition": {
      "state": {
        "pendingPayment": "Aguardando pagamento",
        "paid": "Paga — dossiê a caminho",
        "delivered": "Dossiê com a assessoria",
        "inProgress": "Em andamento",
        "completed": "Concluída",
        "closedWithoutSubmission": "Encerrada sem envio",
        "checkoutExpired": "Não paga"
      },
      "stepsLabel": "Onde está sua requisição",
      "step": {
        "delivered": "Dossiê entregue",
        "working": "A assessoria está cuidando dele",
        "done": "Concluído",
        "closed": "Fechado"
      },
      "next": {
        "paid": "Seu dossiê está sendo preparado e enviado para a {{agency}}.",
        "delivered": "A {{agency}} tem seu dossiê e entra em contato sobre o próximo passo.",
        "inProgress": "A {{agency}} está cuidando do seu pedido e entra em contato se precisar de algo.",
        "completed": "A {{agency}} concluiu seu pedido.",
        "closedWithoutSubmission": "A {{agency}} fechou o pedido sem enviá-lo. Se você não esperava isso, entre em contato com a {{agency}}."
      },
      "receives": "O que a {{agency}} recebe"
    },
    "refundRequest": {
      "state": {
        "requested": "Pedida",
        "handledExternally": "Tratada"
      }
    },
    "operations": {
      "eventSource": {
        "agencyFile": "Arquivo da assessoria",
        "operator": "Registrado pela Tonnie"
      },
      "files": {
        "state": {
          "previewed": "Verificado — pronto para carregar",
          "accepted": "Carregado",
          "rejected": "Recusado — nada carregado",
          "expired": "Expirado — verifique de novo"
        },
        "outcome": {
          "new": "Novo",
          "duplicate": "Já carregado",
          "error": "Com erro"
        }
      },
      "problem": {
        "emptyFile": "O arquivo não tem eventos.",
        "headerMismatch": "O cabeçalho não é o formato v1.",
        "columnCount": "A linha não tem 7 colunas.",
        "unclosedQuote": "Há aspas sem fechar.",
        "formatVersion": "Não é a versão 1 do formato.",
        "agencyMismatch": "Código de outra assessoria.",
        "eventIdMissing": "Sem id do evento.",
        "eventIdRepeated": "O id do evento se repete no arquivo.",
        "caseRefMissing": "Sem referência do ticket.",
        "eventCodeUnknown": "Um código de evento que o país não conhece.",
        "noteCodeUnknown": "Um código de nota que o país não conhece.",
        "occurredAtInvalid": "A data não está em ISO 8601 com o fuso.",
        "caseUnknown": "Nenhum ticket desta assessoria tem esta referência.",
        "caseClosed": "O ticket está encerrado."
      }
    },
    "agency": {
      "purpose": {
        "consultation": "Consulta",
        "requisition": "Requisição"
      },
      "field": {
        "identity": "Seu nome e dados de identificação",
        "contact": "Como entrar em contato com você (e-mail, telefone, fuso horário)",
        "title": "Seu título de residência e suas datas",
        "absences": "As viagens ao exterior que você registrou",
        "plannedTrips": "As viagens que você planejou",
        "clocks": "Suas contagens de ausência, com sua incerteza",
        "evidenceDocuments": "A lista dos documentos das suas viagens"
      },
      "consent": {
        "intro": "Finalidade: {{purpose}}. A {{agency}} recebe isto do seu registro InOut:",
        "fields": "O que é compartilhado",
        "version": "Versão do texto {{version}}",
        "withdraw": "Você pode retirar esta aprovação a qualquer momento nesta aba; a partir daí nada mais é compartilhado.",
        "approve": "Aprovo compartilhar isto com a {{agency}}.",
        "submit": "Aprovar e continuar",
        "readFull": "Ler o texto completo"
      },
      "purchase": {
        "consultationTitle": "Consulta com a {{agency}}",
        "requisitionTitle": "Requisição pela {{agency}}",
        "price": "Preço",
        "credit": "Crédito das suas consultas",
        "toPay": "A pagar agora",
        "accept": "Li este aviso e o aceito.",
        "pay": "Pagar {{amount}}",
        "confirmCredit": "Confirmar — coberto pelo seu crédito",
        "subtitle": "Prestado pela {{agency}} · pago aqui, com segurança",
        "stepsLabel": "Etapas da compra",
        "steps": {
          "summary": "O serviço",
          "share": "Compartilhamento",
          "billing": "Fatura",
          "pay": "Pagar"
        },
        "when": "{{date}} · {{from}}–{{to}}",
        "whenShort": "{{date}} · {{time}}",
        "summary": {
          "title": "O que você está comprando",
          "lead": "Confira o serviço e o valor antes de continuar.",
          "changeTime": "Mudar o horário"
        },
        "share": {
          "title": "O que a {{agency}} recebe do seu registro",
          "leadConsultation": "Para a consulta, a {{agency}} precisa disto — e só disto.",
          "leadRequisition": "Para a requisição, a {{agency}} precisa disto — e só disto.",
          "standingTitle": "Você já aprovou este compartilhamento",
          "standing": "Aprovado em {{date}} · versão {{version}} do texto. Nada muda — siga para a próxima etapa."
        },
        "billing": {
          "title": "Para quem é a fatura",
          "lead": "Cada pagamento tem a sua fatura-recibo. Diga para quem emitir — fica salvo para as próximas.",
          "leadSaved": "Cada pagamento tem a sua fatura-recibo, com estes dados.",
          "change": "Alterar",
          "incomplete": "Faltam dados para a fatura — complete-os para seguir para o pagamento."
        },
        "payStep": {
          "title": "Confirme e pague",
          "lead": "O resumo, o aviso da {{agency}} e o pagamento.",
          "service": "Serviço",
          "invoice": "Fatura",
          "amount": "A pagar",
          "vat": "Impostos incluídos",
          "withCredit": "Depois de {{credit}} de crédito",
          "after": "Depois de pagar",
          "afterConsultation": "O horário fica marcado na agenda da {{agency}} e o link da videochamada chega por e-mail.",
          "afterRequisition": "A {{agency}} recebe o seu dossiê e entra em contato para começar.",
          "afterCase": "Você acompanha tudo no seu ticket, na aba Assessoria.",
          "afterReceipt": "A fatura-recibo fica disponível em Cobrança."
        },
        "secure": "Pagamento seguro com Stripe",
        "back": "Voltar",
        "next": "Continuar",
        "approveNext": "Aprovar e continuar",
        "saveNext": "Salvar e continuar"
      },
      "slots": {
        "previousWeek": "Semana anterior",
        "nextWeek": "Próxima semana",
        "week": "{{from}} – {{to}}",
        "loadError": "Não foi possível carregar os horários disponíveis.",
        "empty": "Sem horários disponíveis nesta semana. Tente a próxima.",
        "pickDay": "Escolha um dia",
        "pickTime": "Escolha um horário",
        "zone": "Horários no seu fuso horário: {{zone}}",
        "current": "seu horário"
      },
      "contact": {
        "title": "A agenda da {{agency}} não está disponível agora",
        "body": "Peça à {{agency}} que entre em contato: ela vai escrever para você para combinar um horário.",
        "request": "Pedir que a {{agency}} entre em contato comigo",
        "sent": "Enviado. A {{agency}} vai entrar em contato com você.",
        "alreadySent": "Você já pediu hoje. A {{agency}} vai entrar em contato.",
        "consentTitle": "Antes de a {{agency}} entrar em contato",
        "consentDescription": "A {{agency}} recebe o que a consulta compartilha, para prepará-la."
      },
      "move": {
        "title": "Remarcar a consulta",
        "description": "Escolha outro horário disponível. Uma consulta marcada pode ser remarcada até {{hours}} h antes.",
        "rebookTitle": "Escolha um novo horário",
        "rebookDescription": "Seu pagamento continua válido — escolha outro horário disponível, sem custo adicional.",
        "confirm": "Confirmar o novo horário",
        "done": "O novo horário está sendo marcado. A confirmação chega por e-mail.",
        "current": "Sua consulta",
        "chosen": "Novo horário: {{date}}, {{from}}–{{to}}",
        "chooseTime": "Escolha o novo horário."
      },
      "refund": {
        "title": "Pedir reembolso",
        "description": "Ticket {{caseRef}} com a {{agency}}.",
        "reason": "Por que você está pedindo?",
        "chooseReason": "Escolha um motivo.",
        "handledBy": "A {{agency}} e a Tonnie cuidam do pedido e escrevem para você.",
        "submit": "Enviar o pedido",
        "done": "Pedido enviado. Você receberá resposta por e-mail.",
        "paid": "O que você pagou neste ticket",
        "paidConsultation": "Consulta de {{date}}",
        "paidRequisition": "Requisição"
      },
      "case": {
        "title": "Seu ticket com a {{agency}}",
        "opened": "Aberto em {{date}}",
        "movableUntil": "Pode ser remarcada até {{date}}",
        "join": "Entrar na reunião",
        "move": "Remarcar",
        "chooseTime": "Escolher horário",
        "credit": "Crédito para a requisição: {{amount}}",
        "requisition": "Requisição",
        "requisitionPaid": "Pago: {{amount}}",
        "continuePayment": "Continuar para o pagamento",
        "confirmingPayment": "Confirmando seu pagamento…",
        "dossier": "Baixar sua cópia do dossiê",
        "dossierPreparing": "Preparando o dossiê…",
        "dossierFailed": "Não foi possível baixar o dossiê. Tente de novo em instantes.",
        "requisitionOffer": "A {{agency}} avalia sua situação, prepara o pedido e o envia.",
        "buyRequisition": "Pedir a requisição",
        "noRequisition": "Nenhuma requisição neste ticket.",
        "refunds": "Reembolsos",
        "askRefund": "Pedir reembolso",
        "consultations_one": "Consulta",
        "consultations_other": "Consultas",
        "creditTaken": "{{credit}} da consulta descontados",
        "toPay": "A pagar",
        "refundsHint": "Se algo não saiu como combinado, você pode pedir reembolso à {{agency}} por um dos motivos previstos.",
        "refundAsked": "Pedido em {{date}} · {{reason}}",
        "next": {
          "label": "Próximo passo",
          "payRequisition": "A requisição espera o pagamento: {{amount}}",
          "chooseTime": "A consulta precisa de outro horário — o pagamento continua válido.",
          "consultationBooked": "Consulta {{date}}, {{from}}–{{to}}",
          "consultationBooking": "A consulta está paga; o horário está sendo marcado.",
          "buyRequisition": "A requisição pode ser pedida: {{amount}}"
        }
      },
      "identity": {
        "byCountry": "A assessoria do InOut em {{country}}.",
        "legalName": "Razão social",
        "taxId": "Número fiscal",
        "registry": "Registro",
        "address": "Endereço",
        "dataProtection": "Contato de proteção de dados",
        "dpa": "Acordo de tratamento de dados",
        "dpaValue": "{{reference}}, versão {{version}}",
        "website": "Visitar o site da assessoria",
        "about": "Sobre a {{agency}}",
        "addressValue": "{{line}}, {{postalCode}} {{city}}, {{country}}"
      },
      "offer": {
        "credited": "O valor é abatido da requisição do mesmo ticket.",
        "requisition": "Requisição",
        "buyRequisition": "Pedir a requisição",
        "bookConsultation": "Agendar uma consulta",
        "vatIncluded": "Preços com IVA incluído."
      },
      "consents": {
        "none": "Você não compartilhou nada com a assessoria.",
        "grantedOn": "Aprovado em {{date}} · versão {{version}} do texto",
        "revokedOn": "Retirado em {{date}}",
        "withdraw": "Retirar",
        "withdrawn": "Retirado. Nada mais é compartilhado.",
        "confirmTitle": "Retirar esta aprovação?",
        "confirmConsultation": "A assessoria deixa de receber dados para consultas. Para marcar outra, você aprova de novo.",
        "confirmRequisition": "A assessoria deixa de receber dados, e o link do dossiê que ela tem deixa de abrir.",
        "titleWith": "O que você compartilha com a {{agency}}",
        "approvedState": "Aprovado",
        "withdrawnState": "Retirado",
        "fields": "O que é compartilhado",
        "beforeNote": "Ao marcar uma consulta ou pedir a requisição, você vê exatamente o que é compartilhado antes de aprovar."
      },
      "booking": {
        "title": "Marcar uma consulta com a {{agency}}",
        "online": "Os horários vêm da agenda da própria assessoria. A reunião é online; o link chega por e-mail e aparece no seu ticket depois de marcada.",
        "continue": "Continuar",
        "chosen": "Você escolheu: {{date}}, {{from}}–{{to}}",
        "chooseTime": "Escolha um horário para continuar."
      },
      "checkout": {
        "success": "Pagamento recebido. Seu ticket, abaixo, mostra o que acontece a seguir.",
        "cancelled": "Pagamento cancelado. Nada foi cobrado."
      },
      "requisition": {
        "paidByCredit": "Pago com seu crédito. A assessoria recebe seu dossiê."
      },
      "loadError": "Não foi possível carregar a assessoria.",
      "casesError": "Não foi possível carregar seus tickets.",
      "notReady": {
        "title": "A assessoria do seu país ainda não está pronta",
        "body": "Os termos de proteção de dados ainda estão sendo concluídos. Até lá nada é compartilhado com ela e nada pode ser comprado."
      },
      "storefront": {
        "eyebrow": "Sua assessoria migratória em {{country}}",
        "title": "Leve sua situação à {{agency}}, com seu registro já pronto.",
        "lead": "Uma consulta online para saber o que fazer, ou a requisição completa: a {{agency}} avalia sua situação, prepara e envia o pedido e o acompanha até a decisão.",
        "trustDossier": "Seu registro do InOut, entregue em dossiê",
        "trustVat": "Preços com impostos incluídos",
        "once": "pagamento único",
        "complete": "o processo completo",
        "closeCalendar": "Fechar o calendário",
        "consultation": {
          "meeting": "Uma reunião com a {{agency}} sobre a sua situação",
          "record": "A {{agency}} recebe antes o seu registro — não começa do zero",
          "movable": "Pode ser remarcada até {{hours}} h antes",
          "credited": "O valor é descontado na requisição do mesmo ticket"
        },
        "requisition": {
          "tag": "Tudo resolvido pela {{agency}}",
          "assess": "A {{agency}} avalia a sua situação",
          "submit": "Prepara e envia o pedido por você",
          "follow": "Acompanha até a decisão",
          "dossier": "Seu registro e seus documentos seguem em dossiê",
          "inCase": "Você tem um ticket aberto — a requisição é pedida nele.",
          "showCase": "Ver o seu ticket",
          "unreadable": "Não conseguimos ler os seus tickets — tente novamente acima."
        }
      },
      "how": {
        "title": "Como funciona",
        "choose": "Escolha e pague aqui",
        "chooseBody": "A consulta ou a requisição, com pagamento seguro e nota fiscal em seu nome.",
        "share": "Aprove o compartilhamento do seu registro",
        "shareBody": "Só o que cada serviço precisa. Você pode retirar a aprovação quando quiser.",
        "firm": "A {{agency}} cuida do resto com você",
        "firmBody": "Na consulta, no horário marcado; na requisição, do pedido até a decisão."
      },
      "providers": {
        "title": "Quem presta o serviço",
        "firm": "A {{agency}} presta a consulta e a requisição",
        "firmBody": "Sociedade regulada, sob sua própria responsabilidade profissional: a avaliação jurídica e o pedido são dela.",
        "tonnie": "A Tonnie guarda o seu registro",
        "tonnieBody": "Conta seus dias, organiza seus documentos e os entrega à {{agency}} — com a sua aprovação."
      }
    },
    "mobile": {
      "setupOnWeb": "Começar o InOut no Citizen Web",
      "setupOnWebDesc": "A calculadora abre lá; guarde a resposta para começar o InOut. Depois, o interruptor, os prazos e as perguntas do InOut também ficam aqui.",
      "calculatorErrorTitle": "A calculadora não abriu",
      "calculatorErrorBody": "Verifique sua conexão e tente novamente.",
      "noticesLink": "Perguntas e avisos",
      "agencyOnWeb": "A assessoria, no Citizen Web",
      "agencyOnWebDesc": "As consultas, a requisição e seus tickets com a assessoria estão no Citizen Web — o app não vende.",
      "answer": "Responder",
      "sourceCamera": "Tirar foto",
      "sourceLibrary": "Das fotos",
      "sourceFiles": "Dos arquivos",
      "cameraTitle": "Acesso à câmera",
      "cameraMessage": "Para fotografar um documento da sua viagem, permita que a Tonnie use a câmera nas configurações do celular.",
      "pickerUnavailableTitle": "Não é possível abrir seus documentos",
      "pickerUnavailableMessage": "Tente de novo ou escolha o documento de outra forma.",
      "pauseConfirmBody": "O InOut guarda tudo como está, mas não conta nem pergunta nada. A aba dele sai do aplicativo até você retomá-lo nas Configurações.",
      "titleOnWebDesc": "Corrija-o, ou adicione o cartão renovado — no Citizen Web.",
      "newOnWebDesc": "Comece um novo InOut a partir de um novo cálculo — no Citizen Web. O que você tem vai para o seu histórico; nada é apagado.",
      "historySubtitle": "Todos os InOuts que você guarda"
    },
    "paused": {
      "title": "O InOut está pausado",
      "body": "Pausado desde {{date}}. Sua autorização, suas viagens e seus documentos ficam como estavam, mas o InOut não conta nem pergunta nada até você retomá-lo.",
      "resume": "Retomar o InOut",
      "resumed": "O InOut voltou a funcionar.",
      "failed": "Não foi possível retomar o InOut. Tente novamente.",
      "history": "Seu histórico do InOut"
    },
    "menu": {
      "label": "Opções do InOut",
      "title": "Atualizar minha autorização",
      "pause": "Pausar o InOut",
      "new": "Novo InOut",
      "close": "Encerrar o InOut"
    },
    "titleDialog": {
      "title": "Atualizar minha autorização",
      "description": "O país se mantém. Outro país é um InOut novo.",
      "renewed": "Recebi um cartão novo",
      "renewedHint": "Fica no lugar do atual; seus dias contam nos dois.",
      "saved": "Sua autorização foi atualizada.",
      "correct": "Corrigir o atual",
      "correctHint": "Está diferente do que diz o cartão."
    },
    "pause": {
      "confirmTitle": "Pausar o InOut?",
      "confirmBody": "O InOut guarda tudo como está, mas não conta nem pergunta nada até você retomá-lo aqui.",
      "confirm": "Pausar o InOut",
      "done": "O InOut está pausado.",
      "caseOpenTitle": "O InOut continua funcionando",
      "caseOpenBody": "A assessoria trabalha sobre o seu registro enquanto o ticket estiver aberto, por isso o InOut não pode parar agora.",
      "caseOpenLead": "Você pode pausá-lo quando o ticket fechar."
    },
    "askBefore": {
      "title": "Peça antes de sair",
      "body": "Para uma ausência como esta, a lei prevê “{{exception}}” — ela é pedida antes de sair. Não damos parecer jurídico: o CoPilot explica o que envolve, e a assessoria pode orientar você.",
      "askCoPilot": "Perguntar ao CoPilot",
      "agency": "Falar com a assessoria",
      "questionNext": "Preciso pedir “{{exception}}” antes da minha próxima viagem?",
      "questionTrip": "Antes da minha viagem de {{from}} a {{to}}, preciso pedir “{{exception}}”?"
    },
    "shortStay": {
      "open": "Como o 90/180 se aplica a você",
      "title": "A regra dos 90/180 — onde ela se aplica a você",
      "lead": "O que você ouviu sobre 90 dias a cada 180 se aplica a você — mas não em {{country}}.",
      "where": "Onde você está",
      "away": "Conta como fora de {{country}}",
      "shortStay": "Conta para os 90/180",
      "inHost": "Em {{country}}",
      "otherSchengen": "Em outro país Schengen",
      "outsideSchengen": "Fora do espaço Schengen",
      "yes": "Sim",
      "no": "Não",
      "twice": "Um dia em outro país Schengen conta duas vezes: como dia fora de {{country}} e para os 90 dias a cada 180 desse espaço. O InOut conta os dois.",
      "calculator": "A calculadora de estadias de curta duração da UE é para visitantes. Ela mesma diz: quem tem um título de residência não está sujeito a ela, nem deve inserir suas estadias lá.",
      "source": "Artigo 21 da Convenção de Aplicação do Acordo de Schengen",
      "today": "Hoje: {{figures}}",
      "youAreHere": "Você está aqui",
      "on": "Em {{date}}: {{figures}}",
      "youWereHere": "Onde você estava em {{date}}"
    },
    "severity": {
      "title": "Nível de alerta",
      "subtitle": "Onde o seu registro está hoje, de informativo a urgente.",
      "ladder": "Nível {{rank}} de {{total}}: {{level}}",
      "level": {
        "informative": "Informativo",
        "attention": "Atenção",
        "potentialRisk": "Risco potencial",
        "professionalReview": "Revisão profissional recomendada",
        "urgent": "Urgente"
      },
      "informative": "Nada precisa de você agora. O InOut continua contando e avisa você com antecedência.",
      "uncertainDays_one": "{{days}} dia do seu registro ainda está por confirmar — até lá, seus números são menos precisos.",
      "uncertainDays_other": "{{days}} dias do seu registro ainda estão por confirmar — até lá, seus números são menos precisos.",
      "renewalWindow": "A janela para renovar seu título está aberta.",
      "riskZone": "Você está na faixa em que duas leituras de “{{rule}}” não coincidem.",
      "dependsOnUncertain": "Se “{{rule}}” fica dentro do limite depende de dias ainda por confirmar.",
      "nearLimit": "“{{rule}}” está perto do limite.",
      "passing": "Suas viagens levariam “{{rule}}” ao limite em {{date}}.",
      "passingException": "{{exception}} pode ser feito antes de sair — a assessoria pode prepará-lo.",
      "passingAgency": "A assessoria pode analisar isso com você antes da viagem.",
      "urgent": "“{{rule}}” passou do limite. Isso não quer dizer que sua residência esteja perdida: a lei prevê respostas, com audiência prévia. A assessoria pode ajudar.",
      "daysLeft_one": "Resta {{days}} dia",
      "daysLeft_other": "Restam {{days}} dias",
      "untilCloses_one": "{{days}} dia até fechar",
      "untilCloses_other": "{{days}} dias até fechar",
      "toAct_one": "{{days}} dia para agir",
      "toAct_other": "{{days}} dias para agir",
      "action": {
        "agency": "Falar com a assessoria",
        "confirmDays": "Confirmar os dias",
        "limits": "Ver seus limites",
        "renewal": "Ver a renovação"
      }
    },
    "export": {
      "title": "Seu registro, pronto para uma auditoria",
      "body": "Seus títulos, suas viagens, as viagens que você planeja, seus limites e seus documentos em um só PDF — seu, para guardar ou entregar a quem pedir.",
      "download": "Baixar seu registro (PDF)",
      "failed": "Não foi possível baixar seu registro. Tente de novo.",
      "onWeb": "Baixar seu registro",
      "onWebDesc": "Seu registro em PDF é baixado no Citizen Web."
    },
    "boardingPass": {
      "add": "A partir de um cartão de embarque",
      "hint": "Uma foto do cartão, ou o PDF da companhia aérea: a viagem é lida a partir dele, para você confirmar, e o cartão fica guardado como prova.",
      "elsewhere": "Este voo vai de {{from}} para {{to}} — não é uma viagem de entrada ou saída do seu país de residência, então nada foi registrado.",
      "proofNotKept": "A viagem foi salva, mas não foi possível guardar o cartão de embarque. Adicione-o em Documentos.",
      "failed": {
        "notBoardingPass": "Isso não é um cartão de embarque. Fotografe o próprio cartão.",
        "unreadable": "Não foi possível ler o voo. Tente uma foto mais nítida, com a data e os aeroportos à vista.",
        "unsupported": "Esse arquivo não pode ser lido. Use uma foto ou um PDF.",
        "tooLarge": "Esse arquivo é grande demais. Use uma foto menor.",
        "unavailable": "No momento não é possível ler cartões de embarque. Tente daqui a pouco ou registre a viagem manualmente.",
        "generic": "Não foi possível ler o cartão de embarque. Tente de novo."
      },
      "fromFile": "Uma foto ou um arquivo",
      "fromVaultDescription": "Um cartão de embarque que você já guarda — lido na viagem que é."
    },
    "summary": {
      "detail": "Ver o detalhe",
      "perTrip": "até {{limit}} dias seguidos em cada saída",
      "unit": {
        "total": "dias",
        "eachTrip": "dias seguidos",
        "needed": "dias faltando"
      }
    },
    "offer": {
      "subtitle": "Sua assessoria migratória",
      "title": {
        "calm": "Tenha certeza antes de viajar",
        "review": "Fale com a assessoria antes de viajar",
        "urgent": "A assessoria pode ajudar agora"
      },
      "body": {
        "calm": "O InOut conta seus dias; a {{agency}} diz o que fazer com eles.",
        "review": "Suas viagens estão chegando perto de um limite: veja com a {{agency}} o que fazer antes de viajar.",
        "urgent": "Um limite foi ultrapassado. Isso não quer dizer que você perdeu a residência: a {{agency}} prepara a resposta que a lei prevê."
      },
      "case": {
        "title": "Seu ticket com a {{agency}}",
        "body": "O Ticket {{caseRef}} está em andamento.",
        "open": "Ver o ticket"
      },
      "consultationTitle": "Consulta online",
      "consultationMeta": "{{minutes}} min · por videochamada",
      "nextSlot": "Próximo horário: {{date}} · {{time}}",
      "requisitionMeta": "Preparada e enviada pela {{agency}}",
      "regulated": "Empresa regulamentada"
    },
    "milestones": {
      "label": "O que vem a seguir",
      "renewal": "Renovação a partir de {{date}}",
      "acquisition": "{{name}} em {{date}}",
      "planTrip": "Planejar uma viagem",
      "title": "Seus marcos",
      "subtitle": "Renovação e direitos de longa duração"
    },
    "stage": {
      "inHost": "Em Portugal",
      "away": "Fora de Portugal",
      "tapToLeave": "Toque no círculo ao sair",
      "tapToReturn": "Desde {{date}} · toque ao voltar",
      "mine": "Meu InOut",
      "noNumber": "ainda sem número",
      "unit": {
        "days": "dias"
      },
      "leftNotice": "Saída registrada em {{date}}",
      "backNotice_one": "Retorno registrado — {{days}} dia fora",
      "backNotice_other": "Retorno registrado — {{days}} dias fora",
      "attention": {
        "beyond": "acima do limite",
        "daysLeft_one": "falta {{days}} dia",
        "daysLeft_other": "faltam {{days}} dias",
        "check": "a verificar",
        "questions": "Aguardando resposta",
        "questionCount_one": "{{questions}} pergunta",
        "questionCount_other": "{{questions}} perguntas",
        "toConfirm": "Dias a confirmar",
        "days_one": "{{days}} dia",
        "days_other": "{{days}} dias",
        "none": "Tudo em dia",
        "unread": "Não conseguimos ler seus avisos"
      },
      "upTo_one": "até {{days}} dia",
      "upTo_other": "até {{days}} dias",
      "upToInARow_one": "até {{days}} dia seguido",
      "upToInARow_other": "até {{days}} dias seguidos",
      "continuedNotice": "Saiu de novo — a viagem de hoje continua"
    },
    "help": {
      "title": "Pedir ajuda",
      "description": "Pergunte já, ou fale com quem decide.",
      "copilot": "Perguntar ao CoPilot",
      "copilotHint": "Responde na hora, a qualquer hora, sobre o seu registro.",
      "agency": "Falar com a assessoria",
      "agencyHint": "Uma consulta com quem decide, no Citizen Web."
    },
    "hub": {
      "subtitle": "Tudo num só lugar",
      "titleOverline": "Seu título",
      "where": "Onde você está",
      "validUntil": "Válido até",
      "renewalFrom": "Renovação a partir de",
      "all": "Tudo sobre o seu InOut",
      "manage": "Gerenciar",
      "onWeb": "No Citizen Web",
      "agency": "A assessoria",
      "documents": "Documentos",
      "planned_one": "{{count}} planejada",
      "planned_other": "{{count}} planejadas"
    },
    "limits": {
      "title": "Seus limites",
      "subtitle": "Uma regra de cada vez",
      "unit": {
        "left": "dias que ainda pode ficar fora",
        "inARow": "dias seguidos, a partir de hoje",
        "needed": "dias que ainda faltam no país"
      },
      "others": "Outras regras",
      "why": {
        "title_one": "Por que uma viagem pode durar {{days}} dia e não {{other}}",
        "title_other": "Por que uma viagem pode durar {{days}} dias e não {{other}}",
        "byTotal_one": "Numa viagem vale o menor dos dois limites. Hoje é o total: resta {{left}} dia dos {{limit}}.",
        "byTotal_other": "Numa viagem vale o menor dos dois limites. Hoje é o total: restam {{left}} dias dos {{limit}}.",
        "byInARow_one": "Numa viagem vale o menor dos dois limites. Hoje é o de seguidos: uma viagem fora de {{country}} não pode passar de {{limit}} dia.",
        "byInARow_other": "Numa viagem vale o menor dos dois limites. Hoje é o de seguidos: uma viagem fora de {{country}} não pode passar dos {{limit}} dias.",
        "titleFrom_one": "Por que uma viagem a partir de {{date}} podia durar {{days}} dia e não {{other}}",
        "titleFrom_other": "Por que uma viagem a partir de {{date}} podia durar {{days}} dias e não {{other}}",
        "byTotalOn_one": "Numa viagem vale o menor dos dois limites. Em {{date}} era o total: restava {{left}} dia dos {{limit}}.",
        "byTotalOn_other": "Numa viagem vale o menor dos dois limites. Em {{date}} era o total: restavam {{left}} dias dos {{limit}}.",
        "byInARowOn_one": "Numa viagem vale o menor dos dois limites. Em {{date}} era o de seguidos: uma viagem fora de {{country}} não podia passar de {{limit}} dia.",
        "byInARowOn_other": "Numa viagem vale o menor dos dois limites. Em {{date}} era o de seguidos: uma viagem fora de {{country}} não podia passar dos {{limit}} dias."
      },
      "line": {
        "today": "hoje",
        "away": "dias fora",
        "toConfirm": "a confirmar",
        "closed": "encerrado"
      },
      "run_one": "{{from}} – {{to}} · {{days}} dia",
      "run_other": "{{from}} – {{to}} · {{days}} dias",
      "trips": {
        "thisTrip_one": "Esta viagem, desde {{from}} · {{days}} dia",
        "thisTrip_other": "Esta viagem, desde {{from}} · {{days}} dias",
        "next_one": "A próxima viagem: até {{days}} dia — o total atinge o limite antes dos {{limit}}",
        "next_other": "A próxima viagem: até {{days}} dias — o total atinge o limite antes dos {{limit}}",
        "none": "Nenhuma viagem contou ainda.",
        "thisTripOn_one": "A viagem em andamento em {{date}}, desde {{from}} · {{days}} dia",
        "thisTripOn_other": "A viagem em andamento em {{date}}, desde {{from}} · {{days}} dias",
        "nextFrom_one": "Uma viagem a partir de {{date}}: até {{days}} dia — o total atinge o limite antes dos {{limit}}",
        "nextFrom_other": "Uma viagem a partir de {{date}}: até {{days}} dias — o total atinge o limite antes dos {{limit}}"
      }
    },
    "trips": {
      "passHint": "Fotografe-o: a viagem é lida e a foto fica como prova.",
      "tab": {
        "trips": "Viagens",
        "record": "Registro"
      },
      "count_one": "{{count}} viagem",
      "count_other": "{{count}} viagens",
      "yearHeading": "{{year}} · {{trips}}"
    },
    "duration": {
      "days_one": "{{value}} dia",
      "days_other": "{{value}} dias",
      "months_one": "{{value}} mês",
      "months_other": "{{value}} meses",
      "years_one": "{{value}} ano",
      "years_other": "{{value}} anos"
    },
    "meter": {
      "title": "Os limites de ausência da sua autorização",
      "name": {
        "inTotal": "No total",
        "inARow": "Seguidos",
        "outsideEuInTotal": "Fora da UE, no total",
        "outsideEuInARow": "Fora da UE, seguidos"
      },
      "detail": {
        "perTrip": "{{limit}} por viagem",
        "perTripRolling": "{{limit}} por viagem, em qualquer período de {{window}}",
        "perTripCalendarYear": "{{limit}} por viagem, em cada ano civil",
        "perTripFromIssue": "{{limit}} por viagem, nos primeiros {{window}}",
        "total": "{{limit}}",
        "totalPermit": "{{limit}} na autorização",
        "totalPermitAndRenewals": "{{limit}} na autorização e nas renovações",
        "totalRolling": "{{limit}} em qualquer período de {{window}}",
        "totalCalendarYear": "{{limit}} em cada ano civil",
        "totalFromIssue": "{{limit}} nos primeiros {{window}}"
      },
      "fraction": "{{taken}} / {{limit}}",
      "valueText": "{{taken}} de {{limit}} dias, restam {{left}}",
      "definesAnswer": "Define a sua resposta"
    },
    "holds": {
      "trips": "Viagens",
      "planned": "Viagens planejadas",
      "documents": "Documentos anexados",
      "daysAway_one": "{{days}} dia fora",
      "daysAway_other": "{{days}} dias fora"
    },
    "newRecord": {
      "confirmTitle": "Começar um novo InOut?",
      "confirmBody": "Seu InOut atual vai para o histórico com tudo o que guarda — nada é apagado, e você pode torná-lo principal de novo quando quiser.",
      "confirm": "Começar um novo InOut",
      "holdsLabel": "O que vai para o histórico",
      "keepTitle": "Começar um novo InOut com isto",
      "keepWhy": "Isto passa a ser seu InOut: sua autorização, suas viagens e o tempo que você esteve no país, como você os descreveu agora. O atual vai para o seu histórico.",
      "keep": "Começar novo InOut",
      "done": "Seu novo InOut está funcionando — o anterior está no seu histórico."
    },
    "recordCase": {
      "title": "Seu InOut fica como está",
      "body": "A assessoria trabalha sobre este InOut enquanto seu ticket estiver aberto, por isso ele não pode ir para o histórico agora.",
      "leadNew": "Você pode começar um novo InOut quando o ticket fechar.",
      "leadClose": "Você pode encerrá-lo quando o ticket fechar."
    },
    "close": {
      "confirmTitle": "Encerrar o InOut?",
      "confirmBody": "Seu InOut vai para o histórico com tudo o que guarda — nada é apagado. O InOut não conta nem envia avisos até você começar um novo ou tornar principal um do histórico.",
      "confirm": "Encerrar o InOut",
      "done": "Seu InOut está encerrado e guardado no histórico."
    },
    "history": {
      "principalTitle": "Seu InOut",
      "closedTitle": "No seu histórico",
      "closedLead": "Os InOuts que você substituiu ou encerrou, guardados como estavam — cada um lido na data em que foi encerrado.",
      "stateActive": "Ativo",
      "statePaused": "Pausado",
      "sinceActive": "Funcionando desde {{date}}",
      "sincePaused": "Pausado desde {{date}}",
      "goToInOut": "Ir para o InOut",
      "view": "Ver",
      "restore": "Tornar principal",
      "delete": "Excluir",
      "noTitle": "Sem autorização de residência",
      "period": "{{from}} – {{to}}",
      "periodOpen": "Desde {{from}}, sem data de término",
      "trips_one": "{{trips}} viagem",
      "trips_other": "{{trips}} viagens",
      "daysAway_one": "{{days}} dia fora",
      "daysAway_other": "{{days}} dias fora",
      "documents_one": "{{documents}} documento",
      "documents_other": "{{documents}} documentos",
      "closedReplaced": "Encerrado em {{date}} — um novo InOut ficou no lugar dele",
      "closedRestoredOther": "Encerrado em {{date}} — outro do seu histórico passou a principal",
      "closedByYou": "Encerrado por você em {{date}}",
      "closedLegacy": "Guardado de antes de o InOut ter histórico",
      "emptyTitle": "Ainda não há nada no seu histórico",
      "emptyBody": "Quando você começar um novo InOut ou encerrar o atual, ele fica guardado aqui — nada é apagado.",
      "noneTitle": "Você ainda não tem InOut",
      "noneBody": "Comece o InOut com a calculadora. Cada InOut que você começar fica guardado aqui.",
      "loadError": "Não conseguimos ler seu histórico",
      "restoreTitle": "Tornar este InOut principal?",
      "restoreBody": "Seu InOut atual vai para o histórico. Este volta pausado — retome-o quando quiser.",
      "restoreBodyNone": "Ele volta pausado — retome-o quando quiser.",
      "restoreConfirm": "Tornar principal",
      "restored": "Voltou a ser seu InOut, pausado — retome-o quando quiser.",
      "deleteTitle": "Excluir este InOut de vez?",
      "deleteBody": "Ele sai do seu histórico e não pode ser recuperado. O que ele guarda é excluído junto; os arquivos ficam no seu Cofre.",
      "deleteConfirm": "Excluir de vez",
      "deleteHolds": "O que é excluído",
      "deleted": "O InOut foi excluído.",
      "back": "Seu histórico",
      "detail": {
        "closedPill": "Encerrado",
        "asOf": "Os números como estavam em {{date}}, o dia em que foi encerrado.",
        "noReading": "Este InOut não tem autorização de residência — não há nada para contar.",
        "principalTitle": "Este é seu InOut",
        "principalBody": "Ele funciona na página do InOut — está tudo lá.",
        "tripsTitle": "Suas viagens",
        "tripsEmpty": "Nenhuma viagem foi registrada neste InOut.",
        "plannedTitle": "Viagens que ainda estavam planejadas",
        "documentsTitle": "Documentos",
        "documents_one": "{{documents}} documento anexado às viagens. O arquivo está no seu Cofre.",
        "documents_other": "{{documents}} documentos anexados às viagens. Os arquivos estão no seu Cofre.",
        "documentsNone": "Nenhum documento foi anexado às viagens.",
        "notFoundTitle": "Este InOut não está no seu histórico",
        "notFoundBody": "Ele pode ter sido excluído. Seu histórico tem todos os InOuts que você guarda.",
        "loadError": "Não conseguimos ler este InOut"
      }
    }
  }
}
